// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/effect/1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/effect/2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/effect/3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/effect/4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/effect/5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/effect/6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/slider/1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/slider/2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/hero1.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/quotation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/hero2.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/hero3.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/calling.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/values.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/clinical.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/about2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/training.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/team.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/work-with.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/funding.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/hero3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/supported.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/consulting.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/specialist.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/brain-injury.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/spinal-cord.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/join-us.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/learning.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/nursingcare.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/neurological.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/children.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/ventilation.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/recruit.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/workWithQuality.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/train.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../img/reward.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../img/bg/21.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../img/others/1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../img/icons/car.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;500;600;700&family=Nunito:wght@400;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Template Name: Vicodin
    Description: Medical eCommerce HTML Template
    Version: 1.0.0
*/
/* Single side border-radius  */
/* BORDER RADIUS */
/* user select */
/* box sizing  */
/* placeholder */
/* transition  */
/* transform */
/* rotate */
/* scale */
/* translate */
/* translate rotate */
/* skew */
/* ============================================================
>>> TABLE OF CONTENTS:
===============================================================
# Google fonts
# Gutter Code 
# Normalize
# Typography
# Custom Class
# input and button type focus outline disable
# Form input box
# Text meant only for screen readers.
# Transition

# Accessibility
# Globals

# Alignments
# Clearings
# Posts and pages
# Captions
# Galleries
# Unit test
# ScrollUp
# Owl Carousel 
# Slick Slider
# Background Overlay
# Scrollbar
# Padding Top
# Padding Bottom
# Margin Top
# Margin Bottom
# Custom margin Padding

============================================================= */
/* -------------------------------------
    Google fonts
------------------------------------- */
/* @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Rajdhani:wght@400;500;600;700&display=swap'); */
/*
font-family: 'Open Sans', sans-serif;
font-family: 'Rajdhani', sans-serif;
*/
/* @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&family=Titillium+Web:wght@400;600;700;900&display=swap'); */
/*
font-family: 'Nunito Sans', sans-serif;
font-family: 'Titillium Web', sans-serif;
*/
/*

Last uses font
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&family=Poppins:wght@400;500;600;700;800;900&display=swap');
*/
/*
font-family: 'Nunito Sans', sans-serif;
font-family: 'Poppins', sans-serif;
*/
/*
font-family: 'Josefin Sans', sans-serif;
font-family: 'Nunito', sans-serif;
*/
/* ====================================================
    Gutter Code 
==================================================== */
.container,
.container-fluid {
  padding-right: 15px;
  padding-left: 15px;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  padding-right: 15px;
  padding-left: 15px;
  position: relative;
}

.ltn__no-gutter > [class*=col-] { /* No padding only for child columns */
  padding-right: 0;
  padding-left: 0;
}

.ltn__no-gutter-all [class*=col-] { /* No padding for every columns */
  padding-right: 0;
  padding-left: 0;
}

@media (min-width: 992px) { /* Modify this based on column def */
  .ltn__custom-gutter {
    margin-left: 0px;
    margin-right: 0px;
  }
  .ltn__custom-gutter > [class*=col-] {
    padding-right: 0px;
    padding-left: 0px;
  }
  .ltn__custom-gutter-all .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  .ltn__custom-gutter-all .row [class*=col-] {
    padding-right: 15px;
    padding-left: 15px;
  }
}
@media (max-width: 991px) { /* Modify this based on column def */
  .ltn__custom-gutter {
    margin-left: -15px;
    margin-right: -15px;
  }
  .ltn__custom-gutter > [class*=col-] {
    padding-right: 15px;
    padding-left: 15px;
  }
  .ltn__custom-gutter-all {
    margin-left: -15px;
    margin-right: -15px;
  }
  .ltn__custom-gutter-all [class*=col-] {
    padding-right: 15px;
    padding-left: 15px;
  }
}
@media (max-width: 767px) { /* Modify this based on column def */
  .ltn__product-gutter .row {
    margin-left: -8px;
    margin-right: -8px;
  }
  .ltn__product-gutter [class*=col-] {
    padding-right: 8px;
    padding-left: 8px;
  }
}
/* ----------------------------------------------------
    Normalize    0B2C3D
---------------------------------------------------- */
:root {
  --ltn__primary-color: #071C1F;
  --ltn__primary-color-2: #041113; /* Darken */
  --ltn__primary-color-3: #133236; /* Lighten */
  --ltn__secondary-color: #21485e;
  --ltn__secondary-color-2: #485e21; /* Darken */
  --ltn__secondary-color-3: #fb412a; /* Lighten */
  --ltn__heading-color: #071c1f;
  --ltn__paragraph-color: #5C727D;
  --ltn__heading-font: "Josefin Sans", sans-serif;
  --ltn__body-font: "Nunito Sans", sans-serif;
  /* Footer ACD2D8 8CB2B2  */
  --ltn__color-1: #8cb2b2;
  --ltn__color-2: #ACD2D8;
  --ltn__color-3: #A3BCC0;
  --ltn__color-4: #84A2A6;
  --ltn__color-5: #5C727D;
  --ltn__color-6: #F5DFDC;
  /* Gradient Colors */
  --gradient-color-1: linear-gradient(90deg, rgba(242,139,194,1) 0%, rgba(216,177,242,1) 50%);
  --gradient-color-2: linear-gradient(to top, rgba(7,28,31,0) 0%, rgba(7,28,31,1) 90%);
  --gradient-color-3: linear-gradient(to bottom, rgba(7,28,31,0) 0%, rgba(7,28,31,1) 90%);
  --gradient-color-4: linear-gradient(to top, rgba(242,246,247,0) 0%, rgba(242,246,247,1) 90%);
  --gradient-color-5: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 70%);
  /* Background Colors ( 1, 2, 3, 4, 5 )  */
  --section-bg-1: #F2F6F7; /* White */
  --section-bg-2: #171B2A; /* Black */
  --section-bg-5: #FFF2F0; /* White */
  --section-bg-6: #0B2C3D; /* Black */
  --section-bg-7: #282b38; /* Black */
  /* Border Colors */
  --border-color-1: #e5eaee; /* White */
  --border-color-2: #1e2021; /* Black */
  --border-color-3: #5C617F; /* Black */
  --border-color-4: #eb6954; /* Red */
  --border-color-5: #bc3928; /* Red */
  --border-color-6: #103034; /* Black */
  --border-color-7: #d1dae0; /* White */
  --border-color-8: #f6f6f6; /* White */
  --border-color-9: #e4ecf2; /* White */
  --border-color-10: #ebeeee; /* White */
  --border-color-11: #ededed; /* White */
  --border-color-12: #e1e6ff; /* White */
  --border-color-13: #f1f8ff; /* White */
  /* Box Shadow Colors */
  --ltn__box-shadow-1: 0 16px 32px 0 rgba(7, 28, 31, 0.1);
  --ltn__box-shadow-2: 0 0 4px rgba(0, 0, 0, 0.1); /* like border */
  --ltn__box-shadow-3: 0 1px 6px 0 rgba(32, 33, 36, .28); /* like border GGL */
  --ltn__box-shadow-4: 0 5px 20px 0 rgba(23, 44, 82, 0.1);
  --ltn__box-shadow-5: 0 8px 16px 0 rgba(93, 93, 93, 0.1);
  --ltn__box-shadow-6: 0 0 25px 2px rgba(93, 93, 93, 0.2);
  --ltn__box-shadow-7: 0 0 10px 0px rgba(93, 93, 93, 0.2);
  /* Common Colors */
  --black: #000000;
  --black-2: #22355B;
  --white: #fff;
  --white-2: #F2F6F7;
  --white-3: #e8edee;
  --white-4: #e6ecf0;
  --white-5: #f0f4f7;
  --white-6: #f1f1f1;
  --white-7: #F7F7F7;
  --white-8: #FAFAFA;
  --white-9: #F2F7FA;
  --white-10: #EDEDED;
  --red: #FF0000;
  --red-2: #f34f3f;
  --red-3: #DB483B;
  --red-4: #FB2448;
  --silver: #C0C0C0;
  --gray: #808080;
  --maroon: #800000;
  --yellow: #FFFF00;
  --olive: #808000;
  --lime: #00FF00;
  --green: #77C720;
  --green-2: #008000;
  --aqua: #00FFFF;
  --teal: #008080;
  --blue: #0000FF;
  --navy: #000080;
  --fuchsia: #B13BFF;
  --purple: #800080;
  --pink: #FFC0CB;
  --nude: #ebc8b2;
  --orange: #ffa500;
  --ratings: #FFB800;
  /* social media colors */
  --facebook: #365493;
  --twitter: #3CF;
  --linkedin: #0077B5;
  --pinterest: #c8232c;
  --dribbble: #ea4c89;
  --behance: #131418;
  --google-plus: #dd4b39;
  --instagram: #e4405f;
  --vk: #3b5998;
  --wechat: #7bb32e;
  --youtube: #CB2027;
  --email: #F89A1E;
}

/* -------------------------------------
    Typography
------------------------------------- */
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

.loader-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0b0b0b;
  display: grid;
  place-items: center;
}

.loader {
  border: 16px solid #e3e3e3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 140px;
  height: 140px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-family: var(--ltn__body-font);
}

* {
  box-sizing: border-box;
  outline: none;
  -moz-osx-font-smoothing: grayscale;
  /* Firefox */
  -webkit-font-smoothing: antialiased;
  /* WebKit  */
}

body {
  color: var(--ltn__paragraph-color);
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  font-family: var(--ltn__body-font);
  line-height: 1.8;
  margin: 0 auto;
}

h1, .h1 {
  font-size: 36px;
  line-height: 1.2;
}

h2, .h2 {
  font-size: 30px;
}

h3, .h3 {
  font-size: 24px;
}

h4, .h4 {
  font-size: 20px;
}

h5, .h5 {
  font-size: 18px;
}

h6, .h6 {
  font-size: 16px;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: var(--ltn__heading-color);
  clear: both;
  font-family: var(--ltn__heading-font);
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 15px;
}

p {
  color: var(--ltn__paragraph-color);
  margin-bottom: 1.5em;
  -webkit-hyphens: auto;
  hyphens: auto;
}

a {
  color: inherit;
  text-decoration: none;
  color: var(--ltn__paragraph-color);
  transition: all 0.3s ease 0s;
}

a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
  color: inherit;
}

a:hover {
  color: var(--ltn__secondary-color);
}

button,
input,
optgroup,
select,
textarea {
  font-family: var(--ltn__body-font);
}

pre,
code,
kbd,
tt,
var,
samp {
  font-family: var(--ltn__body-font);
}

pre {
  word-break: break-word;
}

a i {
  padding: 0 2px;
}

img {
  max-width: 100%;
}

ul li,
ol li {
  margin-top: 1rem;
}

/* -------------------------------------
    Custom Class
------------------------------------- */
.body-wrapper {
  background-color: var(--section-bg-1) !important;
}

.color-border {
  border-top: 8px solid #21485e;
  width: 75px;
  border-radius: 5px;
}

.section-bg-1 {
  background-color: var(--section-bg-1);
}
.section-bg-1 .ltn__separate-line .separate-icon {
  background-color: var(--section-bg-1);
}

.section-bg-2,
.section-bg-6,
.section-bg-7 {
  background-color: var(--section-bg-2);
}
.section-bg-2 h1,
.section-bg-2 h2,
.section-bg-2 h3,
.section-bg-2 h4,
.section-bg-2 h5,
.section-bg-2 h6,
.section-bg-2 p,
.section-bg-2 li,
.section-bg-2 i,
.section-bg-2 span,
.section-bg-2 tr,
.section-bg-2 td,
.section-bg-6 h1,
.section-bg-6 h2,
.section-bg-6 h3,
.section-bg-6 h4,
.section-bg-6 h5,
.section-bg-6 h6,
.section-bg-6 p,
.section-bg-6 li,
.section-bg-6 i,
.section-bg-6 span,
.section-bg-6 tr,
.section-bg-6 td,
.section-bg-7 h1,
.section-bg-7 h2,
.section-bg-7 h3,
.section-bg-7 h4,
.section-bg-7 h5,
.section-bg-7 h6,
.section-bg-7 p,
.section-bg-7 li,
.section-bg-7 i,
.section-bg-7 span,
.section-bg-7 tr,
.section-bg-7 td {
  color: var(--white);
}
.section-bg-2 .ltn__separate-line .separate-icon,
.section-bg-6 .ltn__separate-line .separate-icon,
.section-bg-7 .ltn__separate-line .separate-icon {
  background-color: var(--black-2);
}

.section-bg-3 {
  position: relative;
}
.section-bg-3:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: var(--gradient-color-1);
  opacity: 0.9;
}
.section-bg-3 h1,
.section-bg-3 h2,
.section-bg-3 h3,
.section-bg-3 h4,
.section-bg-3 h5,
.section-bg-3 h6,
.section-bg-3 p,
.section-bg-3 li,
.section-bg-3 i,
.section-bg-3 span,
.section-bg-3 tr,
.section-bg-3 td {
  color: var(--white);
}
.section-bg-3 .slick-arrow-1 .slick-arrow {
  background-color: transparent;
}
.section-bg-3 input[type=text],
.section-bg-3 input[type=email],
.section-bg-3 input[type=password],
.section-bg-3 input[type=submit] {
  border-color: var(--white);
  color: var(--white);
}
.section-bg-3 .btn-wrapper button {
  color: var(--white);
}
.section-bg-3 input::-webkit-input-placeholder {
  color: var(--white);
}
.section-bg-3 input::-moz-placeholder {
  color: var(--white);
}
.section-bg-3 input:-ms-input-placeholder {
  color: var(--white);
}
.section-bg-3 input:-moz-placeholder {
  color: var(--white);
}
.section-bg-3 .ltn__separate-line .separate-icon {
  background: var(--gradient-color-1);
}
.section-bg-3 .ltn__separate-line .separate-icon i {
  color: var(--white);
}

.section-bg-4 {
  background-color: var(--ltn__primary-color-2);
}
.section-bg-4 h1,
.section-bg-4 h2,
.section-bg-4 h3,
.section-bg-4 h4,
.section-bg-4 h5,
.section-bg-4 h6,
.section-bg-4 p,
.section-bg-4 li,
.section-bg-4 i,
.section-bg-4 span,
.section-bg-4 tr,
.section-bg-4 td {
  color: var(--white);
}
.section-bg-4 .ltn__separate-line .separate-icon {
  background-color: var(--black-2);
}
.section-bg-4 .ltn__copyright-design h6, .section-bg-4 .ltn__copyright-design h4 {
  color: var(--ltn__color-1);
}

.section-bg-5 {
  background-color: var(--section-bg-5);
}

.section-bg-6 {
  background-color: var(--section-bg-6);
}

.section-bg-7 {
  background-color: var(--section-bg-7);
}

.text-color-white {
  color: var(--white);
}
.text-color-white h1,
.text-color-white h2,
.text-color-white h3,
.text-color-white h4,
.text-color-white h5,
.text-color-white h6,
.text-color-white p,
.text-color-white li,
.text-color-white i,
.text-color-white span,
.text-color-white tr,
.text-color-white td {
  color: var(--white);
}

.ltn__primary-color {
  color: var(--ltn__primary-color) !important;
}

.ltn__primary-color-2 {
  color: var(--ltn__primary-color-2) !important;
}

.ltn__primary-color-3 {
  color: var(--ltn__primary-color-3) !important;
}

.ltn__secondary-color {
  color: var(--ltn__secondary-color) !important;
}

.ltn__secondary-color-2 {
  color: var(--ltn__secondary-color-2) !important;
}

.ltn__secondary-color-3 {
  color: var(--ltn__secondary-color-3) !important;
}

.ltn__color-1 {
  color: var(--ltn__color-1);
}

.white-color {
  color: var(--white);
}

.white-color-im {
  color: var(--white) !important;
}

.ltn__primary-bg {
  background-color: var(--ltn__primary-color);
}

.ltn__primary-bg-2 {
  background-color: var(--ltn__primary-color-2);
}

.ltn__secondary-bg {
  background-color: var(--ltn__secondary-color);
}

.ltn__secondary-bg-2 {
  background-color: var(--ltn__secondary-color-2);
}

.white-bg {
  background-color: var(--white);
}

.gradient-color-1 {
  background: var(--gradient-color-1);
}

.gradient-color-2 {
  background: var(--gradient-color-2);
}

.gradient-color-3 {
  background: var(--gradient-color-3);
}

.gradient-color-4 {
  background: var(--gradient-color-4);
}

.gradient-color-5 {
  background: var(--gradient-color-5);
}

.before-bg-1 {
  position: relative;
}
.before-bg-1:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 34.2%;
  left: 0;
  bottom: 0;
  background-color: var(--section-bg-1);
}

.before-bg-top {
  position: relative;
}
.before-bg-top:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 72%;
  left: 0;
  top: 0;
  background-color: var(--section-bg-1);
}

.before-bg-bottom {
  position: relative;
}
.before-bg-bottom:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 50%;
  left: 0;
  bottom: 0;
  background-color: var(--section-bg-2);
}

.before-bg-bottom-2 {
  position: relative;
}
.before-bg-bottom-2:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 50%;
  left: 0;
  bottom: 0;
  background-color: var(--section-bg-1);
}

.before-bg-right {
  position: relative;
}
.before-bg-right:before {
  position: absolute;
  content: "";
  width: 25%;
  height: 100%;
  left: auto;
  right: 0;
  top: 0;
  background-color: var(--ltn__primary-color);
}

.before-bg-left {
  position: relative;
}
.before-bg-left:before {
  position: absolute;
  content: "";
  width: 25%;
  height: 100%;
  left: 0;
  right: auto;
  top: 0;
  background-color: var(--ltn__primary-color);
}

.box-shadow {
  box-shadow: var(--ltn__box-shadow-2);
}

.box-shadow-1 {
  box-shadow: var(--ltn__box-shadow-1);
}

.ltn__custom-icon {
  position: relative;
}
.ltn__custom-icon::before {
  content: "\\f063";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.ltn__border {
  border: 1px solid var(--border-color-1);
}

.ltn__border-top {
  border-top: 1px solid var(--border-color-1);
}

.border-top {
  border-top: 1px solid var(--border-color-1);
}

.border-bottom {
  border-bottom: 1px solid var(--border-color-1);
}

.border-color-3 {
  border-color: var(--border-color-3) !important;
}

mark {
  background-color: var(--ltn__primary-color);
  padding: 3px 15px;
  color: var(--white);
  border-radius: 25px;
}

hr {
  margin-top: 50px;
  margin-bottom: 50px;
  border-top: 1px solid var(--border-color-12);
}

a.text-decoration,
.text-decoration a {
  text-decoration: underline;
}

fieldset {
  padding: 30px 40px;
  border: 1px solid #eee;
}

fieldset legend {
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  width: auto;
  margin-top: -9px;
  margin-bottom: 0;
  padding: 0 15px;
  text-transform: uppercase;
  color: #333;
  background-color: #fff;
}

@media (max-width: 991px) {
  .before-bg-right:before {
    width: 0;
  }
  .before-bg-left:before {
    width: 0;
  }
}
.position-relative {
  position: relative;
}

.bg-fixed {
  background-attachment: fixed;
}

.bg-black {
  background-color: var(--black) !important;
  color: var(--white) !important;
}

.bg-lemon {
  background-color: #485e21 !important;
  color: var(--white) !important;
}

.bg-main {
  background-color: #21485e !important;
  color: var(--white) !important;
}

.bg-white {
  background-color: var(--white) !important;
  color: var(--black) !important;
}

.bg-red {
  background-color: var(--red) !important;
  color: var(--white) !important;
}

.bg-yellow {
  background-color: var(--yellow) !important;
  color: var(--white) !important;
}

.bg-green {
  background-color: var(--green) !important;
  color: var(--white) !important;
}

.bg-blue {
  background-color: var(--blue) !important;
  color: var(--white) !important;
}

.bg-orange {
  background-color: var(--orange) !important;
  color: var(--white) !important;
}

.bg-fuchsia {
  background-color: var(--fuchsia) !important;
  color: var(--white) !important;
}

.color-orange {
  color: var(--orange);
}

.font-weight-4 {
  font-weight: 400;
}

.font-weight-5 {
  font-weight: 500;
}

.font-weight-6 {
  font-weight: 600;
}

.font-weight-7 {
  font-weight: 700;
}

/* ----------------------------------------------------
    input and button type focus outline disable
---------------------------------------------------- */
input[type=text]:focus,
input[type=email]:focus,
input[type=url]:focus,
input[type=password]:focus,
input[type=search]:focus,
input[type=tel]:focus,
input[type=number]:focus,
textarea:focus,
input[type=button]:focus,
input[type=reset]:focus,
input[type=submit]:focus,
select:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #ddd;
}

code {
  color: #faa603;
}

/* ----------------------------------------------------
    Form input box
---------------------------------------------------- */
input[type=text],
input[type=email],
input[type=password],
input[type=submit],
textarea {
  background-color: var(--white);
  border: 2px solid;
  border-color: var(--border-color-9);
  height: 65px;
  box-shadow: none;
  padding-left: 20px;
  font-size: 16px;
  color: var(--ltn__paragraph-color);
  width: 100%;
  margin-bottom: 30px;
  border-radius: 0;
  padding-right: 40px;
}

input[type=text]::-webkit-input-placeholder,
input[type=email]::-webkit-input-placeholder,
input[type=password]::-webkit-input-placeholder,
input[type=submit]::-webkit-input-placeholder,
textarea::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: var(--ltn__paragraph-color);
  font-size: 14px;
}

input[type=text]:focus,
input[type=email]:focus,
input[type=password]:focus,
textarea:focus {
  border-color: var(--ltn__secondary-color);
}

input[type=password] {
  letter-spacing: 3px;
  font-size: 16px;
}

textarea {
  resize: vertical;
  padding: 15px 20px;
  min-height: 150px;
}

button {
  outline: none;
  border: none;
  cursor: pointer;
}

button:focus {
  outline: none;
}

.form-input-box {
  position: relative;
}

.form-input-box input[type=text] {
  width: 100%;
  height: 50px;
  padding: 0 70px 0 15px;
  border-radius: 0 15px 0px 0px;
  border: 1px solid var(--ltn__primary-color);
  margin-bottom: 0;
}

.form-input-box button[type=submit] {
  background-color: var(--ltn__primary-color);
  color: var(--white);
  padding: 0 18px;
  height: 100%;
  border: 1px solid var(--ltn__primary-color);
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}

.form-input-box button[type=submit]:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white);
}

/* input-item */
.input-item {
  position: relative;
}
.input-item.ltn__custom-icon::before {
  position: absolute;
  top: 35%;
  transform: translateY(-50%);
  right: 20px;
  color: var(--ltn__secondary-color);
}

.input-item-name.ltn__custom-icon::before {
  content: "\\f007";
}

.input-item-email.ltn__custom-icon::before {
  content: "\\f0e0";
}

.input-item-phone.ltn__custom-icon::before {
  content: "\\f095";
}

.input-item-subject.ltn__custom-icon::before {
  content: "\\f06e";
}

.input-item-website.ltn__custom-icon::before {
  content: "\\f0ac";
}

.input-item-date.ltn__custom-icon::before {
  content: "\\f073";
}

.input-item-textarea.ltn__custom-icon::before {
  content: "\\f303";
  top: 30px;
}

.input-info-save {
  font-size: 14px;
}

label.checkbox-inline {
  font-size: 14px;
}

/* ----------------------------------------------------
    Text meant only for screen readers.
---------------------------------------------------- */
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
  /* Many screen reader and browser combinations announce broken words as they would appear visually. */
}

.screen-reader-text:focus {
  background-color: #f1f1f1;
  border-radius: 3px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);
  clip: auto !important;
  clip-path: none;
  color: #21759b;
  display: block;
  font-size: 14px;
  font-size: 0.875rem;
  font-weight: bold;
  height: auto;
  left: 5px;
  line-height: normal;
  padding: 15px 23px 14px;
  text-decoration: none;
  top: 5px;
  width: auto;
  z-index: 100000;
  /* Above WP toolbar. */
}

/* Do not show the outline on the skip link target. */
#content[tabindex="-1"]:focus {
  outline: 0;
}

/* -------------------------------------
    Transition
------------------------------------- */
/* ----------------------------------------------------
    Alignments
---------------------------------------------------- */
.alignleft {
  float: left;
  clear: both;
  margin-right: 20px;
}

.alignright {
  float: right;
  clear: both;
  margin-left: 20px;
}

.aligncenter {
  clear: both;
  display: block;
  margin: 0 auto 1.75em;
}

.alignfull {
  margin: 1.5em 0;
  max-width: 100%;
}

.alignwide {
  max-width: 1100px;
}

.fix {
  overflow: hidden;
}

/* ----------------------------------------------------
    Clearings
---------------------------------------------------- */
.clear:before,
.clear:after,
.entry-content:before,
.entry-content:after,
.comment-content:before,
.comment-content:after,
.site-header:before,
.site-header:after,
.site-content:before,
.site-content:after,
.site-footer:before,
.site-footer:after {
  content: "";
  display: table;
  table-layout: fixed;
}

.clear:after,
.entry-content:after,
.comment-content:after,
.site-header:after,
.site-content:after,
.site-footer:after {
  clear: both;
}

/* ----------------------------------------------------
    Posts and pages
---------------------------------------------------- */
.sticky {
  display: block;
}

.updated:not(.published) {
  display: none;
}

.blog-pagination ul li {
  display: inline-block;
}

.blog-pagination ul li + li {
  margin: 0 5px;
}

.blog-pagination {
  display: block;
  width: 100%;
}

.blog-pagination ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.blog-pagination ul li a,
.blog-pagination ul li span {
  display: block;
  width: 40px;
  height: 40px;
  border: 1px solid #e2e2e2;
  line-height: 40px;
  text-align: center;
  font-weight: 600;
  transition: 0.3s ease-in;
}

.blog-pagination ul li span.current,
.blog-pagination ul li a:hover {
  background-color: var(--ltn__primary-color);
  color: #fff;
}

/* ----------------------------------------------------
    Media
---------------------------------------------------- */
.page-content .wp-smiley,
.entry-content .wp-smiley,
.comment-content .wp-smiley {
  border: none;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}

/* Make sure embeds and iframes fit their containers. */
embed,
iframe,
object {
  max-width: 100%;
}

/* Make sure logo link wraps around logo image. */
.custom-logo-link {
  display: inline-block;
}

/* ----------------------------------------------------
    Captions
---------------------------------------------------- */
.wp-caption {
  margin-bottom: 1.5em;
  max-width: 100%;
  clear: both;
}

.wp-caption img[class*=wp-image-] {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.wp-caption .wp-caption-text {
  margin: 0.8075em 0;
}

.wp-caption-text {
  text-align: center;
}

/* ----------------------------------------------------
    Galleries
---------------------------------------------------- */
.gallery {
  margin-bottom: 1.5em;
}

.gallery-item {
  display: inline-block;
  text-align: center;
  vertical-align: top;
  width: 100%;
}

.gallery-columns-2 .gallery-item {
  max-width: 50%;
}

.gallery-columns-3 .gallery-item {
  max-width: 33.33%;
}

.gallery-columns-4 .gallery-item {
  max-width: 25%;
}

.gallery-columns-5 .gallery-item {
  max-width: 20%;
}

.gallery-columns-6 .gallery-item {
  max-width: 16.66%;
}

.gallery-columns-7 .gallery-item {
  max-width: 14.28%;
}

.gallery-columns-8 .gallery-item {
  max-width: 12.5%;
}

.gallery-columns-9 .gallery-item {
  max-width: 11.11%;
}

.gallery-caption {
  display: block;
}

/* ----------------------------------------------------
    Unit test
---------------------------------------------------- */
.wp-link-pages a {
  margin: 0 5px;
  transition: 0.3s ease-in;
}

.wp-link-pages {
  margin-bottom: 30px;
  margin-top: 25px;
}

.wp-link-pages span,
.wp-link-pages a {
  border: 1px solid #e2e2e2;
  padding: 5px 15px;
  display: inline-block;
}

.wp-link-pages .current,
.wp-link-pages a:hover {
  background-color: var(--ltn__primary-color);
  color: #fff;
  border-color: var(--ltn__primary-color);
}

.wp-link-pages span:first-child {
  margin-right: 5px;
}

dl,
ol,
ul {
  padding-left: 20px;
}

.post-password-form input {
  display: block;
  border: 1px solid #e2e2e2;
  height: 50px;
  border-radius: 3px;
  padding: 0 20px;
}

.post-password-form label {
  font-weight: 600;
  color: #333;
}

.post-password-form input[type=submit] {
  width: 100px;
  height: 50px;
  background-color: var(--ltn__primary-color);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease-in;
}

.post-password-form input[type=submit]:hover {
  background-color: #121A2F;
}

.footer-widget .table td,
.footer-widget .table th {
  padding: 0.5rem !important;
}

/* ----------------------------------------------------
    ScrollUp
---------------------------------------------------- */
#scrollUp {
  background-color: var(--section-bg-1);
  color: var(--ltn__heading-color);
  bottom: 70px;
  font-size: 20px;
  font-weight: bold;
  height: 40px;
  width: 40px;
  right: 3%;
  text-align: center;
  transform: rotate(45deg);
  transition: all 0.3s ease 0s;
  box-shadow: var(--ltn__box-shadow-3);
}
#scrollUp i {
  line-height: 40px;
  transform: rotate(-45deg);
}
#scrollUp:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

/* ----------------------------------------------------
    Owl Carousel 
---------------------------------------------------- */
.owl-dots {
  display: block;
  text-align: center;
  margin-top: 20px;
}

.owl-dots .owl-dot {
  display: inline-block;
  background-color: var(--ltn__secondary-color);
  height: 10px;
  width: 10px;
  margin-right: 30px;
  border-radius: 100%;
}

.owl-dots .owl-dot:last-child {
  margin-right: 0px;
}

.owl-dots .owl-dot:hover,
.owl-dots .owl-dot.active {
  background-color: var(--ltn__primary-color);
}

/* owl-arrow-1 */
.owl-arrow-1 .owl-nav > div {
  position: absolute;
  left: -60px;
  top: 50%;
  transform: translateY(-50%);
  right: auto;
}

.owl-arrow-1 .owl-nav > div.owl-next {
  left: auto;
  right: -60px;
}

@media only screen and (max-width: 1200px) {
  .owl-arrow-1 .owl-nav > div {
    right: auto;
    left: 0px;
  }
  .owl-arrow-1 .owl-nav > div.owl-next {
    right: 0px;
    left: auto;
  }
}
/* ----------------------------------------------------
    Slick Slider Dots, Arrow
---------------------------------------------------- */
/* Slick dots */
.slick-dots {
  margin: 0 0 30px;
  padding: 0;
  display: block;
  text-align: center;
  line-height: 1;
}
.slick-dots li {
  display: inline-block;
  list-style: none;
  display: inline-block;
  font-size: 0;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  margin-right: 10px;
  background-color: var(--silver);
  cursor: pointer;
  margin-top: 0;
  transition: all 0.3s ease 0s;
}
.slick-dots li button {
  display: none;
}
.slick-dots li:hover, .slick-dots li.slick-active {
  background-color: var(--ltn__secondary-color);
  height: 15px;
  width: 15px;
  margin-bottom: -2px;
}

/* slick-arrow */
.slick-arrow {
  cursor: pointer;
  z-index: 9;
}

/* slick-arrow-1 */
.slick-arrow-1 .slick-arrow {
  background-color: var(--white);
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 15px;
  right: auto;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  line-height: 48px;
  display: block;
  border: 1px solid var(--white-4);
  border-radius: 100%;
  text-align: center;
  font-size: 20px;
  color: var(--ltn__primary-color) !important;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
}
.slick-arrow-1 .slick-arrow:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white) !important;
}
.slick-arrow-1 .slick-next {
  right: 15px;
  left: auto;
}
.slick-arrow-1:hover .slick-arrow {
  opacity: 1;
  visibility: visible;
}

.slick-arrow-1-inner.slick-arrow-1:hover .slick-arrow {
  left: 50px;
  right: auto;
}
.slick-arrow-1-inner.slick-arrow-1:hover .slick-next {
  right: 50px;
  left: auto;
}

@media (min-width: 1350px) {
  .slick-arrow-1:hover .slick-arrow {
    left: -50px;
    right: auto;
  }
  .slick-arrow-1:hover .slick-next {
    right: -50px;
    left: auto;
  }
}
/* slick-arrow-2 */
.slick-arrow-2 .slick-arrow {
  color: var(--ltn__primary-color) !important;
  cursor: pointer;
  position: absolute;
  bottom: -30px;
  height: 30px;
  width: 30px;
  line-height: 28px;
  display: block;
  left: 15px;
  border: 1px solid var(--border-color-1);
  text-align: center;
}
.slick-arrow-2 .slick-arrow:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white) !important;
}
.slick-arrow-2 .slick-next {
  left: 60px;
}

/* slick-arrow-3 */
.slick-arrow-3 .slick-arrow {
  cursor: pointer;
  position: absolute;
  top: -120px;
  height: 60px;
  width: 60px;
  line-height: 58px;
  display: block;
  left: auto;
  right: 100px;
  border: 2px solid;
  text-align: center;
  box-shadow: var(--ltn__box-shadow-2);
}
.slick-arrow-3 .slick-arrow:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--border-color-4);
  color: var(--white) !important;
}
.slick-arrow-3 .slick-next {
  right: 15px;
  background-color: var(--white);
  border-color: var(--white);
  color: var(--ltn__primary-color) !important;
}
.slick-arrow-3 .slick-prev {
  background-color: var(--ltn__secondary-color);
  border-color: var(--border-color-4);
  color: var(--white) !important;
}

/* slick-arrow-4 */
.slick-arrow-4 {
  margin: 0;
}
.slick-arrow-4 .slick-arrow {
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  text-align: center;
  height: 50px;
  width: 50px;
  line-height: 50px;
  margin: 0 auto;
  border: 1px solid;
  border-radius: 100%;
}
.slick-arrow-4 .slick-arrow:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--border-color-4);
  color: var(--white) !important;
}
.slick-arrow-4 .slick-next {
  right: -60px;
}
.slick-arrow-4 .slick-prev {
  left: -60px;
}

@media (max-width: 767px) {
  .slick-dots {
    margin: 0 0 15px;
  }
}
/* ----------------------------------------------------
    Background Overlay
---------------------------------------------------- */
.compassion {
  color: #485e21 !important;
}

.bg-overlay-black-10,
.bg-overlay-black-20,
.bg-overlay-black-30,
.bg-overlay-black-40,
.bg-overlay-black-50,
.bg-overlay-black-60,
.bg-overlay-black-70,
.bg-overlay-black-80,
.bg-overlay-black-90,
.bg-overlay-white-10,
.bg-overlay-white-20,
.bg-overlay-white-30,
.bg-overlay-white-40,
.bg-overlay-white-50,
.bg-overlay-white-60,
.bg-overlay-white-70,
.bg-overlay-white-80,
.bg-overlay-white-90 {
  z-index: 8;
  position: relative;
}

.bg-overlay-black-10:before,
.bg-overlay-black-20:before,
.bg-overlay-black-30:before,
.bg-overlay-black-40:before,
.bg-overlay-black-50:before,
.bg-overlay-black-60:before,
.bg-overlay-black-70:before,
.bg-overlay-black-80:before,
.bg-overlay-black-90:before,
.bg-overlay-white-10:before,
.bg-overlay-white-20:before,
.bg-overlay-white-30:before,
.bg-overlay-white-40:before,
.bg-overlay-white-50:before,
.bg-overlay-white-60:before,
.bg-overlay-white-70:before,
.bg-overlay-white-80:before,
.bg-overlay-white-90:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.bg-overlay-black-10:before {
  background: rgba(0, 0, 0, 0.1);
}

.bg-overlay-black-20:before {
  background: rgba(0, 0, 0, 0.2);
}

.bg-overlay-black-30:before {
  background: rgba(0, 0, 0, 0.3);
}

.bg-overlay-black-40:before {
  background: rgba(0, 0, 0, 0.4);
}

.bg-overlay-black-50:before {
  background: rgba(0, 0, 0, 0.5);
}

.bg-overlay-black-60:before {
  background: rgba(0, 0, 0, 0.6);
}

.bg-overlay-black-70:before {
  background: rgba(0, 0, 0, 0.7);
}

.bg-overlay-black-80:before {
  background: rgba(0, 0, 0, 0.8);
}

.bg-overlay-black-90:before {
  background: rgba(0, 0, 0, 0.9);
}

.bg-overlay-white-10:before {
  background: rgba(255, 255, 255, 0.1);
}

.bg-overlay-white-20:before {
  background: rgba(255, 255, 255, 0.2);
}

.bg-overlay-white-30:before {
  background: rgba(255, 255, 255, 0.3);
}

.bg-overlay-white-40:before {
  background: rgba(255, 255, 255, 0.4);
}

.bg-overlay-white-50:before {
  background: rgba(255, 255, 255, 0.5);
}

.bg-overlay-white-60:before {
  background: rgba(255, 255, 255, 0.6);
}

.bg-overlay-white-70:before {
  background: rgba(255, 255, 255, 0.7);
}

.bg-overlay-white-80:before {
  background: rgba(255, 255, 255, 0.8);
}

.bg-overlay-white-90:before {
  background: rgba(255, 255, 255, 0.9);
}

.compassion-bg,
.bg-overlay-theme-05,
.bg-overlay-theme-10,
.bg-overlay-theme-20,
.bg-overlay-theme-30,
.bg-overlay-theme-40,
.bg-overlay-theme-50,
.bg-overlay-theme-60,
.bg-overlay-theme-70,
.bg-overlay-theme-80,
.bg-overlay-theme-90 {
  z-index: 9;
  position: relative;
}

.bg-overlay-theme-05:before,
.bg-overlay-theme-10:before,
.bg-overlay-theme-20:before,
.bg-overlay-theme-30:before,
.bg-overlay-theme-40:before,
.bg-overlay-theme-50:before,
.bg-overlay-theme-60:before,
.bg-overlay-theme-70:before,
.bg-overlay-theme-80:before,
.compassion-bg:before,
.bg-overlay-theme-90:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.bg-overlay-theme-05:before {
  background: rgba(10, 154, 115, 0.05);
}

.bg-overlay-theme-10:before {
  background: rgba(10, 154, 115, 0.1);
}

.bg-overlay-theme-20:before {
  background: rgba(10, 154, 115, 0.2);
}

.bg-overlay-theme-30:before {
  background: rgba(10, 154, 115, 0.3);
}

.bg-overlay-theme-40:before {
  background: rgba(10, 154, 115, 0.4);
}

.bg-overlay-theme-50:before {
  background: rgba(10, 154, 115, 0.5);
}

.bg-overlay-theme-60:before {
  background: rgba(10, 154, 115, 0.6);
}

.bg-overlay-theme-70:before {
  background: rgba(10, 154, 115, 0.7);
}

.bg-overlay-theme-80:before {
  background: rgba(10, 154, 115, 0.8);
}

.bg-overlay-theme-90:before {
  background: rgba(33, 72, 94, 0.9);
}

.compassion-bg:before {
  background: rgba(72, 94, 33, 0.9);
}

.bg-overlay-theme-black-05,
.bg-overlay-theme-black-10,
.bg-overlay-theme-black-20,
.bg-overlay-theme-black-30,
.bg-overlay-theme-black-40,
.bg-overlay-theme-black-50,
.bg-overlay-theme-black-60,
.bg-overlay-theme-black-70,
.bg-overlay-theme-black-80,
.bg-overlay-theme-black-90 {
  z-index: 9;
  position: relative;
}

.bg-overlay-theme-black-05:before,
.bg-overlay-theme-black-10:before,
.bg-overlay-theme-black-20:before,
.bg-overlay-theme-black-30:before,
.bg-overlay-theme-black-40:before,
.bg-overlay-theme-black-50:before,
.bg-overlay-theme-black-60:before,
.bg-overlay-theme-black-70:before,
.bg-overlay-theme-black-80:before,
.bg-overlay-theme-black-90:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.bg-overlay-theme-black-05:before {
  background: rgba(7, 28, 31, 0.05);
}

.bg-overlay-theme-black-10:before {
  background: rgba(7, 28, 31, 0.1);
}

.bg-overlay-theme-black-20:before {
  background: rgba(7, 28, 31, 0.2);
}

.bg-overlay-theme-black-30:before {
  background: rgba(7, 28, 31, 0.3);
}

.bg-overlay-theme-black-40:before {
  background: rgba(7, 28, 31, 0.4);
}

.bg-overlay-theme-black-50:before {
  background: rgba(7, 28, 31, 0.5);
}

.bg-overlay-theme-black-60:before {
  background: rgba(7, 28, 31, 0.6);
}

.bg-overlay-theme-black-70:before {
  background: rgba(7, 28, 31, 0.7);
}

.bg-overlay-theme-black-80:before {
  background: rgba(7, 28, 31, 0.8);
}

.bg-overlay-theme-black-90:before {
  background: rgba(7, 28, 31, 0.9);
}

/* ----------------------------------------------
  Scrollbar
---------------------------------------------- */
.ltn__scrollbar {
  overflow-y: auto;
}

.ltn__scrollbar::-webkit-scrollbar {
  width: 2px;
  background-color: #f5f5f5;
  border-radius: 30px;
}

.ltn__scrollbar::-webkit-scrollbar-thumb {
  background-color: #ddd;
}

.mean-nav {
  overflow-y: auto;
}

.mean-nav::-webkit-scrollbar {
  width: 3px;
  background-color: var(--ltn__primary-color);
  border-radius: 30px;
}

.mean-nav::-webkit-scrollbar-thumb {
  background-color: var(--ltn__secondary-color);
}

/* ----------------------------------------------------
    Padding Top
---------------------------------------------------- */
.pt-0 {
  padding-top: 0px !important;
}

.pt-10 {
  padding-top: 10px !important;
}

.pt-15 {
  padding-top: 15px !important;
}

.pt-20 {
  padding-top: 20px !important;
}

.pt-25 {
  padding-top: 25px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-35 {
  padding-top: 35px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-45 {
  padding-top: 45px;
}

.pt-50 {
  padding-top: 50px;
}

.pt-55 {
  padding-top: 55px;
}

.pt-60 {
  padding-top: 60px;
}

.pt-65 {
  padding-top: 65px;
}

.pt-70 {
  padding-top: 70px;
}

.pt-75 {
  padding-top: 75px;
}

.pt-80 {
  padding-top: 80px;
}

.pt-85 {
  padding-top: 85px;
}

.pt-90 {
  padding-top: 90px;
}

.pt-95 {
  padding-top: 95px;
}

.pt-97 {
  padding-top: 97px;
}

.pt-100 {
  padding-top: 100px;
}

.pt-105 {
  padding-top: 105px;
}

.pt-110 {
  padding-top: 110px;
}

.pt-112 {
  padding-top: 112px;
}

.pt-115 {
  padding-top: 115px;
}

.pt-118 {
  padding-top: 118px;
}

.pt-120 {
  padding-top: 120px;
}

.pt-122 {
  padding-top: 122px;
}

.pt-125 {
  padding-top: 125px;
}

.pt-130 {
  padding-top: 130px;
}

.pt-135 {
  padding-top: 135px;
}

.pt-140 {
  padding-top: 140px;
}

.pt-145 {
  padding-top: 145px;
}

.pt-150 {
  padding-top: 150px;
}

.pt-155 {
  padding-top: 155px;
}

.pt-160 {
  padding-top: 160px;
}

.pt-170 {
  padding-top: 170px;
}

.pt-180 {
  padding-top: 180px;
}

.pt-190 {
  padding-top: 190px;
}

.pt-200 {
  padding-top: 200px;
}

.pt-210 {
  padding-top: 210px;
}

.pt-220 {
  padding-top: 220px;
}

.pt-230 {
  padding-top: 230px;
}

.pt-250 {
  padding-top: 250px;
}

.pt-280 {
  padding-top: 280px;
}

.pt-290 {
  padding-top: 290px;
}

.pt-300 {
  padding-top: 300px;
}

.pt-310 {
  padding-top: 310px;
}

.pt-320 {
  padding-top: 320px;
}

.pt-350 {
  padding-top: 350px;
}

/* ----------------------------------------------------
    Padding Bottom
---------------------------------------------------- */
.pb-0 {
  padding-bottom: 0px !important;
}

.pb-10 {
  padding-bottom: 10px !important;
}

.pb-15 {
  padding-bottom: 15px !important;
}

.pb-20 {
  padding-bottom: 20px !important;
}

.pb-25 {
  padding-bottom: 25px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-35 {
  padding-bottom: 35px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-45 {
  padding-bottom: 45px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-55 {
  padding-bottom: 55px;
}

.pb-60 {
  padding-bottom: 60px;
}

.pb-65 {
  padding-bottom: 65px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pb-75 {
  padding-bottom: 75px;
}

.pb-80 {
  padding-bottom: 80px;
}

.pb-85 {
  padding-bottom: 85px;
}

.pb-90 {
  padding-bottom: 90px;
}

.pb-95 {
  padding-bottom: 95px;
}

.pb-97 {
  padding-bottom: 97px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pb-105 {
  padding-bottom: 105px;
}

.pb-107 {
  padding-bottom: 107px;
}

.pb-110 {
  padding-bottom: 110px;
}

.pb-112 {
  padding-bottom: 112px;
}

.pb-115 {
  padding-bottom: 115px;
}

.pb-118 {
  padding-bottom: 118px;
}

.pb-120 {
  padding-bottom: 120px;
}

.pb-122 {
  padding-bottom: 122px;
}

.pb-125 {
  padding-bottom: 125px;
}

.pb-130 {
  padding-bottom: 130px;
}

.pb-140 {
  padding-bottom: 140px;
}

.pb-145 {
  padding-bottom: 145px;
}

.pb-150 {
  padding-bottom: 150px;
}

.pb-155 {
  padding-bottom: 155px;
}

.pb-160 {
  padding-bottom: 160px;
}

.pb-170 {
  padding-bottom: 170px;
}

.pb-180 {
  padding-bottom: 180px;
}

.pb-190 {
  padding-bottom: 190px;
}

.pb-200 {
  padding-bottom: 200px;
}

.pb-210 {
  padding-bottom: 210px;
}

.pb-220 {
  padding-bottom: 220px;
}

.pb-250 {
  padding-bottom: 250px;
}

.pb-280 {
  padding-bottom: 280px;
}

.pb-290 {
  padding-bottom: 290px;
}

.pb-300 {
  padding-bottom: 300px;
}

.pb-310 {
  padding-bottom: 310px;
}

.pb-320 {
  padding-bottom: 320px;
}

.pb-350 {
  padding-bottom: 350px;
}

/* ----------------------------------------------------
    Margin Top
---------------------------------------------------- */
.mt-0 {
  margin-top: 0px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-12 {
  margin-top: 12px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-25 {
  margin-top: 25px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.mt-35 {
  margin-top: 35px;
}

.mt-37 {
  margin-top: 37px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-45 {
  margin-top: 45px;
}

.mt-50 {
  margin-top: 50px;
}

.mt-55 {
  margin-top: 55px;
}

.mt-60 {
  margin-top: 60px;
}

.mt-65 {
  margin-top: 65px;
}

.mt-70 {
  margin-top: 70px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-90 {
  margin-top: 90px;
}

.mt-95 {
  margin-top: 95px;
}

.mt-100 {
  margin-top: 100px;
}

.mt-105 {
  margin-top: 105px;
}

.mt-110 {
  margin-top: 110px;
}

.mt-115 {
  margin-top: 115px;
}

.mt-118 {
  margin-top: 118px;
}

.mt-120 {
  margin-top: 120px;
}

.mt-122 {
  margin-top: 122px;
}

.mt-125 {
  margin-top: 125px;
}

.mt-130 {
  margin-top: 130px;
}

.mt-140 {
  margin-top: 140px;
}

.mt-150 {
  margin-top: 150px;
}

.mt-160 {
  margin-top: 160px;
}

.mt-170 {
  margin-top: 170px;
}

/* ----------------------------------------------------
    Margin Bottom
---------------------------------------------------- */
.mb-0 {
  margin-bottom: 0px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mb-12 {
  margin-bottom: 12px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mb-25 {
  margin-bottom: 25px !important;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mb-35 {
  margin-bottom: 35px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-45 {
  margin-bottom: 45px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-55 {
  margin-bottom: 55px;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-65 {
  margin-bottom: 65px;
}

.mb-70 {
  margin-bottom: 70px;
}

.mb-80 {
  margin-bottom: 80px;
}

.mb-90 {
  margin-bottom: 90px;
}

.mb-95 {
  margin-bottom: 95px;
}

.mb-100 {
  margin-bottom: 100px;
}

.mb-105 {
  margin-bottom: 105px;
}

.mb-110 {
  margin-bottom: 110px;
}

.mb-115 {
  margin-bottom: 115px;
}

.mb-118 {
  margin-bottom: 118px;
}

.mb-120 {
  margin-bottom: 120px;
}

.mb-122 {
  margin-bottom: 122px;
}

.mb-125 {
  margin-bottom: 125px;
}

.mb-130 {
  margin-bottom: 130px;
}

.mb-140 {
  margin-bottom: 140px;
}

.mb-150 {
  margin-bottom: 150px;
}

/* ----------------------------------------------------
    Custom margin Padding
---------------------------------------------------- */
.pl-0 {
  padding-left: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.mr-30 {
  margin-right: 30px;
}

.ml-30 {
  margin-left: 30px;
}

.pl-70 {
  padding-left: 70px;
}

.pr-70 {
  padding-right: 70px;
}

/* Padding left right */
.plr--2 {
  padding-left: 2%;
  padding-right: 2%;
}

.plr--3 {
  padding-left: 3%;
  padding-right: 3%;
}

.plr--4 {
  padding-left: 4%;
  padding-right: 4%;
}

.plr--5 {
  padding-left: 5%;
  padding-right: 5%;
}

.plr--6 {
  padding-left: 6%;
  padding-right: 6%;
}

.plr--7 {
  padding-left: 7%;
  padding-right: 7%;
}

.plr--8 {
  padding-left: 8%;
  padding-right: 8%;
}

.plr--9 { /* used */
  padding-left: 9%;
  padding-right: 9%;
}

.plr--10 {
  padding-left: 10%;
  padding-right: 10%;
}

.plr--11 {
  padding-left: 11%;
  padding-right: 11%;
}

.plr--12 {
  padding-left: 12%;
  padding-right: 12%;
}

@media (max-width: 1599px) {
  .plr--2,
  .plr--3,
  .plr--4,
  .plr--5,
  .plr--6,
  .plr--7,
  .plr--8,
  .plr--9,
  .plr--10,
  .plr--11,
  .plr--12 {
    padding-left: 2%;
    padding-right: 2%;
  }
}
@media (max-width: 1399px) {
  .plr--2,
  .plr--3,
  .plr--4,
  .plr--5,
  .plr--6,
  .plr--7,
  .plr--8,
  .plr--9,
  .plr--10,
  .plr--11,
  .plr--12 {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media (min-width: 1200px) {
  /* Margin Top Minus */
  .mt--30 {
    margin-top: -30px !important;
  }
  .mt--65 {
    margin-top: -65px;
  }
  .mt--80 {
    margin-top: -100px;
  }
  .mt--90 {
    margin-top: -100px;
  }
  .mt--100 {
    margin-top: -100px;
  }
  .mt--110 {
    margin-top: -100px;
  }
  .mt--120 {
    margin-top: -100px;
  }
  .mt--150 {
    margin-top: -100px;
  }
}
@media (max-width: 767px) {
  .mb-sm-20 {
    margin-bottom: 20px;
  }
}
/* Margin Bottom Minus */
.mb--30 {
  margin-bottom: -30px;
}

.mb--80 {
  margin-bottom: -100px;
}

.mb--90 {
  margin-bottom: -100px;
}

.mb--100 {
  margin-bottom: -100px;
}

.mb--110 {
  margin-bottom: -100px;
}

.mb--120 {
  margin-bottom: -100px;
}

.mb--150 {
  margin-bottom: -100px;
}

/* ----------------------------------------------------
    Custom Height
---------------------------------------------------- */
.ltn__height-100 {
  height: 100px;
}

.ltn__height-200 {
  height: 200px;
}

.ltn__height-250 {
  height: 250px;
}

.ltn__height-300 {
  height: 300px;
}

.ltn__height-350 {
  height: 350px;
}

.ltn__height-400 {
  height: 400px;
}

.ltn__height-450 {
  height: 450px;
}

.ltn__height-500 {
  height: 500px;
}

.ltn__height-550 {
  height: 550px;
}

.ltn__height-600 {
  height: 600px;
}

.ltn__height-650 {
  height: 650px;
}

.ltn__height-700 {
  height: 700px;
}

/* --------------------------------------------------------------
# Gutenberg	Default Style
-------------------------------------------------------------- */
.single-post-details-item .entry-content > .alignwide {
  max-width: 1100px;
}

.single-post-details-item .entry-content > .alignfull {
  margin: 1.5em 0;
  max-width: 100%;
}

.wp-block-video video {
  max-width: 636px;
}

.wp-block-image img {
  display: block;
}

.wp-block-image.alignleft,
.wp-block-image.alignright {
  width: 100%;
}

.wp-block-image.alignfull img {
  width: 100vw;
}

.wp-block-gallery:not(.components-placeholder) {
  margin: 1.5em auto;
}

.wp-block-cover-text p {
  padding: 1.5em 14px;
}

ul.wp-block-latest-posts.alignwide,
ul.wp-block-latest-posts.alignfull,
ul.wp-block-latest-posts.is-grid.alignwide,
ul.wp-block-latest-posts.is-grid.alignwide {
  padding: 0 14px;
}

.wp-block-table {
  display: block;
  overflow-x: auto;
}

.wp-block-table table {
  border-collapse: collapse;
  width: 100%;
}

.wp-block-table td, .wp-block-table th {
  padding: 0.5em;
}

.wp-block-embed.type-video > .wp-block-embed__wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
}

.wp-block-embed.type-video > .wp-block-embed__wrapper > iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.wp-block-quote.is-large {
  margin: 0 auto 16px;
}

.wp-block-pullquote > p:first-child {
  margin-top: 0;
}

.wp-block-separator {
  margin: 3em auto;
  padding: 0;
}

@media screen and (min-width: 768px) {
  .wp-block-cover-text p {
    padding: 1.5em 0;
  }
}
.wp-block-video video {
  max-width: 636px;
}

.wp-block-image img {
  display: block;
}

.wp-block-image.alignleft,
.wp-block-image.alignright {
  width: 100%;
}

.wp-block-image.alignfull img {
  width: 100vw;
}

.wp-block-gallery:not(.components-placeholder) {
  margin: 1.5em auto;
}

.wp-block-cover-text p {
  padding: 1.5em 14px;
}

ul.wp-block-latest-posts.alignwide,
ul.wp-block-latest-posts.alignfull,
ul.wp-block-latest-posts.is-grid.alignwide,
ul.wp-block-latest-posts.is-grid.alignwide {
  padding: 0 14px;
}

.wp-block-table {
  display: block;
  overflow-x: auto;
}

.wp-block-table table {
  border-collapse: collapse;
  width: 100%;
}

.wp-block-table td, .wp-block-table th {
  padding: 0.5em;
}

.wp-block-embed.type-video > .wp-block-embed__wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
}

.wp-block-embed.type-video > .wp-block-embed__wrapper > iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.wp-block-quote.is-large {
  margin: 0 auto 16px;
}

.wp-block-pullquote > p:first-child {
  margin-top: 0;
}

.wp-block-quote:not(.is-large):not(.is-style-large) {
  border-left: 4px solid #000;
  padding-left: 1em;
}

.wp-block-separator {
  margin: 3em auto;
  padding: 0;
}

@media screen and (min-width: 768px) {
  .wp-block-cover-text p {
    padding: 1.5em 0;
  }
}
.wp-block-pullquote {
  border-top: 4px solid #555d66;
  border-bottom: 4px solid #555d66;
  color: #40464d;
}

/* --------------------------------------------------------------
## Block Color Palette Colors
-------------------------------------------------------------- */
.has-strong-blue-color {
  color: #0073aa;
}

.has-strong-blue-background-color {
  background-color: #0073aa;
}

.has-lighter-blue-color {
  color: #229fd8;
}

.has-lighter-blue-background-color {
  background-color: #229fd8;
}

.has-very-light-gray-color {
  color: #eee;
}

.has-very-light-gray-background-color {
  background-color: #eee;
}

.has-very-dark-gray-color {
  color: #444;
}

.has-very-dark-gray-background-color {
  background-color: #444;
}

/* ----------------------------------------------------
    Animation Custom Class
---------------------------------------------------- */
.ltn__effect-img {
  position: absolute;
}

.ltn__effect-img-top-left {
  top: 6%;
  left: 5%;
}

.ltn__effect-img-top-right {
  top: 5%;
  right: 5%;
}

.ltn__effect-img-center-left {
  top: 50%;
  transform: translateY(-50%);
  left: 3%;
}

.ltn__effect-img-center-center {
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
}

.ltn__effect-img-center-right {
  top: 50%;
  transform: translateY(-50%);
  right: 3%;
}

.ltn__effect-img-bottom-left {
  bottom: 5%;
  left: 0;
}

.ltn__effect-img-bottom-right {
  bottom: 5%;
  right: 5%;
}

.ltn__animation-pulse1 a {
  animation: pulse1 1s infinite;
}

.ltn__animation-pulse2 a {
  animation: pulse2 1s infinite;
}
@keyframes pulse1 {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
@keyframes pulse2 {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0.6);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(255, 90, 60, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0);
  }
}
/* ----------------------------------------------------
    Animation CSS
---------------------------------------------------- */
.ltn__parallax-effect-wrap,
.layer {
  display: block;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}

.ltn__parallax-effect-wrap {
  min-height: 600px;
  position: relative;
  overflow: hidden;
}

.layer {
  position: absolute;
}

.layer div {
  transform: translate3d(0, 0, 0);
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

.background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 100%;
  bottom: 96px;
  background-size: cover;
  position: absolute;
  width: 110%;
  left: -5%;
  top: -5%;
}

.lighthouse {
  transform-origin: 50% 90%;
  animation: lighthouse 4s 0.1s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
  margin: 0px -64px;
  background-size: 128px 224px;
  height: 224px;
  width: 128px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  bottom: 64px;
  position: absolute;
  right: 20%;
}

.wave.plain {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.wave.paint {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.light {
  margin: -120px -120px;
  background-size: 240px 240px;
  height: 240px;
  width: 240px;
  background-repeat: no-repeat;
  bottom: 112px;
  position: absolute;
  left: 50%;
}

.light.orange {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.light.purple {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.light.a {
  bottom: 80px;
  left: 20%;
}

.light.b {
  bottom: 80px;
  left: 30%;
}

.light.c {
  bottom: 112px;
  left: 45%;
}

.light.d {
  bottom: 96px;
  left: 60%;
}

.light.e {
  bottom: 112px;
  left: 75%;
}

.light.f {
  bottom: 64px;
  left: 80%;
}

.light.phase-1 {
  animation: phase 20s 0.1s infinite linear;
}

.light.phase-2 {
  animation: phase 18s 0.1s infinite linear;
}

.light.phase-3 {
  animation: phase 16s 0.1s infinite linear;
}

.light.phase-4 {
  animation: phase 14s 0.1s infinite linear;
}

.light.phase-5 {
  animation: phase 12s 0.1s infinite linear;
}

.light.phase-6 {
  animation: phase 10s 0.1s infinite linear;
}

.hanger {
  transform-origin: 0% 0%;
  position: absolute;
}

.hanger.position-1 {
  top: 28%;
}

.hanger.position-2 {
  top: 46%;
}

.hanger.position-3 {
  top: 59%;
}

.hanger.position-4 {
  top: 66.5%;
}

.hanger.position-5 {
  top: 69.5%;
}

.hanger.position-6 {
  top: 66.5%;
}

.hanger.position-7 {
  top: 59%;
}

.hanger.position-8 {
  top: 46%;
}

.hanger.position-9 {
  top: 28%;
}

.hanger.position-1 {
  left: 10%;
}

.hanger.position-2 {
  left: 20%;
}

.hanger.position-3 {
  left: 30%;
}

.hanger.position-4 {
  left: 40%;
}

.hanger.position-5 {
  left: 50%;
}

.hanger.position-6 {
  left: 60%;
}

.hanger.position-7 {
  left: 70%;
}

.hanger.position-8 {
  left: 80%;
}

.hanger.position-9 {
  left: 90%;
}

.board {
  transform-origin: 50% 0%;
  margin: 0px -140px;
  background-size: 280px 280px;
  height: 280px;
  width: 280px;
  background-repeat: no-repeat;
  position: absolute;
  top: -4px;
  left: 0;
}

.board.birds {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.board.cloud-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.board.cloud-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.board.cloud-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.board.cloud-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.swing-1 {
  animation: swing 4s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.swing-2 {
  animation: swing 3.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.swing-3 {
  animation: swing 3s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.swing-4 {
  animation: swing 2.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.swing-5 {
  animation: swing 2s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

/* --------------- */
.wave {
  background: transparent repeat-x;
  position: absolute;
  width: 100%;
  left: 0;
  margin: 0px 0px;
  background-position: center bottom;
  background-size: auto 101%;
  height: 30%;
  animation: wave 5.33333s 0.1s infinite linear;
}

.ltn__animation-wave-3s {
  animation: wave 3s 0.1s infinite linear;
}

.ltn__animation-wave-4s {
  animation: wave 4s 0.1s infinite linear;
}

.ltn__animation-wave-5s {
  animation: wave 5.33333s 0.1s infinite linear;
}

.ltn__animation-wave-6s {
  animation: wave 6.22222s 0.1s infinite linear;
}

.ltn__animation-wave-7s {
  animation: wave 7.11111s 0.1s infinite linear;
}

.ltn__animation-wave-8s {
  animation: wave 8s 0.1s infinite linear;
}

.cross, .x, .y {
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
@keyframes phase {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
  75% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
@keyframes tilt {
  0% {
    transform: rotateX(-30deg);
  }
  25% {
    transform: rotateX(30deg);
  }
  50% {
    transform: rotateY(-30deg);
  }
  75% {
    transform: rotateY(30deg);
  }
  100% {
    transform: rotateZ(20deg);
  }
}
@keyframes wave {
  0% {
    transform: rotateZ(0deg) translate3d(0, 10%, 0) rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg) translate3d(0, 10%, 0) rotateZ(-360deg);
  }
}
@keyframes lighthouse {
  0% {
    transform: translate3d(15%, 0, 0) rotateZ(10deg);
  }
  100% {
    transform: translate3d(-15%, 0, 0) rotateZ(-10deg);
  }
}
@keyframes swing {
  0% {
    transform: rotateZ(10deg);
  }
  100% {
    transform: rotateZ(-10deg);
  }
}
/* ----------------------------------------------------
    End Animation
---------------------------------------------------- */
/* ----------------------------------------------------
    Breadcurmb Area
---------------------------------------------------- */
.ltn__breadcrumb-area {
  height: 600px;
  background-color: var(--section-bg-1);
  margin-bottom: 120px;
  padding-top: 300px;
  padding-bottom: 110px;
}

.ltn__breadcrumb-list ul {
  margin: 0;
  padding: 0;
}

.ltn__breadcrumb-list ul li {
  display: inline-block;
  margin-right: 30px;
  position: relative;
  font-weight: 700;
}

.ltn__breadcrumb-list ul li:last-child {
  margin-right: 0;
  color: var(--ltn__primary-color);
}

.ltn__breadcrumb-list ul li:after {
  position: absolute;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 10px;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
}

.ltn__breadcrumb-list ul li:last-child:after {
  display: none;
}

/* breadcrumb-area-2 */
.ltn__breadcrumb-area-2 {
  padding-top: 250px;
  padding-bottom: 130px;
}

.ltn__breadcrumb-inner-2 {
  display: flex;
  align-items: center;
}
.ltn__breadcrumb-inner-2 .section-title-area {
  margin-bottom: 0;
}
.ltn__breadcrumb-inner-2 .ltn__section-title-2 .section-title {
  margin-bottom: 0;
}
.ltn__breadcrumb-inner-2 .ltn__breadcrumb-list {
  margin-left: 100px;
}
.ltn__breadcrumb-inner-2 .ltn__breadcrumb-list ul li:after {
  position: absolute;
  content: "";
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  height: 10px;
  width: 2px;
  background-color: var(--ltn__color-1);
  opacity: 0.5;
}

.ltn__breadcrumb-color-white .ltn__breadcrumb-list li {
  color: var(--ltn__color-1);
}
.ltn__breadcrumb-color-white .ltn__breadcrumb-list li:last-child {
  color: var(--ltn__secondary-color);
}

/* breadcrumb-area-3 */
.ltn__breadcrumb-area-3 {
  padding-top: 350px;
  padding-bottom: 130px;
}

/* breadcrumb-area-4 */
.ltn__breadcrumb-inner-4 .section-title-area {
  margin-bottom: 0;
}
.ltn__breadcrumb-inner-4 .ltn__breadcrumb-list ul li:last-child {
  opacity: 0.5;
}

/* ----------------------------------------------------
    Responsive
---------------------------------------------------- */
@media (max-width: 767px) {
  .ltn__breadcrumb-area-2 {
    padding-top: 240px;
    padding-bottom: 80px;
  }
  .ltn__breadcrumb-inner-2 {
    flex-flow: column;
    text-align: center;
  }
  .ltn__breadcrumb-inner-2 .ltn__breadcrumb-list {
    margin-left: 0;
  }
  .ltn__breadcrumb-list ul li {
    font-size: 14px;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ============================================================
>>> TABLE OF CONTENTS:
===============================================================
# Widgets
# Search Widget
# Newsletter Widget
# Tag Cloud Widget
# Color Widget
# Menu Widget
# Popular Post Widget
# Banner Widget
# Top Rated Product Widget
# Price Filter Widget
# Instagram Widget
# Video Widget
# Author Widget
# Widget Responsive

============================================================= */
/* --------------------------------------------------------------
    Widgets
-------------------------------------------------------------- */
.widget {
  margin-bottom: 40px;
  padding: 35px 30px 40px 35px;
  border: 2px solid var(--border-color-11);
}
.widget:last-child {
  margin-bottom: 0;
}
.widget hr {
  margin-top: 35px;
  margin-bottom: 35px;
}

.ltn__widget-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 25px;
  text-transform: capitalize;
}

.ltn__widget-title-border {
  position: relative;
  padding-left: 45px;
}
.ltn__widget-title-border::after, .ltn__widget-title-border::before {
  position: absolute;
  content: "";
  background-color: var(--ltn__secondary-color);
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.ltn__widget-title-border::before {
  width: 18px;
  height: 4px;
  border-radius: 25px;
}
.ltn__widget-title-border::after {
  width: 4px;
  height: 4px;
  left: 22px;
  border-radius: 100%;
}

.ltn__widget-title-border-2 {
  border-left: 2px solid;
  border-color: var(--ltn__secondary-color);
  padding-left: 10px;
  position: relative;
}
.ltn__widget-title-border-2::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 14px;
  background-color: var(--ltn__secondary-color);
  display: none;
}

/* widget-2 */
.widget-2 {
  margin-bottom: 40px;
}

/* ----------------------------------------------------
    Search Widget
---------------------------------------------------- */
.ltn__search-widget form {
  position: relative;
}

.ltn__search-widget input[type=text] {
  margin-bottom: 0;
  padding-right: 65px;
  padding-left: 20px;
  height: 60px;
  background-color: var(--section-bg-1);
  font-weight: 600;
  font-size: 14px;
}

.ltn__search-widget input[type=text]::-webkit-input-placeholder {
  color: var(--ltn__primary-color);
  font-size: 12px;
}

.ltn__search-widget button {
  position: absolute;
  right: 0;
  height: 100%;
  padding: 0 20px;
  color: var(--white);
  border: 1px solid;
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  transition: all 0.3s ease 0s;
}

.ltn__search-widget button:hover {
  color: var(--white);
  background-color: var(--ltn__primary-color);
  border-color: var(--ltn__primary-color);
}

/* ----------------------------------------------------
    Newsletter Widget
---------------------------------------------------- */
.ltn__newsletter-widget {
  background-color: var(--ltn__primary-color);
  padding: 50px 35px;
  position: relative;
  z-index: 2;
}
.ltn__newsletter-widget h6 {
  color: var(--ltn__secondary-color);
  margin-bottom: 5px;
}
.ltn__newsletter-widget h4 {
  color: var(--white);
  font-size: 36px;
}
.ltn__newsletter-widget input[type=text] {
  background-color: #133236;
  color: var(--white);
  border-color: #133236;
  height: 70px;
  padding-left: 25px;
  padding-right: 70px;
}
.ltn__newsletter-widget input[type=text]::placeholder {
  color: var(--white);
}
.ltn__newsletter-widget button {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white);
  padding: 0 25px;
}
.ltn__newsletter-widget button:hover {
  background-color: var(--ltn__secondary-color-2);
  border-color: var(--ltn__secondary-color-2);
  color: var(--white);
}

.ltn__newsletter-bg-icon {
  position: absolute;
  right: 20px;
  top: 15%;
  font-size: 120px;
  color: var(--ltn__color-1);
  opacity: 0.1;
  z-index: -1;
  line-height: 1;
}

/* ----------------------------------------------------
    Tag Cloud Widget
---------------------------------------------------- */
.ltn__tagcloud-widget ul {
  margin: 0;
  padding: 0;
}
.ltn__tagcloud-widget ul li {
  list-style: none;
  display: inline-block;
  margin: 5px 3px;
}
.ltn__tagcloud-widget ul li a {
  display: block;
  padding: 8px 24px 6px;
  font-size: 13px;
  text-transform: uppercase;
  background-color: var(--section-bg-1);
  font-weight: 700;
  font-family: var(--ltn__heading-font);
}
.ltn__tagcloud-widget ul li a:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

/* ----------------------------------------------------
    Color Widget
---------------------------------------------------- */
.ltn__color-widget ul {
  padding: 0;
  margin: 0;
}
.ltn__color-widget ul li {
  list-style: none;
  display: inline-block;
  margin-top: 3px;
  margin-right: 5px;
  background-color: var(--section-bg-1);
  border: 1px solid var(--border-color-1);
}
.ltn__color-widget ul li a {
  width: 40px;
  height: 22px;
  display: block;
}
.ltn__color-widget ul li:hover {
  outline: 2px solid var(--ltn__secondary-color);
  outline-offset: 1px;
}
.ltn__color-widget ul .black {
  background-color: var(--black);
}
.ltn__color-widget ul .white {
  background-color: var(--white);
}
.ltn__color-widget ul .red {
  background-color: var(--red);
}
.ltn__color-widget ul .silver {
  background-color: var(--silver);
}
.ltn__color-widget ul .gray {
  background-color: var(--gray);
}
.ltn__color-widget ul .maroon {
  background-color: var(--maroon);
}
.ltn__color-widget ul .yellow {
  background-color: var(--yellow);
}
.ltn__color-widget ul .olive {
  background-color: var(--olive);
}
.ltn__color-widget ul .lime {
  background-color: var(--lime);
}
.ltn__color-widget ul .green {
  background-color: var(--green);
}
.ltn__color-widget ul .aqua {
  background-color: var(--aqua);
}
.ltn__color-widget ul .teal {
  background-color: var(--teal);
}
.ltn__color-widget ul .blue {
  background-color: var(--blue);
}
.ltn__color-widget ul .navy {
  background-color: var(--navy);
}
.ltn__color-widget ul .fuchsia {
  background-color: var(--fuchsia);
}
.ltn__color-widget ul .purple {
  background-color: var(--purple);
}
.ltn__color-widget ul .pink {
  background-color: var(--pink);
}
.ltn__color-widget ul .nude {
  background-color: var(--nude);
}
.ltn__color-widget ul .orange {
  background-color: var(--orange);
}

/* ----------------------------------------------------
    Menu Widget
---------------------------------------------------- */
.ltn__menu-widget > ul {
  padding: 0;
  margin: 0;
}
.ltn__menu-widget > ul li {
  list-style: none;
  margin-top: 15px;
  display: block;
  font-size: 14px;
  font-weight: 700;
}
.ltn__menu-widget > ul li a {
  display: block;
  font-size: 14px;
  font-weight: 700;
}
.ltn__menu-widget > ul li a span {
  float: right;
  color: var(--ltn__color-5);
}
.ltn__menu-widget > ul li span {
  float: right;
  color: var(--ltn__color-5);
}

.care_bullets li {
  list-style: none;
  position: relative;
  padding: 2px 0 2px 25px;
  color: #fff !important;
}

.care_bullets li::before {
  content: "*";
  position: absolute;
  top: 6px;
  left: 0;
}

.care_bullets-2 li {
  list-style: none;
  position: relative;
  padding: 2px 0 2px 25px;
}

.care_bullets-2 li::before {
  content: "*";
  position: absolute;
  top: 6px;
  left: 0;
}

.job_bullets li {
  list-style: none;
  position: relative;
  padding: 2px 0 2px 25px;
}

.job_bullets li::before {
  content: "";
  top: 6px;
  left: 0;
}

.job-box {
  background-color: #e2e2e2;
  /*box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);*/
  border-radius: 15px;
}

/* menu-widget-2 */
.ltn__menu-widget-2 {
  background-color: transparent;
}
.ltn__menu-widget-2 ul li a {
  background-color: var(--section-bg-1);
  padding: 20px 10px 20px 30px;
}
.ltn__menu-widget-2 ul li a span {
  background-color: var(--white);
  color: var(--ltn__primary-color);
  position: relative;
  top: -11px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  transition: all 0.3s ease 0s;
}
.ltn__menu-widget-2 ul li.active a, .ltn__menu-widget-2 ul li:hover > a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__menu-widget-2 ul li.active a span, .ltn__menu-widget-2 ul li:hover > a span {
  background-color: var(--ltn__secondary-color-2);
  color: var(--white);
}
.ltn__menu-widget-2 ul li.active a span:hover, .ltn__menu-widget-2 ul li:hover > a span:hover {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}
.ltn__menu-widget-2 > ul > li:first-child {
  margin-top: 0;
}
.ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li a {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}
.ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li a span {
  background-color: var(--ltn__primary-color-2);
  color: var(--white);
}
.ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li.active a, .ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li:hover > a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li.active a span, .ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li:hover > a span {
  background-color: var(--ltn__secondary-color-2);
  color: var(--white);
}
.ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li.active a span:hover, .ltn__menu-widget-2.ltn__menu-widget-2-color-2 ul li:hover > a span:hover {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}

/* ----------------------------------------------------
    Popular Post Widget
---------------------------------------------------- */
.ltn__popular-post-widget ul {
  padding: 0;
  margin: 0;
}
.ltn__popular-post-widget ul li {
  list-style: none;
}

.ltn__popular-post-widget > ul > li {
  margin-bottom: 30px;
  border-bottom: 1px solid var(--border-color-1);
  padding-bottom: 30px;
}

.ltn__popular-post-widget > ul > li:last-child {
  margin-bottom: 0;
  border-bottom: 0;
  padding-bottom: 0px;
}

.popular-post-widget-img {
  float: left;
  margin-right: 20px;
}
.popular-post-widget-img img {
  max-width: 80px;
}

.popular-post-widget-brief {
  overflow: hidden;
}
.popular-post-widget-brief h6 {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
}
.popular-post-widget-brief .ltn__blog-meta {
  margin-bottom: 0;
}
.popular-post-widget-brief .ltn__blog-meta li {
  color: var(--ltn__secondary-color);
}

.ltn__twitter-post-widget .popular-post-widget-img {
  float: left;
  margin-right: 20px;
}
.ltn__twitter-post-widget .popular-post-widget-img img {
  max-width: 60px;
  border-radius: 100%;
}
.ltn__twitter-post-widget .popular-post-widget-img a {
  color: var(--ltn__secondary-color);
}
.ltn__twitter-post-widget .popular-post-widget-brief p {
  margin-bottom: 5px;
}
.ltn__twitter-post-widget .popular-post-widget-brief p a {
  color: var(--ltn__secondary-color);
}

/* ----------------------------------------------------
    Banner Widget
---------------------------------------------------- */
.ltn__banner-widget {
  padding: 0 !important;
  border: 0;
}

/* ----------------------------------------------------
    Top Rated Product Widget
---------------------------------------------------- */
.ltn__top-rated-product-widget ul {
  padding: 0;
  margin: 0;
}
.ltn__top-rated-product-widget ul li {
  list-style: none;
}

.ltn__top-rated-product-widget > ul > li {
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid;
  border-color: var(--white-4);
}

.ltn__top-rated-product-widget > ul > li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: 0;
}

.top-rated-product-img {
  max-width: 90px;
  float: left;
  margin-right: 20px;
}

.top-rated-product-info {
  overflow: hidden;
}
.top-rated-product-info h6 {
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: 500;
}
.top-rated-product-info .product-ratting {
  margin-bottom: 0;
}
.top-rated-product-info .product-ratting li {
  font-size: 10px;
}
.top-rated-product-info .product-price {
  margin-bottom: 0;
  font-size: 14px;
  color: var(--ltn__secondary-color);
  font-weight: 700;
}
.top-rated-product-info .product-ratting ul {
  line-height: 1;
  margin-bottom: 5px;
}

/* ----------------------------------------------------
    Popular Product Widget
---------------------------------------------------- */
.ltn__popular-product-widget .ltn__product-item {
  margin-bottom: 30px;
}
.ltn__popular-product-widget .ltn__product-item .product-info {
  padding: 25px 25px 1px;
}
.ltn__popular-product-widget .ltn__product-item .product-title {
  font-size: 16px;
}
.ltn__popular-product-widget .ltn__product-item .product-img-location ul li,
.ltn__popular-product-widget .ltn__product-item .ltn__plot-brief li {
  font-size: 12px;
}
.ltn__popular-product-widget .slick-dots {
  margin-bottom: 0;
}

/* ----------------------------------------------------
    Price Filter Widget
---------------------------------------------------- */
.price_filter {
  padding-bottom: 13px;
}

.price_slider_amount {
  overflow: hidden;
}

.price_slider_amount > input[type=text],
.price_slider_amount > input[type=submit] {
  background: transparent none repeat scroll 0 0;
  border: medium none;
  box-shadow: none;
  float: left;
  height: 25px;
  padding: 0;
  text-align: left;
  width: 140px;
  margin-bottom: 20px;
}

.price_slider_amount > input[type=text] {
  font-weight: 700;
}

.price_filter .ui-widget-content {
  background-color: var(--ltn__primary-color);
  border: medium none;
  color: #222;
  height: 3px;
  width: 98%;
  background-image: none;
}

.price_filter .ui-slider .ui-slider-range {
  background-color: var(--ltn__secondary-color);
  background-image: none;
}

.price_filter .ui-state-default,
.price_filter .ui-widget-content .ui-state-default,
.price_filter .ui-widget-header .ui-state-default {
  background-color: var(--ltn__secondary-color);
  border: medium none;
  border-radius: 100%;
  height: 12px;
  margin-left: 0;
  margin-top: -6px;
  top: 50%;
  width: 12px;
  background-image: none;
}

/* ----------------------------------------------------
    Instagram Widget
---------------------------------------------------- */
.ltn__instafeed-grid {
  display: flex;
}
.ltn__instafeed-grid .instagram_gallery {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.ltn__instafeed-grid .instagram_gallery a,
.ltn__instafeed-grid .instagram_gallery .instagram-image {
  display: block;
  flex: 1 0 16.6666%;
  max-width: 16.6666%;
}

.ltn__instagram-widget .ltn__instafeed-grid .instagram_gallery a,
.ltn__instagram-widget .ltn__instafeed-grid .instagram_gallery .instagram-image {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.ltn__instafeed-slider .slick-list .slick-slide {
  display: flex;
}

.insta-slide-gutter .slick-list {
  margin-right: -7.5px !important;
  margin-left: -7.5px !important;
}
.insta-slide-gutter .slick-list .slick-slide {
  padding-right: 7.5px;
  padding-left: 7.5px;
}

.insta-grid-gutter .instagram_gallery {
  margin-right: -7.5px !important;
  margin-left: -7.5px !important;
}
.insta-grid-gutter .instagram_gallery a,
.insta-grid-gutter .instagram_gallery .instagram-image {
  padding-right: 7.5px;
  padding-left: 7.5px;
  margin: 7px 0;
}

/* ----------------------------------------------------
    Video Widget
---------------------------------------------------- */
.ltn__video-icon-1 {
  background-color: transparent;
  color: var(--white);
  height: 80px;
  width: 80px;
  border: 6px solid;
  border-color: var(--white);
  border-radius: 100%;
  font-size: 22px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ltn__video-icon-1:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.ltn__video-icon-2 {
  height: 80px;
  width: 80px;
  background-color: var(--white);
  color: var(--ltn__secondary-color);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  border-radius: 100%;
}
.ltn__video-icon-2 i {
  color: var(--ltn__secondary-color);
}
.ltn__video-icon-2:hover.ltn__video-icon-2-border {
  outline: outset;
}
.ltn__video-icon-2.border-radius-no {
  border-radius: 0;
}

.ltn__video-icon-2-border {
  outline-offset: 15px;
  outline: 4px solid var(--border-color-9);
  margin: 20px;
}

.ltn__video-bg-img {
  min-height: 350px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  z-index: 99;
}

.ltn__video-img {
  position: relative;
  display: inline-block;
}
.ltn__video-img::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  background-color: var(--ltn__primary-color);
}
.ltn__video-img img {
  margin: 0;
}
.ltn__video-img .ltn__video-icon-1,
.ltn__video-img .ltn__video-icon-2 {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
}

.ltn__video-info {
  position: relative;
}

.ltn__video-popup-height-300 {
  height: 300px;
}

.ltn__video-popup-height-400 {
  height: 400px;
}

.ltn__video-popup-height-500 {
  height: 500px;
}

.ltn__video-popup-height-600 {
  height: 600px;
}

.text-center .slide-video {
  display: flex;
  justify-content: center;
}

.ltn__secondary-bg.ltn__video-icon-2 {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__secondary-bg.ltn__video-icon-2 i {
  color: var(--white);
}

.ltn__video-icon-2-small {
  height: 60px;
  width: 60px;
  font-size: 16px;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ltn__video-popup-height-500,
  .ltn__video-popup-height-600 {
    height: 450px;
  }
}
@media (max-width: 991px) {
  .ltn__video-icon-2 {
    height: 50px;
    width: 50px;
    font-size: 18px;
  }
  .ltn__video-popup-height-500,
  .ltn__video-popup-height-600 {
    height: initial;
  }
}
@media (max-width: 767px) {
  .ltn__video-bg-img {
    min-height: 320px;
  }
  .ltn__video-bg-img.ml-30 {
    margin-left: 0;
  }
  .ltn__video-img.ml-30,
  .ltn__video-bg-img.ml-30 {
    margin-left: 0;
  }
}
/* ----------------------------------------------------
    Author Widget
---------------------------------------------------- */
.ltn__author-widget-inner img {
  margin-bottom: 25px;
  max-width: 140px;
  border-radius: 100%;
}
.ltn__author-widget-inner p {
  font-size: 14px;
}
.ltn__author-widget-inner .ltn__social-media ul li {
  color: var(--ltn__color-1);
}

.ltn__author-widget-2 .ltn__author-widget-inner img {
  margin-bottom: 25px;
  max-width: 100%;
  border-radius: inherit;
}

/* ----------------------------------------------------
    Footer About Widget
---------------------------------------------------- */
@media (min-width: 992px) {
  .footer-about-widget {
    padding-right: 35px;
  }
}
/* ----------------------------------------------------
    Widget Responsive
---------------------------------------------------- */
@media (max-width: 1199px) {
  .widget {
    padding: 35px 20px 40px 20px;
  }
  .top-rated-product-img {
    max-width: 70px;
    margin-right: 15px;
  }
}
@media (max-width: 991px) {
  .ltn__right-sidebar {
    margin-top: 100px;
  }
}
@media (max-width: 767px) {
  .car-price-filter-range .price_filter .ui-state-default:last-child::after {
    display: none;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ============================================================
>>> TABLE OF CONTENTS:
===============================================================
# Header
# Header Top Area
# Header Middle Area
# Header Bottom Area
# Header Feature Area
# Main Menu
# Header Options
# Mini Cart
# Header Searchbox
# Currency Menu
# Header Sticky
# Utilize Mobile Menu

============================================================= */
/* --------------------------------------------------------------
    Header
-------------------------------------------------------------- */
.ltn__header-area {
  z-index: 9999;
  position: relative;
}

/* ----------------------------------------------
    Header Top Area
---------------------------------------------- */
.ltn__header-top-area {
  border-bottom: 1px solid;
  border-color: var(--border-color-3);
}
.ltn__header-top-area .ltn__social-media ul li {
  font-size: 14px;
  margin: 0 10px 0 0;
}

.top-area-color-dark-blue {
  background-color: #21485e;
}
.top-area-color-dark-blue p,
.top-area-color-dark-blue a,
.top-area-color-dark-blue li,
.top-area-color-dark-blue .welcome p,
.top-area-color-dark-blue .welcome a,
.top-area-color-dark-blue .ltn__drop-menu > ul > li > a,
.top-area-color-dark-blue .ltn__drop-menu > ul > li:hover > a {
  color: var(--white);
}

.top-area-color-white {
  background-color: var(--ltn__primary-color);
}
.top-area-color-white p,
.top-area-color-white a,
.top-area-color-white li,
.top-area-color-white .welcome p,
.top-area-color-white .welcome a,
.top-area-color-white .ltn__drop-menu > ul > li > a,
.top-area-color-white .ltn__drop-menu > ul > li:hover > a {
  color: var(--white);
}

.ltn__header-top-area .row {
  align-items: center;
}

/* welcome */
.welcome p {
  margin-bottom: 0;
  font-size: 14px;
  line-height: 40px;
}

.ltn__top-bar-menu > ul {
  padding: 0;
  margin: 0;
}
.ltn__top-bar-menu > ul > li {
  list-style: none;
  display: inline-block;
  margin: 0 30px 0 0;
  font-size: 14px;
  font-weight: 700;
}
.ltn__top-bar-menu > ul > li:last-child {
  margin-right: 0;
}
.ltn__top-bar-menu > ul > li > i, .ltn__top-bar-menu > ul > li > a > i {
  margin-right: 3px;
  color: var(--ltn__secondary-color);
}
.ltn__top-bar-menu .ltn__currency-menu .active-currency {
  font-size: 14px;
  font-weight: 700;
}

.header-top-btn {
  display: inline-block;
}
.header-top-btn a {
  display: inline-block;
  padding: 0 20px;
  line-height: 40px;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.header-top-btn a:hover {
  background-color: var(--ltn__secondary-color-2);
}

/* ----------------------------------------------
    Header Middle Area
---------------------------------------------- */
.ltn__header-middle-area {
  z-index: 999;
}

.ltn__header-middle-area > .container-fluid > .row,
.ltn__header-middle-area > .container > .row {
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.ltn__header-middle-area > .container-fluid > .row > .col,
.ltn__header-middle-area > .container > .row > .col {
  flex-grow: 1;
  position: static;
}

.site-logo {
  min-width: 185px;
  height: 100%;
  display: flex;
  align-items: start;
}
.site-logo a {
  color: var(--ltn__primary-color);
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 1px;
  display: contents;
}
.site-logo i {
  color: var(--ltn__secondary-color);
  margin-right: 5px;
  font-size: 24px;
  position: relative;
  top: -2px;
}

.ltn__header-1 .ltn__header-middle-area {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* ----------------------------------------------
    Header Bottom Area (header-2)
---------------------------------------------- */
.header-bottom-area .row {
  position: relative;
}
.header-bottom-area .row .col {
  display: flex;
  align-items: center;
}

.sticky-logo {
  max-width: 200px;
  align-self: center;
  height: 100%;
  float: left;
  transition: all 0.3s ease 0s;
  display: none;
}

.header-menu-2 {
  text-align: center;
}
.header-menu-2 .ltn__main-menu > ul {
  display: inline-block;
}

/* ----------------------------------------------
    Header Feature Area
---------------------------------------------- */
.header-feature-area {
  display: flex;
}

.header-feature-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 50px;
  max-width: 50%;
}
.header-feature-item:last-child {
  margin-right: 0;
}
.header-feature-item h6 {
  margin-bottom: 0;
  color: var(--ltn__body-color);
  font-weight: 500;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1;
}
.header-feature-item p {
  margin-bottom: 0;
  font-size: 16px;
  font-family: var(--ltn__heading-font);
  line-height: 1.2;
}

.header-feature-icon {
  margin-right: 10px;
  font-size: 25px;
  line-height: 1;
  color: var(--ltn__heading-color);
}

/* ----------------------------------------------
    Main Menu
---------------------------------------------- */
.header-menu-wrap,
.header-menu-column {
  position: inherit;
}

.ltn__main-menu ul {
  margin-bottom: 0;
}

.ltn__main-menu > ul {
  display: flex;
  padding: 0;
}

.ltn__main-menu li {
  list-style: none;
  display: block;
  margin-top: 0;
}

.ltn__main-menu li > a {
  position: relative;
}

.ltn__main-menu > ul > li {
  display: inline-block;
  position: relative;
  margin-right: 20px;
}

.ltn__main-menu > ul > li:last-child {
  margin-right: 0px;
}

.ltn__main-menu > ul > li > a {
  font-size: 16px;
  padding: 20px 10px;
  display: inline-block;
  white-space: nowrap;
  color: var(--ltn__heading-color);
  font-weight: 600;
  font-family: var(--ltn__body-font);
}

.ltn__main-menu li:hover > a {
  color: var(--ltn__secondary-color);
}

/* Submenu */
.ltn__main-menu li > ul,
.ltn__main-menu .sub-menu {
  position: absolute;
  margin: 0;
  top: 130%;
  transition: opacity 0.2s ease 0.1s, visibility 0.2s ease 0.1s, top 0.2s ease 0.1s;
  min-width: 230px;
  padding: 15px 0;
  box-shadow: var(--ltn__box-shadow-4);
  background-color: #fff;
  left: inherit;
  right: inherit;
  opacity: 0;
  visibility: hidden;
  text-align: left;
  z-index: 999;
  border-top: 5px solid var(--ltn__secondary-color);
}

.ltn__main-menu li ul li,
.ltn__main-menu .sub-menu li {
  line-height: 1.3;
  padding: 12px 25px 12px 30px;
  font-size: 16px;
}

.mega-menu li ul {
  border-top: 0;
}

.mega-menu li ul li {
  padding-left: 10px;
  padding-right: 0;
}

.ltn__main-menu li:hover > ul,
.ltn__main-menu li:hover > .sub-menu {
  top: 100%;
  opacity: 1;
  visibility: visible;
}

.ltn__main-menu li ul li > ul,
.ltn__main-menu .sub-menu li > .sub-menu {
  left: 100%;
}

.ltn__main-menu li ul li:hover > ul,
.ltn__main-menu .sub-menu li:hover > .sub-menu {
  top: 0;
}

.ltn__main-menu li ul li,
.ltn__main-menu .sub-menu li {
  position: relative;
}

.ltn__main-menu > ul > li:last-child ul li > ul,
.ltn__main-menu > ul > li:last-child .sub-menu li > .sub-menu,
.ltn__main-menu > ul > li:nth-last-child(2) ul li > ul,
.ltn__main-menu > ul > li:nth-last-child(2) .sub-menu li > .sub-menu,
.ltn__main-menu > ul > li:nth-last-child(3) ul li > ul,
.ltn__main-menu > ul > li:nth-last-child(3) .sub-menu li > .sub-menu {
  left: auto;
  right: 100%;
}

.ltn__main-menu li > ul.ltn__sub-menu-col-2,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2,
.ltn__main-menu li > ul.ltn__sub-menu-col-3,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 {
  width: 510px;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 > li,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 > li,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 > li,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 > li {
  width: 50%;
  float: left;
  padding: 12px 20px 12px 25px;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 > li > a,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 > li > a,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 > li > a,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 > li > a {
  padding: 12px 20px 12px 20px;
  margin-left: 0;
  border-bottom: 1px dashed #ddd;
  display: block;
  font-weight: 600;
  background-color: var(--section-bg-1);
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 .sub-menu-child,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 .sub-menu-child,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 .sub-menu-child,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 .sub-menu-child {
  position: inherit;
  float: left;
  width: 100%;
  left: inherit;
  box-shadow: none;
  border: none;
  z-index: inherit;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 .sub-menu-child li,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 .sub-menu-child li,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 .sub-menu-child li,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 .sub-menu-child li {
  padding: 12px 20px 12px 20px;
  transition: all 0.3s ease 0s;
  position: relative;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 .sub-menu-child li img,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 .sub-menu-child li img,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 .sub-menu-child li img,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 .sub-menu-child li img {
  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 150px;
  height: auto;
  opacity: 0;
  visibility: hidden;
  box-shadow: var(--ltn__box-shadow-3);
  z-index: 999;
  transition: all 0.3s ease 0s;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-2 .sub-menu-child li:hover img,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-2 .sub-menu-child li:hover img,
.ltn__main-menu li > ul.ltn__sub-menu-col-3 .sub-menu-child li:hover img,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 .sub-menu-child li:hover img {
  bottom: -10px;
  visibility: visible;
  opacity: 1;
}

.ltn__main-menu li > ul.ltn__sub-menu-col-3,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 {
  width: 780px;
}
.ltn__main-menu li > ul.ltn__sub-menu-col-3 > li,
.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 > li {
  width: 33.33%;
}

.ltn__main-menu li:hover > ul.ltn__sub-menu-col-2 .sub-menu-child,
.ltn__main-menu li:hover > .sub-menu.ltn__sub-menu-col-2 .sub-menu-child {
  opacity: 1;
  visibility: visible;
}

.menu-pages-img-show li {
  transition: all 0.3s ease 0s;
  position: relative;
}
.menu-pages-img-show li img {
  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 130px;
  height: auto;
  opacity: 0;
  visibility: hidden;
  box-shadow: var(--ltn__box-shadow-3);
  z-index: 999;
  transition: all 0.3s ease 0s;
}
.menu-pages-img-show li:hover img {
  bottom: -10px;
  visibility: visible;
  opacity: 1;
}

/* Menu Reverse */
.ltn__main-menu > ul > li:last-child,
.ltn__main-menu > ul > li:nth-last-child(2) {
  position: relative;
}

.ltn__main-menu > ul > li:last-child > ul,
.ltn__main-menu > ul > li:last-child > .sub-menu,
.ltn__main-menu > ul > li:nth-last-child(2) > ul,
.ltn__main-menu > ul > li:nth-last-child(2) > .sub-menu {
  left: auto;
  right: 0;
}

/* Mega Menu */
.ltn__main-menu .mega-menu {
  left: 0;
  right: auto;
  overflow: hidden;
  width: 100%;
}

.mega-menu > li {
  float: left;
  padding-bottom: 0 !important;
  min-width: 250px !important;
}

.mega-menu > li {
  min-width: 220px;
}

.ltn__main-menu li ul.mega-menu {
  max-height: 400px;
  overflow-y: auto;
}

.ltn__main-menu li:hover ul.mega-menu {
  opacity: 1;
  visibility: visible;
  transform: scaley(1);
}

.mega-menu li ul,
.mega-menu li .sub-menu {
  left: 0% !important;
  box-shadow: none;
  position: inherit;
}

/* .ltn__main-menu li:hover .mega-menu li ul */
.ltn__main-menu li .mega-menu > li > ul,
.ltn__main-menu li .mega-menu .sub-menu {
  top: 0;
}

.ltn__main-menu li:hover .mega-menu > li > ul,
.ltn__main-menu li:hover .mega-menu .sub-menu {
  opacity: 1;
  visibility: visible;
}

.mega-menu > li > a {
  margin-left: 0;
  border-bottom: 1px dashed #ddd;
  display: block;
  font-weight: 600;
  padding: 10px;
  background-color: var(--section-bg-1);
}

.mega-menu.column-1,
.mega-menu.column-2 {
  left: auto;
}

.mega-menu.column-2 > li {
  min-width: 50%;
  width: 50%;
}

.mega-menu.column-3 > li {
  min-width: 33.33%;
  width: 33.33%;
}

@media (min-width: 991px) {
  .mega-menu.column-4 > li,
  .mega-menu.column-5 > li,
  .mega-menu.column-6 > li,
  .mega-menu.column-7 > li,
  .mega-menu.column-8 > li,
  .mega-menu.column-9 > li,
  .mega-menu.column-10 > li,
  .mega-menu.column-11 > li,
  .mega-menu.column-12 > li {
    min-width: 25%;
    width: 25%;
  }
}
@media (max-width: 991px) {
  .mega-menu.column-2 > li,
  .mega-menu.column-3 > li,
  .mega-menu.column-4 > li,
  .mega-menu.column-5 > li,
  .mega-menu.column-6 > li,
  .mega-menu.column-7 > li,
  .mega-menu.column-8 > li,
  .mega-menu.column-9 > li,
  .mega-menu.column-10 > li,
  .mega-menu.column-11 > li,
  .mega-menu.column-12 > li {
    min-width: 50%;
    width: 50%;
  }
}
@media (max-width: 767px) {
  .mega-menu.column-2 > li,
  .mega-menu.column-3 > li,
  .mega-menu.column-4 > li,
  .mega-menu.column-5 > li,
  .mega-menu.column-6 > li,
  .mega-menu.column-7 > li,
  .mega-menu.column-8 > li,
  .mega-menu.column-9 > li,
  .mega-menu.column-10 > li,
  .mega-menu.column-11 > li,
  .mega-menu.column-12 > li {
    min-width: 100%;
    width: 100%;
  }
}
/* Mega menu submenu submenu */
.mega-menu li ul li ul {
  left: 100% !important;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  box-shadow: var(--ltn__box-shadow-4);
}

.mega-menu li ul li:hover > ul {
  opacity: 1;
  visibility: visible;
}

@media (min-width: 991px) {
  .mega-menu-parent {
    position: inherit !important;
  }
}
/* Menu Icon */
.menu-icon > a {
  position: relative;
}
.menu-icon > a::before {
  content: "\\f067";
  font-size: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

/* Menu Item Badge */
.menu-item-badge {
  position: absolute;
  left: -8px;
  top: -10px;
  font-size: 10px;
  padding: 1px 3px 0px;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  border-radius: 2px;
  text-transform: uppercase;
}

/* Menu Porduct Item */
.menu-product-item {
  margin-bottom: 30px;
  margin-top: 15px;
  border: 2px solid;
  border-color: var(--border-color-8);
  transition: all 0.3s ease 0s;
  text-align: center;
}
.menu-product-item .product-info {
  padding: 25px 15px 15px;
  padding-top: 0;
}
.menu-product-item .product-title {
  font-size: 16px;
  margin-bottom: 5px;
}
.menu-product-item .product-price {
  font-size: 16px;
  color: var(--ltn__secondary-color);
  font-weight: 600;
}
.menu-product-item .product-price del {
  font-size: 15px;
  opacity: 0.5;
  color: var(--gray);
}

.menu-product-item:hover {
  box-shadow: var(--ltn__box-shadow-1);
}

/* ----------------------------------------------
    Header Options
---------------------------------------------- */
.ltn__header-options > ul {
  padding: 0;
  margin: 0;
}
.ltn__header-options > ul > li {
  display: inline-block;
  margin-right: 15px;
  margin-top: 0;
  list-style: none;
}
.ltn__header-options > ul > li:last-child {
  margin-right: 0;
}

.ltn__header-options {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.ltn__header-options ul li {
  list-style: none;
}
.ltn__header-options > div {
  margin-right: 20px;
}
.ltn__header-options > div:last-child {
  margin-right: 0;
}
.ltn__header-options .ltn__drop-menu > ul > li > a {
  padding: 0;
}
.ltn__header-options .ltn__drop-menu ul {
  padding: 0;
}
.ltn__header-options .ltn__drop-menu ul li ul {
  padding: 10px 0;
}

.ltn__header-options-2 > div {
  margin-right: 10px;
}
.ltn__header-options-2 .header-search-1,
.ltn__header-options-2 .ltn__drop-menu > ul > li > a,
.ltn__header-options-2 .mini-cart-icon a,
.ltn__header-options-2 .header-wishlist {
  height: 50px;
  width: 50px;
  line-height: 50px;
  background: var(--white);
  color: var(--ltn__heading-color);
  text-align: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s ease 0s;
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__header-options-2 .header-search-1:hover,
.ltn__header-options-2 .ltn__drop-menu > ul > li > a:hover,
.ltn__header-options-2 .mini-cart-icon a:hover,
.ltn__header-options-2 .header-wishlist:hover {
  background: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__header-options-2 .header-search-1:hover,
.ltn__header-options-2 .ltn__drop-menu > ul > li:hover > a,
.ltn__header-options-2 .mini-cart-icon a:hover {
  background: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__header-options-2 .ltn__drop-menu.ltn__currency-menu > ul > li > a {
  height: inherit;
  width: inherit;
  line-height: inherit;
  background: inherit;
  color: inherit;
}
.ltn__header-options-2 .mobile-menu-toggle > a {
  width: 50px;
  height: 50px;
  background: var(--white);
  box-shadow: var(--ltn__box-shadow-1);
}

/* ltn__drop-menu */
.ltn__drop-menu {
  display: inline-block;
  text-align: left;
}

.ltn__drop-menu li {
  margin-top: 0;
}

.ltn__drop-menu + .ltn__drop-menu {
  margin-left: 10px;
}

.ltn__drop-menu ul {
  margin-bottom: 0;
  padding: 0;
}

.ltn__drop-menu > ul > li {
  display: inline-block;
  position: relative;
  color: var(--ltn__heading-color);
}

.ltn__drop-menu > ul > li > a {
  display: block;
  text-decoration: none;
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
}

.ltn__drop-menu ul li ul {
  position: absolute;
  min-width: 150px;
  right: 0;
  background-color: #fff;
  z-index: 999;
  box-shadow: var(--ltn__box-shadow-4);
  border-top: 1px solid #ececec;
  top: 130%;
  padding: 10px 0;
  margin: 0;
  transition: opacity 0.2s ease 0.1s, visibility 0.2s ease 0.1s, top 0.2s ease 0.1s;
  opacity: 0;
  visibility: hidden;
}

.ltn__drop-menu ul li ul li {
  display: block;
  padding: 5px 15px;
  font-size: 16px;
  color: var(--ltn__paragraph-color);
  font-weight: 500;
}

.ltn__drop-menu ul li ul li a {
  color: inherit;
}

.ltn__drop-menu ul li:hover > ul {
  top: 100%;
  opacity: 1;
  visibility: visible;
}
.ltn__drop-menu ul li:hover > a {
  color: var(--ltn__secondary-color);
}

.ltn__drop-menu > ul > li,
.header-wishlist a {
  font-size: 20px;
}

/* header-wishlist */
.header-wishlist {
  color: var(--ltn__heading-color);
}

/* ----------------------------------------------
    Mini Cart
---------------------------------------------- */
.ltn__mini-cart ul {
  margin: 0;
  padding: 0;
}

.mini-cart-icon {
  display: flex;
  align-items: center;
  line-height: 30px;
  cursor: pointer;
  color: var(--ltn__heading-color);
}
.mini-cart-icon i {
  font-size: 18px;
}
.mini-cart-icon sup {
  font-size: 14px;
  font-weight: 600;
}

.mini-cart-header h5 {
  margin-bottom: 0;
}

.mini-cart-product-area {
  max-height: calc(100% - 305px);
}

.ltn__utilize-cart-menu .ltn__mini-cart {
  max-height: calc(100% - 305px);
}

.mini-cart-item {
  padding-top: 20px;
  padding-left: 10px;
  margin-bottom: 20px;
  border-top: 1px solid var(--border-color-1);
}
.mini-cart-item:first-child {
  border-top: 0;
}

.mini-cart-img {
  float: left;
  width: 80px;
  margin-right: 15px;
  position: relative;
}

.mini-cart-img img {
  background-color: var(--section-bg-1);
}

.mini-cart-info {
  overflow: hidden;
}

.mini-cart-info h6 {
  margin-bottom: 5px;
  font-weight: 500;
}

.mini-cart-item-delete {
  position: absolute;
  left: -8px;
  top: -8px;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  display: block;
  line-height: 20px;
  background-color: #fff;
  text-align: center;
  font-size: 10px;
  box-shadow: var(--ltn__box-shadow-3);
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.mini-cart-item-delete:hover {
  background-color: var(--red);
  color: #fff;
}

.mini-cart-footer {
  margin-top: 25px;
}
.mini-cart-footer p {
  font-size: 14px;
  margin-bottom: 0;
}

.mini-cart-sub-total {
  border-top: 1px solid var(--border-color-1);
  border-bottom: 1px solid var(--border-color-1);
  padding: 20px 0;
}
.mini-cart-sub-total h5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.mini-cart-sub-total span {
  color: var(--ltn__secondary-color);
}

.mini-cart-footer .btn-wrapper {
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  padding: 25px 0 15px;
}

.mini-cart-footer .btn-wrapper .btn {
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: 14px;
}

.mini-cart-icon-2 > a {
  display: flex;
  align-items: center;
  min-width: 125px;
}
.mini-cart-icon-2 > a .mini-cart-icon {
  margin-right: 5px;
}
.mini-cart-icon-2 > a .mini-cart-icon i {
  color: var(--ltn__heading-color);
  font-size: 20px;
}
.mini-cart-icon-2 > a .mini-cart-icon sup {
  font-size: 12px;
  font-weight: 600;
  height: 20px;
  width: 20px;
  line-height: 20px;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  text-align: center;
  border-radius: 100%;
  right: 8px;
  top: -8px;
}
.mini-cart-icon-2 > a h6 {
  margin-bottom: 0;
  display: flex;
  flex-flow: column;
  line-height: 20px;
  font-weight: 700;
  color: var(--ltn__body-color);
  font-size: 14px;
  text-transform: uppercase;
}
.mini-cart-icon-2 ul li {
  list-style: none;
}

/* ----------------------------------------
  Header Searchbox
---------------------------------------- */
.header-search-1 {
  cursor: pointer;
  display: inline-block;
}
.header-search-1 .search-icon {
  min-width: 25px;
  text-align: center;
  font-size: 16px;
}

.header-search-wrap {
  position: relative;
}

.header-search-1-form {
  background-color: var(--white);
  box-shadow: var(--ltn__box-shadow-3);
  height: 0;
  margin-right: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 130%;
  transition-duration: 0.4s;
  transition-property: height;
  width: 320px;
  z-index: 9999;
}
.header-search-1-form form {
  position: relative;
  margin: 15px 15px 0;
}
.header-search-1-form input {
  height: 60px;
  padding-right: 50px;
}
.header-search-1-form button[type=submit] {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: var(--ltn__heading-color);
  display: block;
  font-size: 18px;
  height: 60px;
  line-height: 48px;
  position: absolute;
  right: 8px;
  text-align: center;
  top: 0;
  padding: 1px 6px;
  transition: all 0.3s ease 0s;
}
.header-search-1-form button[type=submit]:hover {
  color: var(--ltn__primary-color);
}

.search-icon {
  position: relative;
}
.search-icon .for-search-close {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
}

.search-open.header-search-1-form {
  height: 90px;
}
.search-open .for-search-show {
  opacity: 0;
  visibility: hidden;
}
.search-open .for-search-close {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 767px) {
  .header-search-wrap {
    position: inherit;
  }
  .header-search-1-form {
    top: 100%;
  }
  .header-search-1-form {
    transform: translateX(50%);
    right: 50%;
  }
}
@media (max-width: 575px) {
  .header-search-1-form {
    width: 270px;
  }
}
/* search-2 */
.header-search-2 {
  min-width: 500px;
}
.header-search-2 form {
  position: relative;
}
.header-search-2 input {
  margin-bottom: 0;
  border: 0;
  box-shadow: var(--ltn__box-shadow-3);
  border-radius: 50px;
  padding-left: 20px;
  padding-right: 50px;
  height: 45px;
}
.header-search-2 button {
  position: absolute;
  right: 0;
  background-color: transparent;
  height: 45px;
  top: 0;
  padding: 0 15px;
}

/* ----------------------------------------
    Currency Menu
---------------------------------------- */
.ltn__currency-menu .active-currency {
  font-size: 16px;
  font-weight: 700;
}
.ltn__currency-menu ul li ul {
  min-width: 200px;
}
.ltn__currency-menu .dropdown-toggle::after {
  margin-left: 3px;
  border-top: 0.25em solid;
  border-right: 0.2em solid transparent;
  border-left: 0.2em solid transparent;
}

.ltn__language-menu .dropdown-toggle {
  padding-right: 10px !important;
  position: relative;
}
.ltn__language-menu .dropdown-toggle::after {
  display: none;
}
.ltn__language-menu .dropdown-toggle::before {
  content: "\\e911";
  font-size: 14px;
  position: absolute;
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  font-family: "icomoon";
  color: var(--ltn__secondary-color);
}

/* ----------------------------------------
  Header 2
---------------------------------------- */
.ltn__header-2 .sticky-active .row .col {
  justify-content: space-between !important;
}
.ltn__header-2 .sticky-active .sticky-logo {
  display: block;
}
.ltn__header-2 .sticky-active .header-menu-2 {
  text-align: right;
}

/* ----------------------------------------
  Header 3
---------------------------------------- */
.ltn__header-3 .ltn__header-middle-area {
  padding: 30px 0;
}

.ltn__header-3 .header-bottom-area.sticky-active {
  padding-top: 0px;
  padding-bottom: 0px;
}

.ltn__header-3 .sticky-active .row .col {
  justify-content: space-between !important;
}
.ltn__header-3 .sticky-active .sticky-logo {
  display: block;
}
.ltn__header-3 .sticky-active .header-menu-2 {
  text-align: right;
}

/* ----------------------------------------
    Header 4
---------------------------------------- */
.ltn__header-4 .ltn__header-middle-area,
.ltn__header-5 .ltn__header-middle-area {
  padding-top: 22px;
  padding-bottom: 22px;
}

.ltn__header-4 .ltn__header-top-area {
  border-color: var(--border-color-3);
}

.site-logo-wrap {
  display: flex;
}
.site-logo-wrap .site-logo {
  min-width: auto;
}

.get-support {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 20px;
  margin-left: 20px;
}
.get-support::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 30px;
  width: 1px;
  background-color: #999;
}
.get-support .get-support-icon {
  margin-right: 10px;
  font-size: 35px;
  line-height: 1;
  color: var(--ltn__secondary-color);
}
.get-support .get-support-icon i {
  transform: rotate(-45deg);
}
.get-support .get-support-info {
  margin: 0;
  text-align: left;
}
.get-support .get-support-info h6 {
  margin: 0;
  font-weight: 600;
  font-size: 14px;
}
.get-support .get-support-info h4 {
  margin: 5px 0 0;
  line-height: 1;
}

.get-support-color-white .get-support-info h6,
.get-support-color-white .get-support-info h4 {
  color: var(--white);
}

.special-link {
  margin-left: 15px;
  align-self: center;
}
.special-link a {
  background-color: var(--ltn__secondary-color);
  color: var(--white) !important;
  padding: 12px 30px !important;
}
.special-link a:hover {
  background-color: var(--section-bg-1);
  color: var(--ltn__primary-color) !important;
}

.menu-color-white .ltn__main-menu > ul > li > a {
  color: var(--white);
}

/* ----------------------------------------
  Header 5
---------------------------------------- */
.ltn__header-5 .get-support::before {
  background-color: #e4e8ea;
}
.ltn__header-5 .ltn__header-options {
  margin-left: 30px;
}

/* ----------------------------------------
  ltn__header-logo-mobile-menu-in-mobile
---------------------------------------- */
.ltn__header-logo-mobile-menu-in-mobile {
  margin-top: 0;
}

/* ----------------------------------------------
    Header Sticky
---------------------------------------------- */
.sticky-active {
  animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;
  background-color: var(--white);
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  box-shadow: 0 10px 50px 0 rgba(46, 56, 220, 0.2);
}

.ltn__header-4 .ltn__header-middle-area.sticky-active,
.ltn__header-5 .ltn__header-middle-area.sticky-active {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* Sticky Background Secondary */
.sticky-active.ltn__sticky-bg-secondary {
  background-color: var(--ltn__secondary-color);
}
.sticky-active.ltn__sticky-bg-secondary .ltn__main-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-secondary .header-wishlist a,
.sticky-active.ltn__sticky-bg-secondary .mini-cart-icon,
.sticky-active.ltn__sticky-bg-secondary .header-feature-item h6,
.sticky-active.ltn__sticky-bg-secondary .header-feature-item p,
.sticky-active.ltn__sticky-bg-secondary .header-feature-icon,
.sticky-active.ltn__sticky-bg-secondary .header-search-1 .search-icon,
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options .ltn__drop-menu > ul > li > a {
  color: var(--white);
}
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options-2 .header-search-1,
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options-2 .header-search-1 i,
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options-2 .ltn__drop-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options-2 .mini-cart-icon a,
.sticky-active.ltn__sticky-bg-secondary .ltn__header-options-2 .header-wishlist {
  background: var(--white);
  color: var(--ltn__heading-color);
}

/* Sticky Background Black */
.sticky-active.ltn__sticky-bg-black {
  background-color: var(--ltn__heading-color);
}
.sticky-active.ltn__sticky-bg-black .ltn__main-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-black .header-wishlist a,
.sticky-active.ltn__sticky-bg-black .mini-cart-icon,
.sticky-active.ltn__sticky-bg-black .header-feature-item h6,
.sticky-active.ltn__sticky-bg-black .header-feature-item p,
.sticky-active.ltn__sticky-bg-black .header-feature-icon,
.sticky-active.ltn__sticky-bg-black .header-search-1 .search-icon,
.sticky-active.ltn__sticky-bg-black .ltn__header-options .ltn__drop-menu > ul > li > a {
  color: var(--white);
}
.sticky-active.ltn__sticky-bg-black .ltn__header-options-2 .header-search-1,
.sticky-active.ltn__sticky-bg-black .ltn__header-options-2 .header-search-1 i,
.sticky-active.ltn__sticky-bg-black .ltn__header-options-2 .ltn__drop-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-black .ltn__header-options-2 .mini-cart-icon a,
.sticky-active.ltn__sticky-bg-black .ltn__header-options-2 .header-wishlist {
  background: var(--white);
  color: var(--ltn__heading-color);
}

/* Sticky Background White */
.sticky-active.ltn__sticky-bg-white {
  background-color: var(--white);
}
.sticky-active.ltn__sticky-bg-white .ltn__main-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-white .header-wishlist a,
.sticky-active.ltn__sticky-bg-white .mini-cart-icon,
.sticky-active.ltn__sticky-bg-white .header-feature-item h6,
.sticky-active.ltn__sticky-bg-white .header-feature-item p,
.sticky-active.ltn__sticky-bg-white .header-feature-icon,
.sticky-active.ltn__sticky-bg-white .header-search-1 .search-icon,
.sticky-active.ltn__sticky-bg-white .ltn__header-options .ltn__drop-menu > ul > li > a {
  color: var(--ltn__heading-color);
}
.sticky-active.ltn__sticky-bg-white .ltn__header-options-2 .header-search-1,
.sticky-active.ltn__sticky-bg-white .ltn__header-options-2 .header-search-1 i,
.sticky-active.ltn__sticky-bg-white .ltn__header-options-2 .ltn__drop-menu > ul > li > a,
.sticky-active.ltn__sticky-bg-white .ltn__header-options-2 .mini-cart-icon a,
.sticky-active.ltn__sticky-bg-white .ltn__header-options-2 .header-wishlist {
  box-shadow: var(--ltn__box-shadow-1);
  background: var(--white);
  color: var(--ltn__heading-color);
}

.header-contact-search {
  display: flex;
  justify-content: flex-start;
}

/* ltn__header-transparent */
.ltn__header-transparent {
  position: absolute;
  width: 100%;
  z-index: 999;
  background-color: transparent;
}
.ltn__header-transparent .top-area-color-white {
  background-color: transparent;
}

/* ----------------------------------------
  Utilize Mobile Menu
---------------------------------------- */
.ltn__utilize {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: auto;
  display: block;
  overflow: hidden;
  width: 400px;
  height: 100vh;
  padding: 20px 10px 20px 30px;
  transition: all 0.5s ease 0s;
  transform: translateX(100%);
  background-color: var(--white);
  box-shadow: none;
  z-index: 99999;
}

.ltn__utilize.ltn__utilize-mobile-menu {
  right: auto;
  left: 0;
  padding: 50px 40px;
  transform: translateX(-100%);
}

.ltn__utilize-menu-inner {
  position: relative;
  z-index: 9;
  display: flex;
  flex-direction: column;
  height: 100%;
  touch-action: auto;
  overflow-x: hidden !important;
  padding-right: 20px;
}

.ltn__utilize-menu-search-form {
  margin-bottom: 30px;
  position: relative;
}
.ltn__utilize-menu-search-form input[type=text] {
  margin-bottom: 0;
}
.ltn__utilize-menu-search-form button {
  background-color: transparent;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  padding: 0 15px;
}

@media (max-width: 479px) {
  .ltn__utilize {
    width: 300px;
  }
  .ltn__utilize.ltn__utilize-mobile-menu {
    padding: 50px 20px;
  }
}
.ltn__utilize-menu > ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ltn__utilize-menu > ul > li {
  position: relative;
}

.ltn__utilize-menu > ul > li .menu-expand {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  width: 24px;
  height: 44px;
  cursor: pointer;
  background-color: transparent;
}

.ltn__utilize-menu > ul > li .menu-expand::before,
.ltn__utilize-menu > ul > li .menu-expand::after {
  position: absolute;
  top: calc(50% - 1px);
  left: calc(50% - 7px);
  width: 14px;
  height: 2px;
  content: "";
  transition: all 0.5s ease 0s;
  transform: scale(0.75);
  background-color: #7e7e7e;
}

.ltn__utilize-menu > ul > li .menu-expand::after {
  transform: rotate(90deg) scale(0.75);
}

.ltn__utilize-menu > ul > li.active .menu-expand::after {
  transform: inherit;
}

.ltn__utilize-menu > ul > li > a {
  display: block;
  padding: 8px 24px 8px 0;
  text-transform: uppercase;
}

.ltn__utilize-menu > ul > li .sub-menu {
  position: static;
  top: auto;
  display: none;
  visibility: visible;
  width: 100%;
  min-width: auto;
  padding: 0;
  padding-left: 15px;
  transition: none;
  opacity: 1;
  box-shadow: none;
}

.ltn__utilize-menu > ul > li .sub-menu li {
  line-height: inherit;
  position: relative;
  list-style: none;
}

.ltn__utilize-overlay {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.ltn__utilize.ltn__utilize-open {
  transform: translateX(0);
}

.ltn__utilize.ltn__utilize-mobile-menu.ltn__utilize-open {
  transform: translateX(0);
}

.mobile-menu-toggle {
  margin-right: 15px;
}

.mobile-menu-toggle > a {
  width: 24px;
  height: 32px;
  position: relative;
  display: flex;
  color: #333;
  margin-left: auto;
}

.mobile-menu-toggle svg {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 60px;
  margin-top: -2px;
  margin-left: -2px;
  cursor: pointer;
  transform: translate3d(-50%, -50%, 0);
}

.mobile-menu-toggle svg path {
  transition: stroke-dashoffset 0.5s cubic-bezier(0.25, -0.25, 0.75, 1.25), stroke-dasharray 0.5s cubic-bezier(0.25, -0.25, 0.75, 1.25);
  fill: none;
  stroke: #333;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke-width: 30px;
}

.mobile-menu-toggle svg path#top, .mobile-menu-toggle svg path#bottom {
  stroke-dasharray: 240px 950px;
}

.mobile-menu-toggle svg path#middle {
  stroke-dasharray: 240px 240px;
}

.mobile-menu-toggle .close svg path#top, .mobile-menu-toggle .close svg path#bottom {
  stroke-dasharray: -650px;
  stroke-dashoffset: -650px;
}

.mobile-menu-toggle .close svg path#middle {
  stroke-dasharray: 1px 220px;
  stroke-dashoffset: -115px;
}

.ltn__utilize-menu-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.ltn__utilize-menu-head .ltn__utilize-menu-title {
  font-weight: 700;
}
.ltn__utilize-menu-head .ltn__utilize-close {
  background-color: transparent;
  font-size: 30px;
  padding: 0 15px;
}

.ltn__utilize-buttons {
  border-top: 1px solid var(--border-color-1);
  padding: 5px 0px 20px;
  margin: 30px 0;
  border-bottom: 1px solid var(--border-color-1);
}
.ltn__utilize-buttons ul {
  padding: 0;
  margin: 0;
}
.ltn__utilize-buttons ul li {
  display: inline-block;
}
.ltn__utilize-buttons .utilize-btn-icon {
  width: 50px;
  display: inline-block;
  height: 50px;
  border: 2px solid var(--border-color-1);
  line-height: 46px;
  text-align: center;
  margin-right: 10px;
}

.ltn__utilize-buttons-2 ul li {
  display: block;
}

.menu-btn-white.mobile-menu-toggle > a {
  color: #fff;
}
.menu-btn-white.mobile-menu-toggle svg path {
  stroke: #fff;
}

.menu-btn-border a {
  width: 40px;
  height: 38px;
  border: 1px solid;
}

/* logo-right-menu-option */
.ltn__logo-right-menu-option .row > * {
  width: auto;
}

.ltn__header-row-bg-white .row {
  background-color: var(--white);
}

@media (min-width: 1200px) {
  .ltn__header-padding .row {
    padding: 10px;
  }
  .ltn__header-padding.sticky-active .row {
    padding: 0;
  }
}
/* ----------------------------------------
  Responsive
---------------------------------------- */
@media (min-width: 1200px) and (max-width: 1300px) {
  .ltn__main-menu > ul > li {
    margin-right: 15px;
  }
  .ltn__main-menu > ul > li:last-child {
    margin-right: 0;
  }
  .ltn__main-menu > ul > li > a {
    font-size: 15px;
  }
  .ltn__header-6 .ltn__main-menu > ul > li {
    margin-right: 10px;
  }
  .ltn__header-6 .ltn__main-menu > ul > li:last-child {
    margin-right: 0px;
  }
  .ltn__header-6 .special-link a {
    padding: 15px 20px !important;
  }
  .ltn__header-6 .ltn__main-menu > ul > li > a {
    font-size: 14px;
  }
}
@media (max-width: 1199px) {
  .site-logo {
    min-width: 180px;
  }
  .ltn__main-menu > ul > li > a {
    padding: 20px 15px;
  }
  .ltn__main-menu > ul > li {
    margin-right: 10px;
  }
  .ltn__header-3 .header-feature-item {
    display: none;
  }
  .ltn__header-logo-and-mobile-menu .site-logo-wrap {
    justify-content: flex-start;
    margin: 10px 0 10px;
  }
  .ltn__header-logo-and-mobile-menu .ltn__header-middle-area > .container-fluid > .row > .col,
  .ltn__header-logo-and-mobile-menu .ltn__header-middle-area > .container > .row > .col {
    max-width: 65%;
  }
  .ltn__header-logo-and-mobile-menu .ltn__header-options {
    flex: 0 0 30%;
  }
  .ltn__header-row-bg-white .row {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
@media (max-width: 991px) {
  .header-search-column,
  .header-menu-column {
    display: none;
  }
  /* sticky */
  .sticky-active {
    position: inherit;
  }
  .ltn__header-2 .ltn__header-middle-area > .container > .row .header-feature-column {
    order: 3;
    flex-grow: 1;
    max-width: 100%;
    border-top: 1px solid #ddd;
  }
  .ltn__header-2 .header-feature-area {
    justify-content: space-between;
  }
  .ltn__header-2 .header-feature-item {
    margin-right: 15px;
  }
  .ltn__header-3 .ltn__header-middle-area > .container > .row .header-search-column {
    order: 3;
    flex-grow: 1;
    max-width: 100%;
    border-top: 1px solid #ddd;
  }
  .ltn__header-3 .header-search-2 {
    min-width: 280px;
  }
  .ltn__top-bar-menu ul li {
    margin: 0 20px 0 0;
  }
}
@media (max-width: 767px) {
  .ltn__header-top-area {
    padding: 5px 0;
    text-align: center;
  }
  .ltn__header-top-area .ltn__social-media ul li {
    font-size: 12px;
    margin: 0 5px 0 0;
  }
  .ltn__top-bar-menu .ltn__currency-menu .active-currency,
  .ltn__top-bar-menu > ul > li {
    font-size: 13px;
  }
  .ltn__drop-menu > ul > li {
    position: inherit;
  }
  .ltn__drop-menu > ul > li > a {
    height: 20px;
    line-height: 20px;
  }
  .ltn__drop-menu ul li ul {
    left: 50%;
    right: 50%;
    transform: translateX(-50%);
  }
  .top-bar-right {
    display: flex;
    justify-content: space-between;
  }
  .welcome p {
    line-height: 20px;
    margin: 5px 0;
  }
  .site-logo {
    min-width: 100px;
  }
  .ltn__header-5 .top-bar-right,
  .ltn__header-4 .top-bar-right {
    justify-content: center;
    margin-top: 5px;
  }
  .ltn__logo-right-menu-option .site-logo-wrap,
  .ltn__header-4 .site-logo-wrap,
  .ltn__header-5 .site-logo-wrap {
    flex: 0 0 100%;
    justify-content: center;
    margin: 10px 0 30px;
  }
  .ltn__logo-right-menu-option .ltn__header-options,
  .ltn__header-4 .ltn__header-options,
  .ltn__header-5 .ltn__header-options {
    margin-left: 0;
    flex: 0 0 100%;
    justify-content: center;
  }
  .ltn__header-3 .top-bar-right {
    justify-content: center;
    margin-top: 5px;
  }
  .ltn__header-logo-and-mobile-menu-in-mobile .site-logo-wrap {
    justify-content: flex-start;
    margin: 10px 0 10px;
  }
  .ltn__header-logo-and-mobile-menu-in-mobile .ltn__header-middle-area > .container-fluid > .row > .col,
  .ltn__header-logo-and-mobile-menu-in-mobile .ltn__header-middle-area > .container > .row > .col {
    max-width: 65%;
  }
  .ltn__header-logo-and-mobile-menu-in-mobile .ltn__header-options {
    flex: 0 0 30%;
  }
  .header-top-btn a {
    padding: 0 15px;
    line-height: 25px;
  }
  .ltn__header-row-bg-white .row {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media (max-width: 575px) {
  .site-logo a {
    font-size: 24px;
  }
  .site-logo a i {
    font-size: 20px;
  }
  .ltn__header-1 .ltn__header-middle-area > .container > .row {
    flex-flow: column;
  }
  .ltn__header-1 .site-logo {
    justify-content: center;
  }
  .ltn__header-1 .ltn__header-options {
    justify-content: center;
    margin-top: 30px;
  }
  .ltn__header-7 .site-logo {
    justify-content: center;
  }
  .ltn__header-7 .ltn__header-options {
    justify-content: center;
    margin-top: 20px;
  }
  .ltn__header-7 .ltn__header-middle-area > .container > .row .col,
  .ltn__header-7 .ltn__header-middle-area > .container-fluid > .row .col {
    flex: 0 0 100%;
  }
  .ltn__header-3 .mini-cart-icon-2 > a {
    min-width: auto;
  }
  .ltn__header-3 .mini-cart-icon-2 > a h6 {
    display: none;
  }
}
@media (max-width: 449px) {
  .ltn__header-options > div {
    margin-right: 10px;
  }
  .header-feature-area {
    flex-flow: column;
  }
  .header-feature-item:last-child {
    padding-top: 0;
  }
  .get-support {
    padding-left: 10px;
    margin-left: 10px;
  }
  .get-support .get-support-icon {
    font-size: 20px;
    display: none;
  }
  .get-support .get-support-info h6 {
    display: 13px;
  }
  .get-support .get-support-info h4 {
    font-size: 16px;
  }
}
@media (max-width: 370px) {
  .ltn__header-3 .ltn__header-options > ul > li {
    margin-right: 5px;
  }
}
/* ----------------------------------------
  Icon Font
---------------------------------------- */
.ltn__header-options i,
.ltn__header-top-area i {
  font-weight: bold;
}

/* ----------------------------------------------------
    Category Menu
---------------------------------------------------- */
.ltn__category-menu-wrap {
  position: relative;
}

.ltn__category-menu-title h2 {
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 45px;
  margin: 0;
  overflow: hidden;
  padding: 10px 20px 3px;
  position: relative;
  text-transform: uppercase;
  font-family: var(--ltn__body-font);
}
.ltn__category-menu-title h2::before, .ltn__category-menu-title h2::after {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  display: block;
  font-size: 14px;
}
.ltn__category-menu-title h2::before {
  content: "\\f0c9";
  float: left;
  margin-right: 10px;
}
.ltn__category-menu-title h2::after {
  content: "\\f0dd";
  float: right;
}

.ltn__category-menu-toggle {
  background-color: var(--white);
}
.ltn__category-menu-toggle > ul {
  border-color: var(--border-color-1);
  border-width: 1px 1px 1px;
  border-style: solid;
  padding: 0;
  margin: 0;
}
.ltn__category-menu-toggle > ul > li > a {
  padding: 14px 15px 11px;
  display: block;
  font-size: 15px;
  border-bottom: 1px solid var(--border-color-1);
}
.ltn__category-menu-toggle > ul > li:hover > a {
  background-color: var(--section-bg-1);
  font-weight: 700;
}
.ltn__category-menu-toggle > ul > li:hover .ltn__category-submenu {
  opacity: 1;
  visibility: visible;
  top: 0;
}
.ltn__category-menu-toggle > ul > li i {
  font-size: 18px;
  margin-right: 5px;
  width: 25px;
  display: inline-block;
}
.ltn__category-menu-toggle ul {
  margin: 0;
}
.ltn__category-menu-toggle ul li {
  margin-top: 0;
  list-style: none;
  position: relative;
  font-size: 14px;
}
.ltn__category-menu-toggle ul li a {
  display: block;
}
.ltn__category-menu-toggle ul li:hover > a {
  color: var(--ltn__secondary-color);
}
.ltn__category-menu-toggle.ltn__one-line-active .ltn__category-submenu li a {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ltn__category-submenu {
  position: absolute;
  left: 100%;
  top: 90%;
  width: 230px;
  z-index: 99;
  background-color: #fff;
  padding: 25px 20px;
  box-shadow: var(--ltn__box-shadow-4);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}
.ltn__category-submenu ul {
  padding: 0;
}
.ltn__category-submenu ul li {
  padding: 8px 0px;
}
.ltn__category-submenu > li {
  width: 100%;
  float: left;
  padding: 0 10px;
}
.ltn__category-submenu.ltn__category-column-5, .ltn__category-submenu.ltn__category-column-6, .ltn__category-submenu.ltn__category-column-7, .ltn__category-submenu.ltn__category-column-8, .ltn__category-submenu.ltn__category-column-9, .ltn__category-submenu.ltn__category-column-10, .ltn__category-submenu.ltn__category-column-11, .ltn__category-submenu.ltn__category-column-12, .ltn__category-submenu.ltn__category-column-no-5, .ltn__category-submenu.ltn__category-column-no-6, .ltn__category-submenu.ltn__category-column-no-7, .ltn__category-submenu.ltn__category-column-no-8, .ltn__category-submenu.ltn__category-column-no-9, .ltn__category-submenu.ltn__category-column-no-10, .ltn__category-submenu.ltn__category-column-no-11, .ltn__category-submenu.ltn__category-column-no-12, .ltn__category-submenu.ltn__category-column-no-13, .ltn__category-submenu.ltn__category-column-no-14 {
  width: 730px;
}
.ltn__category-submenu.ltn__category-column-5 > li, .ltn__category-submenu.ltn__category-column-6 > li, .ltn__category-submenu.ltn__category-column-7 > li, .ltn__category-submenu.ltn__category-column-8 > li, .ltn__category-submenu.ltn__category-column-9 > li, .ltn__category-submenu.ltn__category-column-10 > li, .ltn__category-submenu.ltn__category-column-11 > li, .ltn__category-submenu.ltn__category-column-12 > li, .ltn__category-submenu.ltn__category-column-no-5 > li, .ltn__category-submenu.ltn__category-column-no-6 > li, .ltn__category-submenu.ltn__category-column-no-7 > li, .ltn__category-submenu.ltn__category-column-no-8 > li, .ltn__category-submenu.ltn__category-column-no-9 > li, .ltn__category-submenu.ltn__category-column-no-10 > li, .ltn__category-submenu.ltn__category-column-no-11 > li, .ltn__category-submenu.ltn__category-column-no-12 > li, .ltn__category-submenu.ltn__category-column-no-13 > li, .ltn__category-submenu.ltn__category-column-no-14 > li {
  width: 25%;
}
.ltn__category-submenu.ltn__category-column-4, .ltn__category-submenu.ltn__category-column-no-4 {
  width: 730px;
}
.ltn__category-submenu.ltn__category-column-4 > li, .ltn__category-submenu.ltn__category-column-no-4 > li {
  width: 25%;
}
.ltn__category-submenu.ltn__category-column-3, .ltn__category-submenu.ltn__category-column-no-3 {
  width: 690px;
}
.ltn__category-submenu.ltn__category-column-3 > li, .ltn__category-submenu.ltn__category-column-no-3 > li {
  width: 33%;
}
.ltn__category-submenu.ltn__category-column-2, .ltn__category-submenu.ltn__category-column-no-2 {
  width: 460px;
}
.ltn__category-submenu.ltn__category-column-2 > li, .ltn__category-submenu.ltn__category-column-no-2 > li {
  width: 50%;
}

.ltn__category-submenu-title > a {
  border-bottom: 1px solid #ddd;
  font-weight: 700;
  padding: 5px 0;
  margin-bottom: 10px;
}

.ltn__category-menu-toggle .ltn__category-menu-more-item-parent {
  cursor: pointer;
}
.ltn__category-menu-toggle .ltn__category-menu-more-item-child,
.ltn__category-menu-toggle .rx-show {
  display: none;
}
.ltn__category-menu-toggle .rx-change .rx-show {
  display: block;
}
.ltn__category-menu-toggle .rx-change .rx-default {
  display: none;
}

.ltn__category-dropdown-hide .ltn__category-menu-toggle {
  display: none;
}

.ltn__category-menu-with-header-menu .ltn__category-menu-toggle {
  position: absolute;
  width: 100%;
  z-index: 9;
}

@media (max-width: 1200px) {
  .ltn__category-menu-toggle > ul > li > a {
    padding: 10px 5px;
    font-size: 13px;
  }
  .ltn__category-menu-toggle > ul > li i {
    font-size: 16px;
    width: 20px;
  }
  .ltn__category-menu-toggle ul li {
    font-size: 13px;
  }
  .ltn__category-submenu ul {
    padding-left: 10px;
  }
  .ltn__category-submenu ul li {
    padding: 5px 0px;
  }
}
@media (max-width: 991px) {
  .ltn__category-menu-wrap {
    margin-bottom: 30px;
  }
  .ltn__category-menu-toggle {
    max-height: 350px;
    overflow: auto;
    position: absolute;
    width: 100%;
    z-index: 99;
    display: none;
  }
  .ltn__category-submenu {
    display: none;
    opacity: inherit !important;
    visibility: inherit !important;
    left: inherit !important;
    width: 100% !important;
    top: 100%;
    max-height: 350px;
    overflow: auto;
    transition: unset;
    box-shadow: inherit;
    position: inherit;
    padding: 5px 0px 0px 15px;
  }
  .ltn__category-submenu > li {
    width: 100% !important;
    margin-bottom: 0;
    float: none;
  }
  .ltn__category-submenu-children {
    display: none;
  }
  .ltn__category-menu-drop > a {
    position: relative;
  }
  .ltn__category-menu-drop > a::before {
    position: absolute;
    content: "+";
    right: 15px;
    top: 50%;
    transform: translatey(-50%);
    font-size: 20px;
    font-weight: 400;
  }
  .ltn__category-menu-drop.open > a::before {
    display: none;
  }
  .ltn__category-menu-drop.open > a::after {
    position: absolute;
    content: "-";
    right: 15px;
    top: 50%;
    transform: translatey(-50%);
    font-size: 30px;
    font-weight: 400;
  }
}
.mobile-header-menu-fullwidth .mobile-menu-toggle {
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--border-color-1);
  padding: 7px 20px 6px;
  margin-right: 0;
}

.top-a {
  color: var(--white) !important;
}

.overlay {
  /*position: absolute; */
  background: rgba(57, 57, 57, 0.5);
  width: -moz-fit-content !important;
  width: fit-content !important;
  /* center overlay text */
}

.overlay2 {
  width: -moz-fit-content !important;
  width: fit-content !important;
  background: rgba(72, 94, 33, 0.5);
  /* center overlay text */
}

.overlay3 {
  width: -moz-fit-content !important;
  width: fit-content !important;
  background: rgba(72, 94, 33, 0.65);
  /* center overlay text */
}

.overlay4 {
  width: -moz-fit-content !important;
  width: fit-content !important;
  background: rgba(33, 72, 94, 0.65);
  /* center overlay text */
}

.overlay_1 {
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px;
}

/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ----------------------------------------------------
    Slider Area 1, 2, 3, 4, 5, 6, 7, 9
---------------------------------------------------- */
.ltn__slide-item {
  padding-top: 100px;
  padding-bottom: 100px;
  height: 750px;
}

.ltn__slide-item-inner {
  height: 100%;
  display: flex;
  align-items: center;
}

.slide-item-info-inner {
  width: 100%;
}

.slide-title {
  font-size: 38px;
  font-weight: 700;
}

/* Slider Animation Start */
.ltn__slide-animation {
  position: relative;
  z-index: 9;
}
.ltn__slide-animation > * {
  opacity: 0;
  visibility: hidden;
  animation-name: fadeOutUp;
}
.ltn__slide-animation > *:nth-child(1) {
  animation-delay: 0.5s;
  animation-duration: 0.5s;
}
.ltn__slide-animation > *:nth-child(2) {
  animation-delay: 1s;
  animation-duration: 1s;
}
.ltn__slide-animation > *:nth-child(3) {
  animation-delay: 1.5s;
  animation-duration: 1.5s;
}
.ltn__slide-animation > *:nth-child(4) {
  animation-delay: 2s;
  animation-duration: 2s;
}
.ltn__slide-animation > *:nth-child(5) {
  animation-delay: 2.5s;
  animation-duration: 2.5s;
}
.ltn__slide-animation > *:nth-child(6) {
  animation-delay: 3s;
  animation-duration: 3s;
}
.ltn__slide-animation > *:nth-child(7) {
  animation-delay: 3.5s;
  animation-duration: 3.5s;
}
.ltn__slide-animation > *:nth-child(8) {
  animation-delay: 4s;
  animation-duration: 4s;
}
.ltn__slide-animation > *:nth-child(9) {
  animation-delay: 4.5s;
  animation-duration: 4.5s;
}
.ltn__slide-animation > *:nth-child(11) {
  animation-delay: 5s;
  animation-duration: 5s;
}

.slick-current .ltn__slide-animation > *,
.ltn__slide-animation-active .ltn__slide-animation > * {
  opacity: 1;
  visibility: visible;
  animation-name: fadeInUp;
}

/* Title Background Image */
.title-bg-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  -webkit-background-clip: text;
          background-clip: text;
  -webkit-text-fill-color: transparent;
  word-break: break-word;
}

.title-bg-img-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

/* Slide Arrow */
.slick-slide-arrow-1 .slick-arrow {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  line-height: 58px;
  border: 1px solid var(--border-color-1);
  text-align: center;
  font-size: 20px;
  color: var(--ltn__primary-color) !important;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
}
.slick-slide-arrow-1 .slick-arrow:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white) !important;
}
.slick-slide-arrow-1 .slick-next {
  right: 40px;
  left: auto;
}
.slick-slide-arrow-1:hover .slick-arrow {
  opacity: 1;
  visibility: visible;
  left: 20px;
}
.slick-slide-arrow-1:hover .slick-next {
  right: 20px;
  left: auto;
}

.slick-slide-dots-1 .slick-dots {
  position: absolute;
  bottom: 50px;
  width: 100%;
  margin: 0;
}

.arrow-white .slick-arrow {
  color: var(--white) !important;
  border: 1px solid var(--border-color-3);
}

@media (min-width: 1400px) {
  .slick-slide-arrow-1:hover .slick-arrow {
    opacity: 1;
    visibility: visible;
    left: 60px;
  }
  .slick-slide-arrow-1:hover .slick-next {
    right: 60px;
    left: auto;
  }
}
/* slide-item-2 */
.ltn__slide-item-2 {
  height: calc(50vh - 0px) !important;
  padding-top: 100px !important;
}
.ltn__slide-item-2 .slide-item-info {
  max-width: 650px;
}
.ltn__slide-item-2 .slide-sub-title {
  margin-bottom: 20px;
  font-family: var(--ltn__body-font);
}
.ltn__slide-item-2 .slide-sub-title span {
  color: var(--ltn__secondary-color);
}
.ltn__slide-item-2 .slide-title {
  font-size: 65px;
  line-height: 1;
  margin-bottom: 20px;
}
.ltn__slide-item-2 .slide-title span {
  color: var(--ltn__secondary-color);
}
.ltn__slide-item-2 .btn-wrapper {
  margin-top: 40px;
}
.ltn__slide-item-2 .slide-brief {
  padding-left: 30px;
  border-left: 1px solid #576466;
}

.btn-wrapper {
  margin-top: 40px;
}

.slide-brief {
  padding-left: 30px;
  border-left: 1px solid #576466;
}

.ltn__slide-item-6 .text-right .slide-item-info,
.ltn__slide-item-2 .text-right .slide-item-info {
  margin-left: auto;
}
.ltn__slide-item-6 .text-right .slide-brief,
.ltn__slide-item-2 .text-right .slide-brief {
  padding-left: 0px;
  border-left: 0;
  padding-right: 30px;
  border-right: 1px solid #576466;
  margin-left: auto;
}
.ltn__slide-item-6 .text-center .slide-item-info,
.ltn__slide-item-2 .text-center .slide-item-info {
  margin-left: auto;
  margin-right: auto;
}
.ltn__slide-item-6 .text-center .slide-brief,
.ltn__slide-item-2 .text-center .slide-brief {
  padding-left: 0px;
  border-left: 0;
  padding-right: 0px;
  border-right: 0;
}

.slide-brief {
  max-width: 450px;
}

.text-right .slide-brief {
  margin-left: auto;
}

.text-center .slide-brief {
  margin-left: auto;
  margin-right: auto;
}

.ltn__product-pointer {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
}
.ltn__product-pointer > ul {
  padding: 0;
  margin: 0;
}
.ltn__product-pointer > ul > li {
  display: inline-block;
  list-style: none;
  position: relative;
}
.ltn__product-pointer > ul > li > ul {
  position: absolute;
  top: 80%;
  min-width: 300px;
  padding: 0;
  background-color: white;
  right: 80px;
  box-shadow: var(--ltn__box-shadow-3);
  transform: translateY(-50%);
  transition: all 0.3s ease 0s;
  text-align: left;
  opacity: 0;
  visibility: hidden;
}
.ltn__product-pointer > ul > li > ul > li {
  list-style: none;
}
.ltn__product-pointer > ul > li:hover ul {
  top: 50%;
  opacity: 1;
  visibility: visible;
}
.ltn__product-pointer > ul > li:hover .ltn__pointer-icon {
  transform: rotate(45deg);
}
.ltn__product-pointer ul li, .ltn__product-pointer ol li {
  margin-top: 5px;
}
.ltn__product-pointer img {
  height: inherit !important;
}
.ltn__product-pointer p:last-child {
  margin-bottom: 0;
}
.ltn__product-pointer .ltn__pointer-icon {
  cursor: pointer;
  height: 60px;
  width: 60px;
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 20px;
  box-shadow: var(--ltn__box-shadow-4);
  transition: all 0.3s ease 0s;
}
.ltn__product-pointer .ltn__product-pointer-inner {
  padding: 15px 30px 25px;
  position: relative;
}
.ltn__product-pointer .ltn__product-pointer-inner::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-left: 15px solid var(--white);
  border-bottom: 15px solid transparent;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
}
.ltn__product-pointer .ltn__product-pointer-inner h5 {
  margin-bottom: 10px;
}
.ltn__product-pointer .ltn__product-pointer-inner p {
  font-size: 14px;
}
.ltn__product-pointer.ltn__product-pointer-1 {
  top: 38%;
  left: auto;
  right: 24%;
}
.ltn__product-pointer.ltn__product-pointer-2 {
  top: 60%;
  left: 20%;
}
.ltn__product-pointer.ltn__product-pointer-3 {
  top: 10%;
  left: 40%;
}

.slide-img-left .ltn__product-pointer > ul > li > ul {
  left: 80px;
  right: auto;
}
.slide-img-left .ltn__product-pointer .ltn__product-pointer-inner::before {
  border-right: 15px solid var(--white);
  border-left: 0;
  right: auto;
  left: -15px;
}

/* slide-item-3 */
.ltn__slide-item-3 .row [class*=col-] {
  position: inherit;
}
.ltn__slide-item-3 .slide-item-info {
  position: relative;
  z-index: 2;
}
.ltn__slide-item-3 .slide-item-img {
  width: 45%;
  position: absolute;
  right: 150px;
  top: auto;
  bottom: 100px;
  height: 70%;
}
.ltn__slide-item-3 .slide-item-img img {
  text-align: right;
  margin-left: auto;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}
.ltn__slide-item-3 .text-right .slide-item-img {
  right: auto;
  left: 150px;
}

.ltn__slide-item-3-normal {
  height: calc(100vh - 160px);
  padding-top: 100px;
}

/* slide-item-4 */
.ltn__slide-item-4 {
  padding-bottom: 0;
}
.ltn__slide-item-4 .slide-item-img {
  margin-top: 100px;
}

/* slider-5 */
.ltn__slider-5 .ltn__slide-item-2 {
  padding-top: 100px;
}

/* slide-item-5 */
.ltn__slide-item-5 .slide-item-img {
  right: 200px;
  bottom: 0;
  height: 80%;
}
.ltn__slide-item-5 .call-to-circle-1 {
  right: 14%;
  left: auto;
  top: 30%;
  z-index: -1;
  animation: wave 8s 0.1s infinite linear;
}
.ltn__slide-item-5 .text-right .slide-item-img {
  right: auto;
  left: 150px;
}
.ltn__slide-item-5 .text-right .call-to-circle-1 {
  left: 20%;
  right: auto;
}

/* slide-item-6 */
.ltn__slide-item-6 .slide-item-info {
  max-width: 100%;
}
.ltn__slide-item-6 .slide-title {
  font-size: 80px;
  line-height: 1;
}

/* slide-item-7 */
.ltn__slide-item-7 {
  min-height: 800px;
  height: calc(100vh - 0px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ltn__slide-item-7 .slide-item-info {
  max-width: 850px;
}
.ltn__slide-item-7 .slide-title {
  font-size: 90px;
  line-height: 1;
}

/* slider-9 */
.ltn__slide-item-9 {
  height: 800px;
}
.ltn__slide-item-9 .slide-item-info {
  height: 800px;
  max-width: 500px;
}

.ltn__slide-item-9 .ltn__slide-item-inner {
  display: block;
}
.ltn__slide-item-9 .slide-item-info {
  display: flex;
  align-items: center;
  padding: 30px 30px 10px;
}
.ltn__slide-item-9 .right-align .slide-item-info {
  margin-left: auto;
}
.ltn__slide-item-9 .slide-item-info-inner {
  position: relative;
}
.ltn__slide-item-9 .slide-item-info-inner::before, .ltn__slide-item-9 .slide-item-info-inner::after {
  position: absolute;
  content: "";
  width: 2px;
  height: 84px;
  background-color: var(--ltn__heading-color);
  left: 50%;
  transform: translateX(-50%);
}
.ltn__slide-item-9 .slide-item-info-inner::before {
  top: -46.5%;
}
.ltn__slide-item-9 .slide-item-info-inner::after {
  bottom: -51%;
}
.ltn__slide-item-9 .text-color-white .slide-item-info-inner::before, .ltn__slide-item-9 .text-color-white .slide-item-info-inner::after {
  background-color: var(--white);
}
.ltn__slide-item-9 .ltn__tab-menu a {
  padding: 12px 20px;
}
.ltn__slide-item-9 .slide-item-info-line-no::before, .ltn__slide-item-9 .slide-item-info-line-no::after {
  display: none;
}

/* slide-item-10 */
.ltn__slide-item-10 {
  height: 535px;
}
.ltn__slide-item-10 .slide-item-info-inner {
  padding: 30px;
}

/* ----------------------------------------------------
    Slider Area 1, 2, 3, 4, 5, 6, 7, 9
---------------------------------------------------- */
/* ======================================================
    s 3 Start
 ====================================================== */
/* slider-4 */
.ltn__slider-11 .ltn__slider-11-inner {
  position: relative;
}
.ltn__slider-11 .ltn__slide-item-11 {
  position: relative;
}
.ltn__slider-11 .ltn__slide-item-11 .slide-content {
  padding: 80px 0 100px 200px;
  padding-bottom: 250px;
  position: relative;
  width: 90%;
  z-index: 1;
  min-height: 100vh;
  height: 800px;
}
.ltn__slider-11 .ltn__slide-item-11 .slide-content .slide-title-1 {
  color: var(--main-color-one);
}
.ltn__slider-11 .ltn__slide-item-11 .slide-content .slide-title-2 {
  color: var(--secondary-color-three);
}
.ltn__slider-11 .ltn__slide-item-11 .slide-content p {
  color: #000;
}
.ltn__slider-11 .ltn__slide-item-11:before {
  opacity: 0;
}
.ltn__slider-11 .slide-item-img {
  position: absolute;
  right: 0px;
  top: 0;
  height: 100%;
  z-index: 0;
  width: 45%;
}
.ltn__slider-11 .slide-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  margin-left: auto;
}

/* slider-4-active */
.ltn__slider-11-active .slick-arrow {
  position: absolute;
  bottom: 60px;
  left: 30%;
  z-index: 9;
}
.ltn__slider-11-active .slick-arrow i {
  font-size: 30px;
  color: #ccc;
}
.ltn__slider-11-active .slick-arrow.slick-next {
  margin-left: 50px;
}

/* slider-4-pagination */ /* ===== Set Display for show / hide ===== */
.ltn__slider-11-pagination-count {
  display: none;
  position: absolute;
  top: 53%;
  transform: translateY(-50%);
  left: auto;
  right: 50px;
}
.ltn__slider-11-pagination-count span {
  color: var(--ltn__color-5);
}
.ltn__slider-11-pagination-count .count {
  position: absolute;
  top: -22px;
  left: -8px;
}
.ltn__slider-11-pagination-count .total {
  bottom: -25px;
  position: absolute;
  left: -10px;
}
.ltn__slider-11-pagination-count .slick-dots {
  display: flex !important;
  flex-direction: column;
  height: 520px;
}
.ltn__slider-11-pagination-count .slick-dots li {
  margin: 0;
  flex: 1 1 auto;
  border-radius: 0;
  width: 2px;
  opacity: 0.45;
}
.ltn__slider-11-pagination-count .slick-dots li button {
  display: block;
  border-radius: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: var(--section-bg-1);
  opacity: 0.45;
  cursor: pointer;
}
.ltn__slider-11-pagination-count .slick-dots li button:hover {
  background-color: var(--section-bg-1);
  opacity: 1;
}
.ltn__slider-11-pagination-count .slick-dots li.slick-active button {
  background-color: var(--ltn__secondary-color);
  opacity: 1;
}

.ltn__slider-11-pagination-count-show .ltn__slider-11-pagination-count {
  display: block;
}

@media only screen and (min-width: 992px) {
  .ltn__slide-item-11 {
    min-height: calc(100vh - 140px);
  }
}
/* slider-4-img-slide-arrow */
.ltn__slider-11-img-slide-arrow {
  position: absolute;
  bottom: 30px;
  right: 10%;
  width: 500px;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-inner {
  position: relative;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active {
  padding-left: 100px;
  background-color: var(--main-color-one);
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .image-slide-item {
  padding: 0 10px;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .image-slide-item img {
  border: 5px solid;
  border-color: var(--section-bg-1);
  cursor: pointer;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .image-slide-item.slick-current img {
  opacity: 0.9;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .slick-arrow {
  position: absolute;
  right: auto;
  z-index: 9;
  top: 0;
  left: 0;
  padding-left: 0;
  background-color: var(--section-bg-1);
  text-align: center;
  width: 40px;
  height: 40px;
  line-height: 43px;
  font-size: 16px;
}
.ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .slick-arrow.slick-next {
  left: 50px;
}

/* slider-11-slide-item-count */ /* ===== Set Display for show / hide ===== */
.ltn__slider-11-slide-item-count {
  display: none;
  left: 0;
  right: auto;
  top: auto;
  bottom: 0;
  position: absolute;
  background-color: var(--section-bg-1);
  padding: 5px 15px 0px;
}
.ltn__slider-11-slide-item-count .count {
  font-size: 30px;
  line-height: 1;
}

.ltn__slider-11-slide-item-count-show .ltn__slider-11-slide-item-count {
  display: block;
}

/* slider-sticky-icon-2 */
.slider-sticky-icon-2 {
  position: absolute;
  left: 50px;
  bottom: 80px;
  z-index: 1;
}
.slider-sticky-icon-2 ul {
  padding: 0;
}
.slider-sticky-icon-2 ul li {
  list-style: none;
  display: block;
  margin-bottom: 12px;
}

/* ======================================================
    s 3 END
 ====================================================== */
@media (min-width: 1600px) {
  .ltn__slide-item-2 {
    min-height: 800px;
  }
  .ltn__slide-item-3-normal {
    min-height: 780px;
  }
  .ltn__slide-item-6 {
    height: 800px;
  }
}
@media (max-width: 1599px) {
  .liton-slide-item,
  .ltn__slide-item-3,
  .liton-slide-item-inner {
    height: inherit;
  }
  .ltn__slide-item-9 {
    height: 650px;
  }
  .ltn__slide-item-9 .slide-item-info {
    height: 650px;
    max-width: 400px;
  }
  .ltn__slider-11-img-slide-arrow {
    width: 80%;
    max-width: 350px;
  }
  .ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .image-slide-item {
    padding: 0 3px;
  }
  .ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .image-slide-item img {
    border: 2px solid;
    border-color: var(--section-bg-1);
  }
  .ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .slick-arrow {
    width: 30px;
    height: 30px;
    line-height: 33px;
    font-size: 14px;
    top: 50%;
    transform: translateY(-50%);
  }
  .ltn__slider-11-img-slide-arrow .ltn__slider-11-img-slide-arrow-active .slick-arrow.slick-next {
    left: 40px;
  }
  .ltn__slider-11-slide-item-count-show .ltn__slider-11-slide-item-count {
    display: none;
  }
  .ltn__slider-11-pagination-count-show .ltn__slider-11-pagination-count {
    display: none;
  }
  .slider-sticky-icon-2 {
    display: none;
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .ltn__slide-item-2 .slide-title {
    font-size: 50px;
  }
  .ltn__slide-item-6 {
    height: 620px;
  }
  .ltn__slide-item-6 .slide-title {
    font-size: 80px;
  }
}
@media (min-width: 1400px) and (max-width: 1599px) {
  .ltn__slide-item-3 .slide-item-img {
    width: 45%;
    right: 60px;
    top: 60%;
    transform: translateY(-50%);
  }
  .ltn__slide-item-3 .slide-item-img.slide-img-left {
    right: auto;
    left: 60px;
  }
  .ltn__slide-item-4 .slide-item-img {
    margin-top: 50px;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  .ltn__slider-11 .slide-item-img {
    top: 0;
    right: 0;
    transform: inherit;
  }
}
@media (min-width: 1200px) and (max-width: 1399px) {
  .ltn__slide-item-3 .slide-item-img {
    width: 45%;
    right: 60px;
    top: 65%;
    transform: translateY(-50%);
  }
  .ltn__slide-item-3 .slide-item-img.slide-img-left {
    right: auto;
    left: 60px;
  }
  .ltn__slide-item-4 .slide-item-img {
    margin-top: 50px;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  .ltn__slider-11 .slide-item-img {
    top: 0;
    right: 0;
    transform: inherit;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .ltn__slide-item-3 .slide-item-img {
    width: 45%;
    right: 60px;
  }
  .ltn__slide-item-3 .slide-item-img.slide-img-left {
    right: auto;
    left: 60px;
  }
  .ltn__slide-item-6 .slide-title {
    font-size: 60px;
  }
  .ltn__slide-item.ltn__slide-item-10 {
    height: 495px;
  }
  .ltn__slider-11 .slide-item-img {
    top: 0;
    right: 0;
    transform: inherit;
  }
}
@media (max-width: 1199px) {
  .slide-title {
    font-size: 36px;
  }
  .ltn__slide-item {
    height: auto;
  }
  .liton-slide-item-inner {
    height: inherit;
  }
  .slide-item-info-inner {
    margin-bottom: 30px;
  }
  .ltn__slide-item-2 .slide-title {
    font-size: 50px;
  }
  .ltn__slide-item-2 .slide-brief {
    padding-left: 15px;
  }
  .ltn__slide-item-6 {
    padding-top: 140px;
  }
  .ltn__slide-item-7 {
    min-height: 550px;
    height: auto;
  }
  .ltn__slide-item-7 .slide-title {
    font-size: 60px;
  }
}
@media (max-width: 991px) {
  .slide-title {
    font-size: 26px;
  }
  .liton-slide-item-inner {
    height: inherit;
  }
  .slide-item-info-inner {
    margin-bottom: 30px;
  }
  .slick-slide-arrow-1 .slick-arrow {
    width: 40px;
    height: 40px;
    line-height: 38px;
    font-size: 16px;
  }
  .ltn__slide-item-2 .slide-title {
    font-size: 40px;
  }
  .ltn__slide-item-2 .slide-brief {
    padding-left: 15px;
  }
  .ltn__slide-item-2 .btn-wrapper {
    margin-top: 20px;
  }
  .ltn__slide-item-3 .slide-item-img {
    width: 100%;
    position: relative;
    height: auto;
    right: auto;
    bottom: auto;
  }
  .ltn__slide-item-3 .slide-item-img img {
    height: auto;
  }
  .ltn__slide-item-3 .text-right .slide-item-img {
    right: auto;
    left: auto;
  }
  .ltn__product-pointer > ul > li > ul {
    min-width: 280px;
  }
  .ltn__product-pointer > ul > li > ul {
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
  }
  .ltn__product-pointer > ul > li:hover ul {
    top: 130%;
  }
  .ltn__product-pointer .ltn__product-pointer-inner::before {
    left: 50%;
    top: -25px;
    transform: translateX(-50%) rotate(-90deg);
  }
  .slide-img-left .ltn__product-pointer .ltn__product-pointer-inner::before {
    left: 50%;
    transform: translateX(-50%) rotate(90deg);
  }
  .ltn__slide-item-5 .slide-item-img {
    display: none;
  }
  .ltn__slide-item-6 .slide-title {
    font-size: 40px;
  }
  .ltn__slide-item-7 {
    min-height: 400px;
  }
  .ltn__slide-item-7 .slide-title {
    font-size: 40px;
  }
  .ltn__slide-item-9 {
    height: 560px;
  }
  .ltn__slide-item-9 .slide-item-info {
    height: auto;
    margin: 30px;
  }
  .ltn__slide-item-9 .ltn__slide-item-inner {
    display: flex;
    justify-content: space-around;
  }
  .ltn__slide-item-9 .slide-item-info-inner::before,
  .ltn__slide-item-9 .slide-item-info-inner::after {
    display: none;
  }
  .ltn__slider-11-img-slide-arrow {
    right: 50%;
    transform: translate(50%);
  }
}
@media (max-width: 767px) {
  .liton-slide-item-inner {
    height: inherit;
  }
  .slide-item-info-inner {
    margin-bottom: 30px;
  }
  .slide-title br {
    display: none;
  }
  .slide-title {
    font-size: 24px;
  }
  .ltn__slide-item-2 {
    height: auto;
    padding-top: 300px;
  }
  .ltn__slide-item-2 .slide-title {
    font-size: 30px;
  }
  .ltn__slide-item-2 .slide-brief {
    padding-left: 15px;
  }
  .ltn__slide-item-3-normal {
    padding-top: 100px;
  }
  .ltn__product-pointer {
    display: none;
  }
  .ltn__slide-item-6 .slide-title {
    font-size: 30px;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ----------------------------------------------------
    Product Area
---------------------------------------------------- */
.ltn__product-item {
  position: relative;
  margin-bottom: 50px;
}

.product-img {
  position: relative;
  overflow: hidden;
}

.product-img img {
  position: relative;
  transition: all 3.5s ease 0s;
}

.product-img:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--ltn__primary-color);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}

.ltn__product-item:hover .product-img:before {
  opacity: 0.4;
  visibility: visible;
}

.ltn__product-item:hover .product-img::before {
  opacity: 0.4;
  visibility: visible;
}

.product-title {
  font-size: 16px;
  margin-bottom: 5px;
}

.product-ratting {
  margin-bottom: 5px;
}

.product-ratting ul {
  margin: 0;
  padding: 0;
}

.product-ratting li {
  display: inline-block;
  margin: 0 -2px;
  color: var(--ratings);
  font-size: 12px;
}

.product-hover-action {
  position: absolute;
  top: 60%;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}

.ltn__product-item:hover .product-hover-action {
  top: 50%;
  opacity: 1;
  visibility: visible;
}

.product-hover-action ul {
  margin: 0;
  padding: 0;
  display: inline-block;
  box-shadow: var(--ltn__box-shadow-3);
}

.product-hover-action li {
  height: 50px;
  width: 50px;
  line-height: 50px;
  font-size: 14px;
  text-align: center;
  float: left;
  margin-right: 0px;
  margin-top: 0;
  list-style: none;
  border-right: 1px solid var(--border-color-7);
}

.product-hover-action li:last-child {
  margin-right: 0;
  border-right: 0;
}

.product-hover-action li a {
  display: block;
  background-color: var(--white);
  font-weight: 700;
}

.product-hover-action li:hover a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.product-badge {
  position: absolute;
  top: 15px;
  right: 18px;
}

.product-badge ul {
  margin: 0;
  padding: 0;
}

.product-badge li {
  list-style: none;
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  padding: 3px 15px 0px;
  text-transform: uppercase;
  line-height: 25px;
}
.product-badge li:first-child {
  margin-top: 0;
}
.product-badge li::before {
  position: absolute;
  content: "";
  bottom: -8px;
  left: 0;
  border-left: 8px solid var(--ltn__secondary-color);
  width: 0;
  height: 0;
  border-bottom: 8px solid transparent;
  display: none;
}
.product-badge li .soldout-badge {
  background-color: var(--red-2);
}

.product-info {
  padding: 20px 0 0;
}

.product-price {
  color: var(--ltn__heading-color);
  font-weight: 600;
}

.product-price del {
  opacity: 0.6;
  margin-left: 5px;
  font-size: 80%;
}

.ltn__product-item .product-price {
  margin-bottom: 12px;
}

.product-action ul {
  margin: 10px 0 0;
  padding: 0;
}

.product-action li {
  display: inline-block;
  margin-top: 0;
}

.product-action li a {
  display: inline-block;
  padding: 3px 15px;
  border: 1px solid var(--ltn__heading-color);
  color: var(--ltn__heading-color);
  transition: all 0.3s ease 0s;
}

.product-action li:hover a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  border-color: var(--ltn__secondary-color);
}

.button-1 a {
  display: inline-block;
  padding: 5px 15px;
  background-color: var(--ltn__heading-color);
  color: var(--white);
  transition: all 0.3s ease 0s;
}

.button-1:hover a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.no-product-ratting .product-ratting {
  display: none;
}

/* product-item-2 */
.ltn__product-item-2 .product-img img {
  background-color: var(--section-bg-1);
}
.ltn__product-item-2 .product-price {
  font-size: 14px;
}
.ltn__product-item-2 .product-price del {
  opacity: 1;
  color: var(--red);
  font-size: 13px;
}
.ltn__product-item-2:hover .product-img img {
  transform: scale(1.1);
}

.ltn__product-item .add-to-cart {
  width: auto;
  text-transform: uppercase;
}
.ltn__product-item .add-to-cart a {
  padding: 0 15px;
}
.ltn__product-item .add-to-cart span {
  font-size: 12px;
  line-height: 1;
}

/* product-item-3 */
.ltn__product-item-3 {
  border: 2px solid;
  border-color: var(--border-color-8);
  transition: all 0.3s ease 0s;
}
.ltn__product-item-3 .product-img::before {
  display: none;
}
.ltn__product-item-3 .product-info {
  padding: 25px 30px 15px;
}
.ltn__product-item-3 .product-price {
  font-size: 14px;
  color: var(--ltn__secondary-color);
  font-weight: 700;
}
.ltn__product-item-3 .product-price del {
  font-size: 13px;
  opacity: 0.6;
}
.ltn__product-item-3 .product-info-brief {
  border-top: 2px solid;
  border-color: var(--border-color-8);
  margin-bottom: 15px;
  max-width: 400px;
}
.ltn__product-item-3 .product-info-brief ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}
.ltn__product-item-3 .product-info-brief ul li {
  list-style: none;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
}
.ltn__product-item-3 .product-info-brief ul li i {
  color: var(--ltn__secondary-color);
  margin-right: 5px;
}
.ltn__product-item-3:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__product-item-3:hover .product-hover-action {
  top: 70%;
}

/* product-item-4 */
.ltn__product-item-4 {
  box-shadow: var(--ltn__box-shadow-4);
  border: 1px solid;
  border-color: var(--border-color-13);
  background-color: var(--white);
}
.ltn__product-item-4 .product-img {
  position: relative;
}
.ltn__product-item-4 .product-img a {
  display: block;
}
.ltn__product-item-4 .product-img img {
  transition: all 0.5s ease 0s;
}
.ltn__product-item-4 .product-img-location-gallery {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 15px;
  margin: 0;
  background: var(--gradient-color-5);
}
.ltn__product-item-4 .product-img-location-gallery ul {
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}
.ltn__product-item-4 .product-img-location-gallery ul li {
  list-style: none;
  font-size: 14px;
  color: var(--white);
}
.ltn__product-item-4 .product-img-location-gallery .product-img-gallery {
  margin-left: 10px;
}
.ltn__product-item-4 .product-img-location-gallery .product-img-gallery ul li {
  display: inline-block;
  width: 42px;
  height: 30px;
  line-height: 30px;
  background-color: rgba(255, 255, 255, 0.3);
  margin-right: 5px;
  text-align: center;
}
.ltn__product-item-4 .product-img-location-gallery .product-img-gallery ul li a {
  display: block;
}
.ltn__product-item-4 .product-img-location-gallery .product-img-gallery ul li:last-child {
  margin-right: 0;
}
.ltn__product-item-4 .product-info {
  padding: 30px 30px 1px;
}
.ltn__product-item-4 .product-price {
  font-size: 18px;
  font-family: var(--ltn__heading-font);
  font-weight: 600;
  color: var(--ltn__secondary-color);
  margin-bottom: 5px;
}
.ltn__product-item-4 .product-price label {
  font-weight: 400;
  font-size: 14px;
}
.ltn__product-item-4 .product-title {
  font-size: 22px;
  margin-bottom: 15px;
  font-weight: 600;
}
.ltn__product-item-4 .product-description p {
  font-size: 14px;
  margin-bottom: 15px;
}
.ltn__product-item-4 .product-info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid;
  border-color: var(--border-color-1);
  padding: 20px 30px 30px;
}
.ltn__product-item-4 .product-hover-action {
  position: relative;
  opacity: 1;
  visibility: visible;
  transform: inherit;
  line-height: 1;
}
.ltn__product-item-4 .product-hover-action ul {
  box-shadow: none;
}
.ltn__product-item-4 .product-hover-action ul li {
  margin-right: 8px;
  height: 36px;
  width: 36px;
  line-height: 42px;
  border-right: 0;
  font-size: 16px;
  background-color: var(--section-bg-1);
  transition: all 0.3s ease 0s;
}
.ltn__product-item-4 .product-hover-action ul li a {
  background-color: transparent;
}
.ltn__product-item-4 .product-hover-action ul li:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__product-item-4:hover .product-img img {
  transform: scale(1.1);
}
.ltn__product-item-4:hover .product-img::before {
  display: none;
}

.real-estate-agent {
  display: flex;
}
.real-estate-agent .agent-img {
  max-width: 40px;
  margin-right: 12px;
}
.real-estate-agent .agent-img img {
  border-radius: 100%;
}
.real-estate-agent .agent-brief h6 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 600;
}
.real-estate-agent .agent-brief small {
  font-size: 12px;
}

/* product-item-5 */
.ltn__product-item-5 {
  margin-top: 0;
}
.ltn__product-item-5 .product-img {
  margin-top: 0;
}
.ltn__product-item-5 .product-img a {
  display: block;
}
.ltn__product-item-5 .product-info {
  margin-top: 0;
}
.ltn__product-item-5 .product-info-bottom {
  padding: 20px 30px 15px;
}
.ltn__product-item-5 .product-badge {
  position: inherit;
  margin-bottom: 15px;
}
.ltn__product-item-5 .product-badge li {
  font-size: 16px;
  background-color: transparent;
  color: var(--ltn__secondary-color);
  padding: 0;
}
.ltn__product-item-5 .product-img-location ul {
  padding: 0;
  margin-bottom: 0;
}
.ltn__product-item-5 .product-img-location ul li {
  list-style: none;
  font-size: 14px;
}
.ltn__product-item-5 .product-img-location ul li i {
  color: var(--ltn__secondary-color);
  padding-left: 0;
}
.ltn__product-item-5 .ltn__plot-brief {
  padding: 0;
  margin-bottom: 20px;
}
.ltn__product-item-5 .ltn__plot-brief li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
}
.ltn__product-item-5 .ltn__plot-brief li:last-child {
  margin-right: 0;
}
.ltn__product-item-5 .ltn__plot-brief li span {
  font-weight: 700;
}
.ltn__product-item-5 .real-estate-agent {
  position: absolute;
  top: 20px;
  right: 20px;
  transition: all 0.3s ease 0s;
}
.ltn__product-item-5 .real-estate-agent .agent-img {
  max-width: 50px;
}
.ltn__product-item-5 .real-estate-agent .agent-img img {
  border: 3px solid;
  border-color: var(--border-color-1);
}
.ltn__product-item-5 .product-hover-action {
  text-align: left;
  margin-bottom: 25px;
}

.ltn__product-list-view .ltn__product-item-5 {
  padding: 30px 30px 30px;
}
.ltn__product-list-view .ltn__product-item-5 .real-estate-agent {
  position: inherit;
  margin-top: 15px;
}
.ltn__product-list-view .ltn__product-item-5 .product-info-bottom {
  padding: 0px 0px 0px 30px;
  border: 0;
}
.ltn__product-list-view .ltn__product-item-5 .product-hover-action {
  margin-bottom: 0;
}
.ltn__product-list-view .ltn__product-item-5 .ltn__plot-brief {
  margin-bottom: 5px;
}
.ltn__product-list-view .ltn__product-item-5 .product-badge-price {
  display: flex;
  justify-content: space-between;
}

/* ----------------------------------------------------
    Modal Area
---------------------------------------------------- */
.modal-dialog {
  margin-top: 150px;
}

.modal-content {
  border-radius: 0;
}

.modal-header {
  padding: 0;
  border: 0;
}
.modal-header .close {
  position: absolute;
  height: 40px;
  width: 40px;
  line-height: 40px;
  padding: 0;
  right: 16px;
  left: auto;
  top: 16px;
  opacity: 1;
  z-index: 1;
  transition: all 0.3s ease 0s;
}
.modal-header .close span {
  display: block;
  font-size: 25px;
}
.modal-header .close:not(:disabled):not(.disabled):focus, .modal-header .close:not(:disabled):not(.disabled):hover, .modal-header .close:hover {
  opacity: 1;
}

@media (min-width: 992px) {
  .modal-lg {
    max-width: 980px;
  }
}
.modal-product-info {
  padding-left: 25px;
}

.modal-product-info h3 {
  font-size: 24px;
  margin-bottom: 10px;
}

.modal-product-info hr {
  margin-top: 20px;
  margin-bottom: 20px;
}

.modal-product-info .product-price {
  font-size: 50px;
  margin-bottom: 10px;
  color: var(--ltn__secondary-color);
  line-height: 1.2;
  font-weight: 600;
}

.modal-product-meta > ul {
  margin: 15px 0;
  padding: 20px 0;
  border-bottom: 1px solid var(--border-color-12);
  border-top: 1px solid var(--border-color-12);
}

.modal-product-meta > ul > li {
  list-style: none;
  font-size: 14px;
  margin-top: 10px;
}
.modal-product-meta > ul > li:first-child {
  margin-top: 0;
}

.modal-product-meta li strong {
  color: var(--ltn__heading-color);
  margin-right: 5px;
  font-weight: 600;
  min-width: 100px;
  display: inline-block;
}

.modal-product-quantity input {
  border: 1px solid #e5e5e5;
  float: left;
  height: 45px;
  text-align: center;
  width: 80px;
  margin-right: 20px;
}

.modal-btn {
  margin-top: 15px;
  border-top: 1px solid #f1f1f1;
  text-align: right;
}

.modal-btn a {
  font-size: 14px;
  color: var(--ltn__heading-color);
  padding: 5px 10px;
}

.ltn__modal-area .modal-btn {
  border: 0;
}

.modal-body {
  padding: 30px;
}

.ltn__add-to-cart-modal-area .modal-body {
  padding: 30px;
}
.ltn__add-to-cart-modal-area .modal-product-img {
  float: left;
  max-width: 125px;
  margin-right: 20px;
}
.ltn__add-to-cart-modal-area .modal-product-info {
  overflow: hidden;
}
.ltn__add-to-cart-modal-area .added-cart i {
  color: var(--green);
}
.ltn__add-to-cart-modal-area .btn-wrapper {
  margin-top: 20px;
}
.ltn__add-to-cart-modal-area .btn-wrapper .btn {
  padding: 5px 20px;
  margin-right: 10px;
}
.ltn__add-to-cart-modal-area .additional-info {
  border-top: 1px solid var(--border-color-1);
  text-align: center;
  padding-top: 30px;
  margin-top: 40px;
}

.modal-backdrop.show {
  opacity: 0.7;
}

/* ----------------------------------------------------
    Product Tab
---------------------------------------------------- */
.ltn__tab-menu {
  margin-bottom: 50px;
}

.ltn__tab-menu .nav {
  display: inline-block;
}

.ltn__gallery-filter-menu button,
.ltn__tab-menu a {
  display: inline-block;
  padding: 15px 40px;
  margin-right: 5px;
  margin-bottom: 10px;
  color: var(--ltn__heading-color);
  background-color: var(--section-bg-1);
  font-weight: 700;
}
.ltn__gallery-filter-menu button:last-child,
.ltn__tab-menu a:last-child {
  margin-right: 0;
}
.ltn__gallery-filter-menu button i,
.ltn__tab-menu a i {
  margin-right: 10px;
}

.ltn__gallery-filter-menu .active,
.ltn__tab-menu a.active {
  color: var(--white);
  background-color: var(--ltn__primary-color);
  border-color: var(--ltn__primary-color);
}

.ltn__tab-menu-top-left {
  position: absolute;
  left: 15px;
  top: 0;
}

.ltn__tab-menu-top-right {
  position: absolute;
  right: 15px;
  top: 0;
}

.ltn__gallery-filter-menu.text-uppercase button {
  text-transform: uppercase;
}

.ltn__tab-menu-2 a {
  background-color: transparent;
  border-bottom: 2px solid transparent;
  position: relative;
}
.ltn__tab-menu-2 a.active {
  color: var(--ltn__secondary-color);
  background-color: transparent;
  border-color: var(--ltn__secondary-color);
}
.ltn__tab-menu-2 a::before {
  position: absolute;
  content: "";
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  width: 2px;
  background-color: var(--ltn__color-1);
  opacity: 0.4;
}
.ltn__tab-menu-2 a:last-child::before {
  display: none;
}

.ltn__tab-menu-3 {
  margin-top: 0;
}
.ltn__tab-menu-3 a {
  background-color: transparent;
  border-bottom: 2px solid transparent;
  padding: 1px;
  margin-right: 50px;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  position: relative;
}
.ltn__tab-menu-3 a.active {
  color: var(--ltn__secondary-color);
  background-color: transparent;
  border-color: var(--ltn__secondary-color);
}
.ltn__tab-menu-3 a.active::before {
  background-color: var(--ltn__secondary-color);
  border: 3px solid var(--white);
}
.ltn__tab-menu-3 a:last-child {
  margin-right: 0;
}
.ltn__tab-menu-3 a::before {
  position: absolute;
  content: "";
  right: 45%;
  top: 100%;
  transform: translateY(-40%);
  height: 10px;
  width: 10px;
  background-color: transparent;
  opacity: 1;
  border: 3px solid transparent;
  border-radius: 100%;
}

.ltn__tab-menu-4 a {
  background-color: transparent;
  padding: 0;
  border: 7px solid;
  border-color: var(--white);
}
.ltn__tab-menu-4 a img {
  max-width: 120px;
}
.ltn__tab-menu-4 a.active {
  color: var(--ltn__secondary-color);
  background-color: transparent;
  border-color: var(--white);
}
.ltn__tab-menu-4 a.active::before {
  display: none;
}
.ltn__tab-menu-4 a.active img {
  opacity: 0.6;
}

@media (max-width: 1200px) {
  .ltn__tab-menu-3 a {
    margin-right: 30px;
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .ltn__gallery-filter-menu button,
  .ltn__tab-menu a {
    padding: 15px 25px;
    font-size: 14px;
  }
  .ltn__tab-menu-top-right {
    position: initial;
  }
  .ltn__tab-menu-3 {
    margin-top: 0;
  }
  .ltn__tab-menu-3 a {
    padding: 1px;
    margin-right: 20px;
  }
  .ltn__tab-menu-4 a {
    padding: 0;
  }
  .ltn__tab-menu-4 a.active {
    padding: 0;
  }
}
/* ----------------------------------------------------
    Product Details
---------------------------------------------------- */
.ltn__small-product-item {
  background-color: var(--white);
  display: flex;
  padding: 30px 25px;
  border: 2px solid;
  border-color: var(--border-color-1);
  margin-bottom: 30px;
  transition: all 0.3s ease 0s;
}
.ltn__small-product-item:hover {
  box-shadow: var(--ltn__box-shadow-1);
  border-color: transparent;
}
.ltn__small-product-item .product-price {
  color: var(--ltn__secondary-color);
}

.small-product-item-img {
  max-width: 90px;
  margin-right: 20px;
}

/* ----------------------------------------------------
    Product Details
---------------------------------------------------- */
.product-meta-date input[type=date] {
  border: 1px solid #ddd;
  height: 63px;
  padding: 0 15px;
  line-height: 50px;
}

.product-meta-date input[type=date]::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: pink;
  line-height: 50px;
}

.product-meta-date input[type=date]::-moz-placeholder { /* Firefox 19+ */
  color: pink;
  line-height: 50px;
}

.product-meta-date input[type=date]:-ms-input-placeholder { /* IE 10+ */
  color: pink;
  line-height: 50px;
}

.product-meta-date input[type=date]:-moz-placeholder { /* Firefox 18- */
  color: pink;
  line-height: 50px;
}

/* ltn__shop-details-img-gallery */
.ltn__shop-details-img-gallery {
  margin-bottom: 35px;
}
.ltn__shop-details-img-gallery img {
  background-color: var(--white-8);
}

.ltn__shop-details-small-img {
  margin-top: 20px;
  margin-left: -5px;
  margin-right: -5px;
}
.ltn__shop-details-small-img .single-small-img {
  padding: 0 5px;
}
.ltn__shop-details-small-img .single-small-img.slick-current img {
  border: 1px solid var(--ltn__secondary-color);
  margin-bottom: 10px;
}

.ltn__shop-details-small-img.slick-arrow-2 {
  margin-bottom: 35px;
}
.ltn__shop-details-small-img.slick-arrow-2 .slick-arrow {
  left: 5px;
  bottom: -35px;
}
.ltn__shop-details-small-img.slick-arrow-2 .slick-next {
  left: 45px;
}

/* ltn__shop-details-content-wrap */
.ltn__shop-details-content-wrap {
  padding: 50px 50px 40px;
}

/* ltn__shop-details-tab-area */
.ltn__shop-details-tab-menu .nav {
  display: flex;
  flex-wrap: wrap;
}
.ltn__shop-details-tab-menu .nav a {
  background-color: var(--ltn__primary-color);
  color: var(--white);
  padding: 20px 20px;
  font-size: 16px;
  flex: 1 0 auto;
  text-align: center;
  font-weight: 700;
}
.ltn__shop-details-tab-menu .nav a.active {
  background-color: var(--ltn__secondary-color);
}

.ltn__shop-details-tab-content-inner {
  border: 1px solid #e5e5e5;
  padding: 50px 50px 30px;
  background-color: var(--section-bg-1);
}
.ltn__shop-details-tab-content-inner .ltn__comment-reply-area form {
  padding: 0;
}

.add-a-review {
  display: flex;
  align-items: center;
}
.add-a-review h6 {
  margin-bottom: 0;
  margin-right: 15px;
}

.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu {
  border-bottom: 2px solid var(--border-color-1);
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu .nav {
  display: flex;
  flex-wrap: wrap;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu .nav a {
  background-color: transparent;
  color: var(--ltn__paragraph-color);
  padding: 20px 0px;
  margin-right: 50px;
  flex: inherit;
  text-align: left;
  position: relative;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu .nav a::before {
  position: absolute;
  content: "";
  bottom: -2px;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: transparent;
  transition: all 0.3s ease 0s;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu .nav a.active {
  color: var(--ltn__secondary-color);
  background-color: transparent;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-menu .nav a.active::before {
  background-color: var(--ltn__secondary-color);
  width: 100%;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-content-inner {
  border: 0;
  padding: 30px 0px 0px;
  background-color: transparent;
}
.ltn__shop-details-tab-inner-2 .ltn__shop-details-tab-content-inner .ltn__comment-reply-area form {
  padding: 30px;
}

/* product-details-menu-1 */
.ltn__product-details-menu-1 ul li a {
  position: relative;
  margin-right: 10px;
}
.ltn__product-details-menu-1 ul li a::before {
  position: absolute;
  content: ",";
  right: -5px;
}
.ltn__product-details-menu-1 ul li a:last-child::before {
  display: none;
}
.ltn__product-details-menu-1 ul li strong {
  font-weight: 400;
}
.ltn__product-details-menu-1 ul li span {
  font-weight: 600;
}
.ltn__product-details-menu-1 .ltn__color-widget ul li a {
  width: 15px;
  height: 15px;
}
.ltn__product-details-menu-1 .ltn__tagcloud-widget ul li {
  margin: 0;
}
.ltn__product-details-menu-1 .ltn__tagcloud-widget ul li a {
  padding: 3px 10px 1px;
}

/* product-details-menu-2 */
.ltn__product-details-menu-2 ul {
  padding: 0;
  margin: 0;
}
.ltn__product-details-menu-2 ul li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
}
.ltn__product-details-menu-2 ul li:last-child {
  margin-right: 0;
}

/* product-details-menu-3 */
.ltn__product-details-menu-3 ul {
  padding: 0;
  margin: 0;
}
.ltn__product-details-menu-3 ul li {
  list-style: none;
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  font-weight: 600;
}
.ltn__product-details-menu-3 ul li:last-child {
  margin-right: 0;
}

.property-detail-info-list ul {
  padding: 30px 50px 40px;
  margin: 0;
  float: left;
  border-right: 1px solid;
  border-color: var(--border-color-7);
}
.property-detail-info-list ul:last-child {
  border-right: none;
}
.property-detail-info-list ul li {
  display: block;
}
.property-detail-info-list ul li label {
  margin-right: 5px;
  font-weight: 600;
  min-width: 110px;
  display: inline-block;
}
.property-detail-info-list ul li span {
  font-weight: 600;
  color: var(--ltn__heading-color);
}

.property-detail-feature-list {
  margin-top: 0;
}
.property-detail-feature-list ul {
  margin: 0;
  padding: 0;
}
.property-detail-feature-list ul li {
  display: inline-block;
  min-width: 170px;
  margin-right: 19px;
  margin-bottom: 15px;
}
.property-detail-feature-list .property-detail-feature-list-item {
  display: flex;
  align-items: center;
  line-height: 1;
}
.property-detail-feature-list .property-detail-feature-list-item i {
  margin-right: 12px;
  width: 40px;
  min-width: 40px;
  height: 40px;
  line-height: 49px;
  background-color: var(--section-bg-5);
  text-align: center;
  font-size: 22px;
  color: var(--ltn__secondary-color);
}
.property-detail-feature-list .property-detail-feature-list-item h6 {
  margin-top: 0;
  margin-bottom: 6px;
  font-size: 14px;
  font-family: var(--ltn__heading-font);
  font-weight: 500;
}

.property-details-google-map {
  height: 360px;
}

.product-details-apartments-plan .apartments-plan-info {
  padding: 0;
}

.product-details-apartments-info-list {
  padding: 20px 40px;
}

.ltn__page-details-inner .ltn__product-details-review-inner {
  margin-top: 0;
}
.ltn__page-details-inner .ltn__product-details-review-inner h1,
.ltn__page-details-inner .ltn__product-details-review-inner h2,
.ltn__page-details-inner .ltn__product-details-review-inner h3,
.ltn__page-details-inner .ltn__product-details-review-inner h4,
.ltn__page-details-inner .ltn__product-details-review-inner h5,
.ltn__page-details-inner .ltn__product-details-review-inner h6,
.ltn__page-details-inner .ltn__product-details-review-inner p {
  margin-top: 0;
}

@media (max-width: 767px) {
  .property-detail-info-list ul {
    padding: 20px 30px 20px;
    float: none;
    border: none;
  }
}
/* ----------------------------------------------------
    Product Options
---------------------------------------------------- */
.nice-select .option {
  margin-top: 0;
  white-space: normal;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 1.8;
}

.nice-select .list {
  min-width: 100%;
}

.ltn__shop-options {
  margin-bottom: 50px;
}
.ltn__shop-options > ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  margin: 0;
  padding: 0;
}
.ltn__shop-options > ul > li {
  list-style: none;
  margin-top: 0;
  line-height: 50px;
  margin-right: 30px;
}
.ltn__shop-options > ul > li:last-child {
  margin-right: 0;
}
.ltn__shop-options .short-by .nice-select {
  border-radius: 0;
  border: 2px solid #ededed;
  height: 50px;
  line-height: 46px;
  min-width: 190px;
}
.ltn__shop-options .short-by .nice-select .option {
  width: 100%;
  padding-left: 10px;
  padding-right: 5px;
}
.ltn__shop-options .short-by .nice-select .current {
  font-weight: 700;
}

.ltn__grid-list-tab-menu a {
  font-size: 30px;
  margin-right: 20px;
}

.ltn__grid-list-tab-menu a:last-child {
  margin-right: 0px;
}

.ltn__grid-list-tab-menu .active {
  color: var(--ltn__secondary-color);
}

.showing-product-number span {
  font-weight: 500;
  font-size: 16px;
  font-family: var(--ltn__heading-font);
}

.ltn__product-list-view .product-title {
  font-size: 22px;
  margin-bottom: 10px;
}

.ltn__product-list-view .ltn__product-item:after {
  display: block;
  clear: both;
  content: "";
}

.ltn__product-list-view .ltn__product-item .product-img {
  max-width: 40%;
  float: left;
}

.ltn__product-list-view .ltn__product-item .product-info {
  overflow: hidden;
  padding: 0 0 0 30px;
}
.ltn__product-list-view .ltn__product-item-3 .product-info {
  overflow: hidden;
  padding: 25px 25px 20px 30px;
}

.ltn__product-list-view .product-hover-action {
  position: inherit;
  transform: inherit;
  text-align: left;
  opacity: 1;
  visibility: visible;
  margin-top: 15px;
}

/* Bootstrap Tab with Slider Issue Fix Start */
.tab-content {
  width: 100%;
}

.tab-content .tab-pane {
  display: block;
  height: 0;
  max-width: 100%;
  visibility: hidden;
  overflow: hidden;
  opacity: 0;
}

.tab-content .tab-pane.active {
  height: auto;
  visibility: visible;
  opacity: 1;
  overflow: visible;
}

/* Bootstrap Tab with Slider Issue Fix End */
@media (max-width: 1400px) {
  .shop-details-info .product-price {
    font-size: 36px;
  }
  .shop-details-info .cart-plus-minus {
    width: 130px;
  }
  .shop-details-info .ltn__product-details-menu-2 .btn {
    padding: 17px 15px;
  }
}
@media (max-width: 991px) {
  .ltn__product-item-3 .product-info {
    padding: 25px 15px 15px;
  }
  .ltn__product-item-3 .product-price {
    font-size: 16px;
  }
  .ltn__product-item-3 .product-price del {
    font-size: 14px;
  }
  .ltn__shop-details-img-gallery {
    margin-bottom: 75px;
  }
  .ltn__product-item-4 .product-title {
    font-size: 20px;
  }
  .ltn__product-item-4 .product-info {
    padding: 30px 20px 1px;
  }
  .ltn__product-item-4 .product-img-location-gallery {
    padding: 0 15px 15px;
    flex-flow: wrap-reverse;
  }
  .ltn__product-item-4 .product-img-location-gallery ul li {
    font-size: 13px;
    margin-top: 5px;
  }
  .ltn__product-item-4 .product-img-location-gallery .product-img-gallery {
    margin-left: 0;
  }
  .ltn__product-item-4 .product-img-location-gallery .product-img-gallery ul li {
    width: inherit;
    background-color: transparent;
    margin-top: 0;
  }
  .ltn__product-item-4 .product-description p br {
    display: none;
  }
  .ltn__product-item-4 .product-info-bottom {
    padding: 20px 20px 20px;
    flex-flow: wrap-reverse;
  }
  .ltn__product-item-4 .real-estate-agent {
    margin-top: 20px;
  }
  .slick-slide .ltn__product-item-4 {
    box-shadow: none;
  }
}
@media (max-width: 767px) {
  .ltn__shop-options > ul {
    align-items: flex-start;
    flex-flow: column;
  }
  .ltn__shop-options ul li {
    margin: 5px 0;
  }
  .showing-product-number span {
    font-size: 16px;
  }
  .ltn__product-list-view .ltn__product-item .product-img {
    max-width: 100%;
  }
  .ltn__product-list-view .ltn__product-item .product-info {
    padding: 25px 0 0 1px;
  }
  .ltn__product-list-view .ltn__product-item-3 .product-info {
    padding: 25px 25px 20px 30px;
  }
  .modal-product-info h3 {
    font-size: 22px;
  }
  .modal-product-info .product-price {
    font-size: 34px;
  }
  .ltn__shop-details-tab-menu .nav a {
    padding: 15px 15px;
    font-size: 14px;
  }
  .ltn__shop-details-tab-content-inner {
    padding: 50px 20px 30px;
  }
  .ltn__product-item-4 .product-title {
    font-size: 18px;
  }
  .ltn__product-list-view .ltn__product-item-5 .product-info-bottom {
    padding: 0px 0px 0px 0px;
    border: 0;
  }
}
@media (max-width: 576px) {
  .product-hover-action li {
    height: 35px;
    width: 35px;
    line-height: 35px;
    font-size: 13px;
  }
  .product-badge li {
    font-size: 12px;
    padding: 1px 10px;
    line-height: 20px;
  }
  .product-badge li::before {
    bottom: -6px;
  }
  .ltn__product-item-3 .product-title {
    font-size: 14px;
  }
  .ltn__product-item-3 .product-info {
    padding-left: 5px;
    padding-right: 5px;
  }
  .ltn__product-item-3 .product-price {
    font-size: 14px;
  }
  .ltn__product-item-3 .product-price del {
    font-size: 13px;
  }
  .ltn__product-item-3 .product-info-brief ul li {
    font-size: 12px;
  }
  .ltn__product-item-2 .product-title {
    font-size: 14px;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ----------------------------------------------
  Gallery Area
---------------------------------------------- */
.ltn__gallery-item {
  margin-bottom: 30px;
}
.ltn__gallery-item:hover .ltn__gallery-item-img::before {
  opacity: 0.8;
  visibility: visible;
}
.ltn__gallery-item:hover .ltn__gallery-item-img img {
  transform: scale(1.1);
}
.ltn__gallery-item:hover .ltn__gallery-action-icon {
  top: 50%;
  opacity: 1;
  visibility: visible;
}

.ltn__gallery-item-inner {
  position: relative;
  overflow: hidden;
}
.ltn__gallery-item-inner h4 {
  margin-bottom: 5px;
}
.ltn__gallery-item-inner p {
  margin-bottom: 0;
  font-size: 14px;
}

.ltn__gallery-item-img {
  position: relative;
  overflow: hidden;
}
.ltn__gallery-item-img::before {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background-color: var(--ltn__primary-color);
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
  z-index: 1;
}
.ltn__gallery-item-img img {
  transition: all 3.5s ease 0s;
}

.ltn__gallery-action-icon {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease 0s;
  z-index: 2;
}
.ltn__gallery-action-icon i {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background-color: var(--white);
  color: var(--ltn__primary-color);
  border-radius: 100%;
  margin: 3px;
  transition: all 0.3s ease 0s;
}
.ltn__gallery-action-icon i:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.ltn__gallery-item-info {
  padding: 25px 30px;
  position: relative;
  z-index: 2;
}

/* Gallery Style 1 */
.ltn__gallery-style-1 .ltn__gallery-item-info {
  border: 1px solid var(--border-color-1);
  border: 0;
}

/* Gallery Style 2 */
.ltn__gallery-style-2 .ltn__gallery-item-info {
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  background: var(--gradient-color-3);
  transition: all 0.3s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__gallery-style-2 h4, .ltn__gallery-style-2 p {
  color: var(--white);
}
.ltn__gallery-style-2 .ltn__gallery-item:hover .ltn__gallery-item-info {
  bottom: 0px;
  opacity: 1;
  visibility: visible;
}
.ltn__gallery-style-2 .ltn__gallery-item:hover .ltn__gallery-action-icon {
  top: 35%;
}

.ltn__gallery-info-hide .ltn__gallery-item-info {
  display: none;
}
.ltn__gallery-info-hide .ltn__gallery-item:hover .ltn__gallery-action-icon {
  top: 50%;
}

/* Lightcase Default CSS */
.lightcase-error {
  color: var(--white);
}

#lightcase-info {
  color: var(--ltn__color-1);
}

#lightcase-caption {
  color: var(--white);
}

/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ============================================================
>>> TABLE OF CONTENTS:
===============================================================
# Common CSS
# Section title
# Category Area
# Feature Area 
# Countdown Area
# Blog Area
# Blog Details
# Service Details
# Pagination
# Testimonial
# Banner Area
# Team Area
# CounterUp Area
# Contact Form Area
# Cart Table Area
# Cart plus minus
# Product Details
# Shoping Cart
# Custom Content
# Newsletter
# Faq Area
# 404 Area
# Coming Soon Area
# Screenshot Area
# Pricing List Area
# Checkbox
# Body Sidebar Icons
# About Us Area
# Why Choose Us Area
# Service Area
# Call To Action
# Elements Area
# Service Form 
# Get A Quote Form
# Car Dealer Form
# Video Area
# Brand Logo
# Progress Bar 
# Our Journey Area
# Google Map Locations Area
# Team Details
# Our History Area
# Appointment Form Area
# Checkout Page
# Myaccount Page
# Time Schedule Area

============================================================= */
/* ----------------------------------------------------
    Common CSS
---------------------------------------------------- */
.ltn__social-media ul {
  margin: 0;
  padding: 0;
}
.ltn__social-media ul li {
  list-style: none;
  display: inline-block;
  margin: 0 15px 0 0;
}
.ltn__social-media ul li:last-child {
  margin: 0;
}

.ltn__social-media-2 ul {
  margin: 0;
  padding: 0;
}
.ltn__social-media-2 ul li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
}
.ltn__social-media-2 ul li a {
  background-color: var(--section-bg-1);
  color: var(--ltn__paragraph-color);
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.ltn__social-media-2 ul li a i {
  color: inherit;
}
.ltn__social-media-2 ul li:last-child {
  margin-right: 0;
}
.ltn__social-media-2 ul li:hover a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.ltn__social-media-3 ul {
  margin: 0;
  padding: 0;
}
.ltn__social-media-3 ul li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
}
.ltn__social-media-3 ul li a {
  background-color: var(--white);
  color: var(--ltn__paragraph-color);
  border: 2px solid var(--border-color-11);
  display: block;
  width: 50px;
  height: 50px;
  line-height: 46px;
  text-align: center;
}
.ltn__social-media-3 ul li a i {
  color: inherit;
}
.ltn__social-media-3 ul li:last-child {
  margin-right: 0;
}
.ltn__social-media-3 ul li:hover a {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white);
}

.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-quote {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-8 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-9 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-10 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-11 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-12 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-13 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-14 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-15 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-16 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-17 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-18 {
  height: -moz-fit-content;
  height: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-image-19 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-20 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-21 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-22 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-23 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-24 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-25 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-26 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-27 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-28 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-image-top {
  background-size: auto;
  background-position: top center;
  background-repeat: no-repeat;
}

.bg-image-right-before {
  position: relative;
}
.bg-image-right-before::before {
  position: absolute;
  content: "";
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  height: 100%;
  width: 48%;
  left: auto;
  right: 0;
  top: 0;
}

.bg-image-left-before {
  position: relative;
}
.bg-image-left-before::before {
  position: absolute;
  content: "";
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  height: 100%;
  width: 48%;
  left: 0;
  right: auto;
  top: 0;
}

.nice-select .option {
  font-weight: 400;
}

/* Responsive Device under :991px. */
@media (max-width: 991px) {
  .bg-image-top {
    background-size: inherit;
  }
  .bg-image-right-before::before,
  .bg-image-left-before::before {
    display: none;
  }
}
.ltn__social-media-4 ul {
  margin: 0;
  padding: 0;
}
.ltn__social-media-4 ul li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
}
.ltn__social-media-4 ul li a {
  background-color: var(--ltn__primary-color-3);
  color: var(--white);
  display: block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 100%;
}
.ltn__social-media-4 ul li:last-child {
  margin-right: 0;
}
.ltn__social-media-4 ul li:hover a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

/* ----------------------------------------
  Section title
---------------------------------------- */
.section-title-area {
  margin-bottom: 50px;
}
.section-title-area p {
  margin-bottom: 0;
  max-width: 600px;
}
.section-title-area p + p {
  margin-top: 15px;
}
.section-title-area.text-right p {
  margin-left: auto;
}
.section-title-area.text-center p {
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.3;
}
.section-title span {
  color: var(--ltn__secondary-color);
}
.section-title p {
  font-size: 16px;
  line-height: 1.8;
  color: var(--ltn__paragraph-color);
  margin-top: 20px;
}
.section-title.white .section-title {
  color: var(--white);
}
.section-title.white p {
  color: rgba(var(--white), 0.7);
}

/* ltn__separate-line */
.ltn__separate-line {
  position: relative;
  display: inline-block;
  min-width: 200px;
  margin-bottom: 3px;
  text-align: center !important;
}
.ltn__separate-line::before {
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgb(242, 139, 194) 0%, rgb(216, 177, 242) 50%);
}
.ltn__separate-line .separate-icon {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 0 15px;
}
.ltn__separate-line i {
  transform: rotate(45deg);
  margin: 0 -4px;
  color: var(--ltn__secondary-color);
}

/* Section Title 2 */
.ltn__section-title-2 {
  margin-bottom: 40px;
}
.ltn__section-title-2 .section-subtitle {
  margin-top: 0;
}
.ltn__section-title-2 .section-title {
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 15px;
  line-height: 1.3;
}
.ltn__section-title-2 p {
  padding: 0 0 0 30px;
  border-width: 0 0 0 2px;
  border-style: solid;
  border-color: var(--ltn__secondary-color);
  max-width: 450px;
}
.ltn__section-title-2.text-right p {
  padding: 0 30px 0 0;
  border-width: 0 2px 0 0;
  margin-left: auto;
}
.ltn__section-title-2.text-center p {
  padding: 0 0 0 30px;
  border-width: 0 0 0 2px;
  margin-left: auto;
  margin-right: auto;
  text-align: left !important;
}

/* Section Title 3 */
.section-title-style-3 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.section-title-style-3 .section-brief-in p {
  padding: 0 30px 0 0;
  border-width: 0 2px 0 0;
  margin-left: auto;
  margin-right: 30px;
  text-align: right;
}

/* title-2 */
.title-2 {
  margin-bottom: 30px;
  font-size: 22px;
  font-weight: 600;
  border-left: 2px solid;
  border-color: var(--ltn__secondary-color);
  padding-left: 10px;
}

.section-subtitle {
  font-weight: 600;
  font-family: var(--ltn__body-font);
}

.section-subtitle-2 {
  display: inline-block;
  padding: 5px 20px;
  border-radius: 25px;
  position: relative;
}
.section-subtitle-2::before {
  position: absolute;
  content: "";
  background-color: var(--ltn__secondary-color);
  width: 100%;
  height: 100%;
  top: 50%;
  right: 50%;
  transform: translateY(-50%) translateX(50%);
  border-radius: 25px;
  opacity: 0.1;
}

@media (max-width: 1599px) {
  .ltn__section-title-2 .section-title {
    font-size: 60px;
  }
}
@media (max-width: 1399px) {
  .ltn__section-title-2 .section-title {
    font-size: 56px;
  }
  .section-title-style-3 .section-title {
    min-width: 320px;
  }
}
@media (max-width: 1199px) {
  .section-title {
    font-size: 30px;
  }
  .ltn__section-title-2 .section-title {
    font-size: 50px;
  }
}
@media (max-width: 991px) {
  .section-title {
    font-size: 26px;
  }
  .ltn__section-title-2 .section-title {
    font-size: 40px;
  }
  .ltn__section-title-2 p {
    padding: 0 0 0 15px;
  }
}
@media (max-width: 767px) {
  .section-title {
    font-size: 30px;
  }
  .ltn__section-title-2 .section-title {
    font-size: 30px;
  }
  .ltn__section-title-2 p {
    padding: 0 0 0 15px;
  }
  .section-title-style-3 {
    display: block;
  }
  .section-title-style-3 .section-title {
    min-width: 100%;
  }
  .section-title-style-3 .section-brief-in p {
    padding: 0 0px 0 15px;
    border-width: 0 0px 0 2px;
    margin-left: 0;
    margin-right: 0;
    text-align: left;
    margin-bottom: 15px;
  }
  .title-2 {
    font-size: 22px;
  }
}
@media (max-width: 575px) {
  .section-title {
    font-size: 24px;
  }
  .ltn__section-title-2 .section-title {
    font-size: 24px;
  }
}
/* ----------------------------------------------------
    Category Area
---------------------------------------------------- */
.ltn__category-item {
  margin-top: 2px;
  margin-bottom: 30px;
  transition: all 0.3s ease 0s;
  border: 1px solid var(--border-color-7);
  background-color: var(--white);
}

.ltn__category-item-img {
  transition: all 0.3s ease 0s;
}

.ltn__category-item-name {
  padding: 15px 20px 5px;
}

.ltn__category-item:hover {
  box-shadow: var(--ltn__box-shadow-3);
}

/* ltn__category-item-2 */
.ltn__category-item-2 {
  padding: 20px 15px 15px;
}
.ltn__category-item-2 .ltn__category-item-img {
  float: left;
  width: 35%;
}
.ltn__category-item-2 .ltn__category-item-name {
  overflow: hidden;
}
.ltn__category-item-2 .ltn__category-item-name ul {
  padding: 0;
  margin: 0;
}
.ltn__category-item-2 .ltn__category-item-name ul li {
  list-style: circle;
  margin-top: 5px;
  font-size: 14px;
}
.ltn__category-item-2 .ltn__category-item-name ul li a {
  display: block;
}
.ltn__category-item-2 h4 {
  margin-bottom: 5px;
}
.ltn__category-item-2 .category-btn {
  float: right;
  font-size: 13px;
  text-transform: uppercase;
  text-decoration: underline;
}

/* ltn__category-item-3 */
.ltn__category-item-3 {
  padding: 50px 0 25px;
  position: relative;
  box-shadow: none;
}
.ltn__category-item-3::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 0%;
  height: 4px;
  background-color: var(--ltn__secondary-color);
  transition: all 0.5s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__category-item-3:hover {
  box-shadow: none;
}
.ltn__category-item-3:hover::before {
  width: 100%;
  opacity: 1;
  visibility: visible;
}
.ltn__category-item-3:hover h5 {
  color: var(--ltn__secondary-color);
}

.ltn__category-item-4 {
  padding: 40px 30px 30px;
  position: relative;
  border: none;
  box-shadow: var(--ltn__box-shadow-4);
  border-radius: 10px;
}
.ltn__category-item-4 .ltn__category-item-img {
  width: 100px;
  height: 100px;
  line-height: 115px;
  font-size: 45px;
  border-radius: 100%;
  background-color: var(--section-bg-5);
  color: var(--ltn__secondary-color);
  text-align: center;
  margin-right: 0;
  margin-left: auto;
}
.ltn__category-item-4 .ltn__category-item-name {
  padding: 25px 0px 15px;
}
.ltn__category-item-4 .ltn__category-item-name h4 {
  font-weight: 600;
}
.ltn__category-item-4 .ltn__category-item-name p {
  margin-bottom: 0;
}
.ltn__category-item-4 .ltn__category-item-btn {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: -20px;
}
.ltn__category-item-4 .ltn__category-item-btn a {
  width: 45px;
  height: 45px;
  line-height: 50px;
  background-color: var(--white);
  display: block;
  border-radius: 100%;
  text-align: center;
  font-size: 18px;
  box-shadow: var(--ltn__box-shadow-2);
  border: 1px solid var(--border-color-8);
}
.ltn__category-item-4.text-center .ltn__category-item-img {
  margin-left: auto;
  margin-right: auto;
}
.ltn__category-item-4.text-center .ltn__category-item-btn a {
  margin-left: auto;
  margin-right: auto;
}
.ltn__category-item-4:hover {
  box-shadow: var(--ltn__box-shadow-4);
}

.ltn__category-item-5 {
  border: none;
  box-shadow: var(--ltn__box-shadow-4);
  border-radius: 10px;
  margin-bottom: 50px;
}
.ltn__category-item-5 a {
  padding: 40px 30px 35px;
  display: block;
  position: relative;
}
.ltn__category-item-5 a span {
  display: block;
}
.ltn__category-item-5 a .category-icon {
  width: 100px;
  height: 100px;
  line-height: 115px;
  font-size: 45px;
  border-radius: 100%;
  background-color: var(--section-bg-5);
  color: var(--ltn__secondary-color);
  text-align: center;
  margin-bottom: 20px;
}
.ltn__category-item-5 a .category-title {
  font-size: 22px;
  font-weight: 600;
  font-family: var(--ltn__heading-font);
  color: var(--ltn__heading-color);
  transition: all 0.3s ease 0s;
  margin-bottom: 10px;
}
.ltn__category-item-5 a .category-btn {
  width: 45px;
  height: 45px;
  line-height: 50px;
  background-color: var(--white);
  display: block;
  border-radius: 100%;
  text-align: center;
  font-size: 18px;
  box-shadow: var(--ltn__box-shadow-2);
  border: 1px solid var(--border-color-8);
  position: absolute;
  bottom: -20px;
  right: 50%;
  transform: translateX(50%);
}
.ltn__category-item-5.text-center .category-icon {
  margin-left: auto;
  margin-right: auto;
}
.ltn__category-item-5.text-center .category-btn {
  margin-left: auto;
  margin-right: auto;
}
.ltn__category-item-5:hover {
  box-shadow: var(--ltn__box-shadow-4);
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__category-item-5:hover .category-title {
  color: var(--white);
}

.ltn__category-item-5-2 a .category-icon {
  margin-right: 0;
  margin-left: auto;
}
.ltn__category-item-5-2 a .category-number {
  transition: all 0.3s ease 0s;
  font-size: 20px;
  font-weight: 600;
  font-family: var(--ltn__body-font);
  color: var(--ltn__secondary-color);
}
.ltn__category-item-5-2 a .category-brief {
  transition: all 0.3s ease 0s;
}
.ltn__category-item-5-2:hover {
  background-color: var(--ltn__secondary-color);
}
.ltn__category-item-5-2:hover .category-number,
.ltn__category-item-5-2:hover .category-brief {
  color: var(--white);
}

.ltn__category-item-6 {
  border: 0;
}
.ltn__category-item-6 .ltn__category-item-img {
  font-size: 30px;
  line-height: 1;
  color: var(--ltn__color-1);
}
.ltn__category-item-6 .ltn__category-item-name {
  padding: 15px 5px 5px;
}
.ltn__category-item-6:hover {
  box-shadow: none;
}
.ltn__category-item-6:hover i,
.ltn__category-item-6:hover h5,
.ltn__category-item-6:hover h6 {
  color: var(--ltn__secondary-color);
}

@media (max-width: 1200px) {
  .ltn__category-item-5 a {
    padding: 40px 20px 35px;
  }
  .ltn__category-item-5 a .category-icon {
    width: 80px;
    height: 80px;
    line-height: 90px;
    font-size: 30px;
  }
  .ltn__category-item-5 a .category-title {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .ltn__category-item-2 .ltn__category-item-img {
    display: none;
  }
  .ltn__category-item-3 {
    padding: 30px 0 5px;
  }
  .ltn__category-item-5 a {
    padding: 40px 15px 35px;
  }
  .ltn__category-item-5 a .category-icon {
    width: 60px;
    height: 60px;
    line-height: 70px;
    font-size: 25px;
  }
  .ltn__category-item-5 a .category-title {
    font-size: 13px;
  }
}
/* ----------------------------------------------------
    Feature Area 
---------------------------------------------------- */
.ltn__feature-item {
  padding: 40px 25px 10px;
  transition: all 0.3s ease 0s;
}

.ltn__feature-icon-2 {
  margin-bottom: 20px;
  font-size: 60px;
  line-height: 1;
  color: #f1f1f1 !important;
  text-align: center !important;
}

.ltn__feature-icon {
  margin-bottom: 20px;
  font-size: 60px;
  line-height: 1;
  text-align: center !important;
}

/* feature-item-2 */
.ltn__feature-item-2 {
  padding: 40px 25px 10px;
}
.ltn__feature-item-2 .ltn__feature-icon {
  margin-bottom: 20px;
}
.ltn__feature-item-2 .ltn__feature-icon span {
  background: transparent;
  height: 100px;
  width: 100px;
  line-height: 109px;
  border-radius: 100%;
  position: relative;
  transition: all 0.5s ease 0s;
  display: inline-block;
  text-align: center;
}
.ltn__feature-item-2 .ltn__feature-icon span::before, .ltn__feature-item-2 .ltn__feature-icon span::after {
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 100%;
  transition: all 0.8s ease 0s;
}
.ltn__feature-item-2 .ltn__feature-icon span:before {
  height: 0%;
  width: 0%;
  background: transparent;
}
.ltn__feature-item-2 .ltn__feature-icon span:after {
  height: 100%;
  width: 100%;
  border: 1px solid;
  border-color: var(--ltn__heading-color);
}
.ltn__feature-item-2 .ltn__feature-icon i {
  font-size: 26px;
  color: var(--ltn__heading-color);
  line-height: 1;
  transition: all 0.5s ease 0s;
  z-index: 1;
  position: relative;
}
.ltn__feature-item-2.active-feature .ltn__feature-icon span, .ltn__feature-item-2:hover .ltn__feature-icon span {
  color: var(--white);
  border-color: transparent;
}
.ltn__feature-item-2.active-feature .ltn__feature-icon span:before, .ltn__feature-item-2:hover .ltn__feature-icon span:before {
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, rgb(238, 145, 203) 0%, rgb(217, 176, 241) 50%);
}
.ltn__feature-item-2.active-feature .ltn__feature-icon span:after, .ltn__feature-item-2:hover .ltn__feature-icon span:after {
  border-color: var(--white);
  height: 80%;
  width: 80%;
}
.ltn__feature-item-2.active-feature .ltn__feature-icon i, .ltn__feature-item-2:hover .ltn__feature-icon i {
  color: var(--white);
}
.ltn__feature-item-2.active-feature .ltn__feature-info h6, .ltn__feature-item-2:hover .ltn__feature-info h6 {
  color: var(--ltn__secondary-color);
}

/* feature-item-3 */
.ltn__feature-item-3 {
  padding: 25px 22px 1px;
  display: flex;
  transition: all 0.3s ease 0s;
  border: 2px solid;
  border-color: #f4faff;
  margin-bottom: 20px;
  position: relative;
}
.ltn__feature-item-3 h1, .ltn__feature-item-3 h2, .ltn__feature-item-3 h3, .ltn__feature-item-3 h4, .ltn__feature-item-3 h5, .ltn__feature-item-3 h6 {
  margin-bottom: 5px;
}
.ltn__feature-item-3 .ltn__feature-icon {
  margin: 0px 20px 0 0;
  font-size: 50px;
  color: var(--ltn__secondary-color);
  line-height: 1.5;
}
.ltn__feature-item-3::before {
  position: absolute;
  content: "";
  left: -2px;
  top: 50%;
  width: 4px;
  height: 0%;
  background-color: var(--ltn__secondary-color);
  transition: all 0.5s ease 0s;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%);
}
.ltn__feature-item-3:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__feature-item-3:hover::before {
  height: 80%;
  opacity: 1;
  visibility: visible;
}
.ltn__feature-item-3.text-right {
  flex-flow: row-reverse;
}
.ltn__feature-item-3.text-right .ltn__feature-icon {
  margin: 0px 0 0 20px;
}
.ltn__feature-item-3.text-right::before {
  right: -2px;
  left: auto;
}

/* feature-item-4 */
.ltn__feature-item-4 {
  padding: 50px 20px 15px;
  background-color: var(--white);
  margin-bottom: 30px;
  transition: all 0.3s ease 0s;
  box-shadow: var(--ltn__box-shadow-2);
}
.ltn__feature-item-4:hover {
  box-shadow: var(--ltn__box-shadow-1);
}

/* feature-item-5 */
.ltn__feature-item-5 {
  padding: 70px 30px 25px;
  margin-bottom: 30px;
}
.ltn__feature-item-5 .ltn__feature-icon {
  margin-bottom: 25px;
  font-size: 80px;
  line-height: 1;
}
.ltn__feature-item-5 .ltn__feature-icon img {
  max-width: 200px;
}
.ltn__feature-item-5 .ltn__feature-icon span {
  position: relative;
}
.ltn__feature-item-5 .ltn__feature-icon span::before {
  position: absolute;
  content: "\\e942";
  font-family: "icomoon";
  right: -10px;
  top: -10px;
  height: 35px;
  width: 35px;
  line-height: 35px;
  background-color: var(--ltn__primary-color);
  color: var(--white);
  font-size: 14px;
  border-radius: 100%;
}
.ltn__feature-item-5 .btn-wrapper {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 0.3s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__feature-item-5 .btn-wrapper a {
  min-height: 60px;
}
.ltn__feature-item-5:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__feature-item-5:hover .btn-wrapper {
  bottom: -60px;
  opacity: 1;
  visibility: visible;
}
.ltn__feature-item-5.section-bg-2 .ltn__feature-icon {
  color: var(--ltn__secondary-color);
}
.ltn__feature-item-5.section-bg-2 .ltn__feature-icon i {
  color: var(--ltn__secondary-color);
}
.ltn__feature-item-5.section-bg-2 .ltn__feature-icon span::before {
  background-color: var(--white);
  color: var(--ltn__primary-color);
}
.ltn__feature-item-5.white-bg .ltn__feature-icon span::before {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.feature-btn a {
  display: block;
  padding: 15px 20px;
  background-color: #fff;
  text-align: center;
}

/* feature-item-6 */
.ltn__feature-item-6 {
  border: 1px solid var(--border-color-8);
  margin-bottom: 30px;
  padding: 40px 30px 35px;
}
.ltn__feature-item-6::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 0%;
  height: 4px;
  background-color: var(--ltn__secondary-color);
  transition: all 0.5s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__feature-item-6 .ltn__feature-icon {
  color: var(--ltn__secondary-color);
}
.ltn__feature-item-6 .ltn__feature-icon i {
  transition: all 0.3s ease 0s;
}
.ltn__feature-item-6 .ltn__feature-info p {
  font-size: 14px;
  margin-bottom: 0;
}
.ltn__feature-item-6 .ltn__feature-info p + p {
  margin-top: 15px;
}
.ltn__feature-item-6 .ltn__feature-info .ltn__service-btn {
  transition: all 0.3s ease 0s;
  color: var(--ltn__color-1);
  font-weight: 700;
  font-size: 14px;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.ltn__feature-item-6 .ltn__feature-info .ltn__service-btn i {
  display: flex;
  align-items: center;
}
.ltn__feature-item-6.active, .ltn__feature-item-6:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__feature-item-6.active::before, .ltn__feature-item-6:hover::before {
  width: 100%;
  opacity: 1;
  visibility: visible;
}
.ltn__feature-item-6.active .ltn__feature-info .ltn__service-btn,
.ltn__feature-item-6.active .ltn__feature-icon, .ltn__feature-item-6:hover .ltn__feature-info .ltn__service-btn,
.ltn__feature-item-6:hover .ltn__feature-icon {
  color: var(--ltn__secondary-color);
}

.ltn__feature-item-61 {
  border: 1px solid var(--border-color-8);
  margin-bottom: 30px;
  border-radius: 15px;
  padding: 40px 35px 35px;
}
.ltn__feature-item-61::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 0%;
  height: 4px;
  transition: all 0.5s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__feature-item-61 .ltn__feature-icon {
  color: var(--ltn__secondary-color);
}
.ltn__feature-item-61 .ltn__feature-icon i {
  transition: all 0.3s ease 0s;
}
.ltn__feature-item-61 .ltn__feature-info p {
  font-size: 28px;
  margin-bottom: 0;
  color: #f1f1f1;
}
.ltn__feature-item-61 .ltn__feature-info p + p {
  margin-top: 15px;
}
.ltn__feature-item-61 .ltn__feature-info .ltn__service-btn {
  transition: all 0.3s ease 0s;
  color: var(--ltn__color-1);
  font-weight: 700;
  font-size: 14px;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.ltn__feature-item-61 .ltn__feature-info .ltn__service-btn i {
  display: flex;
  align-items: center;
}
.ltn__feature-item-61.active, .ltn__feature-item-61:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__feature-item-61.active::before, .ltn__feature-item-61:hover::before {
  width: 100%;
  opacity: 1;
  visibility: visible;
}
.ltn__feature-item-61.active .ltn__feature-info .ltn__service-btn,
.ltn__feature-item-61.active .ltn__feature-icon, .ltn__feature-item-61:hover .ltn__feature-info .ltn__service-btn,
.ltn__feature-item-61:hover .ltn__feature-icon {
  color: var(--ltn__secondary-color);
}

/* feature-item-7 */
.ltn__feature-item-7 {
  background-color: var(--white);
  padding: 38px 30px 10px;
  box-shadow: var(--ltn__box-shadow-2);
  margin-bottom: 30px;
}
.ltn__feature-item-7 .ltn__feature-icon-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.ltn__feature-item-7 .ltn__feature-icon {
  margin-bottom: 0;
  margin-right: 20px;
  color: var(--ltn__secondary-color);
}
.ltn__feature-item-7 h3 {
  margin-bottom: 0;
}

.ltn__feature-item-7-color-white {
  background-color: transparent;
  border: 1px solid #203336;
}
.ltn__feature-item-7-color-white h3,
.ltn__feature-item-7-color-white p {
  color: var(--white);
}

/* feature-item-8 */
.ltn__feature-item-8 {
  padding: 40px 30px 15px;
  display: flex;
  align-items: center;
}
.ltn__feature-item-8 .ltn__feature-icon {
  margin-right: 20px;
  font-size: 40px;
  width: 50px;
}
.ltn__feature-item-8 .ltn__feature-info h4 {
  margin-bottom: 5px;
}
.ltn__feature-item-8 .ltn__feature-info p {
  font-size: 15px;
}

.ltn__feature-item-box-wrap {
  box-shadow: var(--ltn__box-shadow-1);
}

.ltn__feature-item-box-wrap-2 {
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  box-shadow: none;
}
.ltn__feature-item-box-wrap-2 .ltn__feature-item-8 {
  min-width: 280px;
}

.ltn__border-between-column [class*=col]::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
  width: 1px;
  background-color: var(--border-color-1);
}
.ltn__border-between-column [class*=col]:first-child::before {
  display: none;
}

/* feature-item-9 */
.ltn__feature-item-9 {
  padding: 30px 25px 5px;
  border: 1px solid;
}
.ltn__feature-item-9 .ltn__feature-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  box-shadow: var(--ltn__box-shadow-1);
  border-radius: 100%;
  margin-bottom: 0;
  margin-right: 20px;
  text-align: center;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
}
.ltn__feature-item-9 .ltn__feature-icon span {
  line-height: 1;
}
.ltn__feature-item-9 .ltn__feature-info {
  overflow: hidden;
}
.ltn__feature-item-9 h2 {
  margin-bottom: 5px;
}
.ltn__feature-item-9:hover {
  background-color: var(--ltn__secondary-color);
}

/* small mobile :320px. */
@media (max-width: 767px) {
  .ltn__feature-item-5 + .btn-wrapper {
    margin-bottom: 30px;
  }
  .ltn__feature-item-7 {
    padding: 38px 20px 10px;
  }
}
/* ----------------------------------------------------
    Countdown Area
---------------------------------------------------- */
.ltn__countdown {
  margin-top: 30px;
  display: inline-block;
  box-shadow: var(--ltn__box-shadow-3);
  padding: 25px 40px 5px;
}
.ltn__countdown .single {
  display: inline-block;
  margin-right: 30px;
}
.ltn__countdown .single:last-child {
  margin-right: 0;
}

.ltn__countdown-2 {
  margin-top: 0;
  padding: 20px 30px 1px;
}
.ltn__countdown-2 .single {
  margin-right: 20px;
}
.ltn__countdown-2 .single h1 {
  font-size: 22px;
  margin-bottom: 5px;
}
.ltn__countdown-2 .single p {
  font-size: 14px;
}

.ltn__countdown-3 {
  margin-top: 0;
  padding: 0px;
  box-shadow: none;
}
.ltn__countdown-3 .single {
  margin-right: 20px;
}
.ltn__countdown-3 .single h1 {
  font-size: 24px;
  margin-bottom: 5px;
  height: 50px;
  width: 60px;
  line-height: 50px;
  background-color: var(--white);
  color: var(--ltn__secondary-color);
  text-align: center;
  font-family: var(--ltn__body-font);
}
.ltn__countdown-3 .single p {
  font-size: 18px;
  text-align: center;
  font-family: var(--ltn__heading-font);
}
.ltn__countdown-3 .btn-wrapper {
  margin-top: 20px;
}

@media (max-width: 991px) {
  .ltn__countdown-3 .single h1 {
    font-size: 20px;
    height: 50px;
    width: 50px;
    line-height: 50px;
  }
  .ltn__countdown-3 .single p {
    font-size: 14px;
  }
}
@media (min-width: 767px) {
  .ltn__countdown-1 {
    min-width: 380px;
  }
}
/* ----------------------------------------------------
    Blog Area
---------------------------------------------------- */
.ltn__blog-item {
  position: relative;
  margin-bottom: 30px;
}

.ltn__blog-img {
  position: relative;
}
.ltn__blog-img img {
  margin-bottom: 0;
}

.ltn__blog-likes {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.ltn__blog-likes ul {
  margin: 0;
  padding: 0;
}
.ltn__blog-likes li {
  list-style: none;
}
.ltn__blog-likes li a {
  height: 70px;
  width: 70px;
  font-size: 16px;
  border-radius: 100%;
  display: flex;
  background-color: var(--white);
  text-align: center;
  flex-flow: column;
  justify-content: center;
  box-shadow: var(--ltn__box-shadow-3);
  color: var(--ltn__heading-color);
}
.ltn__blog-likes li a i {
  font-size: 18px;
  margin-bottom: 5px;
}
.ltn__blog-likes li a span {
  display: inline-block;
  line-height: 1;
  font-size: 12px;
}

.ltn__blog-brief {
  padding: 30px 0 30px;
}

.ltn__blog-title {
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 600;
}

.ltn__blog-meta {
  margin-bottom: 20px;
}
.ltn__blog-meta ul {
  padding: 0;
  margin: 0;
}
.ltn__blog-meta li {
  font-weight: 600;
  display: inline-block;
  margin-right: 25px;
  position: relative;
  font-size: 14px;
  margin-top: 0;
}
.ltn__blog-meta li:last-child {
  margin-right: 0;
}
.ltn__blog-meta li i {
  color: var(--ltn__secondary-color);
  margin-right: 5px;
}
.ltn__blog-meta li img {
  margin-bottom: 0;
}

.ltn__blog-tags a {
  margin-right: 10px;
  position: relative;
  display: inline-block;
}
.ltn__blog-tags a::before {
  position: absolute;
  content: ",";
  right: -3px;
}
.ltn__blog-tags a:last-child::before {
  display: none;
}

.ltn__blog-author img {
  border-radius: 100%;
  margin-right: 10px;
  max-width: 30px;
  display: inline-block;
}

.ltn__blog-btn {
  color: var(--ltn__heading-color);
  transition: all 0.3s ease 0s;
}

.ltn__blog-category a {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  padding: 5px 15px 2px;
  margin-bottom: 5px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}
.ltn__blog-category a:last-child {
  margin-right: 0;
}
.ltn__blog-category a:hover {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}

.ltn__blog-meta-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ltn__blog-meta-btn .ltn__blog-meta {
  margin-bottom: 0;
}

/* ltn__blog-item-1 */
.ltn__blog-item-1 .ltn__blog-img img {
  border-radius: 0px 0px 0px 35px;
}
.ltn__blog-item-1 .ltn__blog-meta ul li {
  position: relative;
}
.ltn__blog-item-1 .ltn__blog-meta ul li::before {
  position: absolute;
  content: "";
  width: 2px;
  height: 10px;
  top: 50%;
  background-color: var(--ltn__primary-color);
  right: -15px;
  transform: translateY(-50%);
  opacity: 0.2;
}
.ltn__blog-item-1 .ltn__blog-meta ul li:last-child::before {
  display: none;
}

/* ltn__blog-item-2 */
.ltn__blog-item-2 {
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-2 .ltn__blog-brief {
  padding: 30px 20px 30px;
}
.ltn__blog-item-2 .ltn__blog-meta li:before {
  height: 15px;
  width: 2px;
  top: 50%;
}
.ltn__blog-item-2 .ltn__blog-meta li:before::before {
  position: absolute;
  content: "";
  right: -15px;
  height: 15px;
  width: 2px;
  background-color: var(--ltn__heading-color);
  top: 50%;
  bottom: 6px;
  transform: translateY(-50%);
  opacity: 0.6;
}
.ltn__blog-item-2 .ltn__blog-meta li:before:last-child::before {
  display: none;
}
.ltn__blog-item-2 .ltn__blog-btn {
  opacity: 0;
  visibility: hidden;
  margin-top: -20px;
}
.ltn__blog-item-2:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__blog-item-2:hover .ltn__blog-btn {
  margin-top: 0;
  opacity: 1;
  visibility: visible;
}

/* ltn__blog-item-3 */
/* ltn__blog-item-4 */
.ltn__blog-item-3 .ltn__blog-brief,
.ltn__blog-item-4 .ltn__blog-brief {
  padding: 30px 30px 30px;
  margin-left: auto;
  margin-right: auto;
  background-color: var(--white);
  position: relative;
}
.ltn__blog-item-3 .ltn__blog-meta,
.ltn__blog-item-4 .ltn__blog-meta {
  margin-bottom: 15px;
}
.ltn__blog-item-3 .ltn__blog-meta-btn,
.ltn__blog-item-4 .ltn__blog-meta-btn {
  border-top: 1px solid;
  border-color: var(--border-color-1);
  padding-top: 20px;
}
.ltn__blog-item-3 .ltn__blog-meta-btn .ltn__blog-meta,
.ltn__blog-item-4 .ltn__blog-meta-btn .ltn__blog-meta {
  margin-bottom: 0;
}
.ltn__blog-item-3 .ltn__blog-btn,
.ltn__blog-item-4 .ltn__blog-btn {
  font-size: 14px;
  font-weight: 600;
  color: var(--ltn__secondary-color);
  text-transform: uppercase;
}

/* ltn__blog-item-3 */
.ltn__blog-item-3 .ltn__blog-brief {
  width: calc(100% - 30px);
  box-shadow: var(--ltn__box-shadow-4);
}
.ltn__blog-item-3 .ltn__blog-img + .ltn__blog-brief {
  margin-top: -50px;
}

.ltn__blog-item-3-normal .ltn__blog-item-3 {
  margin-bottom: 50px;
}
.ltn__blog-item-3-normal .ltn__blog-item-3 .ltn__blog-brief {
  width: 100%;
}
.ltn__blog-item-3-normal .ltn__blog-item-3 .ltn__blog-img + .ltn__blog-brief {
  margin-top: 0px;
}

.ltn__blog-item-3 .ltn__blog-img {
  overflow: hidden;
}
.ltn__blog-item-3 .ltn__blog-img img {
  transition: all 0.5s ease 0s;
}
.ltn__blog-item-3:hover .ltn__blog-img img {
  transform: scale(1.1);
}

/* ltn__blog-item-4 */
.ltn__blog-item-4 {
  border: 2px solid var(--white-9);
  margin-top: 1px;
}
.ltn__blog-item-4 .ltn__blog-brief {
  margin-top: 0;
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-4 p {
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-4::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 0%;
  background-color: var(--ltn__primary-color);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-4:hover::before {
  width: 100%;
  height: 100%;
  opacity: 0.9;
  visibility: visible;
}
.ltn__blog-item-4:hover .ltn__blog-brief {
  background-color: transparent;
}
.ltn__blog-item-4:hover .ltn__blog-meta,
.ltn__blog-item-4:hover .ltn__blog-title,
.ltn__blog-item-4:hover p {
  color: var(--white);
}

/* ltn__blog-item-5 */
.ltn__blog-item-5 {
  border: 2px solid var(--border-color-11);
}
.ltn__blog-item-5 .ltn__blog-brief {
  padding: 40px 30px 40px 30px;
}
.ltn__blog-item-5 .ltn__blog-meta-btn {
  padding-top: 10px;
}
.ltn__blog-item-5 .ltn__blog-author {
  font-size: 16px;
}
.ltn__blog-item-5 .ltn__blog-author img {
  max-width: 40px;
}
.ltn__blog-item-5 .ltn__blog-btn {
  font-size: 14px;
  font-weight: 700;
  font-family: var(--ltn__body-font);
}

/* blog-item-audio */
.ltn__blog-item-audio iframe {
  width: 100%;
  min-height: 300px;
}

/* blog-item-quote */
.ltn__blog-item-quote {
  border: 0;
}
.ltn__blog-item-quote .ltn__blog-meta li {
  color: var(--white);
}
.ltn__blog-item-quote .ltn__blog-meta li i {
  color: var(--white);
}
.ltn__blog-item-quote .ltn__blog-meta li:hover a {
  color: var(--white-3);
}
.ltn__blog-item-quote blockquote {
  font-size: 20px;
  font-weight: 700;
  position: relative;
  background-color: transparent;
  font-style: normal;
  border-left: 0;
  border-color: var(--ltn__heading-color);
  padding: 60px 0 0;
  margin: 0px 0 30px 0px;
  color: var(--white);
  text-align: left;
}
.ltn__blog-item-quote blockquote::before {
  position: absolute;
  content: "\\e94d";
  font-family: "icomoon";
  font-size: 30px;
  left: 0;
  right: 0;
  top: 0;
  transform: inherit;
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-quote blockquote a:hover, .ltn__blog-item-quote blockquote:hover {
  color: var(--white-3);
}

/* blog-item-6 */
.ltn__blog-item-6 {
  box-shadow: var(--ltn__box-shadow-5);
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-6:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__blog-item-6 .ltn__blog-brief {
  padding: 35px 30px 15px 35px;
}
.ltn__blog-item-6 .ltn__blog-title {
  font-size: 20px;
}
.ltn__blog-item-6 p {
  font-size: 14px;
}

/* blog-item-7 */
.ltn__blog-item-7 {
  box-shadow: var(--ltn__box-shadow-5);
  transition: all 0.3s ease 0s;
}
.ltn__blog-item-7:hover {
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__blog-item-7 .ltn__blog-meta li {
  color: var(--ltn__secondary-color);
}
.ltn__blog-item-7 .ltn__blog-brief {
  padding: 30px 30px 30px 35px;
}
.ltn__blog-item-7 .ltn__blog-title {
  font-size: 18px;
  text-transform: uppercase;
}
.ltn__blog-item-7 p {
  font-size: 18px;
  line-height: 28px;
}
.ltn__blog-item-7 .ltn__blog-btn {
  font-size: 15px;
}

/* blog-list-wrap */
.ltn__blog-list-wrap .ltn__blog-item {
  margin-bottom: 40px;
}
.ltn__blog-list-wrap .ltn__blog-title {
  font-size: 30px;
  line-height: 1.2;
}
.ltn__blog-list-wrap .ltn__blog-item-5 .ltn__blog-brief {
  padding: 50px 40px 50px 45px;
}
.ltn__blog-list-wrap .ltn__blog-item-quote .ltn__blog-meta {
  padding-left: 100px;
}
.ltn__blog-list-wrap .ltn__blog-item-quote blockquote {
  font-size: 35px;
  line-height: 1.2;
  padding: 0 0 0 100px;
}
.ltn__blog-list-wrap .ltn__blog-item-quote blockquote::before {
  font-size: 80px;
  left: 0;
}
.ltn__blog-list-wrap .ltn__blog-item-quote blockquote a:hover, .ltn__blog-list-wrap .ltn__blog-item-quote blockquote:hover {
  color: var(--white-3);
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ltn__blog-list-wrap .ltn__blog-title {
    font-size: 26px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote {
    font-size: 24px;
    padding: 0 0 0 80px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote::before {
    font-size: 50px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote .ltn__blog-meta {
    padding-left: 80px;
  }
  .ltn__blog-item-6 .ltn__blog-title {
    font-size: 20px;
  }
}
@media (max-width: 991px) {
  .ltn__blog-title {
    font-size: 20px;
  }
  .ltn__blog-item-3 .ltn__blog-brief {
    width: calc(100% - 30px);
  }
  .ltn__blog-list-wrap .ltn__blog-title {
    font-size: 26px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote {
    font-size: 24px;
    padding: 0 0 0 0px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote::before {
    font-size: 30px;
    display: block;
    position: relative;
    margin-bottom: 10px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote .ltn__blog-meta {
    padding-left: 0;
  }
}
@media (max-width: 767px) {
  .ltn__blog-title {
    font-size: 16px;
  }
  .ltn__blog-meta li {
    margin-right: 10px;
    font-size: 12px;
  }
  .ltn__blog-list-wrap .ltn__blog-title {
    font-size: 22px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-5 .ltn__blog-brief {
    padding: 40px 20px 35px 20px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote {
    font-size: 20px;
    padding: 0 0 0 0px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote blockquote::before {
    font-size: 30px;
    display: block;
    position: relative;
    margin-bottom: 10px;
  }
  .ltn__blog-list-wrap .ltn__blog-item-quote .ltn__blog-meta {
    padding-left: 0;
  }
  .ltn__blog-item-3 .ltn__blog-btn,
  .ltn__blog-item-4 .ltn__blog-btn {
    font-size: 12px;
  }
  .ltn__blog-item-6 .ltn__blog-title {
    font-size: 20px;
  }
  .ltn__blog-item-6 .ltn__blog-brief {
    padding: 35px 20px 15px 20px;
  }
}
/* ----------------------------------------------------
    Blog Details
---------------------------------------------------- */
.ltn__page-details-inner h1, .ltn__page-details-inner h2, .ltn__page-details-inner h3, .ltn__page-details-inner h4, .ltn__page-details-inner h5, .ltn__page-details-inner h6 {
  margin-top: 30px;
}
.ltn__page-details-inner p {
  margin-top: 1.5em;
}
.ltn__page-details-inner .ltn__blog-title {
  margin-top: 0;
  font-size: 30px;
}
.ltn__page-details-inner .ltn__blog-img {
  margin-bottom: 40px;
}
.ltn__page-details-inner .img-radius img {
  border-radius: 0px 0px 0px 35px;
}
.ltn__page-details-inner label {
  font-size: 14px;
}

/* blog-details-wrap */
.ltn__blog-details-wrap {
  border: 2px solid var(--border-color-11);
  padding: 50px;
}

blockquote {
  font-size: 18px;
  font-family: var(--ltn__heading-font);
  line-height: 1.6;
  font-weight: 700;
  background-color: var(--section-bg-1);
  padding: 60px 50px 60px 60px;
  margin: 50px 0 50px 0px;
  font-style: normal;
  text-align: center;
  border-left: 0;
  position: relative;
  z-index: 1;
}
blockquote::before {
  position: absolute;
  content: "\\e94d";
  font-family: "icomoon";
  font-size: 150px;
  right: 45px;
  transition: all 0.3s ease 0s;
  top: 50%;
  transform: translateY(-50%);
  color: var(--white);
  z-index: -1;
}

.ltn__comment-item {
  position: relative;
}
.ltn__comment-item p {
  font-size: 14px;
}

.ltn__commenter-img {
  float: left;
  margin-right: 30px;
  max-width: 100px;
}

.ltn__commenter-img img {
  border-radius: 100%;
}

.ltn__commenter-comment {
  overflow: hidden;
}

.ltn__commenter-comment h6 {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 600;
}

.ltn__commenter-comment .comment-date {
  margin-bottom: 10px;
  display: block;
  font-size: 13px;
  font-weight: 700;
  font-family: var(--ltn__heading-font);
  color: var(--ltn__secondary-color);
}

.ltn__comment-inner ul {
  margin: 0;
  padding: 0;
}

.ltn__comment-inner li {
  list-style: none;
  border-top: 1px solid var(--border-color-12);
  padding-top: 30px;
  margin-top: 8px;
}

.ltn__comment-inner > ul > li:first-child {
  border-top: 0;
  padding-top: 0;
  margin-top: 0;
}

.ltn__comment-inner ul ul {
  margin: 0 0 0 70px;
  padding: 0;
}

.ltn__comment-reply-btn {
  position: absolute;
  padding: 0 25px 0;
  border: 2px solid var(--border-color-11);
  display: inline-block;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 700;
  height: 40px;
  line-height: 36px;
  top: 0;
  right: 0;
}
.ltn__comment-reply-btn i {
  margin-right: 5px;
}
.ltn__comment-reply-btn:hover {
  border-color: var(--ltn__secondary-color);
}

.ltn__comment-reply-area form {
  padding: 50px;
  background-color: var(--white-5);
}
.ltn__comment-reply-area form input[type=text],
.ltn__comment-reply-area form input[type=email],
.ltn__comment-reply-area form input[type=password],
.ltn__comment-reply-area form input[type=submit],
.ltn__comment-reply-area form textarea {
  border-color: var(--white-5);
}

.ltn__comment-inner .product-ratting ul {
  padding: 0;
  margin: 0;
}
.ltn__comment-inner .product-ratting ul li {
  padding: 0;
  border: 0;
}

.values_p {
  font-size: 28px;
  margin-bottom: 0;
  line-height: 1.5;
}

.values_p2 {
  font-size: 24px;
  margin-bottom: 0;
  line-height: 1.5;
}

.values_p3 {
  margin-bottom: 0;
  line-height: 1.5;
}

.ltn__first-letter {
  font-size: 70px;
  font-weight: 700;
  float: left;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  margin-right: 30px;
  line-height: 1;
  text-transform: uppercase;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ltn__blog-tags-social-media .ltn__social-media ul li {
  color: var(--ltn__color-1);
}

.ltn__prev-next-btn {
  position: relative;
}
.ltn__prev-next-btn::before {
  position: absolute;
  content: "\\e958";
  font-family: "icomoon";
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 30px;
  color: var(--ltn__secondary-color);
}
.ltn__prev-next-btn h6 {
  color: var(--ltn__secondary-color);
}
.ltn__prev-next-btn .ltn__blog-title {
  font-size: 24px;
  margin-bottom: 0;
}

.ltn-author-introducing {
  padding: 40px;
  border: 2px solid var(--border-color-11);
  margin-bottom: 50px;
}
.ltn-author-introducing .author-img {
  float: left;
  max-width: 180px;
  margin-right: 40px;
}
.ltn-author-introducing .author-info {
  overflow: hidden;
}
.ltn-author-introducing .author-info h6 {
  margin-bottom: 0;
  font-size: 14px;
  color: var(--ltn__secondary-color);
}
.ltn-author-introducing .author-info h1,
.ltn-author-introducing .author-info h2,
.ltn-author-introducing .author-info h3 {
  margin-bottom: 10px;
}
.ltn-author-introducing .author-info p {
  font-size: 14px;
  margin-bottom: 0;
}
.ltn-author-introducing .author-info p + p {
  margin-top: 15px;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ltn-author-introducing .author-img {
    max-width: 120px;
    margin-right: 30px;
  }
}
@media (max-width: 991px) {
  .ltn__blog-tags-social-media .ltn__social-media {
    text-align: left !important;
    margin-top: 30px;
  }
}
@media (max-width: 767px) {
  .ltn__page-details-inner .ltn__blog-title {
    margin-top: 0;
    font-size: 24px;
  }
  .ltn__page-details-inner .ltn__blog-img {
    margin-bottom: 40px;
  }
  .ltn__blog-details-wrap {
    padding: 50px 20px;
  }
  blockquote {
    font-size: 16px;
    padding: 70px 20px 40px 20px;
  }
  blockquote::before {
    position: initial;
    font-size: 60px;
    display: block;
    line-height: 1;
  }
  .ltn__prev-next-btn .ltn__blog-title {
    font-size: 18px;
  }
  .blog-prev {
    margin-bottom: 40px;
  }
  .blog-next {
    margin-top: 40px;
    margin-bottom: 0;
  }
  .ltn-author-introducing {
    padding: 40px 20px;
  }
  .ltn-author-introducing .author-img {
    max-width: 100px;
    margin-right: 0px;
    margin-bottom: 30px;
  }
  .ltn-author-introducing .author-info {
    overflow: inherit;
  }
  .ltn__commenter-img {
    float: inherit;
    margin-right: 0;
    max-width: 80px;
    margin-bottom: 20px;
  }
  .ltn__commenter-comment h6 {
    font-size: 18px;
  }
  .ltn__comment-reply-btn {
    position: inherit;
    font-size: 12px;
  }
  .ltn__comment-inner ul ul {
    margin: 0px;
  }
  .ltn__comment-inner li {
    margin-top: 30px;
  }
  .ltn__comment-reply-area form {
    padding: 50px 20px;
  }
  .ltn__first-letter {
    font-size: 40px;
    margin-right: 20px;
    width: 60px;
    height: 60px;
  }
}
/* ----------------------------------------------------
    Service Details
---------------------------------------------------- */
.ltn__service-list-menu ul {
  padding: 0;
}
.ltn__service-list-menu ul li {
  display: block;
  border-top: 2px solid #f6f6f6;
  padding: 18px 0;
  margin: 0;
  font-weight: 700;
  font-family: var(--ltn__heading-font);
}
.ltn__service-list-menu ul li:last-child {
  border-bottom: 2px solid #f6f6f6;
}
.ltn__service-list-menu ul li i {
  margin-right: 5px;
  color: var(--ltn__secondary-color);
}
.ltn__service-list-menu ul li .service-price {
  float: right;
  text-transform: capitalize;
  font-weight: 400;
  font-family: var(--ltn__body-font);
}

@media (max-width: 767px) {
  .ltn__service-list-menu ul li .service-price {
    float: none;
    display: block;
  }
}
/* ----------------------------------------------------
    Pagination
---------------------------------------------------- */
/* ltn__pagination-3 */
.ltn__pagination ul {
  margin: 0;
  padding: 0;
}
.ltn__pagination ul li {
  list-style: none;
  display: inline-block;
  margin-right: 10px;
}
.ltn__pagination ul li:last-child {
  margin-right: 0px;
}
.ltn__pagination ul li a {
  height: 50px;
  width: 50px;
  line-height: 46px;
  border: 2px solid var(--border-color-11);
  text-align: center;
  display: block;
  font-weight: 700;
  border-radius: 100%;
}
.ltn__pagination ul li:hover a, .ltn__pagination ul li.active a {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white);
}

@media (max-width: 767px) {
  .ltn__pagination ul li {
    margin-right: 5px;
    font-size: 14px;
  }
  .ltn__pagination ul li a {
    height: 40px;
    width: 40px;
    line-height: 36px;
  }
}
/* ----------------------------------------------------
    Testimonial ( 1, 2, 3, 4, 5, 6 )
---------------------------------------------------- */
.ltn__testimonial-item {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 30px;
  margin-bottom: 50px;
}
.ltn__testimonial-item .ltn__testimoni-img img {
  border-radius: 100%;
}
.ltn__testimonial-item.text-center .ltn__testimoni-img {
  margin-left: auto;
  margin-right: auto;
}
.ltn__testimonial-item.text-right .ltn__testimoni-img {
  margin-left: auto;
  margin-right: 0;
}

.ltn__testimoni-img {
  max-width: 120px;
  margin-bottom: 30px;
}
.ltn__testimoni-img img {
  border-radius: 0;
}
.ltn__testimoni-img i {
  width: 50px;
  height: 50px;
  line-height: 48px;
  border: 1px solid;
  border-radius: 100%;
  font-size: 18px;
}

/* testimonial-item-2 */
.ltn__testimonial-item-2 {
  max-width: 60%;
}
.ltn__testimonial-item-2 .ltn__testimoni-img {
  max-width: 85px;
  outline: 8px solid;
  outline-color: var(--white);
  margin-top: 8px;
  position: relative;
}
.ltn__testimonial-item-2 .ltn__testimoni-img img {
  border-radius: 0;
  box-shadow: var(--ltn__box-shadow-4);
}
.ltn__testimonial-item-2 p {
  font-size: 24px;
}
.ltn__testimonial-item-2 .ltn__testimoni-info h4 {
  font-size: 30px;
  margin-bottom: 5px;
}
.ltn__testimonial-item-2 .ltn__testimoni-info h6 {
  color: var(--ltn__secondary-color);
}

/* testimonial-item-3 */
.ltn__testimonial-item-3 {
  max-width: 100%;
  margin-bottom: 20px;
}
.ltn__testimonial-item-3 .ltn__testimoni-info {
  box-shadow: var(--ltn__box-shadow-4);
  width: calc(100% - 40px);
  margin: -60px auto 0;
  background-color: var(--white);
  padding: 25px 30px 30px;
  position: relative;
  z-index: 9;
}
.ltn__testimonial-item-3 .ltn__testimoni-info p {
  margin-top: 0;
}
.ltn__testimonial-item-3 .ltn__testimoni-info h4 {
  margin-bottom: 5px;
  margin-top: 0;
}
.ltn__testimonial-item-3 .ltn__testimoni-info h6 {
  margin-bottom: 5px;
  margin-top: 0;
  color: var(--ltn__secondary-color);
}
.ltn__testimonial-item-3 .ltn__testimoni-info-inner {
  display: flex;
  align-items: center;
}
.ltn__testimonial-item-3 .ltn__testimoni-img {
  max-width: 60px;
  margin-bottom: 0;
  margin-right: 15px;
}
.ltn__testimonial-item-3 .ltn__testimoni-img img {
  border-radius: 0;
}

.ltn__testimoni-bg-icon {
  position: absolute;
  right: 15px;
  bottom: 5px;
  z-index: -1;
  opacity: 0.1;
}
.ltn__testimoni-bg-icon i {
  font-size: 110px;
  line-height: 1;
  color: var(--ltn__color-1);
}

/* testimonial-item-4 */
.ltn__testimonial-item-4 {
  max-width: 100%;
  position: relative;
  padding: 40px;
  background-color: var(--white);
  box-shadow: var(--ltn__box-shadow-2);
  z-index: 2;
}
.ltn__testimonial-item-4 .ltn__testimoni-img {
  max-width: 160px;
  float: left;
  margin-right: 40px;
}
.ltn__testimonial-item-4 .ltn__testimoni-img img {
  border-radius: 0;
}
.ltn__testimonial-item-4 .ltn__testimoni-info {
  overflow: hidden;
}
.ltn__testimonial-item-4 .ltn__testimoni-info p {
  margin-bottom: 15px;
}
.ltn__testimonial-item-4 .ltn__testimoni-info h4 {
  margin-bottom: 5px;
}
.ltn__testimonial-item-4 .ltn__testimoni-info h6 {
  margin-bottom: 5px;
  color: var(--ltn__secondary-color);
}

/* testimonial-item-5 */
.ltn__testimonial-slider-4 {
  max-width: 45%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.ltn__testimonial-item-5 .ltn__quote-icon {
  font-size: 240px;
  position: absolute;
  top: -15px;
  line-height: 1;
  color: var(--white-7);
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.ltn__testimonial-item-5 .ltn__testimonial-image {
  max-width: 85px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
}
.ltn__testimonial-item-5 .ltn__testimonial-image img {
  outline: 8px solid #fff;
  box-shadow: var(--ltn__box-shadow-1);
}
.ltn__testimonial-item-5 .ltn__testimonial-info {
  margin-top: 30px;
}
.ltn__testimonial-item-5 .ltn__testimonial-info p {
  font-size: 24px;
}
.ltn__testimonial-item-5 .ltn__testimonial-info h4 {
  font-size: 30px;
  margin-bottom: 5px;
}
.ltn__testimonial-item-5 .ltn__testimonial-info h6 {
  color: var(--ltn__secondary-color);
}

.ltn__testimonial-quote-menu {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.ltn__testimonial-quote-menu li {
  list-style: none;
}
.ltn__testimonial-quote-menu li img {
  position: absolute;
}
.ltn__testimonial-quote-menu li:nth-child(1) img {
  width: 105px;
  top: -15%;
  left: 0;
}
.ltn__testimonial-quote-menu li:nth-child(2) img {
  width: 65px;
  top: 0;
  left: auto;
  right: 3%;
}
.ltn__testimonial-quote-menu li:nth-child(3) img {
  width: 65px;
  top: 70%;
  left: 10%;
}
.ltn__testimonial-quote-menu li:nth-child(4) img {
  width: 125px;
  top: 60%;
  left: auto;
  right: 10%;
}
.ltn__testimonial-quote-menu li:nth-child(5) img {
  width: 75px;
  top: 40%;
  left: 3%;
}
.ltn__testimonial-quote-menu li:nth-child(6) img {
  width: 75px;
  top: 25%;
  left: auto;
  right: 15%;
}
.ltn__testimonial-quote-menu li:nth-child(7) img {
  width: 55px;
  top: 20%;
  left: 15%;
}
.ltn__testimonial-quote-menu li:nth-child(8) img {
  width: 55px;
  top: 40%;
  left: auto;
  right: 3%;
}

/* testimonial-item-6 */
.ltn__testimonial-item-6 {
  padding-top: 50px;
  margin-bottom: 0;
}
.ltn__testimonial-item-6 .ltn__testimoni-img i {
  border: 0;
  color: var(--ltn__secondary-color);
}
.ltn__testimonial-item-6 p {
  font-size: 28px;
}

/* testimonial-item-7 */
.ltn__testimonial-item-7 {
  background-color: var(--white);
  padding: 30px 35px 40px;
  max-width: 100%;
  border-radius: 10px;
  box-shadow: var(--ltn__box-shadow-4);
  border: 1px solid;
  border-color: var(--border-color-13);
  position: relative;
}
.ltn__testimonial-item-7 .ltn__testimonial-img {
  margin-bottom: 30px;
}
.ltn__testimonial-item-7 .ltn__testimoni-info p {
  font-size: 18px;
}
.ltn__testimonial-item-7 .ltn__testimoni-info p i {
  font-size: 30px;
  position: relative;
  top: 8px;
  margin-right: 2px;
  line-height: 1;
  transition: all 0.3s ease 0s;
}
.ltn__testimonial-item-7 .ltn__testimoni-info-inner {
  display: flex;
  align-items: center;
}
.ltn__testimonial-item-7 .ltn__testimoni-info-inner .ltn__testimoni-img {
  max-width: 60px;
  margin-right: 15px;
  margin-bottom: 0;
}
.ltn__testimonial-item-7 .ltn__testimoni-info-inner .ltn__testimoni-name-designation h5 {
  font-weight: 600;
  margin-bottom: 0;
}
.ltn__testimonial-item-7 .ltn__testimoni-info-inner .ltn__testimoni-name-designation label {
  font-size: 14px;
  margin-bottom: 0;
  text-transform: uppercase;
}
.ltn__testimonial-item-7::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 0%;
  height: 4px;
  background-color: var(--ltn__secondary-color);
  transition: all 0.5s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__testimonial-item-7:hover::before {
  width: 100%;
  opacity: 1;
  visibility: visible;
}
.ltn__testimonial-item-7:hover .ltn__testimoni-info p i {
  color: var(--ltn__secondary-color);
}

/* testimonial-item-8 */
.ltn__testimonial-item-8 {
  padding: 35px 35px 35px;
}
.ltn__testimonial-item-8 .ltn__testimoni-info p {
  margin-bottom: 0;
}
.ltn__testimonial-item-8 .ltn__testimoni-info p + p {
  margin-top: 15px;
}

.ltn__testimoni-author-ratting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

@media (max-width: 991px) {
  .ltn__testimonial-item-2 {
    max-width: 70%;
  }
  .ltn__testimonial-item-2 p {
    font-size: 20px;
  }
  .ltn__testimonial-item-2 .ltn__testimoni-info h4 {
    font-size: 24px;
  }
  .ltn__testimonial-slider-4 {
    max-width: 70%;
  }
  .ltn__testimonial-item-5 .ltn__testimonial-info p {
    font-size: 20px;
  }
  .quote-animated-image {
    display: none !important;
  }
  .ltn__testimoni-author-ratting {
    flex-flow: column-reverse;
  }
  .ltn__testimonial-item-7 .ltn__testimoni-info p {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .ltn__testimonial-item-2 {
    max-width: 95%;
  }
  .ltn__testimonial-item-2 p {
    font-size: 16px;
  }
  .ltn__testimonial-item-2 .ltn__testimoni-info h4 {
    font-size: 20px;
  }
  .ltn__testimonial-item-3 .ltn__testimoni-info {
    width: calc(100% - 20px);
    padding: 25px 20px 30px;
  }
  .ltn__testimonial-item-3 .ltn__testimoni-info-inner {
    flex-flow: row wrap;
  }
  .ltn__testimonial-item-3 .ltn__testimoni-img {
    margin-bottom: 10px;
  }
  .ltn__testimonial-item-4 .ltn__testimoni-img {
    float: none;
  }
  .ltn__testimonial-slider-4 {
    max-width: 95%;
  }
  .ltn__testimonial-item-5 .ltn__testimonial-info p {
    font-size: 16px;
  }
  .ltn__testimonial-item-7 .ltn__testimoni-info p {
    font-size: 14px;
  }
  .ltn__testimonial-item-7 .ltn__testimoni-info-inner {
    flex-flow: row wrap;
  }
  .ltn__testimonial-item-7 .ltn__testimoni-info-inner .ltn__testimoni-img {
    margin-bottom: 10px;
  }
}
/* ----------------------------------------------------
    Banner Area ( style: 2, 3 )
---------------------------------------------------- */
.ltn__banner-item {
  margin-bottom: 30px;
  position: relative;
}

.ltn__banner-img {
  overflow: hidden;
}
.ltn__banner-img img {
  transition: all 3.5s ease 0s;
}
.ltn__banner-img:hover img {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
}

.ltn__banner-info h4 {
  margin-bottom: 10px;
}

.ltn__banner-style-2 .ltn__banner-info {
  padding: 20px 30px;
  border: 1px solid;
  border-color: var(--border-color-1);
}

.ltn__banner-style-3 .ltn__banner-info {
  position: absolute;
  left: 35px;
  top: 30px;
}

.ltn__banner-style-3 .banner-button {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.ltn__banner-style-3 .banner-button a {
  color: var(--ltn__color-1);
  padding: 12px 25px;
  background-color: rgba(255, 255, 255, 0.1);
  display: inline-block;
}
.ltn__banner-style-3 .banner-button a:hover {
  color: var(--white);
}

.ltn__banner-style-4 {
  position: relative;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ltn__banner-style-4 .ltn__banner-info {
  position: relative;
  padding: 30px 30px;
}
.ltn__banner-style-4 .ltn__banner-info h3 {
  margin-bottom: 10px;
}
.ltn__banner-style-4 .ltn__banner-info p {
  margin-bottom: 12px;
}
.ltn__banner-style-4 .ltn__banner-info mark {
  background-color: var(--ltn__secondary-color);
}
.ltn__banner-style-4::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.4s ease 0s;
  background-color: var(--ltn__primary-color);
  opacity: 0.3;
}
.ltn__banner-style-4:hover::before {
  opacity: 0.15;
}

/* ----------------------------------------------------
    Team Area
---------------------------------------------------- */
.ltn__team-item {
  margin-bottom: 30px;
  border: 1px solid #f1f1f1;
  text-align: center;
  transition: 0.3s;
}
.ltn__team-item:hover {
  box-shadow: var(--ltn__box-shadow-1);
}

.team-info {
  padding: 25px 15px;
}

/* team-item-2 */
.ltn__team-item-2 {
  position: relative;
}
.ltn__team-item-2:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--gradient-color-1);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}
.ltn__team-item-2 .team-info {
  position: absolute;
  width: 100%;
  top: 60%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease 0s;
}
.ltn__team-item-2:hover:before {
  opacity: 0.7;
  visibility: visible;
}
.ltn__team-item-2:hover .team-info {
  top: 50%;
  opacity: 1;
  visibility: visible;
}

/* team-item-3 */
.ltn__team-item-3 {
  padding: 45px 20px 25px;
  box-shadow: var(--ltn__box-shadow-1);
  border: 0;
  position: relative;
}
.ltn__team-item-3 .team-img {
  max-width: 180px;
  margin-left: auto;
  margin-right: auto;
}
.ltn__team-item-3 .team-img img {
  border-radius: 100%;
}
.ltn__team-item-3 h6 {
  text-transform: uppercase;
}
.ltn__team-item-3 .team-info {
  padding: 0;
  margin-top: 30px;
}
.ltn__team-item-3 .ltn__social-media {
  transition: 0.5s;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: currentColor;
  width: 100%;
  padding: 10px 20px 20px;
  opacity: 0;
  visibility: hidden;
  border-bottom: 3px solid transparent;
}
.ltn__team-item-3:hover {
  background-color: var(--ltn__primary-color);
}
.ltn__team-item-3:hover h6,
.ltn__team-item-3:hover h4,
.ltn__team-item-3:hover .ltn__social-media ul li {
  color: var(--white);
}
.ltn__team-item-3:hover .ltn__social-media {
  bottom: -25px;
  opacity: 1;
  visibility: visible;
  z-index: 999;
  border-bottom-color: var(--ltn__secondary-color);
}

@media (max-width: 767px) {
  .ltn__team-item-3 {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
}
/* ----------------------------------------------------
    CounterUp Area
---------------------------------------------------- */
.ltn__counterup-item {
  margin-bottom: 50px;
  text-align: center;
}
.ltn__counterup-item .counter-icon {
  margin-bottom: 25px;
}
.ltn__counterup-item .counter-icon i {
  font-size: 65px;
  line-height: 1;
  color: var(--ltn__secondary-color);
}
.ltn__counterup-item h1 {
  font-weight: 700;
  font-size: 42px;
}
.ltn__counterup-item h6 {
  color: var(--ltn__color-5);
  font-family: var(--ltn__body-font);
}

/* counterup-item-2 */
.ltn__counterup-item-2 {
  margin-bottom: 50px;
  display: flex;
}
.ltn__counterup-item-2 .counter-icon {
  margin-bottom: 0;
  margin-right: 30px;
  text-align: center;
}
.ltn__counterup-item-2 .counter-icon i {
  font-size: 35px;
  height: 65px;
  width: 65px;
  line-height: 65px;
  border: 1px solid;
  border-radius: 5px;
  color: var(--ltn__color-1);
}
.ltn__counterup-item-2 h1, .ltn__counterup-item-2 h6 {
  font-weight: 600;
  font-size: 36px;
  line-height: 1;
  margin-bottom: 10px;
}
.ltn__counterup-item-2 h6 {
  font-size: 20px;
}

/* counterup-item-3 */
.ltn__counterup-item-3 {
  margin-bottom: 50px;
}
.ltn__counterup-item-3 .counter-icon {
  color: var(--ltn__color-1);
}
.ltn__counterup-item-3 h1 {
  font-size: 72px;
  line-height: 1;
  margin-bottom: 5px;
}
.ltn__counterup-item-3 .counterUp-icon {
  font-size: 30px;
}
.ltn__counterup-item-3 h6 {
  font-family: var(--ltn__body-font);
}

@media (max-width: 1199px) {
  .ltn__counterup-item-3 h1 {
    font-size: 56px;
  }
}
@media (max-width: 991px) {
  .ltn__counterup-item h1 {
    font-size: 36px;
  }
}
@media (max-width: 767px) {
  .ltn__counterup-area .ltn__section-title-2 {
    text-align: center;
  }
  .ltn__counterup-item h1 {
    font-size: 30px;
  }
  .ltn__counterup-item-3 {
    text-align: center;
  }
  .ltn__counterup-item-3 h1 {
    font-size: 56px;
  }
}
/* ----------------------------------------------------
    Contact Form Area
---------------------------------------------------- */
.ltn__contact-address-item {
  padding: 40px 30px 10px;
  text-align: center;
  box-shadow: var(--ltn__box-shadow-2);
  margin-bottom: 30px;
}
.ltn__contact-address-item i {
  background-color: transparent;
  color: var(--ltn__heading-color);
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: var(--ltn__box-shadow-2);
  text-align: center;
  border-radius: 100%;
  margin-bottom: 30px;
  transition: all 0.3s ease 0s;
}
.ltn__contact-address-item:hover i {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}

.ltn__contact-address-item-2 {
  padding: 30px 0 10px;
  margin-bottom: 0;
  box-shadow: none;
}
.ltn__contact-address-item-2 + .ltn__contact-address-item-2 {
  border-top: 1px solid;
}

.contact-form-box {
  padding: 40px 50px 50px;
  position: relative;
  z-index: 1;
}
.contact-form-box input::-webkit-input-placeholder {
  color: var(--ltn__color-1);
}
.contact-form-box input::-moz-placeholder {
  color: var(--ltn__color-1);
}
.contact-form-box input:-ms-input-placeholder {
  color: var(--ltn__color-1);
}
.contact-form-box input:-moz-placeholder {
  color: var(--ltn__color-1);
}

.contact-form-box-2 input,
.contact-form-box-2 textarea {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  padding-left: 0;
}

.google-map {
  height: 800px;
}

.ltn__contact-address-item-3 {
  box-shadow: none;
  border: 2px solid var(--border-color-11);
  padding: 50px 30px 25px;
}
.ltn__contact-address-item-3 i {
  font-size: 50px;
  border: 0;
  box-shadow: none;
}
.ltn__contact-address-item-3 .ltn__contact-address-icon {
  margin-bottom: 35px;
}
.ltn__contact-address-item-3 .ltn__contact-address-icon img {
  max-width: 80px;
}
.ltn__contact-address-item-3:hover i {
  background-color: transparent;
  color: var(--ltn__secondary-color);
}

.form-messege .error {
  color: var(--red);
}
.form-messege .success {
  color: var(--green);
}

@media (max-width: 767px) {
  .contact-form-box {
    padding: 40px 25px 50px;
  }
}
/* ----------------------------------------------------
    Cart Table Area
---------------------------------------------------- */
.table-1 table {
  border: 0;
  text-transform: uppercase;
  font-size: 13px;
  width: 100%;
}
.table-1 table tr:first-child {
  font-weight: 700;
  text-transform: uppercase;
  background-color: #e5e5e6;
}
.table-1 table tr:nth-child(odd) {
  background-color: #e5e5e6;
}
.table-1 table tr:nth-of-type(even) {
  background: #f9f9f9;
}
.table-1 table tr th {
  font-weight: 700;
  text-transform: uppercase;
  background-color: #e5e5e6;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  padding: 10px 0;
  display: table-cell;
  line-height: 18px;
  text-align: center;
  width: 12%;
}
.table-1 table tr td {
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  padding: 10px 0;
  display: table-cell;
  line-height: 18px;
  text-align: center;
}

.mobile-show {
  display: none;
}

@media only screen and (max-width: 767px) {
  .mobile-none {
    display: none;
  }
  .mobile-show {
    display: block;
  }
}
/* ----------------------------------------------------
    Cart plus minus
---------------------------------------------------- */
.cart-plus-minus {
  border: 2px solid;
  height: 63px;
  line-height: 56px;
  width: 140px;
  text-align: center;
}

.qtybutton {
  height: 100%;
  width: 30%;
}

.dec.qtybutton {
  float: left;
  border-right: 2px solid;
}

.inc.qtybutton {
  float: right;
  border-left: 2px solid;
}

.cart-plus-minus,
.dec.qtybutton,
.inc.qtybutton {
  background-color: var(--white);
  border-color: var(--border-color-11);
  font-size: 20px;
  font-weight: 700;
}

input.cart-plus-minus-box {
  background: transparent none repeat scroll 0 0;
  box-shadow: none;
  border: none;
  height: 100%;
  margin-bottom: 0;
  padding: 0;
  text-align: center;
  width: 40%;
  font-weight: 700;
}

/* ----------------------------------------------------
    Product Details
---------------------------------------------------- */
.product-details-content .product-title {
  font-size: 36px;
  font-weight: 700;
}
.product-details-content .product-price {
  font-size: 24px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.product-details-content .product-excerpt {
  margin-bottom: 30px;
}
.product-details-content .cart-plus-minus {
  display: inline-block;
  margin-right: 20px;
}
.product-details-content .product-details-cart-btn {
  display: inline-block;
  margin-top: 0;
}
.product-details-content .product-details-buy-btn .theme-btn-1 {
  padding: 10px 100px 9px;
}

/* ----------------------------------------------------
    Shoping Cart
---------------------------------------------------- */
.table tr:nth-child(odd) {
  background-color: #f7f8fa;
}

.table tr:nth-child(even) {
  background-color: #fafafa;
}

.shoping-cart-table tbody {
  border-bottom: 1px solid #dee2e6;
}
.shoping-cart-table thead th {
  vertical-align: middle;
  border-bottom: 0;
  background-color: #f7f8fa;
}
.shoping-cart-table .table tr {
  background-color: transparent;
  display: table;
  width: 100%;
}
.shoping-cart-table td {
  padding: 20px 25px;
  vertical-align: middle;
}

.cart-product-image img {
  max-width: 100px;
}

.cart-product-remove {
  cursor: pointer;
}

.cart-product-remove:hover {
  color: var(--ltn__secondary-color);
}

.cart-product-subtotal {
  font-weight: 700;
}

.cart-coupon-row {
  background-color: #f7f8fa;
  text-align: right;
}

.cart-coupon {
  text-align: left;
}

.cart-coupon input {
  max-width: 250px;
  margin-bottom: 0;
}

.submit-button-1 {
  padding: 10px 30px;
  background-color: var(--ltn__primary-color);
  color: var(--white);
  transition: all 0.3s ease 0s;
}

.submit-button-1:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.btn.disabled {
  cursor: not-allowed;
}

.shoping-cart-total {
  float: right;
  max-width: 450px;
  width: 100%;
}
.shoping-cart-total .table {
  margin-bottom: 0;
}
.shoping-cart-total .btn-wrapper {
  margin-top: 0;
}
.shoping-cart-total .btn-wrapper .theme-btn-1 {
  display: block;
}

@media (min-width: 768px) and (max-width: 991px) {
  .shoping-cart-table td {
    padding: 20px 10px;
  }
  .cart-product-image img {
    max-width: 80px;
  }
  .cart-product-info h4 {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .shoping-cart-table thead th {
    display: none;
  }
  .shoping-cart-table .table tr {
    display: block;
    text-align: center;
  }
  .shoping-cart-table td {
    display: block;
    padding: 20px 15px;
  }
  .cart-product-image {
    max-width: 100%;
  }
  .shoping-cart-table .cart-plus-minus {
    margin-left: auto;
    margin-right: auto;
  }
  .cart-coupon input {
    margin-bottom: 20px;
  }
  .shoping-cart-table .table tr:nth-child(even) {
    background-color: var(--section-bg-1);
  }
}
/* ----------------------------------------------------
    Custom Content
---------------------------------------------------- */
.custom-content-brief h1 {
  margin-bottom: 30px;
}
.custom-content-brief .btn-wrapper {
  margin-top: 40px;
}

/* ----------------------------------------------------
    Newsletter
---------------------------------------------------- */
.ltn__newsletter-inner .ltn__form-box {
  position: relative;
  margin-top: 30px;
}
.ltn__newsletter-inner .ltn__form-box input {
  margin-bottom: 0;
  padding-right: 140px;
}
.ltn__newsletter-inner .ltn__form-box button {
  margin-top: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  height: 100%;
  box-shadow: none;
}

.ltn__newsletter-inner-2 .ltn__form-box input {
  border-width: 0px 0px 1px 0px;
  padding-right: 140px;
}

.ltn__newsletter-inner-3 .ltn__form-box input {
  border-radius: 50px;
  padding-left: 30px;
}

/* ----------------------------------------------------
    Faq Area
---------------------------------------------------- */
.ltn__faq-inner .card {
  border: none;
  border-radius: 0;
  margin-bottom: 35px;
}
.ltn__faq-inner .card:last-child {
  margin-bottom: 0;
}
.ltn__faq-inner .card .ltn__card-title {
  background-color: var(--section-bg-1);
  padding: 22px 15px 22px 40px;
  cursor: pointer;
  position: relative;
  transition: 0.3s;
  font-size: 18px;
  margin-bottom: 0;
}
.ltn__faq-inner .card .ltn__card-title::before {
  position: absolute;
  content: "\\e903";
  font-family: "icomoon";
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
}
.ltn__faq-inner .card .ltn__card-title[aria-expanded=true] {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__faq-inner .card .ltn__card-title[aria-expanded=true]:before {
  content: "\\e904";
}
.ltn__faq-inner .card .card-body {
  padding: 20px 0 0 0;
}

/* ltn__faq-inner-2 */
.ltn__faq-inner-2 .card {
  margin: 0 0 -2px 0;
  border: 2px solid;
  border-color: var(--border-color-10);
}
.ltn__faq-inner-2 .card .ltn__card-title {
  background-color: transparent;
  padding: 20px 60px 20px 40px;
}
.ltn__faq-inner-2 .card .ltn__card-title::before {
  background-color: var(--section-bg-1);
  color: var(--ltn__primary-color);
  font-size: 16px;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
}
.ltn__faq-inner-2 .card .ltn__card-title[aria-expanded=true] {
  background-color: transparent;
  color: var(--ltn__primary-color);
}
.ltn__faq-inner-2 .card .ltn__card-title[aria-expanded=true]:before {
  color: var(--ltn__secondary-color);
}
.ltn__faq-inner-2 .card .card-body {
  padding: 15px 40px 25px;
}

.ltn__faq-inner-3 .card {
  background-color: transparent;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
.ltn__faq-inner-3 .card .ltn__card-title {
  padding: 20px 60px 20px 5px;
  font-weight: 600;
}
.ltn__faq-inner-3 .card .ltn__card-title i {
  width: 50px;
  height: 50px;
  line-height: 55px;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  display: inline-block;
  text-align: center;
  margin-right: 10px;
  font-size: 26px;
}

@media (max-width: 767px) {
  .ltn__faq-inner-2 .card .ltn__card-title {
    padding: 20px 60px 20px 20px;
    font-size: 16px;
  }
  .ltn__faq-inner-2 .card .card-body {
    padding: 15px 20px 25px;
  }
  .ltn__faq-inner-3 .card .ltn__card-title {
    font-size: 14px;
  }
  .ltn__faq-inner-3 .card .ltn__card-title i {
    width: 40px;
    height: 40px;
    line-height: 45px;
    font-size: 20px;
  }
}
/* ----------------------------------------------------
    404 Area
---------------------------------------------------- */
.error-404-inner .btn-wrapper {
  margin-top: 50px;
}

.error-404-title {
  font-size: 120px;
  line-height: 1;
  margin-bottom: 40px;
}

/* 404 area 1 */
.ltn__404-area-1 .error-404-title {
  font-size: 400px;
  line-height: 1;
  color: var(--ltn__secondary-color);
  margin-bottom: 0;
}
.ltn__404-area-1 h2 {
  font-size: 60px;
}

/* 404 area 2 */
.ltn__404-area-2 {
  min-height: 90vh;
  display: flex;
  align-items: center;
}
.ltn__404-area-2 .error-404-inner {
  padding: 150px 0 170px;
}

@media (max-width: 1199px) {
  .ltn__404-area-1 .error-404-title {
    font-size: 200px;
  }
  .ltn__404-area-1 h2 {
    font-size: 30px;
  }
}
@media (max-width: 991px) {
  .ltn__404-area-2 .error-404-inner {
    padding: 80px 0 110px;
  }
  .error-404-inner p br {
    display: none;
  }
  .error-404-title {
    font-size: 80px;
  }
  .ltn__404-area-1 .error-404-title {
    font-size: 100px;
  }
  .ltn__404-area-1 h2 {
    font-size: 20px;
  }
}
/* ----------------------------------------------------
    Coming Soon Area
---------------------------------------------------- */
.ltn__coming-soon-area {
  min-height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
}

.coming-soon-inner {
  padding: 120px 0 100px;
}
.coming-soon-inner .ltn__countdown {
  margin-top: 0;
}
.coming-soon-inner .ltn__countdown .single {
  border: 1px solid var(--border-color-3);
  margin-right: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
  min-width: 120px;
  padding-top: 15px;
}
.coming-soon-inner .btn-wrapper {
  margin-top: 50px;
}
.coming-soon-inner p {
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;
}
.coming-soon-inner .ltn__form-box {
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
}
.coming-soon-inner .ltn__form-box input {
  background-color: transparent;
  color: var(--white);
  border: 1px solid var(--border-color-3);
}
.coming-soon-inner .ltn__form-box input[type=text]::-webkit-input-placeholder,
.coming-soon-inner .ltn__form-box input[type=email]::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: var(--white);
}

@media (min-width: 767px) and (max-width: 991px) {
  .coming-soon-inner .ltn__countdown .single {
    min-width: 110px;
  }
}
@media (max-width: 991px) {
  .coming-soon-inner {
    padding: 80px 0 110px;
  }
  .coming-soon-inner p br {
    display: none;
  }
}
@media (max-width: 767px) {
  .coming-soon-inner .ltn__countdown {
    padding: 25px 20px 5px;
  }
  .coming-soon-inner .ltn__countdown .single {
    margin-right: 20px;
    min-width: 90px;
  }
}
/* ----------------------------------------------------
    Screenshot Area
---------------------------------------------------- */
/* img-slide-item-1 */
.ltn__img-slide-item-1 {
  margin: 10px 0 20px 0;
  padding: 0 0;
}

.slick-current .ltn__img-slide-item-1 {
  box-shadow: var(--ltn__box-shadow-1);
}

/* img-slide-item-2 */
.ltn__img-slide-item-2 {
  margin-bottom: 30px;
}

/* img-slide-item-3 */
.ltn__img-slide-item-3 {
  position: relative;
  margin-bottom: 85px;
}
.ltn__img-slide-item-3 .ltn__img-slide-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 35px;
  background-color: white;
  position: absolute;
  bottom: 0;
  width: calc(100% - 60px);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  transition: all 0.3s ease 0s;
  opacity: 0;
  visibility: hidden;
  box-shadow: var(--ltn__box-shadow-2);
}
.ltn__img-slide-item-3 .ltn__img-slide-info-brief {
  padding-right: 20px;
}
.ltn__img-slide-item-3 h6 {
  margin-bottom: 5px;
  color: var(--ltn__secondary-color);
}
.ltn__img-slide-item-3 h1 {
  margin-bottom: 0;
  font-size: 30px;
}
.ltn__img-slide-item-3 .btn-wrapper {
  margin-top: 0;
}
.ltn__img-slide-item-3 .btn-wrapper .btn {
  padding: 15px 20px 13px;
}
.ltn__img-slide-item-3:hover .ltn__img-slide-info {
  bottom: -65px;
  opacity: 1;
  visibility: visible;
}

.slick-current .ltn__img-slide-item-3 .ltn__img-slide-info {
  bottom: -65px;
  opacity: 1;
  visibility: visible;
}

.ltn__img-slide-item-4 {
  position: relative;
  margin-bottom: 30px;
}
.ltn__img-slide-item-4 .ltn__img-slide-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 35px;
  position: absolute;
  bottom: 5px;
  width: 100%;
  transition: all 0.3s ease 0s;
  background: var(--gradient-color-3);
  opacity: 0;
  visibility: hidden;
}
.ltn__img-slide-item-4 .ltn__img-slide-info-brief {
  padding-right: 20px;
}
.ltn__img-slide-item-4 h6 {
  margin-bottom: 5px;
  color: var(--white);
  font-weight: 400;
}
.ltn__img-slide-item-4 h1 {
  margin-bottom: 0;
  font-size: 26px;
  color: var(--white);
  font-weight: 500;
}
.ltn__img-slide-item-4 .btn-wrapper {
  margin-top: 0;
}
.ltn__img-slide-item-4 .btn-wrapper .btn {
  padding: 15px 20px 13px;
}
.ltn__img-slide-item-4:hover .ltn__img-slide-info {
  bottom: 0;
  opacity: 1;
  visibility: visible;
}

@media (max-width: 1399px) {
  .ltn__img-slide-item-3 .ltn__img-slide-info {
    padding: 30px 20px;
    width: calc(100% - 30px);
  }
  .ltn__img-slide-item-3 .ltn__img-slide-info-brief {
    padding-right: 15px;
  }
  .ltn__img-slide-item-3 h1 {
    font-size: 18px;
  }
  .ltn__img-slide-item-3 .btn-wrapper .btn {
    padding: 10px 10px 8px;
  }
  .ltn__img-slide-item-4 .ltn__img-slide-info {
    padding: 30px 20px;
  }
  .ltn__img-slide-item-4 h1 {
    font-size: 18px;
  }
  .ltn__img-slide-item-4 .btn-wrapper .btn {
    padding: 10px 10px 8px;
  }
}
/* ----------------------------------------------------
    Pricing List Area
---------------------------------------------------- */
.ltn__pricing-plan-item {
  box-shadow: var(--ltn__box-shadow-1);
  margin-bottom: 30px;
  transition: all 0.3s ease 0s;
  position: relative;
  overflow: hidden;
}
.ltn__pricing-plan-item .pricing-badge {
  color: var(--white);
  background-color: var(--ltn__secondary-color);
  padding: 4px 20px;
  text-transform: uppercase;
  font-size: 8px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  display: table;
  transform: rotate(45deg);
  top: 18px;
  position: absolute;
  right: -28px;
  transition: all 0.3s ease-in;
}
.ltn__pricing-plan-item .pricing-title {
  margin: 0;
  height: 100px;
  line-height: 100px;
}
.ltn__pricing-plan-item .pricing-price {
  background-color: var(--section-bg-1);
  height: 85px;
  line-height: 85px;
  transition: all 0.3s ease 0s;
}
.ltn__pricing-plan-item .pricing-price h2 {
  margin-bottom: 0;
  line-height: inherit;
  font-size: 48px;
}
.ltn__pricing-plan-item .pricing-price sup,
.ltn__pricing-plan-item .pricing-price sub {
  font-size: 24px;
}
.ltn__pricing-plan-item .pricing-price sup {
  top: -0.9em;
}
.ltn__pricing-plan-item .pricing-price sub {
  bottom: -0.2em;
}
.ltn__pricing-plan-item ul {
  margin: 35px 0;
  padding: 0;
}
.ltn__pricing-plan-item ul li {
  list-style: none;
  font-size: 18px;
}
.ltn__pricing-plan-item .btn-wrapper {
  padding-bottom: 50px;
}
.ltn__pricing-plan-item.active-price, .ltn__pricing-plan-item.active {
  box-shadow: var(--ltn__box-shadow-6);
  transform: scale(1.1);
  overflow: hidden;
  position: relative;
}
.ltn__pricing-plan-item.active-price .pricing-price h2, .ltn__pricing-plan-item.active .pricing-price h2 {
  color: var(--ltn__secondary-color);
}
.ltn__pricing-plan-item.active-price .btn, .ltn__pricing-plan-item.active .btn {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

@media (max-width: 767px) {
  .ltn__pricing-plan-item.active-price, .ltn__pricing-plan-item.active {
    transform: scale(1);
  }
}
/* ----------------------------------------------------
    Checkbox
---------------------------------------------------- */
/* checkbox-item */
.checkbox-item {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-item input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkbox-item .checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: var(--white);
  border: 1px solid;
  border-color: #93959E;
}

/* On mouse-over, add a grey background color */
.checkbox-item:hover input ~ .checkmark {
  background-color: var(--ltn__secondary-color);
}

/* When the checkbox is checked, add a blue background */
.checkbox-item input:checked ~ .checkmark {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-item .checkmark:after {
  position: absolute;
  content: "";
  display: none;
}

/* Show the checkmark when checked */
.checkbox-item input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-item .checkmark:after {
  left: 4px;
  top: 0px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}

/* ----------------------------------------------------
    Body Sidebar Icons
---------------------------------------------------- */
.body-sidebar-icons {
  position: fixed;
  top: 50%;
  display: flex;
  flex-direction: column;
  z-index: 9;
  transition: transform 0.3s ease 1s;
  right: 0;
  transform: translate3d(100%, -50%, 0);
  align-items: flex-end;
  transform: translate3d(0, -50%, 0);
}
.body-sidebar-icons a {
  background-color: #ddd;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: auto;
  height: 40px;
  min-width: 40px;
  margin: 0;
  overflow: hidden;
  flex-direction: row-reverse;
}
.body-sidebar-icons a i {
  width: 40px;
  line-height: 40px;
  font-size: 14px;
  vertical-align: middle;
}
.body-sidebar-icons a .icon-name {
  white-space: nowrap;
  max-width: 0;
  padding: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  transition: padding 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.15), max-width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.15);
}
.body-sidebar-icons a.facebook-icon {
  background-color: var(--facebook);
}
.body-sidebar-icons a.twitter-icon {
  background-color: var(--twitter);
}
.body-sidebar-icons a.pinterest-icon {
  background-color: var(--pinterest);
}
.body-sidebar-icons a.instagram-icon {
  background-color: var(--instagram);
}
.body-sidebar-icons a.dribbble-icon {
  background-color: var(--dribbble);
}
.body-sidebar-icons a.behance-icon {
  background-color: var(--behance);
}
.body-sidebar-icons a.google-plus-icon {
  background-color: var(--google-plus);
}
.body-sidebar-icons a.linkedin-icon {
  background-color: var(--linkedin);
}
.body-sidebar-icons a.youtube-icon {
  background-color: var(--youtube);
}
.body-sidebar-icons a.vk-icon {
  background-color: var(--vk);
}
.body-sidebar-icons a.wechat-icon {
  background-color: var(--wechat);
}
.body-sidebar-icons a.email-icon {
  background-color: var(--email);
}
.body-sidebar-icons a:hover {
  box-shadow: none;
}
.body-sidebar-icons a:hover .icon-name {
  padding-left: 15px;
  max-width: 220px;
}
.body-sidebar-icons.left-side {
  left: 0;
  right: auto;
  align-items: flex-start;
}
.body-sidebar-icons.left-side a {
  flex-direction: unset;
}
.body-sidebar-icons.left-side a:hover {
  box-shadow: none;
}
.body-sidebar-icons.left-side a:hover .icon-name {
  padding-right: 15px;
  padding-left: 0;
}

/* ----------------------------------------------------
    About Us Area
---------------------------------------------------- */
.about-us-img-wrap {
  position: relative;
}
.about-us-img-wrap img {
  margin: 0;
}

.about-us-img-info {
  width: 310px;
  height: 310px;
  background-color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--ltn__box-shadow-1);
  position: absolute;
  top: 70%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}
.about-us-img-info h1 {
  margin: 0;
  font-size: 120px;
  line-height: 0.8;
  color: var(--ltn__secondary-color);
}
.about-us-img-info h1 .counter {
  font-size: 120px;
  line-height: 0.8;
  color: var(--ltn__secondary-color);
}
.about-us-img-info h1 span {
  font-size: 20px;
  color: var(--ltn__heading-color);
}
.about-us-img-info h6 {
  margin: 0;
}
.about-us-img-info h6 span {
  font-size: 20px;
  color: var(--ltn__secondary-color);
}
.about-us-img-info .btn-wrapper {
  margin-top: 50px;
}
.about-us-img-info .dots-bottom {
  height: 25px;
  width: 25px;
  background-color: var(--ltn__secondary-color);
  display: inline-block;
  position: absolute;
  bottom: -10px;
  left: 12px;
}

.about-us-img-info-2 {
  width: 190px;
  height: 190px;
  background-color: var(--ltn__secondary-color);
  border: 15px solid;
  border-color: var(--white);
  bottom: 0;
  top: auto;
  transform: inherit;
  margin-right: 0;
}
.about-us-img-info-2 h1 {
  font-size: 50px;
  color: var(--white);
}
.about-us-img-info-2 h1 .counter {
  font-size: 50px;
  color: var(--white);
}
.about-us-img-info-2 h1 span {
  font-size: 20px;
  color: var(--white);
}
.about-us-img-info-2 h6 {
  color: var(--white);
}

.about-us-img-info-3 {
  right: auto;
  left: 10px;
  border: 0;
  height: inherit;
  width: inherit;
  max-width: 300px;
  bottom: 70px;
  background-color: transparent;
}
.about-us-img-info-3 .ltn__video-img::before {
  opacity: 0.1;
}

.about-us-info-wrap {
  position: relative;
}
.about-us-info-wrap .btn-wrapper {
  margin-top: 40px;
}
.about-us-info-wrap hr {
  margin-top: 40px;
  margin-bottom: 40px;
}
.about-us-info-wrap .ltn__video-play-btn {
  width: 80px;
  height: 80px;
  line-height: 84px;
  font-size: 20px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -100px;
}

.about-us-info-devide {
  display: flex;
}
.about-us-info-devide .list-item-with-icon {
  margin-left: 30px;
  margin-bottom: 30px;
}

.list-item-with-icon {
  min-width: 300px;
}

.about-us-img-info-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}

.list-item-with-icon-2 ul,
.list-item-with-icon ul {
  padding: 0;
  margin: 0;
}
.list-item-with-icon-2 ul li,
.list-item-with-icon ul li {
  position: relative;
  list-style: none;
  padding-left: 60px;
  font-weight: 700;
  margin-bottom: 25px;
}
.list-item-with-icon-2 ul li:last-child,
.list-item-with-icon ul li:last-child {
  margin-bottom: 0;
}
.list-item-with-icon-2 ul li::before,
.list-item-with-icon ul li::before {
  position: absolute;
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  left: 0;
  top: -5px;
  background-color: var(--section-bg-1);
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  color: var(--ltn__secondary-color);
}

.list-item-with-icon-2 ul li {
  padding-left: 30px;
  font-weight: 400;
  margin-bottom: 0;
}
.list-item-with-icon-2 ul li::before {
  height: inherit;
  line-height: inherit;
  width: inherit;
  background-color: transparent;
  color: var(--ltn__heading-color);
  top: 5px;
}

.about-img-left {
  margin-right: 30px;
}

.about-img-right {
  margin-left: 30px;
}

.ltn__img-shape-left,
.ltn__img-shape-right {
  position: relative;
}
.ltn__img-shape-left::before,
.ltn__img-shape-right::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 85%;
  width: 30px;
  background-color: var(--ltn__secondary-color);
}

.ltn__img-shape-left {
  padding-left: 30px;
}
.ltn__img-shape-left::before {
  left: 0;
}

.ltn__img-shape-right {
  padding-right: 30px;
}
.ltn__img-shape-right::before {
  left: auto;
  right: 0;
}

.about-call-us {
  display: flex;
  align-items: center;
}
.about-call-us .call-us-icon {
  font-size: 50px;
  margin-right: 20px;
  color: var(--ltn__secondary-color);
  line-height: 1;
}
.about-call-us .call-us-info p {
  margin-bottom: 10px;
}
.about-call-us .call-us-info h2 {
  margin-bottom: 0px;
}

.ltn__list-item-half {
  margin-top: 0;
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}
.ltn__list-item-half li {
  width: 50%;
  float: left;
  list-style: none;
  display: flex;
  align-items: center;
  padding-right: 20px;
}
.ltn__list-item-half li img {
  max-width: 50px;
  margin-right: 10px;
}
.ltn__list-item-half li i {
  font-size: 20px;
  color: var(--white);
  margin-right: 15px;
  height: 45px;
  width: 45px;
  line-height: 45px;
  background-color: var(--ltn__secondary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 45px;
  border-radius: 100%;
}

.ltn__list-item-half-2 li i {
  font-size: 14px;
  height: 32px;
  width: 32px;
  line-height: 32px;
  flex: 0 0 32px;
}

.ltn__list-item-1 {
  padding-left: 0;
}
.ltn__list-item-1 li {
  list-style: none;
}
.ltn__list-item-1 li i {
  margin-right: 10px;
  color: var(--ltn__secondary-color);
  font-size: 26px;
  float: left;
}

.ltn__list-item-1-before {
  padding-left: 30px;
}
.ltn__list-item-1-before li {
  position: relative;
}
.ltn__list-item-1-before li::before {
  position: absolute;
  content: "";
  left: -30px;
  width: 15px;
  height: 1px;
  background-color: var(--ltn__secondary-color);
  top: 50%;
  transform: translateY(-50%);
}

.ltn__list-item-2 {
  padding-left: 0;
}
.ltn__list-item-2 li {
  list-style: none;
  display: inline-block;
  position: relative;
  margin-right: 30px;
  max-width: 160px;
  font-size: 14px;
}
.ltn__list-item-2 li span {
  display: block;
  font-weight: 700;
}
.ltn__list-item-2 li:last-child {
  margin-right: 0;
}

.ltn__list-item-2-before li {
  position: relative;
}
.ltn__list-item-2-before li::before {
  position: absolute;
  content: "";
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background-color: var(--ltn__primary-color);
  opacity: 0.2;
}
.ltn__list-item-2-before li:last-child::before {
  display: none;
}

.ltn__list-item-2-img li {
  margin-right: 10px;
  width: 30%;
}

.ltn__callout {
  padding: 20px;
  margin: 25px 0;
  border-left: 4px solid;
  border-color: var(--ltn__secondary-color);
}
.ltn__callout p {
  margin-bottom: 0;
}
.ltn__callout p + p {
  margin-top: 20px;
}

.list-item-margin li {
  margin-top: 30px;
}

.about-author-info-2 ul {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.about-author-info-2 ul li {
  list-style: none;
  margin-right: 45px;
  position: relative;
}
.about-author-info-2 ul li::before {
  position: absolute;
  content: "";
  top: 50%;
  right: -22px;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background-color: var(--ltn__primary-color);
  opacity: 0.2;
}
.about-author-info-2 ul li:last-child {
  margin-right: 0;
}
.about-author-info-2 ul li:last-child::before {
  display: none;
}
.about-author-info-2 .about-author-info-2-brief img {
  max-width: 40px;
  border-radius: 100%;
  margin-right: 15px;
}
.about-author-info-2 .about-author-info-2-contact {
  padding: 10px 20px;
  background-color: var(--section-bg-1);
}
.about-author-info-2 .about-author-info-2-contact i {
  font-size: 25px;
  margin-right: 15px;
  color: var(--ltn__secondary-color);
}

@media (min-width: 992px) and (max-width: 1199px) {
  .about-us-info-devide {
    display: block;
  }
  .about-us-info-devide .list-item-with-icon {
    margin-left: 0;
  }
  .list-item-with-icon {
    margin-top: 30px;
    margin-bottom: 40px;
  }
}
@media (max-width: 991px) {
  .about-img-left {
    margin-right: 0;
    margin-bottom: 40px;
  }
  .about-img-right {
    margin-left: 0;
    margin-bottom: 40px;
  }
  .about-us-info-wrap .ltn__video-play-btn {
    position: inherit;
    transform: inherit;
  }
}
@media (max-width: 767px) {
  .custom-content-brief {
    margin-bottom: 30px;
  }
  .about-us-img-info {
    height: 200px;
    width: 220px;
  }
  .about-us-img-info h1 .counter {
    font-size: 80px;
  }
  .about-us-img-info-2 {
    width: 150px;
    height: 150px;
  }
  .about-us-img-info-2 h1 .counter {
    font-size: 30px;
  }
  .about-us-info-devide {
    display: block;
  }
  .about-us-info-devide .list-item-with-icon {
    margin-left: 0;
  }
  .list-item-with-icon {
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .list-item-with-icon {
    min-width: 275px;
  }
  .ltn__list-item-half li {
    width: 100%;
    padding-right: 0px;
  }
  .ltn__flat-info li {
    margin-right: 20px;
  }
  .ltn__list-item-2-before li::before {
    right: -12px;
  }
}
/* ----------------------------------------------------
    Why Choose Us Area
---------------------------------------------------- */
.why-choose-us-feature-item {
  display: flex;
  margin-bottom: 10px;
  max-width: 480px;
}
.why-choose-us-feature-item .why-choose-us-feature-icon {
  margin-right: 20px;
  font-size: 70px;
  line-height: 1.2;
  color: var(--ltn__secondary-color);
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.why-choose-us-feature-item .why-choose-us-feature-brief h3 {
  margin-bottom: 5px;
}

.why-choose-us-img-wrap img {
  max-width: 65%;
}

.why-choose-us-img-2 {
  margin-top: -15%;
}
.why-choose-us-img-2 img {
  border: 15px solid var(--white);
}

/* ----------------------------------------------------
    Service Area
---------------------------------------------------- */
.ltn__service-item-1 {
  background-color: var(--white);
  margin-bottom: 50px;
}
.ltn__service-item-1 .service-item-img {
  position: relative;
  overflow: hidden;
}
.ltn__service-item-1 .service-item-img img {
  transition: all 0.5s ease 0s;
}
.ltn__service-item-1 .service-item-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 70px;
  height: 70px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: var(--ltn__secondary-color);
}
.ltn__service-item-1 .service-item-brief {
  padding: 32px 40px 10px;
}
.ltn__service-item-1 .service-item-brief h3 {
  margin-bottom: 5px;
}
.ltn__service-item-1:hover .service-item-img img {
  transform: scale(1.1);
}

.ltn__service-item-2 {
  padding: 0px 45px 30px;
  margin-bottom: 50px;
  margin-top: 35px;
}
.ltn__service-item-2 .service-item-icon {
  font-size: 80px;
  line-height: 1;
  top: -35px;
  position: relative;
  color: var(--ltn__secondary-color);
}
.ltn__service-item-2 .service-item-brief {
  padding-top: 50px;
}
.ltn__service-item-2 .service-item-icon + .service-item-brief {
  padding-top: 0;
}
.ltn__service-item-2 ul {
  margin-bottom: 10px;
  padding: 0;
}
.ltn__service-item-2 ul li {
  list-style: none;
  margin-top: 10px;
}
.ltn__service-item-2 ul li span {
  color: var(--ltn__color-1);
}
.ltn__service-item-2 hr {
  margin-top: 25px;
  margin-bottom: 25px;
}

@media (max-width: 1199px) {
  .ltn__service-item-2 {
    padding: 0px 30px 30px;
  }
}
@media (max-width: 767px) {
  .ltn__service-item-1 .service-item-brief {
    padding: 30px 22px 10px;
  }
}
/* ----------------------------------------------------
    Call To Action 1, 2, 3, 4, 5
---------------------------------------------------- */
/* call-to-action-2 */
.call-to-action-2 {
  background-color: var(--white-3);
}

.call-to-action-inner-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.call-to-action-inner-2 h2 {
  margin: 0;
}
.call-to-action-inner-2 .btn-wrapper {
  margin-top: 0;
}

/* call-to-action-3 */
.get-a-free-service-margin {
  margin-bottom: -180px;
}

.get-a-free-service-inner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: var(--ltn__box-shadow-1);
  padding-right: 80px;
  padding-left: 30px;
}
.get-a-free-service-inner .call-to-img img {
  max-width: 350px;
  position: absolute;
  left: 35px;
  bottom: 0;
  z-index: 2;
}
.get-a-free-service-inner .call-to-action-inner-content {
  position: relative;
  z-index: 3;
}

.call-to-circle-1,
.call-to-circle-2 {
  height: 265px;
  width: 265px;
  display: inline-block;
  background-color: var(--ltn__secondary-color);
  position: absolute;
  left: 60px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 100%;
  z-index: 1;
}

.call-to-circle-2 {
  height: 80px;
  width: 80px;
  left: 300px;
  top: 10%;
  transform: inherit;
  animation: wave 8s 0.1s infinite linear;
}

.call-to-bg-icon {
  position: absolute;
  font-size: 220px;
  right: 35px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: var(--ltn__color-1);
  opacity: 0.1;
}

.get-a-free-service-inner .call-to-circle-2 {
  animation: wave 8s 0.1s infinite linear;
}

/* call-to-action-4 */
.ltn__call-to-action-4 {
  position: relative;
}
.ltn__call-to-action-4 .call-to-action-inner-4 {
  position: relative;
  z-index: 99;
}
.ltn__call-to-action-4 .call-to-action-inner-4 h2 {
  font-style: italic;
}
.ltn__call-to-action-4 .call-to-action-inner-4 .h1 {
  font-size: 50px;
}
.ltn__call-to-action-4 .call-to-action-inner-4 p {
  font-size: 18px;
}

.ltn__call-to-4-img-1 {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: 34%;
}

.ltn__call-to-4-img-2 {
  position: absolute;
  right: 0;
  bottom: 0;
  max-width: 27%;
}

/* call-to-action-5 */
.call-to-action-inner-5 a:hover {
  text-decoration: underline;
  color: var(--white);
}

.team-pics {
  border-radius: 50%;
  height: 450px;
}

.team-pics1 {
  border-radius: 50%;
  height: 400px;
  width: 400px;
}

/* call-to-action-6 */
.call-to-action-inner-6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 60px;
}
.call-to-action-inner-6 .coll-to-info p {
  margin-bottom: 0;
}
.call-to-action-inner-6 .coll-to-info p + p {
  margin-top: 15px;
}
.call-to-action-inner-6 .btn-wrapper {
  margin-top: 0;
}

/* Device :991px. */
@media (max-width: 991px) {
  .ltn__call-to-4-img-1,
  .ltn__call-to-4-img-2 {
    display: none;
  }
  .ltn__call-to-action-4 .call-to-action-inner-4 .h1 {
    font-size: 30px;
  }
  .ltn__call-to-action-4 .call-to-action-inner-4 p {
    font-size: 14px;
  }
  .call-to-action-inner-6 {
    padding: 50px 25px;
    flex-flow: column;
  }
  .call-to-action-inner-6 .btn {
    margin-top: 30px;
  }
}
/* small mobile :320px. */
@media (max-width: 767px) {
  .call-to-action-inner-2 {
    flex-flow: column;
  }
  .call-to-action-inner-2 .btn-wrapper {
    margin-top: 15px;
  }
  .get-a-free-service-inner {
    display: block;
    padding-right: 0;
    padding-left: 0px;
  }
  .get-a-free-service-inner .call-to-img {
    margin-bottom: 40px;
  }
  .get-a-free-service-inner .call-to-img img {
    max-width: 100%;
    position: relative;
    left: 0;
  }
  .call-to-circle-1,
  .call-to-circle-2 {
    display: none;
  }
  .ltn__call-to-action-4 .call-to-action-inner-4 .h1 {
    font-size: 24px;
  }
}
/* small mobile :320px. */
@media (max-width: 580px) {
  .call-to-action-inner-6 h1 br,
  .call-to-action-inner-6 h2 br,
  .call-to-action-inner-6 h3 br {
    display: none;
  }
}
/* ----------------------------------------------------
    Elements Area
---------------------------------------------------- */
.ltn__elements-area {
  background-color: var(--section-bg-1);
  padding: 50px 0;
  margin: 50px 0;
}

.elements-title-area {
  text-align: center;
}

.elements-title-inner {
  background-color: var(--white-3);
  display: inline-block;
  padding: 10px 30px;
  outline: 10px solid;
  outline-offset: 10px;
  outline-color: var(--white-3);
  margin: 20px;
}
.elements-title-inner p {
  margin-bottom: 0;
  padding-top: 5px;
  border-top: 1px solid #ddd;
  margin-top: 5px;
}

.elements-title {
  display: inline-block;
  margin: 0;
}

/* ----------------------------------------------------
    Service Form 
---------------------------------------------------- */
.ltn__service-form-box {
  margin: 0;
  padding: 0 30px;
}
.ltn__service-form-box > ul {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.ltn__service-form-box > ul > li {
  display: inline-block;
  margin-right: 20px;
  list-style: none;
}
.ltn__service-form-box .nice-select {
  margin: 0;
  height: 60px;
  line-height: 58px;
  padding-right: 40px;
  padding-left: 20px;
  border-radius: 0;
  min-width: 200px;
  font-size: 16px;
  font-weight: 700;
  font-family: var(--ltn__heading-font);
}
.ltn__service-form-box .nice-select:after {
  right: 20px;
}
.ltn__service-form-box .nice-select UL li {
  display: block;
}
.ltn__service-form-box input {
  margin: 0;
}
.ltn__service-form-box input[type=date] {
  margin: 0;
  height: 60px;
  padding: 0 20px;
  border: 1px solid;
  font-weight: 700;
  font-family: var(--ltn__heading-font);
  text-transform: uppercase;
}
.ltn__service-form-box .btn-wrapper {
  margin: 0;
}

.ltn__service-form-color-white .ltn__service-form-box .nice-select {
  background-color: transparent;
  border: 2px solid;
  border-color: var(--border-color-3);
}
.ltn__service-form-color-white .ltn__service-form-box .nice-select .current {
  color: var(--white);
  text-transform: uppercase;
}
.ltn__service-form-color-white .ltn__service-form-box .nice-select::after {
  border-bottom: 2px solid;
  border-right: 2px solid;
  border-color: var(--border-color-3);
}
.ltn__service-form-color-white .ltn__service-form-box input {
  background-color: transparent;
  color: var(--white);
  border-color: var(--border-color-3);
  font-weight: 700;
  height: 60px;
}
.ltn__service-form-color-white .ltn__service-form-box input[type=date] {
  background-color: transparent;
  color: var(--white);
}
.ltn__service-form-color-white .ltn__service-form-box input[type=date]::-webkit-calendar-picker-indicator {
  filter: invert(100%);
}
.ltn__service-form-color-white .ltn__service-form-box input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: var(--white);
}
.ltn__service-form-color-white .ltn__service-form-box input::-moz-placeholder { /* Firefox 19+ */
  color: var(--white);
}
.ltn__service-form-color-white .ltn__service-form-box input:-ms-input-placeholder { /* IE 10+ */
  color: var(--white);
}
.ltn__service-form-color-white .ltn__service-form-box input:-moz-placeholder { /* Firefox 18- */
  color: var(--white);
}
.ltn__service-form-color-white .input-item-date.ltn__custom-icon::before {
  color: var(--white);
  top: 50%;
}

.input-item-date {
  margin-bottom: 30px;
}
.input-item-date input[type=date] {
  background-color: transparent;
  border: 2px solid var(--border-color-1);
  height: 65px;
  width: 100%;
  padding: 0 20px;
}
.input-item-date input[type=date]::-webkit-calendar-picker-indicator {
  filter: invert(0%);
}

.ltn__service-form-1 .ltn__service-form-brief {
  padding-left: 100px;
}

.ltn__service-form-margin {
  margin-top: -160px;
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .ltn__service-form-box {
    padding: 0;
  }
  .ltn__service-form-box .input-item {
    max-width: 200px;
  }
}
@media (max-width: 1199px) {
  .ltn__service-form-box > ul {
    justify-content: center;
  }
}
@media (max-width: 767px) {
  .ltn__service-form-box > ul {
    flex-flow: column;
  }
}
@media (max-width: 575px) {
  .ltn__service-form-1 .ltn__service-form-brief {
    padding-left: 20px;
  }
}
/* ----------------------------------------------------
    Get A Quote Form
---------------------------------------------------- */
.get-a-quote-wrap {
  padding: 40px 50px 50px;
  border: 2px solid;
  border-color: var(--border-color-1);
}

.get-a-quote-form {
  margin: 0;
}
.get-a-quote-form .btn-wrapper {
  padding: 0 40px;
}
.get-a-quote-form .btn {
  width: 100%;
}
.get-a-quote-form input::-webkit-input-placeholder {
  color: var(--ltn__color-1);
}
.get-a-quote-form input::-moz-placeholder {
  color: var(--ltn__color-1);
}
.get-a-quote-form input:-ms-input-placeholder {
  color: var(--ltn__color-1);
}
.get-a-quote-form input:-moz-placeholder {
  color: var(--ltn__color-1);
}

.input-item .nice-select {
  border: 2px solid;
  border-color: var(--border-color-1);
  border-radius: 0;
  font-size: 14px;
  font-weight: 400;
  height: 65px;
  line-height: 60px;
  width: 100%;
  margin-bottom: 30px;
}
.input-item .nice-select .current {
  font-weight: 700;
}
.input-item .nice-select::after {
  display: none;
}
.input-item .nice-select::before {
  content: "\\f063";
  font-size: 14px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: var(--ltn__secondary-color);
}
.input-item::after {
  display: block;
  clear: both;
  content: "";
}

@media (max-width: 1199px) {
  .get-a-quote-form .btn-wrapper {
    padding: 0 0px;
  }
}
@media (max-width: 767px) {
  .get-a-quote-wrap {
    padding: 40px 30px 50px;
  }
}
/* ----------------------------------------------------
    Car Dealer Form
---------------------------------------------------- */
.ltn__car-dealer-form-tab .ltn__tab-menu {
  margin-bottom: 0;
}
.ltn__car-dealer-form-tab .ltn__tab-menu .active {
  border-color: var(--ltn__secondary-color);
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.ltn__car-dealer-form-tab .tab-content {
  padding: 40px;
  background-color: var(--section-bg-1);
}

.ltn__car-dealer-form-box .ltn__car-dealer-form-item {
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
}
.ltn__car-dealer-form-box .nice-select {
  margin: 0;
  height: 60px;
  line-height: 58px;
  padding-right: 40px;
  padding-left: 20px;
  border-radius: 0;
  min-width: 200px;
  font-size: 16px;
  font-weight: 500;
  font-family: var(--ltn__heading-font);
  width: 100%;
}
.ltn__car-dealer-form-box .nice-select .list {
  width: 100%;
  z-index: 99;
}
.ltn__car-dealer-form-box .ltn__custom-icon::before {
  display: none;
}
.ltn__car-dealer-form-box .ltn__custom-icon .nice-select::before {
  content: "\\f063";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  margin-right: 10px;
  color: var(--ltn__secondary-color);
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-calendar .nice-select::before {
  content: "\\f073";
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-car .nice-select::before {
  content: "\\f1b9";
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-meter .nice-select::before {
  content: "\\f3fd";
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-ring .nice-select::before {
  content: "\\f1cd";
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-cog .nice-select::before {
  content: "\\f013";
}
.ltn__car-dealer-form-box .ltn__custom-icon.ltn__icon-transgender .nice-select::before {
  content: "\\f225";
}

.car-price-filter-range .price_filter .ui-widget-content {
  height: 8px;
  background-color: var(--white);
  margin-top: 20px;
}
.car-price-filter-range .price_filter .ui-state-default:last-child::before {
  position: absolute;
}
.car-price-filter-range .price_filter .ui-state-default:last-child::after {
  position: absolute;
  content: "";
  top: -30px;
  left: -5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  z-index: 99;
  width: 125px;
  height: 50px;
  background-repeat: no-repeat;
}
.car-price-filter-range .price_slider_amount > input[type=text],
.car-price-filter-range .price_slider_amount > input[type=submit] {
  font-weight: 700;
}

@media (max-width: 767px) {
  .ltn__car-dealer-form-tab .tab-content {
    padding: 40px 25px;
  }
}
/* ----------------------------------------------------
    Video Area
---------------------------------------------------- */
/* car home 3 */
.ltn__video-popup-margin {
  margin-bottom: -180px;
}

/* Service page */
.ltn__video-popup-margin-2 {
  margin-top: -295px;
}

/* ----------------------------------------------------
    Brand Logo
---------------------------------------------------- */
.ltn__brand-logo-item {
  filter: grayscale(0);
  opacity: 1;
  transition: all 0.3s ease 0s;
  margin: 10px 0;
}
.ltn__brand-logo-item img {
  transition: all 0.3s ease 0s;
}
.ltn__brand-logo-item:hover {
  filter: grayscale(0);
  opacity: 1;
}
.ltn__brand-logo-item:hover img {
  transform: scale(1.1);
}

/* ----------------------------------------------------
    Progress Bar 
---------------------------------------------------- */
.ltn__progress-bar-wrap {
  margin-bottom: 50px;
}

.ltn__progress-bar-item {
  overflow: hidden;
  margin-bottom: 10px;
}
.ltn__progress-bar-item > p {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}
.ltn__progress-bar-item .progress {
  background: #ebeeee none repeat scroll 0 0;
  border-radius: 0;
  box-shadow: none;
  font-weight: 400;
  height: 3px;
  letter-spacing: 1px;
  margin-bottom: 15px;
  margin-top: 12px;
  overflow: visible;
  text-transform: uppercase;
  position: relative;
}
.ltn__progress-bar-item .progress-bar {
  background-color: var(--ltn__secondary-color);
  box-sizing: border-box;
  color: var(--ltn__secondary-color);
  font-size: 11px;
  overflow: visible;
  height: 7px;
  margin-top: -2px;
  text-align: left;
  position: relative;
}
.ltn__progress-bar-item .progress-bar span {
  border-radius: 15px;
  display: inline-block;
  height: 25px;
  letter-spacing: 0;
  line-height: 24px;
  min-width: 25px;
  padding: 0 3px;
  position: absolute;
  right: 0;
  text-align: center;
  bottom: 15px;
  font-size: 18px;
  font-weight: 700;
  transition: all 0.3s ease 0s;
}

/* progress-bar-item-2 */
.ltn__progress-bar-item-2 {
  margin-bottom: 50px;
}
.ltn__progress-bar-item-2 .progress {
  width: 160px;
  height: 160px;
  background: none;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
.ltn__progress-bar-item-2 .progress::after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 10px solid #eee;
  position: absolute;
  top: 0;
  left: 0;
}
.ltn__progress-bar-item-2 .progress > span {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
}
.ltn__progress-bar-item-2 .progress .progress-bar {
  width: 100%;
  height: 100%;
  background: none;
  border-width: 10px;
  border-style: solid;
  position: absolute;
  top: 0;
  border-color: var(--ltn__secondary-color) !important;
}
.ltn__progress-bar-item-2 .progress .progress-left {
  left: 0;
}
.ltn__progress-bar-item-2 .progress .progress-left .progress-bar {
  left: 100%;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-left: 0;
  transform-origin: center left;
}
.ltn__progress-bar-item-2 .progress .progress-right {
  right: 0;
}
.ltn__progress-bar-item-2 .progress .progress-right .progress-bar {
  left: -100%;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  border-right: 0;
  transform-origin: center right;
}
.ltn__progress-bar-item-2 .progress .progress-value {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ltn__progress-bar-item-2 .progress .progress-count {
  font-size: 50px;
  font-weight: 700;
}
.ltn__progress-bar-item-2 .progress .progress-count sup, .ltn__progress-bar-item-2 .progress .progress-count sub {
  font-weight: 400;
  font-size: 20px;
  color: var(--ltn__secondary-color);
}
.ltn__progress-bar-item-2 .ltn__progress-info {
  margin-top: 25px;
}
.ltn__progress-bar-item-2 .ltn__progress-info h3 {
  margin-bottom: 5px;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .ltn__progress-bar-item > p {
    font-size: 14px;
  }
}
/* ----------------------------------------------------
    Our Journey Area
---------------------------------------------------- */
.ltn__our-journey-wrap ul {
  margin-left: 0;
  padding-left: 0;
}
.ltn__our-journey-wrap > ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.ltn__our-journey-wrap > ul::before {
  position: absolute;
  content: "";
  background-color: #d13724;
  height: 4px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}
.ltn__our-journey-wrap > ul li {
  list-style: none;
  margin: 0;
}
.ltn__our-journey-wrap > ul > li {
  display: inline-block;
  position: relative;
  margin: 0 10px;
}
.ltn__our-journey-wrap > ul > li:nth-last-child(1) ul, .ltn__our-journey-wrap > ul > li:nth-last-child(2) ul {
  left: auto;
  right: 0;
}
.ltn__our-journey-wrap > ul > li::before {
  position: absolute;
  content: "";
  top: 15px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #fff;
  left: 0;
  right: 0;
  margin: auto;
  transition: all 0.3s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__our-journey-wrap > ul > li ul {
  position: absolute;
  bottom: 100%;
  transition: all 0.3s ease 0s;
  opacity: 0;
  visibility: hidden;
}
.ltn__our-journey-wrap > ul > li.active .ltn__journey-icon, .ltn__our-journey-wrap > ul > li:hover .ltn__journey-icon {
  background-color: var(--white);
  color: var(--ltn__secondary-color);
}
.ltn__our-journey-wrap > ul > li.active ul, .ltn__our-journey-wrap > ul > li:hover ul {
  opacity: 1;
  visibility: visible;
}
.ltn__our-journey-wrap > ul > li.active::before, .ltn__our-journey-wrap > ul > li:hover::before {
  opacity: 1;
  visibility: visible;
}
.ltn__our-journey-wrap .ltn__journey-icon {
  font-size: 20px;
  font-weight: 700;
  padding: 40px;
  background-color: var(--ltn__primary-color);
  color: var(--white);
  display: block;
  margin: 30px 0;
  transition: all 0.3s ease 0s;
  box-shadow: var(--ltn__box-shadow-2);
  text-align: center;
}
.ltn__our-journey-wrap .dropdown-menu {
  padding: 0;
}

.ltn__journey-history-item-info {
  background-color: var(--white);
  padding: 20px;
  display: block;
  width: 550px;
  box-shadow: var(--ltn__box-shadow-2);
  position: relative;
}
.ltn__journey-history-item-info .ltn__journey-history-img {
  float: left;
  margin-right: 20px;
  max-width: 150px;
}
.ltn__journey-history-item-info .ltn__journey-history-info {
  overflow: hidden;
}
.ltn__journey-history-item-info h3 {
  margin-bottom: 5px;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ltn__journey-history-item-info {
    width: 500px;
  }
}
@media (max-width: 1199px) {
  .ltn__our-journey-wrap .ltn__journey-icon {
    font-size: 18px;
    padding: 20px;
  }
}
@media (max-width: 991px) {
  .ltn__journey-history-item-info {
    width: 350px;
  }
  .ltn__journey-history-item-info .ltn__journey-history-img {
    float: none;
    margin-bottom: 20px;
    max-width: 100px;
  }
}
@media (max-width: 767px) {
  .ltn__our-journey-wrap > ul {
    flex-flow: column;
  }
  .ltn__our-journey-wrap > ul > li ul {
    left: 30px;
  }
  .ltn__our-journey-wrap > ul > li:nth-last-child(1) ul,
  .ltn__our-journey-wrap > ul > li:nth-last-child(2) ul {
    left: 30px;
    right: auto;
  }
}
@media (max-width: 575px) {
  .ltn__journey-history-item-info {
    width: 250px;
  }
  .ltn__journey-history-item-info .ltn__journey-history-img {
    float: none;
    margin-bottom: 20px;
  }
}
/* ----------------------------------------------------
    Google Map Locations Area
---------------------------------------------------- */
.ltn__google-map-locations-area #gmap {
  height: 90vh;
}
.ltn__google-map-locations-area #gmap .gm-ui-hover-effect {
  top: 0 !important;
  right: 0 !important;
}
.ltn__google-map-locations-area #gmap .gm-style .gm-style-iw-c {
  padding: 25px 8px 5px 25px !important;
  border-radius: 0;
}

.ltn__map-item {
  padding: 30px 25px 35px;
  box-shadow: var(--ltn__box-shadow-4);
}
.ltn__map-item .ltn__location-name {
  border-bottom: 2px solid var(--border-color-1);
  margin-bottom: 25px;
  color: var(--ltn__secondary-color);
  font-size: 20px;
}
.ltn__map-item .ltn__location-single-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}
.ltn__map-item .ltn__location-single-info i {
  margin-right: 10px;
  background: var(--ltn__secondary-color);
  color: var(--white);
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.ltn__map-item .btn-wrapper {
  display: flex;
  justify-content: space-between;
}
.ltn__map-item .btn {
  padding: 10px 10px;
  font-size: 13px;
  margin-right: 10px;
}

.ltn__google-map-locations-list-area .ltn__map-item {
  margin-bottom: 50px;
}

.ltn__location-search h3 {
  float: left;
  margin-right: 30px;
  margin-bottom: 0;
  line-height: 63px;
  color: var(--white);
}
.ltn__location-search .input-item {
  float: left;
  width: 300px;
}
.ltn__location-search form {
  padding: 50px 50px 20px;
  background-color: var(--ltn__secondary-color);
}

.ltn__state-location-title {
  padding: 15px 30px;
  background-color: var(--ltn__secondary-color);
  color: var(--white);
  margin: 50px 0;
}

.ltn__map-product-item {
  max-width: 260px;
}
.ltn__map-product-item img {
  max-width: 100%;
  margin-bottom: 25px;
}
.ltn__map-product-item .ltn__map-product-title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}
.ltn__map-product-item .ltn__map-product-price {
  color: var(--ltn__secondary-color);
}
.ltn__map-product-item .ltn__map-product-location {
  font-weight: 500;
}
.ltn__map-product-item .ltn__map-product-location i {
  color: var(--ltn__secondary-color);
  margin-right: 2px;
}
.ltn__map-product-item .ltn__map-product-info {
  font-weight: 500;
}
.ltn__map-product-item .ltn__map-product-info span {
  margin-right: 10px;
}

/* ----------------------------------------------------
    Team Details
---------------------------------------------------- */
.ltn__team-details-member-info .team-details-img {
  margin-bottom: 30px;
  max-width: 350px;
}
.ltn__team-details-member-info.text-right .team-details-img {
  margin-left: auto;
  margin-right: 0;
}
.ltn__team-details-member-info.text-center .team-details-img {
  margin-left: auto;
  margin-right: auto;
}

.ltn__team-details-member-about ul {
  margin: 0;
}
.ltn__team-details-member-about ul li {
  list-style: none;
  display: block;
}
.ltn__team-details-member-about ul li strong {
  min-width: 120px;
  display: inline-block;
}
.ltn__team-details-member-about > ul {
  padding: 0;
}

/* ----------------------------------------------------
    Our History Area
---------------------------------------------------- */
.ltn__our-history-inner .ltn__tab-menu .nav {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.ltn__our-history-inner .ltn__tab-menu .nav::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  width: 100%;
  height: 2px;
  background-color: var(--white-6);
  z-index: -1;
}
.ltn__our-history-inner .ltn__tab-menu a {
  background-color: var(--white);
  border: 2px solid var(--white-6);
}
.ltn__our-history-inner .ltn__tab-menu .active {
  border-color: var(--ltn__secondary-color);
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.ltn__history-icon {
  position: absolute;
  bottom: 40px;
  right: 0;
  font-size: 160px;
  line-height: 1;
  color: var(--ltn__secondary-color);
}
.ltn__history-icon i {
  margin: 0;
}

.ltn__our-history-inner .about-img-left {
  padding-right: 70px;
}
.ltn__our-history-inner .about-img-right {
  padding-left: 70px;
}

.ltn__our-history-inner-2 .ltn__tab-menu {
  margin-bottom: 20px;
}
.ltn__our-history-inner-2 .ltn__tab-menu .nav {
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.ltn__our-history-inner-2 .ltn__tab-menu .nav::before {
  display: none;
}
.ltn__our-history-inner-2 .ltn__tab-menu a {
  background-color: transparent;
  border: 2px solid transparent;
  font-size: 22px;
  padding: 5px 20px;
}
.ltn__our-history-inner-2 .ltn__tab-menu .active {
  border-color: transparent;
  background-color: transparent;
  color: var(--ltn__secondary-color);
}

@media (max-width: 767px) {
  .ltn__history-icon {
    bottom: 10px;
    right: 10px;
    font-size: 80px;
  }
  .ltn__our-history-inner .about-img-left {
    padding-right: 0px;
  }
  .ltn__our-history-inner .about-img-right {
    padding-left: 0px;
  }
}
/* ----------------------------------------------------
    Appointment Form Area
---------------------------------------------------- */
.ltn__appointment-inner .alert {
  border-radius: 0;
  padding: 20px 30px;
  margin-bottom: 30px;
}
.ltn__appointment-inner .alert-danger {
  font-weight: 600;
  font-size: 14px;
}

/* ----------------------------------------------------
    Checkout Page
---------------------------------------------------- */
.ltn__checkout-single-content {
  margin-bottom: 30px;
}
.ltn__checkout-single-content h5 {
  background-color: var(--section-bg-1);
  padding: 20px 30px;
}

.ltn__checkout-single-content-info {
  padding: 30px;
  border: 1px solid var(--border-color-1);
}

.ltn__checkout-payment-method .card {
  padding: 20px;
  border-radius: 0;
}
.ltn__checkout-payment-method .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.ltn__checkout-payment-method .card-body {
  padding: 15px 30px;
  box-shadow: var(--ltn__box-shadow-3);
  margin-top: 15px;
  position: relative;
}
.ltn__checkout-payment-method .card-body::before {
  position: absolute;
  top: -3px;
  left: 25px;
  width: 10px;
  height: 10px;
  content: "";
  transform: rotate(45deg);
  background-color: #fff;
}
.ltn__checkout-payment-method .ltn__card-title {
  position: relative;
  padding-left: 30px;
  margin-bottom: 0;
}
.ltn__checkout-payment-method .ltn__card-title::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  content: "";
  transform: translateY(-50%);
  border: 1px solid #333;
  border-radius: 50%;
}
.ltn__checkout-payment-method .ltn__card-title::after {
  position: absolute;
  top: 50%;
  left: 2px;
  width: 11px;
  height: 11px;
  margin-top: 2px;
  content: "";
  transition: all 0.5s ease 0s;
  transform: translateY(-50%);
  opacity: 0;
  border-radius: 50%;
  background-color: #333;
}
.ltn__checkout-payment-method .ltn__card-title img {
  height: 45px;
  margin-left: 10px;
}
.ltn__checkout-payment-method .ltn__card-title[aria-expanded=true]::after {
  opacity: 1;
}
.ltn__checkout-payment-method p {
  font-size: 14px;
}
.ltn__checkout-payment-method p:last-child {
  margin-bottom: 0;
}

/* ----------------------------------------------------
    Myaccount Page
---------------------------------------------------- */
.ltn__tab-menu-list .nav {
  display: block;
  margin-right: 30px;
  border: 1px solid #eee;
}
.ltn__tab-menu-list .nav a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border-color-1);
}
.ltn__tab-menu-list .nav a:last-child {
  border-bottom: 0;
}
.ltn__tab-menu-list .nav a i {
  font-size: 14px;
}
.ltn__tab-menu-list .nav a.active {
  background-color: var(--section-bg-2);
  color: var(--white);
}

.ltn__myaccount-tab-content-inner > p {
  padding: 20px;
  background-color: var(--section-bg-1);
}

/* ----------------------------------------------------
    Time Schedule Area
---------------------------------------------------- */
.ltn__time-schedule-widget {
  padding: 50px 40px;
  margin-top: -10px;
}
.ltn__time-schedule-widget h3 {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 20px;
  margin-bottom: 25px;
}
.ltn__time-schedule-widget ul {
  padding: 0;
  margin: 0;
}
.ltn__time-schedule-widget ul li {
  display: block;
}
.ltn__time-schedule-widget ul li span {
  float: right;
}

/* ----------------------------------------------------
    Contact Feature
---------------------------------------------------- */
.ltn__contact-feature-item {
  display: flex;
  align-items: center;
  padding: 25px 30px 20px;
  box-shadow: var(--ltn__box-shadow-4);
  margin-bottom: 30px;
  background-color: var(--white);
}

.ltn__contact-feature-icon {
  font-size: 50px;
  margin-right: 20px;
  color: var(--ltn__secondary-color);
  line-height: 1;
  max-width: 50px;
}

.ltn__contact-feature-info .h6,
.ltn__contact-feature-info .h2 {
  font-family: var(--ltn__body-font);
}
.ltn__contact-feature-info .h6 {
  color: var(--ltn__color-3);
}

@media (max-width: 1400px) {
  .ltn__contact-feature-icon {
    font-size: 40px;
    margin-right: 15px;
  }
  .ltn__contact-feature-info .h6 {
    font-size: 14px;
  }
  .ltn__contact-feature-info .h2 {
    font-size: 18px;
  }
}
/* ----------------------------------------------------
    Image Slide (Screenshot)
---------------------------------------------------- */
.ltn__img-slide-item-4 > a,
.ltn__img-slide-item-3 > a,
.ltn__img-slide-item-2 > a {
  display: block;
  overflow: hidden;
}
.ltn__img-slide-item-4 img,
.ltn__img-slide-item-3 img,
.ltn__img-slide-item-2 img {
  transition: all 0.5s ease 0s;
}
.ltn__img-slide-item-4:hover img,
.ltn__img-slide-item-3:hover img,
.ltn__img-slide-item-2:hover img {
  transform: scale(1.1);
}

/* ----------------------------------------------------
    Background Video
---------------------------------------------------- */
/* Video From Local (src="myFolderName/videoName.mp4") */
/*
#myVideo {
    position: absolute;
    right: 0;
    bottom: 0;
    min-width: 100%; 
    min-height: 100%;
}

*/
#myVideo {
  position: absolute;
  left: 0;
  right: auto;
  bottom: 0;
  width: 100%;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}

/* Video From Link (src="website.com/videoUrl") */
.video-foreground,
.video-background iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ltn__video-play-btn {
  margin-top: 0;
  width: 60px;
  height: 60px;
  line-height: 65px;
  display: inline-block;
  text-align: center;
  border-radius: 100%;
  box-shadow: var(--ltn__box-shadow-2);
}

/* YouTube Video */
.ltn__youtube-video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

/* ----------------------------------------------------
    Newsletter Popup 2
---------------------------------------------------- */
.ltn__newsletter-popup-2 .modal-header .close {
  background-color: var(--section-bg-1);
  color: var(--ltn__heading-color);
  border-radius: 0px 0px 0px 20px;
}
.ltn__newsletter-popup-2 .modal-body {
  padding: 0;
}
.ltn__newsletter-popup-2 .ltn__newsletter-popup-info {
  padding: 30px;
}

/* ----------------------------------------------------
    Newsletter Popup
---------------------------------------------------- */
.ltn__newletter-popup-active {
  max-width: 850px;
  background: #fff;
  top: 50% !important;
  margin-top: -179px;
  position: fixed !important;
  display: none;
}

.ltn__newletter-popup {
  position: relative;
  padding: 30px;
}
.ltn__newletter-popup p {
  font-size: 14px;
}
.ltn__newletter-popup .subscribe-bottom {
  font-size: 14px;
}

.ltn__newsletter-close {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  z-index: 999;
}

.ltn__newsletter-close:hover {
  color: var(--ltn__secondary-color);
}

.ltn__newsletter-close-btn-left {
  right: auto;
  left: 0;
}

.ltn__newsletter-popup-info {
  padding: 15px;
}

.text-center .ltn__newsletter-popup-info input[type=email] {
  text-align: center;
}

.ltn__newletter-popup-3 {
  padding: 0;
}
.ltn__newletter-popup-3 .ltn__newsletter-popup-info {
  padding: 30px;
}

.ltn__newletter-popup-4 {
  padding: 0;
}
.ltn__newletter-popup-4 .ltn__newsletter-popup-info {
  padding: 30px 30px 30px 10px;
}

@media (max-width: 991px) {
  .ltn__newletter-popup-active {
    max-width: 400px;
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .ltn__newsletter-popup-img {
    display: none;
  }
}
@media (max-width: 768px) {
  .ltn__newletter-popup-active {
    max-width: 300px;
  }
}
/* ----------------------------------------------------
    Apartments Plan Area
---------------------------------------------------- */
.apartments-plan-info {
  padding: 70px;
}

.apartments-plan-info,
.apartments-plan-img {
  margin-bottom: 50px;
}

.apartments-info-list > ul {
  padding: 0;
  margin: 0;
}
.apartments-info-list > ul li {
  list-style: none;
  margin-top: 10px;
  display: block;
  font-size: 16px;
  font-weight: 600;
  position: relative;
}
.apartments-info-list > ul li::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  top: 50%;
  transform: translateY(-50%);
  border: 1px dashed;
  border-color: var(--section-bg-5);
  z-index: 1;
}
.apartments-info-list > ul li a {
  display: block;
}
.apartments-info-list > ul li a span {
  float: right;
}
.apartments-info-list > ul li label {
  padding-right: 10px;
  background-color: var(--white);
  position: relative;
  z-index: 2;
}
.apartments-info-list > ul li span {
  float: right;
  padding-left: 10px;
  background-color: var(--white);
  position: relative;
  z-index: 2;
}

.apartments-info-list-color > ul li::before {
  border-color: var(--section-bg-5);
}
.apartments-info-list-color > ul li label {
  background-color: var(--ltn__secondary-color);
}
.apartments-info-list-color > ul li span {
  background-color: var(--ltn__secondary-color);
}

.section-bg-1 .apartments-info-list-color > ul li::before {
  border-color: var(--ltn__color-1);
}
.section-bg-1 .apartments-info-list-color > ul li label {
  background-color: var(--section-bg-1);
}
.section-bg-1 .apartments-info-list-color > ul li span {
  background-color: var(--section-bg-1);
}

@media (max-width: 767px) {
  .apartments-plan-info {
    padding: 30px;
  }
  .apartments-info-list ul li {
    font-size: 14px;
  }
}
/* ----------------------------------------------------
    Upcoming Project Area
---------------------------------------------------- */
.ltn__upcoming-project-item {
  padding: 30px 45px 30px 30px;
  box-shadow: var(--ltn__box-shadow-4);
  margin-top: 10px;
  margin-bottom: 50px;
  background-color: var(--white);
}
.ltn__upcoming-project-item .ltn__upcoming-project-img {
  margin-top: 0;
}
.ltn__upcoming-project-item .ltn__upcoming-project-info {
  padding: 50px 20px;
}

@media (max-width: 991px) {
  .ltn__upcoming-project-item {
    padding: 30px 30px 30px 30px;
  }
  .ltn__upcoming-project-item .ltn__upcoming-project-img {
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .ltn__upcoming-project-item .ltn__upcoming-project-info {
    padding: 50px 0px;
  }
}
/* ----------------------------------------------------
    Search By Place Area
---------------------------------------------------- */
.ltn__search-by-place-item {
  padding: 15px;
  box-shadow: var(--ltn__box-shadow-4);
  background-color: var(--white);
  margin-bottom: 50px;
}
.ltn__search-by-place-item .search-by-place-img {
  position: relative;
}
.ltn__search-by-place-item .search-by-place-img .search-by-place-badge {
  position: absolute;
  top: 0;
  left: 10px;
}
.ltn__search-by-place-item .search-by-place-img .search-by-place-badge ul {
  padding: 0;
  margin: 0;
}
.ltn__search-by-place-item .search-by-place-img .search-by-place-badge ul li {
  display: inline-block;
  background-color: var(--white);
  padding: 6px 15px 2px;
  border-radius: 25px;
  box-shadow: var(--ltn__box-shadow-4);
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 600;
}
.ltn__search-by-place-item .search-by-place-info {
  padding: 30px 5px 10px;
}
.ltn__search-by-place-item .search-by-place-info h6 {
  font-family: var(--ltn__body-font);
  color: var(--ltn__color-5);
  font-weight: 400;
}
.ltn__search-by-place-item .search-by-place-info h4 {
  font-weight: 600;
}
.ltn__search-by-place-item .search-by-place-info .search-by-place-btn a {
  color: var(--ltn__secondary-color);
}
.ltn__search-by-place-item .search-by-place-brief {
  font-size: 14px;
  margin-top: 10px;
}

/* ----------------------------------------------------
    Select Availability Table Area
---------------------------------------------------- */
.ltn__select-availability-table-wrap .tower-name {
  text-transform: uppercase;
}

.ltn__select-availability-table ul {
  padding: 0 0 15px;
  margin: 0;
  display: flex;
}
.ltn__select-availability-table ul li {
  list-style: none;
  display: inline-block;
  flex: 1 1;
  text-align: center;
}
.ltn__select-availability-table .ltn__select-availability-table-head {
  border-bottom: 2px solid;
  border-color: var(--border-color-1);
}
.ltn__select-availability-table .ltn__select-availability-table-row:nth-child(odd) {
  background-color: var(--section-bg-1);
}

.ltn__select-availability-table-responsive .ltn__select-availability-table-row-responsive-item {
  padding: 10px 0 25px;
  margin: 0;
  text-align: center;
}
.ltn__select-availability-table-responsive .ltn__select-availability-table-row-responsive-item:nth-child(odd) {
  background-color: var(--section-bg-1);
}
.ltn__select-availability-table-responsive .ltn__select-availability-table-row-responsive-item li {
  display: block;
  list-style: none;
}
.ltn__select-availability-table-responsive .ltn__select-availability-table-row-responsive-item li::after {
  display: block;
  clear: both;
  content: "";
}
.ltn__select-availability-table-responsive .ltn__select-availability-table-row-responsive-item li span {
  width: 50%;
  float: left;
}

/* ----------------------------------------------------
    Neighbour Area
---------------------------------------------------- */
.ltn__neighbour-tab-wrap {
  position: relative;
}
.ltn__neighbour-tab-wrap .ltn__tab-menu-4 {
  position: absolute;
  z-index: 2;
  bottom: 10px;
  left: 20px;
}

@media (max-width: 991px) {
  .ltn__neighbour-tab-wrap .ltn__tab-menu-4 {
    position: inherit;
    margin-bottom: 30px;
    left: inherit;
    bottom: inherit;
  }
  .ltn__neighbour-tab-wrap .ltn__tab-menu-4 a img {
    max-width: 70px;
  }
}
/* ----------------------------------------------------
    LightCase
---------------------------------------------------- */
#lightcase-overlay {
  z-index: 9999;
  background: var(--section-bg-2);
}

#lightcase-case {
  z-index: 99999;
}

/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* ----------------------------------------------------
    Footer Default Style
---------------------------------------------------- */
.footer-widget .footer-title {
  font-size: 22px;
}

/* footer-2 */
.ltn__footer-2 .footer-widget .footer-title {
  font-size: 24px;
}
.ltn__footer-2 .footer-widget p,
.ltn__footer-2 .footer-widget li {
  font-size: 16px;
}
.ltn__footer-2 .footer-about-widget .footer-logo {
  position: relative;
  top: -20px;
  margin-bottom: 10px;
}
.ltn__footer-2 .footer-menu ul li {
  margin-bottom: 30px;
  font-weight: 600;
}

.ltn__footer-2 .footer-widget .ltn__blog-meta li,
.footer-widget .ltn__blog-meta li {
  font-size: 14px;
}

/* footer-color-1 */
.ltn__footer-color-1 p {
  color: var(--ltn__color-2);
}
.ltn__footer-color-1 p a {
  color: var(--white);
}
.ltn__footer-color-1 .ltn__footer-timeline-widget-1 li span {
  color: var(--ltn__color-1);
}
.ltn__footer-color-1 .ltn__footer-timeline-widget-1 li:last-child span {
  color: var(--white);
}
.ltn__footer-color-1 .footer-menu ul li {
  color: var(--ltn__color-2);
}
.ltn__footer-color-1 .ltn__footer-blog-item {
  border-color: var(--border-color-6);
}
.ltn__footer-color-1 .ltn__footer-blog-item .ltn__blog-meta li {
  color: var(--ltn__color-2);
}
.ltn__footer-color-1 .ltn__copyright-area {
  background-color: var(--ltn__primary-color-2);
}
.ltn__footer-color-1 .get-support-info h6 {
  color: var(--ltn__color-4);
}
.ltn__footer-color-1 .get-support-info h4 {
  color: var(--white);
}
.ltn__footer-color-1 .ltn__copyright-menu ul li {
  color: var(--white);
}

/* footer-color-2 */
.ltn__footer-color-2 .ltn__footer-timeline-widget-1 {
  background-color: var(--white);
}
.ltn__footer-color-2 .ltn__footer-timeline-widget-1 li {
  border-color: transparent;
}
.ltn__footer-color-2 .ltn__footer-timeline-widget-1 li:last-child span {
  color: var(--ltn__secondary-color);
}
.ltn__footer-color-2 .ltn__footer-blog-item {
  border-color: var(--border-color-7);
}
.ltn__footer-color-2 .ltn__copyright-area {
  background-color: var(--white-4);
}

/*-------------------------
    Footer Area
-------------------------*/
.footer-top-area {
  padding-top: 92px;
  padding-bottom: 20px;
}

.footer-widget {
  margin-bottom: 60px;
}

.footer-logo {
  position: relative;
  top: -10px;
}

.footer-title {
  font-size: 20px;
  margin-bottom: 25px;
}

/* ----------------------------------------------------
    Footer About Widget
---------------------------------------------------- */
/* footer-address */
.footer-address ul {
  margin: 0;
  padding: 0;
}
.footer-address ul li {
  list-style: none;
  display: block;
  margin-top: 8px;
}
.footer-address ul li:after {
  display: block;
  clear: both;
  content: "";
}
.footer-address ul li .footer-address-icon {
  float: left;
  margin-right: 15px;
}
.footer-address ul li .footer-address-info {
  overflow: hidden;
}
.footer-address ul li .footer-address-info p {
  margin-bottom: 0;
}

/* ----------------------------------------------------
    Footer Menu Widget
---------------------------------------------------- */
/* footer-menu */
.footer-menu ul {
  margin: 0;
  padding: 0;
}
.footer-menu ul li {
  list-style: none;
  margin-top: 0px;
  margin-bottom: 15px;
  position: relative;
}
.footer-menu ul li a {
  position: relative;
}
.footer-menu ul li a::before {
  position: absolute;
  content: "//";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: inherit;
  opacity: 0;
  visibility: hidden;
  margin-left: -20px;
  color: var(--ltn__secondary-color);
}
.footer-menu ul li:hover a {
  padding-left: 20px;
}
.footer-menu ul li:hover a::before {
  opacity: 1;
  visibility: visible;
  margin-left: 0;
}

.footer-menu ul ul {
  margin-left: 15px;
}

/* footer-menu-widget-2-column */
.footer-menu-widget-2-column {
  padding-left: 30px;
}
.footer-menu-widget-2-column .footer-menu {
  width: 50%;
  float: left;
}
.footer-menu-widget-2-column .footer-menu:nth-child(odd) {
  padding-left: 20px;
}
.footer-menu-widget-2-column ul {
  margin: 0;
}
.footer-menu-widget-2-column ul li {
  font-weight: 600;
}

/* ----------------------------------------------------
    Footer Newsletter Widget
---------------------------------------------------- */
.footer-newsletter form {
  position: relative;
}
.footer-newsletter input[type=email] {
  margin: 0;
  padding-right: 50px;
}
.footer-newsletter .btn-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  height: 100%;
}
.footer-newsletter .btn-wrapper .btn {
  padding: 0 18px;
  height: 100%;
}

/* ----------------------------------------------------
    Footer Timeline Widget
---------------------------------------------------- */
.ltn__footer-timeline-widget {
  padding: 50px 50px 40px;
  border-bottom: 5px solid;
  border-color: var(--border-color-5);
  margin-top: -92px;
}
.ltn__footer-timeline-widget .footer-title {
  font-size: 36px;
}
.ltn__footer-timeline-widget ul {
  margin: 0;
  padding: 0;
}
.ltn__footer-timeline-widget ul li {
  list-style: none;
  font-family: var(--ltn__heading-font);
  font-weight: 700;
  border-bottom: 1px solid;
  border-color: var(--border-color-6);
  padding-bottom: 10px;
  margin-top: 10px;
}
.ltn__footer-timeline-widget ul li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.ltn__footer-timeline-widget ul li:last-child span {
  font-weight: 700;
}
.ltn__footer-timeline-widget ul li span {
  float: right;
  font-weight: 600;
}

/* ----------------------------------------------------
    Footer Blog Widget
---------------------------------------------------- */
.ltn__footer-blog-item {
  border-bottom: 1px solid;
  border-color: var(--border-color-6);
  margin-bottom: 20px;
}
.ltn__footer-blog-item:last-child {
  border-bottom: 0;
  margin-bottom: 0;
}
.ltn__footer-blog-item .ltn__blog-meta {
  margin-bottom: 5px;
}
.ltn__footer-blog-item .ltn__blog-meta i {
  color: var(--ltn__secondary-color);
  margin-right: 5px;
}
.ltn__footer-blog-item .ltn__blog-title {
  font-size: 20px;
}

/* ----------------------------------------------------
    Copyright Area
---------------------------------------------------- */
.ltn__copyright-area {
  padding-top: 25px;
  padding-bottom: 25px;
}
.ltn__copyright-area .payment-method {
  text-align: right;
}

.ltn__copyright-design h6, .ltn__copyright-design h4 {
  font-size: 14px;
  font-family: var(--ltn__body-font);
  font-weight: 700;
}
.ltn__copyright-design p {
  margin-bottom: 0;
}

.ltn__copyright-menu ul {
  margin: 0;
  padding: 0;
}
.ltn__copyright-menu ul li {
  list-style: none;
  display: inline-block;
  margin-top: 0;
  margin-right: 20px;
  font-size: 14px;
  font-family: var(--ltn__heading-font);
  font-weight: 600;
}
.ltn__copyright-menu ul li:last-child {
  margin-right: 0;
}
.ltn__copyright-menu ul li a {
  margin: 0;
}

/* ----------------------------------------------------
    Responsive
---------------------------------------------------- */
@media (max-width: 991px) {
  .ltn__footer-timeline-widget {
    padding: 50px 25px 40px;
  }
  .ltn__copyright-area {
    text-align: center;
  }
  .ltn__copyright-area .payment-method {
    text-align: center;
    margin-top: 15px;
  }
  .ltn__copyright-area .site-logo-wrap {
    justify-content: center;
  }
  .ltn__copyright-area .ltn__copyright-menu {
    text-align: center !important;
  }
  #scrollUp {
    font-size: 16px;
    height: 30px;
    width: 30px;
    bottom: 50px;
  }
  #scrollUp i {
    line-height: 30px;
  }
}
@media (max-width: 767px) {
  .ltn__footer-timeline-widget {
    padding: 50px 25px 40px;
  }
  .footer-menu-widget-2-column {
    padding-left: 0;
  }
  .ltn__copyright-menu {
    margin-top: 25px;
  }
  .ltn__footer-2 .footer-widget p,
  .ltn__footer-2 .footer-widget li {
    font-size: 14px;
  }
  .ltn__footer-2 .footer-widget .ltn__blog-meta li,
  .footer-widget .ltn__blog-meta li {
    font-size: 12px;
  }
  .ltn__footer-2 .footer-menu ul li {
    margin-bottom: 20px;
  }
  .ltn__footer-blog-item .ltn__blog-title {
    font-size: 18px;
  }
}
@media (max-width: 575px) {
  .ltn__footer-timeline-widget {
    padding: 50px 25px 40px;
  }
  .footer-menu-widget-2-column .footer-menu {
    width: 100%;
  }
  .footer-menu-widget-2-column .footer-menu:nth-child(odd) {
    padding-left: 0px;
  }
  .ltn__copyright-menu {
    margin-top: 25px;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */
/* -------------------------
    ## Preloader Css
--------------------------- */
.pre-wrap {
  position: fixed;
  content: "";
  transform: translate(-100%, -240%);
  font-size: 62px;
}

.preloader-inner {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
  background-color: rgb(7, 28, 31);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preloader-inner .cancel-preloader {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.preloader-inner .cancel-preloader a {
  background-color: var(--white);
  font-weight: 600;
  text-transform: capitalize;
  color: var(--ltn__primary-color);
  width: 200px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 30px;
  display: block;
  transition: all 0.3s ease 0s;
}
.preloader-inner .cancel-preloader a:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.spinner {
  margin: 120px auto;
  width: 60px;
  height: 60px;
  position: relative;
  text-align: center;
  animation: sk-rotate 2s infinite linear;
}

.dot1, .dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: var(--ltn__secondary-color);
  border-radius: 100%;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  animation-delay: -1s;
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
/*----------------------------------------
  Search Popup
----------------------------------------*/
/* ---------------------------------------
    ## Button
--------------------------------------- */
.btn-wrapper {
  display: block;
  margin-top: 30px;
}

.btn-top {
  background-color: var(--ltn__secondary-color);
  border-radius: 0px;
  display: block;
  font-size: 12px;
  font-weight: 400;
  font-family: var(--ltn__heading-font);
  padding-left: 20px !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  padding-right: 20px !important;
  text-align: center;
  color: #fff !important;
  cursor: pointer;
  height: -moz-fit-content !important;
  height: fit-content !important;
  transition: all 0.3s ease 0s;
  position: relative;
  z-index: 1;
  margin-right: 15px;
}
.btn-top:last-child {
  margin-right: 0;
}

.btn {
  border-radius: 0;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  font-family: var(--ltn__heading-font);
  padding: 17px 35px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  position: relative;
  z-index: 1;
  margin-right: 15px;
}
.btn:last-child {
  margin-right: 0;
}

.theme-btn-top {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.theme-btn-top:hover {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}

.theme-btn-1 {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}
.theme-btn-1:hover {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}

.theme-btn-2 {
  background-color: var(--ltn__primary-color);
  color: var(--white);
}
.theme-btn-2:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.theme-btn-3 {
  background-color: transparent;
  border: 2px solid var(--border-color-9);
}
.theme-btn-3:hover {
  background-color: var(--ltn__secondary-color);
  border-color: var(--ltn__secondary-color);
  color: var(--white);
}

.reverse-color {
  background-color: var(--ltn__secondary-color);
}
.reverse-color:hover {
  background-color: var(--ltn__primary-color);
}

.btn-white {
  background-color: var(--white);
  color: var(--ltn__primary-color);
  box-shadow: var(--ltn__box-shadow-3);
}
.btn-white:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.btn-black {
  background-color: var(--black);
  color: var(--white);
}
.btn-black:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.btn-transparent {
  background-color: transparent;
  box-shadow: var(--ltn__box-shadow-3);
  border-color: #ddd;
}
.btn-transparent:hover {
  background-color: var(--ltn__secondary-color);
  color: var(--white);
}

.btn-round {
  border-radius: 50px;
}

.btn-opacity-6 {
  opacity: 0.6;
}
.btn-opacity-6:hover {
  opacity: 1;
}

.btn-opacity-7 {
  opacity: 0.7;
}
.btn-opacity-7:hover {
  opacity: 1;
}

.btn-opacity-8 {
  opacity: 0.8;
}
.btn-opacity-8:hover {
  opacity: 1;
}

.btn-opacity-9 {
  opacity: 0.9;
}
.btn-opacity-9:hover {
  opacity: 1;
}

.btn:after {
  content: "";
  position: absolute;
  z-index: -1;
  transition: all 0.3s;
}

.btn-effect-1:after {
  width: 0%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--white);
}
.btn-effect-1:hover {
  color: var(--ltn__heading-color);
}
.btn-effect-1:hover::after {
  width: 100%;
}

.btn-effect-2:after {
  width: 0%;
  height: 100%;
  top: 0;
  right: 0;
  background: var(--white);
}
.btn-effect-2:hover {
  color: var(--ltn__heading-color);
}
.btn-effect-2:hover::after {
  width: 100%;
}

.btn-effect-3:after {
  width: 0%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--ltn__primary-color);
}
.btn-effect-3:hover {
  color: var(--white);
}
.btn-effect-3:hover::after {
  width: 100%;
}

.btn-effect-4:after {
  width: 0%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--ltn__secondary-color);
}
.btn-effect-4:hover {
  color: var(--white);
}
.btn-effect-4:hover::after {
  width: 100%;
}

.btn-full-width {
  display: block;
}

.btn-full-width-2 {
  display: block;
  width: 100%;
}

.btn-border {
  border: 2px solid var(--border-color-10);
  box-shadow: none;
}

@media (min-width: 768px) and (max-width: 991px) {
  .btn {
    padding: 12px 25px;
  }
  [type=submit].btn {
    padding: 15px 30px;
  }
}
@media only screen and (max-width: 767px) {
  .btn {
    padding: 10px 20px;
    font-size: 14px;
  }
  [type=submit].btn {
    padding: 12px 30px;
  }
}
/* ----------------------------------------------------
    END
---------------------------------------------------- */`, "",{"version":3,"sources":["webpack://./src/assets/sass/style.scss","webpack://./src/assets/sass/global/_mixins.scss","webpack://./src/assets/sass/global/_global.scss","webpack://./src/assets/sass/global/_gutenberg.scss","webpack://./src/assets/sass/sections/_animation.scss","webpack://./src/assets/sass/sections/_breadcrumb.scss","webpack://./src/assets/sass/sections/_widgets.scss","webpack://./src/assets/sass/sections/_header.scss","webpack://./src/assets/sass/sections/_slider.scss","webpack://./src/assets/sass/sections/_product.scss","webpack://./src/assets/sass/sections/_portfolio.scss","webpack://./src/assets/sass/sections/_main.scss","webpack://./src/assets/sass/sections/_footer.scss","webpack://./src/assets/sass/elements/_preloader.scss","webpack://./src/assets/sass/elements/_search_popup.scss","webpack://./src/assets/sass/elements/_button.scss"],"names":[],"mappings":"AAAA;;;;CAAA;ACuCA,+BAAA;AAqBA,kBAAA;AAOA,gBAAA;AAQA,gBAAA;AAOA,gBAAA;AAsDA,gBAAA;AAOA,cAAA;AASA,WAAA;AAKA,UAAA;AAKA,cAAA;AAaA,qBAAA;AAKA,SAAA;ACpLA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;+DAAA;AAmCA;;uCAAA;AAGA,0IAAA;AACA;;;CAAA;AAMA,qJAAA;AACA;;;CAAA;AAKA;;;;CAAA;AAKA;;;CAAA;AAOA;;;CAAA;AAOA;;sDAAA;AAGA;;EAEI,mBAAA;EACA,kBAAA;AFSJ;;AEPA;EACI,kBAAA;EACA,mBAAA;AFUJ;;AERA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,mBAAA;EACA,kBAAA;EACA,kBAAA;AFWJ;;AERA,kCAAA,sCAAA;EACI,gBAAA;EACA,eAAA;AFWJ;;AETA,oCAAA,iCAAA;EACI,gBAAA;EACA,eAAA;AFYJ;;AETA,4BAAA,oCAAA;EACI;IACI,gBAAA;IACA,iBAAA;EFYN;EEVE;IACI,kBAAA;IACA,iBAAA;EFYN;EETM;IACI,kBAAA;IACA,mBAAA;EFWV;EEVU;IACI,mBAAA;IACA,kBAAA;EFYd;AACF;AEJA,4BAAA,oCAAA;EACI;IACI,kBAAA;IACA,mBAAA;EFMN;EEJE;IACI,mBAAA;IACA,kBAAA;EFMN;EEJE;IACI,kBAAA;IACA,mBAAA;EFMN;EEJE;IACI,mBAAA;IACA,kBAAA;EFMN;AACF;AEFA,4BAAA,oCAAA;EAEQ;IACI,iBAAA;IACA,kBAAA;EFGV;EEAE;IACI,kBAAA;IACA,iBAAA;EFEN;AACF;AEGA;;sDAAA;AAGA;EACI,6BAAA;EACA,+BAAA,EAAA,WAAA;EACA,+BAAA,EAAA,YAAA;EACA,+BAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,YAAA;EACA,6BAAA;EACA,+BAAA;EAEA,+CAAA;EACA,2CAAA;EAEA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,2FAAA;EACA,oFAAA;EACA,uFAAA;EACA,4FAAA;EACA,qFAAA;EAGA,yCAAA;EACA,uBAAA,EAAA,UAAA;EACA,uBAAA,EAAA,UAAA;EACA,uBAAA,EAAA,UAAA;EACA,uBAAA,EAAA,UAAA;EACA,uBAAA,EAAA,UAAA;EAGA,kBAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,QAAA;EACA,yBAAA,EAAA,QAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,UAAA;EACA,yBAAA,EAAA,UAAA;EACA,0BAAA,EAAA,UAAA;EACA,0BAAA,EAAA,UAAA;EACA,0BAAA,EAAA,UAAA;EACA,0BAAA,EAAA,UAAA;EAGA,sBAAA;EACA,uDAAA;EACA,+CAAA,EAAA,gBAAA;EACA,sDAAA,EAAA,oBAAA;EACA,uDAAA;EACA,uDAAA;EAEA,uDAAA;EACA,uDAAA;EAGA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AFdJ;;AEmBA;;uCAAA;AAGA;EACE,SAAA;EACA,UAAA;EACA,YAAA;AFhBF;;AEmBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AFhBF;;AEmBA;EACE,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;AFhBF;;AEmBA;EACE;IACE,uBAAA;EFhBF;EEmBA;IACE,yBAAA;EFjBF;AACF;AEmBA;EACI,8BAAA;EACA,0BAAA;EACA,kCAAA;AFjBJ;;AEmBA;EAEI,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,YAAA;EACA,mCAAA;EACA,YAAA;AFhBJ;;AEkBA;EACI,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;AFfJ;;AEiBA;EACI,eAAA;EACA,gBAAA;AFdJ;;AEgBA;EACI,eAAA;AFbJ;;AEeA;EACI,eAAA;AFZJ;;AEcA;EACI,eAAA;AFXJ;;AEaA;EACI,eAAA;AFVJ;;AEYA;EACI,eAAA;AFTJ;;AEWA;;;;;;;;;;;;EAYI,gCAAA;EACA,WAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AFRJ;;AEUA;EACI,kCAAA;EACA,oBAAA;EACA,qBAAA;EAGA,aAAA;AFPJ;;AESA;EACI,cAAA;EACA,qBAAA;EACA,kCAAA;EACA,4BAAA;AFNJ;;AEQA;;;;EAII,qBAAA;EACA,aAAA;EACA,cAAA;AFLJ;;AEOA;EACI,kCAAA;AFJJ;;AEMA;;;;;EAKI,kCAAA;AFHJ;;AEKA;;;;;;EAMI,kCAAA;AFFJ;;AEIA;EACI,sBAAA;AFDJ;;AEGA;EACI,cAAA;AFAJ;;AEEA;EACI,eAAA;AFCJ;;AECA;;EAEI,gBAAA;AFEJ;;AECA;;uCAAA;AAGA;EACE,gDAAA;AFEF;;AECA;EACE,6BAAA;EACA,WAAA;EACA,kBAAA;AFEF;;AEAA;EACI,qCAAA;AFGJ;AEFI;EACI,qCAAA;AFIR;;AEDA;;;EAGI,qCAAA;AFIJ;AEHI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAYI,mBAAA;AF6BR;AE3BI;;;EACI,gCAAA;AF+BR;;AE5BA;EACI,kBAAA;AF+BJ;AE9BI;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,YAAA;AFgCR;AE9BI;;;;;;;;;;;;EAYI,mBAAA;AFgCR;AE9BI;EACI,6BAAA;AFgCR;AE9BI;;;;EAII,0BAAA;EACA,mBAAA;AFgCR;AE9BI;EACI,mBAAA;AFgCR;AE9BI;EACI,mBAAA;AFgCR;AE9BI;EACI,mBAAA;AFgCR;AE9BI;EACI,mBAAA;AFgCR;AE9BI;EACI,mBAAA;AFgCR;AE9BI;EACI,mCAAA;AFgCR;AE/BQ;EACI,mBAAA;AFiCZ;;AE7BA;EACI,6CAAA;AFgCJ;AE/BI;;;;;;;;;;;;EAYI,mBAAA;AFiCR;AE/BI;EACI,gCAAA;AFiCR;AE9BQ;EACI,0BAAA;AFgCZ;;AE5BA;EACI,qCAAA;AF+BJ;;AE7BA;EACI,qCAAA;AFgCJ;;AE9BA;EACI,qCAAA;AFiCJ;;AE/BA;EACI,mBAAA;AFkCJ;AEjCI;;;;;;;;;;;;EAYI,mBAAA;AFmCR;;AEhCA;EACI,2CAAA;AFmCJ;;AEjCA;EACI,6CAAA;AFoCJ;;AElCA;EACI,6CAAA;AFqCJ;;AEnCA;EACI,6CAAA;AFsCJ;;AEpCA;EACI,+CAAA;AFuCJ;;AErCA;EACI,+CAAA;AFwCJ;;AEtCA;EACI,0BAAA;AFyCJ;;AEvCA;EACI,mBAAA;AF0CJ;;AExCA;EACI,8BAAA;AF2CJ;;AEzCA;EACI,2CAAA;AF4CJ;;AE1CA;EACI,6CAAA;AF6CJ;;AE3CA;EACI,6CAAA;AF8CJ;;AE5CA;EACI,+CAAA;AF+CJ;;AE7CA;EACI,8BAAA;AFgDJ;;AE9CA;EACI,mCAAA;AFiDJ;;AE/CA;EACI,mCAAA;AFkDJ;;AEhDA;EACI,mCAAA;AFmDJ;;AEjDA;EACI,mCAAA;AFoDJ;;AElDA;EACI,mCAAA;AFqDJ;;AEnDA;EACI,kBAAA;AFsDJ;AErDI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,SAAA;EACA,qCAAA;AFuDR;;AEpDA;EACI,kBAAA;AFuDJ;AEtDI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,qCAAA;AFwDR;;AErDA;EACI,kBAAA;AFwDJ;AEvDI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,qCAAA;AFyDR;;AEtDA;EACI,kBAAA;AFyDJ;AExDI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,qCAAA;AF0DR;;AEvDA;EACI,kBAAA;AF0DJ;AEzDI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,MAAA;EACA,2CAAA;AF2DR;;AExDA;EACI,kBAAA;AF2DJ;AE1DI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,MAAA;EACA,2CAAA;AF4DR;;AExDA;EACI,oCAAA;AF2DJ;;AEzDA;EACI,oCAAA;AF4DJ;;AEzDA;EACI,kBAAA;AF4DJ;AE3DI;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;AF6DR;;AE1DA;EACI,uCAAA;AF6DJ;;AE3DA;EACI,2CAAA;AF8DJ;;AE5DA;EACI,2CAAA;AF+DJ;;AE7DA;EACI,8CAAA;AFgEJ;;AE9DA;EACI,8CAAA;AFiEJ;;AE/DA;EACI,2CAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AFkEJ;;AEhEA;EACI,gBAAA;EACA,mBAAA;EACA,4CAAA;AFmEJ;;AEjEA;;EAEI,0BAAA;AFoEJ;;AElEA;EACI,kBAAA;EACA,sBAAA;AFqEJ;;AEnEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AFsEJ;;AEpEA;EACI;IACI,QAAA;EFuEN;EErEE;IACI,QAAA;EFuEN;AACF;AErEA;EACI,kBAAA;AFuEJ;;AErEA;EACI,4BAAA;AFwEJ;;AErEA;EACI,yCAAA;EACA,8BAAA;AFwEJ;;AEtEA;EACE,oCAAA;EACA,8BAAA;AFyEF;;AEvEA;EACE,oCAAA;EACA,8BAAA;AF0EF;;AExEA;EACI,yCAAA;EACA,8BAAA;AF2EJ;;AEzEA;EACI,uCAAA;EACA,8BAAA;AF4EJ;;AE1EA;EACI,0CAAA;EACA,8BAAA;AF6EJ;;AE3EA;EACI,yCAAA;EACA,8BAAA;AF8EJ;;AE5EA;EACI,wCAAA;EACA,8BAAA;AF+EJ;;AE7EA;EACI,0CAAA;EACA,8BAAA;AFgFJ;;AE9EA;EACI,2CAAA;EACA,8BAAA;AFiFJ;;AE/EA;EACI,oBAAA;AFkFJ;;AEhFA;EACI,gBAAA;AFmFJ;;AEjFA;EACI,gBAAA;AFoFJ;;AElFA;EACI,gBAAA;AFqFJ;;AEnFA;EACI,gBAAA;AFsFJ;;AEpFA;;sDAAA;AAGA;;;;;;;;;;;;EAYI,aAAA;EAEA,gBAAA;EACA,sBAAA;AFuFJ;;AEpFA;EACI,cAAA;AFuFJ;;AEpFA;;sDAAA;AAGA;;;;;EAKI,8BAAA;EACA,iBAAA;EACA,mCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AFuFJ;;AErFA;;;;sCAIsC,wBAAA;EAClC,kCAAA;EACA,eAAA;AFwFJ;;AEtFA;;;;EAII,yCAAA;AFyFJ;;AEvFA;EACI,mBAAA;EACA,eAAA;AF0FJ;;AExFA;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AF2FJ;;AEzFA;EACI,aAAA;EACA,YAAA;EACA,eAAA;AF4FJ;;AE1FA;EACI,aAAA;AF6FJ;;AE3FA;EACI,kBAAA;AF8FJ;;AE5FA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,2CAAA;EACA,gBAAA;AF+FJ;;AE7FA;EACI,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,2CAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;EACA,4BAAA;AFgGJ;;AE9FA;EACI,6CAAA;EACA,yCAAA;EACA,mBAAA;AFiGJ;;AE9FA,eAAA;AACA;EACI,kBAAA;AFiGJ;AEhGI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,kCAAA;AFkGR;;AE/FA;EACI,gBAAA;AFkGJ;;AEhGA;EACI,gBAAA;AFmGJ;;AEjGA;EACI,gBAAA;AFoGJ;;AElGA;EACI,gBAAA;AFqGJ;;AEnGA;EACI,gBAAA;AFsGJ;;AEpGA;EACI,gBAAA;AFuGJ;;AErGA;EACI,gBAAA;EACA,SAAA;AFwGJ;;AEtGA;EACI,eAAA;AFyGJ;;AEvGA;EACI,eAAA;AF0GJ;;AExGA;;sDAAA;AAGA;EACI,SAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,4BAAA;EACA,qGAAA;AF2GJ;;AExGA;EACI,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AF2GJ;;AExGA,qDAAA;AACA;EACI,UAAA;AF2GJ;;AEvGA;;uCAAA;AAOA;;sDAAA;AAGA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AFsGJ;;AEpGA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AFuGJ;;AErGA;EACI,WAAA;EACA,cAAA;EACA,qBAAA;AFwGJ;;AEtGA;EACI,eAAA;EACA,eAAA;AFyGJ;;AEvGA;EACI,iBAAA;AF0GJ;;AExGA;EACI,gBAAA;AF2GJ;;AExGA;;sDAAA;AAGA;;;;;;;;;;;;EAYI,WAAA;EACA,cAAA;EACA,mBAAA;AF2GJ;;AExGA;;;;;;EAMI,WAAA;AF2GJ;;AExGA;;sDAAA;AAGA;EACI,cAAA;AF2GJ;;AEzGA;EACI,aAAA;AF4GJ;;AE1GA;EACI,qBAAA;AF6GJ;;AE3GA;EACI,aAAA;AF8GJ;;AE5GA;EACI,cAAA;EACA,WAAA;AF+GJ;;AE7GA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AFgHJ;;AE9GA;;EAEI,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AFiHJ;;AE/GA;;EAEI,2CAAA;EACA,WAAA;AFkHJ;;AE/GA;;sDAAA;AAGA;;;EAGI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AFkHJ;;AE9GA,uDAAA;AACA;;;EAGI,eAAA;AFiHJ;;AE9GA,iDAAA;AACA;EACI,qBAAA;AFiHJ;;AE9GA;;sDAAA;AAGA;EACI,oBAAA;EACA,eAAA;EACA,WAAA;AFiHJ;;AE/GA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AFkHJ;;AEhHA;EACI,kBAAA;AFmHJ;;AEjHA;EACI,kBAAA;AFoHJ;;AEjHA;;sDAAA;AAGA;EACI,oBAAA;AFoHJ;;AEjHA;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AFoHJ;;AEjHA;EACI,cAAA;AFoHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AEjHA;EACI,cAAA;AFoHJ;;AEjHA;EACI,cAAA;AFoHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AEjHA;EACI,gBAAA;AFoHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AEjHA;EACI,cAAA;AFoHJ;;AEjHA;;sDAAA;AAGA;EACI,aAAA;EACA,wBAAA;AFoHJ;;AEjHA;EACI,mBAAA;EACA,gBAAA;AFoHJ;;AEjHA;;EAEI,yBAAA;EACA,iBAAA;EACA,qBAAA;AFoHJ;;AEjHA;;EAEI,2CAAA;EACA,WAAA;EACA,uCAAA;AFoHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AEjHA;;;EAGI,kBAAA;AFoHJ;;AEjHA;EACI,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AFoHJ;;AEjHA;EACI,gBAAA;EACA,WAAA;AFoHJ;;AEjHA;EACI,YAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AFoHJ;;AEjHA;EACI,yBAAA;AFoHJ;;AEjHA;;EAEI,0BAAA;AFoHJ;;AEjHA;;sDAAA;AAGA;EACI,qCAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EAEA,wBAAA;EAEA,4BAAA;EACA,oCAAA;AFoHJ;AEnHI;EACI,iBAAA;EAEA,yBAAA;AFqHR;AEnHI;EACI,6CAAA;EACA,mBAAA;AFqHR;;AEjHA;;sDAAA;AAGA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AFoHJ;;AElHA;EACI,qBAAA;EACA,6CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AFqHJ;;AEnHA;EACI,iBAAA;AFsHJ;;AEpHA;;EAEI,2CAAA;AFuHJ;;AErHA,gBAAA;AACA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AFwHJ;;AEtHA;EACI,UAAA;EACA,YAAA;AFyHJ;;AEvHA;EACI;IACI,WAAA;IACA,SAAA;EF0HN;EExHE;IACI,UAAA;IACA,UAAA;EF0HN;AACF;AEvHA;;sDAAA;AAGA,eAAA;AACA;EACI,gBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AFyHJ;AExHI;EACI,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,4BAAA;AF0HR;AEzHQ;EACI,aAAA;AF2HZ;AEzHQ;EAEI,6CAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AF0HZ;;AErHA,gBAAA;AACA;EACI,eAAA;EACA,UAAA;AFwHJ;;AErHA,kBAAA;AAEI;EACI,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AFuHR;AEtHQ;EACI,6CAAA;EACA,yCAAA;EACA,8BAAA;AFwHZ;AErHI;EACI,WAAA;EACA,UAAA;AFuHR;AEpHQ;EACI,UAAA;EACA,mBAAA;AFsHZ;;AEhHQ;EACI,UAAA;EACA,WAAA;AFmHZ;AEjHQ;EACI,WAAA;EACA,UAAA;AFmHZ;;AE9GA;EAEQ;IACI,WAAA;IACA,WAAA;EFgHV;EE9GM;IACI,YAAA;IACA,UAAA;EFgHV;AACF;AE5GA,kBAAA;AAEI;EACI,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AF6GR;AE5GQ;EACI,6CAAA;EACA,yCAAA;EACA,8BAAA;AF8GZ;AE3GI;EACI,UAAA;AF6GR;;AEzGA,kBAAA;AAEI;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AF2GR;AE1GQ;EACI,6CAAA;EACA,mCAAA;EACA,8BAAA;AF4GZ;AEzGI;EACI,WAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;AF2GR;AEzGI;EACI,6CAAA;EACA,mCAAA;EACA,8BAAA;AF2GR;;AEvGA,kBAAA;AACA;EACI,SAAA;AF0GJ;AEzGI;EACI,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AF2GR;AE1GQ;EACI,6CAAA;EACA,mCAAA;EACA,8BAAA;AF4GZ;AEzGI;EACI,YAAA;AF2GR;AEzGI;EACI,WAAA;AF2GR;;AEvGA;EACI;IACI,gBAAA;EF0GN;AACF;AEvGA;;sDAAA;AAIA;EACE,yBAAA;AFwGF;;AElGC;;;;;;;;;;;;;;;;;;EAkBG,UAAA;EACA,kBAAA;AFqGJ;;AEnGC;;;;;;;;;;;;;;;;;;EAkBG,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AFsGJ;;AEpGA;EAA+B,8BAAA;AFwG/B;;AEvGA;EAA+B,8BAAA;AF2G/B;;AE1GA;EAA+B,8BAAA;AF8G/B;;AE7GA;EAA+B,8BAAA;AFiH/B;;AEhHA;EAA+B,8BAAA;AFoH/B;;AEnHA;EAA+B,8BAAA;AFuH/B;;AEtHA;EAA+B,8BAAA;AF0H/B;;AEzHA;EAA+B,8BAAA;AF6H/B;;AE5HA;EAA+B,8BAAA;AFgI/B;;AE9HA;EAA+B,oCAAA;AFkI/B;;AEjIA;EAA+B,oCAAA;AFqI/B;;AEpIA;EAA+B,oCAAA;AFwI/B;;AEvIA;EAA+B,oCAAA;AF2I/B;;AE1IA;EAA+B,oCAAA;AF8I/B;;AE7IA;EAA+B,oCAAA;AFiJ/B;;AEhJA;EAA+B,oCAAA;AFoJ/B;;AEnJA;EAA+B,oCAAA;AFuJ/B;;AEtJA;EAA+B,oCAAA;AF0J/B;;AEvJA;;;;;;;;;;;EAWI,UAAA;EACA,kBAAA;AF0JJ;;AExJA;;;;;;;;;;;EAWG,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AF2JH;;AEzJA;EAA+B,oCAAA;AF6J/B;;AE5JA;EAA+B,mCAAA;AFgK/B;;AE/JA;EAA+B,mCAAA;AFmK/B;;AElKA;EAA+B,mCAAA;AFsK/B;;AErKA;EAA+B,mCAAA;AFyK/B;;AExKA;EAA+B,mCAAA;AF4K/B;;AE3KA;EAA+B,mCAAA;AF+K/B;;AE9KA;EAA+B,mCAAA;AFkL/B;;AEjLA;EAA+B,mCAAA;AFqL/B;;AEpLA;EAA+B,iCAAA;AFwL/B;;AEvLA;EACE,iCAAA;AF0LF;;AEvLA;;;;;;;;;;EAUI,UAAA;EACA,kBAAA;AF0LJ;;AExLA;;;;;;;;;;EAUG,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AF2LH;;AEzLA;EAAqC,iCAAA;AF6LrC;;AE5LA;EAAqC,gCAAA;AFgMrC;;AE/LA;EAAqC,gCAAA;AFmMrC;;AElMA;EAAqC,gCAAA;AFsMrC;;AErMA;EAAqC,gCAAA;AFyMrC;;AExMA;EAAqC,gCAAA;AF4MrC;;AE3MA;EAAqC,gCAAA;AF+MrC;;AE9MA;EAAqC,gCAAA;AFkNrC;;AEjNA;EAAqC,gCAAA;AFqNrC;;AEpNA;EAAqC,gCAAA;AFwNrC;;AEvNA;;gDAAA;AAGA;EACI,gBAAA;AF0NJ;;AExNA;EACI,UAAA;EACA,yBAAA;EACA,mBAAA;AF2NJ;;AEzNA;EACI,sBAAA;AF4NJ;;AExNA;EACI,gBAAA;AF2NJ;;AEzNA;EACI,UAAA;EACA,2CAAA;EACA,mBAAA;AF4NJ;;AE1NA;EACI,6CAAA;AF6NJ;;AEzNA;;sDAAA;AAGA;EAAQ,2BAAA;AF6NR;;AE5NA;EAAS,4BAAA;AFgOT;;AE/NA;EAAS,4BAAA;AFmOT;;AElOA;EAAS,4BAAA;AFsOT;;AErOA;EAAS,iBAAA;AFyOT;;AExOA;EAAS,iBAAA;AF4OT;;AE3OA;EAAS,iBAAA;AF+OT;;AE9OA;EAAS,iBAAA;AFkPT;;AEjPA;EAAS,iBAAA;AFqPT;;AEpPA;EAAS,iBAAA;AFwPT;;AEvPA;EAAS,iBAAA;AF2PT;;AE1PA;EAAS,iBAAA;AF8PT;;AE7PA;EAAS,iBAAA;AFiQT;;AEhQA;EAAS,iBAAA;AFoQT;;AEnQA;EAAS,iBAAA;AFuQT;;AEtQA;EAAS,iBAAA;AF0QT;;AEzQA;EAAS,iBAAA;AF6QT;;AE5QA;EAAS,iBAAA;AFgRT;;AE/QA;EAAS,iBAAA;AFmRT;;AElRA;EAAS,iBAAA;AFsRT;;AErRA;EAAU,kBAAA;AFyRV;;AExRA;EAAU,kBAAA;AF4RV;;AE3RA;EAAU,kBAAA;AF+RV;;AE9RA;EAAU,kBAAA;AFkSV;;AEjSA;EAAU,kBAAA;AFqSV;;AEpSA;EAAU,kBAAA;AFwSV;;AEvSA;EAAU,kBAAA;AF2SV;;AE1SA;EAAU,kBAAA;AF8SV;;AE7SA;EAAU,kBAAA;AFiTV;;AEhTA;EAAU,kBAAA;AFoTV;;AEnTA;EAAU,kBAAA;AFuTV;;AEtTA;EAAU,kBAAA;AF0TV;;AEzTA;EAAU,kBAAA;AF6TV;;AE5TA;EAAU,kBAAA;AFgUV;;AE/TA;EAAU,kBAAA;AFmUV;;AElUA;EAAU,kBAAA;AFsUV;;AErUA;EAAU,kBAAA;AFyUV;;AExUA;EAAU,kBAAA;AF4UV;;AE3UA;EAAU,kBAAA;AF+UV;;AE9UA;EAAU,kBAAA;AFkVV;;AEjVA;EAAU,kBAAA;AFqVV;;AEpVA;EAAU,kBAAA;AFwVV;;AEvVA;EAAU,kBAAA;AF2VV;;AE1VA;EAAU,kBAAA;AF8VV;;AE7VA;EAAU,kBAAA;AFiWV;;AEhWA;EAAU,kBAAA;AFoWV;;AEnWA;EAAU,kBAAA;AFuWV;;AEtWA;EAAU,kBAAA;AF0WV;;AEzWA;EAAU,kBAAA;AF6WV;;AE5WA;EAAU,kBAAA;AFgXV;;AE9WA;;sDAAA;AAGA;EAAQ,8BAAA;AFkXR;;AEjXA;EAAS,+BAAA;AFqXT;;AEpXA;EAAS,+BAAA;AFwXT;;AEvXA;EAAS,+BAAA;AF2XT;;AE1XA;EAAS,oBAAA;AF8XT;;AE7XA;EAAS,oBAAA;AFiYT;;AEhYA;EAAS,oBAAA;AFoYT;;AEnYA;EAAS,oBAAA;AFuYT;;AEtYA;EAAS,oBAAA;AF0YT;;AEzYA;EAAS,oBAAA;AF6YT;;AE5YA;EAAS,oBAAA;AFgZT;;AE/YA;EAAS,oBAAA;AFmZT;;AElZA;EAAS,oBAAA;AFsZT;;AErZA;EAAS,oBAAA;AFyZT;;AExZA;EAAS,oBAAA;AF4ZT;;AE3ZA;EAAS,oBAAA;AF+ZT;;AE9ZA;EAAS,oBAAA;AFkaT;;AEjaA;EAAS,oBAAA;AFqaT;;AEpaA;EAAS,oBAAA;AFwaT;;AEvaA;EAAS,oBAAA;AF2aT;;AE1aA;EAAU,qBAAA;AF8aV;;AE7aA;EAAU,qBAAA;AFibV;;AEhbA;EAAU,qBAAA;AFobV;;AEnbA;EAAU,qBAAA;AFubV;;AEtbA;EAAU,qBAAA;AF0bV;;AEzbA;EAAU,qBAAA;AF6bV;;AE5bA;EAAU,qBAAA;AFgcV;;AE/bA;EAAU,qBAAA;AFmcV;;AElcA;EAAU,qBAAA;AFscV;;AErcA;EAAU,qBAAA;AFycV;;AExcA;EAAU,qBAAA;AF4cV;;AE3cA;EAAU,qBAAA;AF+cV;;AE9cA;EAAU,qBAAA;AFkdV;;AEjdA;EAAU,qBAAA;AFqdV;;AEpdA;EAAU,qBAAA;AFwdV;;AEvdA;EAAU,qBAAA;AF2dV;;AE1dA;EAAU,qBAAA;AF8dV;;AE7dA;EAAU,qBAAA;AFieV;;AEheA;EAAU,qBAAA;AFoeV;;AEneA;EAAU,qBAAA;AFueV;;AEteA;EAAU,qBAAA;AF0eV;;AEzeA;EAAU,qBAAA;AF6eV;;AE5eA;EAAU,qBAAA;AFgfV;;AE/eA;EAAU,qBAAA;AFmfV;;AElfA;EAAU,qBAAA;AFsfV;;AErfA;EAAU,qBAAA;AFyfV;;AExfA;EAAU,qBAAA;AF4fV;;AE3fA;EAAU,qBAAA;AF+fV;;AE9fA;EAAU,qBAAA;AFkgBV;;AEhgBA;;sDAAA;AAGA;EAAQ,0BAAA;AFogBR;;AEngBA;EAAS,2BAAA;AFugBT;;AEtgBA;EAAS,2BAAA;AF0gBT;;AEzgBA;EAAS,2BAAA;AF6gBT;;AE5gBA;EAAS,2BAAA;AFghBT;;AE/gBA;EAAS,2BAAA;AFmhBT;;AElhBA;EAAS,2BAAA;AFshBT;;AErhBA;EAAS,gBAAA;AFyhBT;;AExhBA;EAAS,gBAAA;AF4hBT;;AE3hBA;EAAS,gBAAA;AF+hBT;;AE9hBA;EAAS,gBAAA;AFkiBT;;AEjiBA;EAAS,gBAAA;AFqiBT;;AEpiBA;EAAS,gBAAA;AFwiBT;;AEviBA;EAAS,gBAAA;AF2iBT;;AE1iBA;EAAS,gBAAA;AF8iBT;;AE7iBA;EAAS,gBAAA;AFijBT;;AEhjBA;EAAS,gBAAA;AFojBT;;AEnjBA;EAAS,gBAAA;AFujBT;;AEtjBA;EAAS,gBAAA;AF0jBT;;AEzjBA;EAAU,iBAAA;AF6jBV;;AE5jBA;EAAU,iBAAA;AFgkBV;;AE/jBA;EAAU,iBAAA;AFmkBV;;AElkBA;EAAU,iBAAA;AFskBV;;AErkBA;EAAU,iBAAA;AFykBV;;AExkBA;EAAU,iBAAA;AF4kBV;;AE3kBA;EAAU,iBAAA;AF+kBV;;AE9kBA;EAAU,iBAAA;AFklBV;;AEjlBA;EAAU,iBAAA;AFqlBV;;AEplBA;EAAU,iBAAA;AFwlBV;;AEvlBA;EAAU,iBAAA;AF2lBV;;AE1lBA;EAAU,iBAAA;AF8lBV;;AE7lBA;EAAU,iBAAA;AFimBV;;AE/lBA;;sDAAA;AAGA;EAAQ,6BAAA;AFmmBR;;AElmBA;EAAS,8BAAA;AFsmBT;;AErmBA;EAAS,8BAAA;AFymBT;;AExmBA;EAAS,8BAAA;AF4mBT;;AE3mBA;EAAS,8BAAA;AF+mBT;;AE9mBA;EAAS,8BAAA;AFknBT;;AEjnBA;EAAS,8BAAA;AFqnBT;;AEpnBA;EAAS,mBAAA;AFwnBT;;AEvnBA;EAAS,mBAAA;AF2nBT;;AE1nBA;EAAS,mBAAA;AF8nBT;;AE7nBA;EAAS,mBAAA;AFioBT;;AEhoBA;EAAS,mBAAA;AFooBT;;AEnoBA;EAAS,mBAAA;AFuoBT;;AEtoBA;EAAS,mBAAA;AF0oBT;;AEzoBA;EAAS,mBAAA;AF6oBT;;AE5oBA;EAAS,mBAAA;AFgpBT;;AE/oBA;EAAS,mBAAA;AFmpBT;;AElpBA;EAAS,mBAAA;AFspBT;;AErpBA;EAAU,oBAAA;AFypBV;;AExpBA;EAAU,oBAAA;AF4pBV;;AE3pBA;EAAU,oBAAA;AF+pBV;;AE9pBA;EAAU,oBAAA;AFkqBV;;AEjqBA;EAAU,oBAAA;AFqqBV;;AEpqBA;EAAU,oBAAA;AFwqBV;;AEvqBA;EAAU,oBAAA;AF2qBV;;AE1qBA;EAAU,oBAAA;AF8qBV;;AE7qBA;EAAU,oBAAA;AFirBV;;AEhrBA;EAAU,oBAAA;AForBV;;AEnrBA;EAAU,oBAAA;AFurBV;;AErrBA;;sDAAA;AAGA;EACI,0BAAA;AFwrBJ;;AEtrBA;EACI,2BAAA;AFyrBJ;;AEvrBA;EACI,kBAAA;AF0rBJ;;AExrBA;EACI,iBAAA;AF2rBJ;;AEzrBA;EACI,kBAAA;AF4rBJ;;AE1rBA;EACI,mBAAA;AF6rBJ;;AE3rBA,uBAAA;AACA;EACI,gBAAA;EACA,iBAAA;AF8rBJ;;AE5rBA;EACI,gBAAA;EACA,iBAAA;AF+rBJ;;AE7rBA;EACI,gBAAA;EACA,iBAAA;AFgsBJ;;AE9rBA;EACI,gBAAA;EACA,iBAAA;AFisBJ;;AE/rBA;EACI,gBAAA;EACA,iBAAA;AFksBJ;;AEhsBA;EACI,gBAAA;EACA,iBAAA;AFmsBJ;;AEjsBA;EACI,gBAAA;EACA,iBAAA;AFosBJ;;AElsBA,UAAA,SAAA;EACI,gBAAA;EACA,iBAAA;AFqsBJ;;AEnsBA;EACI,iBAAA;EACA,kBAAA;AFssBJ;;AEpsBA;EACI,iBAAA;EACA,kBAAA;AFusBJ;;AErsBA;EACI,iBAAA;EACA,kBAAA;AFwsBJ;;AEtsBA;EACI;;;;;;;;;;;IAWI,gBAAA;IACA,iBAAA;EFysBN;AACF;AEvsBA;EACI;;;;;;;;;;;IAWI,kBAAA;IACA,mBAAA;EFysBN;AACF;AEvsBA;EACI,qBAAA;EACA;IACI,4BAAA;EFysBN;EEvsBE;IACI,iBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;EEvsBE;IACI,kBAAA;EFysBN;AACF;AEvsBA;EACI;IACI,mBAAA;EFysBN;AACF;AEvsBA,wBAAA;AACA;EACI,oBAAA;AFysBJ;;AEvsBA;EACI,qBAAA;AF0sBJ;;AExsBA;EACI,qBAAA;AF2sBJ;;AEzsBA;EACI,qBAAA;AF4sBJ;;AE1sBA;EACI,qBAAA;AF6sBJ;;AE3sBA;EACI,qBAAA;AF8sBJ;;AE5sBA;EACI,qBAAA;AF+sBJ;;AE5sBA;;sDAAA;AAGA;EACI,aAAA;AF+sBJ;;AE7sBA;EACI,aAAA;AFgtBJ;;AE9sBA;EACI,aAAA;AFitBJ;;AE/sBA;EACI,aAAA;AFktBJ;;AEhtBA;EACI,aAAA;AFmtBJ;;AEjtBA;EACI,aAAA;AFotBJ;;AEltBA;EACI,aAAA;AFqtBJ;;AEntBA;EACI,aAAA;AFstBJ;;AEptBA;EACI,aAAA;AFutBJ;;AErtBA;EACI,aAAA;AFwtBJ;;AEttBA;EACI,aAAA;AFytBJ;;AEvtBA;EACI,aAAA;AF0tBJ;;AG93FA;;gEAAA;AAIA;EACC,iBAAA;AHg4FD;;AG73FA;EACC,eAAA;EACA,eAAA;AHg4FD;;AG53FA;EACC,gBAAA;AH+3FD;;AG53FA;EACC,cAAA;AH+3FD;;AG53FA;;EAEC,WAAA;AH+3FD;;AG53FA;EACC,YAAA;AH+3FD;;AG53FA;EACC,kBAAA;AH+3FD;;AG53FA;EACC,mBAAA;AH+3FD;;AG53FA;;;;EAIC,eAAA;AH+3FD;;AG53FA;EACC,cAAA;EACA,gBAAA;AH+3FD;;AG53FA;EACC,yBAAA;EACA,WAAA;AH+3FD;;AG53FA;EACC,cAAA;AH+3FD;;AG53FA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AH+3FD;;AG53FA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AH+3FD;;AG53FA;EACC,mBAAA;AH+3FD;;AG53FA;EACC,aAAA;AH+3FD;;AG53FA;EACC,gBAAA;EACA,UAAA;AH+3FD;;AG53FA;EACC;IACC,gBAAA;EH+3FA;AACF;AG73FA;EACC,gBAAA;AH+3FD;;AG53FA;EACC,cAAA;AH+3FD;;AG53FA;;EAEC,WAAA;AH+3FD;;AG53FA;EACC,YAAA;AH+3FD;;AG53FA;EACC,kBAAA;AH+3FD;;AG53FA;EACC,mBAAA;AH+3FD;;AG53FA;;;;EAIC,eAAA;AH+3FD;;AG53FA;EACC,cAAA;EACA,gBAAA;AH+3FD;;AG53FA;EACC,yBAAA;EACA,WAAA;AH+3FD;;AG53FA;EACC,cAAA;AH+3FD;;AG53FA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AH+3FD;;AG53FA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AH+3FD;;AG53FA;EACC,mBAAA;AH+3FD;;AG53FA;EACC,aAAA;AH+3FD;;AG73FA;EACC,2BAAA;EACA,iBAAA;AHg4FD;;AG93FA;EACC,gBAAA;EACA,UAAA;AHi4FD;;AG93FA;EACC;IACC,gBAAA;EHi4FA;AACF;AG/3FA;EACC,6BAAA;EACA,gCAAA;EACA,cAAA;AHi4FD;;AG/3FA;;gEAAA;AAGA;EACC,cAAA;AHk4FD;;AG/3FA;EACC,yBAAA;AHk4FD;;AG/3FA;EACC,cAAA;AHk4FD;;AG/3FA;EACC,yBAAA;AHk4FD;;AG/3FA;EACC,WAAA;AHk4FD;;AG/3FA;EACC,sBAAA;AHk4FD;;AG/3FA;EACC,WAAA;AHk4FD;;AG/3FA;EACC,sBAAA;AHk4FD;;AI1lGA;;sDAAA;AAGA;EACI,kBAAA;AJ6lGJ;;AI3lGA;EACI,OAAA;EACA,QAAA;AJ8lGJ;;AI5lGA;EACI,OAAA;EACA,SAAA;AJ+lGJ;;AI7lGA;EACI,QAAA;EACA,2BAAA;EACA,QAAA;AJgmGJ;;AI9lGA;EACI,QAAA;EACA,4CAAA;EACA,SAAA;AJimGJ;;AI/lGA;EACI,QAAA;EACA,2BAAA;EACA,SAAA;AJkmGJ;;AIhmGA;EACI,UAAA;EACA,OAAA;AJmmGJ;;AIjmGA;EACI,UAAA;EACA,SAAA;AJomGJ;;AIhmGE;EAEI,6BAAA;AJmmGN;;AI/lGE;EAEI,6BAAA;AJkmGN;AIhlGA;EACE;IAEE,4CAAA;EJimGF;EI/lGA;IAEE,6CAAA;EJimGF;EI/lGA;IAEE,0CAAA;EJimGF;AACF;AIhlGA;EACE;IAEE,0CAAA;EJgmGF;EI9lGA;IAEE,2CAAA;EJgmGF;EI9lGA;IAEE,wCAAA;EJgmGF;AACF;AI7lGA;;sDAAA;AAGA;;EAEE,cAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AJ+lGF;;AI7lGA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AJgmGF;;AI9lGA;EACE,kBAAA;AJimGF;;AIhmGE;EAGE,+BAAA;EAGA,4BAAA;EAGA,2BAAA;AJmmGJ;;AIjmGA;EACE,sEAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AJomGF;;AIlmGA;EAGE,yBAAA;EAGA,wFAAA;EACA,iBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,yDAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AJqmGF;;AIjmGE;EACE,yDAAA;AJomGJ;;AInmGE;EACE,yDAAA;AJsmGJ;;AIpmGA;EACE,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;AJumGF;;AItmGE;EACE,yDAAA;AJymGJ;;AIxmGE;EACE,yDAAA;AJ2mGJ;;AI1mGE;EACE,YAAA;EACA,SAAA;AJ6mGJ;;AI5mGE;EACE,YAAA;EACA,SAAA;AJ+mGJ;;AI9mGE;EACE,aAAA;EACA,SAAA;AJinGJ;;AIhnGE;EACE,YAAA;EACA,SAAA;AJmnGJ;;AIlnGE;EACE,aAAA;EACA,SAAA;AJqnGJ;;AIpnGE;EACE,YAAA;EACA,SAAA;AJunGJ;;AItnGE;EAGE,yCAAA;AJynGJ;;AIxnGE;EAGE,yCAAA;AJ2nGJ;;AI1nGE;EAGE,yCAAA;AJ6nGJ;;AI5nGE;EAGE,yCAAA;AJ+nGJ;;AI9nGE;EAGE,yCAAA;AJioGJ;;AIhoGE;EAGE,yCAAA;AJmoGJ;;AI/nGA;EAGE,uBAAA;EACA,kBAAA;AJkoGF;;AIjoGE;EACE,QAAA;AJooGJ;;AInoGE;EACE,QAAA;AJsoGJ;;AIroGE;EACE,QAAA;AJwoGJ;;AIvoGE;EACE,UAAA;AJ0oGJ;;AIzoGE;EACE,UAAA;AJ4oGJ;;AI3oGE;EACE,UAAA;AJ8oGJ;;AI7oGE;EACE,QAAA;AJgpGJ;;AI/oGE;EACE,QAAA;AJkpGJ;;AIjpGE;EACE,QAAA;AJopGJ;;AInpGE;EACE,SAAA;AJspGJ;;AIrpGE;EACE,SAAA;AJwpGJ;;AIvpGE;EACE,SAAA;AJ0pGJ;;AIzpGE;EACE,SAAA;AJ4pGJ;;AI3pGE;EACE,SAAA;AJ8pGJ;;AI7pGE;EACE,SAAA;AJgqGJ;;AI/pGE;EACE,SAAA;AJkqGJ;;AIjqGE;EACE,SAAA;AJoqGJ;;AInqGE;EACE,SAAA;AJsqGJ;;AIpqGA;EAGE,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AJuqGF;;AItqGE;EACE,yDAAA;AJyqGJ;;AIxqGE;EACE,yDAAA;AJ2qGJ;;AI1qGE;EACE,yDAAA;AJ6qGJ;;AI5qGE;EACE,yDAAA;AJ+qGJ;;AI9qGE;EACE,yDAAA;AJirGJ;;AI/qGA;EAGE,8EAAA;AJkrGF;;AIhrGA;EAGE,gFAAA;AJmrGF;;AIjrGA;EAGE,8EAAA;AJorGF;;AIlrGA;EAGE,gFAAA;AJqrGF;;AInrGA;EAGE,8EAAA;AJsrGF;;AInrGA,oBAAA;AACA;EACI,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,kCAAA;EACA,0BAAA;EACA,WAAA;EAGA,6CAAA;AJsrGJ;;AInrGA;EAGI,uCAAA;AJsrGJ;;AIprGA;EAGI,uCAAA;AJurGJ;;AIrrGA;EAGI,6CAAA;AJwrGJ;;AItrGA;EAGI,6CAAA;AJyrGJ;;AIvrGA;EAGI,6CAAA;AJ0rGJ;;AIxrGA;EAGI,uCAAA;AJ2rGJ;;AIxrGA;EAGE,uDAAA;AJ2rGF;AIvpGA;EACE;IACE,UAAA;EJ6sGF;EI5sGA;IACE,YAAA;EJ8sGF;EI7sGA;IACE,YAAA;EJ+sGF;EI9sGA;IACE,YAAA;EJgtGF;EI/sGA;IACE,UAAA;EJitGF;AACF;AIlpGA;EACE;IAGE,0BAAA;EJquGF;EIpuGA;IAGE,yBAAA;EJsuGF;EIruGA;IAGE,0BAAA;EJuuGF;EItuGA;IAGE,yBAAA;EJwuGF;EIvuGA;IAGE,yBAAA;EJyuGF;AACF;AI9sGA;EACE;IAGE,6DAAA;EJovGF;EInvGA;IAGE,kEAAA;EJqvGF;AACF;AI1tGA;EACE;IAGE,gDAAA;EJgwGF;EI/vGA;IAGE,kDAAA;EJiwGF;AACF;AItuGA;EACE;IAGE,yBAAA;EJ4wGF;EI3wGA;IAGE,0BAAA;EJ6wGF;AACF;AI5wGA;;sDAAA;ACjmBA;;sDAAA;AAGA;EACI,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;ALk3HJ;;AKh3HA;EACI,SAAA;EACA,UAAA;ALm3HJ;;AKj3HA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ALo3HJ;;AKl3HA;EACI,eAAA;EACA,gCAAA;ALq3HJ;;AKn3HA;EACI,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;ALs3HJ;;AKp3HA;EACI,aAAA;ALu3HJ;;AKp3HA,sBAAA;AACA;EACI,kBAAA;EACA,qBAAA;ALu3HJ;;AKr3HA;EACI,aAAA;EACA,mBAAA;ALw3HJ;AKv3HI;EACI,gBAAA;ALy3HR;AKv3HI;EACI,gBAAA;ALy3HR;AKv3HI;EACI,kBAAA;ALy3HR;AKv3HI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EAGA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,YAAA;ALy3HR;;AKn3HQ;EACI,0BAAA;ALs3HZ;AKr3HY;EACI,kCAAA;ALu3HhB;;AKj3HA,sBAAA;AACA;EACI,kBAAA;EACA,qBAAA;ALo3HJ;;AKj3HA,sBAAA;AAEI;EACI,gBAAA;ALm3HR;AKj3HI;EACI,YAAA;ALm3HR;;AKh3HA;;sDAAA;AAGA;EACI;IACI,kBAAA;IACA,oBAAA;ELm3HN;EKj3HE;IACI,iBAAA;IACA,kBAAA;ELm3HN;EKl3HM;IACI,cAAA;ELo3HV;EK/2HU;IACI,eAAA;ELi3Hd;AACF;AK52HA;;sDAAA;ACxHA;;;;;;;;;;;;;;;;;;+DAAA;AAoBA;;gEAAA;AAGA;EACI,mBAAA;EACA,4BAAA;EACA,wCAAA;ANw+HJ;AMv+HI;EACI,gBAAA;ANy+HR;AMv+HI;EACI,gBAAA;EACA,mBAAA;ANy+HR;;AMt+HA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;ANy+HJ;;AMv+HA;EACI,kBAAA;EACA,kBAAA;AN0+HJ;AMz+HI;EAEI,kBAAA;EACA,WAAA;EACA,6CAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;AN0+HR;AMx+HI;EACI,WAAA;EACA,WAAA;EACA,mBAAA;AN0+HR;AMx+HI;EACI,UAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AN0+HR;;AMv+HA;EACI,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AN0+HJ;AMz+HI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,6CAAA;EACA,aAAA;AN2+HR;;AMx+HA,aAAA;AACA;EACI,mBAAA;AN2+HJ;;AMx+HA;;sDAAA;AAGA;EACI,kBAAA;AN2+HJ;;AMz+HA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AN4+HJ;;AM1+HA;EACI,gCAAA;EACA,eAAA;AN6+HJ;;AM3+HA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,6CAAA;EACA,yCAAA;EACA,4BAAA;AN8+HJ;;AM5+HA;EACI,mBAAA;EACA,2CAAA;EACA,uCAAA;AN++HJ;;AM5+HA;;sDAAA;AAGA;EACI,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AN++HJ;AM9+HI;EACI,kCAAA;EACA,kBAAA;ANg/HR;AM9+HI;EACI,mBAAA;EACA,eAAA;ANg/HR;AM9+HI;EACI,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ANg/HR;AM9+HI;EACQ,mBAAA;ANg/HZ;AM9+HI;EACI,6CAAA;EACA,yCAAA;EACA,mBAAA;EACA,eAAA;ANg/HR;AM/+HQ;EACI,+CAAA;EACA,2CAAA;EACA,mBAAA;ANi/HZ;;AM7+HA;EACI,kBAAA;EAEA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AN++HJ;;AM5+HA;;sDAAA;AAII;EACI,SAAA;EACA,UAAA;AN8+HR;AM7+HQ;EACI,gBAAA;EACA,qBAAA;EACA,eAAA;AN++HZ;AM9+HY;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,qCAAA;EACA,gBAAA;EACA,qCAAA;ANg/HhB;AM/+HgB;EACI,6CAAA;EACA,mBAAA;ANi/HpB;;AM1+HA;;sDAAA;AAII;EACI,UAAA;EACA,SAAA;AN4+HR;AM3+HQ;EACI,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,uCAAA;AN6+HZ;AM5+HY;EACI,WAAA;EACA,YAAA;EACA,cAAA;AN8+HhB;AM5+HY;EACI,8CAAA;EACA,mBAAA;AN8+HhB;AM3+HQ;EACI,8BAAA;AN6+HZ;AM3+HQ;EACI,8BAAA;AN6+HZ;AM3+HQ;EACI,4BAAA;AN6+HZ;AM3+HQ;EACI,+BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,+BAAA;AN6+HZ;AM3+HQ;EACI,+BAAA;AN6+HZ;AM3+HQ;EACI,8BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,8BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,gCAAA;AN6+HZ;AM3+HQ;EACI,+BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,6BAAA;AN6+HZ;AM3+HQ;EACI,+BAAA;AN6+HZ;;AMx+HA;;sDAAA;AAII;EACI,UAAA;EACA,SAAA;AN0+HR;AMz+HQ;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AN2+HZ;AM1+HY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AN4+HhB;AM3+HgB;EACI,YAAA;EACA,0BAAA;AN6+HpB;AM1+HY;EACI,YAAA;EACA,0BAAA;AN4+HhB;;AMt+HA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;ANy+HF;;AMt+HA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;ANy+HF;;AMt+HA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;ANy+HF;;AMr+HA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;ANw+HF;;AMr+HA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;ANw+HF;;AMp+HA;EACE,WAAA;EAEA,QAAA;EACA,OAAA;ANs+HF;;AMn+HA;EACE,yBAAA;EACA,2CAAA;EACA,mBAAA;ANs+HF;;AMl+HA,kBAAA;AACA;EACI,6BAAA;ANq+HJ;AMl+HY;EACI,qCAAA;EACA,4BAAA;ANo+HhB;AMn+HgB;EACI,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;ANq+HpB;AMh+HgB;EACI,6CAAA;EACA,mBAAA;ANk+HpB;AMj+HoB;EACI,+CAAA;EACA,mBAAA;ANm+HxB;AMl+HwB;EACI,2CAAA;EACA,mBAAA;ANo+H5B;AM39HY;EACI,aAAA;AN69HhB;AMt9HgB;EACI,2CAAA;EACA,mBAAA;ANw9HpB;AMv9HoB;EACI,6CAAA;EACA,mBAAA;ANy9HxB;AMp9HoB;EACI,6CAAA;EACA,mBAAA;ANs9HxB;AMr9HwB;EACI,+CAAA;EACA,mBAAA;ANu9H5B;AMt9H4B;EACI,2CAAA;EACA,mBAAA;ANw9HhC;;AM98HA;;sDAAA;AAII;EACI,UAAA;EACA,SAAA;ANg9HR;AM/8HQ;EACI,gBAAA;ANi9HZ;;AM78HA;EACI,mBAAA;EACA,8CAAA;EACA,oBAAA;ANg9HJ;;AM98HA;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;ANi9HJ;;AM/8HA;EACI,WAAA;EACA,kBAAA;ANk9HJ;AMj9HI;EACI,eAAA;ANm9HR;;AMh9HA;EACI,gBAAA;ANm9HJ;AMl9HI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;ANo9HR;AMl9HI;EACI,gBAAA;ANo9HR;AMn9HQ;EACI,kCAAA;ANq9HZ;;AM/8HI;EACI,WAAA;EACA,kBAAA;ANk9HR;AMj9HQ;EACI,eAAA;EACA,mBAAA;ANm9HZ;AMj9HQ;EACI,kCAAA;ANm9HZ;AM/8HQ;EACG,kBAAA;ANi9HX;AMh9HY;EACI,kCAAA;ANk9HhB;;AM58HA;;sDAAA;AAGA;EACI,qBAAA;EACA,SAAA;AN+8HJ;;AM58HA;;sDAAA;AAII;EACI,UAAA;EACA,SAAA;AN88HR;AM78HQ;EACI,gBAAA;AN+8HZ;;AM38HA;EACI,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,4BAAA;AN88HJ;;AM58HA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;AN+8HJ;;AM78HA;EACI,eAAA;EACA,WAAA;EACA,kBAAA;ANg9HJ;;AM98HA;EACI,gBAAA;ANi9HJ;AMh9HI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;ANk9HR;AMh9HI;EACI,gBAAA;ANk9HR;AMj9HQ;EACI,eAAA;ANm9HZ;AMh9HI;EACI,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;ANk9HR;AMh9HI;EACI,cAAA;EACA,kBAAA;ANk9HR;;AM98HA;;sDAAA;AAII;EACI,mBAAA;ANg9HR;AM/8HQ;EACI,sBAAA;ANi9HZ;AM/8HQ;EACI,eAAA;ANi9HZ;AM/8HQ;;EAEI,eAAA;ANi9HZ;AM98HI;EACI,gBAAA;ANg9HR;;AM58HA;;sDAAA;AAGA;EACE,oBAAA;AN+8HF;;AM78HA;EACE,gBAAA;ANg9HF;;AM98HA;;EAEE,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;ANi9HF;;AM/8HA;EACE,gBAAA;ANk9HF;;AMh9HA;EACE,2CAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;ANm9HF;;AMj9HA;EACE,6CAAA;EACA,sBAAA;ANo9HF;;AMl9HA;;;EAGI,6CAAA;EACF,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;ANq9HF;;AMl9HA;;sDAAA;AAGA;EAII,aAAA;ANq9HJ;AMp9HG;EAIK,aAAA;EAGA,eAAA;EACA,WAAA;ANs9HR;AMr9HQ;;EAEI,cAAA;EAIA,kBAAA;EACA,mBAAA;ANu9HZ;;AMh9HY;;EAII,oBAAA;EACA,qBAAA;ANm9HhB;;AM58HQ;EAII,aAAA;AN+8HZ;;AMz8HI;EACI,+BAAA;EACA,8BAAA;AN48HR;AM38HQ;EACI,oBAAA;EACA,mBAAA;AN68HZ;;AMx8HI;EACI,+BAAA;EACA,8BAAA;AN28HR;AM18HQ;;EAEI,oBAAA;EACA,mBAAA;EACA,aAAA;AN48HZ;;AMv8HA;;sDAAA;AAGA;EACI,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AN08HJ;AMz8HI;EACI,6CAAA;EACA,mBAAA;AN28HR;;AMx8HA;EACI,YAAA;EACA,WAAA;EACA,8BAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AN28HJ;AM18HI;EACI,kCAAA;AN48HR;AMz8HQ;EACI,eAAA;AN28HZ;AMx8HI;EACI,gBAAA;AN08HR;;AMv8HA;EACI,oBAAA;EACA,wCAAA;EACA,YAAA;AN08HJ;;AMx8HA;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AN28HJ;;AMz8HA;EACI,kBAAA;EACA,qBAAA;AN48HJ;AM38HI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;AN68HR;AM38HI;EACI,SAAA;AN68HR;AM38HI;;EAEI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AN68HR;;AM18HA;EACI,kBAAA;AN68HJ;;AM38HA;EACI,aAAA;AN88HJ;;AM58HA;EACI,aAAA;AN+8HJ;;AM78HA;EACI,aAAA;ANg9HJ;;AM98HA;EACI,aAAA;ANi9HJ;;AM98HI;EACI,aAAA;EACA,uBAAA;ANi9HR;;AM78HI;EACI,6CAAA;EACA,mBAAA;ANg9HR;AM98HI;EACI,mBAAA;ANg9HR;;AM78HA;EACI,YAAA;EACA,WAAA;EACA,eAAA;ANg9HJ;;AM78HA;EACI;;IAEI,aAAA;ENg9HN;AACF;AM98HA;EACI;IACI,YAAA;IACA,WAAA;IACA,eAAA;ENg9HN;EM98HE;;IAEI,eAAA;ENg9HN;AACF;AM98HA;EACI;IACI,iBAAA;ENg9HN;EM/8HM;IACI,cAAA;ENi9HV;EM58HM;;IACI,cAAA;EN+8HV;AACF;AM38HA;;sDAAA;AAII;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AN48HR;AM18HI;EACI,eAAA;AN48HR;AM18HI;EACI,0BAAA;AN48HR;;AMt8HQ;EACI,mBAAA;EACA,eAAA;EACA,sBAAA;ANy8HZ;;AMr8HA;;sDAAA;AAGA;EACI;IACI,mBAAA;ENw8HN;AACF;AMt8HA;;sDAAA;AAGA;EACI;IACI,4BAAA;ENw8HN;EMt8HE;IACI,eAAA;IACA,kBAAA;ENw8HN;AACF;AMr8HA;EACI;IACI,iBAAA;ENu8HN;AACF;AMp8HA;EACI;IACI,aAAA;ENs8HN;AACF;AMn8HA;;sDAAA;AC75BA;;;;;;;;;;;;;;;;+DAAA;AAkBA;;gEAAA;AAGA;EACI,aAAA;EACA,kBAAA;APo2JJ;;AOl2JA;;gDAAA;AAGA;EACI,wBAAA;EACA,mCAAA;APq2JJ;AOp2JI;EACI,eAAA;EACA,kBAAA;APs2JR;;AOn2JA;EACE,yBAAA;APs2JF;AOr2JE;;;;;;;EAOI,mBAAA;APu2JN;;AOp2JA;EACI,2CAAA;APu2JJ;AOt2JI;;;;;;;EAOI,mBAAA;APw2JR;;AOp2JA;EACI,mBAAA;APu2JJ;;AOr2JA,YAAA;AACA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;APw2JJ;;AOr2JI;EACI,UAAA;EACA,SAAA;APw2JR;AOv2JQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;APy2JZ;AOx2JY;EACI,eAAA;AP02JhB;AOx2JY;EACI,iBAAA;EACA,kCAAA;AP02JhB;AOr2JQ;EACI,eAAA;EACA,gBAAA;APu2JZ;;AOj2JA;EACI,qBAAA;APo2JJ;AOn2JI;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;EACA,mBAAA;APq2JR;AOp2JQ;EACI,+CAAA;APs2JZ;;AOl2JA;;gDAAA;AAGA;EACI,YAAA;APq2JJ;;AOn2JA;;EAII,8BAAA;EAGA,mBAAA;EACA,kBAAA;APs2JJ;;AOn2JA;;EAII,YAAA;EACA,gBAAA;APs2JJ;;AOn2JA;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;APs2JJ;AOp2JI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;APs2JR;AOp2JI;EACI,kCAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;APs2JR;;AOj2JI;EACI,iBAAA;EACA,oBAAA;APo2JR;;AOj2JA;;gDAAA;AAII;EACI,kBAAA;APm2JR;AOl2JQ;EACI,aAAA;EACA,mBAAA;APo2JZ;;AOh2JA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;APm2JJ;;AOj2JA;EACI,kBAAA;APo2JJ;AOn2JI;EACI,qBAAA;APq2JR;;AOj2JA;;gDAAA;AAGA;EACI,aAAA;APo2JJ;;AOl2JA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;APq2JJ;AOp2JI;EACI,eAAA;APs2JR;AOp2JI;EACI,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;APs2JR;AOp2JI;EACI,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,gBAAA;APs2JR;;AOn2JA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;APs2JJ;;AOn2JA;;gDAAA;AAGA;;EAEI,iBAAA;APs2JJ;;AOp2JA;EACI,gBAAA;APu2JJ;;AOr2JA;EACI,aAAA;EACA,UAAA;APw2JJ;;AOt2JA;EACI,gBAAA;EACA,cAAA;EACA,aAAA;APy2JJ;;AOv2JA;EACI,kBAAA;AP02JJ;;AOx2JA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;AP22JJ;;AOz2JA;EACI,iBAAA;AP42JJ;;AO12JA;EACI,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kCAAA;AP62JJ;;AO32JA;EACI,kCAAA;AP82JJ;;AO52JA,YAAA;AACA;;EAEI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iFAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iDAAA;AP+2JJ;;AO72JA;;EAEI,gBAAA;EACA,4BAAA;EACA,eAAA;APg3JJ;;AO92JA;EACI,aAAA;APi3JJ;;AO/2JA;EACI,kBAAA;EACA,gBAAA;APk3JJ;;AOh3JA;;EAEI,SAAA;EACA,UAAA;EACA,mBAAA;APm3JJ;;AOj3JA;;EAEI,UAAA;APo3JJ;;AOl3JA;;EAEI,MAAA;APq3JJ;;AOn3JA;;EAEI,kBAAA;APs3JJ;;AOp3JA;;;;;;EAMI,UAAA;EACA,WAAA;APu3JJ;;AOr3JA;;;;EAII,YAAA;APw3JJ;AOv3JI;;;;EACI,UAAA;EACA,WAAA;EACA,4BAAA;AP43JR;AO33JQ;;;;EACI,4BAAA;EACA,cAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,qCAAA;APg4JZ;AO73JI;;;;EACI,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;APk4JR;AOj4JQ;;;;EACI,4BAAA;EACA,4BAAA;EACA,kBAAA;APs4JZ;AOr4JY;;;;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;AP04JhB;AOv4JgB;;;;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AP44JpB;;AOt4JA;;EAEI,YAAA;APy4JJ;AOx4JI;;EACI,aAAA;AP24JR;;AOt4JI;;EACI,UAAA;EACA,mBAAA;AP04JR;;AOp4JI;EACI,4BAAA;EACA,kBAAA;APu4JR;AOt4JQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;APw4JZ;AOr4JY;EACI,aAAA;EACA,mBAAA;EACA,UAAA;APu4JhB;;AOh4JA,iBAAA;AACA;;EAEI,kBAAA;APm4JJ;;AOj4JA;;;;EAII,UAAA;EACA,QAAA;APo4JJ;;AOj4JA,cAAA;AACA;EACI,OAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;APo4JJ;;AOl4JA;EACI,WAAA;EACA,4BAAA;EACA,2BAAA;APq4JJ;;AOn4JA;EACI,gBAAA;APs4JJ;;AOp4JA;EACI,iBAAA;EACA,gBAAA;APu4JJ;;AOr4JA;EACI,UAAA;EACA,mBAAA;EAEA,oBAAA;APw4JJ;;AOt4JA;;EAEI,mBAAA;EACA,gBAAA;EACA,iBAAA;APy4JJ;;AOv4JA,8CAAA;AACA;;EAEI,MAAA;AP04JJ;;AOx4JA;;EAEI,UAAA;EACA,mBAAA;AP24JJ;;AOz4JA;EACI,cAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;AP44JJ;;AO14JA;;EAEI,UAAA;AP64JJ;;AO34JA;EACI,cAAA;EACA,UAAA;AP84JJ;;AO54JA;EACI,iBAAA;EACA,aAAA;AP+4JJ;;AO74JA;EACI;;;;;;;;;IASI,cAAA;IACA,UAAA;EPg5JN;AACF;AO74JA;EACI;;;;;;;;;;;IAWI,cAAA;IACA,UAAA;EP+4JN;AACF;AO54JA;EACI;;;;;;;;;;;IAWI,eAAA;IACA,WAAA;EP84JN;AACF;AO14JA,8BAAA;AACA;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;AP44JJ;;AO14JA;EACI,UAAA;EACA,mBAAA;AP64JJ;;AO14JA;EACI;IACI,4BAAA;EP64JN;AACF;AO14JA,cAAA;AAEI;EACI,kBAAA;AP24JR;AO14JQ;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EAGA,2BAAA;EACA,kCAAA;EACA,gBAAA;AP44JZ;;AOv4JA,oBAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AP04JJ;;AOv4JA,sBAAA;AACA;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,4BAAA;EACA,kBAAA;AP04JJ;AOz4JI;EACI,uBAAA;EACA,cAAA;AP24JR;AOz4JI;EACI,eAAA;EACA,kBAAA;AP24JR;AOz4JI;EACI,eAAA;EACA,kCAAA;EACA,gBAAA;AP24JR;AO14JQ;EACI,eAAA;EACA,YAAA;EACA,kBAAA;AP44JZ;;AOx4JA;EACI,oCAAA;AP24JJ;;AOz4JA;;gDAAA;AAII;EACI,UAAA;EACA,SAAA;AP24JR;AO14JQ;EACI,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AP44JZ;AO34JY;EACI,eAAA;AP64JhB;;AOv4JA;EACI,aAAA;EAGA,mBAAA;EAGA,yBAAA;AP04JJ;AOx4JQ;EACI,gBAAA;AP04JZ;AOv4JI;EACI,kBAAA;APy4JR;AOx4JQ;EACI,eAAA;AP04JZ;AOv4JI;EACI,UAAA;APy4JR;AOv4JI;EACI,UAAA;APy4JR;AOv4JY;EACI,eAAA;APy4JhB;;AOn4JI;EACI,kBAAA;APs4JR;AOp4JI;;;;EAII,YAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,gCAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,4BAAA;EACA,oCAAA;APs4JR;AOr4JQ;;;;EACI,uCAAA;EACA,mBAAA;AP04JZ;AOv4JI;;;EAGI,uCAAA;EACA,mBAAA;APy4JR;AOv4JI;EACI,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;APy4JR;AOv4JI;EACI,WAAA;EACA,YAAA;EACA,wBAAA;EACA,oCAAA;APy4JR;;AOr4JA,mBAAA;AACA;EACI,qBAAA;EACA,gBAAA;APw4JJ;;AOt4JA;EACI,aAAA;APy4JJ;;AOv4JA;EACI,iBAAA;AP04JJ;;AOx4JA;EACI,gBAAA;EACA,UAAA;AP24JJ;;AOz4JA;EACI,qBAAA;EACA,kBAAA;EACA,gCAAA;AP44JJ;;AO14JA;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AP64JJ;;AO34JA;EACI,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,YAAA;EACA,oCAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,iFAAA;EACA,UAAA;EACA,kBAAA;AP84JJ;;AO54JA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;AP+4JJ;;AO74JA;EAAgC,cAAA;APi5JhC;;AO/4JI;EACI,SAAA;EACA,UAAA;EACA,mBAAA;APk5JR;AOh5JI;EACI,kCAAA;APk5JR;;AO94JA;;EAEI,eAAA;APi5JJ;;AO94JA,oBAAA;AACA;EACI,gCAAA;APi5JJ;;AO94JA;;gDAAA;AAGA;EACI,SAAA;EACA,UAAA;APi5JJ;;AO/4JA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;APk5JJ;AOj5JI;EACI,eAAA;APm5JR;AOj5JI;EACI,eAAA;EACA,gBAAA;APm5JR;;AOh5JA;EACI,gBAAA;APm5JJ;;AOj5JA;EACI,8BAAA;APo5JJ;;AOj5JI;EACI,8BAAA;APo5JR;;AOj5JA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;APo5JJ;AOn5JI;EACI,aAAA;APq5JR;;AOl5JA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;APq5JJ;;AOn5JA;EACI,qCAAA;APs5JJ;;AOp5JA;EACI,gBAAA;APu5JJ;;AOr5JA;EACI,kBAAA;EACA,gBAAA;APw5JJ;;AOt5JA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,eAAA;EACA,4BAAA;APy5JJ;AOx5JI;EACI,4BAAA;EACA,WAAA;AP05JR;;AOv5JA;EACI,gBAAA;AP05JJ;AOz5JI;EACI,eAAA;EACA,gBAAA;AP25JR;;AOx5JA;EACI,2CAAA;EACA,8CAAA;EACA,eAAA;AP25JJ;AO15JI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AP45JR;AO15JI;EACI,kCAAA;AP45JR;;AOz5JA;EACI,aAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AP45JJ;;AO15JA;EACI,kBAAA;EACA,yBAAA;EACA,eAAA;AP65JJ;;AOz5JI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AP45JR;AO35JQ;EACI,iBAAA;AP65JZ;AO55JY;EACI,gCAAA;EACA,eAAA;AP85JhB;AO55JY;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AP85JhB;AO35JQ;EACI,gBAAA;EACA,aAAA;EAIA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;AP65JZ;AOz5JQ;EACI,gBAAA;AP25JZ;;AOv5JA;;0CAAA;AAGA;EACI,eAAA;EACA,qBAAA;AP05JJ;AOz5JI;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AP25JR;;AOx5JA;EACI,kBAAA;AP25JJ;;AOz5JA;EACI,8BAAA;EACA,oCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;AP45JJ;AO35JI;EACI,kBAAA;EACA,mBAAA;AP65JR;AO35JI;EACI,YAAA;EACA,mBAAA;AP65JR;AO35JI;EACI,mDAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,4BAAA;AP65JR;AO55JQ;EACI,gCAAA;AP85JZ;;AO15JA;EACI,kBAAA;AP65JJ;AO55JI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AP85JR;;AO15JI;EACI,YAAA;AP65JR;AO35JI;EACI,UAAA;EACA,kBAAA;AP65JR;AO35JI;EACI,UAAA;EACA,mBAAA;AP65JR;;AOz5JA;EACI;IACI,iBAAA;EP45JN;EO15JE;IACI,SAAA;EP45JN;EO15JE;IACI,0BAAA;IACA,UAAA;EP45JN;AACF;AO15JA;EACI;IACI,YAAA;EP45JN;AACF;AOz5JA,aAAA;AACA;EACI,gBAAA;AP25JJ;AO15JI;EACI,kBAAA;AP45JR;AO15JI;EACI,gBAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AP45JR;AO15JI;EACI,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,MAAA;EACA,eAAA;AP45JR;;AOx5JA;;0CAAA;AAII;EACI,eAAA;EACA,gBAAA;AP05JR;AOx5JI;EACI,gBAAA;AP05JR;AOx5JI;EACI,gBAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;AP05JR;;AOt5JI;EACI,8BAAA;EACA,kBAAA;APy5JR;AOx5JQ;EACI,aAAA;AP05JZ;AOx5JQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EAGA,2BAAA;EACA,sBAAA;EACA,kCAAA;AP05JZ;;AOr5JA;;0CAAA;AAMY;EACI,yCAAA;APq5JhB;AOl5JQ;EACI,cAAA;APo5JZ;AOl5JQ;EACI,iBAAA;APo5JZ;;AO/4JA;;0CAAA;AAII;EACI,eAAA;APi5JR;;AO94JA;EACI,gBAAA;EACA,mBAAA;APi5JJ;;AO54JY;EACI,yCAAA;AP+4JhB;AO54JQ;EACI,cAAA;AP84JZ;AO54JQ;EACI,iBAAA;AP84JZ;;AOz4JA;;0CAAA;AAKI;;EACI,iBAAA;EACA,oBAAA;AP24JR;;AOv4JI;EACI,mCAAA;AP04JR;;AOv4JA;EACI,aAAA;AP04JJ;AOz4JI;EACI,eAAA;AP24JR;;AOx4JA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AP24JJ;AO14JI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AP44JR;AO14JI;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;AP44JR;AO34JQ;EACI,yBAAA;AP64JZ;AO14JI;EACI,SAAA;EACA,gBAAA;AP44JR;AO34JQ;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AP64JZ;AO34JQ;EACI,eAAA;EACA,cAAA;AP64JZ;;AOx4JI;;EAEI,mBAAA;AP24JR;;AOx4JA;EACI,iBAAA;EACA,kBAAA;AP24JJ;AO14JI;EACI,6CAAA;EACA,8BAAA;EACA,6BAAA;AP44JR;AO34JQ;EACI,qCAAA;EACA,2CAAA;AP64JZ;;AOv4JI;EACI,mBAAA;AP04JR;;AOt4JA;;0CAAA;AAII;EACI,yBAAA;APw4JR;AOt4JI;EACI,iBAAA;APw4JR;;AOp4JA;;0CAAA;AAGA;EACI,aAAA;APu4JJ;;AOp4JA;;gDAAA;AAGA;EACI,gEAAA;EACA,8BAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;APu4JJ;;AOp4JA;;EAEI,iBAAA;EACA,oBAAA;APu4JJ;;AOr4JA,gCAAA;AACA;EACI,6CAAA;APw4JJ;AOv4JI;;;;;;;;EAQI,mBAAA;APy4JR;AOv4JI;;;;;EAKI,wBAAA;EACA,gCAAA;APy4JR;;AOt4JA,4BAAA;AACA;EACI,2CAAA;APy4JJ;AOx4JI;;;;;;;;EAQI,mBAAA;AP04JR;AOx4JI;;;;;EAKI,wBAAA;EACA,gCAAA;AP04JR;;AOv4JA,4BAAA;AACA;EACI,8BAAA;AP04JJ;AOz4JI;;;;;;;;EAQI,gCAAA;AP24JR;AOz4JI;;;;;EAKI,oCAAA;EACA,wBAAA;EACA,gCAAA;AP24JR;;AOv4JA;EACI,aAAA;EACA,2BAAA;AP04JJ;;AOv4JA,4BAAA;AACA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AP04JJ;AOz4JI;EACI,6BAAA;AP24JR;;AOt4JA;;0CAAA;AAGA;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EAGA,4BAAA;EAGA,2BAAA;EACA,8BAAA;EAEA,gBAAA;EACA,cAAA;APy4JJ;;AOv4JA;EACI,WAAA;EACA,OAAA;EACA,kBAAA;EAGA,4BAAA;AP04JJ;;AOx4JA;EACI,kBAAA;EACA,UAAA;EAIA,aAAA;EAKA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AP24JJ;;AOz4JA;EACI,mBAAA;EACA,kBAAA;AP44JJ;AO34JI;EACI,gBAAA;AP64JR;AO34JI;EACI,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;AP64JR;;AO14JA;EACI;IACI,YAAA;EP64JN;EO34JE;IACI,kBAAA;EP64JN;AACF;AO14JA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AP44JJ;;AO14JA;EACI,kBAAA;AP64JJ;;AO34JA;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AP84JJ;;AO54JA;;EAEI,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EAGA,4BAAA;EAGA,sBAAA;EACA,yBAAA;AP+4JJ;;AO74JA;EAGI,oCAAA;APg5JJ;;AO94JA;EAGI,kBAAA;APi5JJ;;AO/4JA;EACI,cAAA;EACA,uBAAA;EACA,yBAAA;APk5JJ;;AOh5JA;EACI,gBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EAGA,gBAAA;EACA,UAAA;EAEA,gBAAA;APm5JJ;;AOj5JA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;APo5JJ;;AOl5JA;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,oCAAA;APq5JJ;;AOn5JA;EAGI,wBAAA;APs5JJ;;AOp5JA;EAGI,wBAAA;APu5JJ;;AOr5JA;EACI,kBAAA;APw5JJ;;AOt5JA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAIA,aAAA;EACA,WAAA;EACA,iBAAA;APy5JJ;;AOv5JA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EAEA,qCAAA;AP05JJ;;AOx5JA;EAGI,qIAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AP25JJ;;AOz5JA;EACI,6BAAA;AP45JJ;;AO15JA;EACI,6BAAA;AP65JJ;;AO35JA;EACI,wBAAA;EACA,yBAAA;AP85JJ;;AO55JA;EACI,2BAAA;EACA,yBAAA;AP+5JJ;;AO75JA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;APg6JJ;AO/5JI;EACI,gBAAA;APi6JR;AO/5JI;EACI,6BAAA;EACA,eAAA;EACA,eAAA;APi6JR;;AO95JA;EACI,2CAAA;EACA,qBAAA;EACA,cAAA;EACA,8CAAA;APi6JJ;AOh6JI;EACI,UAAA;EACA,SAAA;APk6JR;AOj6JQ;EACI,qBAAA;APm6JZ;AOh6JI;EACI,WAAA;EACA,qBAAA;EACA,YAAA;EACA,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;APk6JR;;AO75JQ;EACI,cAAA;APg6JZ;;AO15JQ;EACI,WAAA;AP65JZ;AO35JQ;EACI,YAAA;AP65JZ;;AOx5JG;EACK,WAAA;EACA,YAAA;EACA,iBAAA;AP25JR;;AOt5JA,2BAAA;AAEI;EACI,WAAA;APw5JR;;AOn5JI;EACI,8BAAA;APs5JR;;AOl5JA;EAEQ;IACI,aAAA;EPo5JV;EOj5JU;IACI,UAAA;EPm5Jd;AACF;AO94JA;;0CAAA;AAGA;EACI;IACI,kBAAA;EPg5JN;EO94JE;IACI,eAAA;EPg5JN;EO94JE;IACI,eAAA;EPg5JN;EO74JM;IACI,kBAAA;EP+4JV;EO74JM;IACI,iBAAA;EP+4JV;EO74JM;IACI,6BAAA;EP+4JV;EO74JM;IACI,eAAA;EP+4JV;AACF;AO34JA;EAEI;IACI,gBAAA;EP44JN;EO14JE;IACI,kBAAA;EP44JN;EO14JE;IACI,kBAAA;EP44JN;EOz4JM;IACI,aAAA;EP24JV;EOt4JM;IACI,2BAAA;IACA,mBAAA;EPw4JV;EOt4JM;;IAEI,cAAA;EPw4JV;EOt4JM;IACI,aAAA;EPw4JV;EOp4JM;IACI,iBAAA;IACA,oBAAA;EPs4JV;AACF;AOh4JA;EACI;;IAEI,aAAA;EPk4JN;EOh4JE,WAAA;EACA;IACI,iBAAA;EPk4JN;EO/3JM;IACI,QAAA;IACA,YAAA;IACA,eAAA;IACA,0BAAA;EPi4JV;EO/3JM;IACI,8BAAA;EPi4JV;EO/3JM;IACI,kBAAA;EPi4JV;EO53JM;IACI,QAAA;IACA,YAAA;IACA,eAAA;IACA,0BAAA;EP83JV;EO53JM;IACI,gBAAA;EP83JV;EOz3JE;IACI,kBAAA;EP23JN;AACF;AOt3JA;EACI;IACI,cAAA;IACA,kBAAA;EPw3JN;EOt3JE;IACI,eAAA;IACA,iBAAA;EPw3JN;EOt3JE;;IAEI,eAAA;EPw3JN;EOt3JE;IACI,iBAAA;EPw3JN;EOt3JE;IACI,YAAA;IACA,iBAAA;EPw3JN;EOt3JE;IACI,SAAA;IACA,UAAA;IACA,2BAAA;EPw3JN;EOt3JE;IACI,aAAA;IACA,8BAAA;EPw3JN;EOt3JE;IACI,iBAAA;IACA,aAAA;EPw3JN;EOt3JE;IACI,gBAAA;EPw3JN;EOp3JM;;IACI,uBAAA;IACA,eAAA;EPu3JV;EOj3JM;;;IACI,cAAA;IACA,uBAAA;IACA,mBAAA;EPq3JV;EOn3JM;;;IACI,cAAA;IACA,cAAA;IACA,uBAAA;EPu3JV;EOn3JM;IACI,uBAAA;IACA,eAAA;EPq3JV;EOj3JM;IACI,2BAAA;IACA,mBAAA;EPm3JV;EOj3JM;;IAEI,cAAA;EPm3JV;EOj3JM;IACI,aAAA;EPm3JV;EOh3JE;IACI,eAAA;IACA,iBAAA;EPk3JN;EO/2JM;IACI,gBAAA;IACA,mBAAA;EPi3JV;AACF;AO32JA;EACI;IACI,eAAA;EP62JN;EO52JM;IACI,eAAA;EP82JV;EO12JM;IACI,iBAAA;EP42JV;EO12JM;IACI,uBAAA;EP42JV;EO12JM;IACI,uBAAA;IACA,gBAAA;EP42JV;EOx2JM;IAGI,uBAAA;EP02JV;EOx2JM;IAGI,uBAAA;IACA,gBAAA;EP02JV;EOv2JE;;IAII,cAAA;EPy2JN;EOt2JM;IACI,eAAA;EPw2JV;EOv2JU;IACI,aAAA;EPy2Jd;AACF;AOn2JA;EACI;IACI,kBAAA;EPq2JN;EOn2JE;IACI,iBAAA;EPq2JN;EOn2JE;IACI,cAAA;EPq2JN;EOl2JE;IACI,kBAAA;IACA,iBAAA;EPo2JN;EOn2JM;IACI,eAAA;IACA,aAAA;EPq2JV;EOl2JU;IACI,aAAA;EPo2Jd;EOl2JU;IACI,eAAA;EPo2Jd;AACF;AO91JA;EAEQ;IACI,iBAAA;EP+1JV;AACF;AO31JA;;0CAAA;AAKI;;EACI,iBAAA;AP41JR;;AOx1JA;;sDAAA;AAGA;EACI,kBAAA;AP21JJ;;AOx1JI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kCAAA;AP21JR;AO11JQ;EAEI,kCAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AP21JZ;AOz1JQ;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AP21JZ;AOz1JQ;EACI,gBAAA;EACA,YAAA;AP21JZ;;AOv1JA;EACI,8BAAA;AP01JJ;AOz1JI;EACI,mCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AP21JR;AOz1JY;EACI,uBAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;AP21JhB;AOx1JgB;EACI,qCAAA;EACA,gBAAA;AP01JpB;AOx1JgB;EACI,UAAA;EACA,mBAAA;EACA,MAAA;AP01JpB;AOv1JY;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;APy1JhB;AOr1JI;EACI,SAAA;APu1JR;AOt1JQ;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;APw1JZ;AOv1JY;EACI,cAAA;APy1JhB;AOt1JgB;EACI,kCAAA;APw1JpB;AOh1JgB;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;APk1JpB;;AO30JA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AP80JJ;AO70JI;EACI,UAAA;AP+0JR;AO90JQ;EACI,gBAAA;APg1JZ;AO70JI;EACI,WAAA;EACA,WAAA;EACA,eAAA;AP+0JR;AO70JI;EAkBI,YAAA;AP8zJR;AO7zJQ;EACI,UAAA;AP+zJZ;AO5zJI;EAEI,YAAA;AP6zJR;AO5zJQ;EACI,UAAA;AP8zJZ;AO3zJI;EAEI,YAAA;AP4zJR;AO3zJQ;EACI,UAAA;AP6zJZ;AO1zJI;EAEI,YAAA;AP2zJR;AO1zJQ;EACI,UAAA;AP4zJZ;;AOvzJI;EACI,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AP0zJR;;AOrzJI;EACI,eAAA;APwzJR;AOtzJI;;EAEI,aAAA;APwzJR;AOrzJQ;EACI,cAAA;APuzJZ;AOrzJQ;EACI,aAAA;APuzJZ;;AOlzJI;EACI,aAAA;APqzJR;;AOjzJI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;APozJR;;AOhzJA;EAIgB;IACI,iBAAA;IACA,eAAA;EPgzJlB;EO9yJc;IACI,eAAA;IACA,WAAA;EPgzJlB;EO3yJU;IACI,eAAA;EP6yJd;EOxyJM;IACI,kBAAA;EP0yJV;EOzyJU;IACI,gBAAA;EP2yJd;AACF;AOpyJA;EACI;IACI,mBAAA;EPsyJN;EOpyJE;IACI,iBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;EPsyJN;EOpyJE;IACI,aAAA;IACA,2BAAA;IACA,8BAAA;IACA,wBAAA;IACA,sBAAA;IACA,SAAA;IACA,iBAAA;IACA,cAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;IACA,yBAAA;EPsyJN;EOryJM;IACI,sBAAA;IACA,gBAAA;IACA,WAAA;EPuyJV;EOnyJE;IACI,aAAA;EPqyJN;EOlyJM;IACI,kBAAA;EPoyJV;EOnyJU;IACI,kBAAA;IACA,YAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;IACA,eAAA;IACA,gBAAA;EPqyJd;EOhyJY;IACI,aAAA;EPkyJhB;EOhyJY;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;IACA,eAAA;IACA,gBAAA;EPkyJd;AACF;AO3xJI;EACI,aAAA;EACA,8BAAA;EACA,uCAAA;EACA,qBAAA;EACA,eAAA;AP6xJR;;AOzxJA;EACE,8BAAA;AP4xJF;;AOzxJA;EACE,uBAAA;EACA,iCAAA;EACA,kCAAA;EAAA,6BAAA;EACA,wBAAA;AP4xJF;;AOzxJA;EACE,kCAAA;EAAA,6BAAA;EACA,iCAAA;EAEA,wBAAA;AP2xJF;;AOvxJA;EACE,kCAAA;EAAA,6BAAA;EACA,kCAAA;EAEA,wBAAA;APyxJF;;AOrxJA;EACE,kCAAA;EAAA,6BAAA;EACA,kCAAA;EAEA,wBAAA;APuxJF;;AOnxJA;EAEE,OAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;APqxJF;;AOjxJA;;sDAAA;AChyEA;;sDAAA;AAGA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;ARujOJ;;AQrjOA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;ARwjOJ;;AQtjOA;EACI,WAAA;ARyjOJ;;AQvjOA;EACI,eAAA;EACA,gBAAA;AR0jOJ;;AQvjOA,2BAAA;AACA;EACI,kBAAA;EACA,UAAA;AR0jOJ;AQzjOI;EACI,UAAA;EACA,kBAAA;EACA,yBAAA;AR2jOR;AQ1jOQ;EACI,qBAAA;EACA,wBAAA;AR4jOZ;AQ1jOQ;EACI,mBAAA;EACA,sBAAA;AR4jOZ;AQ1jOQ;EACI,qBAAA;EACA,wBAAA;AR4jOZ;AQ1jOQ;EACI,mBAAA;EACA,sBAAA;AR4jOZ;AQ1jOQ;EACI,qBAAA;EACA,wBAAA;AR4jOZ;AQ1jOQ;EACI,mBAAA;EACA,sBAAA;AR4jOZ;AQ1jOQ;EACI,qBAAA;EACA,wBAAA;AR4jOZ;AQ1jOQ;EACI,mBAAA;EACA,sBAAA;AR4jOZ;AQ1jOQ;EACI,qBAAA;EACA,wBAAA;AR4jOZ;AQ1jOQ;EACI,mBAAA;EACA,sBAAA;AR4jOZ;;AQrjOQ;;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;ARyjOZ;;AQpjOA,2BAAA;AACA;EACI,yDAAA;EACA,6BAAA;UAAA,qBAAA;EACA,oCAAA;EACA,sBAAA;ARujOJ;;AQrjOA;EACI,yDAAA;ARwjOJ;;AQrjOA,gBAAA;AAEI;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;ARujOR;AQtjOQ;EACI,6CAAA;EACA,yCAAA;EACA,8BAAA;ARwjOZ;AQrjOI;EACI,WAAA;EACA,UAAA;ARujOR;AQpjOQ;EACI,UAAA;EACA,mBAAA;EACA,UAAA;ARsjOZ;AQpjOQ;EACI,WAAA;EACA,UAAA;ARsjOZ;;AQjjOI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;ARojOR;;AQhjOI;EACI,8BAAA;EACA,uCAAA;ARmjOR;;AQhjOA;EAGY;IACI,UAAA;IACA,mBAAA;IACA,UAAA;ERijOd;EQ/iOU;IACI,WAAA;IACA,UAAA;ERijOd;AACF;AQ5iOA,iBAAA;AACA;EACI,mCAAA;EACA,6BAAA;AR8iOJ;AQ7iOI;EACI,gBAAA;AR+iOR;AQ7iOI;EACI,mBAAA;EACA,kCAAA;AR+iOR;AQ9iOQ;EACI,kCAAA;ARgjOZ;AQ7iOI;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AR+iOR;AQ9iOQ;EACI,kCAAA;ARgjOZ;AQ7iOI;EACI,gBAAA;AR+iOR;AQ7iOI;EACI,kBAAA;EACA,8BAAA;AR+iOR;;AQ1iOA;EACE,gBAAA;AR6iOF;;AQ3iOA;EACE,kBAAA;EACA,8BAAA;AR8iOF;;AQviOQ;;EACI,iBAAA;AR2iOZ;AQziOQ;;EACI,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;AR4iOZ;AQxiOQ;;EACI,iBAAA;EACA,kBAAA;AR2iOZ;AQziOQ;;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AR4iOZ;;AQviOA;EACI,gBAAA;AR0iOJ;;AQviOI;EACI,iBAAA;AR0iOR;;AQtiOI;EACI,iBAAA;EACA,kBAAA;ARyiOR;;AQriOA;EACQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ARwiOR;AQviOI;EACI,UAAA;EACA,SAAA;ARyiOR;AQxiOQ;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;AR0iOZ;AQziOY;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,oCAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AR2iOhB;AQ1iOgB;EACI,gBAAA;AR4iOpB;AQxiOgB;EACI,QAAA;EACA,UAAA;EACA,mBAAA;AR0iOpB;AQxiOgB;EACI,wBAAA;AR0iOpB;AQriOI;EACI,eAAA;ARuiOR;AQriOI;EACI,0BAAA;ARuiOR;AQriOI;EACI,gBAAA;ARuiOR;AQriOI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;ARuiOR;AQriOI;EACI,uBAAA;EACA,kBAAA;ARuiOR;AQtiOQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,oCAAA;EACA,qCAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;ARwiOZ;AQtiOQ;EACI,mBAAA;ARwiOZ;AQtiOQ;EACI,eAAA;ARwiOZ;AQriOI;EACI,QAAA;EACA,UAAA;EACA,UAAA;ARuiOR;AQriOI;EACI,QAAA;EACA,SAAA;ARuiOR;AQriOI;EACI,QAAA;EACA,SAAA;ARuiOR;;AQhiOgB;EACI,UAAA;EACA,WAAA;ARmiOpB;AQ9hOY;EACI,qCAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ARgiOhB;;AQ1hOA,iBAAA;AAEI;EACI,iBAAA;AR4hOR;AQ1hOI;EACI,kBAAA;EACA,UAAA;AR4hOR;AQ1hOI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AR4hOR;AQ3hOQ;EACI,iBAAA;EACA,iBAAA;EACA,YAAA;EAEA,mBAAA;EAEA,8BAAA;AR6hOZ;AQzhOQ;EACI,WAAA;EACA,WAAA;AR2hOZ;;AQthOA;EACI,2BAAA;EACA,kBAAA;ARyhOJ;;AQthOA,iBAAA;AACA;EACI,iBAAA;ARyhOJ;AQxhOI;EACI,iBAAA;AR0hOR;;AQthOA,aAAA;AAEI;EACI,kBAAA;ARwhOR;;AQrhOA,iBAAA;AAEI;EACI,YAAA;EACA,SAAA;EACA,WAAA;ARuhOR;AQrhOI;EACI,UAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,uCAAA;ARuhOR;AQphOQ;EACI,WAAA;EACA,WAAA;ARshOZ;AQphOQ;EACI,SAAA;EACA,WAAA;ARshOZ;;AQlhOA,iBAAA;AAEI;EACI,eAAA;ARohOR;AQlhOI;EACI,eAAA;EACA,cAAA;ARohOR;;AQhhOA,iBAAA;AACA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ARmhOJ;AQlhOI;EACI,gBAAA;ARohOR;AQlhOI;EACI,eAAA;EACA,cAAA;ARohOR;;AQ/gOA,aAAA;AACA;EACI,aAAA;ARkhOJ;AQjhOI;EACI,aAAA;EACA,gBAAA;ARmhOR;;AQ/gOI;EACI,cAAA;ARkhOR;AQhhOI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;ARkhOR;AQ/gOQ;EACI,iBAAA;ARihOZ;AQ9gOI;EACI,kBAAA;ARghOR;AQ/gOQ;EAEI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,2CAAA;EACA,SAAA;EACA,2BAAA;ARghOZ;AQ9gOQ;EACI,WAAA;ARghOZ;AQ9gOQ;EACI,YAAA;ARghOZ;AQ3gOY;EAEI,8BAAA;AR4gOhB;AQxgOI;EACI,kBAAA;AR0gOR;AQvgOQ;EAEI,aAAA;ARwgOZ;;AQngOA,kBAAA;AACA;EACI,aAAA;ARsgOJ;AQrgOI;EACI,aAAA;ARugOR;;AQpgOA;;sDAAA;AAGA;;yDAAA;AAGA,aAAA;AAEI;EACI,kBAAA;ARsgOR;AQpgOI;EACI,kBAAA;ARsgOR;AQrgOQ;EACI,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;ARugOZ;AQtgOY;EACI,4BAAA;ARwgOhB;AQtgOY;EACI,mCAAA;ARwgOhB;AQtgOY;EACI,WAAA;ARwgOhB;AQrgOQ;EACI,UAAA;ARugOZ;AQpgOI;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ARsgOR;AQrgOQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,iBAAA;ARugOZ;;AQlgOA,oBAAA;AAEI;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;ARogOR;AQngOQ;EACI,eAAA;EACA,WAAA;ARqgOZ;AQngOQ;EACI,iBAAA;ARqgOZ;;AQ//NA,wBAAA,EAAA,4CAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;ARkgOJ;AQjgOI;EACI,0BAAA;ARmgOR;AQjgOI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;ARmgOR;AQjgOI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;ARmgOR;AQjgOI;EACI,wBAAA;EACA,sBAAA;EACA,aAAA;ARmgOR;AQlgOQ;EACI,SAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;ARogOZ;AQngOY;EACI,cAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;ARqgOhB;AQpgOgB;EACI,qCAAA;EACA,UAAA;ARsgOpB;AQlgOgB;EACI,6CAAA;EACA,UAAA;ARogOpB;;AQ7/NI;EACI,cAAA;ARggOR;;AQ5/NA;EACI;IACI,+BAAA;ER+/NN;AACF;AQ5/NA,6BAAA;AACA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AR8/NJ;AQ7/NI;EACI,kBAAA;AR+/NR;AQ7/NI;EACI,mBAAA;EACA,uCAAA;AR+/NR;AQ9/NQ;EACI,eAAA;ARggOZ;AQ//NY;EACI,iBAAA;EACA,iCAAA;EACA,eAAA;ARigOhB;AQ9/NgB;EACI,YAAA;ARggOpB;AQ5/NQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AR8/NZ;AQ7/NY;EACI,UAAA;AR+/NhB;;AQz/NA,+BAAA,EAAA,4CAAA;AACA;EACI,aAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,qBAAA;AR4/NJ;AQ3/NI;EACI,eAAA;EACA,cAAA;AR6/NR;;AQz/NI;EACI,cAAA;AR4/NR;;AQx/NA,yBAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AR2/NJ;AQ1/NI;EACI,UAAA;AR4/NR;AQ3/NQ;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;AR6/NZ;;AQt/NA;;yDAAA;AAIA;EACI;IACI,iBAAA;ERw/NN;EQt/NE;IACI,iBAAA;ERw/NN;EQt/NE;IACI,aAAA;ERw/NN;AACF;AQt/NA;EACI;;;IAGI,eAAA;ERw/NN;EQt/NE;IACI,aAAA;ERw/NN;EQv/NM;IACI,aAAA;IACA,gBAAA;ERy/NV;EQt/NE;IACI,UAAA;IACA,gBAAA;ERw/NN;EQt/NU;IACI,cAAA;ERw/Nd;EQv/Nc;IACI,iBAAA;IACA,iCAAA;ERy/NlB;EQt/NU;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;IACA,2BAAA;ERw/Nd;EQv/Nc;IACI,UAAA;ERy/NlB;EQn/NM;IACI,aAAA;ERq/NV;EQj/NM;IACI,aAAA;ERm/NV;EQh/NE;IACI,aAAA;ERk/NN;AACF;AQ/+NA;EACI;IACI,eAAA;ERi/NN;EQ/+NE;IACI,aAAA;ERi/NN;EQh/NM;IACI,eAAA;ERk/NV;AACF;AQ9+NA;EAEQ;IACI,UAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;ER++NV;EQ9+NU;IACI,WAAA;IACA,UAAA;ERg/Nd;EQ3+NM;IACI,gBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;ER6+NV;EQz+NM;IACI,MAAA;IACA,QAAA;IACA,kBAAA;ER2+NV;AACF;AQv+NA;EAEQ;IACI,UAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;ERw+NV;EQv+NU;IACI,WAAA;IACA,UAAA;ERy+Nd;EQp+NM;IACI,gBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;ERs+NV;EQl+NM;IACI,MAAA;IACA,QAAA;IACA,kBAAA;ERo+NV;AACF;AQh+NA;EAEQ;IACI,UAAA;IACA,WAAA;ERi+NV;EQh+NU;IACI,WAAA;IACA,UAAA;ERk+Nd;EQ79NM;IACI,eAAA;ER+9NV;EQ59NE;IACI,aAAA;ER89NN;EQ39NM;IACI,MAAA;IACA,QAAA;IACA,kBAAA;ER69NV;AACF;AQz9NA;EACI;IACI,eAAA;ER29NN;EQz9NE;IACI,YAAA;ER29NN;EQz9NE;IACI,eAAA;ER29NN;EQz9NE;IACI,mBAAA;ER29NN;EQx9NM;IACI,eAAA;ER09NV;EQx9NM;IACI,kBAAA;ER09NV;EQv9NE;IACI,kBAAA;ERy9NN;EQv9NE;IACI,iBAAA;IACA,YAAA;ERy9NN;EQx9NM;IACI,eAAA;ER09NV;AACF;AQr9NA;EACI;IACI,eAAA;ERu9NN;EQr9NE;IACI,eAAA;ERu9NN;EQr9NE;IACI,mBAAA;ERu9NN;EQr9NE;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;ERu9NN;EQp9NM;IACI,eAAA;ERs9NV;EQp9NM;IACI,kBAAA;ERs9NV;EQp9NM;IACI,gBAAA;ERs9NV;EQl9NK;IACK,WAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;ERo9NV;EQn9NU;IACI,YAAA;ERq9Nd;EQj9NE;IACI,WAAA;IACA,UAAA;ERm9NN;EQh9NE;IACI,gBAAA;ERk9NN;EQh9NE;IACI,SAAA;IACA,SAAA;IACA,2BAAA;ERk9NN;EQh9NE;IACI,SAAA;ERk9NN;EQh9NE;IACI,SAAA;IACA,UAAA;IACA,0CAAA;ERk9NN;EQh9NE;IACI,SAAA;IACA,yCAAA;ERk9NN;EQ/8NM;IACI,aAAA;ERi9NV;EQ78NM;IACI,eAAA;ER+8NV;EQ58NE;IACI,iBAAA;ER88NN;EQ78NM;IACI,eAAA;ER+8NV;EQ58NE;IACI,aAAA;ER88NN;EQ78NM;IACI,YAAA;IACA,YAAA;ER+8NV;EQ78NM;IACI,aAAA;IACA,6BAAA;ER+8NV;EQ78NM;;IAEI,aAAA;ER+8NV;EQ58NE;IACI,UAAA;IACA,yBAAA;ER88NN;AACF;AQz8NA;EAEI;IACI,eAAA;ER08NN;EQx8NE;IACI,mBAAA;ER08NN;EQx8NE;IACI,aAAA;ER08NN;EQx8NE;IACI,eAAA;ER08NN;EQx8NE;IACI,YAAA;IACA,kBAAA;ER08NN;EQz8NM;IACI,eAAA;ER28NV;EQz8NM;IACI,kBAAA;ER28NV;EQx8NE;IACI,kBAAA;ER08NN;EQx8NE;IACI,aAAA;ER08NN;EQv8NM;IACI,eAAA;ERy8NV;AACF;AQl8NA;;sDAAA;AChlCA;;sDAAA;AAGA;EACI,kBAAA;EACA,mBAAA;ATuhQJ;;ASrhQA;EACI,kBAAA;EACA,gBAAA;ATwhQJ;;ASthQA;EACI,kBAAA;EACA,4BAAA;ATyhQJ;;ASvhQA;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AT0hQJ;;ASxhQA;EACI,YAAA;EACA,mBAAA;AT2hQJ;;ASthQY;EACI,YAAA;EACA,mBAAA;ATyhQhB;;ASphQA;EACI,eAAA;EACA,kBAAA;ATuhQJ;;ASrhQA;EACI,kBAAA;ATwhQJ;;ASthQA;EACI,SAAA;EACA,UAAA;ATyhQJ;;ASvhQA;EACI,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AT0hQJ;;ASxhQA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AT2hQJ;;ASzhQA;EACI,QAAA;EACA,UAAA;EACA,mBAAA;AT4hQJ;;AS1hQA;EACI,SAAA;EACA,UAAA;EACA,qBAAA;EACA,oCAAA;AT6hQJ;;AS3hQA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,6CAAA;AT8hQJ;;AS5hQA;EACI,eAAA;EACA,eAAA;AT+hQJ;;AS7hQA;EACI,cAAA;EACA,8BAAA;EACA,gBAAA;ATgiQJ;;AS9hQA;EACI,6CAAA;EACA,mBAAA;ATiiQJ;;AS/hQA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;ATkiQJ;;AShiQA;EACI,SAAA;EACA,UAAA;ATmiQJ;;ASjiQA;EACI,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AToiQJ;ASniQI;EACI,aAAA;ATqiQR;ASniQI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kDAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;ATqiQR;ASniQI;EACI,8BAAA;ATqiQR;;ASliQA;EACI,iBAAA;ATqiQJ;;ASniQA;EACI,gCAAA;EACA,gBAAA;ATsiQJ;;ASpiQA;EACI,YAAA;EACA,gBAAA;EACA,cAAA;ATuiQJ;;ASriQA;EACI,mBAAA;ATwiQJ;;AStiQA;EACI,gBAAA;EACA,UAAA;ATyiQJ;;ASviQA;EACI,qBAAA;EACA,aAAA;AT0iQJ;;ASxiQA;EACI,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,gCAAA;EACA,4BAAA;AT2iQJ;;ASziQA;EACI,6CAAA;EACA,mBAAA;EACA,yCAAA;AT4iQJ;;ASziQA;EACI,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,4BAAA;AT4iQJ;;AS1iQA;EACI,6CAAA;EACA,mBAAA;AT6iQJ;;AS1iQI;EACI,aAAA;AT6iQR;;AS1iQA,mBAAA;AAGQ;EACI,qCAAA;AT2iQZ;ASxiQI;EACI,eAAA;AT0iQR;ASxiQI;EACI,UAAA;EACA,iBAAA;EACA,eAAA;AT0iQR;AStiQY;EACI,qBAAA;ATwiQhB;;AShiQI;EACI,WAAA;EACA,yBAAA;ATmiQR;ASliQQ;EACI,eAAA;AToiQZ;ASliQQ;EACI,eAAA;EACA,cAAA;AToiQZ;;AS/hQA,mBAAA;AACA;EACI,iBAAA;EACA,mCAAA;EACA,4BAAA;ATkiQJ;AShiQQ;EACI,aAAA;ATkiQZ;AS/hQI;EACI,uBAAA;ATiiQR;AS/hQI;EACI,eAAA;EACA,kCAAA;EACA,gBAAA;ATiiQR;AShiQQ;EACI,eAAA;EACA,YAAA;ATkiQZ;AS/hQI;EACI,qBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;ATiiQR;AShiQQ;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;ATkiQZ;ASjiQY;EACI,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;ATmiQhB;ASliQgB;EACI,kCAAA;EACA,iBAAA;AToiQpB;AS/hQI;EACI,oCAAA;ATiiQR;AShiQQ;EACI,QAAA;ATkiQZ;;AS7hQA,mBAAA;AACA;EACI,oCAAA;EACA,iBAAA;EACA,oCAAA;EACA,8BAAA;ATgiQJ;AS/hQI;EACI,kBAAA;ATiiQR;AShiQQ;EACI,cAAA;ATkiQZ;AShiQQ;EACI,4BAAA;ATkiQZ;AS/hQI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,mCAAA;ATiiQR;AShiQQ;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;ATkiQZ;ASjiQY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;ATmiQhB;AShiQQ;EACI,iBAAA;ATkiQZ;AShiQgB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,iBAAA;EACA,kBAAA;ATkiQpB;ASjiQoB;EACI,cAAA;ATmiQxB;ASjiQoB;EACI,eAAA;ATmiQxB;AS7hQI;EACI,sBAAA;AT+hQR;AS7hQI;EACI,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;AT+hQR;AS9hQQ;EACI,gBAAA;EACA,eAAA;ATgiQZ;AS7hQI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AT+hQR;AS5hQQ;EACI,eAAA;EACA,mBAAA;AT8hQZ;AS3hQI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mCAAA;EACA,uBAAA;AT6hQR;AS3hQI;EACI,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AT6hQR;AS5hQQ;EACI,gBAAA;AT8hQZ;AS7hQY;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,qCAAA;EACA,4BAAA;AT+hQhB;AS9hQgB;EACI,6BAAA;ATgiQpB;AS9hQgB;EACI,6CAAA;EACA,mBAAA;ATgiQpB;ASzhQY;EACI,qBAAA;AT2hQhB;ASzhQY;EACI,aAAA;AT2hQhB;;ASthQA;EACI,aAAA;ATyhQJ;ASxhQI;EACI,eAAA;EACA,kBAAA;AT0hQR;ASzhQQ;EACI,mBAAA;AT2hQZ;ASvhQQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;ATyhQZ;ASvhQQ;EACI,eAAA;ATyhQZ;;ASphQA,mBAAA;AACA;EACI,aAAA;ATuhQJ;ASthQI;EACI,aAAA;ATwhQR;ASvhQQ;EACI,cAAA;ATyhQZ;ASthQI;EACI,aAAA;ATwhQR;ASthQI;EACI,uBAAA;ATwhQR;ASthQI;EACI,iBAAA;EACA,mBAAA;ATwhQR;ASvhQQ;EACI,eAAA;EACA,6BAAA;EACA,kCAAA;EACA,UAAA;ATyhQZ;ASrhQQ;EACI,UAAA;EACA,gBAAA;ATuhQZ;ASthQY;EACI,gBAAA;EACA,eAAA;ATwhQhB;ASvhQgB;EACI,kCAAA;EACA,eAAA;ATyhQpB;ASphQI;EACI,UAAA;EACA,mBAAA;ATshQR;ASrhQQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;ATuhQZ;ASthQY;EACI,eAAA;ATwhQhB;ASthQY;EACI,gBAAA;ATwhQhB;ASphQI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;ATshQR;ASrhQQ;EACI,eAAA;ATuhQZ;ASthQY;EACI,iBAAA;EACA,mCAAA;ATwhQhB;ASphQI;EACI,gBAAA;EACA,mBAAA;ATshQR;;ASlhQI;EACI,uBAAA;ATqhQR;ASphQQ;EACI,iBAAA;EACA,gBAAA;ATshQZ;ASphQQ;EACI,yBAAA;EACA,SAAA;ATshQZ;ASphQQ;EACI,gBAAA;ATshQZ;ASphQQ;EACI,kBAAA;ATshQZ;ASphQQ;EACI,aAAA;EACA,8BAAA;ATshQZ;;ASjhQA;;sDAAA;AAGA;EACI,iBAAA;ATohQJ;;ASlhQA;EACI,gBAAA;ATqhQJ;;ASnhQA;EACI,UAAA;EACA,SAAA;ATshQJ;ASrhQI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,4BAAA;ATuhQR;ASthQQ;EACI,cAAA;EACA,eAAA;ATwhQZ;ASthQQ;EAGI,UAAA;ATshQZ;;ASlhQA;EACI;IACI,gBAAA;ETqhQN;AACF;ASnhQA;EACI,kBAAA;ATqhQJ;;ASnhQA;EACI,eAAA;EACA,mBAAA;ATshQJ;;ASphQA;EACI,gBAAA;EACA,mBAAA;ATuhQJ;;ASrhQA;EACI,eAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;ATwhQJ;;ASthQA;EACI,cAAA;EACA,eAAA;EACA,+CAAA;EACA,4CAAA;ATyhQJ;;ASvhQA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AT0hQJ;ASzhQI;EACI,aAAA;AT2hQR;;ASxhQA;EACI,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AT2hQJ;;ASzhQA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AT4hQJ;;AS1hQA;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;AT6hQJ;;AS3hQA;EACI,eAAA;EACA,gCAAA;EACA,iBAAA;AT8hQJ;;AS3hQI;EACI,SAAA;AT8hQR;;AS3hQA;EACI,aAAA;AT8hQJ;;AS1hQI;EACI,aAAA;AT6hQR;AS3hQI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AT6hQR;AS3hQI;EACI,gBAAA;AT6hQR;AS1hQQ;EACI,mBAAA;AT4hQZ;ASzhQI;EACI,gBAAA;AT2hQR;AS1hQQ;EACI,iBAAA;EACA,kBAAA;AT4hQZ;ASzhQI;EACI,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AT2hQR;;ASvhQA;EACI,YAAA;AT0hQJ;;ASvhQA;;sDAAA;AAGA;EACI,mBAAA;AT0hQJ;;ASxhQA;EACI,qBAAA;AT2hQJ;;ASzhQA;;EAEI,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,qCAAA;EACA,gBAAA;AT4hQJ;AS3hQI;;EACI,eAAA;AT8hQR;AS5hQI;;EACI,kBAAA;AT+hQR;;AS5hQA;;EAEI,mBAAA;EACA,2CAAA;EACA,uCAAA;AT+hQJ;;AS7hQA;EACI,kBAAA;EACA,UAAA;EACA,MAAA;ATgiQJ;;AS9hQA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;ATiiQJ;;AS7hQQ;EACI,yBAAA;ATgiQZ;;AS1hQI;EACI,6BAAA;EACA,oCAAA;EACA,kBAAA;AT6hQR;AS5hQQ;EACI,kCAAA;EACA,6BAAA;EACA,yCAAA;AT8hQZ;AS5hQQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,YAAA;AT8hQZ;AS5hQQ;EACI,aAAA;AT8hQZ;;AS1hQA;EACI,aAAA;AT6hQJ;AS5hQI;EACI,6BAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AT8hQR;AS7hQQ;EACI,kCAAA;EACA,6BAAA;EACA,yCAAA;AT+hQZ;AS9hQY;EACI,6CAAA;EACA,8BAAA;ATgiQhB;AS7hQQ;EACI,eAAA;AT+hQZ;AS7hQQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;AT+hQZ;;ASzhQI;EACI,6BAAA;EACA,UAAA;EACA,iBAAA;EACA,0BAAA;AT4hQR;AS3hQQ;EACI,gBAAA;AT6hQZ;AS3hQQ;EACI,kCAAA;EACA,6BAAA;EACA,0BAAA;AT6hQZ;AS5hQY;EACI,aAAA;AT8hQhB;AS5hQY;EACI,YAAA;AT8hQhB;;ASxhQA;EAEQ;IACI,kBAAA;IACA,eAAA;ET0hQV;AACF;ASrhQA;EACI;;IAEI,kBAAA;IACA,eAAA;ETuhQN;ESrhQE;IACI,iBAAA;ETuhQN;ESrhQE;IACI,aAAA;ETuhQN;ESthQM;IACI,YAAA;IACA,kBAAA;ETwhQV;ESphQM;IACI,UAAA;ETshQV;ESrhQU;IACI,UAAA;ETuhQd;AACF;ASjhQA;;sDAAA;AAGA;EACI,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,mBAAA;EACA,4BAAA;ATmhQJ;ASlhQI;EACI,oCAAA;EACA,yBAAA;ATohQR;ASlhQI;EACI,kCAAA;ATohQR;;ASjhQA;EACI,eAAA;EACA,kBAAA;ATohQJ;;ASjhQA;;sDAAA;AAGA;EACI,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;ATohQJ;;ASlhQA,iEAAA,wBAAA;EACE,WAAA;EACE,iBAAA;ATqhQJ;;ASnhQA,wDAAA,gBAAA;EACE,WAAA;EACE,iBAAA;ATshQJ;;ASphQA,4DAAA,WAAA;EACE,WAAA;EACE,iBAAA;ATuhQJ;;ASrhQA,uDAAA,gBAAA;EACE,WAAA;EACE,iBAAA;ATwhQJ;;ASthQA,kCAAA;AACA;EACI,mBAAA;ATyhQJ;ASxhQI;EACI,gCAAA;AT0hQR;;ASvhQA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AT0hQJ;ASzhQI;EACI,cAAA;AT2hQR;ASzhQY;EACI,6CAAA;EACA,mBAAA;AT2hQhB;;ASthQA;EACI,mBAAA;ATyhQJ;ASxhQI;EACI,SAAA;EACA,aAAA;AT0hQR;ASxhQI;EACI,UAAA;AT0hQR;;ASthQA,mCAAA;AACA;EACI,uBAAA;ATyhQJ;;ASthQA,+BAAA;AAEI;EACI,aAAA;EACA,eAAA;ATwhQR;ASvhQQ;EACI,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ATyhQZ;ASxhQY;EACI,6CAAA;AT0hQhB;;ASrhQA;EACI,yBAAA;EACA,uBAAA;EACA,qCAAA;ATwhQJ;ASvhQI;EACI,UAAA;ATyhQR;;ASthQA;EACI,aAAA;EACA,mBAAA;ATyhQJ;ASxhQI;EACI,gBAAA;EACA,kBAAA;AT0hQR;;ASrhQI;EACI,8CAAA;ATwhQR;ASvhQQ;EACI,aAAA;EACA,eAAA;ATyhQZ;ASxhQY;EACI,6BAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AT0hQhB;ASzhQgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,4BAAA;AT2hQpB;ASzhQgB;EACI,kCAAA;EACA,6BAAA;AT2hQpB;AS1hQoB;EACI,6CAAA;EACA,WAAA;AT4hQxB;ASthQI;EACI,SAAA;EACA,qBAAA;EACA,6BAAA;ATwhQR;ASvhQQ;EACI,aAAA;ATyhQZ;;ASphQA,2BAAA;AAIY;EACI,kBAAA;EACA,kBAAA;ATohQhB;ASnhQgB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;ATqhQpB;ASnhQgB;EACI,aAAA;ATqhQpB;ASlhQY;EACI,gBAAA;ATohQhB;ASlhQY;EACI,gBAAA;ATohQhB;AShhQI;EACI,WAAA;EACA,YAAA;ATkhQR;AShhQI;EACI,SAAA;ATkhQR;ASjhQQ;EACI,qBAAA;ATmhQZ;;AS9gQA,2BAAA;AAEI;EACI,UAAA;EACA,SAAA;ATghQR;AS/gQQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;ATihQZ;AShhQY;EACI,eAAA;ATkhQhB;;AS5gQA,2BAAA;AAEI;EACI,UAAA;EACA,SAAA;AT8gQR;AS7gQQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AT+gQZ;AS9gQY;EACI,eAAA;ATghQhB;;AS1gQI;EACI,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,mCAAA;AT6gQR;AS5gQQ;EACI,kBAAA;AT8gQZ;AS5gQQ;EACI,cAAA;AT8gQZ;AS7gQY;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AT+gQhB;AS7gQY;EACI,gBAAA;EACA,gCAAA;AT+gQhB;;AS1gQA;EACI,aAAA;AT6gQJ;AS5gQI;EACI,SAAA;EACA,UAAA;AT8gQR;AS7gQQ;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AT+gQZ;AS5gQI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AT8gQR;AS7gQQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AT+gQZ;AS7gQQ;EACI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,qCAAA;EACA,gBAAA;AT+gQZ;;AS3gQA;EACI,aAAA;AT8gQJ;;AS3gQI;EACI,UAAA;AT8gQR;;AS3gQA;EACI,kBAAA;AT8gQJ;;AS3gQI;EACI,aAAA;AT8gQR;AS7gQQ;;;;;;;EAOI,aAAA;AT+gQZ;;AS1gQA;EAEQ;IACI,uBAAA;IACA,WAAA;IACA,YAAA;ET4gQV;AACF;ASxgQA;;sDAAA;AAGA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AT0gQJ;;ASxgQA;EACI,eAAA;AT2gQJ;;ASzgQA;EACI,mBAAA;AT4gQJ;AS3gQI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AT6gQR;AS5gQQ;EACI,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AT8gQZ;AS7gQY;EACI,eAAA;AT+gQhB;AS1gQQ;EACI,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AT4gQZ;AS3gQY;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;AT6gQhB;AS3gQY;EACI,gBAAA;AT6gQhB;;ASxgQA;EACI,eAAA;EACA,kBAAA;AT2gQJ;;ASzgQA;EACI,iBAAA;AT4gQJ;;AS1gQA;EACI,kCAAA;AT6gQJ;;AS3gQA;EACI,gBAAA;EACA,eAAA;EACA,qCAAA;AT8gQJ;;AS3gQA;EACI,eAAA;EACA,mBAAA;AT8gQJ;;AS5gQA;EACI,cAAA;EACA,WAAA;EACA,WAAA;AT+gQJ;;AS7gQA;EACI,cAAA;EACA,WAAA;ATghQJ;;AS5gQO;EACK,gBAAA;EACA,mBAAA;AT+gQZ;AS3gQO;EACK,gBAAA;EACA,4BAAA;AT6gQZ;;ASxgQA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AT2gQJ;;ASvgQA,8CAAA;AACA;EACI,WAAA;AT0gQJ;;ASxgQA;EACI,cAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AT2gQJ;;ASzgQA;EACI,YAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;AT4gQJ;;AS1gQA,4CAAA;AAEA;EAEQ;IACI,eAAA;ET2gQV;ESzgQM;IACI,YAAA;ET2gQV;ESxgQU;IACI,kBAAA;ET0gQd;AACF;ASrgQA;EAEQ;IACI,uBAAA;ETsgQV;ESpgQM;IACI,eAAA;ETsgQV;ESrgQU;IACI,eAAA;ETugQd;ESngQE;IACI,mBAAA;ETqgQN;ESlgQM;IACI,eAAA;ETogQV;ESlgQM;IACI,sBAAA;ETogQV;ESlgQM;IACI,oBAAA;IACA,uBAAA;ETogQV;ESlgQc;IACI,eAAA;IACA,eAAA;ETogQlB;ESjgQU;IACI,cAAA;ETmgQd;ESjgQkB;IACI,cAAA;IACA,6BAAA;IACA,aAAA;ETmgQtB;ES9/PM;IACI,aAAA;ETggQV;ES9/PM;IACI,uBAAA;IACA,uBAAA;ETggQV;ES9/PM;IACI,gBAAA;ETggQV;ES5/PM;IACI,gBAAA;ET8/PV;AACF;AS1/PA;EACI;IACI,uBAAA;IACA,iBAAA;ET4/PN;ES1/PE;IACI,aAAA;ET4/PN;ES1/PE;IACI,eAAA;ET4/PN;ESx/PU;IACI,eAAA;ET0/Pd;ESx/PU;IACI,qBAAA;ET0/Pd;ESt/PU;IACI,4BAAA;ETw/Pd;ESn/PM;IACI,eAAA;ETq/PV;ESn/PM;IACI,eAAA;ETq/PV;ESl/PE;IACI,kBAAA;IACA,eAAA;ETo/PN;ESl/PE;IACI,uBAAA;ETo/PN;ESj/PM;IACI,eAAA;ETm/PV;ES9+PU;IACI,wBAAA;IACA,SAAA;ETg/Pd;AACF;ASz+PA;EACI;IACI,YAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;ET2+PN;ESz+PE;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;ET2+PN;ES1+PM;IACI,YAAA;ET4+PV;ESx+PM;IACI,eAAA;ET0+PV;ESx+PM;IACI,iBAAA;IACA,kBAAA;ET0+PV;ESx+PK;IACI,eAAA;ET0+PT;ESz+PU;IACI,eAAA;ET2+Pd;ESx+PK;IACK,eAAA;ET0+PV;ESr+PM;IACI,eAAA;ETu+PV;AACF;ASl+PA;;sDAAA;AC18CA;;gDAAA;AAGA;EACE,mBAAA;AVi7SF;AU96SM;EACE,YAAA;EACA,mBAAA;AVg7SR;AU96SM;EACE,qBAAA;AVg7SR;AU76SI;EACE,QAAA;EACA,UAAA;EACA,mBAAA;AV+6SN;;AU36SA;EACE,kBAAA;EACA,gBAAA;AV86SF;AU76SE;EACE,kBAAA;AV+6SJ;AU76SE;EACE,gBAAA;EACA,eAAA;AV+6SJ;;AU56SA;EACE,kBAAA;EACA,gBAAA;AV+6SF;AU96SE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,2CAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;AVg7SJ;AU96SE;EACE,4BAAA;AVg7SJ;;AU76SA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;AVg7SF;AU/6SE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;AVi7SJ;AUh7SI;EACE,6CAAA;EACA,mBAAA;AVk7SN;;AU96SA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AVi7SF;;AU96SA,oBAAA;AAEE;EACE,uCAAA;EACA,SAAA;AVg7SJ;;AU56SA,oBAAA;AAEE;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AV86SJ;AU56SE;EACE,mBAAA;AV86SJ;AU16SQ;EACE,WAAA;EACA,UAAA;EACA,mBAAA;AV46SV;AU16SQ;EACE,QAAA;AV46SV;;AUt6SE;EACE,aAAA;AVy6SJ;AUr6SQ;EACE,QAAA;AVu6SV;;AUj6SA,0BAAA;AACA;EACE,mBAAA;AVo6SF;;AUl6SA;EACE,0BAAA;AVq6SF;;AUn6SA;EACE,mBAAA;AVs6SF;;AUn6SA;;sDAAA;ACpJA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;+DAAA;AAoDA;;sDAAA;AAII;EACI,SAAA;EACA,UAAA;AX2jTR;AW1jTQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;AX4jTZ;AW3jTY;EACI,SAAA;AX6jThB;;AWtjTI;EACI,SAAA;EACA,UAAA;AXyjTR;AWxjTQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;AX0jTZ;AWzjTY;EACI,qCAAA;EACA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AX2jThB;AW1jTgB;EACI,cAAA;AX4jTpB;AWzjTY;EACI,eAAA;AX2jThB;AWxjTgB;EACI,6CAAA;EACA,mBAAA;AX0jTpB;;AWljTI;EACI,SAAA;EACA,UAAA;AXqjTR;AWpjTQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;AXsjTZ;AWrjTY;EACI,8BAAA;EACA,kCAAA;EACA,wCAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXujThB;AWtjTgB;EACI,cAAA;AXwjTpB;AWrjTY;EACI,eAAA;AXujThB;AWpjTgB;EACI,6CAAA;EACA,yCAAA;EACA,mBAAA;AXsjTpB;;AW/iTA;EAEI,yDAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXijTJ;;AW9iTA;EAEE,yDAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTF;;AW9iTA;EAEI,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTJ;;AW9iTA;EAEI,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTJ;;AW9iTA;EAEM,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTN;;AW9iTE;EAEE,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTJ;;AW7iTA;EAEE,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AX+iTF;;AW5iTA;EAEE,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AX8iTF;;AW5iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AX+iTF;;AW5iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AX+iTF;;AW7iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXgjTF;;AW9iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXijTF;;AW9iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXijTF;;AW/iTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXkjTF;;AWhjTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXmjTF;;AWjjTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXojTF;;AWljTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXqjTF;;AWljTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXqjTF;;AWnjTA;EACE,wBAAA;EAAA,mBAAA;EACA,0DAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AXsjTF;;AWnjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXsjTF;;AWnjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXsjTF;;AWpjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXujTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACE,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AXwjTF;;AWrjTA;EACI,qBAAA;EACA,+BAAA;EACA,4BAAA;AXwjTJ;;AWtjTA;EACI,kBAAA;AXyjTJ;AWxjTI;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,0DAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,MAAA;AX0jTR;;AWtjTA;EACI,kBAAA;AXyjTJ;AWxjTI;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,0DAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,MAAA;AX0jTR;;AWvjTA;EACI,gBAAA;AX0jTJ;;AWvjTA,oCAAA;AACA;EACI;IACI,wBAAA;EX0jTN;EWtjTM;;IACI,aAAA;EXyjTV;AACF;AWpjTI;EACI,SAAA;EACA,UAAA;AXsjTR;AWrjTQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;AXujTZ;AWtjTY;EACI,6CAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AXwjThB;AWtjTY;EACI,eAAA;AXwjThB;AWrjTgB;EACI,6CAAA;EACA,mBAAA;AXujTpB;;AWhjTA;;0CAAA;AAGA;EACI,mBAAA;AXmjTJ;AWljTI;EACI,gBAAA;EACA,gBAAA;AXojTR;AWljTI;EACI,gBAAA;AXojTR;AWjjTQ;EACI,iBAAA;AXmjTZ;AW/iTQ;EACI,iBAAA;EACA,kBAAA;AXijTZ;;AW5iTA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AX+iTJ;AW9iTI;EACI,kCAAA;AXgjTR;AW9iTI;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AXgjTR;AW7iTQ;EACI,mBAAA;AX+iTZ;AW7iTQ;EACI,8BAAA;AX+iTZ;;AWziTA,uBAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AX4iTJ;AW3iTI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,iFAAA;AX6iTR;AW3iTI;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;AX6iTR;AW3iTI;EACI,wBAAA;EACA,cAAA;EACA,kCAAA;AX6iTR;;AWziTA,oBAAA;AACA;EACI,mBAAA;AX4iTJ;AW3iTI;EACI,aAAA;AX6iTR;AW3iTI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AX6iTR;AW3iTI;EACI,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;AX6iTR;AW1iTQ;EACI,mBAAA;EACA,uBAAA;EACA,iBAAA;AX4iTZ;AWxiTQ;EACI,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AX0iTZ;;AWriTA,oBAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AXwiTJ;AWtiTQ;EACI,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AXwiTZ;;AWniTA,YAAA;AACA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;AXsiTJ;;AWniTA;EACI,gBAAA;EACA,kCAAA;AXsiTJ;;AWpiTA;EACI,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AXuiTJ;AWtiTI;EACI,kBAAA;EACA,WAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,YAAA;AXwiTR;;AWniTA;EAEQ;IACI,eAAA;EXqiTV;AACF;AWliTA;EAEQ;IACI,eAAA;EXmiTV;EW/hTM;IACI,gBAAA;EXiiTV;AACF;AW7hTA;EACI;IACI,eAAA;EX+hTN;EW5hTM;IACI,eAAA;EX8hTV;AACF;AW1hTA;EACI;IACI,eAAA;EX4hTN;EWzhTM;IACI,eAAA;EX2hTV;EWzhTO;IACG,mBAAA;EX2hTV;AACF;AWvhTA;EACI;IACI,eAAA;EXyhTN;EWthTM;IACI,eAAA;EXwhTV;EWthTO;IACG,mBAAA;EXwhTV;EWrhTE;IACI,cAAA;EXuhTN;EWthTM;IACI,eAAA;EXwhTV;EWrhTU;IACI,qBAAA;IACA,yBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EXuhTd;EWnhTE;IACI,eAAA;EXqhTN;AACF;AWlhTA;EACI;IACI,eAAA;EXohTN;EWjhTM;IACI,eAAA;EXmhTV;AACF;AW9gTA;;sDAAA;AAGA;EACI,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,uCAAA;EACA,8BAAA;AXghTJ;;AW9gTA;EACI,4BAAA;AXihTJ;;AW/gTA;EACI,sBAAA;AXkhTJ;;AWhhTA;EACI,oCAAA;AXmhTJ;;AWhhTA,yBAAA;AACA;EACI,uBAAA;AXmhTJ;AWlhTI;EACI,WAAA;EACA,UAAA;AXohTR;AWlhTI;EACI,gBAAA;AXohTR;AWnhTQ;EACI,UAAA;EACA,SAAA;AXqhTZ;AWphTY;EACI,kBAAA;EACA,eAAA;EACA,eAAA;AXshThB;AWrhTgB;EACI,cAAA;AXuhTpB;AWlhTI;EACI,kBAAA;AXohTR;AWlhTI;EACI,YAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;AXohTR;;AWhhTA,yBAAA;AACA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;AXmhTJ;AWlhTI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,6CAAA;EAGA,4BAAA;EACA,UAAA;EACA,kBAAA;AXohTR;AWlhTI;EACI,gBAAA;AXohTR;AWnhTQ;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AXqhTZ;AWnhTQ;EACI,kCAAA;AXqhTZ;;AWhhTA;EACI,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;AXmhTJ;AWlhTI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AXohTR;AWlhTI;EACI,sBAAA;AXohTR;AWnhTQ;EACI,gBAAA;AXqhTZ;AWnhTQ;EACI,gBAAA;AXqhTZ;AWlhTI;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;AXohTR;AWnhTQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,oCAAA;EACA,uCAAA;AXqhTZ;AWjhTQ;EACI,iBAAA;EACA,kBAAA;AXmhTZ;AWjhTQ;EACI,iBAAA;EACA,kBAAA;AXmhTZ;AWhhTI;EACI,oCAAA;AXkhTR;;AW/gTA;EACI,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AXkhTJ;AWjhTI;EACI,uBAAA;EACA,cAAA;EACA,kBAAA;AXmhTR;AWlhTQ;EACI,cAAA;AXohTZ;AWlhTQ;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;AXohTZ;AWlhTQ;EACI,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,gCAAA;EACA,4BAAA;EACA,mBAAA;AXohTZ;AWlhTQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,oCAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,0BAAA;AXohTZ;AWhhTQ;EACI,iBAAA;EACA,kBAAA;AXkhTZ;AWhhTQ;EACI,iBAAA;EACA,kBAAA;AXkhTZ;AW/gTI;EACI,oCAAA;EACA,6CAAA;EACA,mBAAA;AXihTR;AWhhTQ;EACI,mBAAA;AXkhTZ;;AW5gTQ;EACI,eAAA;EACA,iBAAA;AX+gTZ;AW7gTQ;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,kCAAA;AX+gTZ;AW7gTQ;EACI,4BAAA;AX+gTZ;AW5gTI;EACI,6CAAA;AX8gTR;AW7gTQ;;EAEI,mBAAA;AX+gTZ;;AWzgTA;EACI,SAAA;AX4gTJ;AW3gTI;EACI,eAAA;EACA,cAAA;EACA,0BAAA;AX6gTR;AW3gTI;EACI,qBAAA;AX6gTR;AW3gTI;EACI,gBAAA;AX6gTR;AW5gTQ;;;EAGI,kCAAA;AX8gTZ;;AWzgTA;EAEQ;IACI,uBAAA;EX2gTV;EW1gTU;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EX4gTd;EW1gTU;IACI,eAAA;EX4gTd;AACF;AWtgTA;EAEQ;IACI,aAAA;EXugTV;EWpgTE;IACI,mBAAA;EXsgTN;EWngTM;IACI,uBAAA;EXqgTV;EWpgTU;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EXsgTd;EWpgTU;IACI,eAAA;EXsgTd;AACF;AWlgTA;;sDAAA;AAGA;EACI,uBAAA;EACA,4BAAA;AXogTJ;;AWjgTA;EAEE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;AXmgTF;;AWhgTA;EAEI,mBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AXkgTJ;;AW//SA,mBAAA;AACA;EACI,uBAAA;AXkgTJ;AWjgTI;EACI,mBAAA;AXmgTR;AWlgTQ;EACI,uBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;AXogTZ;AWngTY;EAEI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AXogThB;AWlgTY;EACI,UAAA;EACA,SAAA;EACA,uBAAA;AXogThB;AWlgTY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,uCAAA;AXogThB;AWjgTQ;EACI,eAAA;EACA,gCAAA;EACA,cAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AXmgTZ;AW7/SY;EACI,mBAAA;EACA,yBAAA;AX+/ShB;AW9/SgB;EACI,YAAA;EACA,WAAA;EACA,iFAAA;AXggTpB;AW9/SgB;EACI,0BAAA;EACA,WAAA;EACA,UAAA;AXggTpB;AW7/SY;EACI,mBAAA;AX+/ShB;AW3/SY;EACI,kCAAA;AX6/ShB;;AWv/SA,mBAAA;AACA;EACI,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AX0/SJ;AWz/SI;EACI,kBAAA;AX2/SR;AWz/SI;EACI,oBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;AX2/SR;AWz/SI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6CAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;AX2/SR;AWz/SI;EACI,oCAAA;AX2/SR;AW1/SQ;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AX4/SZ;AWz/SI;EACI,sBAAA;AX2/SR;AW1/SQ;EACI,oBAAA;AX4/SZ;AW1/SQ;EACI,WAAA;EACA,UAAA;AX4/SZ;;AWv/SA,mBAAA;AACA;EACI,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;AX0/SJ;AWz/SI;EACI,oCAAA;AX2/SR;;AWv/SA,mBAAA;AACA;EACI,uBAAA;EACA,mBAAA;AX0/SJ;AWz/SI;EACI,mBAAA;EACA,eAAA;EACA,cAAA;AX2/SR;AW1/SQ;EACI,gBAAA;AX4/SZ;AW1/SQ;EACI,kBAAA;AX4/SZ;AW3/SY;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AX6/ShB;AWz/SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AX2/SR;AW1/SQ;EACI,gBAAA;AX4/SZ;AWz/SI;EACI,oCAAA;AX2/SR;AW1/SQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;AX4/SZ;AWx/SQ;EACI,kCAAA;AX0/SZ;AWz/SY;EACI,kCAAA;AX2/ShB;AWx/SgB;EACI,8BAAA;EACA,gCAAA;AX0/SpB;AWl/SgB;EACI,6CAAA;EACA,mBAAA;AXo/SpB;;AW5+SI;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AX++SR;;AW3+SA,mBAAA;AACA;EACI,uCAAA;EACA,mBAAA;EACA,uBAAA;AX8+SJ;AW7+SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,6CAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AX++SR;AW7+SI;EACI,kCAAA;AX++SR;AW9+SQ;EACI,4BAAA;AXg/SZ;AW5+SQ;EACI,eAAA;EACA,gBAAA;AX8+SZ;AW5+SQ;EACI,gBAAA;AX8+SZ;AW5+SQ;EACI,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AX8+SZ;AW7+SY;EACI,aAAA;EACA,mBAAA;AX++ShB;AW3+SI;EAEI,oCAAA;AX4+SR;AW3+SQ;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AX6+SZ;AW3+SQ;;;EAEI,kCAAA;AX8+SZ;;AWz+SA;EACE,uCAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AX4+SF;AW3+SE;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EAEA,4BAAA;EACA,UAAA;EACA,kBAAA;AX4+SN;AW1+SE;EACI,kCAAA;AX4+SN;AW3+SM;EACI,4BAAA;AX6+SV;AWz+SM;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AX2+SV;AWz+SM;EACI,gBAAA;AX2+SV;AWz+SM;EACI,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AX2+SV;AW1+SU;EACI,aAAA;EACA,mBAAA;AX4+Sd;AWx+SE;EAEI,oCAAA;AXy+SN;AWx+SM;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AX0+SV;AWx+SM;;;EAEI,kCAAA;AX2+SV;;AWt+SA,mBAAA;AACA;EACI,8BAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;AXy+SJ;AWx+SI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AX0+SR;AWx+SI;EACI,gBAAA;EACA,kBAAA;EACA,kCAAA;AX0+SR;AWx+SI;EACI,gBAAA;AX0+SR;;AWv+SA;EACI,6BAAA;EACA,yBAAA;AX0+SJ;AWz+SI;;EAEI,mBAAA;AX2+SR;;AWv+SA,mBAAA;AACA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;AX0+SJ;AWz+SI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;AX2+SR;AWx+SQ;EACI,kBAAA;AX0+SZ;AWx+SQ;EACI,eAAA;AX0+SZ;;AWr+SA;EACI,oCAAA;AXw+SJ;;AWr+SA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AXw+SJ;AWv+SI;EACI,gBAAA;AXy+SR;;AWp+SQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,uCAAA;AXu+SZ;AWr+SQ;EACI,aAAA;AXu+SZ;;AWl+SA,mBAAA;AACA;EACI,sBAAA;EACA,iBAAA;AXq+SJ;AWp+SI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,eAAA;AXs+SR;AWr+SQ;EACI,cAAA;AXu+SZ;AWp+SI;EACI,gBAAA;AXs+SR;AWp+SI;EACI,kBAAA;AXs+SR;AWp+SI;EACI,6CAAA;AXs+SR;;AWl+SA,yBAAA;AACA;EACI;IACI,mBAAA;EXq+SN;EWn+SE;IACI,uBAAA;EXq+SN;AACF;AWl+SA;;sDAAA;AAGA;EACI,gBAAA;EACA,qBAAA;EACA,oCAAA;EACA,sBAAA;AXo+SJ;AWn+SI;EACI,qBAAA;EACA,kBAAA;AXq+SR;AWp+SQ;EACI,eAAA;AXs+SZ;;AWj+SA;EACI,aAAA;EACA,sBAAA;AXo+SJ;AWn+SI;EACI,kBAAA;AXq+SR;AWp+SQ;EACI,eAAA;EACA,kBAAA;AXs+SZ;AWp+SQ;EACI,eAAA;AXs+SZ;;AWl+SA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AXq+SJ;AWp+SI;EACI,kBAAA;AXs+SR;AWr+SQ;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,kCAAA;AXu+SZ;AWr+SQ;EACI,eAAA;EACA,kBAAA;EACA,qCAAA;AXu+SZ;AWp+SI;EACI,gBAAA;AXs+SR;;AWn+SA;EAGY;IACI,eAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;EXo+Sd;EWl+SU;IACI,eAAA;EXo+Sd;AACF;AW/9SA;EACI;IACI,gBAAA;EXi+SN;AACF;AW99SA;;sDAAA;AAGA;EACI,kBAAA;EACA,mBAAA;AXg+SJ;;AW99SA;EACI,kBAAA;AXi+SJ;AWh+SI;EACI,gBAAA;AXk+SR;;AW/9SA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AXk+SJ;AWj+SI;EACI,SAAA;EACA,UAAA;AXm+SR;AWj+SI;EACI,gBAAA;AXm+SR;AWl+SQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oCAAA;EACA,gCAAA;AXo+SZ;AWn+SY;EACI,eAAA;EACA,kBAAA;AXq+ShB;AWn+SY;EACI,qBAAA;EACA,cAAA;EACA,eAAA;AXq+ShB;;AWh+SA;EACI,oBAAA;AXm+SJ;;AWj+SA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;AXo+SJ;;AWl+SA;EACI,mBAAA;AXq+SJ;AWp+SI;EACI,UAAA;EACA,SAAA;AXs+SR;AWp+SI;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AXs+SR;AWr+SQ;EACI,eAAA;AXu+SZ;AWr+SQ;EACI,kCAAA;EACA,iBAAA;AXu+SZ;AWr+SQ;EACI,gBAAA;AXu+SZ;;AWl+SG;EACK,kBAAA;EACA,kBAAA;EACA,qBAAA;AXq+SR;AWp+SQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AXs+SZ;AWp+SQ;EACI,aAAA;AXs+SZ;;AWj+SI;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AXo+SR;;AWj+SA;EACI,gCAAA;EACA,4BAAA;AXo+SJ;;AWj+SI;EACI,6CAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AXo+SR;AWn+SQ;EACI,eAAA;AXq+SZ;AWn+SQ;EACI,2CAAA;EACA,mBAAA;AXq+SZ;;AWj+SA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AXo+SJ;AWn+SI;EACI,gBAAA;AXq+SR;;AWj+SA,qBAAA;AAEI;EACI,+BAAA;AXm+SR;AW/9SY;EACI,kBAAA;AXi+ShB;AWh+SgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,2CAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;AXk+SpB;AW/9SoB;EACI,aAAA;AXi+SxB;;AWz9SA,qBAAA;AACA;EACI,4BAAA;AX49SJ;AW39SI;EACI,uBAAA;AX69SR;AW39SI;EACI,YAAA;EACA,UAAA;EACA,QAAA;AX69SR;AW59SQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,2CAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;AX89SZ;AW59SQ;EACI,aAAA;AX89SZ;AW39SI;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;AX69SR;AW39SI;EACI,oCAAA;AX69SR;AW59SQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;AX89SZ;;AWz9SA,qBAAA;AACA,qBAAA;AAGI;;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;AX29SR;AWz9SI;;EACI,mBAAA;AX49SR;AW19SI;;EACI,qBAAA;EACA,mCAAA;EACA,iBAAA;AX69SR;AW59SQ;;EACI,gBAAA;AX+9SZ;AW59SI;;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;AX+9SR;;AW39SA,qBAAA;AAEI;EACI,wBAAA;EACA,oCAAA;AX69SR;AW39SI;EACI,iBAAA;AX69SR;;AWx9SI;EACI,mBAAA;AX29SR;AW19SQ;EACI,WAAA;AX49SZ;AW19SQ;EACI,eAAA;AX49SZ;;AWt9SI;EACI,gBAAA;AXy9SR;AWx9SQ;EACI,4BAAA;AX09SZ;AWr9SY;EACI,qBAAA;AXu9ShB;;AWj9SA,qBAAA;AACA;EACI,gCAAA;EACA,eAAA;AXo9SJ;AWn9SI;EACI,aAAA;EACA,4BAAA;AXq9SR;AWn9SI;EACI,4BAAA;AXq9SR;AWn9SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,2CAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AXq9SR;AWl9SQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AXo9SZ;AWl9SQ;EACI,6BAAA;AXo9SZ;AWl9SQ;;;EAGI,mBAAA;AXo9SZ;;AW98SA,qBAAA;AACA;EACI,wCAAA;AXi9SJ;AWh9SI;EACI,4BAAA;AXk9SR;AWh9SI;EACI,iBAAA;AXk9SR;AWh9SI;EACI,eAAA;AXk9SR;AWj9SQ;EACI,eAAA;AXm9SZ;AWh9SI;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;AXk9SR;;AW98SA,oBAAA;AAEI;EACI,WAAA;EACA,iBAAA;AXg9SR;;AW58SA,oBAAA;AACA;EACI,SAAA;AX+8SJ;AW78SQ;EACI,mBAAA;AX+8SZ;AW98SY;EACI,mBAAA;AXg9ShB;AW78SgB;EACI,qBAAA;AX+8SpB;AW18SI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AX48SR;AW38SQ;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,kBAAA;EACA,4BAAA;AX68SZ;AW38SQ;EAEI,qBAAA;AX48SZ;;AWv8SA,gBAAA;AACA;EACI,oCAAA;EACA,4BAAA;AX08SJ;AWz8SI;EACI,oCAAA;AX28SR;AWz8SI;EACI,4BAAA;AX28SR;AWz8SI;EACI,eAAA;AX28SR;AWz8SI;EACI,eAAA;AX28SR;;AWv8SA,gBAAA;AACA;EACI,oCAAA;EACA,4BAAA;AX08SJ;AWz8SI;EACI,oCAAA;AX28SR;AWx8SQ;EACI,kCAAA;AX08SZ;AWv8SI;EACI,4BAAA;AXy8SR;AWv8SI;EACI,eAAA;EACA,yBAAA;AXy8SR;AWv8SI;EACI,eAAA;EACA,iBAAA;AXy8SR;AWv8SI;EACI,eAAA;AXy8SR;;AWr8SA,mBAAA;AAEI;EACI,mBAAA;AXu8SR;AWr8SI;EACI,eAAA;EACA,gBAAA;AXu8SR;AWp8SQ;EACI,4BAAA;AXs8SZ;AWl8SQ;EACI,mBAAA;AXo8SZ;AWl8SQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AXo8SZ;AWn8SY;EACI,eAAA;EACA,OAAA;AXq8ShB;AWn8SY;EAEI,qBAAA;AXo8ShB;;AW97SA;EAEQ;IACI,eAAA;EXg8SV;EW77SS;IACK,eAAA;IACA,mBAAA;EX+7Sd;EW97Sc;IACI,eAAA;EXg8SlB;EW77SU;IACI,kBAAA;EX+7Sd;EW17SM;IACI,eAAA;EX47SV;AACF;AWz7SA;EACI;IACI,eAAA;EX27SN;EWx7SM;IACI,wBAAA;EX07SV;EWt7SM;IACI,eAAA;EXw7SV;EWr7SS;IACK,eAAA;IACA,kBAAA;EXu7Sd;EWt7Sc;IACI,eAAA;IACA,cAAA;IACA,kBAAA;IACA,mBAAA;EXw7SlB;EWr7SU;IACI,eAAA;EXu7Sd;AACF;AWl7SA;EACI;IACI,eAAA;EXo7SN;EWl7SE;IACI,kBAAA;IACA,eAAA;EXo7SN;EWj7SM;IACI,eAAA;EXm7SV;EWh7SS;IACK,4BAAA;EXk7Sd;EW96SS;IACK,eAAA;IACA,kBAAA;EXg7Sd;EW/6Sc;IACI,eAAA;IACA,cAAA;IACA,kBAAA;IACA,mBAAA;EXi7SlB;EW96SU;IACI,eAAA;EXg7Sd;EW16SM;;IACI,eAAA;EX66SV;EWz6SM;IACI,eAAA;EX26SV;EWz6SK;IACK,4BAAA;EX26SV;AACF;AWt6SA;;sDAAA;AAII;EACI,gBAAA;AXu6SR;AWr6SI;EACI,iBAAA;AXu6SR;AWr6SI;EACI,aAAA;EACA,eAAA;AXu6SR;AWr6SI;EACI,mBAAA;AXu6SR;AWp6SQ;EACI,+BAAA;AXs6SZ;AWn6SI;EACI,eAAA;AXq6SR;;AWj6SA,sBAAA;AACA;EACI,wCAAA;EACA,aAAA;AXo6SJ;;AWj6SA;EACI,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AXo6SJ;AWn6SI;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AXq6SR;;AWj6SA;EACI,kBAAA;AXo6SJ;AWn6SI;EACI,eAAA;AXq6SR;;AWl6SA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AXq6SJ;;AWn6SA;EACI,mBAAA;AXs6SJ;;AWp6SA;EACI,gBAAA;AXu6SJ;;AWr6SA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AXw6SJ;;AWt6SA;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,kCAAA;AXy6SJ;;AWt6SA;EACI,SAAA;EACA,UAAA;AXy6SJ;;AWv6SA;EACI,gBAAA;EACA,4CAAA;EACA,iBAAA;EACA,eAAA;AX06SJ;;AWx6SA;EACI,aAAA;EACA,cAAA;EACA,aAAA;AX26SJ;;AWz6SA;EACI,kBAAA;EACA,UAAA;AX46SJ;;AW16SA;EACI,kBAAA;EACA,iBAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,MAAA;EACA,QAAA;AX66SJ;AW56SI;EACI,iBAAA;AX86SR;AW56SI;EACI,yCAAA;AX86SR;;AW16SI;EACI,aAAA;EACA,gCAAA;AX66SR;AW56SQ;;;;;EAKI,4BAAA;AX86SZ;;AWx6SQ;EACI,UAAA;EACA,SAAA;AX26SZ;AW16SY;EACI,UAAA;EACA,SAAA;AX46ShB;;AWv6SA;EACG,eAAA;EACA,gBAAA;EACA,gBAAA;AX06SH;;AWx6SA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AX26SF;;AWx6SA;EAEE,gBAAA;EACA,gBAAA;AX06SF;;AWx6SA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AX26SJ;;AWt6SY;EACI,0BAAA;AXy6ShB;;AWp6SA;EACI,kBAAA;AXu6SJ;AWt6SI;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,eAAA;EACA,kCAAA;AXw6SR;AWt6SI;EACI,kCAAA;AXw6SR;AWt6SI;EACI,eAAA;EACA,gBAAA;AXw6SR;;AWr6SA;EACI,aAAA;EACA,wCAAA;EACA,mBAAA;AXw6SJ;AWv6SI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AXy6SR;AWv6SI;EACI,gBAAA;AXy6SR;AWx6SQ;EACI,gBAAA;EACA,eAAA;EACA,kCAAA;AX06SZ;AWx6SQ;;;EAGI,mBAAA;AX06SZ;AWx6SQ;EACI,eAAA;EACA,gBAAA;AX06SZ;AWz6SY;EACI,gBAAA;AX26ShB;;AWr6SA;EACI;IACI,gBAAA;IACA,kBAAA;EXw6SN;AACF;AWr6SA;EACI;IACI,2BAAA;IACA,gBAAA;EXu6SN;AACF;AWp6SA;EAEQ;IACI,aAAA;IACA,eAAA;EXq6SV;EWn6SM;IACI,mBAAA;EXq6SV;EWl6SE;IACI,kBAAA;EXo6SN;EWl6SE;IACI,eAAA;IACA,4BAAA;EXo6SN;EWn6SM;IACI,iBAAA;IACA,eAAA;IACA,cAAA;IACA,cAAA;EXq6SV;EWj6SM;IACI,eAAA;EXm6SV;EWh6SE;IACI,mBAAA;EXk6SN;EWh6SE;IACI,gBAAA;IACA,gBAAA;EXk6SN;EWh6SE;IACI,kBAAA;EXk6SN;EWj6SM;IACI,gBAAA;IACA,iBAAA;IACA,mBAAA;EXm6SV;EWj6SM;IACI,iBAAA;EXm6SV;EWh6SE;IACI,cAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;EXk6SN;EWh6SE;IACI,eAAA;EXk6SN;EWh6SE;IACI,iBAAA;IACA,eAAA;EXk6SN;EWh6SE;IACI,WAAA;EXk6SN;EWh6SE;IACI,gBAAA;EXk6SN;EWh6SE;IACI,kBAAA;EXk6SN;EWh6SE;IACI,eAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;EXk6SN;AACF;AW/5SA;;sDAAA;AAII;EACI,UAAA;AXg6SR;AW/5SQ;EACI,cAAA;EACA,6BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,qCAAA;AXi6SZ;AWh6SY;EACI,gCAAA;AXk6ShB;AWh6SY;EACI,iBAAA;EACA,kCAAA;AXk6ShB;AWh6SY;EACI,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,kCAAA;AXk6ShB;;AW55SA;EACI;IACI,WAAA;IACA,cAAA;EX+5SN;AACF;AW55SA;;sDAAA;AAGA,sBAAA;AAEI;EACI,SAAA;EACA,UAAA;AX65SR;AW55SQ;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;AX85SZ;AW75SY;EACI,iBAAA;AX+5ShB;AW75SY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AX+5ShB;AW55SgB;EACA,6CAAA;EACA,yCAAA;EACA,mBAAA;AX85ShB;;AWv5SA;EAGW;IACK,iBAAA;IACA,eAAA;EXw5Sd;EWv5Sc;IACI,YAAA;IACA,WAAA;IACA,iBAAA;EXy5SlB;AACF;AWn5SA;;sDAAA;AAGA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AXq5SJ;AWn5SQ;EACI,mBAAA;AXq5SZ;AWj5SQ;EACI,iBAAA;EACA,kBAAA;AXm5SZ;AW/4SQ;EACI,iBAAA;EACA,eAAA;AXi5SZ;;AW74SA;EACI,gBAAA;EACA,mBAAA;AXg5SJ;AW/4SI;EACI,gBAAA;AXi5SR;AW/4SI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AXi5SR;;AW74SA,uBAAA;AACA;EACI,cAAA;AXg5SJ;AW/4SI;EACI,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AXi5SR;AWh5SQ;EACI,gBAAA;EACA,oCAAA;AXk5SZ;AW/4SI;EACI,eAAA;AXi5SR;AW94SQ;EACI,eAAA;EACA,kBAAA;AXg5SZ;AW94SQ;EACI,kCAAA;AXg5SZ;;AW34SA,uBAAA;AACA;EACI,eAAA;EACA,mBAAA;AX84SJ;AW74SI;EACI,oCAAA;EACA,wBAAA;EACA,oBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AX+4SR;AW94SQ;EACI,aAAA;AXg5SZ;AW94SQ;EACG,kBAAA;EACC,aAAA;AXg5SZ;AW94SQ;EACI,kBAAA;EACA,aAAA;EACA,kCAAA;AXg5SZ;AW74SI;EACI,aAAA;EACA,mBAAA;AX+4SR;AW74SI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AX+4SR;AW94SQ;EACI,gBAAA;AXg5SZ;;AW34SA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AX84SJ;AW74SI;EACI,gBAAA;EACA,cAAA;EACA,0BAAA;AX+4SR;;AW34SA,uBAAA;AACA;EACI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,oCAAA;EACA,UAAA;AX84SJ;AW74SI;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AX+4SR;AW94SQ;EACI,gBAAA;AXg5SZ;AW74SI;EACI,gBAAA;AX+4SR;AW94SQ;EACI,mBAAA;AXg5SZ;AW94SQ;EACG,kBAAA;AXg5SX;AW94SQ;EACI,kBAAA;EACA,kCAAA;AXg5SZ;;AW34SA,uBAAA;AACA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AX84SJ;;AW34SI;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AX84SR;AW54SI;EACQ,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AX84SZ;AW74SQ;EACI,uBAAA;EACA,oCAAA;AX+4SZ;AW54SI;EACI,gBAAA;AX84SR;AW74SQ;EACI,eAAA;AX+4SZ;AW74SQ;EACI,eAAA;EACA,kBAAA;AX+4SZ;AW74SQ;EACI,kCAAA;AX+4SZ;;AW14SA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AX64SJ;AW54SI;EACI,gBAAA;AX84SR;AW74SQ;EACI,kBAAA;AX+4SZ;AW74SQ;EACI,YAAA;EACA,SAAA;EACA,OAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,QAAA;EACA,SAAA;AX+4SZ;AW74SQ;EACI,YAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,QAAA;EACA,QAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,QAAA;EACA,SAAA;AX+4SZ;AW74SQ;EACI,WAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AX+4SZ;;AW14SA,uBAAA;AACA;EACI,iBAAA;EACA,gBAAA;AX64SJ;AW34SQ;EACI,SAAA;EACA,kCAAA;AX64SZ;AW14SI;EACI,eAAA;AX44SR;;AWx4SA,uBAAA;AACA;EACI,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AX24SJ;AW14SI;EACI,mBAAA;AX44SR;AWz4SQ;EACI,eAAA;AX24SZ;AW14SY;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AX44ShB;AWx4SI;EACI,aAAA;EACA,mBAAA;AX04SR;AWz4SQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AX24SZ;AWx4SY;EACI,gBAAA;EACA,gBAAA;AX04ShB;AWx4SY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AX04ShB;AWt4SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,6CAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AXw4SR;AWr4SQ;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AXu4SZ;AWn4SgB;EACI,kCAAA;AXq4SpB;;AW93SA,uBAAA;AACA;EACI,uBAAA;AXi4SJ;AW/3SQ;EACI,gBAAA;AXi4SZ;AW/3SQ;EACI,gBAAA;AXi4SZ;;AW53SA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AX+3SJ;;AW53SA;EACI;IACI,cAAA;EX+3SN;EW93SM;IACI,eAAA;EXg4SV;EW93SM;IACI,eAAA;EXg4SV;EW73SE;IACI,cAAA;EX+3SN;EW33SU;IACI,eAAA;EX63Sd;EWx3SE;IACI,wBAAA;EX03SN;EWx3SE;IACI,yBAAA;EX03SN;EWt3SU;IACI,eAAA;EXw3Sd;AACF;AWl3SA;EACI;IACI,cAAA;EXo3SN;EWn3SM;IACI,eAAA;EXq3SV;EWn3SM;IACI,eAAA;EXq3SV;EWj3SM;IACI,wBAAA;IACA,uBAAA;EXm3SV;EWj3SM;IACI,mBAAA;EXm3SV;EWj3SM;IACI,mBAAA;EXm3SV;EW/2SK;IACK,WAAA;EXi3SV;EW92SE;IACI,cAAA;EXg3SN;EW52SU;IACI,eAAA;EX82Sd;EWx2SU;IACI,eAAA;EX02Sd;EWv2SM;IACI,mBAAA;EXy2SV;EWx2SU;IACI,mBAAA;EX02Sd;AACF;AWl2SA;;sDAAA;AAGA;EACI,mBAAA;EACA,kBAAA;AXo2SJ;;AWl2SA;EACI,gBAAA;AXq2SJ;AWp2SI;EACI,4BAAA;AXs2SR;AWn2SQ;EACI,qBAAA;EACA,6BAAA;AXq2SZ;;AWj2SA;EACI,mBAAA;AXo2SJ;;AWl2SA;EACI,kBAAA;EACA,iBAAA;EACA,mCAAA;AXq2SJ;;AWl2SA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AXq2SJ;;AWn2SA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AXs2SJ;AWr2SI;EACI,0BAAA;EACA,kBAAA;EACA,0CAAA;EACA,qBAAA;AXu2SR;AWt2SQ;EACI,mBAAA;AXw2SZ;;AWn2SA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AXs2SJ;AWr2SI;EACI,kBAAA;EACA,kBAAA;AXu2SR;AWt2SQ;EACI,mBAAA;AXw2SZ;AWt2SQ;EACI,mBAAA;AXw2SZ;AWt2SQ;EACI,6CAAA;AXw2SZ;AWr2SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,2CAAA;EACA,YAAA;AXu2SR;AWp2SQ;EACI,aAAA;AXs2SZ;;AW/1SA;;sDAAA;AAGA;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AXk2SJ;AWj2SI;EACI,oCAAA;AXm2SR;;AWh2SA;EACI,kBAAA;AXm2SJ;;AWh2SA,gBAAA;AACA;EACI,kBAAA;AXm2SJ;AWl2SI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AXo2SR;AWl2SI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AXo2SR;AWj2SQ;EACI,YAAA;EACA,mBAAA;AXm2SZ;AWj2SQ;EACI,QAAA;EACA,UAAA;EACA,mBAAA;AXm2SZ;;AW91SA,gBAAA;AACA;EACI,uBAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;AXi2SJ;AWh2SI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AXk2SR;AWj2SQ;EACI,mBAAA;AXm2SZ;AWh2SI;EACI,yBAAA;AXk2SR;AWh2SI;EACI,UAAA;EACA,gBAAA;AXk2SR;AWh2SI;EACI,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;AXk2SR;AWh2SI;EACI,2CAAA;AXk2SR;AWj2SQ;;;EAGI,mBAAA;AXm2SZ;AWj2SQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,gDAAA;AXm2SZ;;AW91SA;EACI;IACI,gBAAA;IACA,iBAAA;IACA,kBAAA;EXi2SN;AACF;AW91SA;;sDAAA;AAGA;EACI,mBAAA;EACA,kBAAA;AXg2SJ;AW/1SI;EACI,mBAAA;AXi2SR;AWh2SQ;EACI,eAAA;EACA,cAAA;EACA,kCAAA;AXk2SZ;AW/1SI;EACI,gBAAA;EACA,eAAA;AXi2SR;AW/1SI;EACI,0BAAA;EACA,kCAAA;AXi2SR;;AW91SA,qBAAA;AACA;EACI,mBAAA;EACA,aAAA;AXi2SJ;AWh2SI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;AXk2SR;AWj2SQ;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AXm2SZ;AWh2SI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AXk2SR;AWh2SI;EACI,eAAA;AXk2SR;;AW/1SA,qBAAA;AACA;EACI,mBAAA;AXk2SJ;AWj2SI;EACI,0BAAA;AXm2SR;AWj2SI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AXm2SR;AWj2SI;EACI,eAAA;AXm2SR;AWj2SI;EACI,kCAAA;AXm2SR;;AW/1SA;EAEQ;IACI,eAAA;EXi2SV;AACF;AW91SA;EACI;IACI,eAAA;EXg2SN;AACF;AW91SA;EACI;IACI,kBAAA;EXg2SN;EW91SE;IACI,eAAA;EXg2SN;EW91SE;IACI,kBAAA;EXg2SN;EW/1SM;IACI,eAAA;EXi2SV;AACF;AW71SA;;sDAAA;AAGA;EACI,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AX+1SJ;AW91SI;EACI,6BAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;AXg2SR;AW71SQ;EACI,2CAAA;EACA,mBAAA;AX+1SZ;;AW31SA;EACI,oBAAA;EACA,gBAAA;EACA,gBAAA;AX81SJ;AW71SI;EACI,qBAAA;AX+1SR;;AW51SA;EACI,uBAAA;EACA,kBAAA;EACA,UAAA;AX+1SJ;AW91SI;EACI,0BAAA;AXg2SR;AW91SI;EACI,0BAAA;AXg2SR;AW91SI;EACI,0BAAA;AXg2SR;AW91SI;EACI,0BAAA;AXg2SR;;AW51SI;;EAEI,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AX+1SR;;AW51SA;EACI,aAAA;AX+1SJ;;AW71SA;EACI,gBAAA;EACA,wCAAA;EACA,uBAAA;AXg2SJ;AW/1SI;EACI,eAAA;EACA,SAAA;EACA,gBAAA;AXi2SR;AW/1SI;EACI,mBAAA;AXi2SR;AWh2SQ;EACI,eAAA;AXk2SZ;AW91SQ;EACI,6BAAA;EACA,kCAAA;AXg2SZ;;AW11SI;EACI,iBAAA;AX61SR;AW31SI;EACI,mBAAA;AX61SR;;AWz1SA;EACI;IACI,uBAAA;EX41SN;AACF;AW11SA;;sDAAA;AAII;EACI,SAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;AX21SR;AWz1SY;EACI,gBAAA;EACA,yBAAA;EACA,yBAAA;AX21ShB;AWz1SY;EACI,yBAAA;AX21ShB;AWz1SY;EACI,mBAAA;AX21ShB;AWz1SY;EACI,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AX21ShB;AWz1SY;EACI,4BAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AX21ShB;;AWr1SA;EACI,aAAA;AXw1SJ;;AWt1SA;EACG;IACK,aAAA;EXy1SN;EWv1SE;IACI,cAAA;EXy1SN;AACF;AWr1SA;;sDAAA;AAGA;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AXu1SJ;;AWr1SA;EACI,YAAA;EACA,UAAA;AXw1SJ;;AWt1SA;EACI,WAAA;EACA,uBAAA;AXy1SJ;;AWv1SA;EACI,YAAA;EACA,sBAAA;AX01SJ;;AWx1SA;;;EAGI,8BAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;AX21SJ;;AWz1SA;EACI,8CAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AX41SJ;;AWz1SA;;sDAAA;AAII;EACI,eAAA;EACA,gBAAA;AX21SR;AWz1SI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AX21SR;AWz1SI;EACI,mBAAA;AX21SR;AWz1SI;EACI,qBAAA;EACA,kBAAA;AX21SR;AWz1SI;EACI,qBAAA;EACA,aAAA;AX21SR;AWz1SI;EACI,uBAAA;AX21SR;;AWt1SA;;sDAAA;AAGA;EACI,yBAAA;AXy1SJ;;AWv1SA;EACI,yBAAA;AX01SJ;;AWv1SI;EACI,gCAAA;AX01SR;AWx1SI;EACI,sBAAA;EACA,gBAAA;EACA,yBAAA;AX01SR;AWx1SI;EACI,6BAAA;EACA,cAAA;EACA,WAAA;AX01SR;AWx1SI;EACI,kBAAA;EACA,sBAAA;AX01SR;;AWv1SA;EACI,gBAAA;AX01SJ;;AWx1SA;EACI,eAAA;AX21SJ;;AWz1SA;EACI,kCAAA;AX41SJ;;AW11SA;EACI,gBAAA;AX61SJ;;AW31SA;EACI,yBAAA;EACA,iBAAA;AX81SJ;;AW51SA;EACI,gBAAA;AX+1SJ;;AW71SA;EACI,gBAAA;EACA,gBAAA;AXg2SJ;;AW91SA;EACI,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,4BAAA;AXi2SJ;;AW/1SA;EACI,6CAAA;EACA,mBAAA;AXk2SJ;;AWh2SA;EACI,mBAAA;AXm2SJ;;AWj2SA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;AXo2SJ;AWn2SI;EACI,gBAAA;AXq2SR;AWn2SI;EACI,aAAA;AXq2SR;AWp2SQ;EACI,cAAA;AXs2SZ;;AWj2SA;EACI;IACI,kBAAA;EXo2SN;EWl2SE;IACI,eAAA;EXo2SN;EWl2SE;IACI,eAAA;EXo2SN;AACF;AWj2SA;EACI;IACI,aAAA;EXm2SN;EWj2SE;IACI,cAAA;IACA,kBAAA;EXm2SN;EWj2SE;IACI,cAAA;IACA,kBAAA;EXm2SN;EWj2SE;IACI,eAAA;EXm2SN;EWj2SE;IACI,iBAAA;IACA,kBAAA;EXm2SN;EWj2SE;IACI,mBAAA;EXm2SN;EWj2SE;IACI,qCAAA;EXm2SN;AACF;AW/1SA;;sDAAA;AAII;EACI,mBAAA;AXg2SR;AW91SI;EACI,gBAAA;AXg2SR;;AW31SA;;sDAAA;AAII;EACI,kBAAA;EACA,gBAAA;AX61SR;AW51SQ;EACI,gBAAA;EACA,oBAAA;AX81SZ;AW51SQ;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AX81SZ;;AWx1SQ;EACI,6BAAA;EACA,oBAAA;AX21SZ;;AWr1SQ;EACI,mBAAA;EACA,kBAAA;AXw1SZ;;AWn1SA;;sDAAA;AAII;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;AXq1SR;AWp1SQ;EACI,gBAAA;AXs1SZ;AWp1SQ;EACI,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AXs1SZ;AWr1SY;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AXu1ShB;AWp1SQ;EACI,6CAAA;EACA,mBAAA;AXs1SZ;AWp1SQ;EACI,gBAAA;AXs1SZ;AWp1SQ;EACI,mBAAA;AXs1SZ;;AWj1SA,qBAAA;AAEI;EACI,kBAAA;EACA,iBAAA;EACA,oCAAA;AXm1SR;AWl1SQ;EACI,6BAAA;EACA,4BAAA;AXo1SZ;AWn1SY;EACI,qCAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AXq1ShB;AWl1SQ;EACI,6BAAA;EACA,gCAAA;AXo1SZ;AWl1SQ;EACI,kCAAA;AXo1SZ;AWl1SQ;EACI,uBAAA;AXo1SZ;;AW/0SI;EACI,6BAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AXk1SR;AWj1SQ;EACI,2BAAA;EACA,gBAAA;AXm1SZ;AWl1SY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6CAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AXo1ShB;;AW90SA;EAGY;IACI,4BAAA;IACA,eAAA;EX+0Sd;EW70SU;IACI,uBAAA;EX+0Sd;EWz0SU;IACI,eAAA;EX20Sd;EW10Sc;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EX40SlB;AACF;AWt0SA;;sDAAA;AAII;EACI,gBAAA;AXu0SR;;AWp0SA;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;AXu0SJ;;AWp0SA,eAAA;AAEI;EACI,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;AXs0SR;AWp0SI;EACI,eAAA;AXs0SR;;AWl0SA,eAAA;AACA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AXq0SJ;AWp0SI;EACI,sBAAA;AXs0SR;;AWn0SA;EAEQ;IACI,gBAAA;EXq0SV;EWn0SM;IACI,eAAA;EXq0SV;AACF;AWl0SA;EAEQ;IACI,qBAAA;EXm0SV;EW/zSM;IACI,aAAA;EXi0SV;EW9zSE;IACI,eAAA;EXg0SN;EW7zSM;IACI,gBAAA;EX+zSV;EW7zSM;IACI,eAAA;EX+zSV;AACF;AW1zSA;;sDAAA;AAGA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AX4zSJ;;AW1zSA;EACI,sBAAA;AX6zSJ;AW5zSI;EACI,aAAA;AX8zSR;AW7zSQ;EACI,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AX+zSZ;AW5zSI;EACI,gBAAA;AX8zSR;AW5zSI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AX8zSR;AW5zSI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AX8zSR;AW7zSQ;EACI,6BAAA;EACA,mBAAA;EACA,uCAAA;AX+zSZ;AW7zSQ;iFACiD,wBAAA;EAC7C,mBAAA;AX+zSZ;;AW1zSA;EACI;IACI,gBAAA;EX6zSN;AACF;AW1zSA;EACI;IACI,qBAAA;EX4zSN;EW3zSM;IACI,aAAA;EX6zSV;AACF;AWxzSA;EAEQ;IACI,sBAAA;EXyzSV;EWxzSS;IACK,kBAAA;IACA,eAAA;EX0zSd;AACF;AWpzSA;;sDAAA;AAGA,qBAAA;AACA;EACI,qBAAA;EACA,YAAA;AXszSJ;;AWpzSA;EACI,oCAAA;AXuzSJ;;AWpzSA,qBAAA;AACA;EACI,mBAAA;AXuzSJ;;AWpzSA,qBAAA;AACA;EACI,kBAAA;EACA,mBAAA;AXuzSJ;AWtzSI;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;AXwzSR;AWtzSI;EACI,mBAAA;AXwzSR;AWtzSI;EACI,kBAAA;EACA,kCAAA;AXwzSR;AWtzSI;EACI,gBAAA;EACA,eAAA;AXwzSR;AWtzSI;EACI,aAAA;AXwzSR;AWvzSQ;EACI,uBAAA;AXyzSZ;AWrzSQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;AXuzSZ;;AWjzSQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;AXozSZ;;AWhzSA;EACI,kBAAA;EACA,mBAAA;AXmzSJ;AWlzSI;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,mCAAA;EACA,UAAA;EACA,kBAAA;AXozSR;AWlzSI;EACI,mBAAA;AXozSR;AWlzSI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;AXozSR;AWlzSI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AXozSR;AWlzSI;EACI,aAAA;AXozSR;AWnzSQ;EACI,uBAAA;AXqzSZ;AWjzSQ;EACI,SAAA;EACA,UAAA;EACA,mBAAA;AXmzSZ;;AW9ySA;EAEQ;IACI,kBAAA;IACA,wBAAA;EXgzSV;EW9ySM;IACI,mBAAA;EXgzSV;EW9ySM;IACI,eAAA;EXgzSV;EW9ySM;IACI,sBAAA;EXgzSV;EW5ySM;IACI,kBAAA;EX8ySV;EW5ySM;IACI,eAAA;EX8ySV;EW5ySM;IACI,sBAAA;EX8ySV;AACF;AW1ySA;;sDAAA;AAGA;EACI,oCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AX4ySJ;AW3ySI;EACI,mBAAA;EACA,6CAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;AX6ySR;AW3ySI;EACI,SAAA;EACA,aAAA;EACA,kBAAA;AX6ySR;AW3ySI;EACI,qCAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AX6ySR;AW5ySQ;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;AX8ySZ;AW5ySQ;;EAEI,eAAA;AX8ySZ;AW5ySQ;EACI,WAAA;AX8ySZ;AW5ySQ;EACI,cAAA;AX8ySZ;AW3ySI;EACI,cAAA;EACA,UAAA;AX6ySR;AW5ySQ;EACI,gBAAA;EACA,eAAA;AX8ySZ;AW3ySI;EACI,oBAAA;AX6ySR;AW3ySI;EAEI,oCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AX4ySR;AW1ySY;EACI,kCAAA;AX4yShB;AWzySQ;EACI,6CAAA;EACA,mBAAA;AX2ySZ;;AWtySA;EACI;IACI,mBAAA;EXyySN;AACF;AWvySA;;sDAAA;AAGA,kBAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AXyySF;;AWvySA,wCAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AX0ySF;;AWvySA,6BAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AX0ySF;;AWxySA,+CAAA;AACA;EACE,6CAAA;AX2ySF;;AWzySA,wDAAA;AACA;EACE,6CAAA;EACA,yCAAA;AX4ySF;;AWzySA,6DAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AX4ySF;;AW1ySA,oCAAA;AACA;EACE,cAAA;AX6ySF;;AW3ySA,kCAAA;AACA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,wBAAA;AX8ySF;;AW5ySA;;sDAAA;AAGA;EACI,eAAA;EACA,QAAA;EAGA,aAAA;EAIA,sBAAA;EACA,UAAA;EAGA,kCAAA;EAGA,QAAA;EAEA,qCAAA;EAGA,qBAAA;EAGA,kCAAA;AX6ySJ;AW5ySI;EACI,sBAAA;EACA,kBAAA;EACA,WAAA;EAGA,aAAA;EAGA,mBAAA;EAEA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EAMA,2BAAA;AX4ySR;AW3ySQ;EACI,WAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AX6ySZ;AW3ySQ;EACI,mBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,sHAAA;AX6ySZ;AW3ySQ;EACI,iCAAA;AX6ySZ;AW3ySQ;EACI,gCAAA;AX6ySZ;AW3ySQ;EACI,kCAAA;AX6ySZ;AW3ySQ;EACI,kCAAA;AX6ySZ;AW3ySQ;EACI,iCAAA;AX6ySZ;AW3ySQ;EACI,gCAAA;AX6ySZ;AW3ySQ;EACI,oCAAA;AX6ySZ;AW3ySQ;EACI,iCAAA;AX6ySZ;AW3ySQ;EACI,gCAAA;AX6ySZ;AW3ySQ;EACI,2BAAA;AX6ySZ;AW3ySQ;EACI,+BAAA;AX6ySZ;AW3ySQ;EACI,8BAAA;AX6ySZ;AW3ySQ;EAEI,gBAAA;AX6ySZ;AW5ySY;EACI,kBAAA;EACA,gBAAA;AX8yShB;AW1ySI;EACI,OAAA;EACA,WAAA;EACA,uBAAA;AX4ySR;AW3ySQ;EACI,qBAAA;AX6ySZ;AW5ySY;EAEI,gBAAA;AX8yShB;AW7ySgB;EACI,mBAAA;EACA,eAAA;AX+ySpB;;AWxySA;;sDAAA;AAGA;EACI,kBAAA;AX2ySJ;AW1ySI;EACI,SAAA;AX4ySR;;AWzySA;EACI,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AX4ySJ;AW3ySI;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AX6ySR;AW5ySQ;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AX8ySR;AW3ySQ;EACI,eAAA;EACA,gCAAA;AX6ySZ;AW1ySI;EACI,SAAA;AX4ySR;AW3ySQ;EACI,eAAA;EACA,kCAAA;AX6ySZ;AW1ySI;EACI,gBAAA;AX4ySR;AW1ySI;EACI,YAAA;EACA,WAAA;EACA,6CAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AX4ySR;;AWzySA;EACI,YAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AX4ySJ;AW3ySI;EACI,eAAA;EACA,mBAAA;AX6ySR;AW5ySQ;EACI,eAAA;EACA,mBAAA;AX8ySZ;AW5ySQ;EACI,eAAA;EACA,mBAAA;AX8ySZ;AW3ySI;EACI,mBAAA;AX6ySR;;AW1ySA;EACI,WAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;AX6ySJ;AW5ySI;EACI,YAAA;AX8ySR;;AW3ySA;EACI,kBAAA;AX8ySJ;AW7ySI;EACI,gBAAA;AX+ySR;AW7ySI;EACI,gBAAA;EACA,mBAAA;AX+ySR;AW7ySI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;AX+ySR;;AW5ySA;EACI,aAAA;AX+ySJ;AW9ySI;EACI,iBAAA;EACA,mBAAA;AXgzSR;;AW7ySA;EACI,gBAAA;AXgzSJ;;AW9ySA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AXizSJ;;AW7ySI;;EACI,UAAA;EACA,SAAA;AXizSR;AWhzSQ;;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AXmzSZ;AWlzSY;;EACI,gBAAA;AXqzShB;AWnzSY;;EACI,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,OAAA;EACA,SAAA;EACA,qCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AXszShB;;AW/ySQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AXkzSZ;AWjzSY;EACI,eAAA;EACA,oBAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;EACA,QAAA;AXmzShB;;AW9ySA;EACI,kBAAA;AXizSJ;;AW/ySA;EACI,iBAAA;AXkzSJ;;AWhzSA;;EAEI,kBAAA;AXmzSJ;AWlzSI;;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,6CAAA;AXqzSR;;AWlzSA;EACI,kBAAA;AXqzSJ;AWpzSI;EACI,OAAA;AXszSR;;AWnzSA;EACI,mBAAA;AXszSJ;AWrzSI;EACI,UAAA;EACA,QAAA;AXuzSR;;AWpzSA;EACI,aAAA;EACA,mBAAA;AXuzSJ;AWtzSI;EACI,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AXwzSR;AWrzSQ;EACI,mBAAA;AXuzSZ;AWrzSQ;EACI,kBAAA;AXuzSZ;;AWlzSA;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AXqzSJ;AWpzSI;EACI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AXszSR;AWrzSQ;EACI,eAAA;EACA,kBAAA;AXuzSZ;AWrzSQ;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AXuzSZ;;AWjzSQ;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AXozSZ;;AWhzSA;EACI,eAAA;AXmzSJ;AWlzSI;EACI,gBAAA;AXozSR;AWnzSQ;EACI,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,WAAA;AXqzSZ;;AWjzSA;EACI,kBAAA;AXozSJ;AWnzSI;EACI,kBAAA;AXqzSR;AWpzSQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,6CAAA;EACA,QAAA;EACA,2BAAA;AXszSZ;;AWlzSA;EACI,eAAA;AXqzSJ;AWpzSI;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AXszSR;AWrzSQ;EACI,cAAA;EACA,gBAAA;AXuzSZ;AWrzSQ;EACI,eAAA;AXuzSZ;;AWlzSI;EACI,kBAAA;AXqzSR;AWpzSQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AXszSZ;AWnzSY;EACI,aAAA;AXqzShB;;AW/ySI;EACI,kBAAA;EACA,UAAA;AXkzSR;;AW/ySA;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,yCAAA;AXkzSJ;AWjzSI;EACI,gBAAA;AXmzSR;AWjzSI;EACI,gBAAA;AXmzSR;;AW9ySI;EACI,gBAAA;AXizSR;;AW5ySI;EACI,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AX+ySR;AW9ySQ;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;AXgzSZ;AW/ySY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AXizShB;AW/ySY;EACI,eAAA;AXizShB;AWhzSgB;EACI,aAAA;AXkzSpB;AW5ySQ;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AX8ySZ;AW3ySI;EACI,kBAAA;EACA,qCAAA;AX6ySR;AW5ySQ;EACI,eAAA;EACA,kBAAA;EACA,kCAAA;AX8ySZ;;AW1ySA;EACI;IACI,cAAA;EX6ySN;EW5ySM;IACG,cAAA;EX8yST;EW3ySE;IACI,gBAAA;IACA,mBAAA;EX6ySN;AACF;AW3ySA;EACI;IACI,eAAA;IACA,mBAAA;EX6ySN;EW3ySE;IACI,cAAA;IACA,mBAAA;EX6ySN;EW1ySM;IACI,iBAAA;IACA,kBAAA;EX4ySV;AACF;AWxySA;EACI;IACI,mBAAA;EX0ySN;EWxySE;IACI,aAAA;IACA,YAAA;EX0ySN;EWxySU;IACI,eAAA;EX0ySd;EWtySE;IACI,YAAA;IACA,aAAA;EXwySN;EWtySU;IACI,eAAA;EXwySd;EWpySE;IACI,cAAA;EXsySN;EWrySM;IACG,cAAA;EXuyST;EWpySE;IACI,gBAAA;IACA,mBAAA;EXsySN;EWpySE;IACI,gBAAA;EXsySN;EWpySE;IACI,WAAA;IACA,kBAAA;EXsySN;EWnySM;IACI,kBAAA;EXqySV;EWhySU;IACI,YAAA;EXkySd;AACF;AW5xSA;;sDAAA;AAGA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AX8xSJ;AW7xSI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,2BAAA;EAAA,sBAAA;AX+xSR;AW5xSQ;EACI,kBAAA;AX8xSZ;;AW1xSA;EACI,cAAA;AX6xSJ;;AW3xSA;EACI,gBAAA;AX8xSJ;AW7xSI;EACI,+BAAA;AX+xSR;;AW3xSA;;sDAAA;AAGA;EACI,8BAAA;EACA,mBAAA;AX8xSJ;AW7xSI;EACI,kBAAA;EACA,gBAAA;AX+xSR;AW9xSQ;EACI,4BAAA;AXgySZ;AW7xSI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;AX+xSR;AW7xSI;EACI,uBAAA;AX+xSR;AW9xSQ;EACI,kBAAA;AXgySZ;AW3xSY;EACI,qBAAA;AX6xShB;;AWvxSA;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AX0xSJ;AWzxSI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,kCAAA;AX2xSR;AWzxSI;EACI,iBAAA;AX2xSR;AWzxSI;EACI,cAAA;AX2xSR;AWzxSI;EACI,mBAAA;EACA,UAAA;AX2xSR;AW1xSQ;EACI,gBAAA;EACA,gBAAA;AX4xSZ;AW3xSY;EACI,0BAAA;AX6xShB;AWzxSI;EACI,gBAAA;EACA,mBAAA;AX2xSR;;AWxxSA;EACI;IACI,sBAAA;EX2xSN;AACF;AWzxSA;EAEQ;IACI,uBAAA;EX0xSV;AACF;AWrxSA;;sDAAA;AAGA,qBAAA;AACA;EACI,gCAAA;AXuxSJ;;AWrxSA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AXwxSJ;AWvxSI;EACI,SAAA;AXyxSR;AWvxSI;EACI,aAAA;AXyxSR;;AWrxSA,qBAAA;AACA;EACI,qBAAA;AXwxSJ;;AWtxSA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AXyxSJ;AWvxSQ;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AXyxSZ;AWtxSI;EACI,kBAAA;EACA,UAAA;AXwxSR;;AWrxSA;;EAEI,aAAA;EACA,YAAA;EACA,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;AXwxSJ;;AWtxSA;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;AXyxSJ;;AWvxSA;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;AX0xSJ;;AWtxSI;EACI,uCAAA;AXyxSR;;AWrxSA,qBAAA;AACA;EACI,kBAAA;AXwxSJ;AWvxSI;EACI,kBAAA;EACA,WAAA;AXyxSR;AWxxSQ;EACI,kBAAA;AX0xSZ;AWxxSQ;EACI,eAAA;AX0xSZ;AWxxSQ;EACI,eAAA;AX0xSZ;;AWrxSA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AXwxSJ;;AWtxSA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AXyxSJ;;AWtxSA,qBAAA;AAIQ;EACI,0BAAA;EACA,mBAAA;AXsxSZ;;AWjxSA;EACE,kBAAA;EACA,aAAA;AXoxSF;;AWjxSA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AXoxSF;;AWjxSA,qBAAA;AACA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AXoxSJ;AWlxSQ;EACI,gBAAA;AXoxSZ;AWlxSQ;EACI,gBAAA;AXoxSZ;AWjxSI;EACI,aAAA;AXmxSR;;AW/wSA,mBAAA;AACA;EACI;;IAEI,aAAA;EXkxSN;EW9wSU;IACI,eAAA;EXgxSd;EW9wSU;IACI,eAAA;EXgxSd;EW5wSE;IACI,kBAAA;IACA,iBAAA;EX8wSN;EW7wSM;IACI,gBAAA;EX+wSV;AACF;AW3wSA,yBAAA;AACA;EACI;IACI,iBAAA;EX6wSN;EW5wSM;IACI,gBAAA;EX8wSV;EW3wSE;IACI,cAAA;IACA,gBAAA;IACA,iBAAA;EX6wSN;EW5wSM;IACI,mBAAA;EX8wSV;EW7wSU;IACI,eAAA;IACA,kBAAA;IACA,OAAA;EX+wSd;EW3wSE;;IAEI,aAAA;EX6wSN;EWzwSU;IACI,eAAA;EX2wSd;AACF;AWrwSA,yBAAA;AACA;EAKY;;;IACI,aAAA;EXqwSd;AACF;AW/vSA;;sDAAA;AAGA;EACI,qCAAA;EACA,eAAA;EACA,cAAA;AXiwSJ;;AW/vSA;EACI,kBAAA;AXkwSJ;;AWhwSA;EACI,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;AXmwSJ;AWlwSI;EACI,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AXowSR;;AWjwSA;EACI,qBAAA;EACA,SAAA;AXowSJ;;AWjwSA;;sDAAA;AAGA;EACI,SAAA;EACA,eAAA;AXowSJ;AWnwSI;EACI,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AXqwSR;AWpwSQ;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;AXswSZ;AWnwSI;EACI,SAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;AXqwSR;AWpwSQ;EACI,WAAA;AXswSZ;AWnwSY;EACI,cAAA;AXqwShB;AWjwSI;EACI,SAAA;AXmwSR;AWjwSI;EACI,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AXmwSR;AWjwSI;EACI,SAAA;AXmwSR;;AW9vSQ;EACI,6BAAA;EACA,iBAAA;EACA,mCAAA;AXiwSZ;AWhwSY;EACI,mBAAA;EACA,yBAAA;AXkwShB;AWhwSY;EACI,wBAAA;EACA,uBAAA;EACA,mCAAA;AXkwShB;AW/vSQ;EACI,6BAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,YAAA;AXiwSZ;AW9vSI;EACI,6BAAA;EACA,mBAAA;AXgwSR;AW9vSI;EACI,oBAAA;AXgwSR;AW9vSI,yFAAA,wBAAA;EACI,mBAAA;AXgwSR;AW9vSI,gFAAA,gBAAA;EACI,mBAAA;AXgwSR;AW9vSI,oFAAA,WAAA;EACI,mBAAA;AXgwSR;AW9vSI,+EAAA,gBAAA;EACI,mBAAA;AXgwSR;AW9vSI;EACI,mBAAA;EACA,QAAA;AXgwSR;;AW7vSA;EACI,mBAAA;AXgwSJ;AW/vSI;EACI,6BAAA;EACA,uCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AXiwSR;AW/vSI;EACI,kBAAA;AXiwSR;;AW5vSI;EACI,mBAAA;AX+vSR;;AW5vSA;EACI,kBAAA;AX+vSJ;;AW5vSA;EACI;IACI,UAAA;EX+vSN;EW9vSM;IACI,gBAAA;EXgwSV;AACF;AW5vSA;EACI;IACI,uBAAA;EX8vSN;AACF;AW5vSA;EACI;IACI,iBAAA;EX8vSN;AACF;AW5vSA;EAEQ;IACI,kBAAA;EX6vSV;AACF;AWzvSA;;sDAAA;AAGA;EACI,uBAAA;EACA,iBAAA;EACA,mCAAA;AX2vSJ;;AWzvSA;EACI,SAAA;AX4vSJ;AW3vSI;EACI,eAAA;AX6vSR;AW3vSI;EACI,WAAA;AX6vSR;AW3vSI;EACI,0BAAA;AX6vSR;AW3vSI;EACI,0BAAA;AX6vSR;AW3vSI;EACI,0BAAA;AX6vSR;AW3vSI;EACI,0BAAA;AX6vSR;;AWxvSI;EACI,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AX2vSR;AW1vSQ;EACI,gBAAA;AX4vSZ;AW1vSQ;EACI,aAAA;AX4vSZ;AW1vSQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EAGA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,kCAAA;AX4vSZ;AWzvSI;EACI,cAAA;EACA,WAAA;EACA,WAAA;AX2vSR;;AWxvSA;EACI;IACI,cAAA;EX2vSN;AACF;AWzvSA;EACI;IACI,uBAAA;EX2vSN;AACF;AWxvSA;;sDAAA;AAII;EACI,gBAAA;AXyvSR;AWxvSQ;EACI,yCAAA;EACA,6CAAA;EACA,mBAAA;AX0vSZ;AWvvSI;EACI,aAAA;EACA,qCAAA;AXyvSR;;AWrvSI;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;AXwvSR;AWtvSI;EACI,SAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;AXwvSR;AWvvSQ;EACI,WAAA;EACA,WAAA;AXyvSZ;AWrvSQ;EACI,aAAA;AXuvSZ;AWpvSY;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;AXsvShB;AWjvSgB;EACI,gBAAA;AXmvSpB;AW7uSgB;EACI,gBAAA;AX+uSpB;AWzuSgB;EACI,gBAAA;AX2uSpB;AWruSgB;EACI,gBAAA;AXuuSpB;AWjuSgB;EACI,gBAAA;AXmuSpB;AW7tSgB;EACI,gBAAA;AX+tSpB;;AWttSQ;EACI,WAAA;EACA,8BAAA;EACA,gBAAA;AXytSZ;AWrtSgB;EACI,kBAAA;AXutSpB;AWrtSgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,0DAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AXutSpB;AWltSI;;EAEI,gBAAA;AXotSR;;AWhtSA;EACI;IACI,kBAAA;EXmtSN;AACF;AW/sSA;;sDAAA;AAGA,eAAA;AACA;EACI,qBAAA;AXitSJ;;AW/sSA,iBAAA;AACA;EACI,kBAAA;AXktSJ;;AW/sSA;;sDAAA;AAGA;EAEI,oBAAA;EACA,UAAA;EACA,4BAAA;EACA,cAAA;AXktSJ;AWjtSI;EACI,4BAAA;AXmtSR;AWjtSI;EAEI,oBAAA;EACA,UAAA;AXmtSR;AWltSQ;EACI,qBAAA;AXotSZ;;AW/sSA;;sDAAA;AAGA;EACI,mBAAA;AXktSJ;;AWhtSA;EACI,gBAAA;EACA,mBAAA;AXmtSJ;AWltSI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AXotSR;AWltSI;EACI,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AXotSR;AWltSI;EACI,6CAAA;EACA,sBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AXotSR;AWntSQ;EACI,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AXqtSZ;;AWhtSA,wBAAA;AACA;EACI,mBAAA;AXmtSJ;AWltSI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AXotSR;AWntSQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AXqtSZ;AWntSQ;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AXqtSZ;AWntSQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,oDAAA;AXqtSZ;AWntSQ;EACI,OAAA;AXqtSZ;AWptSY;EACI,UAAA;EACA,6BAAA;EACA,gCAAA;EACA,cAAA;EAEA,6BAAA;AXstShB;AWntSQ;EACI,QAAA;AXqtSZ;AWptSY;EACI,WAAA;EACA,4BAAA;EACA,+BAAA;EACA,eAAA;EAEA,8BAAA;AXstShB;AWntSQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXqtSZ;AWntSQ;EACI,eAAA;EACA,gBAAA;AXqtSZ;AWptSY;EACI,gBAAA;EACA,eAAA;EACA,kCAAA;AXstShB;AWltSI;EACI,gBAAA;AXotSR;AWntSQ;EACI,kBAAA;EACA,yBAAA;AXqtSZ;;AW/sSA;EAEQ;IACI,eAAA;EXitSV;AACF;AW5sSA;;sDAAA;AAII;EACI,cAAA;EACA,eAAA;AX6sSR;AW3sSI;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AX6sSR;AW5sSQ;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AX8sSZ;AW5sSQ;EACI,gBAAA;EACA,SAAA;AX8sSZ;AW5sSQ;EACI,qBAAA;EACA,kBAAA;EACA,cAAA;AX8sSZ;AW3sSgB;EACI,UAAA;EACA,QAAA;AX6sSpB;AW1sSY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AX4sShB;AW1sSY;EACI,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;AX4sShB;AWxsSgB;EACI,8BAAA;EACA,kCAAA;AX0sSpB;AWxsSgB;EACI,UAAA;EACA,mBAAA;AX0sSpB;AWxsSgB;EACI,UAAA;EACA,mBAAA;AX0sSpB;AWrsSI;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,4BAAA;EACA,oCAAA;EACA,kBAAA;AXusSR;AWrsSI;EACI,UAAA;AXusSR;;AWpsSA;EACI,8BAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AXusSJ;AWtsSI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AXwsSR;AWtsSI;EACI,gBAAA;AXwsSR;AWtsSI;EACI,kBAAA;AXwsSR;;AWpsSA;EACI;IACI,YAAA;EXusSN;AACF;AWrsSA;EACI;IACI,eAAA;IACA,aAAA;EXusSN;AACF;AWrsSA;EACI;IACI,YAAA;EXusSN;EWtsSM;IACI,WAAA;IACA,mBAAA;IACA,gBAAA;EXwsSV;AACF;AWrsSA;EACI;IACI,iBAAA;EXusSN;EWrsSE;IACI,UAAA;EXusSN;EWrsSE;;IAEI,UAAA;IACA,WAAA;EXusSN;AACF;AWrsSA;EACI;IACI,YAAA;EXusSN;EWtsSM;IACI,WAAA;IACA,mBAAA;EXwsSV;AACF;AWnsSA;;sDAAA;AAII;EACI,YAAA;AXosSR;AWnsSQ;EACI,iBAAA;EACA,mBAAA;AXqsSZ;AWnsSQ;EACI,qCAAA;EACA,gBAAA;AXqsSZ;;AWhsSA;EACI,uBAAA;EACA,oCAAA;AXmsSJ;AWlsSI;EACI,8CAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;AXosSR;AWlsSI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AXosSR;AWnsSQ;EACI,kBAAA;EACA,uCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXqsSZ;AWlsSI;EACI,aAAA;EACA,8BAAA;AXosSR;AWlsSI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;AXosSR;;AWhsSI;EACI,mBAAA;AXmsSR;;AW/rSI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AXksSR;AWhsSI;EACI,WAAA;EACA,YAAA;AXksSR;AWhsSI;EACI,uBAAA;EACA,6CAAA;AXksSR;;AW/rSA;EACI,kBAAA;EACA,6CAAA;EACA,mBAAA;EACA,cAAA;AXksSJ;;AWhsSA;EACI,gBAAA;AXmsSJ;AWlsSI;EACI,eAAA;EACA,mBAAA;AXosSR;AWlsSI;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;AXosSR;AWlsSI;EACI,kCAAA;AXosSR;AWlsSI;EACI,gBAAA;AXosSR;AWnsSQ;EACI,kCAAA;EACA,iBAAA;AXqsSZ;AWlsSI;EACI,gBAAA;AXosSR;AWnsSQ;EACI,kBAAA;AXqsSZ;;AWhsSA;;sDAAA;AAII;EACI,mBAAA;EACA,gBAAA;AXksSR;AW/rSQ;EACI,iBAAA;EACA,eAAA;AXisSZ;AW7rSQ;EACI,iBAAA;EACA,kBAAA;AX+rSZ;;AW1rSI;EACI,SAAA;AX6rSR;AW5rSQ;EACI,gBAAA;EACA,cAAA;AX8rSZ;AW7rSY;EACI,gBAAA;EACA,qBAAA;AX+rShB;AW3rSI;EACI,UAAA;AX6rSR;;AWzrSA;;sDAAA;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AX0rSZ;AWzrSY;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,WAAA;AX2rShB;AWxrSQ;EACI,8BAAA;EACA,gCAAA;AX0rSZ;AWxrSQ;EACI,yCAAA;EACA,6CAAA;EACA,mBAAA;AX0rSZ;;AWrrSA;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AXwrSJ;AWvrSI;EACI,SAAA;AXyrSR;;AWrrSI;EACI,mBAAA;AXwrSR;AWtrSI;EACI,kBAAA;AXwrSR;;AWnrSI;EACI,mBAAA;AXsrSR;AWrrSQ;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;AXurSZ;AWtrSY;EACI,aAAA;AXwrShB;AWrrSQ;EACI,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AXurSZ;AWrrSQ;EACI,yBAAA;EACA,6BAAA;EACA,kCAAA;AXurSZ;;AWlrSA;EACI;IACI,YAAA;IACA,WAAA;IACA,eAAA;EXqrSN;EWlrSM;IACI,kBAAA;EXorSV;EWlrSM;IACI,iBAAA;EXorSV;AACF;AWhrSA;;sDAAA;AAII;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;AXirSR;AW/qSI;EACI,gBAAA;EACA,eAAA;AXirSR;;AW7qSA;;sDAAA;AAGA;EACI,mBAAA;AXgrSJ;AW/qSI;EACI,qCAAA;EACA,kBAAA;AXirSR;;AW9qSA;EACI,aAAA;EACA,uCAAA;AXirSJ;;AW7qSI;EACI,aAAA;EACA,gBAAA;AXgrSR;AW9qSI;EACI,gBAAA;EACA,6BAAA;EACA,4BAAA;AXgrSR;AW9qSI;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AXgrSR;AW/qSQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAGA,wBAAA;EACA,sBAAA;AXirSZ;AW9qSI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;AXgrSR;AW/qSQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EAGA,2BAAA;EACA,sBAAA;EACA,kBAAA;AXirSZ;AW/qSQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EAGA,4BAAA;EAGA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;AXirSZ;AW/qSQ;EACI,YAAA;EACA,iBAAA;AXirSZ;AW9qSI;EACI,UAAA;AXgrSR;AW9qSI;EACI,eAAA;AXgrSR;AW/qSQ;EACI,gBAAA;AXirSZ;;AW5qSA;;sDAAA;AAII;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;AX8qSR;AW7qSQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AX+qSZ;AW9qSY;EACI,gBAAA;AXgrShB;AW9qSY;EACI,eAAA;AXgrShB;AW9qSY;EACI,qCAAA;EACA,mBAAA;AXgrShB;;AW1qSI;EACI,aAAA;EACA,qCAAA;AX6qSR;;AWzqSA;;sDAAA;AAGA;EACI,kBAAA;EACA,iBAAA;AX4qSJ;AW3qSI;EACI,iDAAA;EACA,oBAAA;EACA,mBAAA;AX6qSR;AW3qSI;EACI,UAAA;EACA,SAAA;AX6qSR;AW5qSQ;EACI,cAAA;AX8qSZ;AW7qSY;EACI,YAAA;AX+qShB;;AWzqSA;;sDAAA;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;EACA,8BAAA;AX4qSJ;;AW1qSA;EACI,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,eAAA;AX6qSJ;;AW1qSI;;EAEI,kCAAA;AX6qSR;AW3qSI;EACI,0BAAA;AX6qSR;;AW1qSA;EACI;IACI,eAAA;IACA,kBAAA;EX6qSN;EW1qSM;IACI,eAAA;EX4qSV;EW1qSM;IACI,eAAA;EX4qSV;AACF;AWxqSA;;sDAAA;AAMI;;;EACI,cAAA;EACA,gBAAA;AXyqSR;AWvqSI;;;EACI,4BAAA;AX2qSR;AWxqSQ;;;EACI,qBAAA;AX4qSZ;;AWvqSA;;sDAAA;AAGA,wDAAA;AAEA;;;;;;;;;CAAA;AAUA;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AXyqSJ;;AWrqSA,iDAAA;AACA;;EAEI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AXwqSJ;;AWtqSA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;AXyqSJ;;AWtqSA,kBAAA;AACA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AXyqSJ;;AWtqSA;;sDAAA;AAII;EACI,qCAAA;EACA,gCAAA;EACA,+BAAA;AXwqSR;AWtqSI;EACI,UAAA;AXwqSR;AWtqSI;EACI,aAAA;AXwqSR;;AWpqSA;;sDAAA;AAGA;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;AXuqSJ;;AWrqSA;EACI,kBAAA;EACA,aAAA;AXwqSJ;AWvqSI;EACI,eAAA;AXyqSR;AWvqSI;EACI,eAAA;AXyqSR;;AWtqSA;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AXyqSJ;;AWvqSA;EACI,kCAAA;AX0qSJ;;AWxqSA;EACI,WAAA;EACA,OAAA;AX2qSJ;;AWzqSA;EACI,aAAA;AX4qSJ;;AWxqSQ;EACI,kBAAA;AX2qSZ;;AWvqSA;EACI,UAAA;AX0qSJ;AWzqSI;EACI,aAAA;AX2qSR;;AWxqSA;EACI,UAAA;AX2qSJ;AW1qSI;EACI,4BAAA;AX4qSR;;AWxqSA;EACI;IACI,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,kBAAA;EX2qSN;EWzqSE;IACI,aAAA;EX2qSN;AACF;AWzqSA;EACI;IACI,gBAAA;EX2qSN;AACF;AWxqSA;;sDAAA;AAGA;EACI,aAAA;AX0qSJ;;AWxqSA;;EAEI,mBAAA;AX2qSJ;;AWxqSI;EACI,UAAA;EACA,SAAA;AX2qSR;AW1qSQ;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AX4qSZ;AW3qSY;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;AX6qShB;AW3qSY;EACI,cAAA;AX6qShB;AW5qSgB;EACI,YAAA;AX8qSpB;AW3qSY;EACI,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AX6qShB;AW3qSY;EACI,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AX6qShB;;AWrqSY;EACI,iCAAA;AXwqShB;AWtqSY;EACI,6CAAA;AXwqShB;AWtqSY;EACI,6CAAA;AXwqShB;;AW/pSgB;EACI,iCAAA;AXkqSpB;AWhqSgB;EACI,qCAAA;AXkqSpB;AWhqSgB;EACI,qCAAA;AXkqSpB;;AW3pSA;EACI;IACI,aAAA;EX8pSN;EW1pSU;IACI,eAAA;EX4pSd;AACF;AWvpSA;;sDAAA;AAGA;EACI,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AXypSJ;AWxpSI;EACI,aAAA;AX0pSR;AWxpSI;EACI,kBAAA;AX0pSR;;AWtpSA;EACI;IACI,4BAAA;EXypSN;EWxpSM;IACI,mBAAA;EX0pSV;AACF;AWvpSA;EAEQ;IACI,iBAAA;EXwpSV;AACF;AWppSA;;sDAAA;AAGA;EACI,aAAA;EACA,oCAAA;EACA,8BAAA;EACA,mBAAA;AXspSJ;AWrpSI;EACI,kBAAA;AXupSR;AWtpSQ;EACI,kBAAA;EACA,MAAA;EACA,UAAA;AXwpSZ;AWvpSY;EACI,UAAA;EACA,SAAA;AXypShB;AWxpSgB;EACI,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AX0pSpB;AWrpSI;EACI,sBAAA;AXupSR;AWtpSQ;EACI,kCAAA;EACA,0BAAA;EACA,gBAAA;AXwpSZ;AWtpSQ;EACI,gBAAA;AXwpSZ;AWrpSY;EACI,kCAAA;AXupShB;AWnpSI;EACI,eAAA;EACA,gBAAA;AXqpSR;;AWjpSA;;sDAAA;AAII;EACI,yBAAA;AXmpSR;;AW/oSI;EACI,iBAAA;EACA,SAAA;EACA,aAAA;AXkpSR;AWjpSQ;EACI,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AXmpSZ;AWhpSI;EACI,wBAAA;EACA,mCAAA;AXkpSR;AW/oSQ;EACI,qCAAA;AXipSZ;;AW3oSI;EACI,oBAAA;EACA,SAAA;EACA,kBAAA;AX8oSR;AW7oSQ;EACI,qCAAA;AX+oSZ;AW7oSQ;EACI,cAAA;EACA,gBAAA;AX+oSZ;AW9oSY;EACI,cAAA;EACA,WAAA;EACA,WAAA;AXgpShB;AW9oSY;EACI,UAAA;EACA,WAAA;AXgpShB;;AW1oSA;;sDAAA;AAGA;EACI,kBAAA;AX6oSJ;AW5oSI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AX8oSR;;AW1oSA;EAEQ;IACI,iBAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;EX4oSV;EW1oSc;IACI,eAAA;EX4oSlB;AACF;AWtoSA;;sDAAA;AAGA;EACI,aAAA;EACA,+BAAA;AXwoSJ;;AWtoSA;EACI,cAAA;AXyoSJ;;AWtoSA;;sDAAA;ACtxNA;;sDAAA;AAII;EACI,eAAA;AZi6fR;;AY75fA,aAAA;AAGQ;EACI,eAAA;AZ85fZ;AY55fQ;;EAEI,eAAA;AZ85fZ;AY15fQ;EACI,kBAAA;EACA,UAAA;EACA,mBAAA;AZ45fZ;AYz5fI;EACI,mBAAA;EACA,gBAAA;AZ25fR;;AYp5fQ;;EACI,eAAA;AZw5fZ;;AYn5fA,mBAAA;AAEI;EACI,0BAAA;AZq5fR;AYp5fQ;EACI,mBAAA;AZs5fZ;AYj5fY;EACI,0BAAA;AZm5fhB;AYh5fgB;EACI,mBAAA;AZk5fpB;AY74fI;EACI,0BAAA;AZ+4fR;AY74fI;EACI,mCAAA;AZ+4fR;AY74fY;EACI,0BAAA;AZ+4fhB;AY34fI;EACI,6CAAA;AZ64fR;AY34fI;EACI,0BAAA;AZ64fR;AY34fI;EACI,mBAAA;AZ64fR;AY34fI;EACI,mBAAA;AZ64fR;;AYz4fA,mBAAA;AAEI;EACI,8BAAA;AZ24fR;AY14fQ;EACI,yBAAA;AZ44fZ;AY14fgB;EACI,kCAAA;AZ44fpB;AYv4fI;EACI,mCAAA;AZy4fR;AYv4fI;EACI,gCAAA;AZy4fR;;AYr4fA;;0BAAA;AAGA;EACI,iBAAA;EACA,oBAAA;AZw4fJ;;AYt4fA;EACI,mBAAA;AZy4fJ;;AYv4fA;EACI,kBAAA;EACA,UAAA;AZ04fJ;;AYx4fA;EACI,eAAA;EACA,mBAAA;AZ24fJ;;AYx4fA;;sDAAA;AAGA,mBAAA;AAEI;EACI,SAAA;EACA,UAAA;AZ04fR;AYz4fQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AZ24fZ;AY14fY;EACI,cAAA;EACA,WAAA;EACA,WAAA;AZ44fhB;AY14fY;EACI,WAAA;EACA,kBAAA;AZ44fhB;AY14fY;EACI,gBAAA;AZ44fhB;AY34fgB;EACI,gBAAA;AZ64fpB;;AYt4fA;;sDAAA;AAGA,gBAAA;AACA;EACI,SAAA;EACA,UAAA;AZy4fJ;AYx4fI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AZ04fR;AYz4fQ;EACI,kBAAA;AZ24fZ;AY14fY;EACI,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;AZ44fhB;AYx4fY;EACI,kBAAA;AZ04fhB;AYz4fgB;EACI,UAAA;EACA,mBAAA;EACA,cAAA;AZ24fpB;;AYr4fA;EACI,iBAAA;AZw4fJ;;AYr4fA,gCAAA;AACA;EACI,kBAAA;AZw4fJ;AYv4fI;EACI,UAAA;EACA,WAAA;AZy4fR;AYx4fQ;EACI,kBAAA;AZ04fZ;AYv4fI;EACI,SAAA;AZy4fR;AYx4fQ;EACI,gBAAA;AZ04fZ;;AYr4fA;;sDAAA;AAII;EACI,kBAAA;AZu4fR;AYr4fI;EACI,SAAA;EACA,mBAAA;AZu4fR;AYr4fI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AZu4fR;AYt4fQ;EACI,eAAA;EACA,YAAA;AZw4fZ;;AYn4fA;;sDAAA;AAGA;EACI,uBAAA;EACA,wBAAA;EACA,mCAAA;EACA,iBAAA;AZs4fJ;AYr4fI;EACI,eAAA;AZu4fR;AYr4fI;EACI,SAAA;EACA,UAAA;AZu4fR;AYt4fQ;EACI,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wBAAA;EACA,mCAAA;EACA,oBAAA;EACA,gBAAA;AZw4fZ;AYv4fY;EACI,gBAAA;EACA,iBAAA;AZy4fhB;AYx4fgB;EACI,gBAAA;AZ04fpB;AYv4fY;EACI,YAAA;EACA,gBAAA;AZy4fhB;;AYl4fA;;sDAAA;AAGA;EACI,wBAAA;EACA,mCAAA;EACA,mBAAA;AZq4fJ;AYp4fI;EACI,gBAAA;EACA,gBAAA;AZs4fR;AYp4fI;EACI,kBAAA;AZs4fR;AYr4fQ;EACI,kCAAA;EACA,iBAAA;AZu4fZ;AYp4fI;EACI,eAAA;AZs4fR;;AYl4fA;;sDAAA;AAGA;EACI,iBAAA;EACA,oBAAA;AZq4fJ;AYp4fI;EACI,iBAAA;AZs4fR;;AYj4fI;EACI,eAAA;EACA,kCAAA;EACA,gBAAA;AZo4fR;AYl4fI;EACI,gBAAA;AZo4fR;;AYh4fI;EACI,SAAA;EACA,UAAA;AZm4fR;AYl4fQ;EACI,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,qCAAA;EACA,gBAAA;AZo4fZ;AYn4fY;EACI,eAAA;AZq4fhB;AYn4fY;EACI,SAAA;AZq4fhB;;AY/3fA;;sDAAA;AAGA;EACI;IACI,uBAAA;EZk4fN;EYh4fE;IACI,kBAAA;EZk4fN;EYj4fM;IACI,kBAAA;IACA,gBAAA;EZm4fV;EYj4fM;IACI,uBAAA;EZm4fV;EYh4fM;IACI,6BAAA;EZk4fV;EY/3fE;IACI,eAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;EZi4fN;EY/3fE;IACI,iBAAA;EZi4fN;AACF;AY93fA;EACI;IACI,uBAAA;EZg4fN;EY93fE;IACI,eAAA;EZg4fN;EY93fE;IACI,gBAAA;EZg4fN;EY93fE;;IAEI,eAAA;EZg4fN;EY33fU;;IACI,eAAA;EZ83fd;EY13fE;IACI,mBAAA;EZ43fN;EY13fE;IACI,eAAA;EZ43fN;AACF;AYz3fA;EACI;IACI,uBAAA;EZ23fN;EYx3fM;IACI,WAAA;EZ03fV;EYz3fU;IACI,iBAAA;EZ23fd;EYv3fE;IACI,gBAAA;EZy3fN;AACF;AYr3fA;;sDAAA;AC1aA;;6BAAA;AAGA;EACI,eAAA;EACA,WAAA;EACA,kCAAA;EACA,eAAA;AboygBJ;;AalygBA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AbqygBJ;AapygBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AbsygBR;AarygBO;EACK,8BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;AbuygBZ;AatygBY;EACI,6CAAA;EACA,mBAAA;AbwygBhB;;AanygBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,uCAAA;AbqygBF;;AalygBA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,6CAAA;EACA,mBAAA;EAEA,4CAAA;AbqygBF;;AalygBA;EACE,SAAA;EACA,SAAA;EAEA,oBAAA;AbqygBF;AajygBA;EAAuB;IAAO,yBAAA;IAA2B,iCAAA;Eb4ygBvD;AACF;AatygBA;EACE;IACE,mBAAA;IACA,2BAAA;EbgzgBF;Ea/ygBE;IACA,mBAAA;IACA,2BAAA;EbizgBF;AACF;Ac14gBA;;yCAAA;ACAA;;yCAAA;AAGA;EACI,cAAA;EACA,gBAAA;Af+4gBJ;;Ae74gBA;EACE,6CAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,mCAAA;EAAA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;Afg5gBF;Ae/4gBE;EACI,eAAA;Afi5gBN;;Ae94gBA;EACI,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;Afi5gBJ;Aeh5gBI;EACI,eAAA;Afk5gBR;;Ae/4gBA;EACE,6CAAA;EACA,mBAAA;Afk5gBF;Aej5gBE;EACI,2CAAA;EACA,mBAAA;Afm5gBN;;Aeh5gBA;EACI,6CAAA;EACA,mBAAA;Afm5gBJ;Ael5gBI;EACI,2CAAA;EACA,mBAAA;Afo5gBR;;Aej5gBA;EACI,2CAAA;EACA,mBAAA;Afo5gBJ;Aen5gBI;EACI,6CAAA;EACA,mBAAA;Afq5gBR;;Ael5gBA;EACI,6BAAA;EACA,uCAAA;Afq5gBJ;Aep5gBI;EACI,6CAAA;EACA,yCAAA;EACA,mBAAA;Afs5gBR;;Aen5gBA;EACI,6CAAA;Afs5gBJ;Aer5gBI;EACI,2CAAA;Afu5gBR;;Aep5gBA;EACI,8BAAA;EACA,gCAAA;EACA,oCAAA;Afu5gBJ;Aet5gBI;EACI,6CAAA;EACA,mBAAA;Afw5gBR;;Aer5gBA;EACI,8BAAA;EACA,mBAAA;Afw5gBJ;Aev5gBI;EACI,6CAAA;EACA,mBAAA;Afy5gBR;;Aet5gBA;EACI,6BAAA;EACA,oCAAA;EACA,kBAAA;Afy5gBJ;Aex5gBI;EACI,6CAAA;EACA,mBAAA;Af05gBR;;Aev5gBA;EACI,mBAAA;Af05gBJ;;Aex5gBA;EACI,YAAA;Af25gBJ;Ae15gBI;EACI,UAAA;Af45gBR;;Aez5gBA;EACI,YAAA;Af45gBJ;Ae35gBI;EACI,UAAA;Af65gBR;;Ae15gBA;EACI,YAAA;Af65gBJ;Ae55gBI;EACI,UAAA;Af85gBR;;Ae35gBA;EACI,YAAA;Af85gBJ;Ae75gBI;EACI,UAAA;Af+5gBR;;Ae35gBA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EAGA,oBAAA;Af85gBJ;;Ae35gBI;EACI,SAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;Af85gBR;Ae55gBI;EACI,gCAAA;Af85gBR;Ae75gBQ;EACI,WAAA;Af+5gBZ;;Ae15gBI;EACI,SAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,wBAAA;Af65gBR;Ae35gBI;EACI,gCAAA;Af65gBR;Ae55gBQ;EACI,WAAA;Af85gBZ;;Aez5gBI;EACI,SAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;Af45gBR;Ae15gBI;EACI,mBAAA;Af45gBR;Ae35gBQ;EACI,WAAA;Af65gBZ;;Aex5gBI;EACI,SAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;Af25gBR;Aez5gBI;EACI,mBAAA;Af25gBR;Ae15gBQ;EACI,WAAA;Af45gBZ;;Aex5gBA;EACI,cAAA;Af25gBJ;;Aez5gBA;EACI,cAAA;EACA,WAAA;Af45gBJ;;Aex5gBA;EACI,wCAAA;EACA,gBAAA;Af25gBJ;;Aet5gBA;EACI;IACI,kBAAA;Efy5gBN;Eev5gBE;IACI,kBAAA;Efy5gBN;AACF;Aet5gBA;EACI;IACI,kBAAA;IACA,eAAA;Efw5gBN;Eet5gBE;IACI,kBAAA;Efw5gBN;AACF;Aer5gBA;;sDAAA","sourcesContent":["/*\r\n    Template Name: Vicodin\r\n    Description: Medical eCommerce HTML Template\r\n    Version: 1.0.0\r\n*/\r\n\r\n//== Global Design\r\n@import \"global/_mixins\";\r\n@import \"global/_variables\";\r\n@import \"global/_global\";\r\n@import \"global/_gutenberg\";\r\n\r\n//== Sections\r\n@import \"sections/_animation\";\r\n@import \"sections/_breadcrumb\";\r\n@import \"sections/_widgets\";\r\n@import \"sections/_header\";\r\n@import \"sections/_slider\";\r\n@import \"sections/_product\";\r\n@import \"sections/_portfolio\";\r\n@import \"sections/_main\";\r\n@import \"sections/_footer\";\r\n\r\n//== Elements\r\n@import \"elements/_preloader\";\r\n@import \"elements/_search_popup\";\r\n@import \"elements/_button\";","@mixin gradient-border-with-radius($left, $right) {\r\n    background-image: linear-gradient(white, white), radial-gradient(circle at top left, $left, $right);\r\n    background-origin: border-box;\r\n    background-clip: content-box, border-box;\r\n    @include transition($transition);\r\n}\r\n\r\n@mixin gradient-border($left, $right) {\r\n    -moz-border-image: -moz-linear-gradient(top, $left 0%, $right 100%);\r\n    -webkit-border-image: -webkit-linear-gradient(top, $left 0%, $right 100%);\r\n    border-image: linear-gradient(to bottom, $left 0%, $right 100%);\r\n    background-clip: padding-box;\r\n    border-image-slice: 1;\r\n}\r\n\r\n@mixin text-gradient ($left, $right) {\r\n    background: -webkit-linear-gradient(-25deg, $left 0%, $right 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n}\r\n\r\n@mixin gradient-left-right($leftColor, $rightColor) {\r\n    background-image: -moz-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\r\n    background-image: -webkit-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\r\n    background-image: -ms-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\r\n}\r\n\r\n@mixin gradient-top-bottom($from, $to) {\r\n    background-color: $from;\r\n    background-image: -moz-linear-gradient($from, $to);\r\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, from($from), to($to));\r\n    background-image: -webkit-linear-gradient($from, $to);\r\n    background-image: -o-linear-gradient($from, $to);\r\n}\r\n@mixin hostgr ($left,$right) {\r\n    background-image: -moz-linear-gradient( 90deg, $left 0%, $right 92%);\r\n    background-image: -webkit-linear-gradient( 90deg, $left 0%, $right 92%);\r\n    background-image: -ms-linear-gradient( 90deg, $left 0%, $right 92%);\r\n}\r\n/* Single side border-radius  */\r\n@mixin border-top-radius($radius) {\r\n    border-top-right-radius: $radius;\r\n    border-top-left-radius: $radius;\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n    border-bottom-right-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n    border-bottom-left-radius: $radius;\r\n    border-top-left-radius: $radius;\r\n}\r\n\r\n/* BORDER RADIUS */\r\n@mixin border-radius($radius) {\r\n    -webkit-border-radius: $radius;\r\n    -moz-border-radius: $radius;\r\n    border-radius: $radius;\r\n}\r\n\r\n/* user select */\r\n@mixin userSelect($user) {\r\n    -webkit-user-select: $user;\r\n    -moz-user-select: $user;\r\n    -ms-user-select: $user;\r\n    user-select: $user;\r\n}\r\n\r\n/* box sizing  */\r\n@mixin box-sizing($box) {\r\n    box-sizing: $box;\r\n    -moz-box-sizing: $box;\r\n    -webkit-box-sizing: $box;\r\n}\r\n\r\n/* placeholder */\r\n@mixin placeholder {\r\n    ::-webkit-input-placeholder {\r\n        @content;\r\n    }\r\n    :-moz-placeholder {\r\n        @content;\r\n    }\r\n    ::-moz-placeholder {\r\n        @content;\r\n    }\r\n    :-ms-input-placeholder {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin placeholder-color($color) {\r\n    &::-webkit-input-placeholder {\r\n        /* WebKit browsers */\r\n        color: $color;\r\n    }\r\n    &:-moz-placeholder {\r\n        /* Mozilla Firefox 4 to 18 */\r\n        color: $color;\r\n    }\r\n    &::-moz-placeholder {\r\n        /* Mozilla Firefox 19+ */\r\n        color: $color;\r\n    }\r\n    &:-ms-input-placeholder {\r\n        /* Internet Explorer 10+ */\r\n        color: $color;\r\n    }\r\n}\r\n\r\n@mixin placeholder-style($style) {\r\n    &::-webkit-input-placeholder {\r\n        /* WebKit browsers */\r\n        font-style: $style;\r\n    }\r\n    &:-moz-placeholder {\r\n        /* Mozilla Firefox 4 to 18 */\r\n        font-style: $style;\r\n    }\r\n    &::-moz-placeholder {\r\n        /* Mozilla Firefox 19+ */\r\n        font-style: $style;\r\n    }\r\n    &:-ms-input-placeholder {\r\n        /* Internet Explorer 10+ */\r\n        font-style: $style;\r\n    }\r\n}\r\n\r\n/* transition  */\r\n@mixin transition($transition) {\r\n    -webkit-transition: $transition;\r\n    -moz-transition: $transition;\r\n    transition: $transition;\r\n}\r\n\r\n/* transform */\r\n@mixin transform($transform) {\r\n    -ms-transform: $transform;\r\n    /* IE 9 */\r\n    -webkit-transform: $transform;\r\n    /* Chrome, Safari, Opera */\r\n    transform: $transform;\r\n}\r\n\r\n/* rotate */\r\n@mixin rotate ($deg) {\r\n    @include transform(rotate(#{$deg}deg));\r\n}\r\n\r\n/* scale */\r\n@mixin scale($scale) {\r\n    @include transform(scale($scale));\r\n}\r\n\r\n/* translate */\r\n@mixin translate ($x, $y) {\r\n    @include transform(translate($x, $y));\r\n}\r\n\r\n@mixin translateX ($x) {\r\n    @include transform(translateX($x));\r\n}\r\n\r\n@mixin translateY ($y) {\r\n    @include transform(translateY($y));\r\n}\r\n\r\n/* translate rotate */\r\n@mixin translate-rotate ($x, $y, $deg) {\r\n    @include transform(translate($x, $y)rotate(#{$deg}deg));\r\n}\r\n\r\n/* skew */\r\n@mixin skew ($x, $y) {\r\n    @include transform(skew(#{$x}deg, #{$y}deg));\r\n}\r\n\r\n@mixin rotate3d($vector-x: $default-vector-x, $vector-y: $default-vector-y, $vector-z: $default-vector-z, $rotate: $default-rotate, $perspective: false) {\r\n    $trans: rotate3d($vector-x, $vector-y, $vector-z, $rotate);\r\n    @if $perspective {\r\n        $trans: perspective($perspective) $trans;\r\n    }\r\n}\r\n\r\n@mixin even() {\r\n    &:nth-child(even) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin odd() {\r\n    &:nth-child(odd) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin fontawesomeIcon($content) {\r\n    content: $content;\r\n    font-family: \"Font Awesome 5 Free\";\r\n    font-weight: 900;\r\n}\r\n\r\n@mixin box-shadow($top, $left, $blur, $color, $inset: false) {\r\n    @if $inset {\r\n        -webkit-box-shadow: inset $top $left $blur $color;\r\n        -moz-box-shadow: inset $top $left $blur $color;\r\n        box-shadow: inset $top $left $blur $color;\r\n    }\r\n    @else {\r\n        -webkit-box-shadow: $top $left $blur $color;\r\n        -moz-box-shadow: $top $left $blur $color;\r\n        box-shadow: $top $left $blur $color;\r\n    }\r\n}\r\n\r\n@mixin selectArrow($arrow) {\r\n    -webkit-appearance: $arrow;\r\n    -moz-appearance: $arrow;\r\n    appearance: $arrow;\r\n}\r\n\r\n@mixin keyframes($animationName) {\r\n    @-webkit-keyframes #{$animationName} {\r\n        @content;\r\n    }\r\n    @-moz-keyframes #{$animationName} {\r\n        @content;\r\n    }\r\n    @-o-keyframes #{$animationName} {\r\n        @content;\r\n    }\r\n    @keyframes #{$animationName} {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin animate($name, $duration, $iteration, $direction) {\r\n    -webkit-animation-duration: $duration;\r\n    -moz-animation-duration: $duration;\r\n    -o-animation-duration: $duration;\r\n    animation-duration: $duration;\r\n    -webkit-animation-iteration-count: $iteration;\r\n    -moz-animation-iteration-count: $iteration;\r\n    -o-animation-iteration-count: $iteration;\r\n    animation-iteration-count: $iteration;\r\n    -webkit-animation-name: $name;\r\n    -moz-animation-name: $name;\r\n    -o-animation-name: $name;\r\n    animation-name: $name;\r\n    -webkit-animation-direction: $direction;\r\n    -moz-animation-direction: $direction;\r\n    -o-animation-direction: $direction;\r\n    animation-direction: $direction;\r\n}\r\n\r\n@mixin skewX($deg) {\r\n    -moz-transform: skewX($deg);\r\n    -webkit-transform: skewX($deg);\r\n    -o-transform: skewX($deg);\r\n    -ms-transform: skewX($deg);\r\n    transform: skewX($deg);\r\n}\r\n\r\n@mixin skewY($deg) {\r\n    -moz-transform: skewY($deg);\r\n    -webkit-transform: skewY($deg);\r\n    -o-transform: skewY($deg);\r\n    -ms-transform: skewY($deg);\r\n    transform: skewY($deg);\r\n}\r\n","/* ============================================================\r\n>>> TABLE OF CONTENTS:\r\n===============================================================\r\n# Google fonts\r\n# Gutter Code \r\n# Normalize\r\n# Typography\r\n# Custom Class\r\n# input and button type focus outline disable\r\n# Form input box\r\n# Text meant only for screen readers.\r\n# Transition\r\n\r\n# Accessibility\r\n# Globals\r\n\r\n# Alignments\r\n# Clearings\r\n# Posts and pages\r\n# Captions\r\n# Galleries\r\n# Unit test\r\n# ScrollUp\r\n# Owl Carousel \r\n# Slick Slider\r\n# Background Overlay\r\n# Scrollbar\r\n# Padding Top\r\n# Padding Bottom\r\n# Margin Top\r\n# Margin Bottom\r\n# Custom margin Padding\r\n\r\n============================================================= */\r\n\r\n/* -------------------------------------\r\n    Google fonts\r\n------------------------------------- */\r\n/* @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Rajdhani:wght@400;500;600;700&display=swap'); */\r\n/*\r\nfont-family: 'Open Sans', sans-serif;\r\nfont-family: 'Rajdhani', sans-serif;\r\n*/\r\n\r\n\r\n/* @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&family=Titillium+Web:wght@400;600;700;900&display=swap'); */\r\n/*\r\nfont-family: 'Nunito Sans', sans-serif;\r\nfont-family: 'Titillium Web', sans-serif;\r\n*/\r\n\r\n/*\r\n\r\nLast uses font\r\n@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&family=Poppins:wght@400;500;600;700;800;900&display=swap');\r\n*/\r\n/*\r\nfont-family: 'Nunito Sans', sans-serif;\r\nfont-family: 'Poppins', sans-serif;\r\n*/\r\n\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;500;600;700&family=Nunito:wght@400;600;700&display=swap');\r\n/*\r\nfont-family: 'Josefin Sans', sans-serif;\r\nfont-family: 'Nunito', sans-serif;\r\n*/\r\n\r\n\r\n\r\n/* ====================================================\r\n    Gutter Code \r\n==================================================== */\r\n.container,\r\n.container-fluid {\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n}\r\n.row {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n}\r\n.col, \r\n.col-1, \r\n.col-10, \r\n.col-11, \r\n.col-12, \r\n.col-2, \r\n.col-3, \r\n.col-4, \r\n.col-5, \r\n.col-6, \r\n.col-7, \r\n.col-8, \r\n.col-9, \r\n.col-auto, \r\n.col-lg, \r\n.col-lg-1, \r\n.col-lg-10, \r\n.col-lg-11, \r\n.col-lg-12, \r\n.col-lg-2, \r\n.col-lg-3, \r\n.col-lg-4, \r\n.col-lg-5, \r\n.col-lg-6, \r\n.col-lg-7, \r\n.col-lg-8, \r\n.col-lg-9, \r\n.col-lg-auto, \r\n.col-md, \r\n.col-md-1, \r\n.col-md-10, \r\n.col-md-11, \r\n.col-md-12, \r\n.col-md-2, \r\n.col-md-3, \r\n.col-md-4, \r\n.col-md-5, \r\n.col-md-6, \r\n.col-md-7, \r\n.col-md-8, \r\n.col-md-9, \r\n.col-md-auto, \r\n.col-sm, \r\n.col-sm-1, \r\n.col-sm-10, \r\n.col-sm-11, \r\n.col-sm-12, \r\n.col-sm-2, \r\n.col-sm-3, \r\n.col-sm-4, \r\n.col-sm-5, \r\n.col-sm-6, \r\n.col-sm-7, \r\n.col-sm-8, \r\n.col-sm-9, \r\n.col-sm-auto, \r\n.col-xl, \r\n.col-xl-1, \r\n.col-xl-10, \r\n.col-xl-11, \r\n.col-xl-12, \r\n.col-xl-2, \r\n.col-xl-3, \r\n.col-xl-4, \r\n.col-xl-5, \r\n.col-xl-6, \r\n.col-xl-7, \r\n.col-xl-8, \r\n.col-xl-9, \r\n.col-xl-auto {\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    position: relative;\r\n}\r\n\r\n.ltn__no-gutter > [class*='col-'] { /* No padding only for child columns */\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n}\r\n.ltn__no-gutter-all [class*='col-'] { /* No padding for every columns */\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n}\r\n\r\n@media(min-width:992px) {  /* Modify this based on column def */\r\n    .ltn__custom-gutter {\r\n        margin-left: -0px;\r\n        margin-right: -0px;\r\n    }\r\n    .ltn__custom-gutter > [class*='col-'] {\r\n        padding-right: 0px;\r\n        padding-left: 0px; \r\n    }\r\n    .ltn__custom-gutter-all {\r\n        .row {\r\n            margin-left: -15px;\r\n            margin-right: -15px;\r\n            & [class*='col-'] {\r\n                padding-right: 15px;\r\n                padding-left: 15px; \r\n            }\r\n        }\r\n    }\r\n    \r\n    \r\n    \r\n}\r\n\r\n@media(max-width:991px) {  /* Modify this based on column def */\r\n    .ltn__custom-gutter {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n    .ltn__custom-gutter > [class*='col-'] {\r\n        padding-right: 15px;\r\n        padding-left: 15px; \r\n    }\r\n    .ltn__custom-gutter-all {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n    .ltn__custom-gutter-all [class*='col-'] {\r\n        padding-right: 15px;\r\n        padding-left: 15px; \r\n    }\r\n\r\n}\r\n\r\n@media(max-width:767px) {  /* Modify this based on column def */\r\n    .ltn__product-gutter {\r\n        .row {\r\n            margin-left: -8px;\r\n            margin-right: -8px;\r\n        }\r\n    }\r\n    .ltn__product-gutter [class*='col-'] {\r\n        padding-right: 8px;\r\n        padding-left: 8px; \r\n    }\r\n\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Normalize    0B2C3D\r\n---------------------------------------------------- */\r\n:root {\r\n    --ltn__primary-color: #071C1F;\r\n    --ltn__primary-color-2: #041113; /* Darken */\r\n    --ltn__primary-color-3: #133236; /* Lighten */\r\n    --ltn__secondary-color: #21485e;\r\n    --ltn__secondary-color-2: #485e21; /* Darken */\r\n    --ltn__secondary-color-3: #fb412a; /* Lighten */\r\n    --ltn__heading-color: #071c1f;\r\n    --ltn__paragraph-color: #5C727D;\r\n    \r\n    --ltn__heading-font: 'Josefin Sans', sans-serif;\r\n    --ltn__body-font: 'Nunito Sans', sans-serif;\r\n    \r\n    /* Footer ACD2D8 8CB2B2  */\r\n    --ltn__color-1: #8cb2b2; \r\n    --ltn__color-2: #ACD2D8; \r\n    --ltn__color-3: #A3BCC0; \r\n    --ltn__color-4: #84A2A6; \r\n    --ltn__color-5: #5C727D; \r\n    --ltn__color-6: #F5DFDC; \r\n\r\n    /* Gradient Colors */ \r\n    --gradient-color-1: linear-gradient(90deg, rgba(242,139,194,1) 0%, rgba(216,177,242,1) 50%);\r\n    --gradient-color-2: linear-gradient(to top, rgba(7,28,31,0) 0%, rgba(7,28,31,1) 90%);\r\n    --gradient-color-3: linear-gradient(to bottom, rgba(7,28,31,0) 0%, rgba(7,28,31,1) 90%);\r\n    --gradient-color-4: linear-gradient(to top, rgba(242,246,247,0) 0%, rgba(242,246,247,1) 90%);\r\n    --gradient-color-5: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 70%);\r\n\r\n\r\n    /* Background Colors ( 1, 2, 3, 4, 5 )  */\r\n    --section-bg-1: #F2F6F7; /* White */\r\n    --section-bg-2: #171B2A; /* Black */\r\n    --section-bg-5: #FFF2F0; /* White */\r\n    --section-bg-6: #0B2C3D; /* Black */\r\n    --section-bg-7: #282b38; /* Black */\r\n\r\n\r\n    /* Border Colors */ \r\n    --border-color-1: #e5eaee; /* White */\r\n    --border-color-2: #1e2021; /* Black */\r\n    --border-color-3: #5C617F; /* Black */\r\n    --border-color-4: #eb6954; /* Red */\r\n    --border-color-5: #bc3928; /* Red */\r\n    --border-color-6: #103034; /* Black */\r\n    --border-color-7: #d1dae0; /* White */\r\n    --border-color-8: #f6f6f6; /* White */\r\n    --border-color-9: #e4ecf2; /* White */\r\n    --border-color-10: #ebeeee; /* White */\r\n    --border-color-11: #ededed; /* White */\r\n    --border-color-12: #e1e6ff; /* White */\r\n    --border-color-13: #f1f8ff; /* White */\r\n\r\n\r\n    /* Box Shadow Colors */\r\n    --ltn__box-shadow-1: 0 16px 32px 0 rgba(7, 28, 31, 0.1);\r\n    --ltn__box-shadow-2: 0 0 4px rgba(0, 0, 0, 0.1); /* like border */\r\n    --ltn__box-shadow-3: 0 1px 6px 0 rgba(32, 33, 36, .28); /* like border GGL */\r\n    --ltn__box-shadow-4: 0 5px 20px 0 rgba(23, 44, 82, 0.1); \r\n    --ltn__box-shadow-5: 0 8px 16px 0 rgba(93, 93, 93, 0.1); \r\n    // --ltn__box-shadow-6: 0 8px 16px 0 rgba(229, 62, 41, 0.70); \r\n    --ltn__box-shadow-6: 0 0 25px 2px rgba(93, 93, 93, 0.2);\r\n    --ltn__box-shadow-7: 0 0 10px 0px rgba(93, 93, 93, 0.2);\r\n\r\n\r\n    /* Common Colors */ \r\n    --black: #000000;\r\n    --black-2: #22355B;\r\n    --white: #fff;\r\n    --white-2: #F2F6F7;\r\n    --white-3: #e8edee;\r\n    --white-4: #e6ecf0; \r\n    --white-5: #f0f4f7; \r\n    --white-6: #f1f1f1; \r\n    --white-7: #F7F7F7; \r\n    --white-8: #FAFAFA; \r\n    --white-9: #F2F7FA; \r\n    --white-10: #EDEDED; \r\n    --red: #FF0000;\r\n    --red-2: #f34f3f;\r\n    --red-3: #DB483B;\r\n    --red-4: #FB2448;\r\n    --silver: #C0C0C0;\r\n    --gray: #808080;\r\n    --maroon: #800000;\r\n    --yellow: #FFFF00;\r\n    --olive: #808000;\r\n    --lime: #00FF00;\r\n    --green: #77C720;\r\n    --green-2: #008000;\r\n    --aqua: #00FFFF;\r\n    --teal: #008080;\r\n    --blue: #0000FF;\r\n    --navy: #000080;\r\n    --fuchsia: #B13BFF;\r\n    --purple: #800080;\r\n    --pink: #FFC0CB;\r\n    --nude: #ebc8b2;\r\n    --orange: #ffa500;\r\n    --ratings: #FFB800;\r\n\r\n    /* social media colors */\r\n    --facebook: #365493;\r\n    --twitter: #3CF;\r\n    --linkedin: #0077B5;\r\n    --pinterest: #c8232c;\r\n    --dribbble: #ea4c89;\r\n    --behance: #131418;\r\n    --google-plus: #dd4b39;\r\n    --instagram: #e4405f;\r\n    --vk: #3b5998;\r\n    --wechat: #7bb32e;\r\n    --youtube: #CB2027;              \r\n    --email: #F89A1E;\r\n\r\n\r\n}\r\n\r\n/* -------------------------------------\r\n    Typography\r\n------------------------------------- */\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;\r\n}\r\n\r\n.loader-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #0b0b0b;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.loader {\r\n  border: 16px solid #e3e3e3;\r\n  border-top: 16px solid #3498db;\r\n  border-radius: 50%;\r\n  width: 140px;\r\n  height: 140px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\nhtml {\r\n    -webkit-text-size-adjust: 100%;\r\n    -ms-text-size-adjust: 100%;\r\n    font-family: var(--ltn__body-font);\r\n}\r\n* {\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    outline: none;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    /* Firefox */\r\n    -webkit-font-smoothing: antialiased;\r\n    /* WebKit  */\r\n}\r\nbody {\r\n    color: var(--ltn__paragraph-color);\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-size: 16px;\r\n    font-family: var(--ltn__body-font);\r\n    line-height: 1.8;\r\n    margin: 0 auto;\r\n}\r\nh1, .h1 {\r\n    font-size: 36px;\r\n    line-height: 1.2;\r\n}\r\nh2, .h2 {\r\n    font-size: 30px;\r\n}\r\nh3, .h3 {\r\n    font-size: 24px;\r\n}\r\nh4, .h4 {\r\n    font-size: 20px;\r\n}\r\nh5, .h5 {\r\n    font-size: 18px;\r\n}\r\nh6, .h6 {\r\n    font-size: 16px;\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n    color: var(--ltn__heading-color);\r\n    clear: both;\r\n    font-family: var(--ltn__heading-font);\r\n    font-weight: 700;\r\n    line-height: 1.3;\r\n    margin-bottom: 15px;\r\n}\r\np {\r\n    color: var(--ltn__paragraph-color);\r\n    margin-bottom: 1.5em;\r\n    -webkit-hyphens: auto;\r\n    -moz-hyphens: auto;\r\n    -ms-hyphens: auto;\r\n    hyphens: auto;\r\n}\r\na {\r\n    color: inherit;\r\n    text-decoration: none;\r\n    color: var(--ltn__paragraph-color);\r\n    transition: all 0.3s ease 0s;\r\n}\r\na,\r\na:hover,\r\na:focus,\r\na:active {\r\n    text-decoration: none;\r\n    outline: none;\r\n    color: inherit;\r\n}\r\na:hover {\r\n    color: var(--ltn__secondary-color);\r\n}\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n    font-family: var(--ltn__body-font);\r\n}\r\npre,\r\ncode,\r\nkbd,\r\ntt,\r\nvar,\r\nsamp {\r\n    font-family: var(--ltn__body-font);\r\n}\r\npre {\r\n    word-break: break-word;\r\n}\r\na i {\r\n    padding: 0 2px;\r\n}\r\nimg {\r\n    max-width: 100%;\r\n}\r\nul li,\r\nol li {\r\n    margin-top: 1rem;\r\n}\r\n\r\n/* -------------------------------------\r\n    Custom Class\r\n------------------------------------- */\r\n.body-wrapper{\r\n  background-color: var(--section-bg-1)!important;\r\n}\r\n\r\n.color-border{\r\n  border-top: 8px solid #21485e;\r\n  width: 75px;\r\n  border-radius: 5px;\r\n}\r\n.section-bg-1 {\r\n    background-color: var(--section-bg-1);\r\n    .ltn__separate-line .separate-icon {\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n.section-bg-2,\r\n.section-bg-6,\r\n.section-bg-7 {\r\n    background-color: var(--section-bg-2);\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6,\r\n    p,\r\n    li,\r\n    i,\r\n    span,\r\n    tr,\r\n    td {\r\n        color: var(--white);\r\n    }\r\n    .ltn__separate-line .separate-icon {\r\n        background-color: var(--black-2);\r\n    }\r\n}\r\n.section-bg-3 {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: var(--gradient-color-1);\r\n        opacity: 0.9;\r\n    }\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6,\r\n    p,\r\n    li,\r\n    i,\r\n    span,\r\n    tr,\r\n    td {\r\n        color: var(--white);\r\n    }\r\n    .slick-arrow-1 .slick-arrow {\r\n        background-color: transparent;\r\n    }\r\n    input[type=\"text\"], \r\n    input[type=\"email\"], \r\n    input[type=\"password\"], \r\n    input[type=\"submit\"] {\r\n        border-color: var(--white);\r\n        color: var(--white);\r\n    }\r\n    .btn-wrapper button {\r\n        color: var(--white);\r\n    }\r\n    input::-webkit-input-placeholder {\r\n        color: var(--white);\r\n    }\r\n    input::-moz-placeholder {\r\n        color: var(--white);\r\n    }\r\n    input:-ms-input-placeholder {\r\n        color: var(--white);\r\n    }\r\n    input:-moz-placeholder {\r\n        color: var(--white);\r\n    }\r\n    .ltn__separate-line .separate-icon {\r\n        background: var(--gradient-color-1);\r\n        i {\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n.section-bg-4 {\r\n    background-color: var(--ltn__primary-color-2);\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6,\r\n    p,\r\n    li,\r\n    i,\r\n    span,\r\n    tr,\r\n    td {\r\n        color: var(--white);\r\n    }\r\n    .ltn__separate-line .separate-icon {\r\n        background-color: var(--black-2);\r\n    }\r\n    .ltn__copyright-design {\r\n        h6, h4 {\r\n            color: var(--ltn__color-1);\r\n        }\r\n    }\r\n}\r\n.section-bg-5 {\r\n    background-color: var(--section-bg-5);\r\n}\r\n.section-bg-6 {\r\n    background-color: var(--section-bg-6);\r\n}\r\n.section-bg-7 {\r\n    background-color: var(--section-bg-7);\r\n}\r\n.text-color-white {\r\n    color: var(--white);\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6,\r\n    p,\r\n    li,\r\n    i,\r\n    span,\r\n    tr,\r\n    td {\r\n        color: var(--white);\r\n    }\r\n}\r\n.ltn__primary-color {\r\n    color: var(--ltn__primary-color) !important;\r\n}\r\n.ltn__primary-color-2 {\r\n    color: var(--ltn__primary-color-2) !important;\r\n}\r\n.ltn__primary-color-3 {\r\n    color: var(--ltn__primary-color-3) !important;\r\n}\r\n.ltn__secondary-color {\r\n    color: var(--ltn__secondary-color) !important;\r\n}\r\n.ltn__secondary-color-2 {\r\n    color: var(--ltn__secondary-color-2) !important;\r\n}\r\n.ltn__secondary-color-3 {\r\n    color: var(--ltn__secondary-color-3) !important;\r\n}\r\n.ltn__color-1 {\r\n    color: var(--ltn__color-1);\r\n}\r\n.white-color {\r\n    color: var(--white);\r\n}\r\n.white-color-im {\r\n    color: var(--white) !important;\r\n}\r\n.ltn__primary-bg {\r\n    background-color: var(--ltn__primary-color);\r\n}\r\n.ltn__primary-bg-2 {\r\n    background-color: var(--ltn__primary-color-2);\r\n}\r\n.ltn__secondary-bg {\r\n    background-color: var(--ltn__secondary-color);\r\n}\r\n.ltn__secondary-bg-2 {\r\n    background-color: var(--ltn__secondary-color-2);\r\n}\r\n.white-bg {\r\n    background-color: var(--white);\r\n}\r\n.gradient-color-1 {\r\n    background: var(--gradient-color-1);\r\n}\r\n.gradient-color-2 {\r\n    background: var(--gradient-color-2);\r\n}\r\n.gradient-color-3 {\r\n    background: var(--gradient-color-3);\r\n}\r\n.gradient-color-4 {\r\n    background: var(--gradient-color-4);\r\n}\r\n.gradient-color-5 {\r\n    background: var(--gradient-color-5);\r\n}\r\n.before-bg-1 {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 100%;\r\n        height: 34.2%;\r\n        left: 0;\r\n        bottom: 0;\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n.before-bg-top {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 100%;\r\n        height: 72%;\r\n        left: 0;\r\n        top: 0;\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n.before-bg-bottom {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 100%;\r\n        height: 50%;\r\n        left: 0;\r\n        bottom: 0;\r\n        background-color: var(--section-bg-2);\r\n    }\r\n}\r\n.before-bg-bottom-2 {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 100%;\r\n        height: 50%;\r\n        left: 0;\r\n        bottom: 0;\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n.before-bg-right {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 25%;\r\n        height: 100%;\r\n        left: auto;\r\n        right: 0;\r\n        top: 0;\r\n        background-color: var(--ltn__primary-color);\r\n    }\r\n}\r\n.before-bg-left {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 25%;\r\n        height: 100%;\r\n        left: 0;\r\n        right: auto;\r\n        top: 0;\r\n        background-color: var(--ltn__primary-color);\r\n    }\r\n}\r\n\r\n.box-shadow {\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n}\r\n.box-shadow-1 {\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n}\r\n\r\n.ltn__custom-icon {\r\n    position: relative;\r\n    &::before {\r\n        content: \"\\f063\";\r\n        font-family: 'Font Awesome\\ 5 Free';\r\n        font-weight: 900;\r\n    }\r\n}\r\n.ltn__border {\r\n    border: 1px solid var(--border-color-1);\r\n}\r\n.ltn__border-top {\r\n    border-top: 1px solid var(--border-color-1);\r\n}\r\n.border-top {\r\n    border-top: 1px solid var(--border-color-1);\r\n}\r\n.border-bottom {\r\n    border-bottom: 1px solid var(--border-color-1);\r\n}\r\n.border-color-3 {\r\n    border-color: var(--border-color-3) !important;\r\n}\r\nmark {\r\n    background-color: var(--ltn__primary-color);\r\n    padding: 3px 15px;\r\n    color: var(--white);\r\n    border-radius: 25px;\r\n}\r\nhr {\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n    border-top: 1px solid var(--border-color-12);\r\n}\r\na.text-decoration,\r\n.text-decoration a {\r\n    text-decoration: underline;\r\n}\r\nfieldset {\r\n    padding: 30px 40px;\r\n    border: 1px solid #eee;\r\n}\r\nfieldset legend {\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    line-height: 1;\r\n    width: auto;\r\n    margin-top: -9px;\r\n    margin-bottom: 0;\r\n    padding: 0 15px;\r\n    text-transform: uppercase;\r\n    color: #333;\r\n    background-color: #fff;\r\n}\r\n@media (max-width: 991px) {\r\n    .before-bg-right:before {\r\n        width: 0;\r\n    }\r\n    .before-bg-left:before {\r\n        width: 0;\r\n    }\r\n}\r\n.position-relative {\r\n    position: relative;\r\n}\r\n.bg-fixed {\r\n    background-attachment: fixed;\r\n}\r\n\r\n.bg-black {\r\n    background-color: var(--black) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-lemon {\r\n  background-color: #485e21 !important;\r\n  color: var(--white) !important;\r\n}\r\n.bg-main {\r\n  background-color: #21485e !important;\r\n  color: var(--white) !important;\r\n}\r\n.bg-white {\r\n    background-color: var(--white) !important;\r\n    color: var(--black) !important;\r\n}\r\n.bg-red {\r\n    background-color: var(--red) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-yellow {\r\n    background-color: var(--yellow) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-green {\r\n    background-color: var(--green) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-blue {\r\n    background-color: var(--blue) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-orange {\r\n    background-color: var(--orange) !important;\r\n    color: var(--white) !important;\r\n}\r\n.bg-fuchsia {\r\n    background-color: var(--fuchsia) !important;\r\n    color: var(--white) !important;\r\n}\r\n.color-orange {\r\n    color: var(--orange);\r\n}\r\n.font-weight-4 {\r\n    font-weight: 400;\r\n}\r\n.font-weight-5 {\r\n    font-weight: 500;\r\n}\r\n.font-weight-6 {\r\n    font-weight: 600;\r\n}\r\n.font-weight-7 {\r\n    font-weight: 700;\r\n}\r\n/* ----------------------------------------------------\r\n    input and button type focus outline disable\r\n---------------------------------------------------- */\r\ninput[type=\"text\"]:focus,\r\ninput[type=\"email\"]:focus,\r\ninput[type=\"url\"]:focus,\r\ninput[type=\"password\"]:focus,\r\ninput[type=\"search\"]:focus,\r\ninput[type=\"tel\"]:focus,\r\ninput[type=\"number\"]:focus,\r\ntextarea:focus,\r\ninput[type=\"button\"]:focus,\r\ninput[type=\"reset\"]:focus,\r\ninput[type=\"submit\"]:focus,\r\nselect:focus {\r\n    outline: none;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    border: 1px solid #ddd;\r\n}\r\n\r\ncode {\r\n    color: #faa603;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Form input box\r\n---------------------------------------------------- */\r\ninput[type=\"text\"], \r\ninput[type=\"email\"], \r\ninput[type=\"password\"], \r\ninput[type=\"submit\"],\r\ntextarea {\r\n    background-color: var(--white);\r\n    border: 2px solid;\r\n    border-color: var(--border-color-9);\r\n    height: 65px;\r\n    box-shadow: none;\r\n    padding-left: 20px;\r\n    font-size: 16px;\r\n    color: var(--ltn__paragraph-color);\r\n    width: 100%;\r\n    margin-bottom: 30px;\r\n    border-radius: 0;\r\n    padding-right: 40px;\r\n}\r\ninput[type=\"text\"]::-webkit-input-placeholder, \r\ninput[type=\"email\"]::-webkit-input-placeholder, \r\ninput[type=\"password\"]::-webkit-input-placeholder, \r\ninput[type=\"submit\"]::-webkit-input-placeholder,\r\ntextarea::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n    color: var(--ltn__paragraph-color);\r\n    font-size: 14px;\r\n}\r\ninput[type=\"text\"]:focus, \r\ninput[type=\"email\"]:focus, \r\ninput[type=\"password\"]:focus,\r\ntextarea:focus {\r\n    border-color: var(--ltn__secondary-color);\r\n}\r\ninput[type=\"password\"] {\r\n    letter-spacing: 3px;\r\n    font-size: 16px;\r\n}\r\ntextarea {\r\n    resize: vertical;\r\n    padding: 15px 20px;\r\n    min-height: 150px;\r\n}\r\nbutton {\r\n    outline: none;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\nbutton:focus {\r\n    outline: none;\r\n}\r\n.form-input-box {\r\n    position: relative;\r\n}\r\n.form-input-box input[type=\"text\"] {\r\n    width: 100%;\r\n    height: 50px;\r\n    padding: 0 70px 0 15px;\r\n    border-radius: 0 15px 0px 0px;\r\n    border: 1px solid var(--ltn__primary-color);\r\n    margin-bottom: 0;\r\n}\r\n.form-input-box button[type=\"submit\"] {\r\n    background-color: var(--ltn__primary-color);\r\n    color: var(--white);\r\n    padding: 0 18px;\r\n    height: 100%;\r\n    border: 1px solid var(--ltn__primary-color);\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.form-input-box button[type=\"submit\"]:hover {\r\n    background-color: var(--ltn__secondary-color);\r\n    border-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n}\r\n\r\n/* input-item */\r\n.input-item {\r\n    position: relative;\r\n    &.ltn__custom-icon::before {\r\n        position: absolute;\r\n        top: 35%;\r\n        transform: translateY(-50%);\r\n        right: 20px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n.input-item-name.ltn__custom-icon::before {\r\n    content: \"\\f007\";\r\n}\r\n.input-item-email.ltn__custom-icon::before {\r\n    content: \"\\f0e0\";\r\n}\r\n.input-item-phone.ltn__custom-icon::before {\r\n    content: \"\\f095\";\r\n}\r\n.input-item-subject.ltn__custom-icon::before {\r\n    content: \"\\f06e\";\r\n}\r\n.input-item-website.ltn__custom-icon::before {\r\n    content: \"\\f0ac\";\r\n}\r\n.input-item-date.ltn__custom-icon::before {\r\n    content: \"\\f073\";\r\n}\r\n.input-item-textarea.ltn__custom-icon::before {\r\n    content: \"\\f303\";\r\n    top: 30px;\r\n}\r\n.input-info-save {\r\n    font-size: 14px;\r\n}\r\nlabel.checkbox-inline {\r\n    font-size: 14px;\r\n}\r\n/* ----------------------------------------------------\r\n    Text meant only for screen readers.\r\n---------------------------------------------------- */\r\n.screen-reader-text {\r\n    border: 0;\r\n    clip: rect(1px, 1px, 1px, 1px);\r\n    clip-path: inset(50%);\r\n    height: 1px;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: absolute !important;\r\n    width: 1px;\r\n    word-wrap: normal !important;\r\n    /* Many screen reader and browser combinations announce broken words as they would appear visually. */\r\n}\r\n\r\n.screen-reader-text:focus {\r\n    background-color: #f1f1f1;\r\n    border-radius: 3px;\r\n    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);\r\n    clip: auto !important;\r\n    clip-path: none;\r\n    color: #21759b;\r\n    display: block;\r\n    font-size: 14px;\r\n    font-size: 0.875rem;\r\n    font-weight: bold;\r\n    height: auto;\r\n    left: 5px;\r\n    line-height: normal;\r\n    padding: 15px 23px 14px;\r\n    text-decoration: none;\r\n    top: 5px;\r\n    width: auto;\r\n    z-index: 100000;\r\n    /* Above WP toolbar. */\r\n}\r\n\r\n/* Do not show the outline on the skip link target. */\r\n#content[tabindex=\"-1\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n\r\n/* -------------------------------------\r\n    Transition\r\n------------------------------------- */\r\n$transition: all .3s ease-in;\r\n$transition-long: all .5s ease-in;\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Alignments\r\n---------------------------------------------------- */\r\n.alignleft {\r\n    float: left;\r\n    clear: both;\r\n    margin-right: 20px;\r\n}\r\n.alignright {\r\n    float: right;\r\n    clear: both;\r\n    margin-left: 20px;\r\n}\r\n.aligncenter {\r\n    clear: both;\r\n    display: block;\r\n    margin: 0 auto 1.75em;\r\n}\r\n.alignfull {\r\n    margin: 1.5em 0;\r\n    max-width: 100%;\r\n}\r\n.alignwide {\r\n    max-width: 1100px;\r\n}\r\n.fix {\r\n    overflow: hidden;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Clearings\r\n---------------------------------------------------- */\r\n.clear:before,\r\n.clear:after,\r\n.entry-content:before,\r\n.entry-content:after,\r\n.comment-content:before,\r\n.comment-content:after,\r\n.site-header:before,\r\n.site-header:after,\r\n.site-content:before,\r\n.site-content:after,\r\n.site-footer:before,\r\n.site-footer:after {\r\n    content: \"\";\r\n    display: table;\r\n    table-layout: fixed;\r\n}\r\n\r\n.clear:after,\r\n.entry-content:after,\r\n.comment-content:after,\r\n.site-header:after,\r\n.site-content:after,\r\n.site-footer:after {\r\n    clear: both;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Posts and pages\r\n---------------------------------------------------- */\r\n.sticky {\r\n    display: block;\r\n}\r\n.updated:not(.published) {\r\n    display: none;\r\n}\r\n.blog-pagination ul li {\r\n    display: inline-block;\r\n}\r\n.blog-pagination ul li+li {\r\n    margin: 0 5px;\r\n}\r\n.blog-pagination {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n.blog-pagination ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n.blog-pagination ul li a,\r\n.blog-pagination ul li span {\r\n    display: block;\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 1px solid #e2e2e2;\r\n    line-height: 40px;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    transition: .3s ease-in;\r\n}\r\n.blog-pagination ul li span.current,\r\n.blog-pagination ul li a:hover {\r\n    background-color: var(--ltn__primary-color);\r\n    color: #fff;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Media\r\n---------------------------------------------------- */\r\n.page-content .wp-smiley,\r\n.entry-content .wp-smiley,\r\n.comment-content .wp-smiley {\r\n    border: none;\r\n    margin-bottom: 0;\r\n    margin-top: 0;\r\n    padding: 0;\r\n}\r\n\r\n\r\n/* Make sure embeds and iframes fit their containers. */\r\nembed,\r\niframe,\r\nobject {\r\n    max-width: 100%;\r\n}\r\n\r\n/* Make sure logo link wraps around logo image. */\r\n.custom-logo-link {\r\n    display: inline-block;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Captions\r\n---------------------------------------------------- */\r\n.wp-caption {\r\n    margin-bottom: 1.5em;\r\n    max-width: 100%;\r\n    clear: both;\r\n}\r\n.wp-caption img[class*=\"wp-image-\"] {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n.wp-caption .wp-caption-text {\r\n    margin: 0.8075em 0;\r\n}\r\n.wp-caption-text {\r\n    text-align: center;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Galleries\r\n---------------------------------------------------- */\r\n.gallery {\r\n    margin-bottom: 1.5em;\r\n}\r\n\r\n.gallery-item {\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: top;\r\n    width: 100%;\r\n}\r\n\r\n.gallery-columns-2 .gallery-item {\r\n    max-width: 50%;\r\n}\r\n\r\n.gallery-columns-3 .gallery-item {\r\n    max-width: 33.33%;\r\n}\r\n\r\n.gallery-columns-4 .gallery-item {\r\n    max-width: 25%;\r\n}\r\n\r\n.gallery-columns-5 .gallery-item {\r\n    max-width: 20%;\r\n}\r\n\r\n.gallery-columns-6 .gallery-item {\r\n    max-width: 16.66%;\r\n}\r\n\r\n.gallery-columns-7 .gallery-item {\r\n    max-width: 14.28%;\r\n}\r\n\r\n.gallery-columns-8 .gallery-item {\r\n    max-width: 12.5%;\r\n}\r\n\r\n.gallery-columns-9 .gallery-item {\r\n    max-width: 11.11%;\r\n}\r\n\r\n.gallery-caption {\r\n    display: block;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Unit test\r\n---------------------------------------------------- */\r\n.wp-link-pages a {\r\n    margin: 0 5px;\r\n    transition: .3s ease-in;\r\n}\r\n\r\n.wp-link-pages {\r\n    margin-bottom: 30px;\r\n    margin-top: 25px;\r\n}\r\n\r\n.wp-link-pages span,\r\n.wp-link-pages a {\r\n    border: 1px solid #e2e2e2;\r\n    padding: 5px 15px;\r\n    display: inline-block;\r\n}\r\n\r\n.wp-link-pages .current,\r\n.wp-link-pages a:hover {\r\n    background-color: var(--ltn__primary-color);\r\n    color: #fff;\r\n    border-color: var(--ltn__primary-color);\r\n}\r\n\r\n.wp-link-pages span:first-child {\r\n    margin-right: 5px;\r\n}\r\n\r\ndl,\r\nol,\r\nul {\r\n    padding-left: 20px;\r\n}\r\n\r\n.post-password-form input {\r\n    display: block;\r\n    border: 1px solid #e2e2e2;\r\n    height: 50px;\r\n    border-radius: 3px;\r\n    padding: 0 20px;\r\n}\r\n\r\n.post-password-form label {\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.post-password-form input[type=submit] {\r\n    width: 100px;\r\n    height: 50px;\r\n    background-color: var(--ltn__primary-color);\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    letter-spacing: 1px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: .3s ease-in;\r\n}\r\n\r\n.post-password-form input[type=submit]:hover {\r\n    background-color: #121A2F;\r\n}\r\n\r\n.footer-widget .table td,\r\n.footer-widget .table th {\r\n    padding: 0.50rem !important;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    ScrollUp\r\n---------------------------------------------------- */\r\n#scrollUp {\r\n    background-color: var(--section-bg-1);\r\n    color: var(--ltn__heading-color);\r\n    bottom: 70px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    height: 40px;\r\n    width: 40px;\r\n    right: 3%;\r\n    text-align: center;\r\n    -webkit-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n    -webkit-transition: all 0.3s ease 0s;\r\n    transition: all 0.3s ease 0s;\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    i {\r\n        line-height: 40px;\r\n        -webkit-transform: rotate(-45deg);\r\n        transform: rotate(-45deg);\r\n    }\r\n    &:hover {\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Owl Carousel \r\n---------------------------------------------------- */\r\n.owl-dots {\r\n    display: block;\r\n    text-align: center;\r\n    margin-top: 20px;\r\n}\r\n.owl-dots .owl-dot {\r\n    display: inline-block;\r\n    background-color: var(--ltn__secondary-color);\r\n    height: 10px;\r\n    width: 10px;\r\n    margin-right: 30px;\r\n    border-radius: 100%;\r\n}\r\n.owl-dots .owl-dot:last-child {\r\n    margin-right: 0px;\r\n}\r\n.owl-dots .owl-dot:hover,\r\n.owl-dots .owl-dot.active {\r\n    background-color: var(--ltn__primary-color);\r\n}\r\n/* owl-arrow-1 */\r\n.owl-arrow-1 .owl-nav > div {\r\n    position: absolute;\r\n    left: -60px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: auto;\r\n}\r\n.owl-arrow-1 .owl-nav > div.owl-next {\r\n    left: auto;\r\n    right: -60px;\r\n}\r\n@media only screen and (max-width: 1200px) { \r\n    .owl-arrow-1 .owl-nav > div {\r\n        right: auto;\r\n        left: 0px;\r\n    }\r\n    .owl-arrow-1 .owl-nav > div.owl-next {\r\n        right: 0px;\r\n        left: auto;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Slick Slider Dots, Arrow\r\n---------------------------------------------------- */\r\n/* Slick dots */\r\n.slick-dots {\r\n    margin: 0 0 30px;\r\n    padding: 0;\r\n    display: block;\r\n    text-align: center;\r\n    line-height: 1;\r\n    li {\r\n        display: inline-block;\r\n        list-style: none;\r\n        display: inline-block;\r\n        font-size: 0;\r\n        height: 10px;\r\n        width: 10px;\r\n        border-radius: 100%;\r\n        margin-right: 10px;\r\n        background-color: var(--silver);\r\n        cursor: pointer;\r\n        margin-top: 0;\r\n        transition: all 0.3s ease 0s;\r\n        button {\r\n            display: none;\r\n        }\r\n        &:hover,\r\n        &.slick-active {\r\n            background-color: var(--ltn__secondary-color);\r\n            height: 15px;\r\n            width: 15px;\r\n            margin-bottom: -2px;\r\n        }\r\n    }\r\n}\r\n\r\n/* slick-arrow */\r\n.slick-arrow {\r\n    cursor: pointer;\r\n    z-index: 9;\r\n}\r\n\r\n/* slick-arrow-1 */\r\n.slick-arrow-1 {\r\n    .slick-arrow {\r\n        background-color: var(--white);\r\n        cursor: pointer;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 15px;\r\n        right: auto;\r\n        transform: translateY(-50%);\r\n        width: 50px;\r\n        height: 50px;\r\n        line-height: 48px;\r\n        display: block;\r\n        border: 1px solid var(--white-4);\r\n        border-radius: 100%;\r\n        text-align: center;\r\n        font-size: 20px;\r\n        color: var(--ltn__primary-color) !important;\r\n        z-index: 1;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color);\r\n            border-color: var(--ltn__secondary-color);\r\n            color: var(--white) !important;\r\n        }\r\n    }\r\n    .slick-next {\r\n        right: 15px;\r\n        left: auto;\r\n    }\r\n    &:hover {\r\n        .slick-arrow {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n.slick-arrow-1-inner {\r\n    &.slick-arrow-1:hover {\r\n        .slick-arrow {\r\n            left: 50px;\r\n            right: auto;\r\n        }\r\n        .slick-next {\r\n            right: 50px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1350px) {\r\n    .slick-arrow-1:hover {\r\n        .slick-arrow {\r\n            left: -50px;\r\n            right: auto;\r\n        }\r\n        .slick-next {\r\n            right: -50px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n/* slick-arrow-2 */\r\n.slick-arrow-2 {\r\n    .slick-arrow {\r\n        color: var(--ltn__primary-color) !important;\r\n        cursor: pointer;\r\n        position: absolute;\r\n        bottom: -30px;\r\n        height: 30px;\r\n        width: 30px;\r\n        line-height: 28px;\r\n        display: block;\r\n        left: 15px;\r\n        border: 1px solid var(--border-color-1);\r\n        text-align: center;\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color);\r\n            border-color: var(--ltn__secondary-color);\r\n            color: var(--white) !important;\r\n        }\r\n    }\r\n    .slick-next {\r\n        left: 60px;\r\n    }\r\n}\r\n\r\n/* slick-arrow-3 */\r\n.slick-arrow-3 {\r\n    .slick-arrow {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        top: -120px;\r\n        height: 60px;\r\n        width: 60px;\r\n        line-height: 58px;\r\n        display: block;\r\n        left: auto;\r\n        right: 100px;\r\n        border: 2px solid;\r\n        text-align: center;\r\n        box-shadow: var(--ltn__box-shadow-2);\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color);\r\n            border-color: var(--border-color-4);\r\n            color: var(--white) !important;\r\n        }\r\n    }\r\n    .slick-next {\r\n        right: 15px;\r\n        background-color: var(--white);\r\n        border-color: var(--white);\r\n        color: var(--ltn__primary-color) !important;\r\n    }\r\n    .slick-prev {\r\n        background-color: var(--ltn__secondary-color);\r\n        border-color: var(--border-color-4);\r\n        color: var(--white) !important;\r\n    }\r\n}\r\n\r\n/* slick-arrow-4 */\r\n.slick-arrow-4 {\r\n    margin: 0;\r\n    .slick-arrow {\r\n        position: absolute;\r\n        bottom: -50px;\r\n        left: 0;\r\n        right: 0;\r\n        text-align: center;\r\n        height: 50px;\r\n        width: 50px;\r\n        line-height: 50px;\r\n        margin: 0 auto;\r\n        border: 1px solid;\r\n        border-radius: 100%;\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color);\r\n            border-color: var(--border-color-4);\r\n            color: var(--white) !important;\r\n        }\r\n    }\r\n    .slick-next {\r\n        right: -60px;\r\n    }\r\n    .slick-prev {\r\n        left: -60px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .slick-dots {\r\n        margin: 0 0 15px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Background Overlay\r\n---------------------------------------------------- */\r\n\r\n.compassion{\r\n  color: #485e21 !important;\r\n}\r\n\r\n\r\n\r\n\r\n .bg-overlay-black-10, \r\n .bg-overlay-black-20, \r\n .bg-overlay-black-30, \r\n .bg-overlay-black-40, \r\n .bg-overlay-black-50, \r\n .bg-overlay-black-60, \r\n .bg-overlay-black-70, \r\n .bg-overlay-black-80, \r\n .bg-overlay-black-90, \r\n .bg-overlay-white-10, \r\n .bg-overlay-white-20, \r\n .bg-overlay-white-30,  \r\n .bg-overlay-white-40, \r\n .bg-overlay-white-50, \r\n .bg-overlay-white-60, \r\n .bg-overlay-white-70,  \r\n .bg-overlay-white-80, \r\n .bg-overlay-white-90 {\r\n    z-index: 8;\r\n    position: relative;\r\n }\r\n .bg-overlay-black-10:before, \r\n .bg-overlay-black-20:before, \r\n .bg-overlay-black-30:before, \r\n .bg-overlay-black-40:before, \r\n .bg-overlay-black-50:before, \r\n .bg-overlay-black-60:before, \r\n .bg-overlay-black-70:before, \r\n .bg-overlay-black-80:before, \r\n .bg-overlay-black-90:before, \r\n .bg-overlay-white-10:before, \r\n .bg-overlay-white-20:before, \r\n .bg-overlay-white-30:before, \r\n .bg-overlay-white-40:before, \r\n .bg-overlay-white-50:before, \r\n .bg-overlay-white-60:before, \r\n .bg-overlay-white-70:before, \r\n .bg-overlay-white-80:before, \r\n .bg-overlay-white-90:before{\r\n    position: absolute; \r\n    content: \"\"; \r\n    left: 0;\r\n    top: 0; \r\n    height: 100%;\r\n    width: 100%;  \r\n    z-index: -1; \r\n }\r\n.bg-overlay-black-10:before {  background: rgba(0, 0, 0, 0.1);}\r\n.bg-overlay-black-20:before {  background: rgba(0, 0, 0, 0.2);}\r\n.bg-overlay-black-30:before {  background: rgba(0, 0, 0, 0.3);}\r\n.bg-overlay-black-40:before {  background: rgba(0, 0, 0, 0.4);}\r\n.bg-overlay-black-50:before {  background: rgba(0, 0, 0, 0.5);}\r\n.bg-overlay-black-60:before {  background: rgba(0, 0, 0, 0.6);}\r\n.bg-overlay-black-70:before {  background: rgba(0, 0, 0, 0.7);}\r\n.bg-overlay-black-80:before {  background: rgba(0, 0, 0, 0.8);}\r\n.bg-overlay-black-90:before {  background: rgba(0, 0, 0, 0.9);}\r\n\r\n.bg-overlay-white-10:before {  background: rgba(255, 255, 255, 0.1);}\r\n.bg-overlay-white-20:before {  background: rgba(255, 255, 255, 0.2);}\r\n.bg-overlay-white-30:before {  background: rgba(255, 255, 255, 0.3);}\r\n.bg-overlay-white-40:before {  background: rgba(255, 255, 255, 0.4);}\r\n.bg-overlay-white-50:before {  background: rgba(255, 255, 255, 0.5);}\r\n.bg-overlay-white-60:before {  background: rgba(255, 255, 255, 0.6);}\r\n.bg-overlay-white-70:before {  background: rgba(255, 255, 255, 0.7);}\r\n.bg-overlay-white-80:before {  background: rgba(255, 255, 255, 0.8);}\r\n.bg-overlay-white-90:before {  background: rgba(255, 255, 255, 0.9);}\r\n\r\n\r\n.compassion-bg,\r\n.bg-overlay-theme-05, \r\n.bg-overlay-theme-10, \r\n.bg-overlay-theme-20, \r\n.bg-overlay-theme-30, \r\n.bg-overlay-theme-40, \r\n.bg-overlay-theme-50, \r\n.bg-overlay-theme-60, \r\n.bg-overlay-theme-70, \r\n.bg-overlay-theme-80, \r\n.bg-overlay-theme-90 {\r\n    z-index: 9;\r\n    position: relative;\r\n}\r\n.bg-overlay-theme-05:before, \r\n.bg-overlay-theme-10:before, \r\n.bg-overlay-theme-20:before, \r\n.bg-overlay-theme-30:before, \r\n.bg-overlay-theme-40:before, \r\n.bg-overlay-theme-50:before, \r\n.bg-overlay-theme-60:before, \r\n.bg-overlay-theme-70:before, \r\n.bg-overlay-theme-80:before, \r\n.compassion-bg:before,\r\n.bg-overlay-theme-90:before{\r\n   position: absolute; \r\n   content: \"\"; \r\n   left: 0;\r\n   top: 0; \r\n   height: 100%;\r\n   width: 100%;  \r\n   z-index: -1; \r\n}\r\n.bg-overlay-theme-05:before {  background: rgba(10, 154, 115, 0.05);}\r\n.bg-overlay-theme-10:before {  background: rgba(10, 154, 115, 0.1);}\r\n.bg-overlay-theme-20:before {  background: rgba(10, 154, 115, 0.2);}\r\n.bg-overlay-theme-30:before {  background: rgba(10, 154, 115, 0.3);}\r\n.bg-overlay-theme-40:before {  background: rgba(10, 154, 115, 0.4);}\r\n.bg-overlay-theme-50:before {  background: rgba(10, 154, 115, 0.5);}\r\n.bg-overlay-theme-60:before {  background: rgba(10, 154, 115, 0.6);}\r\n.bg-overlay-theme-70:before {  background: rgba(10, 154, 115, 0.7);}\r\n.bg-overlay-theme-80:before {  background: rgba(10, 154, 115, 0.8);}\r\n.bg-overlay-theme-90:before {  background: rgba(33, 72, 94, 0.9);}\r\n.compassion-bg:before{\r\n  background: rgba(72, 94, 33, 0.9);\r\n}\r\n\r\n.bg-overlay-theme-black-05, \r\n.bg-overlay-theme-black-10, \r\n.bg-overlay-theme-black-20, \r\n.bg-overlay-theme-black-30, \r\n.bg-overlay-theme-black-40, \r\n.bg-overlay-theme-black-50, \r\n.bg-overlay-theme-black-60, \r\n.bg-overlay-theme-black-70, \r\n.bg-overlay-theme-black-80, \r\n.bg-overlay-theme-black-90 {\r\n    z-index: 9;\r\n    position: relative;\r\n}\r\n.bg-overlay-theme-black-05:before, \r\n.bg-overlay-theme-black-10:before, \r\n.bg-overlay-theme-black-20:before, \r\n.bg-overlay-theme-black-30:before, \r\n.bg-overlay-theme-black-40:before, \r\n.bg-overlay-theme-black-50:before, \r\n.bg-overlay-theme-black-60:before, \r\n.bg-overlay-theme-black-70:before, \r\n.bg-overlay-theme-black-80:before, \r\n.bg-overlay-theme-black-90:before{\r\n   position: absolute; \r\n   content: \"\"; \r\n   left: 0;\r\n   top: 0; \r\n   height: 100%;\r\n   width: 100%;  \r\n   z-index: -1; \r\n}\r\n.bg-overlay-theme-black-05:before {  background: rgba(7, 28, 31, 0.05);}\r\n.bg-overlay-theme-black-10:before {  background: rgba(7, 28, 31, 0.1);}\r\n.bg-overlay-theme-black-20:before {  background: rgba(7, 28, 31, 0.2);}\r\n.bg-overlay-theme-black-30:before {  background: rgba(7, 28, 31, 0.3);}\r\n.bg-overlay-theme-black-40:before {  background: rgba(7, 28, 31, 0.4);}\r\n.bg-overlay-theme-black-50:before {  background: rgba(7, 28, 31, 0.5);}\r\n.bg-overlay-theme-black-60:before {  background: rgba(7, 28, 31, 0.6);}\r\n.bg-overlay-theme-black-70:before {  background: rgba(7, 28, 31, 0.7);}\r\n.bg-overlay-theme-black-80:before {  background: rgba(7, 28, 31, 0.8);}\r\n.bg-overlay-theme-black-90:before {  background: rgba(7, 28, 31, 0.9);}\r\n/* ----------------------------------------------\r\n  Scrollbar\r\n---------------------------------------------- */\r\n.ltn__scrollbar {\r\n    overflow-y: auto; \r\n}  \r\n.ltn__scrollbar::-webkit-scrollbar {\r\n    width: 2px;\r\n    background-color: #f5f5f5;\r\n    border-radius: 30px;\r\n}    \r\n.ltn__scrollbar::-webkit-scrollbar-thumb {\r\n    background-color: #ddd; \r\n}\r\n\r\n\r\n.mean-nav {\r\n    overflow-y: auto; \r\n}  \r\n.mean-nav::-webkit-scrollbar {\r\n    width: 3px;\r\n    background-color: var(--ltn__primary-color);\r\n    border-radius: 30px;\r\n}    \r\n.mean-nav::-webkit-scrollbar-thumb {\r\n    background-color: var(--ltn__secondary-color); \r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Padding Top\r\n---------------------------------------------------- */\r\n.pt-0 { padding-top: 0px !important; }\r\n.pt-10 { padding-top: 10px !important; }\r\n.pt-15 { padding-top: 15px !important; }\r\n.pt-20 { padding-top: 20px !important; }\r\n.pt-25 { padding-top: 25px; }\r\n.pt-30 { padding-top: 30px; }\r\n.pt-35 { padding-top: 35px; }\r\n.pt-40 { padding-top: 40px; }\r\n.pt-45 { padding-top: 45px; }\r\n.pt-50 { padding-top: 50px; }\r\n.pt-55 { padding-top: 55px; }\r\n.pt-60 { padding-top: 60px; }\r\n.pt-65 { padding-top: 65px; }\r\n.pt-70 { padding-top: 70px; }\r\n.pt-75 { padding-top: 75px; }\r\n.pt-80 { padding-top: 80px; }\r\n.pt-85 { padding-top: 85px; }\r\n.pt-90 { padding-top: 90px; }\r\n.pt-95 { padding-top: 95px; }\r\n.pt-97 { padding-top: 97px; }\r\n.pt-100 { padding-top: 100px; }\r\n.pt-105 { padding-top: 105px; }\r\n.pt-110 { padding-top: 110px; }\r\n.pt-112 { padding-top: 112px; }\r\n.pt-115 { padding-top: 115px; }\r\n.pt-118 { padding-top: 118px; }\r\n.pt-120 { padding-top: 120px; }\r\n.pt-122 { padding-top: 122px; }\r\n.pt-125 { padding-top: 125px; }\r\n.pt-130 { padding-top: 130px; }\r\n.pt-135 { padding-top: 135px; }\r\n.pt-140 { padding-top: 140px; }\r\n.pt-145 { padding-top: 145px; }\r\n.pt-150 { padding-top: 150px; }\r\n.pt-155 { padding-top: 155px; }\r\n.pt-160 { padding-top: 160px; }\r\n.pt-170 { padding-top: 170px; }\r\n.pt-180 { padding-top: 180px; }\r\n.pt-190 { padding-top: 190px; }\r\n.pt-200 { padding-top: 200px; }\r\n.pt-210 { padding-top: 210px; }\r\n.pt-220 { padding-top: 220px; }\r\n.pt-230 { padding-top: 230px; }\r\n.pt-250 { padding-top: 250px; }\r\n.pt-280 { padding-top: 280px; }\r\n.pt-290 { padding-top: 290px; }\r\n.pt-300 { padding-top: 300px; }\r\n.pt-310 { padding-top: 310px; }\r\n.pt-320 { padding-top: 320px; }\r\n.pt-350 { padding-top: 350px; }\r\n\r\n/* ----------------------------------------------------\r\n    Padding Bottom\r\n---------------------------------------------------- */\r\n.pb-0 { padding-bottom: 0px !important; }\r\n.pb-10 { padding-bottom: 10px !important; }\r\n.pb-15 { padding-bottom: 15px !important; }\r\n.pb-20 { padding-bottom: 20px !important; }\r\n.pb-25 { padding-bottom: 25px; }\r\n.pb-30 { padding-bottom: 30px; }\r\n.pb-35 { padding-bottom: 35px; }\r\n.pb-40 { padding-bottom: 40px; }\r\n.pb-45 { padding-bottom: 45px; }\r\n.pb-50 { padding-bottom: 50px; }\r\n.pb-55 { padding-bottom: 55px; }\r\n.pb-60 { padding-bottom: 60px; }\r\n.pb-65 { padding-bottom: 65px; }\r\n.pb-70 { padding-bottom: 70px; }\r\n.pb-75 { padding-bottom: 75px; }\r\n.pb-80 { padding-bottom: 80px; }\r\n.pb-85 { padding-bottom: 85px; }\r\n.pb-90 { padding-bottom: 90px; }\r\n.pb-95 { padding-bottom: 95px; }\r\n.pb-97 { padding-bottom: 97px; }\r\n.pb-100 { padding-bottom: 100px; }\r\n.pb-105 { padding-bottom: 105px; }\r\n.pb-107 { padding-bottom: 107px; }\r\n.pb-110 { padding-bottom: 110px; }\r\n.pb-112 { padding-bottom: 112px; }\r\n.pb-115 { padding-bottom: 115px; }\r\n.pb-118 { padding-bottom: 118px; }\r\n.pb-120 { padding-bottom: 120px; }\r\n.pb-122 { padding-bottom: 122px; }\r\n.pb-125 { padding-bottom: 125px; }\r\n.pb-130 { padding-bottom: 130px; }\r\n.pb-140 { padding-bottom: 140px; }\r\n.pb-145 { padding-bottom: 145px; }\r\n.pb-150 { padding-bottom: 150px; }\r\n.pb-155 { padding-bottom: 155px; }\r\n.pb-160 { padding-bottom: 160px; }\r\n.pb-170 { padding-bottom: 170px; }\r\n.pb-180 { padding-bottom: 180px; }\r\n.pb-190 { padding-bottom: 190px; }\r\n.pb-200 { padding-bottom: 200px; }\r\n.pb-210 { padding-bottom: 210px; }\r\n.pb-220 { padding-bottom: 220px; }\r\n.pb-250 { padding-bottom: 250px; }\r\n.pb-280 { padding-bottom: 280px; }\r\n.pb-290 { padding-bottom: 290px; }\r\n.pb-300 { padding-bottom: 300px; }\r\n.pb-310 { padding-bottom: 310px; }\r\n.pb-320 { padding-bottom: 320px; }\r\n.pb-350 { padding-bottom: 350px; }\r\n\r\n/* ----------------------------------------------------\r\n    Margin Top\r\n---------------------------------------------------- */\r\n.mt-0 { margin-top: 0px !important; }\r\n.mt-10 { margin-top: 10px !important; }\r\n.mt-12 { margin-top: 12px !important; }\r\n.mt-15 { margin-top: 15px !important; }\r\n.mt-20 { margin-top: 20px !important; }\r\n.mt-25 { margin-top: 25px !important; }\r\n.mt-30 { margin-top: 30px !important; }\r\n.mt-35 { margin-top: 35px; }\r\n.mt-37 { margin-top: 37px; }\r\n.mt-40 { margin-top: 40px; }\r\n.mt-45 { margin-top: 45px; }\r\n.mt-50 { margin-top: 50px; }\r\n.mt-55 { margin-top: 55px; }\r\n.mt-60 { margin-top: 60px; }\r\n.mt-65 { margin-top: 65px; }\r\n.mt-70 { margin-top: 70px; }\r\n.mt-80 { margin-top: 80px; }\r\n.mt-90 { margin-top: 90px; }\r\n.mt-95 { margin-top: 95px; }\r\n.mt-100 { margin-top: 100px; }\r\n.mt-105 { margin-top: 105px; }\r\n.mt-110 { margin-top: 110px; }\r\n.mt-115 { margin-top: 115px; }\r\n.mt-118 { margin-top: 118px; }\r\n.mt-120 { margin-top: 120px; }\r\n.mt-122 { margin-top: 122px; }\r\n.mt-125 { margin-top: 125px; }\r\n.mt-130 { margin-top: 130px; }\r\n.mt-140 { margin-top: 140px; }\r\n.mt-150 { margin-top: 150px; }\r\n.mt-160 { margin-top: 160px; }\r\n.mt-170 { margin-top: 170px; }\r\n\r\n/* ----------------------------------------------------\r\n    Margin Bottom\r\n---------------------------------------------------- */\r\n.mb-0 { margin-bottom: 0px !important; }\r\n.mb-10 { margin-bottom: 10px !important; }\r\n.mb-12 { margin-bottom: 12px !important; }\r\n.mb-15 { margin-bottom: 15px !important; }\r\n.mb-20 { margin-bottom: 20px !important; }\r\n.mb-25 { margin-bottom: 25px !important; }\r\n.mb-30 { margin-bottom: 30px !important; }\r\n.mb-35 { margin-bottom: 35px; }\r\n.mb-40 { margin-bottom: 40px; }\r\n.mb-45 { margin-bottom: 45px; }\r\n.mb-50 { margin-bottom: 50px; }\r\n.mb-55 { margin-bottom: 55px; }\r\n.mb-60 { margin-bottom: 60px; }\r\n.mb-65 { margin-bottom: 65px; }\r\n.mb-70 { margin-bottom: 70px; }\r\n.mb-80 { margin-bottom: 80px; }\r\n.mb-90 { margin-bottom: 90px; }\r\n.mb-95 { margin-bottom: 95px; }\r\n.mb-100 { margin-bottom: 100px; }\r\n.mb-105 { margin-bottom: 105px; }\r\n.mb-110 { margin-bottom: 110px; }\r\n.mb-115 { margin-bottom: 115px; }\r\n.mb-118 { margin-bottom: 118px; }\r\n.mb-120 { margin-bottom: 120px; }\r\n.mb-122 { margin-bottom: 122px; }\r\n.mb-125 { margin-bottom: 125px; }\r\n.mb-130 { margin-bottom: 130px; }\r\n.mb-140 { margin-bottom: 140px; }\r\n.mb-150 { margin-bottom: 150px; }\r\n\r\n/* ----------------------------------------------------\r\n    Custom margin Padding\r\n---------------------------------------------------- */\r\n.pl-0 {\r\n    padding-left: 0 !important;\r\n}\r\n.pr-0 {\r\n    padding-right: 0 !important;\r\n}\r\n.mr-30 {\r\n    margin-right: 30px;\r\n}\r\n.ml-30 {\r\n    margin-left: 30px;\r\n}\r\n.pl-70 {\r\n    padding-left: 70px;\r\n}\r\n.pr-70 {\r\n    padding-right: 70px;\r\n}\r\n/* Padding left right */\r\n.plr--2 {\r\n    padding-left: 2%;\r\n    padding-right: 2%;\r\n}\r\n.plr--3 {\r\n    padding-left: 3%;\r\n    padding-right: 3%;\r\n}\r\n.plr--4 {\r\n    padding-left: 4%;\r\n    padding-right: 4%;\r\n}\r\n.plr--5 {\r\n    padding-left: 5%;\r\n    padding-right: 5%;\r\n}\r\n.plr--6 {\r\n    padding-left: 6%;\r\n    padding-right: 6%;\r\n}\r\n.plr--7 {\r\n    padding-left: 7%;\r\n    padding-right: 7%;\r\n}\r\n.plr--8 {\r\n    padding-left: 8%;\r\n    padding-right: 8%;\r\n}\r\n.plr--9 { /* used */\r\n    padding-left: 9%;\r\n    padding-right: 9%;\r\n}\r\n.plr--10 {\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n}\r\n.plr--11 {\r\n    padding-left: 11%;\r\n    padding-right: 11%;\r\n}\r\n.plr--12 {\r\n    padding-left: 12%;\r\n    padding-right: 12%;\r\n}\r\n@media (max-width: 1599px) {\r\n    .plr--2,\r\n    .plr--3,\r\n    .plr--4,\r\n    .plr--5,\r\n    .plr--6,\r\n    .plr--7,\r\n    .plr--8,\r\n    .plr--9,\r\n    .plr--10,\r\n    .plr--11,\r\n    .plr--12 {\r\n        padding-left: 2%;\r\n        padding-right: 2%;\r\n    }\r\n}\r\n@media (max-width: 1399px) {\r\n    .plr--2,\r\n    .plr--3,\r\n    .plr--4,\r\n    .plr--5,\r\n    .plr--6,\r\n    .plr--7,\r\n    .plr--8,\r\n    .plr--9,\r\n    .plr--10,\r\n    .plr--11,\r\n    .plr--12 {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n}\r\n@media (min-width: 1200px) {\r\n    /* Margin Top Minus */\r\n    .mt--30 {\r\n        margin-top: -30px !important;\r\n    }\r\n    .mt--65 {\r\n        margin-top: -65px;\r\n    }\r\n    .mt--80 {\r\n        margin-top: -100px;\r\n    }\r\n    .mt--90 {\r\n        margin-top: -100px;\r\n    }\r\n    .mt--100 {\r\n        margin-top: -100px;\r\n    }\r\n    .mt--110 {\r\n        margin-top: -100px;\r\n    }\r\n    .mt--120 {\r\n        margin-top: -100px;\r\n    }\r\n    .mt--150 {\r\n        margin-top: -100px;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .mb-sm-20 {\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n/* Margin Bottom Minus */\r\n.mb--30 {\r\n    margin-bottom: -30px;\r\n}\r\n.mb--80 {\r\n    margin-bottom: -100px;\r\n}\r\n.mb--90 {\r\n    margin-bottom: -100px;\r\n}\r\n.mb--100 {\r\n    margin-bottom: -100px;\r\n}\r\n.mb--110 {\r\n    margin-bottom: -100px;\r\n}\r\n.mb--120 {\r\n    margin-bottom: -100px;\r\n}\r\n.mb--150 {\r\n    margin-bottom: -100px;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Custom Height\r\n---------------------------------------------------- */\r\n.ltn__height-100 {\r\n    height: 100px;\r\n}\r\n.ltn__height-200 {\r\n    height: 200px;\r\n}\r\n.ltn__height-250 {\r\n    height: 250px;\r\n}\r\n.ltn__height-300 {\r\n    height: 300px;\r\n}\r\n.ltn__height-350 {\r\n    height: 350px;\r\n}\r\n.ltn__height-400 {\r\n    height: 400px;\r\n}\r\n.ltn__height-450 {\r\n    height: 450px;\r\n}\r\n.ltn__height-500 {\r\n    height: 500px;\r\n}\r\n.ltn__height-550 {\r\n    height: 550px;\r\n}\r\n.ltn__height-600 {\r\n    height: 600px;\r\n}\r\n.ltn__height-650 {\r\n    height: 650px;\r\n}\r\n.ltn__height-700 {\r\n    height: 700px;\r\n}","/* --------------------------------------------------------------\r\n# Gutenberg\tDefault Style\r\n-------------------------------------------------------------- */\r\n\r\n.single-post-details-item .entry-content > .alignwide {\r\n\tmax-width: 1100px;\r\n}\r\n\r\n.single-post-details-item .entry-content > .alignfull {\r\n\tmargin: 1.5em 0;\r\n\tmax-width: 100%;\r\n}\r\n\r\n\r\n.wp-block-video video {\r\n\tmax-width: 636px;\r\n}\r\n\r\n.wp-block-image img {\r\n\tdisplay: block;\r\n}\r\n\r\n.wp-block-image.alignleft,\r\n.wp-block-image.alignright {\r\n\twidth: 100%\r\n}\r\n\r\n.wp-block-image.alignfull img {\r\n\twidth: 100vw;\r\n}\r\n\r\n.wp-block-gallery:not(.components-placeholder) {\r\n\tmargin: 1.5em auto;\r\n}\r\n\r\n.wp-block-cover-text p {\r\n\tpadding: 1.5em 14px;\r\n}\r\n\r\nul.wp-block-latest-posts.alignwide,\r\nul.wp-block-latest-posts.alignfull,\r\nul.wp-block-latest-posts.is-grid.alignwide,\r\nul.wp-block-latest-posts.is-grid.alignwide {\r\n\tpadding: 0 14px;\r\n}\r\n\r\n.wp-block-table {\r\n\tdisplay: block;\r\n\toverflow-x: auto;\r\n}\r\n\r\n.wp-block-table table {\r\n\tborder-collapse: collapse;\r\n\twidth: 100%\r\n}\r\n\r\n.wp-block-table td, .wp-block-table th {\r\n\tpadding: .5em;\r\n}\r\n\r\n.wp-block-embed.type-video > .wp-block-embed__wrapper {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 0;\r\n\tpadding-top: 56.25%;\r\n}\r\n\r\n.wp-block-embed.type-video > .wp-block-embed__wrapper > iframe {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tright: 0;\r\n}\r\n\r\n.wp-block-quote.is-large {\r\n\tmargin: 0 auto 16px;\r\n}\r\n\r\n.wp-block-pullquote>p:first-child {\r\n\tmargin-top: 0;\r\n}\r\n\r\n.wp-block-separator {\r\n\tmargin: 3em auto;\r\n\tpadding: 0;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n\t.wp-block-cover-text p {\r\n\t\tpadding: 1.5em 0;\r\n\t}\r\n}\r\n.wp-block-video video {\r\n\tmax-width: 636px;\r\n}\r\n\r\n.wp-block-image img {\r\n\tdisplay: block;\r\n}\r\n\r\n.wp-block-image.alignleft,\r\n.wp-block-image.alignright {\r\n\twidth: 100%;\r\n}\r\n\r\n.wp-block-image.alignfull img {\r\n\twidth: 100vw;\r\n}\r\n\r\n.wp-block-gallery:not(.components-placeholder) {\r\n\tmargin: 1.5em auto;\r\n}\r\n\r\n.wp-block-cover-text p {\r\n\tpadding: 1.5em 14px;\r\n}\r\n\r\nul.wp-block-latest-posts.alignwide,\r\nul.wp-block-latest-posts.alignfull,\r\nul.wp-block-latest-posts.is-grid.alignwide,\r\nul.wp-block-latest-posts.is-grid.alignwide {\r\n\tpadding: 0 14px;\r\n}\r\n\r\n.wp-block-table {\r\n\tdisplay: block;\r\n\toverflow-x: auto;\r\n}\r\n\r\n.wp-block-table table {\r\n\tborder-collapse: collapse;\r\n\twidth: 100%;\r\n}\r\n\r\n.wp-block-table td, .wp-block-table th {\r\n\tpadding: .5em;\r\n}\r\n\r\n.wp-block-embed.type-video > .wp-block-embed__wrapper {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 0;\r\n\tpadding-top: 56.25%;\r\n}\r\n\r\n.wp-block-embed.type-video > .wp-block-embed__wrapper > iframe {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tright: 0;\r\n}\r\n\r\n.wp-block-quote.is-large {\r\n\tmargin: 0 auto 16px;\r\n}\r\n\r\n.wp-block-pullquote > p:first-child {\r\n\tmargin-top: 0;\r\n}\r\n.wp-block-quote:not(.is-large):not(.is-style-large) {\r\n\tborder-left: 4px solid #000;\r\n\tpadding-left: 1em;\r\n}\r\n.wp-block-separator {\r\n\tmargin: 3em auto;\r\n\tpadding: 0;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n\t.wp-block-cover-text p {\r\n\t\tpadding: 1.5em 0;\r\n\t}\r\n}\r\n.wp-block-pullquote {\r\n\tborder-top: 4px solid #555d66;\r\n\tborder-bottom: 4px solid #555d66;\r\n\tcolor: #40464d;\r\n}\r\n/* --------------------------------------------------------------\r\n## Block Color Palette Colors\r\n-------------------------------------------------------------- */\r\n.has-strong-blue-color {\r\n\tcolor: #0073aa;\r\n}\r\n\r\n.has-strong-blue-background-color {\r\n\tbackground-color: #0073aa;\r\n}\r\n\r\n.has-lighter-blue-color {\r\n\tcolor: #229fd8;\r\n}\r\n\r\n.has-lighter-blue-background-color {\r\n\tbackground-color: #229fd8;\r\n}\r\n\r\n.has-very-light-gray-color {\r\n\tcolor: #eee;\r\n}\r\n\r\n.has-very-light-gray-background-color {\r\n\tbackground-color: #eee;\r\n}\r\n\r\n.has-very-dark-gray-color {\r\n\tcolor: #444;\r\n}\r\n\r\n.has-very-dark-gray-background-color {\r\n\tbackground-color: #444;\r\n}\r\n","/* ----------------------------------------------------\r\n    Animation Custom Class\r\n---------------------------------------------------- */\r\n.ltn__effect-img {\r\n    position: absolute;\r\n}\r\n.ltn__effect-img-top-left {\r\n    top: 6%;\r\n    left: 5%;\r\n}\r\n.ltn__effect-img-top-right {\r\n    top: 5%;\r\n    right: 5%;\r\n}\r\n.ltn__effect-img-center-left {\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    left: 3%;\r\n}\r\n.ltn__effect-img-center-center {\r\n    top: 50%;\r\n    transform: translateY(-50%) translateX(-50%);\r\n    left: 50%;\r\n}\r\n.ltn__effect-img-center-right {\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 3%;\r\n}\r\n.ltn__effect-img-bottom-left {\r\n    bottom: 5%;\r\n    left: 0;\r\n}\r\n.ltn__effect-img-bottom-right {\r\n    bottom: 5%;\r\n    right: 5%;\r\n}\r\n\r\n.ltn__animation-pulse1 {\r\n  a {\r\n      -webkit-animation: pulse1 1s infinite;\r\n      animation: pulse1 1s infinite;\r\n  }\r\n}\r\n.ltn__animation-pulse2 {\r\n  a {\r\n      -webkit-animation: pulse2 1s infinite;\r\n      animation: pulse2 1s infinite;\r\n  }\r\n}\r\n@-webkit-keyframes pulse1 {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0.6);\r\n    box-shadow: 0 0 0 0 rgba(255,255,255, 0.6); \r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 15px rgba(255,255,255, 0);\r\n    box-shadow: 0 0 0 15px rgba(255,255,255, 0); \r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0);\r\n    box-shadow: 0 0 0 0 rgba(255,255,255, 0); \r\n  } \r\n}\r\n\r\n@keyframes pulse1 {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0.6);\r\n    box-shadow: 0 0 0 0 rgba(255,255,255, 0.6); \r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 15px rgba(255,255,255, 0);\r\n    box-shadow: 0 0 0 15px rgba(255,255,255, 0); \r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255,255,255, 0);\r\n    box-shadow: 0 0 0 0 rgba(255,255,255, 0); \r\n  } \r\n}\r\n@-webkit-keyframes pulse2 {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 90, 60, 0.6);\r\n    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0.6); \r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 15px rgba(255, 90, 60, 0);\r\n    box-shadow: 0 0 0 15px rgba(255, 90, 60, 0); \r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 90, 60, 0);\r\n    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0); \r\n  } \r\n}\r\n\r\n@keyframes pulse2 {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 90, 60, 0.6);\r\n    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0.6); \r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 15px rgba(255, 90, 60, 0);\r\n    box-shadow: 0 0 0 15px rgba(255, 90, 60, 0); \r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 90, 60, 0);\r\n    box-shadow: 0 0 0 0 rgba(255, 90, 60, 0); \r\n  } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Animation CSS\r\n---------------------------------------------------- */\r\n.ltn__parallax-effect-wrap,\r\n.layer {\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0; }\r\n\r\n.ltn__parallax-effect-wrap {\r\n  min-height: 600px;\r\n  position: relative;\r\n  overflow: hidden; }\r\n\r\n.layer {\r\n  position: absolute; }\r\n  .layer div {\r\n    -webkit-transform: translate3d(0,0,0);\r\n    -moz-transform: translate3d(0,0,0);\r\n    transform: translate3d(0,0,0);\r\n    -webkit-transform-style: preserve-3d;\r\n    -moz-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n    -webkit-backface-visibility: hidden;\r\n    -moz-backface-visibility: hidden;\r\n    backface-visibility: hidden; }\r\n\r\n.background {\r\n  background: url(../../img/effect/1.png) no-repeat 50% 100%;\r\n  bottom: 96px;\r\n  background-size: cover;\r\n  position: absolute;\r\n  width: 110%;\r\n  left: -5%;\r\n  top: -5%; }\r\n\r\n.lighthouse {\r\n  -webkit-transform-origin: 50% 90%;\r\n  -moz-transform-origin: 50% 90%;\r\n  transform-origin: 50% 90%;\r\n  -webkit-animation: lighthouse 4s 0.1s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: lighthouse 4s 0.1s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: lighthouse 4s 0.1s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  margin: 0px -64px;\r\n  background-size: 128px 224px;\r\n  height: 224px;\r\n  width: 128px;\r\n  background-image: url(../../img/effect/2.png);\r\n  background-repeat: no-repeat;\r\n  bottom: 64px;\r\n  position: absolute;\r\n  right: 20%; }\r\n\r\n\r\n\r\n  .wave.plain {\r\n    background-image: url(../../img/effect/3.png); }\r\n  .wave.paint {\r\n    background-image: url(../../img/effect/4.png); }\r\n\r\n.light {\r\n  margin: -120px -120px;\r\n  background-size: 240px 240px;\r\n  height: 240px;\r\n  width: 240px;\r\n  background-repeat: no-repeat;\r\n  bottom: 112px;\r\n  position: absolute;\r\n  left: 50%; }\r\n  .light.orange {\r\n    background-image: url(../../img/effect/5.png); }\r\n  .light.purple {\r\n    background-image: url(../../img/effect/6.png); }\r\n  .light.a {\r\n    bottom: 80px;\r\n    left: 20%; }\r\n  .light.b {\r\n    bottom: 80px;\r\n    left: 30%; }\r\n  .light.c {\r\n    bottom: 112px;\r\n    left: 45%; }\r\n  .light.d {\r\n    bottom: 96px;\r\n    left: 60%; }\r\n  .light.e {\r\n    bottom: 112px;\r\n    left: 75%; }\r\n  .light.f {\r\n    bottom: 64px;\r\n    left: 80%; }\r\n  .light.phase-1 {\r\n    -webkit-animation: phase 20s 0.1s infinite linear;\r\n    -moz-animation: phase 20s 0.1s infinite linear;\r\n    animation: phase 20s 0.1s infinite linear; }\r\n  .light.phase-2 {\r\n    -webkit-animation: phase 18s 0.1s infinite linear;\r\n    -moz-animation: phase 18s 0.1s infinite linear;\r\n    animation: phase 18s 0.1s infinite linear; }\r\n  .light.phase-3 {\r\n    -webkit-animation: phase 16s 0.1s infinite linear;\r\n    -moz-animation: phase 16s 0.1s infinite linear;\r\n    animation: phase 16s 0.1s infinite linear; }\r\n  .light.phase-4 {\r\n    -webkit-animation: phase 14s 0.1s infinite linear;\r\n    -moz-animation: phase 14s 0.1s infinite linear;\r\n    animation: phase 14s 0.1s infinite linear; }\r\n  .light.phase-5 {\r\n    -webkit-animation: phase 12s 0.1s infinite linear;\r\n    -moz-animation: phase 12s 0.1s infinite linear;\r\n    animation: phase 12s 0.1s infinite linear; }\r\n  .light.phase-6 {\r\n    -webkit-animation: phase 10s 0.1s infinite linear;\r\n    -moz-animation: phase 10s 0.1s infinite linear;\r\n    animation: phase 10s 0.1s infinite linear; }\r\n\r\n\r\n\r\n.hanger {\r\n  -webkit-transform-origin: 0% 0%;\r\n  -moz-transform-origin: 0% 0%;\r\n  transform-origin: 0% 0%;\r\n  position: absolute; }\r\n  .hanger.position-1 {\r\n    top: 28%; }\r\n  .hanger.position-2 {\r\n    top: 46%; }\r\n  .hanger.position-3 {\r\n    top: 59%; }\r\n  .hanger.position-4 {\r\n    top: 66.5%; }\r\n  .hanger.position-5 {\r\n    top: 69.5%; }\r\n  .hanger.position-6 {\r\n    top: 66.5%; }\r\n  .hanger.position-7 {\r\n    top: 59%; }\r\n  .hanger.position-8 {\r\n    top: 46%; }\r\n  .hanger.position-9 {\r\n    top: 28%; }\r\n  .hanger.position-1 {\r\n    left: 10%; }\r\n  .hanger.position-2 {\r\n    left: 20%; }\r\n  .hanger.position-3 {\r\n    left: 30%; }\r\n  .hanger.position-4 {\r\n    left: 40%; }\r\n  .hanger.position-5 {\r\n    left: 50%; }\r\n  .hanger.position-6 {\r\n    left: 60%; }\r\n  .hanger.position-7 {\r\n    left: 70%; }\r\n  .hanger.position-8 {\r\n    left: 80%; }\r\n  .hanger.position-9 {\r\n    left: 90%; }\r\n\r\n.board {\r\n  -webkit-transform-origin: 50% 0%;\r\n  -moz-transform-origin: 50% 0%;\r\n  transform-origin: 50% 0%;\r\n  margin: 0px -140px;\r\n  background-size: 280px 280px;\r\n  height: 280px;\r\n  width: 280px;\r\n  background-repeat: no-repeat;\r\n  position: absolute;\r\n  top: -4px;\r\n  left: 0; }\r\n  .board.birds {\r\n    background-image: url(../../img/effect/5.png); }\r\n  .board.cloud-1 {\r\n    background-image: url(../../img/effect/1.png); }\r\n  .board.cloud-2 {\r\n    background-image: url(../../img/effect/2.png); }\r\n  .board.cloud-3 {\r\n    background-image: url(../../img/effect/3.png); }\r\n  .board.cloud-4 {\r\n    background-image: url(../../img/effect/4.png); }\r\n\r\n.swing-1 {\r\n  -webkit-animation: swing 4s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: swing 4s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: swing 4s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955); }\r\n\r\n.swing-2 {\r\n  -webkit-animation: swing 3.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: swing 3.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: swing 3.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955); }\r\n\r\n.swing-3 {\r\n  -webkit-animation: swing 3s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: swing 3s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: swing 3s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955); }\r\n\r\n.swing-4 {\r\n  -webkit-animation: swing 2.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: swing 2.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: swing 2.5s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955); }\r\n\r\n.swing-5 {\r\n  -webkit-animation: swing 2s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-animation: swing 2s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  animation: swing 2s infinite alternate cubic-bezier(0.455, 0.03, 0.515, 0.955); }\r\n\r\n\r\n/* --------------- */\r\n.wave {\r\n    background: transparent repeat-x;\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 0; \r\n    margin: 0px 0px;\r\n    background-position: center bottom;\r\n    background-size: auto 101%;\r\n    height: 30%;\r\n    -webkit-animation: wave 5.33333s 0.1s infinite linear;\r\n    -moz-animation: wave 5.33333s 0.1s infinite linear;\r\n    animation: wave 5.33333s 0.1s infinite linear;\r\n\r\n}\r\n.ltn__animation-wave-3s {\r\n    -webkit-animation: wave 3s 0.1s infinite linear;\r\n    -moz-animation: wave 3s 0.1s infinite linear;\r\n    animation: wave 3s 0.1s infinite linear;\r\n}\r\n.ltn__animation-wave-4s {\r\n    -webkit-animation: wave 4s 0.1s infinite linear;\r\n    -moz-animation: wave 4s 0.1s infinite linear;\r\n    animation: wave 4s 0.1s infinite linear;\r\n}\r\n.ltn__animation-wave-5s {\r\n    -webkit-animation: wave 5.33333s 0.1s infinite linear;\r\n    -moz-animation: wave 5.33333s 0.1s infinite linear;\r\n    animation: wave 5.33333s 0.1s infinite linear;\r\n}\r\n.ltn__animation-wave-6s {\r\n    -webkit-animation: wave 6.22222s 0.1s infinite linear;\r\n    -moz-animation: wave 6.22222s 0.1s infinite linear;\r\n    animation: wave 6.22222s 0.1s infinite linear;\r\n}\r\n.ltn__animation-wave-7s {\r\n    -webkit-animation: wave 7.11111s 0.1s infinite linear;\r\n    -moz-animation: wave 7.11111s 0.1s infinite linear;\r\n    animation: wave 7.11111s 0.1s infinite linear;\r\n}\r\n.ltn__animation-wave-8s {\r\n    -webkit-animation: wave 8s 0.1s infinite linear;\r\n    -moz-animation: wave 8s 0.1s infinite linear;\r\n    animation: wave 8s 0.1s infinite linear;\r\n}\r\n\r\n.cross, .x, .y {\r\n  -webkit-transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  -moz-transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1); }\r\n\r\n\r\n@-webkit-keyframes phase {\r\n  0% {\r\n    opacity: 1; }\r\n  25% {\r\n    opacity: 0.4; }\r\n  50% {\r\n    opacity: 0.8; }\r\n  75% {\r\n    opacity: 0.4; }\r\n  100% {\r\n    opacity: 1; } }\r\n@-moz-keyframes phase {\r\n  0% {\r\n    opacity: 1; }\r\n  25% {\r\n    opacity: 0.4; }\r\n  50% {\r\n    opacity: 0.8; }\r\n  75% {\r\n    opacity: 0.4; }\r\n  100% {\r\n    opacity: 1; } }\r\n@-ms-keyframes phase {\r\n  0% {\r\n    opacity: 1; }\r\n  25% {\r\n    opacity: 0.4; }\r\n  50% {\r\n    opacity: 0.8; }\r\n  75% {\r\n    opacity: 0.4; }\r\n  100% {\r\n    opacity: 1; } }\r\n@keyframes phase {\r\n  0% {\r\n    opacity: 1; }\r\n  25% {\r\n    opacity: 0.4; }\r\n  50% {\r\n    opacity: 0.8; }\r\n  75% {\r\n    opacity: 0.4; }\r\n  100% {\r\n    opacity: 1; } }\r\n@-webkit-keyframes tilt {\r\n  0% {\r\n    -webkit-transform: rotateX(-30deg);\r\n    -moz-transform: rotateX(-30deg);\r\n    transform: rotateX(-30deg); }\r\n  25% {\r\n    -webkit-transform: rotateX( 30deg);\r\n    -moz-transform: rotateX( 30deg);\r\n    transform: rotateX( 30deg); }\r\n  50% {\r\n    -webkit-transform: rotateY(-30deg);\r\n    -moz-transform: rotateY(-30deg);\r\n    transform: rotateY(-30deg); }\r\n  75% {\r\n    -webkit-transform: rotateY( 30deg);\r\n    -moz-transform: rotateY( 30deg);\r\n    transform: rotateY( 30deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ( 20deg);\r\n    -moz-transform: rotateZ( 20deg);\r\n    transform: rotateZ( 20deg); } }\r\n@-moz-keyframes tilt {\r\n  0% {\r\n    -webkit-transform: rotateX(-30deg);\r\n    -moz-transform: rotateX(-30deg);\r\n    transform: rotateX(-30deg); }\r\n  25% {\r\n    -webkit-transform: rotateX( 30deg);\r\n    -moz-transform: rotateX( 30deg);\r\n    transform: rotateX( 30deg); }\r\n  50% {\r\n    -webkit-transform: rotateY(-30deg);\r\n    -moz-transform: rotateY(-30deg);\r\n    transform: rotateY(-30deg); }\r\n  75% {\r\n    -webkit-transform: rotateY( 30deg);\r\n    -moz-transform: rotateY( 30deg);\r\n    transform: rotateY( 30deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ( 20deg);\r\n    -moz-transform: rotateZ( 20deg);\r\n    transform: rotateZ( 20deg); } }\r\n@-ms-keyframes tilt {\r\n  0% {\r\n    -webkit-transform: rotateX(-30deg);\r\n    -moz-transform: rotateX(-30deg);\r\n    transform: rotateX(-30deg); }\r\n  25% {\r\n    -webkit-transform: rotateX( 30deg);\r\n    -moz-transform: rotateX( 30deg);\r\n    transform: rotateX( 30deg); }\r\n  50% {\r\n    -webkit-transform: rotateY(-30deg);\r\n    -moz-transform: rotateY(-30deg);\r\n    transform: rotateY(-30deg); }\r\n  75% {\r\n    -webkit-transform: rotateY( 30deg);\r\n    -moz-transform: rotateY( 30deg);\r\n    transform: rotateY( 30deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ( 20deg);\r\n    -moz-transform: rotateZ( 20deg);\r\n    transform: rotateZ( 20deg); } }\r\n@keyframes tilt {\r\n  0% {\r\n    -webkit-transform: rotateX(-30deg);\r\n    -moz-transform: rotateX(-30deg);\r\n    transform: rotateX(-30deg); }\r\n  25% {\r\n    -webkit-transform: rotateX( 30deg);\r\n    -moz-transform: rotateX( 30deg);\r\n    transform: rotateX( 30deg); }\r\n  50% {\r\n    -webkit-transform: rotateY(-30deg);\r\n    -moz-transform: rotateY(-30deg);\r\n    transform: rotateY(-30deg); }\r\n  75% {\r\n    -webkit-transform: rotateY( 30deg);\r\n    -moz-transform: rotateY( 30deg);\r\n    transform: rotateY( 30deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ( 20deg);\r\n    -moz-transform: rotateZ( 20deg);\r\n    transform: rotateZ( 20deg); } }\r\n@-webkit-keyframes wave {\r\n  0% {\r\n    -webkit-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    -moz-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    -moz-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg); } }\r\n@-moz-keyframes wave {\r\n  0% {\r\n    -webkit-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    -moz-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    -moz-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg); } }\r\n@-ms-keyframes wave {\r\n  0% {\r\n    -webkit-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    -moz-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    -moz-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg); } }\r\n@keyframes wave {\r\n  0% {\r\n    -webkit-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    -moz-transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg);\r\n    transform: rotateZ(0deg) translate3d(0,10%,0) rotateZ(0deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    -moz-transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg);\r\n    transform: rotateZ(360deg) translate3d(0,10%,0) rotateZ(-360deg); } }\r\n@-webkit-keyframes lighthouse {\r\n  0% {\r\n    -webkit-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    -moz-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    transform: translate3d(15%,0,0) rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    -moz-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    transform: translate3d(-15%,0,0) rotateZ(-10deg); } }\r\n@-moz-keyframes lighthouse {\r\n  0% {\r\n    -webkit-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    -moz-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    transform: translate3d(15%,0,0) rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    -moz-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    transform: translate3d(-15%,0,0) rotateZ(-10deg); } }\r\n@-ms-keyframes lighthouse {\r\n  0% {\r\n    -webkit-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    -moz-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    transform: translate3d(15%,0,0) rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    -moz-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    transform: translate3d(-15%,0,0) rotateZ(-10deg); } }\r\n@keyframes lighthouse {\r\n  0% {\r\n    -webkit-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    -moz-transform: translate3d(15%,0,0) rotateZ(10deg);\r\n    transform: translate3d(15%,0,0) rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    -moz-transform: translate3d(-15%,0,0) rotateZ(-10deg);\r\n    transform: translate3d(-15%,0,0) rotateZ(-10deg); } }\r\n@-webkit-keyframes swing {\r\n  0% {\r\n    -webkit-transform: rotateZ(10deg);\r\n    -moz-transform: rotateZ(10deg);\r\n    transform: rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(-10deg);\r\n    -moz-transform: rotateZ(-10deg);\r\n    transform: rotateZ(-10deg); } }\r\n@-moz-keyframes swing {\r\n  0% {\r\n    -webkit-transform: rotateZ(10deg);\r\n    -moz-transform: rotateZ(10deg);\r\n    transform: rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(-10deg);\r\n    -moz-transform: rotateZ(-10deg);\r\n    transform: rotateZ(-10deg); } }\r\n@-ms-keyframes swing {\r\n  0% {\r\n    -webkit-transform: rotateZ(10deg);\r\n    -moz-transform: rotateZ(10deg);\r\n    transform: rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(-10deg);\r\n    -moz-transform: rotateZ(-10deg);\r\n    transform: rotateZ(-10deg); } }\r\n@keyframes swing {\r\n  0% {\r\n    -webkit-transform: rotateZ(10deg);\r\n    -moz-transform: rotateZ(10deg);\r\n    transform: rotateZ(10deg); }\r\n  100% {\r\n    -webkit-transform: rotateZ(-10deg);\r\n    -moz-transform: rotateZ(-10deg);\r\n    transform: rotateZ(-10deg); } }\r\n\r\n/* ----------------------------------------------------\r\n    End Animation\r\n---------------------------------------------------- */","/* ----------------------------------------------------\r\n    Breadcurmb Area\r\n---------------------------------------------------- */\r\n.ltn__breadcrumb-area {\r\n    height: 600px;\r\n    background-color: var(--section-bg-1);\r\n    margin-bottom: 120px;\r\n    padding-top: 300px;\r\n    padding-bottom: 110px;\r\n}\r\n.ltn__breadcrumb-list ul {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.ltn__breadcrumb-list ul li {\r\n    display: inline-block;\r\n    margin-right: 30px;\r\n    position: relative;\r\n    font-weight: 700;\r\n}\r\n.ltn__breadcrumb-list ul li:last-child {\r\n    margin-right: 0;\r\n    color: var(--ltn__primary-color);\r\n}\r\n.ltn__breadcrumb-list ul li:after {\r\n    position: absolute;\r\n    content: \"\\f054\";\r\n    font-family: 'Font Awesome\\ 5 Free';\r\n    font-weight: 900;\r\n    font-size: 10px;\r\n    right: -20px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n.ltn__breadcrumb-list ul li:last-child:after {\r\n    display: none;\r\n}\r\n\r\n/* breadcrumb-area-2 */\r\n.ltn__breadcrumb-area-2 {\r\n    padding-top: 250px;\r\n    padding-bottom: 130px;\r\n}\r\n.ltn__breadcrumb-inner-2 {\r\n    display: flex;\r\n    align-items: center;\r\n    .section-title-area {\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn__section-title-2 .section-title {\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn__breadcrumb-list {\r\n        margin-left: 100px;\r\n    }\r\n    .ltn__breadcrumb-list ul li:after {\r\n        position: absolute;\r\n        content: \"\";\r\n        right: -20px;\r\n        top: 50%;\r\n        -webkit-transform: translateY(-50%);\r\n        -ms-transform: translateY(-50%);\r\n        transform: translateY(-50%);\r\n        height: 10px;\r\n        width: 2px;\r\n        background-color: var(--ltn__color-1);\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n.ltn__breadcrumb-color-white {\r\n    .ltn__breadcrumb-list {\r\n        li {\r\n            color: var(--ltn__color-1);\r\n            &:last-child {\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* breadcrumb-area-3 */\r\n.ltn__breadcrumb-area-3 {\r\n    padding-top: 350px;\r\n    padding-bottom: 130px;\r\n}\r\n\r\n/* breadcrumb-area-4 */\r\n.ltn__breadcrumb-inner-4 {\r\n    .section-title-area {\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn__breadcrumb-list ul li:last-child {\r\n        opacity: 0.5;\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Responsive\r\n---------------------------------------------------- */\r\n@media (max-width: 767px) {\r\n    .ltn__breadcrumb-area-2 {\r\n        padding-top: 240px;\r\n        padding-bottom: 80px;\r\n    }\r\n    .ltn__breadcrumb-inner-2 {\r\n        flex-flow: column;\r\n        text-align: center;\r\n        .ltn__breadcrumb-list {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n    .ltn__breadcrumb-list {\r\n        ul {\r\n            li {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","/* ============================================================\r\n>>> TABLE OF CONTENTS:\r\n===============================================================\r\n# Widgets\r\n# Search Widget\r\n# Newsletter Widget\r\n# Tag Cloud Widget\r\n# Color Widget\r\n# Menu Widget\r\n# Popular Post Widget\r\n# Banner Widget\r\n# Top Rated Product Widget\r\n# Price Filter Widget\r\n# Instagram Widget\r\n# Video Widget\r\n# Author Widget\r\n# Widget Responsive\r\n\r\n============================================================= */\r\n\r\n/* --------------------------------------------------------------\r\n    Widgets\r\n-------------------------------------------------------------- */\r\n.widget {\r\n    margin-bottom: 40px;\r\n    padding: 35px 30px 40px 35px;\r\n    border: 2px solid var(--border-color-11);\r\n    &:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n    hr {\r\n        margin-top: 35px;\r\n        margin-bottom: 35px;\r\n    }\r\n}\r\n.ltn__widget-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin-bottom: 25px;\r\n    text-transform: capitalize;\r\n}\r\n.ltn__widget-title-border {\r\n    position: relative;\r\n    padding-left: 45px;\r\n    &::after,\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        background-color: var(--ltn__secondary-color);\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 0;\r\n    }\r\n    &::before {\r\n        width: 18px;\r\n        height: 4px;\r\n        border-radius: 25px;\r\n    }\r\n    &::after {\r\n        width: 4px;\r\n        height: 4px;\r\n        left: 22px;\r\n        border-radius: 100%;\r\n    }\r\n}\r\n.ltn__widget-title-border-2 {\r\n    border-left: 2px solid;\r\n    border-color: var(--ltn__secondary-color);\r\n    padding-left: 10px;\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        width: 2px;\r\n        height: 14px;\r\n        background-color: var(--ltn__secondary-color);\r\n        display: none;\r\n    }\r\n}\r\n/* widget-2 */\r\n.widget-2 {\r\n    margin-bottom: 40px;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Search Widget\r\n---------------------------------------------------- */\r\n.ltn__search-widget form {\r\n    position: relative;\r\n}\r\n.ltn__search-widget input[type=\"text\"] {\r\n    margin-bottom: 0;\r\n    padding-right: 65px;\r\n    padding-left: 20px;\r\n    height: 60px;\r\n    background-color: var(--section-bg-1);\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n}\r\n.ltn__search-widget input[type=\"text\"]::-webkit-input-placeholder {\r\n    color: var(--ltn__primary-color);\r\n    font-size: 12px;\r\n}\r\n.ltn__search-widget button {\r\n    position: absolute;\r\n    right: 0;\r\n    height: 100%;\r\n    padding: 0 20px;\r\n    color: var(--white);\r\n    border: 1px solid;\r\n    background-color: var(--ltn__secondary-color);\r\n    border-color: var(--ltn__secondary-color);\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.ltn__search-widget button:hover {\r\n    color: var(--white);\r\n    background-color: var(--ltn__primary-color);\r\n    border-color: var(--ltn__primary-color);\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Newsletter Widget\r\n---------------------------------------------------- */\r\n.ltn__newsletter-widget {\r\n    background-color: var(--ltn__primary-color);\r\n    padding: 50px 35px;\r\n    position: relative;\r\n    z-index: 2;\r\n    h6 {\r\n        color: var(--ltn__secondary-color);\r\n        margin-bottom: 5px;\r\n    }\r\n    h4 {\r\n        color: var(--white);\r\n        font-size: 36px;\r\n    }\r\n    input[type=\"text\"] {\r\n        background-color: #133236;\r\n        color: var(--white);\r\n        border-color: #133236;\r\n        height: 70px;\r\n        padding-left: 25px;\r\n        padding-right: 70px;\r\n    }\r\n    input[type=\"text\"]::placeholder {\r\n            color: var(--white);\r\n    }\r\n    button {\r\n        background-color: var(--ltn__secondary-color);\r\n        border-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n        padding: 0 25px;\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color-2);\r\n            border-color: var(--ltn__secondary-color-2);\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n.ltn__newsletter-bg-icon {\r\n    position: absolute;\r\n   \r\n    right: 20px;\r\n    top: 15%;\r\n    font-size: 120px;\r\n    color: var(--ltn__color-1);\r\n    opacity: 0.1;\r\n    z-index: -1;\r\n    line-height: 1;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Tag Cloud Widget\r\n---------------------------------------------------- */\r\n.ltn__tagcloud-widget {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin: 5px 3px;\r\n            a {\r\n                display: block;\r\n                padding: 8px 24px 6px;\r\n                font-size: 13px;\r\n                text-transform: uppercase;\r\n                background-color: var(--section-bg-1);\r\n                font-weight: 700;\r\n                font-family: var(--ltn__heading-font);\r\n                &:hover {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Color Widget\r\n---------------------------------------------------- */\r\n.ltn__color-widget {\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-top: 3px;\r\n            margin-right: 5px;\r\n            background-color: var(--section-bg-1);\r\n            border: 1px solid var(--border-color-1);\r\n            a {\r\n                width: 40px;\r\n                height: 22px;\r\n                display: block;\r\n            }\r\n            &:hover {\r\n                outline: 2px solid var(--ltn__secondary-color);\r\n                outline-offset: 1px;\r\n            }\r\n        }\r\n        .black {\r\n            background-color: var(--black);\r\n        }\r\n        .white {\r\n            background-color: var(--white);\r\n        }\r\n        .red {\r\n            background-color: var(--red);\r\n        }\r\n        .silver {\r\n            background-color: var(--silver);\r\n        }\r\n        .gray {\r\n            background-color: var(--gray);\r\n        }\r\n        .maroon {\r\n            background-color: var(--maroon);\r\n        }\r\n        .yellow {\r\n            background-color: var(--yellow);\r\n        }\r\n        .olive {\r\n            background-color: var(--olive);\r\n        }\r\n        .lime {\r\n            background-color: var(--lime);\r\n        }\r\n        .green {\r\n            background-color: var(--green);\r\n        }\r\n        .aqua {\r\n            background-color: var(--aqua);\r\n        }\r\n        .teal {\r\n            background-color: var(--teal);\r\n        }\r\n        .blue {\r\n            background-color: var(--blue);\r\n        }\r\n        .navy {\r\n            background-color: var(--navy);\r\n        }\r\n        .fuchsia {\r\n            background-color: var(--fuchsia);\r\n        }\r\n        .purple {\r\n            background-color: var(--purple);\r\n        }\r\n        .pink {\r\n            background-color: var(--pink);\r\n        }\r\n        .nude {\r\n            background-color: var(--nude);\r\n        }\r\n        .orange {\r\n            background-color: var(--orange);\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Menu Widget\r\n---------------------------------------------------- */\r\n.ltn__menu-widget {\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n            margin-top: 15px;\r\n            display: block;\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n            a {\r\n                display: block;\r\n                font-size: 14px;\r\n                font-weight: 700;\r\n                span {\r\n                    float: right;\r\n                    color: var(--ltn__color-5);\r\n                }\r\n            }\r\n            span {\r\n                float: right;\r\n                color: var(--ltn__color-5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.care_bullets li {\r\n  list-style: none;\r\n  position: relative;\r\n  padding: 2px 0 2px 25px;\r\n  color: #fff !important;\r\n}\r\n\r\n.care_bullets li::before {\r\n  content: '*';\r\n  position: absolute;\r\n  top: 6px;\r\n  left: 0;\r\n}\r\n\r\n.care_bullets-2 li {\r\n  list-style: none;\r\n  position: relative;\r\n  padding: 2px 0 2px 25px;\r\n \r\n}\r\n\r\n.care_bullets-2 li::before {\r\n  content: '*';\r\n  position: absolute;\r\n  top: 6px;\r\n  left: 0;\r\n}\r\n\r\n.job_bullets li {\r\n  list-style: none;\r\n  position: relative;\r\n  padding: 2px 0 2px 25px;\r\n \r\n}\r\n\r\n.job_bullets li::before {\r\n  content: '';\r\n \r\n  top: 6px;\r\n  left: 0;\r\n}\r\n\r\n.job-box{\r\n  background-color: #e2e2e2;\r\n  /*box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);*/\r\n  border-radius: 15px;\r\n}\r\n \r\n\r\n/* menu-widget-2 */\r\n.ltn__menu-widget-2 {\r\n    background-color: transparent;\r\n    ul {\r\n        li {\r\n            a {\r\n                background-color: var(--section-bg-1);\r\n                padding: 20px 10px 20px 30px;\r\n                span {\r\n                    background-color: var(--white);\r\n                    color: var(--ltn__primary-color);\r\n                    position: relative;\r\n                    top: -11px;\r\n                    width: 50px;\r\n                    height: 50px;\r\n                    line-height: 50px;\r\n                    text-align: center;\r\n                    transition: all 0.3s ease 0s;\r\n                }\r\n            }\r\n            &.active,\r\n            &:hover > {\r\n                a {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    color: var(--white);\r\n                    span {\r\n                        background-color: var(--ltn__secondary-color-2);\r\n                        color: var(--white);\r\n                        &:hover {\r\n                            background-color: var(--ltn__primary-color);\r\n                            color: var(--white);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    & > ul {\r\n        & > li {\r\n            &:first-child {\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n    &.ltn__menu-widget-2-color-2 {\r\n        ul {\r\n            li {\r\n                a {\r\n                    background-color: var(--ltn__primary-color);\r\n                    color: var(--white);\r\n                    span {\r\n                        background-color: var(--ltn__primary-color-2);\r\n                        color: var(--white);\r\n                    }\r\n                }\r\n                &.active,\r\n                &:hover > {\r\n                    a {\r\n                        background-color: var(--ltn__secondary-color);\r\n                        color: var(--white);\r\n                        span {\r\n                            background-color: var(--ltn__secondary-color-2);\r\n                            color: var(--white);\r\n                            &:hover {\r\n                                background-color: var(--ltn__primary-color);\r\n                                color: var(--white);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Popular Post Widget\r\n---------------------------------------------------- */\r\n.ltn__popular-post-widget { \r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n        }\r\n    }\r\n}\r\n.ltn__popular-post-widget > ul > li {\r\n    margin-bottom: 30px;\r\n    border-bottom: 1px solid var(--border-color-1);\r\n    padding-bottom: 30px;\r\n}\r\n.ltn__popular-post-widget > ul > li:last-child {\r\n    margin-bottom: 0;\r\n    border-bottom: 0;\r\n    padding-bottom: 0px;\r\n}\r\n.popular-post-widget-img {\r\n    float: left;\r\n    margin-right: 20px;\r\n    img {\r\n        max-width: 80px;\r\n    }\r\n}\r\n.popular-post-widget-brief {\r\n    overflow: hidden;\r\n    h6 {\r\n        margin-bottom: 5px;\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n    }\r\n    .ltn__blog-meta {\r\n        margin-bottom: 0;\r\n        li {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__twitter-post-widget {\r\n    .popular-post-widget-img {\r\n        float: left;\r\n        margin-right: 20px;\r\n        img {\r\n            max-width: 60px;\r\n            border-radius: 100%;\r\n        }\r\n        a {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .popular-post-widget-brief {\r\n        p {\r\n           margin-bottom: 5px;\r\n            a {\r\n                color: var(--ltn__secondary-color);\r\n            } \r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Banner Widget\r\n---------------------------------------------------- */\r\n.ltn__banner-widget {\r\n    padding: 0 !important;\r\n    border: 0;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Top Rated Product Widget\r\n---------------------------------------------------- */\r\n.ltn__top-rated-product-widget {\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n        }\r\n    }\r\n} \r\n.ltn__top-rated-product-widget > ul > li {\r\n    margin-bottom: 25px;\r\n    padding-bottom: 25px;\r\n    border-bottom: 1px solid;\r\n    border-color: var(--white-4);\r\n}\r\n.ltn__top-rated-product-widget > ul > li:last-child {\r\n    margin-bottom: 0;\r\n    padding-bottom: 0;\r\n    border-bottom: 0;\r\n}\r\n.top-rated-product-img {\r\n    max-width: 90px;\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\n.top-rated-product-info {\r\n    overflow: hidden;\r\n    h6 {\r\n        margin-bottom: 3px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n    }\r\n    .product-ratting {\r\n        margin-bottom: 0;\r\n        li {\r\n            font-size: 10px;\r\n        }\r\n    }\r\n    .product-price {\r\n        margin-bottom: 0;\r\n        font-size: 14px;\r\n        color: var(--ltn__secondary-color);\r\n        font-weight: 700;\r\n    }\r\n    .product-ratting ul {\r\n        line-height: 1;\r\n        margin-bottom: 5px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Popular Product Widget\r\n---------------------------------------------------- */\r\n.ltn__popular-product-widget {\r\n    .ltn__product-item {\r\n        margin-bottom: 30px;\r\n        .product-info {\r\n            padding: 25px 25px 1px;\r\n        }\r\n        .product-title {\r\n            font-size: 16px;\r\n        }\r\n        .product-img-location ul li,\r\n        .ltn__plot-brief li {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    .slick-dots {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Price Filter Widget\r\n---------------------------------------------------- */\r\n.price_filter {\r\n  padding-bottom: 13px;\r\n}\r\n.price_slider_amount {\r\n  overflow: hidden;\r\n}\r\n.price_slider_amount > input[type=\"text\"],\r\n.price_slider_amount > input[type=\"submit\"] {\r\n  background: transparent none repeat scroll 0 0;\r\n  border: medium none;\r\n  box-shadow: none;\r\n  float: left;\r\n  height: 25px;\r\n  padding: 0;\r\n  text-align: left;\r\n  width: 140px;\r\n  margin-bottom: 20px;\r\n}\r\n.price_slider_amount > input[type=\"text\"] {\r\n  font-weight: 700;\r\n}\r\n.price_filter .ui-widget-content {\r\n  background-color: var(--ltn__primary-color);\r\n  border: medium none;\r\n  color: #222;\r\n  height: 3px;\r\n  width: 98%;\r\n  background-image: none;\r\n}\r\n.price_filter .ui-slider .ui-slider-range {\r\n  background-color: var(--ltn__secondary-color);\r\n  background-image: none;\r\n}\r\n.price_filter .ui-state-default, \r\n.price_filter .ui-widget-content .ui-state-default, \r\n.price_filter .ui-widget-header .ui-state-default {\r\n    background-color: var(--ltn__secondary-color);\r\n  border: medium none;\r\n  border-radius: 100%;\r\n  height: 12px;\r\n  margin-left: 0;\r\n  margin-top: -6px;\r\n  top: 50%;\r\n  width: 12px;\r\n  background-image: none;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Instagram Widget\r\n---------------------------------------------------- */\r\n.ltn__instafeed-grid {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n   .instagram_gallery {\r\n        display: -webkit-box;\r\n        display: -webkit-flex;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-flex-wrap: wrap;\r\n        -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n        width: 100%;\r\n        a,\r\n        .instagram-image {\r\n            display: block;\r\n            -webkit-box-flex: 1;\r\n            -webkit-flex: 1 0 16.6666%;\r\n            -ms-flex: 1 0 16.6666%;\r\n            flex: 1 0 16.6666%;\r\n            max-width: 16.6666%;\r\n        }\r\n    } \r\n} \r\n.ltn__instagram-widget {\r\n    .ltn__instafeed-grid {\r\n       .instagram_gallery {\r\n            a,\r\n            .instagram-image {\r\n                -webkit-flex: 0 0 33.333333%;\r\n                -ms-flex: 0 0 33.333333%;\r\n                flex: 0 0 33.333333%;\r\n                max-width: 33.333333%;\r\n            }\r\n        } \r\n    }  \r\n}\r\n.ltn__instafeed-slider {\r\n   .slick-list {\r\n        .slick-slide {\r\n            display: -webkit-box;\r\n            display: -webkit-flex;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n        }\r\n    } \r\n} \r\n\r\n.insta-slide-gutter {\r\n    .slick-list {\r\n        margin-right: -7.5px !important;\r\n        margin-left: -7.5px !important;\r\n        .slick-slide {\r\n            padding-right: 7.5px;\r\n            padding-left: 7.5px;\r\n        }\r\n    }\r\n}\r\n.insta-grid-gutter {\r\n    .instagram_gallery {\r\n        margin-right: -7.5px !important;\r\n        margin-left: -7.5px !important;\r\n        a,\r\n        .instagram-image {\r\n            padding-right: 7.5px;\r\n            padding-left: 7.5px;\r\n            margin: 7px 0;\r\n        }\r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Video Widget\r\n---------------------------------------------------- */\r\n.ltn__video-icon-1 {\r\n    background-color: transparent;\r\n    color: var(--white);\r\n    height: 80px;\r\n    width: 80px;\r\n    border: 6px solid;\r\n    border-color: var(--white);\r\n    border-radius: 100%;\r\n    font-size: 22px;\r\n    z-index: 9;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    &:hover {\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.ltn__video-icon-2 {\r\n    height: 80px;\r\n    width: 80px;\r\n    background-color: var(--white);\r\n    color: var(--ltn__secondary-color);\r\n    font-size: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9;\r\n    border-radius: 100%;\r\n    i {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    &:hover {\r\n        &.ltn__video-icon-2-border {\r\n            outline: outset;\r\n        }\r\n    }\r\n    &.border-radius-no {\r\n        border-radius: 0;\r\n    }\r\n}\r\n.ltn__video-icon-2-border {\r\n    outline-offset: 15px;\r\n    outline: 4px solid var(--border-color-9);\r\n    margin: 20px;\r\n}\r\n.ltn__video-bg-img {\r\n    min-height: 350px;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-flow: column;\r\n    z-index: 99;\r\n}\r\n.ltn__video-img {\r\n    position: relative;\r\n    display: inline-block;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        opacity: 0.3;\r\n        background-color: var(--ltn__primary-color);\r\n    }\r\n    img {\r\n        margin: 0;\r\n    }\r\n    .ltn__video-icon-1,\r\n    .ltn__video-icon-2 {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        margin: auto;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n    }\r\n}\r\n.ltn__video-info {\r\n    position: relative;\r\n}\r\n.ltn__video-popup-height-300 {\r\n    height: 300px;\r\n}\r\n.ltn__video-popup-height-400 {\r\n    height: 400px;\r\n}\r\n.ltn__video-popup-height-500 {\r\n    height: 500px;\r\n}\r\n.ltn__video-popup-height-600 {\r\n    height: 600px;\r\n}\r\n.text-center {\r\n    .slide-video {\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n}\r\n.ltn__secondary-bg {\r\n    &.ltn__video-icon-2 {\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n    &.ltn__video-icon-2 i {\r\n        color: var(--white);\r\n    }\r\n}\r\n.ltn__video-icon-2-small {\r\n    height: 60px;\r\n    width: 60px;\r\n    font-size: 16px;\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    .ltn__video-popup-height-500,\r\n    .ltn__video-popup-height-600 {\r\n        height: 450px;\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__video-icon-2 {\r\n        height: 50px;\r\n        width: 50px;\r\n        font-size: 18px;\r\n    }\r\n    .ltn__video-popup-height-500,\r\n    .ltn__video-popup-height-600 {\r\n        height: initial;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__video-bg-img {\r\n        min-height: 320px;\r\n        &.ml-30 {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n    .ltn__video-img,\r\n    .ltn__video-bg-img {\r\n        &.ml-30 {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Author Widget\r\n---------------------------------------------------- */\r\n.ltn__author-widget-inner {\r\n    img {\r\n        margin-bottom: 25px;\r\n        max-width: 140px;\r\n        border-radius: 100%;\r\n    }\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n    .ltn__social-media ul li {\r\n        color: var(--ltn__color-1);\r\n    }\r\n}\r\n\r\n.ltn__author-widget-2 {\r\n    .ltn__author-widget-inner {\r\n        img {\r\n            margin-bottom: 25px;\r\n            max-width: 100%;\r\n            border-radius: inherit;\r\n        }\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Footer About Widget\r\n---------------------------------------------------- */\r\n@media (min-width: 992px) {\r\n    .footer-about-widget {\r\n        padding-right: 35px;\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Widget Responsive\r\n---------------------------------------------------- */\r\n@media (max-width: 1199px) {\r\n    .widget {\r\n        padding: 35px 20px 40px 20px;\r\n    }\r\n    .top-rated-product-img {\r\n        max-width: 70px;\r\n        margin-right: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .ltn__right-sidebar {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .car-price-filter-range .price_filter .ui-state-default:last-child::after {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","/* ============================================================\r\n>>> TABLE OF CONTENTS:\r\n===============================================================\r\n# Header\r\n# Header Top Area\r\n# Header Middle Area\r\n# Header Bottom Area\r\n# Header Feature Area\r\n# Main Menu\r\n# Header Options\r\n# Mini Cart\r\n# Header Searchbox\r\n# Currency Menu\r\n# Header Sticky\r\n# Utilize Mobile Menu\r\n\r\n============================================================= */\r\n\r\n/* --------------------------------------------------------------\r\n    Header\r\n-------------------------------------------------------------- */\r\n.ltn__header-area {\r\n    z-index: 9999;\r\n    position: relative;\r\n}\r\n/* ----------------------------------------------\r\n    Header Top Area\r\n---------------------------------------------- */\r\n.ltn__header-top-area {\r\n    border-bottom: 1px solid;\r\n    border-color: var(--border-color-3);\r\n    .ltn__social-media ul li {\r\n        font-size: 14px;\r\n        margin: 0 10px 0 0;\r\n    }\r\n}\r\n.top-area-color-dark-blue {\r\n  background-color: #21485e;\r\n  p,\r\n  a,\r\n  li,\r\n  .welcome p,\r\n  .welcome a,\r\n  .ltn__drop-menu > ul > li > a,\r\n  .ltn__drop-menu > ul > li:hover > a {\r\n      color: var(--white);\r\n  }\r\n}\r\n.top-area-color-white {\r\n    background-color: var(--ltn__primary-color);\r\n    p,\r\n    a,\r\n    li,\r\n    .welcome p,\r\n    .welcome a,\r\n    .ltn__drop-menu > ul > li > a,\r\n    .ltn__drop-menu > ul > li:hover > a {\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n.ltn__header-top-area .row {\r\n    align-items: center;\r\n}\r\n/* welcome */\r\n.welcome p {\r\n    margin-bottom: 0;\r\n    font-size: 14px;\r\n    line-height: 40px;\r\n}\r\n.ltn__top-bar-menu {\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        & > li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin: 0 30px 0 0;\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            & > i, & > a > i {\r\n                margin-right: 3px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n    .ltn__currency-menu {\r\n        .active-currency {\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.header-top-btn {\r\n    display: inline-block;\r\n    a {\r\n        display: inline-block;\r\n        padding: 0 20px;\r\n        line-height: 40px;\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color-2);\r\n        }\r\n    }\r\n}\r\n/* ----------------------------------------------\r\n    Header Middle Area\r\n---------------------------------------------- */\r\n.ltn__header-middle-area {\r\n    z-index: 999; \r\n}\r\n.ltn__header-middle-area > .container-fluid > .row,\r\n.ltn__header-middle-area > .container > .row {\r\n    -webkit-box-pack: justify;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    position: relative; \r\n}\r\n\r\n.ltn__header-middle-area > .container-fluid > .row > .col,\r\n.ltn__header-middle-area > .container > .row > .col {\r\n    -webkit-box-flex: 0;\r\n    -ms-flex-positive: 0;\r\n    flex-grow: 1;\r\n    position: static; \r\n\r\n}\r\n.site-logo {\r\n    min-width: 185px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: start;\r\n    \r\n    a {\r\n        color: var(--ltn__primary-color);\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n        letter-spacing: 1px;\r\n        display: contents;\r\n    }\r\n    i {\r\n        color: var(--ltn__secondary-color);\r\n        margin-right: 5px;\r\n        font-size: 24px;\r\n        position: relative;\r\n        top: -2px;\r\n    }\r\n}\r\n\r\n.ltn__header-1 {\r\n    .ltn__header-middle-area {\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n    }\r\n}\r\n/* ----------------------------------------------\r\n    Header Bottom Area (header-2)\r\n---------------------------------------------- */\r\n.header-bottom-area {\r\n    .row {\r\n        position: relative;\r\n        .col {\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n    }\r\n}\r\n.sticky-logo {\r\n    max-width: 200px;\r\n    align-self: center;\r\n    height: 100%;\r\n    float: left;\r\n    transition: all 0.3s ease 0s;\r\n    display: none;\r\n}\r\n.header-menu-2 {\r\n    text-align: center;\r\n    .ltn__main-menu > ul {\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------\r\n    Header Feature Area\r\n---------------------------------------------- */\r\n.header-feature-area {\r\n    display: flex;\r\n}\r\n.header-feature-item {\r\n    display: flex;\r\n    align-items: center;\r\n    white-space: nowrap;\r\n    margin-right: 50px;\r\n    max-width: 50%;\r\n    &:last-child {\r\n        margin-right: 0;\r\n    }\r\n    h6 {\r\n        margin-bottom: 0;\r\n        color: var(--ltn__body-color);\r\n        font-weight: 500;\r\n        text-transform: uppercase;\r\n        font-size: 14px;\r\n        line-height: 1;\r\n    }\r\n    p {\r\n        margin-bottom: 0;\r\n        font-size: 16px;\r\n        font-family: var(--ltn__heading-font);\r\n        line-height: 1.2;\r\n    }\r\n}\r\n.header-feature-icon {\r\n    margin-right: 10px;\r\n    font-size: 25px;\r\n    line-height: 1;\r\n    color: var(--ltn__heading-color);\r\n}\r\n\r\n/* ----------------------------------------------\r\n    Main Menu\r\n---------------------------------------------- */\r\n.header-menu-wrap,\r\n.header-menu-column {\r\n    position: inherit;\r\n}\r\n.ltn__main-menu ul {\r\n    margin-bottom: 0;\r\n}\r\n.ltn__main-menu > ul {\r\n    display: flex;\r\n    padding: 0;\r\n}\r\n.ltn__main-menu li {\r\n    list-style: none;\r\n    display: block;\r\n    margin-top: 0;\r\n}\r\n.ltn__main-menu li > a {\r\n    position: relative;\r\n}\r\n.ltn__main-menu > ul > li {\r\n    display: inline-block;\r\n    position: relative;\r\n    margin-right: 20px;\r\n}\r\n.ltn__main-menu > ul > li:last-child {\r\n    margin-right: 0px;\r\n}\r\n.ltn__main-menu > ul > li > a {\r\n    font-size: 16px;\r\n    padding: 20px 10px;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    color: var(--ltn__heading-color);\r\n    font-weight: 600;\r\n    font-family: var(--ltn__body-font);\r\n}\r\n.ltn__main-menu li:hover > a {\r\n    color: var(--ltn__secondary-color);\r\n}\r\n/* Submenu */\r\n.ltn__main-menu li > ul,\r\n.ltn__main-menu .sub-menu {\r\n    position: absolute;\r\n    margin: 0;\r\n    top: 130%;\r\n    transition: opacity .2s ease .1s,visibility .2s ease .1s,top .2s ease .1s;\r\n    min-width: 230px;\r\n    padding: 15px 0;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    background-color: #fff;\r\n    left: inherit;\r\n    right: inherit;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    text-align: left;\r\n    z-index: 999;\r\n    border-top: 5px solid var(--ltn__secondary-color);\r\n}\r\n.ltn__main-menu li ul li,\r\n.ltn__main-menu .sub-menu li {\r\n    line-height: 1.3;\r\n    padding: 12px 25px 12px 30px;\r\n    font-size: 16px;\r\n}\r\n.mega-menu li ul {\r\n    border-top: 0;\r\n}\r\n.mega-menu li ul li {\r\n    padding-left: 10px;\r\n    padding-right: 0;\r\n}\r\n.ltn__main-menu li:hover > ul,\r\n.ltn__main-menu li:hover > .sub-menu {\r\n    top: 100%;\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n.ltn__main-menu li ul li > ul,\r\n.ltn__main-menu .sub-menu li > .sub-menu {\r\n    left: 100%;\r\n}\r\n.ltn__main-menu li ul li:hover > ul,\r\n.ltn__main-menu .sub-menu li:hover > .sub-menu {\r\n    top: 0;\r\n}\r\n.ltn__main-menu li ul li,\r\n.ltn__main-menu .sub-menu li {\r\n    position: relative;\r\n}\r\n.ltn__main-menu > ul > li:last-child ul li > ul,\r\n.ltn__main-menu > ul > li:last-child .sub-menu li > .sub-menu,\r\n.ltn__main-menu > ul > li:nth-last-child(2) ul li > ul,\r\n.ltn__main-menu > ul > li:nth-last-child(2) .sub-menu li > .sub-menu,\r\n.ltn__main-menu > ul > li:nth-last-child(3) ul li > ul,\r\n.ltn__main-menu > ul > li:nth-last-child(3) .sub-menu li > .sub-menu {\r\n    left: auto;\r\n    right: 100%;\r\n}\r\n.ltn__main-menu li > ul.ltn__sub-menu-col-2, \r\n.ltn__main-menu .sub-menu.ltn__sub-menu-col-2,\r\n.ltn__main-menu li > ul.ltn__sub-menu-col-3, \r\n.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 {\r\n    width: 510px;\r\n    & > li {\r\n        width: 50%;\r\n        float: left;\r\n        padding: 12px 20px 12px 25px;\r\n        & > a {\r\n            padding: 12px 20px 12px 20px;\r\n            margin-left: 0;\r\n            border-bottom: 1px dashed #ddd;\r\n            display: block;\r\n            font-weight: 600;\r\n            background-color: var(--section-bg-1);\r\n        }\r\n    }\r\n    .sub-menu-child {\r\n        position: inherit;\r\n        float: left;\r\n        width: 100%;\r\n        left: inherit;\r\n        box-shadow: none;\r\n        border: none;\r\n        z-index: inherit;\r\n        li {\r\n            padding: 12px 20px 12px 20px;\r\n            transition: all 0.3s ease 0s;\r\n            position: relative;\r\n            img {\r\n                position: absolute;\r\n                bottom: -20px;\r\n                left: 50%;\r\n                width: 150px;\r\n                height: auto;\r\n                opacity: 0;\r\n                visibility: hidden;\r\n                box-shadow: var(--ltn__box-shadow-3);\r\n                z-index: 999;\r\n                transition: all 0.3s ease 0s;\r\n            }\r\n            &:hover {\r\n                img {\r\n                    bottom: -10px;\r\n                    visibility: visible;\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__main-menu li > ul.ltn__sub-menu-col-3, \r\n.ltn__main-menu .sub-menu.ltn__sub-menu-col-3 {\r\n    width: 780px;\r\n    & > li {\r\n        width: 33.33%;\r\n    }\r\n}\r\n.ltn__main-menu li:hover > ul.ltn__sub-menu-col-2,\r\n.ltn__main-menu li:hover > .sub-menu.ltn__sub-menu-col-2 {\r\n    .sub-menu-child {\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n\r\n}\r\n\r\n.menu-pages-img-show {\r\n    li {\r\n        transition: all 0.3s ease 0s;\r\n        position: relative;\r\n        img {\r\n            position: absolute;\r\n            bottom: -20px;\r\n            left: 50%;\r\n            width: 130px;\r\n            height: auto;\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            box-shadow: var(--ltn__box-shadow-3);\r\n            z-index: 999;\r\n            transition: all 0.3s ease 0s;\r\n        }\r\n        &:hover {\r\n            img {\r\n                bottom: -10px;\r\n                visibility: visible;\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* Menu Reverse */\r\n.ltn__main-menu > ul > li:last-child,\r\n.ltn__main-menu > ul > li:nth-last-child(2) {\r\n    position: relative;\r\n}\r\n.ltn__main-menu > ul > li:last-child > ul,\r\n.ltn__main-menu > ul > li:last-child > .sub-menu,\r\n.ltn__main-menu > ul > li:nth-last-child(2) > ul,\r\n.ltn__main-menu > ul > li:nth-last-child(2) > .sub-menu {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n\r\n/* Mega Menu */\r\n.ltn__main-menu .mega-menu {\r\n    left: 0;\r\n    right: auto;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n.mega-menu > li {\r\n    float: left;\r\n    padding-bottom: 0 !important;\r\n    min-width: 250px !important;\r\n}\r\n.mega-menu > li {\r\n    min-width: 220px;\r\n}\r\n.ltn__main-menu li ul.mega-menu {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n}\r\n.ltn__main-menu li:hover ul.mega-menu {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    -webkit-transform: scaley(1);\r\n    transform: scaley(1);\r\n}\r\n.mega-menu li ul,\r\n.mega-menu li .sub-menu {\r\n    left: 0% !important;\r\n    box-shadow: none;\r\n    position: inherit;\r\n}\r\n/* .ltn__main-menu li:hover .mega-menu li ul */\r\n.ltn__main-menu li .mega-menu > li > ul, \r\n.ltn__main-menu li .mega-menu .sub-menu {\r\n    top: 0;\r\n}\r\n.ltn__main-menu li:hover .mega-menu > li > ul,\r\n.ltn__main-menu li:hover .mega-menu .sub-menu {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n.mega-menu > li > a {\r\n    margin-left: 0;\r\n    border-bottom: 1px dashed #ddd;\r\n    display: block;\r\n    font-weight: 600;\r\n    padding: 10px;\r\n    background-color: var(--section-bg-1);\r\n}\r\n.mega-menu.column-1,\r\n.mega-menu.column-2 {\r\n    left: auto;\r\n}\r\n.mega-menu.column-2 > li {\r\n    min-width: 50%;\r\n    width: 50%;\r\n}\r\n.mega-menu.column-3 > li {\r\n    min-width: 33.33%;\r\n    width: 33.33%;\r\n}\r\n@media (min-width: 991px) {\r\n    .mega-menu.column-4 > li,\r\n    .mega-menu.column-5 > li,\r\n    .mega-menu.column-6 > li,\r\n    .mega-menu.column-7 > li,\r\n    .mega-menu.column-8 > li,\r\n    .mega-menu.column-9 > li,\r\n    .mega-menu.column-10 > li,\r\n    .mega-menu.column-11 > li,\r\n    .mega-menu.column-12 > li {\r\n        min-width: 25%;\r\n        width: 25%;\r\n    }\r\n\r\n}\r\n@media (max-width: 991px) {\r\n    .mega-menu.column-2 > li,\r\n    .mega-menu.column-3 > li,\r\n    .mega-menu.column-4 > li,\r\n    .mega-menu.column-5 > li,\r\n    .mega-menu.column-6 > li,\r\n    .mega-menu.column-7 > li,\r\n    .mega-menu.column-8 > li,\r\n    .mega-menu.column-9 > li,\r\n    .mega-menu.column-10 > li,\r\n    .mega-menu.column-11 > li,\r\n    .mega-menu.column-12 > li {\r\n        min-width: 50%;\r\n        width: 50%;\r\n    }\r\n\r\n}\r\n@media (max-width: 767px) {\r\n    .mega-menu.column-2 > li,\r\n    .mega-menu.column-3 > li,\r\n    .mega-menu.column-4 > li,\r\n    .mega-menu.column-5 > li,\r\n    .mega-menu.column-6 > li,\r\n    .mega-menu.column-7 > li,\r\n    .mega-menu.column-8 > li,\r\n    .mega-menu.column-9 > li,\r\n    .mega-menu.column-10 > li,\r\n    .mega-menu.column-11 > li,\r\n    .mega-menu.column-12 > li {\r\n        min-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n}\r\n\r\n/* Mega menu submenu submenu */\r\n.mega-menu li ul li ul {\r\n    left: 100% !important;\r\n    position: absolute;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n}\r\n.mega-menu li ul li:hover > ul {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n@media (min-width: 991px) {\r\n    .mega-menu-parent {\r\n        position: inherit !important;\r\n    }\r\n}\r\n\r\n/* Menu Icon */\r\n.menu-icon {\r\n    & > a {\r\n        position: relative;\r\n        &::before {\r\n            content: \"\\f067\";\r\n            font-size: 8px;\r\n            position: absolute;\r\n            top: 50%;\r\n            right: 0;\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n            font-family: 'Font Awesome\\ 5 Free';\r\n            font-weight: 900;\r\n        }\r\n    }\r\n} \r\n\r\n/* Menu Item Badge */\r\n.menu-item-badge {\r\n    position: absolute;\r\n    left: -8px;\r\n    top: -10px;\r\n    font-size: 10px;\r\n    padding: 1px 3px 0px;\r\n    background-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n    border-radius: 2px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n/* Menu Porduct Item */\r\n.menu-product-item {\r\n    margin-bottom: 30px;\r\n    margin-top: 15px;\r\n    border: 2px solid;\r\n    border-color: var(--border-color-8);\r\n    transition: all 0.3s ease 0s;\r\n    text-align: center;\r\n    .product-info {\r\n        padding: 25px 15px 15px;\r\n        padding-top: 0;\r\n    }\r\n    .product-title {\r\n        font-size: 16px;\r\n        margin-bottom: 5px;\r\n    }\r\n    .product-price {\r\n        font-size: 16px;\r\n        color: var(--ltn__secondary-color);\r\n        font-weight: 600;\r\n        del {\r\n            font-size: 15px;\r\n            opacity: 0.5;\r\n            color: var(--gray);\r\n        }\r\n    }\r\n}\r\n.menu-product-item:hover {\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n}\r\n/* ----------------------------------------------\r\n    Header Options\r\n---------------------------------------------- */\r\n.ltn__header-options {\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        & > li {\r\n            display: inline-block;\r\n            margin-right: 15px;\r\n            margin-top: 0;\r\n            list-style: none;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__header-options {\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: end;\r\n    -ms-flex-pack: end;\r\n    justify-content: flex-end;\r\n    ul {\r\n        li {\r\n            list-style: none;\r\n        }\r\n    }\r\n    & > div {\r\n        margin-right: 20px;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n    .ltn__drop-menu > ul > li > a {\r\n        padding: 0;\r\n    }\r\n    .ltn__drop-menu ul {\r\n        padding: 0;\r\n        li {\r\n            ul {\r\n                padding: 10px 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__header-options-2 {\r\n    & > div {\r\n        margin-right: 10px;\r\n    }\r\n    .header-search-1,\r\n    .ltn__drop-menu > ul > li > a,\r\n    .mini-cart-icon a,\r\n    .header-wishlist {\r\n        height: 50px;\r\n        width: 50px;\r\n        line-height: 50px;\r\n        background: var(--white);\r\n        color: var(--ltn__heading-color);\r\n        text-align: center;\r\n        justify-content: center;\r\n        padding: 0;\r\n        transition: all 0.3s ease 0s;\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        &:hover {\r\n            background: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n    .header-search-1:hover,\r\n    .ltn__drop-menu > ul > li:hover > a,\r\n    .mini-cart-icon a:hover {\r\n        background: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n    .ltn__drop-menu.ltn__currency-menu > ul > li > a {\r\n        height: inherit;\r\n        width: inherit;\r\n        line-height: inherit;\r\n        background: inherit;\r\n        color: inherit;\r\n    }\r\n    .mobile-menu-toggle > a {\r\n        width: 50px;\r\n        height: 50px;\r\n        background: var(--white);\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n    }\r\n}\r\n\r\n/* ltn__drop-menu */\r\n.ltn__drop-menu {\r\n    display: inline-block;\r\n    text-align: left;\r\n}\r\n.ltn__drop-menu li {\r\n    margin-top: 0;\r\n}\r\n.ltn__drop-menu + .ltn__drop-menu {\r\n    margin-left: 10px;\r\n}\r\n.ltn__drop-menu ul {\r\n    margin-bottom: 0;\r\n    padding: 0;\r\n}\r\n.ltn__drop-menu > ul > li {\r\n    display: inline-block;\r\n    position: relative;\r\n    color: var(--ltn__heading-color);\r\n}\r\n.ltn__drop-menu > ul > li > a {\r\n    display: block;\r\n    text-decoration: none;\r\n    padding: 0 10px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n}\r\n.ltn__drop-menu ul li ul {\r\n    position: absolute;\r\n    min-width: 150px;\r\n    right: 0;\r\n    background-color: #fff;\r\n    z-index: 999;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    border-top: 1px solid #ececec;\r\n    top: 130%;\r\n    padding: 10px 0;\r\n    margin: 0;\r\n    transition: opacity .2s ease .1s,visibility .2s ease .1s,top .2s ease .1s;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n.ltn__drop-menu ul li ul li {\r\n    display: block;\r\n    padding: 5px 15px;\r\n    font-size: 16px;\r\n    color: var(--ltn__paragraph-color);\r\n    font-weight: 500;\r\n}\r\n.ltn__drop-menu ul li ul li a { color: inherit; }\r\n.ltn__drop-menu ul li:hover {\r\n    & > ul {\r\n        top: 100%;\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n    & > a {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n} \r\n\r\n.ltn__drop-menu > ul > li,\r\n.header-wishlist a {\r\n    font-size: 20px;\r\n}\r\n\r\n/* header-wishlist */\r\n.header-wishlist {\r\n    color: var(--ltn__heading-color);\r\n}\r\n\r\n/* ----------------------------------------------\r\n    Mini Cart\r\n---------------------------------------------- */\r\n.ltn__mini-cart ul {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.mini-cart-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    line-height: 30px;\r\n    cursor: pointer;\r\n    color: var(--ltn__heading-color);\r\n    i {\r\n        font-size: 18px;\r\n    }\r\n    sup {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n.mini-cart-header h5 {\r\n    margin-bottom: 0;\r\n}\r\n.mini-cart-product-area {\r\n    max-height: calc(100% - (60px + 245px));\r\n}\r\n.ltn__utilize-cart-menu {\r\n    .ltn__mini-cart {\r\n        max-height: calc(100% - (60px + 245px));\r\n    }\r\n}\r\n.mini-cart-item {\r\n    padding-top: 20px;\r\n    padding-left: 10px;\r\n    margin-bottom: 20px;\r\n    border-top: 1px solid var(--border-color-1);\r\n    &:first-child {\r\n        border-top: 0;\r\n    }\r\n}\r\n.mini-cart-img {\r\n    float: left;\r\n    width: 80px;\r\n    margin-right: 15px;\r\n    position: relative;\r\n}\r\n.mini-cart-img img {\r\n    background-color: var(--section-bg-1);\r\n}\r\n.mini-cart-info {\r\n    overflow: hidden;\r\n}\r\n.mini-cart-info h6 {\r\n    margin-bottom: 5px;\r\n    font-weight: 500;\r\n}\r\n.mini-cart-item-delete {\r\n    position: absolute;\r\n    left: -8px;\r\n    top: -8px;\r\n    height: 20px;\r\n    width: 20px;\r\n    border-radius: 100%;\r\n    display: block;\r\n    line-height: 20px;\r\n    background-color: #fff;\r\n    text-align: center;\r\n    font-size: 10px;\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    cursor: pointer;\r\n    transition: all 0.3s ease 0s;\r\n    &:hover {\r\n        background-color: var(--red);\r\n        color: #fff;\r\n    }\r\n}\r\n.mini-cart-footer {\r\n    margin-top: 25px;\r\n    p {\r\n        font-size: 14px;\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.mini-cart-sub-total {\r\n    border-top: 1px solid var(--border-color-1);\r\n    border-bottom: 1px solid var(--border-color-1);\r\n    padding: 20px 0;\r\n    h5 {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 0;\r\n    }\r\n    span {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n.mini-cart-footer .btn-wrapper {\r\n    margin-top: 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 25px 0 15px;\r\n}\r\n.mini-cart-footer .btn-wrapper .btn {\r\n    margin-bottom: 5px;\r\n    text-transform: uppercase;\r\n    font-size: 14px;\r\n}\r\n\r\n.mini-cart-icon-2 {\r\n    & > a {\r\n        display: flex;\r\n        align-items: center;\r\n        min-width: 125px;\r\n        .mini-cart-icon {\r\n            margin-right: 5px;\r\n            i {\r\n                color: var(--ltn__heading-color);\r\n                font-size: 20px;\r\n            }\r\n            sup {\r\n                font-size: 12px;\r\n                font-weight: 600;\r\n                height: 20px;\r\n                width: 20px;\r\n                line-height: 20px;\r\n                background-color: var(--ltn__secondary-color);\r\n                color: var(--white);\r\n                text-align: center;\r\n                border-radius: 100%;\r\n                right: 8px;\r\n                top: -8px;\r\n            }\r\n        }\r\n        h6 {\r\n            margin-bottom: 0;\r\n            display: flex;\r\n            -webkit-box-orient: vertical;\r\n            -webkit-box-direction: normal;\r\n            -ms-flex-flow: column;\r\n            flex-flow: column;\r\n            line-height: 20px;\r\n            font-weight: 700;\r\n            color: var(--ltn__body-color);\r\n            font-size: 14px;\r\n            text-transform: uppercase;\r\n        }\r\n    }\r\n    ul {\r\n        li {\r\n            list-style: none;\r\n        }\r\n    }\r\n}\r\n/* ----------------------------------------\r\n  Header Searchbox\r\n---------------------------------------- */\r\n.header-search-1 {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    .search-icon {\r\n        min-width: 25px;\r\n        text-align: center;\r\n        font-size: 16px;\r\n    }\r\n}\r\n.header-search-wrap {\r\n    position: relative;\r\n}\r\n.header-search-1-form {\r\n    background-color: var(--white);\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    height: 0;\r\n    margin-right: 0;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 130%;\r\n    transition-duration: 0.4s;\r\n    transition-property: height;\r\n    width: 320px;\r\n    z-index: 9999;\r\n    form {\r\n        position: relative;\r\n        margin: 15px 15px 0;\r\n    }\r\n    input {\r\n        height: 60px;\r\n        padding-right: 50px;\r\n    }\r\n    button[type=\"submit\"] {\r\n        background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\r\n        border: medium none;\r\n        color: var(--ltn__heading-color);\r\n        display: block;\r\n        font-size: 18px;\r\n        height: 60px;\r\n        line-height: 48px;\r\n        position: absolute;\r\n        right: 8px;\r\n        text-align: center;\r\n        top: 0;\r\n        padding: 1px 6px;\r\n        transition: all 0.3s ease 0s;\r\n        &:hover {\r\n            color: var(--ltn__primary-color);\r\n        }\r\n    }\r\n}\r\n.search-icon {\r\n    position: relative;\r\n    .for-search-close {\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 0;\r\n        right: 0;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }\r\n}\r\n.search-open {\r\n    &.header-search-1-form {\r\n        height: 90px;\r\n    }\r\n    .for-search-show {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }\r\n    .for-search-close {\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .header-search-wrap {\r\n        position: inherit;\r\n    }\r\n    .header-search-1-form {\r\n        top: 100%;\r\n    }\r\n    .header-search-1-form {\r\n        transform: translateX(50%);\r\n        right: 50%;\r\n    }\r\n}\r\n@media (max-width: 575px) {\r\n    .header-search-1-form {\r\n        width: 270px;\r\n    }\r\n}\r\n\r\n/* search-2 */\r\n.header-search-2 {\r\n    min-width: 500px;\r\n    form {\r\n        position: relative;\r\n    }\r\n    input {\r\n        margin-bottom: 0;\r\n        border: 0;\r\n        box-shadow: var(--ltn__box-shadow-3);\r\n        border-radius: 50px;\r\n        padding-left: 20px;\r\n        padding-right: 50px;\r\n        height: 45px;\r\n    }\r\n    button {\r\n        position: absolute;\r\n        right: 0;\r\n        background-color: transparent;\r\n        height: 45px;\r\n        top: 0;\r\n        padding: 0 15px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n    Currency Menu\r\n---------------------------------------- */\r\n.ltn__currency-menu {\r\n    .active-currency {\r\n        font-size: 16px;\r\n        font-weight: 700;\r\n    }\r\n    ul li ul {\r\n        min-width: 200px;\r\n    }\r\n    .dropdown-toggle::after {\r\n        margin-left: 3px;    \r\n        border-top: 0.25em solid;\r\n        border-right: .20em solid transparent;\r\n        border-left: .20em solid transparent;\r\n    }\r\n}\r\n.ltn__language-menu {\r\n    .dropdown-toggle {\r\n        padding-right: 10px !important;\r\n        position: relative;\r\n        &::after {\r\n            display: none;\r\n        }\r\n        &::before {\r\n            content: \"\\e911\";\r\n            font-size: 14px;\r\n            position: absolute;\r\n            top: 50%;\r\n            right: -5px;\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n            font-family: 'icomoon';\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  Header 2\r\n---------------------------------------- */\r\n.ltn__header-2 {\r\n    .sticky-active {\r\n        .row {\r\n            .col {\r\n                justify-content: space-between !important;\r\n            }\r\n        }\r\n        .sticky-logo {\r\n            display: block;\r\n        }\r\n        .header-menu-2 {\r\n            text-align: right;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  Header 3\r\n---------------------------------------- */\r\n.ltn__header-3 {\r\n    .ltn__header-middle-area {\r\n        padding: 30px 0;\r\n    }\r\n}\r\n.ltn__header-3 .header-bottom-area.sticky-active {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n.ltn__header-3 {\r\n    .sticky-active {\r\n        .row {\r\n            .col {\r\n                justify-content: space-between !important;\r\n            }\r\n        }\r\n        .sticky-logo {\r\n            display: block;\r\n        }\r\n        .header-menu-2 {\r\n            text-align: right;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n    Header 4\r\n---------------------------------------- */\r\n.ltn__header-4,\r\n.ltn__header-5 {\r\n    .ltn__header-middle-area {\r\n        padding-top: 22px;\r\n        padding-bottom: 22px;\r\n    }\r\n}\r\n.ltn__header-4 {\r\n    .ltn__header-top-area {\r\n        border-color: var(--border-color-3);\r\n    }\r\n}\r\n.site-logo-wrap {\r\n    display: flex;\r\n    .site-logo {\r\n        min-width: auto;\r\n    }\r\n}\r\n.get-support {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    padding-left: 20px;\r\n    margin-left: 20px;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        height: 30px;\r\n        width: 1px;\r\n        background-color: #999;\r\n    }\r\n    .get-support-icon {\r\n        margin-right: 10px;\r\n        font-size: 35px;\r\n        line-height: 1;\r\n        color: var(--ltn__secondary-color);\r\n        i {\r\n            transform: rotate(-45deg);\r\n        }\r\n    }\r\n    .get-support-info {\r\n        margin: 0;\r\n        text-align: left;\r\n        h6 {\r\n            margin: 0;\r\n            font-weight: 600;\r\n            font-size: 14px;\r\n        }\r\n        h4 {\r\n            margin: 5px 0 0;\r\n            line-height: 1;\r\n        }\r\n    }\r\n}\r\n.get-support-color-white {\r\n    .get-support-info h6,\r\n    .get-support-info h4 {\r\n        color: var(--white);\r\n    }\r\n}\r\n.special-link {\r\n    margin-left: 15px;\r\n    align-self: center;\r\n    a {\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white) !important;\r\n        padding: 12px 30px !important;\r\n        &:hover {\r\n            background-color: var(--section-bg-1);\r\n            color: var(--ltn__primary-color) !important;\r\n        }\r\n    }\r\n}\r\n\r\n.menu-color-white {\r\n    .ltn__main-menu > ul > li > a {\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  Header 5\r\n---------------------------------------- */\r\n.ltn__header-5 {\r\n    .get-support::before {\r\n        background-color: #e4e8ea;\r\n    }\r\n    .ltn__header-options {\r\n        margin-left: 30px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  ltn__header-logo-mobile-menu-in-mobile\r\n---------------------------------------- */\r\n.ltn__header-logo-mobile-menu-in-mobile {\r\n    margin-top: 0;\r\n}\r\n\r\n/* ----------------------------------------------\r\n    Header Sticky\r\n---------------------------------------------- */\r\n.sticky-active {\r\n    animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;\r\n    background-color: var(--white);\r\n    left: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 999;\r\n    box-shadow: 0 10px 50px 0 rgba(46,56,220,.2);\r\n}\r\n\r\n.ltn__header-4 .ltn__header-middle-area.sticky-active, \r\n.ltn__header-5 .ltn__header-middle-area.sticky-active {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n/* Sticky Background Secondary */\r\n.sticky-active.ltn__sticky-bg-secondary {\r\n    background-color: var(--ltn__secondary-color);\r\n    .ltn__main-menu > ul > li > a,\r\n    .header-wishlist a,\r\n    .mini-cart-icon,\r\n    .header-feature-item h6, \r\n    .header-feature-item p, \r\n    .header-feature-icon, \r\n    .header-search-1 .search-icon,\r\n    .ltn__header-options .ltn__drop-menu > ul > li > a {\r\n        color: var(--white);\r\n    }\r\n    .ltn__header-options-2 .header-search-1, \r\n    .ltn__header-options-2 .header-search-1 i, \r\n    .ltn__header-options-2 .ltn__drop-menu > ul > li > a, \r\n    .ltn__header-options-2 .mini-cart-icon a, \r\n    .ltn__header-options-2 .header-wishlist {\r\n        background: var(--white);\r\n        color: var(--ltn__heading-color);\r\n    }\r\n}\r\n/* Sticky Background Black */\r\n.sticky-active.ltn__sticky-bg-black {\r\n    background-color: var(--ltn__heading-color);\r\n    .ltn__main-menu > ul > li > a,\r\n    .header-wishlist a,\r\n    .mini-cart-icon,\r\n    .header-feature-item h6, \r\n    .header-feature-item p, \r\n    .header-feature-icon, \r\n    .header-search-1 .search-icon,\r\n    .ltn__header-options .ltn__drop-menu > ul > li > a {\r\n        color: var(--white);\r\n    }\r\n    .ltn__header-options-2 .header-search-1, \r\n    .ltn__header-options-2 .header-search-1 i, \r\n    .ltn__header-options-2 .ltn__drop-menu > ul > li > a, \r\n    .ltn__header-options-2 .mini-cart-icon a, \r\n    .ltn__header-options-2 .header-wishlist {\r\n        background: var(--white);\r\n        color: var(--ltn__heading-color);\r\n    }\r\n}\r\n/* Sticky Background White */\r\n.sticky-active.ltn__sticky-bg-white {\r\n    background-color: var(--white);\r\n    .ltn__main-menu > ul > li > a,\r\n    .header-wishlist a,\r\n    .mini-cart-icon,\r\n    .header-feature-item h6, \r\n    .header-feature-item p, \r\n    .header-feature-icon, \r\n    .header-search-1 .search-icon,\r\n    .ltn__header-options .ltn__drop-menu > ul > li > a {\r\n        color: var(--ltn__heading-color);\r\n    }\r\n    .ltn__header-options-2 .header-search-1, \r\n    .ltn__header-options-2 .header-search-1 i, \r\n    .ltn__header-options-2 .ltn__drop-menu > ul > li > a, \r\n    .ltn__header-options-2 .mini-cart-icon a, \r\n    .ltn__header-options-2 .header-wishlist {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        background: var(--white);\r\n        color: var(--ltn__heading-color);\r\n    }\r\n}\r\n\r\n.header-contact-search {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n}\r\n\r\n/* ltn__header-transparent */\r\n.ltn__header-transparent {\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 999;\r\n    background-color: transparent;\r\n    .top-area-color-white {\r\n        background-color: transparent;\r\n    } \r\n}\r\n\r\n\r\n/* ----------------------------------------\r\n  Utilize Mobile Menu\r\n---------------------------------------- */\r\n.ltn__utilize {\r\n    position: fixed;\r\n    z-index: 1000;\r\n    top: 0;\r\n    right: 0;\r\n    left: auto;\r\n    display: block;\r\n    overflow: hidden;\r\n    width: 400px;\r\n    height: 100vh;\r\n    padding: 20px 10px 20px 30px;\r\n    -webkit-transition: all .5s ease 0s;\r\n    -o-transition: all .5s ease 0s;\r\n    transition: all .5s ease 0s;\r\n    -webkit-transform: translateX(100%);\r\n    -ms-transform: translateX(100%);\r\n    transform: translateX(100%);\r\n    background-color: var(--white);\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    z-index: 99999;\r\n}\r\n.ltn__utilize.ltn__utilize-mobile-menu {\r\n    right: auto;\r\n    left: 0;\r\n    padding: 50px 40px;\r\n    -webkit-transform: translateX(-100%);\r\n    -ms-transform: translateX(-100%);\r\n    transform: translateX(-100%);\r\n}\r\n.ltn__utilize-menu-inner {\r\n    position: relative;\r\n    z-index: 9;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    touch-action: auto;\r\n    overflow-x: hidden !important;\r\n    padding-right: 20px;\r\n}\r\n.ltn__utilize-menu-search-form {\r\n    margin-bottom: 30px;\r\n    position: relative;\r\n    input[type=\"text\"] {\r\n        margin-bottom: 0;\r\n    }\r\n    button {\r\n        background-color: transparent;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        height: 100%;\r\n        padding: 0 15px;\r\n    }\r\n}\r\n@media (max-width: 479px) {\r\n    .ltn__utilize {\r\n        width: 300px;\r\n    }\r\n    .ltn__utilize.ltn__utilize-mobile-menu {\r\n        padding: 50px 20px;\r\n    }\r\n}\r\n\r\n.ltn__utilize-menu>ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n.ltn__utilize-menu>ul>li {\r\n    position: relative;\r\n}\r\n.ltn__utilize-menu>ul>li .menu-expand {\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 0;\r\n    right: 0;\r\n    width: 24px;\r\n    height: 44px;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n}\r\n.ltn__utilize-menu>ul>li .menu-expand::before, \r\n.ltn__utilize-menu>ul>li .menu-expand::after {\r\n    position: absolute;\r\n    top: calc(50% - 1px);\r\n    left: calc(50% - 7px);\r\n    width: 14px;\r\n    height: 2px;\r\n    content: \"\";\r\n    -webkit-transition: all .5s ease 0s;\r\n    -o-transition: all .5s ease 0s;\r\n    transition: all .5s ease 0s;\r\n    -webkit-transform: scale(0.75);\r\n    -ms-transform: scale(0.75);\r\n    transform: scale(0.75);\r\n    background-color: #7e7e7e;\r\n}\r\n.ltn__utilize-menu>ul>li .menu-expand::after {\r\n    -webkit-transform: rotate(90deg) scale(0.75);\r\n    -ms-transform: rotate(90deg) scale(0.75);\r\n    transform: rotate(90deg) scale(0.75);\r\n}\r\n.ltn__utilize-menu>ul>li.active .menu-expand::after {\r\n    -webkit-transform: inherit;\r\n    -ms-transform: inherit;\r\n    transform: inherit;\r\n}\r\n.ltn__utilize-menu>ul>li>a {\r\n    display: block;\r\n    padding: 8px 24px 8px 0;\r\n    text-transform: uppercase;\r\n}\r\n.ltn__utilize-menu>ul>li .sub-menu {\r\n    position: static;\r\n    top: auto;\r\n    display: none;\r\n    visibility: visible;\r\n    width: 100%;\r\n    min-width: auto;\r\n    padding: 0;\r\n    padding-left: 15px;\r\n    -webkit-transition: none;\r\n    -o-transition: none;\r\n    transition: none;\r\n    opacity: 1;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n.ltn__utilize-menu>ul>li .sub-menu li {\r\n    line-height: inherit;\r\n    position: relative;\r\n    list-style: none;\r\n}\r\n.ltn__utilize-overlay {\r\n    position: fixed;\r\n    z-index: 9999;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    display: none;\r\n    background-color: rgba(0,0,0,0.5);\r\n}\r\n.ltn__utilize.ltn__utilize-open {\r\n    -webkit-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    transform: translateX(0);\r\n}\r\n.ltn__utilize.ltn__utilize-mobile-menu.ltn__utilize-open {\r\n    -webkit-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    transform: translateX(0);\r\n}\r\n.mobile-menu-toggle {\r\n    margin-right: 15px;\r\n}\r\n.mobile-menu-toggle>a {\r\n    width: 24px;\r\n    height: 32px;\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    color: #333;\r\n    margin-left: auto;\r\n}\r\n.mobile-menu-toggle svg {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 50px;\r\n    height: 60px;\r\n    margin-top: -2px;\r\n    margin-left: -2px;\r\n    cursor: pointer;\r\n    -webkit-transform: translate3d(-50%,-50%,0);\r\n    transform: translate3d(-50%,-50%,0);\r\n}\r\n.mobile-menu-toggle svg path {\r\n    -webkit-transition: stroke-dashoffset .5s cubic-bezier(0.25,-0.25,0.75,1.25),stroke-dasharray .5s cubic-bezier(0.25,-0.25,0.75,1.25);\r\n    -o-transition: stroke-dashoffset .5s cubic-bezier(0.25,-0.25,0.75,1.25),stroke-dasharray .5s cubic-bezier(0.25,-0.25,0.75,1.25);\r\n    transition: stroke-dashoffset .5s cubic-bezier(0.25,-0.25,0.75,1.25),stroke-dasharray .5s cubic-bezier(0.25,-0.25,0.75,1.25);\r\n    fill: none;\r\n    stroke: #333;\r\n    stroke-dashoffset: 0;\r\n    stroke-linecap: round;\r\n    stroke-width: 30px;\r\n}\r\n.mobile-menu-toggle svg path#top, .mobile-menu-toggle svg path#bottom {\r\n    stroke-dasharray: 240px 950px;\r\n}\r\n.mobile-menu-toggle svg path#middle {\r\n    stroke-dasharray: 240px 240px;\r\n}\r\n.mobile-menu-toggle .close svg path#top, .mobile-menu-toggle .close svg path#bottom {\r\n    stroke-dasharray: -650px;\r\n    stroke-dashoffset: -650px;\r\n}\r\n.mobile-menu-toggle .close svg path#middle {\r\n    stroke-dasharray: 1px 220px;\r\n    stroke-dashoffset: -115px;\r\n}\r\n.ltn__utilize-menu-head {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 25px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #eee;\r\n    .ltn__utilize-menu-title {\r\n        font-weight: 700;\r\n    }\r\n    .ltn__utilize-close {\r\n        background-color: transparent;\r\n        font-size: 30px;\r\n        padding: 0 15px;\r\n    }\r\n}\r\n.ltn__utilize-buttons {\r\n    border-top: 1px solid var(--border-color-1);\r\n    padding: 5px 0px 20px;\r\n    margin: 30px 0;\r\n    border-bottom: 1px solid var(--border-color-1);\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            display: inline-block;\r\n        }\r\n    }\r\n    .utilize-btn-icon {\r\n        width: 50px;\r\n        display: inline-block;\r\n        height: 50px;\r\n        border: 2px solid var(--border-color-1);\r\n        line-height: 46px;\r\n        text-align: center;\r\n        margin-right: 10px;\r\n    }\r\n}\r\n.ltn__utilize-buttons-2 {\r\n    ul {\r\n        li {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n.menu-btn-white {\r\n    &.mobile-menu-toggle {\r\n        & > a {\r\n            color: #fff;\r\n        }\r\n        svg path {\r\n            stroke: #fff;\r\n        }\r\n    }\r\n}\r\n.menu-btn-border {\r\n   a {\r\n        width: 40px;\r\n        height: 38px;\r\n        border: 1px solid;\r\n   }\r\n}\r\n\r\n\r\n/* logo-right-menu-option */\r\n.ltn__logo-right-menu-option {\r\n    .row > * {\r\n        width: auto;\r\n    }\r\n}\r\n\r\n.ltn__header-row-bg-white {\r\n    .row {\r\n        background-color: var(--white);\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .ltn__header-padding {\r\n        .row {\r\n            padding: 10px;\r\n        }\r\n        &.sticky-active {\r\n            .row {\r\n                padding: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  Responsive\r\n---------------------------------------- */\r\n@media (min-width: 1200px) and (max-width: 1300px) {\r\n    .ltn__main-menu > ul > li {\r\n        margin-right: 15px;\r\n    }\r\n    .ltn__main-menu > ul > li:last-child {\r\n        margin-right: 0;\r\n    }\r\n    .ltn__main-menu > ul > li > a {\r\n        font-size: 15px;\r\n    }\r\n    .ltn__header-6 {\r\n        .ltn__main-menu > ul > li {\r\n            margin-right: 10px;\r\n        }\r\n        .ltn__main-menu > ul > li:last-child {\r\n            margin-right: 0px;\r\n        }\r\n        .special-link a {\r\n            padding: 15px 20px !important;\r\n        }\r\n        .ltn__main-menu > ul > li > a {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n    \r\n    .site-logo {\r\n        min-width: 180px;\r\n    }\r\n    .ltn__main-menu > ul > li > a {\r\n        padding: 20px 15px;\r\n    }\r\n    .ltn__main-menu > ul > li {\r\n        margin-right: 10px;\r\n    }\r\n    .ltn__header-3 {\r\n        .header-feature-item {\r\n            display: none;\r\n        }\r\n    }\r\n    \r\n    .ltn__header-logo-and-mobile-menu {\r\n        .site-logo-wrap {\r\n            justify-content: flex-start;\r\n            margin: 10px 0 10px;\r\n        }\r\n        .ltn__header-middle-area > .container-fluid > .row > .col, \r\n        .ltn__header-middle-area > .container > .row > .col {\r\n            max-width: 65%;\r\n        }\r\n        .ltn__header-options {\r\n            flex: 0 0 30%;\r\n        }\r\n    }\r\n    .ltn__header-row-bg-white {\r\n        .row {\r\n            padding-top: 10px;\r\n            padding-bottom: 10px;\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .header-search-column,\r\n    .header-menu-column {\r\n        display: none;\r\n    }\r\n    /* sticky */\r\n    .sticky-active {\r\n        position: inherit;\r\n    }\r\n    .ltn__header-2 {\r\n        .ltn__header-middle-area > .container > .row .header-feature-column {\r\n            order: 3;\r\n            flex-grow: 1;\r\n            max-width: 100%;\r\n            border-top: 1px solid #ddd;\r\n        }\r\n        .header-feature-area {\r\n            justify-content: space-between;\r\n        }\r\n        .header-feature-item {\r\n            margin-right: 15px;\r\n        }\r\n\r\n    }\r\n    .ltn__header-3 {\r\n        .ltn__header-middle-area > .container > .row .header-search-column {\r\n            order: 3;\r\n            flex-grow: 1;\r\n            max-width: 100%;\r\n            border-top: 1px solid #ddd;\r\n        }\r\n        .header-search-2 {\r\n            min-width: 280px;\r\n        }\r\n\r\n    }\r\n\r\n    .ltn__top-bar-menu ul li {\r\n        margin: 0 20px 0 0;\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__header-top-area {\r\n        padding: 5px 0;\r\n        text-align: center;\r\n    }\r\n    .ltn__header-top-area .ltn__social-media ul li {\r\n        font-size: 12px;\r\n        margin: 0 5px 0 0;\r\n    }\r\n    .ltn__top-bar-menu .ltn__currency-menu .active-currency,\r\n    .ltn__top-bar-menu > ul > li {\r\n        font-size: 13px;\r\n    }\r\n    .ltn__drop-menu > ul > li {\r\n        position: inherit;\r\n    }\r\n    .ltn__drop-menu > ul > li > a {\r\n        height: 20px;\r\n        line-height: 20px;\r\n    }\r\n    .ltn__drop-menu ul li ul { \r\n        left: 50%;\r\n        right: 50%;\r\n        transform: translateX(-50%);\r\n    }\r\n    .top-bar-right {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .welcome p {\r\n        line-height: 20px;\r\n        margin: 5px 0;\r\n    }\r\n    .site-logo {\r\n        min-width: 100px;\r\n    }\r\n    .ltn__header-5,\r\n    .ltn__header-4 {\r\n        .top-bar-right {\r\n            justify-content: center;\r\n            margin-top: 5px;\r\n        }\r\n    }\r\n    .ltn__logo-right-menu-option,\r\n    .ltn__header-4,\r\n    .ltn__header-5 {\r\n        .site-logo-wrap {\r\n            flex: 0 0 100%;\r\n            justify-content: center;\r\n            margin: 10px 0 30px;\r\n        }\r\n        .ltn__header-options {\r\n            margin-left: 0;\r\n            flex: 0 0 100%;\r\n            justify-content: center;\r\n        }\r\n    }\r\n    .ltn__header-3 {\r\n        .top-bar-right {\r\n            justify-content: center;\r\n            margin-top: 5px;\r\n        }\r\n    }\r\n    .ltn__header-logo-and-mobile-menu-in-mobile {\r\n        .site-logo-wrap {\r\n            justify-content: flex-start;\r\n            margin: 10px 0 10px;\r\n        }\r\n        .ltn__header-middle-area > .container-fluid > .row > .col, \r\n        .ltn__header-middle-area > .container > .row > .col {\r\n            max-width: 65%;\r\n        }\r\n        .ltn__header-options {\r\n            flex: 0 0 30%;\r\n        }\r\n    }\r\n    .header-top-btn a {\r\n        padding: 0 15px;\r\n        line-height: 25px;\r\n    }\r\n    .ltn__header-row-bg-white {\r\n        .row {\r\n            padding-top: 0px;\r\n            padding-bottom: 0px;\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 575px) {\r\n    .site-logo a {\r\n        font-size: 24px;\r\n        i {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n    .ltn__header-1 {\r\n        .ltn__header-middle-area > .container > .row {\r\n            flex-flow: column;\r\n        }\r\n        .site-logo {\r\n            justify-content: center;\r\n        }\r\n        .ltn__header-options {\r\n            justify-content: center;\r\n            margin-top: 30px;\r\n        }\r\n    }\r\n    .ltn__header-7 {\r\n        .site-logo {\r\n            -webkit-box-pack: center;\r\n            -ms-flex-pack: center;\r\n            justify-content: center;\r\n        }\r\n        .ltn__header-options {\r\n            -webkit-box-pack: center;\r\n            -ms-flex-pack: center;\r\n            justify-content: center;\r\n            margin-top: 20px;\r\n        }\r\n    } \r\n    .ltn__header-7 .ltn__header-middle-area > .container > .row .col,\r\n    .ltn__header-7 .ltn__header-middle-area > .container-fluid > .row .col {\r\n        -webkit-box-flex: 0;\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n    }\r\n    .ltn__header-3 {\r\n        .mini-cart-icon-2 > a {\r\n            min-width: auto;\r\n            h6 {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 449px) {\r\n    .ltn__header-options > div {\r\n        margin-right: 10px;\r\n    }\r\n    .header-feature-area {\r\n        flex-flow: column;\r\n    }\r\n    .header-feature-item:last-child {\r\n        padding-top: 0;\r\n    }\r\n\r\n    .get-support {\r\n        padding-left: 10px;\r\n        margin-left: 10px;\r\n        .get-support-icon {\r\n            font-size: 20px;\r\n            display: none;\r\n        }\r\n        .get-support-info {\r\n            h6 {\r\n                display: 13px;\r\n            }\r\n            h4 {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n}\r\n@media (max-width: 370px) {\r\n    .ltn__header-3 {\r\n        .ltn__header-options > ul > li {\r\n            margin-right: 5px;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------\r\n  Icon Font\r\n---------------------------------------- */\r\n.ltn__header-options,\r\n.ltn__header-top-area {\r\n    i {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Category Menu\r\n---------------------------------------------------- */\r\n.ltn__category-menu-wrap {\r\n    position: relative;\r\n}\r\n.ltn__category-menu-title {\r\n    h2 {\r\n        cursor: pointer;\r\n        font-size: 16px;\r\n        font-weight: bold;\r\n        letter-spacing: 1px;\r\n        line-height: 45px;\r\n        margin: 0;\r\n        overflow: hidden;\r\n        padding: 10px 20px 3px;\r\n        position: relative;\r\n        text-transform: uppercase;\r\n        font-family: var(--ltn__body-font);\r\n        &::before,\r\n        &::after {\r\n            font-family: 'Font Awesome\\ 5 Free';\r\n            font-weight: 900;\r\n            display: block;\r\n            font-size: 14px;\r\n        }\r\n        &::before {\r\n            content: \"\\f0c9\";\r\n            float: left;\r\n            margin-right: 10px;\r\n        }\r\n        &::after {\r\n            content: \"\\f0dd\";\r\n            float: right;\r\n        }\r\n    }\r\n}\r\n.ltn__category-menu-toggle {\r\n    background-color: var(--white);\r\n    & > ul {\r\n        border-color: var(--border-color-1);\r\n        border-width: 1px 1px 1px;\r\n        border-style: solid;\r\n        padding: 0;\r\n        margin: 0;\r\n        & > li {\r\n            & > a {\r\n                padding: 14px 15px 11px;\r\n                display: block;\r\n                font-size: 15px;\r\n                border-bottom: 1px solid var(--border-color-1);\r\n            }\r\n            &:hover {\r\n                & > a {\r\n                    background-color: var(--section-bg-1);\r\n                    font-weight: 700;\r\n                }\r\n                .ltn__category-submenu {\r\n                    opacity: 1;\r\n                    visibility: visible;\r\n                    top: 0;\r\n                }\r\n            }\r\n            i {\r\n                font-size: 18px;\r\n                margin-right: 5px;\r\n                width: 25px;\r\n                display: inline-block;\r\n            }\r\n        }\r\n    }\r\n    ul {\r\n        margin: 0;\r\n        li {\r\n            margin-top: 0;\r\n            list-style: none;\r\n            position: relative;\r\n            font-size: 14px;\r\n            a {\r\n                display: block;\r\n            }\r\n            &:hover {\r\n                & > a {\r\n                    color: var(--ltn__secondary-color);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.ltn__one-line-active {\r\n        .ltn__category-submenu {\r\n            li {\r\n                a {\r\n                    display: block;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    white-space: nowrap;\r\n                }\r\n            }\r\n        }\r\n    } \r\n}\r\n\r\n.ltn__category-submenu {\r\n    position: absolute;\r\n    left: 100%;\r\n    top: 90%;\r\n    width: 230px;\r\n    z-index: 99;\r\n    background-color: #fff;\r\n    padding: 25px 20px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s ease 0s;\r\n    ul {\r\n        padding: 0;\r\n        li {\r\n            padding: 8px 0px;\r\n        }\r\n    }\r\n    & > li {\r\n        width: 100%;\r\n        float: left;\r\n        padding: 0 10px;\r\n    }\r\n    &.ltn__category-column-5,\r\n    &.ltn__category-column-6,\r\n    &.ltn__category-column-7,\r\n    &.ltn__category-column-8,\r\n    &.ltn__category-column-9,\r\n    &.ltn__category-column-10,\r\n    &.ltn__category-column-11,\r\n    &.ltn__category-column-12,\r\n    &.ltn__category-column-no-5,\r\n    &.ltn__category-column-no-6,\r\n    &.ltn__category-column-no-7,\r\n    &.ltn__category-column-no-8,\r\n    &.ltn__category-column-no-9,\r\n    &.ltn__category-column-no-10,\r\n    &.ltn__category-column-no-11,\r\n    &.ltn__category-column-no-12,\r\n    &.ltn__category-column-no-13,\r\n    &.ltn__category-column-no-14 {\r\n        width: 730px;\r\n        & > li {\r\n            width: 25%;\r\n        }\r\n    }\r\n    &.ltn__category-column-4,\r\n    &.ltn__category-column-no-4 {\r\n        width: 730px;\r\n        & > li {\r\n            width: 25%;\r\n        }\r\n    }\r\n    &.ltn__category-column-3,\r\n    &.ltn__category-column-no-3 {\r\n        width: 690px;\r\n        & > li {\r\n            width: 33%;\r\n        }\r\n    }\r\n    &.ltn__category-column-2,\r\n    &.ltn__category-column-no-2 {\r\n        width: 460px;\r\n        & > li {\r\n            width: 50%;\r\n        }\r\n    }\r\n}\r\n.ltn__category-submenu-title {\r\n    & > a {\r\n        border-bottom: 1px solid #ddd;\r\n        font-weight: 700;\r\n        padding: 5px 0;\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n\r\n.ltn__category-menu-toggle {\r\n    .ltn__category-menu-more-item-parent {\r\n        cursor: pointer;\r\n    }\r\n    .ltn__category-menu-more-item-child,\r\n    .rx-show {\r\n        display: none;\r\n    }\r\n    .rx-change {\r\n        .rx-show {\r\n            display: block;\r\n        }\r\n        .rx-default {\r\n            display: none;\r\n        }\r\n    } \r\n}\r\n.ltn__category-dropdown-hide {\r\n    .ltn__category-menu-toggle {\r\n        display: none;\r\n    }\r\n}\r\n.ltn__category-menu-with-header-menu {\r\n    .ltn__category-menu-toggle {\r\n        position: absolute;\r\n        width: 100%;\r\n        z-index: 9;\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .ltn__category-menu-toggle {\r\n        & > ul {\r\n            & > li {\r\n                & > a {\r\n                    padding: 10px 5px;\r\n                    font-size: 13px;\r\n                }\r\n                i {\r\n                    font-size: 16px;\r\n                    width: 20px;\r\n                }\r\n            }\r\n        }\r\n        ul {\r\n            li {\r\n                font-size: 13px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__category-submenu {\r\n        ul {\r\n            padding-left: 10px;\r\n            li {\r\n                padding: 5px 0px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .ltn__category-menu-wrap {\r\n        margin-bottom: 30px;\r\n    }\r\n    .ltn__category-menu-toggle {\r\n        max-height: 350px;\r\n        overflow: auto;\r\n        position: absolute;\r\n        width: 100%;\r\n        z-index: 99;\r\n        display: none;\r\n    }\r\n    .ltn__category-submenu {\r\n        display: none;\r\n        opacity: inherit !important;\r\n        visibility: inherit !important;\r\n        left: inherit !important;\r\n        width: 100% !important;\r\n        top: 100%;\r\n        max-height: 350px;\r\n        overflow: auto;\r\n        transition: unset;\r\n        box-shadow: inherit;\r\n        position: inherit;\r\n        padding: 5px 0px 0px 15px;\r\n        & > li {\r\n            width: 100% !important;\r\n            margin-bottom: 0;\r\n            float: none;\r\n        }\r\n\r\n    }\r\n    .ltn__category-submenu-children {\r\n        display: none;\r\n    }\r\n    .ltn__category-menu-drop {\r\n        & > a {\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"+\";\r\n                right: 15px;\r\n                top: 50%;\r\n                transform: translatey(-50%);\r\n                font-size: 20px;\r\n                font-weight: 400;\r\n            }\r\n        }\r\n        &.open {\r\n          & > a {\r\n              &::before {\r\n                  display: none;\r\n              }\r\n              &::after {\r\n                position: absolute;\r\n                content: \"-\";\r\n                right: 15px;\r\n                top: 50%;\r\n                transform: translatey(-50%);\r\n                font-size: 30px;\r\n                font-weight: 400;\r\n            }\r\n          }  \r\n        }\r\n    }\r\n\r\n}\r\n.mobile-header-menu-fullwidth {\r\n    .mobile-menu-toggle {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        border: 1px solid var(--border-color-1);\r\n        padding: 7px 20px 6px;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n.top-a{\r\n  color: var(--white) !important;\r\n}\r\n\r\n.overlay {\r\n  /*position: absolute; */\r\n  background: rgba(57, 57, 57, 0.5);\r\n  width: fit-content !important;\r\n  /* center overlay text */\r\n  \r\n}\r\n.overlay2 {\r\n  width: fit-content !important;\r\n  background: rgba(72, 94, 33, 0.5);\r\n\r\n  /* center overlay text */\r\n\r\n}\r\n\r\n.overlay3 {\r\n  width: fit-content !important;\r\n  background: rgba(72, 94, 33, 0.65);\r\n\r\n  /* center overlay text */\r\n\r\n}\r\n\r\n.overlay4 {\r\n  width: fit-content !important;\r\n  background: rgba(33, 72, 94, 0.65);\r\n\r\n  /* center overlay text */\r\n\r\n}\r\n\r\n.overlay_1 {\r\n \r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding: 10px;\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","/* ----------------------------------------------------\r\n    Slider Area 1, 2, 3, 4, 5, 6, 7, 9\r\n---------------------------------------------------- */\r\n.ltn__slide-item {\r\n    padding-top: 100px;\r\n    padding-bottom: 100px;\r\n    height: 750px;\r\n}\r\n.ltn__slide-item-inner {\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.slide-item-info-inner {\r\n    width: 100%;\r\n}\r\n.slide-title {\r\n    font-size: 38px;\r\n    font-weight: 700;\r\n}\r\n\r\n/* Slider Animation Start */\r\n.ltn__slide-animation {\r\n    position: relative;\r\n    z-index: 9;\r\n    & > * {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        animation-name: fadeOutUp;\r\n        &:nth-child(1) {\r\n            animation-delay: 0.5s;\r\n            animation-duration: 0.5s;\r\n        }\r\n        &:nth-child(2) {\r\n            animation-delay: 1s;\r\n            animation-duration: 1s;\r\n        }\r\n        &:nth-child(3) {\r\n            animation-delay: 1.5s;\r\n            animation-duration: 1.5s;\r\n        }\r\n        &:nth-child(4) {\r\n            animation-delay: 2s;\r\n            animation-duration: 2s;\r\n        }\r\n        &:nth-child(5) {\r\n            animation-delay: 2.5s;\r\n            animation-duration: 2.5s;\r\n        }\r\n        &:nth-child(6) {\r\n            animation-delay: 3s;\r\n            animation-duration: 3s;\r\n        }\r\n        &:nth-child(7) {\r\n            animation-delay: 3.5s;\r\n            animation-duration: 3.5s;\r\n        }\r\n        &:nth-child(8) {\r\n            animation-delay: 4s;\r\n            animation-duration: 4s;\r\n        }\r\n        &:nth-child(9) {\r\n            animation-delay: 4.5s;\r\n            animation-duration: 4.5s;\r\n        }\r\n        &:nth-child(11) {\r\n            animation-delay: 5s;\r\n            animation-duration: 5s;\r\n        }\r\n    }\r\n}\r\n.slick-current,\r\n.ltn__slide-animation-active {\r\n    & .ltn__slide-animation {\r\n        & > * {\r\n            opacity: 1;\r\n            visibility: visible;\r\n            animation-name: fadeInUp;\r\n        }\r\n    }\r\n}\r\n\r\n/* Title Background Image */\r\n.title-bg-img {\r\n    background-image: url(\"../../img/slider/1.jpg\");\r\n    background-clip: text;\r\n    -webkit-text-fill-color: transparent; \r\n    word-break: break-word;\r\n}\r\n.title-bg-img-2 {\r\n    background-image: url(\"../../img/slider/2.jpg\");\r\n}\r\n\r\n/* Slide Arrow */\r\n.slick-slide-arrow-1 {\r\n    .slick-arrow {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 40px;\r\n        transform: translateY(-50%);\r\n        width: 60px;\r\n        height: 60px;\r\n        line-height: 58px;\r\n        border: 1px solid var(--border-color-1);\r\n        text-align: center;\r\n        font-size: 20px;\r\n        color: var(--ltn__primary-color) !important;\r\n        z-index: 1;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        &:hover {\r\n            background-color: var(--ltn__secondary-color);\r\n            border-color: var(--ltn__secondary-color);\r\n            color: var(--white) !important;\r\n        }\r\n    }\r\n    .slick-next {\r\n        right: 40px;\r\n        left: auto;\r\n    }\r\n    &:hover {\r\n        .slick-arrow {\r\n            opacity: 1;\r\n            visibility: visible;\r\n            left: 20px;\r\n        }\r\n        .slick-next {\r\n            right: 20px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n.slick-slide-dots-1 {\r\n    .slick-dots {\r\n        position: absolute;\r\n        bottom: 50px;\r\n        width: 100%;\r\n        margin: 0;\r\n    }\r\n}\r\n.arrow-white {\r\n    .slick-arrow {\r\n        color: var(--white) !important;\r\n        border: 1px solid var(--border-color-3);\r\n    }\r\n}\r\n@media (min-width: 1400px) {\r\n    .slick-slide-arrow-1 {\r\n        &:hover {\r\n            .slick-arrow {\r\n                opacity: 1;\r\n                visibility: visible;\r\n                left: 60px;\r\n            }\r\n            .slick-next {\r\n                right: 60px;\r\n                left: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* slide-item-2 */\r\n.ltn__slide-item-2 {\r\n    height: calc(50vh - 0px) !important;\r\n    padding-top: 100px !important;\r\n    .slide-item-info {\r\n        max-width: 650px;\r\n    }\r\n    .slide-sub-title {\r\n        margin-bottom: 20px;\r\n        font-family: var(--ltn__body-font);\r\n        span {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .slide-title {\r\n        font-size: 65px;\r\n        line-height: 1;\r\n        margin-bottom: 20px;\r\n        span {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 40px;\r\n    }\r\n    .slide-brief {\r\n        padding-left: 30px;\r\n        border-left: 1px solid #576466;\r\n    }\r\n\r\n\r\n}\r\n.btn-wrapper {\r\n  margin-top: 40px;\r\n}\r\n.slide-brief {\r\n  padding-left: 30px;\r\n  border-left: 1px solid #576466;\r\n}\r\n\r\n\r\n.ltn__slide-item-6, \r\n.ltn__slide-item-2 { \r\n    .text-right {\r\n        .slide-item-info {\r\n            margin-left: auto;\r\n        }\r\n        .slide-brief {\r\n            padding-left: 0px;\r\n            border-left: 0;\r\n            padding-right: 30px;\r\n            border-right: 1px solid #576466;\r\n            margin-left: auto;\r\n        }\r\n    }\r\n    .text-center {\r\n        .slide-item-info {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n        .slide-brief {\r\n            padding-left: 0px;\r\n            border-left: 0;\r\n            padding-right: 0px;\r\n            border-right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.slide-brief {\r\n    max-width: 450px;\r\n}\r\n.text-right {\r\n    .slide-brief {\r\n        margin-left: auto;\r\n    }\r\n}\r\n.text-center {\r\n    .slide-brief {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n}\r\n\r\n.ltn__product-pointer {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        z-index: 9;\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        & > li {\r\n            display: inline-block;\r\n            list-style: none;\r\n            position: relative;\r\n            & > ul {\r\n                position: absolute;\r\n                top: 80%;\r\n                min-width: 300px;\r\n                padding: 0;\r\n                background-color: white;\r\n                right: 80px;\r\n                box-shadow: var(--ltn__box-shadow-3);\r\n                transform: translateY(-50%);\r\n                transition: all 0.3s ease 0s;\r\n                text-align: left;\r\n                opacity: 0;\r\n                visibility: hidden;\r\n                & > li {\r\n                    list-style: none;\r\n                }\r\n            }\r\n            &:hover {\r\n                ul {\r\n                    top: 50%;\r\n                    opacity: 1;\r\n                    visibility: visible;\r\n                }\r\n                .ltn__pointer-icon {\r\n                    transform: rotate(45deg);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    ul li, ol li {\r\n        margin-top: 5px;\r\n    }\r\n    img {\r\n        height: inherit !important;\r\n    }\r\n    p:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn__pointer-icon {\r\n        cursor: pointer;\r\n        height: 60px;\r\n        width: 60px;\r\n        display: flex;\r\n        background-color: white;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 100%;\r\n        font-size: 20px;\r\n        box-shadow: var(--ltn__box-shadow-4);\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    .ltn__product-pointer-inner {\r\n        padding: 15px 30px 25px;\r\n        position: relative;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            width: 0;\r\n            height: 0;\r\n            border-top: 15px solid transparent;\r\n            border-left: 15px solid var(--white);\r\n            border-bottom: 15px solid transparent;\r\n            right: -15px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n        }\r\n        h5 {\r\n            margin-bottom: 10px;\r\n        }\r\n        p {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n    &.ltn__product-pointer-1 {\r\n        top: 38%;\r\n        left: auto;\r\n        right: 24%;\r\n    }\r\n    &.ltn__product-pointer-2 {\r\n        top: 60%;\r\n        left: 20%;\r\n    }\r\n    &.ltn__product-pointer-3 {\r\n        top: 10%;\r\n        left: 40%;\r\n    }\r\n}\r\n.slide-img-left {\r\n    .ltn__product-pointer {\r\n        & > ul {\r\n            & > li {\r\n                & > ul {\r\n                    left: 80px;\r\n                    right: auto;\r\n                }\r\n            }\r\n        }\r\n        .ltn__product-pointer-inner {\r\n            &::before {\r\n                border-right: 15px solid var(--white);\r\n                border-left: 0;\r\n                right: auto;\r\n                left: -15px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* slide-item-3 */\r\n.ltn__slide-item-3 {\r\n    .row [class*='col-'] {\r\n        position: inherit;\r\n    }\r\n    .slide-item-info { \r\n        position: relative;\r\n        z-index: 2;\r\n    }\r\n    .slide-item-img {\r\n        width: 45%;\r\n        position: absolute;\r\n        right: 150px;\r\n        top: auto;\r\n        bottom: 100px;\r\n        height: 70%;\r\n        img {\r\n            text-align: right;\r\n            margin-left: auto;\r\n            height: 100%;\r\n            -o-object-fit: contain;\r\n            object-fit: contain;\r\n            -o-object-position: center center;\r\n            object-position: center center;\r\n        }\r\n    }\r\n    .text-right {\r\n        .slide-item-img {\r\n            right: auto;\r\n            left: 150px;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__slide-item-3-normal {\r\n    height: calc(100vh - 160px);\r\n    padding-top: 100px;\r\n}\r\n\r\n/* slide-item-4 */\r\n.ltn__slide-item-4 {\r\n    padding-bottom: 0;\r\n    .slide-item-img {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n\r\n/* slider-5 */\r\n.ltn__slider-5 {\r\n    .ltn__slide-item-2 {\r\n        padding-top: 100px;\r\n    }\r\n}\r\n/* slide-item-5 */\r\n.ltn__slide-item-5 {\r\n    .slide-item-img {\r\n        right: 200px;\r\n        bottom: 0;\r\n        height: 80%;\r\n    }\r\n    .call-to-circle-1 {\r\n        right: 14%;\r\n        left: auto;\r\n        top: 30%;\r\n        z-index: -1;\r\n        animation: wave 8s 0.1s infinite linear;\r\n    }\r\n    .text-right {\r\n        .slide-item-img {\r\n            right: auto;\r\n            left: 150px;\r\n        }\r\n        .call-to-circle-1 {\r\n            left: 20%;\r\n            right: auto;\r\n        }\r\n    }\r\n}\r\n/* slide-item-6 */\r\n.ltn__slide-item-6 {\r\n    .slide-item-info {\r\n        max-width: 100%;\r\n    }\r\n    .slide-title {\r\n        font-size: 80px;\r\n        line-height: 1;\r\n    }\r\n}\r\n\r\n/* slide-item-7 */\r\n.ltn__slide-item-7 {    \r\n    min-height: 800px;\r\n    height: calc(100vh - 0px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    .slide-item-info {\r\n        max-width: 850px;\r\n    }\r\n    .slide-title {\r\n        font-size: 90px;\r\n        line-height: 1;\r\n    }\r\n}\r\n\r\n\r\n/* slider-9 */\r\n.ltn__slide-item-9 {\r\n    height: 800px;\r\n    .slide-item-info {\r\n        height: 800px;\r\n        max-width: 500px;\r\n    }\r\n}\r\n.ltn__slide-item-9 {\r\n    .ltn__slide-item-inner {\r\n        display: block;\r\n    }\r\n    .slide-item-info {\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 30px 30px 10px;\r\n    }\r\n    .right-align {\r\n        .slide-item-info {\r\n            margin-left: auto;\r\n        }\r\n    }\r\n    .slide-item-info-inner {\r\n        position: relative;\r\n        &::before,\r\n        &::after {\r\n            position: absolute;\r\n            content: '';\r\n            width: 2px;\r\n            height: 84px;\r\n            background-color: var(--ltn__heading-color);\r\n            left: 50%;\r\n            transform: translateX(-50%);\r\n        }\r\n        &::before {\r\n            top: -46.5%;\r\n        }\r\n        &::after {\r\n            bottom: -51%;\r\n        }\r\n    }\r\n    .text-color-white {\r\n        .slide-item-info-inner {\r\n            &::before,\r\n            &::after {\r\n                background-color: var(--white);\r\n            }\r\n        }\r\n    }\r\n    .ltn__tab-menu a {\r\n        padding: 12px 20px;\r\n    }\r\n    .slide-item-info-line-no {\r\n        &::before,\r\n        &::after {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n/* slide-item-10 */\r\n.ltn__slide-item-10 {\r\n    height: 535px;\r\n    .slide-item-info-inner {\r\n        padding: 30px;\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Slider Area 1, 2, 3, 4, 5, 6, 7, 9\r\n---------------------------------------------------- */\r\n/* ======================================================\r\n    s 3 Start\r\n ====================================================== */\r\n/* slider-4 */\r\n.ltn__slider-11 {\r\n    .ltn__slider-11-inner {\r\n        position: relative;\r\n    }\r\n    .ltn__slide-item-11 {\r\n        position: relative;\r\n        .slide-content {\r\n            padding: 80px 0 100px 200px;\r\n            padding-bottom: 250px;\r\n            position: relative;\r\n            width: 90%;\r\n            z-index: 1;\r\n            min-height: 100vh;\r\n            height: 800px;\r\n            .slide-title-1 {\r\n                color: var(--main-color-one);\r\n            }\r\n            .slide-title-2 {\r\n                color: var(--secondary-color-three);\r\n            }\r\n            p {\r\n                color: #000;\r\n            }\r\n        } \r\n        &:before {\r\n            opacity: 0;\r\n        }\r\n    }    \r\n    .slide-item-img {\r\n        position: absolute;\r\n        right: 0px;\r\n        top: 0;\r\n        height: 100%;\r\n        z-index: 0;\r\n        width: 45%;\r\n        & img {\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: cover;\r\n            object-position: center center;\r\n            margin-left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n/* slider-4-active */\r\n.ltn__slider-11-active {\r\n    .slick-arrow {\r\n        position: absolute;\r\n        bottom: 60px;\r\n        left: 30%;\r\n        z-index: 9;\r\n        i {\r\n            font-size: 30px;\r\n            color: #ccc;\r\n        }\r\n        &.slick-next {\r\n            margin-left: 50px;\r\n        }\r\n    }\r\n\r\n} \r\n\r\n/* slider-4-pagination */ /* ===== Set Display for show / hide ===== */\r\n.ltn__slider-11-pagination-count {\r\n    display: none;\r\n    position: absolute;\r\n    top: 53%;\r\n    transform: translateY(-50%);\r\n    left: auto;\r\n    right: 50px;\r\n    & span {\r\n        color: var(--ltn__color-5);\r\n    }\r\n    .count {\r\n        position: absolute;\r\n        top: -22px;\r\n        left: -8px;\r\n    }\r\n    .total {\r\n        bottom: -25px;\r\n        position: absolute;\r\n        left: -10px;\r\n    }\r\n    & .slick-dots {\r\n        display: flex !important;\r\n        flex-direction: column;\r\n        height: 520px;\r\n        & li {\r\n            margin: 0;\r\n            flex: 1 1 auto;\r\n            border-radius: 0;\r\n            width: 2px;\r\n            opacity: 0.45;\r\n            & button {\r\n                display: block;\r\n                border-radius: 0;\r\n                padding: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n                background-color: var(--section-bg-1);\r\n                opacity: 0.45;\r\n                cursor: pointer;\r\n                &:hover {\r\n                    background-color: var(--section-bg-1);\r\n                    opacity: 1;\r\n                }\r\n            }\r\n            &.slick-active {\r\n                & button {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__slider-11-pagination-count-show {\r\n    .ltn__slider-11-pagination-count {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 992px) {\r\n    .ltn__slide-item-11 {\r\n        min-height: calc(100vh - 140px);\r\n    }\r\n}\r\n\r\n/* slider-4-img-slide-arrow */\r\n.ltn__slider-11-img-slide-arrow {\r\n    position: absolute;\r\n    bottom: 30px;\r\n    right: 10%;\r\n    width: 500px;\r\n    .ltn__slider-11-img-slide-arrow-inner {\r\n        position: relative;\r\n    }\r\n    .ltn__slider-11-img-slide-arrow-active {\r\n        padding-left: 100px;\r\n        background-color: var(--main-color-one);\r\n        .image-slide-item {\r\n            padding: 0 10px;\r\n            img {\r\n                border: 5px solid;\r\n                border-color: var(--section-bg-1);\r\n                cursor: pointer;\r\n            }\r\n            &.slick-current {\r\n                img {\r\n                    opacity: 0.9;\r\n                }\r\n            }\r\n        }\r\n        .slick-arrow {\r\n            position: absolute;\r\n            right: auto;\r\n            z-index: 9;\r\n            top: 0;\r\n            left: 0;\r\n            padding-left: 0;\r\n            background-color: var(--section-bg-1);\r\n            text-align: center;\r\n            width: 40px;\r\n            height: 40px;\r\n            line-height: 43px;\r\n            font-size: 16px;\r\n            &.slick-next {\r\n                left: 50px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* slider-11-slide-item-count */ /* ===== Set Display for show / hide ===== */\r\n.ltn__slider-11-slide-item-count {\r\n    display: none; \r\n    left: 0;\r\n    right: auto;\r\n    top: auto;\r\n    bottom: 0;\r\n    position: absolute;\r\n    background-color: var(--section-bg-1);\r\n    padding: 5px 15px 0px;\r\n    .count {\r\n        font-size: 30px;\r\n        line-height: 1;\r\n    }\r\n}\r\n.ltn__slider-11-slide-item-count-show {\r\n    .ltn__slider-11-slide-item-count {\r\n        display: block;\r\n    }\r\n}\r\n\r\n/* slider-sticky-icon-2 */\r\n.slider-sticky-icon-2 {\r\n    position: absolute;\r\n    left: 50px;\r\n    bottom: 80px;\r\n    z-index: 1;\r\n    ul {\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: block;\r\n            margin-bottom: 12px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n\r\n/* ======================================================\r\n    s 3 END\r\n ====================================================== */\r\n\r\n@media (min-width: 1600px) {\r\n    .ltn__slide-item-2 {\r\n        min-height: 800px;\r\n    }\r\n    .ltn__slide-item-3-normal {\r\n        min-height: 780px;\r\n    }    \r\n    .ltn__slide-item-6 {\r\n        height: 800px;\r\n    }\r\n}\r\n@media (max-width: 1599px) {\r\n    .liton-slide-item,\r\n    .ltn__slide-item-3,\r\n    .liton-slide-item-inner {\r\n        height: inherit;\r\n    }\r\n    .ltn__slide-item-9 {\r\n        height: 650px;\r\n        .slide-item-info {\r\n            height: 650px;\r\n            max-width: 400px;\r\n        }\r\n    }\r\n    .ltn__slider-11-img-slide-arrow {\r\n        width: 80%;\r\n        max-width: 350px;\r\n        .ltn__slider-11-img-slide-arrow-active {\r\n            .image-slide-item {\r\n                padding: 0 3px;\r\n                img {\r\n                    border: 2px solid;\r\n                    border-color: var(--section-bg-1);\r\n                }\r\n            }\r\n            .slick-arrow {\r\n                width: 30px;\r\n                height: 30px;\r\n                line-height: 33px;\r\n                font-size: 14px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                &.slick-next {\r\n                    left: 40px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .ltn__slider-11-slide-item-count-show {\r\n        .ltn__slider-11-slide-item-count {\r\n            display: none;\r\n        }\r\n    }\r\n    .ltn__slider-11-pagination-count-show {\r\n        .ltn__slider-11-pagination-count {\r\n            display: none;\r\n        }\r\n    }\r\n    .slider-sticky-icon-2 {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1599px) {\r\n    .ltn__slide-item-2 .slide-title {\r\n        font-size: 50px;\r\n    }\r\n    .ltn__slide-item-6 {\r\n        height: 620px;\r\n        .slide-title {\r\n            font-size: 80px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) and  (max-width: 1599px) {\r\n    .ltn__slide-item-3 {\r\n        .slide-item-img {\r\n            width: 45%;\r\n            right: 60px;\r\n            top: 60%;\r\n            transform: translateY(-50%);\r\n            &.slide-img-left {\r\n                right: auto;\r\n                left: 60px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__slide-item-4 {\r\n        .slide-item-img {\r\n            margin-top: 50px;\r\n            width: 50%;\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n    .ltn__slider-11 {\r\n        .slide-item-img {\r\n            top: 0;\r\n            right: 0;\r\n            transform: inherit;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) and  (max-width: 1399px) {\r\n    .ltn__slide-item-3 {\r\n        .slide-item-img {\r\n            width: 45%;\r\n            right: 60px;\r\n            top: 65%;\r\n            transform: translateY(-50%);\r\n            &.slide-img-left {\r\n                right: auto;\r\n                left: 60px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__slide-item-4 {\r\n        .slide-item-img {\r\n            margin-top: 50px;\r\n            width: 50%;\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n    .ltn__slider-11 {\r\n        .slide-item-img {\r\n            top: 0;\r\n            right: 0;\r\n            transform: inherit;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) and  (max-width: 1199px) {\r\n    .ltn__slide-item-3 {\r\n        .slide-item-img {\r\n            width: 45%;\r\n            right: 60px;\r\n            &.slide-img-left {\r\n                right: auto;\r\n                left: 60px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__slide-item-6 {\r\n        .slide-title {\r\n            font-size: 60px;\r\n        }\r\n    }\r\n    .ltn__slide-item.ltn__slide-item-10 {\r\n        height: 495px;\r\n    }\r\n    .ltn__slider-11 {\r\n        .slide-item-img {\r\n            top: 0;\r\n            right: 0;\r\n            transform: inherit;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n    .slide-title {\r\n        font-size: 36px;\r\n    }\r\n    .ltn__slide-item {\r\n        height: auto;\r\n    }\r\n    .liton-slide-item-inner {\r\n        height: inherit;\r\n    }\r\n    .slide-item-info-inner {\r\n        margin-bottom: 30px;\r\n    }\r\n    .ltn__slide-item-2 {\r\n        .slide-title {\r\n            font-size: 50px;\r\n        }\r\n        .slide-brief {\r\n            padding-left: 15px;\r\n        }\r\n    }\r\n    .ltn__slide-item-6 {\r\n        padding-top: 140px;\r\n    }\r\n    .ltn__slide-item-7 {\r\n        min-height: 550px;\r\n        height: auto;\r\n        .slide-title {\r\n            font-size: 60px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .slide-title {\r\n        font-size: 26px;\r\n    }\r\n    .liton-slide-item-inner {\r\n        height: inherit;\r\n    }\r\n    .slide-item-info-inner {\r\n        margin-bottom: 30px;\r\n    }\r\n    .slick-slide-arrow-1 .slick-arrow {\r\n        width: 40px;\r\n        height: 40px;\r\n        line-height: 38px;\r\n        font-size: 16px;\r\n    }\r\n    .ltn__slide-item-2 {\r\n        .slide-title {\r\n            font-size: 40px;\r\n        }\r\n        .slide-brief {\r\n            padding-left: 15px;\r\n        }\r\n        .btn-wrapper {\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n    .ltn__slide-item-3 {\r\n       .slide-item-img {\r\n            width: 100%;\r\n            position: relative;\r\n            height: auto;\r\n            right: auto;\r\n            bottom: auto;\r\n            img {\r\n                height: auto;\r\n            }\r\n        } \r\n    }\r\n    .ltn__slide-item-3 .text-right .slide-item-img {\r\n        right: auto;\r\n        left: auto;\r\n    }\r\n\r\n    .ltn__product-pointer > ul > li > ul {\r\n        min-width: 280px;\r\n    }\r\n    .ltn__product-pointer > ul > li > ul {\r\n        top: 110%;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n    }\r\n    .ltn__product-pointer > ul > li:hover ul {\r\n        top: 130%;\r\n    }\r\n    .ltn__product-pointer .ltn__product-pointer-inner::before {\r\n        left: 50%;\r\n        top: -25px;\r\n        transform: translateX(-50%) rotate(-90deg);\r\n    }\r\n    .slide-img-left .ltn__product-pointer .ltn__product-pointer-inner::before {\r\n        left: 50%;\r\n        transform: translateX(-50%) rotate(90deg);\r\n    }\r\n    .ltn__slide-item-5 {\r\n        .slide-item-img {\r\n            display: none;\r\n        }\r\n    }\r\n    .ltn__slide-item-6 {\r\n        .slide-title {\r\n            font-size: 40px;\r\n        }\r\n    }\r\n    .ltn__slide-item-7 {\r\n        min-height: 400px;\r\n        .slide-title {\r\n            font-size: 40px;\r\n        }\r\n    }\r\n    .ltn__slide-item-9 {\r\n        height: 560px;\r\n        .slide-item-info {\r\n            height: auto;\r\n            margin: 30px;\r\n        }\r\n        .ltn__slide-item-inner {\r\n            display: flex;\r\n            justify-content: space-around;\r\n        }\r\n        .slide-item-info-inner::before,\r\n        .slide-item-info-inner::after {\r\n            display: none;\r\n        }\r\n    }\r\n    .ltn__slider-11-img-slide-arrow {\r\n        right: 50%;\r\n        transform: translate(50%);\r\n    }\r\n    \r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    \r\n    .liton-slide-item-inner {\r\n        height: inherit;\r\n    }\r\n    .slide-item-info-inner {\r\n        margin-bottom: 30px;\r\n    }\r\n    .slide-title br {\r\n        display: none;\r\n    }\r\n    .slide-title {\r\n        font-size: 24px;\r\n    }\r\n    .ltn__slide-item-2 {\r\n        height: auto;\r\n        padding-top: 300px;\r\n        .slide-title {\r\n            font-size: 30px;\r\n        }\r\n        .slide-brief {\r\n            padding-left: 15px;\r\n        }\r\n    }\r\n    .ltn__slide-item-3-normal {\r\n        padding-top: 100px;\r\n    }\r\n    .ltn__product-pointer {\r\n        display: none;\r\n    }\r\n    .ltn__slide-item-6 {\r\n        .slide-title {\r\n            font-size: 30px;\r\n        }\r\n    }\r\n    \r\n\r\n}\r\n\r\n \r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","/* ----------------------------------------------------\n    Product Area\n---------------------------------------------------- */\n.ltn__product-item {\n    position: relative;\n    margin-bottom: 50px;\n}\n.product-img {\n    position: relative;\n    overflow: hidden;\n}\n.product-img img {\n    position: relative;\n    transition: all 3.5s ease 0s;\n}\n.product-img:before {\n    position: absolute;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--ltn__primary-color);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease 0s;\n}\n.ltn__product-item:hover .product-img:before {\n    opacity: 0.4;\n    visibility: visible;\n}\n.ltn__product-item {\n    &:hover {\n        .product-img {\n            &::before {\n                opacity: 0.4;\n                visibility: visible;\n            }\n        }\n    }\n}\n.product-title {\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n.product-ratting {\n    margin-bottom: 5px;\n}\n.product-ratting ul {\n    margin: 0;\n    padding: 0;\n}\n.product-ratting li {\n    display: inline-block;\n    margin: 0 -2px;\n    color: var(--ratings);\n    font-size: 12px;\n}\n.product-hover-action {\n    position: absolute;\n    top: 60%;\n    left: 0;\n    right: 0;\n    text-align: center;\n    transform: translateY(-50%);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease 0s;\n}\n.ltn__product-item:hover .product-hover-action {\n    top: 50%;\n    opacity: 1;\n    visibility: visible;\n}\n.product-hover-action ul {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    box-shadow: var(--ltn__box-shadow-3);\n}\n.product-hover-action li {\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n    font-size: 14px;\n    text-align: center;\n    float: left;\n    margin-right: 0px;\n    margin-top: 0;\n    list-style: none;\n    border-right: 1px solid var(--border-color-7);\n}\n.product-hover-action li:last-child {\n    margin-right: 0;\n    border-right: 0;\n}\n.product-hover-action li a {\n    display: block;\n    background-color: var(--white);\n    font-weight: 700;\n}\n.product-hover-action li:hover a {\n    background-color: var(--ltn__secondary-color);\n    color: var(--white);\n}\n.product-badge {\n    position: absolute;\n    top: 15px;\n    right: 18px;\n}\n.product-badge ul {\n    margin: 0;\n    padding: 0;\n}\n.product-badge li {\n    list-style: none;\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 600;\n    background-color: var(--ltn__secondary-color);\n    color: var(--white);\n    padding: 3px 15px 0px;\n    text-transform: uppercase;\n    line-height: 25px;\n    &:first-child {\n        margin-top: 0;\n    }\n    &::before {\n        position: absolute;\n        content: \"\";\n        bottom: -8px;\n        left: 0;\n        border-left: 8px solid var(--ltn__secondary-color);\n        width: 0;\n        height: 0;\n        border-bottom: 8px solid transparent;\n        display: none;\n    }\n    .soldout-badge {\n        background-color: var(--red-2);\n    }\n}\n.product-info {\n    padding: 20px 0 0;\n}\n.product-price {\n    color: var(--ltn__heading-color);\n    font-weight: 600;\n}\n.product-price del {\n    opacity: 0.6;\n    margin-left: 5px;\n    font-size: 80%;\n}\n.ltn__product-item .product-price {\n    margin-bottom: 12px;\n}\n.product-action ul {\n    margin: 10px 0 0;\n    padding: 0;\n}\n.product-action li {\n    display: inline-block;\n    margin-top: 0;\n}\n.product-action li a {\n    display: inline-block;\n    padding: 3px 15px;\n    border: 1px solid var(--ltn__heading-color);\n    color: var(--ltn__heading-color);\n    transition: all 0.3s ease 0s;\n}\n.product-action li:hover a {\n    background-color: var(--ltn__secondary-color);\n    color: var(--white);\n    border-color: var(--ltn__secondary-color);\n}\n\n.button-1 a {\n    display: inline-block;\n    padding: 5px 15px;\n    background-color: var(--ltn__heading-color);\n    color: var(--white);\n    transition: all 0.3s ease 0s;\n}\n.button-1:hover a {\n    background-color: var(--ltn__secondary-color);\n    color: var(--white);\n}\n.no-product-ratting {\n    .product-ratting {\n        display: none;\n    }\n}\n/* product-item-2 */\n.ltn__product-item-2 {\n    .product-img {\n        img {\n            background-color: var(--section-bg-1);\n        }\n    }\n    .product-price {\n        font-size: 14px;\n    }\n    .product-price del {\n        opacity: 1;\n        color: var(--red);\n        font-size: 13px;\n    }\n    &:hover {\n        .product-img {\n            img {\n                transform: scale(1.1);\n            }\n        }\n    }\n    \n}\n\n.ltn__product-item {\n    .add-to-cart {\n        width: auto;\n        text-transform: uppercase;\n        a {\n            padding: 0 15px;\n        }\n        span {\n            font-size: 12px;\n            line-height: 1;\n        }\n    }\n}\n\n/* product-item-3 */\n.ltn__product-item-3 {\n    border: 2px solid;\n    border-color: var(--border-color-8);\n    transition: all 0.3s ease 0s;\n    .product-img {\n        &::before {\n            display: none;\n        }\n    }\n    .product-info {\n        padding: 25px 30px 15px;\n    }\n    .product-price {\n        font-size: 14px;\n        color: var(--ltn__secondary-color);\n        font-weight: 700;\n        del {\n            font-size: 13px;\n            opacity: 0.6;\n        }\n    }\n    .product-info-brief {\n        border-top: 2px solid;\n        border-color: var(--border-color-8);\n        margin-bottom: 15px;\n        max-width: 400px;\n        ul {\n            margin: 0;\n            padding: 0;\n            display: flex;\n            justify-content: space-between;\n            li {\n                list-style: none;\n                display: inline-block;\n                font-size: 14px;\n                font-weight: 700;\n                i {\n                    color: var(--ltn__secondary-color);\n                    margin-right: 5px;\n                }\n            }\n        }\n    }\n    &:hover {\n        box-shadow: var(--ltn__box-shadow-1);\n        .product-hover-action {\n            top: 70%;\n        }\n    }\n}\n\n/* product-item-4 */\n.ltn__product-item-4 {\n    box-shadow: var(--ltn__box-shadow-4);\n    border: 1px solid;\n    border-color: var(--border-color-13);\n    background-color: var(--white);\n    .product-img {\n        position: relative;\n        a {\n            display: block;\n        }\n        img {\n            transition: all 0.5s ease 0s;\n        }\n    }\n    .product-img-location-gallery {    \n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 30px 15px;\n        margin: 0;\n        background: var(--gradient-color-5);\n        ul {\n            padding: 0;\n            margin: 0;\n            position: relative;\n            z-index: 2;\n            li {\n                list-style: none;\n                font-size: 14px;\n                color: var(--white);\n            }\n        }\n        .product-img-gallery {\n            margin-left: 10px;\n            ul {\n                li {\n                    display: inline-block;\n                    width: 42px;\n                    height: 30px;\n                    line-height: 30px;\n                    background-color: rgba(255,255,255, 0.3);\n                    margin-right: 5px;\n                    text-align: center;\n                    a {\n                        display: block;\n                    }\n                    &:last-child {\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n    .product-info {\n        padding: 30px 30px 1px;\n    }\n    .product-price {\n        font-size: 18px;\n        font-family: var(--ltn__heading-font);\n        font-weight: 600;\n        color: var(--ltn__secondary-color);\n        margin-bottom: 5px;\n        label {\n            font-weight: 400;\n            font-size: 14px;\n        }\n    }\n    .product-title {\n        font-size: 22px;\n        margin-bottom: 15px;\n        font-weight: 600;\n    }\n    .product-description {\n        p {\n            font-size: 14px;\n            margin-bottom: 15px;\n        }\n    }\n    .product-info-bottom {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid;\n        border-color: var(--border-color-1);\n        padding: 20px 30px 30px;\n    }\n    .product-hover-action {\n        position: relative;\n        opacity: 1;\n        visibility: visible;\n        transform: inherit;\n        line-height: 1;\n        ul {\n            box-shadow: none;\n            li {    \n                margin-right: 8px;\n                height: 36px;\n                width: 36px;\n                line-height: 42px;\n                border-right: 0;\n                font-size: 16px;\n                background-color: var(--section-bg-1);\n                transition: all 0.3s ease 0s;\n                a {\n                    background-color: transparent;\n                }\n                &:hover {\n                    background-color: var(--ltn__secondary-color);\n                    color: var(--white);\n                }\n            }\n        }\n    }\n    &:hover {\n        .product-img {\n            img {\n                transform: scale(1.1);\n            }\n            &::before {\n                display: none;\n            }\n        }\n    }\n}\n.real-estate-agent {\n    display: flex;\n    .agent-img {\n        max-width: 40px;\n        margin-right: 12px;\n        img {\n            border-radius: 100%;\n        }\n    }\n    .agent-brief {\n        h6 {\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 600;\n        }\n        small {\n            font-size: 12px;\n        }\n    }\n}\n\n/* product-item-5 */\n.ltn__product-item-5 {\n    margin-top: 0;\n    .product-img {\n        margin-top: 0;\n        a {\n            display: block;\n        }\n    }\n    .product-info {\n        margin-top: 0;\n    }\n    .product-info-bottom {\n        padding: 20px 30px 15px;\n    }\n    .product-badge {\n        position: inherit;\n        margin-bottom: 15px;\n        li {\n            font-size: 16px;\n            background-color: transparent;\n            color: var(--ltn__secondary-color);\n            padding: 0;\n        }\n    }\n    .product-img-location {\n        ul {\n            padding: 0;\n            margin-bottom: 0;\n            li {\n                list-style: none;\n                font-size: 14px;\n                i {\n                    color: var(--ltn__secondary-color);\n                    padding-left: 0;\n                }\n            }\n        }\n    }\n    .ltn__plot-brief {\n        padding: 0;\n        margin-bottom: 20px;\n        li {\n            list-style: none;\n            display: inline-block;\n            margin-right: 10px;\n            font-size: 14px;\n            &:last-child {\n                margin-right: 0;\n            }\n            span {\n                font-weight: 700;\n            }\n        }\n    }\n    .real-estate-agent {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        transition: all 0.3s ease 0s;\n        .agent-img {\n            max-width: 50px;\n            img {\n                border: 3px solid;\n                border-color: var(--border-color-1);\n            }\n        }\n    }\n    .product-hover-action {\n        text-align: left;\n        margin-bottom: 25px;\n    }\n}\n.ltn__product-list-view {\n    .ltn__product-item-5 {\n        padding: 30px 30px 30px;\n        .real-estate-agent {\n            position: inherit;\n            margin-top: 15px;\n        }\n        .product-info-bottom {\n            padding: 0px 0px 0px 30px;\n            border: 0;\n        }\n        .product-hover-action {\n            margin-bottom: 0;\n        }\n        .ltn__plot-brief {\n            margin-bottom: 5px;\n        }\n        .product-badge-price {\n            display: flex;\n            justify-content: space-between;\n        }\n    }\n}\n\n/* ----------------------------------------------------\n    Modal Area\n---------------------------------------------------- */\n.modal-dialog {\n    margin-top: 150px;\n}\n.modal-content {\n    border-radius: 0;\n}\n.modal-header {\n    padding: 0;\n    border: 0;\n    .close {\n        position: absolute;\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n        padding: 0;\n        right: 16px;\n        left: auto;\n        top: 16px;\n        opacity: 1;\n        z-index: 1;\n        transition: all 0.3s ease 0s;\n        span {\n            display: block;\n            font-size: 25px;\n        }\n        &:not(:disabled):not(.disabled):focus, \n        &:not(:disabled):not(.disabled):hover,\n        &:hover {\n            opacity: 1;\n        }\n    }\n}\n@media (min-width: 992px) {\n    .modal-lg {\n        max-width: 980px;\n    }\n}\n.modal-product-info {\n    padding-left: 25px;\n}\n.modal-product-info h3 {\n    font-size: 24px;\n    margin-bottom: 10px;\n}\n.modal-product-info hr {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.modal-product-info .product-price {\n    font-size: 50px;\n    margin-bottom: 10px;\n    color: var(--ltn__secondary-color);\n    line-height: 1.2;\n    font-weight: 600;\n}\n.modal-product-meta > ul {\n    margin: 15px 0;\n    padding: 20px 0;\n    border-bottom: 1px solid var(--border-color-12);\n    border-top: 1px solid var(--border-color-12);\n}\n.modal-product-meta > ul > li {\n    list-style: none;\n    font-size: 14px;\n    margin-top: 10px;\n    &:first-child {\n        margin-top: 0;\n    }\n}\n.modal-product-meta li strong {\n    color: var(--ltn__heading-color);\n    margin-right: 5px;\n    font-weight: 600;\n    min-width: 100px;\n    display: inline-block;\n}\n.modal-product-quantity input {\n    border: 1px solid #e5e5e5;\n    float: left;\n    height: 45px;\n    text-align: center;\n    width: 80px;\n    margin-right: 20px;\n}\n.modal-btn {\n    margin-top: 15px;\n    border-top: 1px solid #f1f1f1;\n    text-align: right;\n}\n.modal-btn a {\n    font-size: 14px;\n    color: var(--ltn__heading-color);\n    padding: 5px 10px;\n}\n.ltn__modal-area {\n    .modal-btn {\n        border: 0;\n    }\n}\n.modal-body {\n    padding: 30px;\n}\n\n.ltn__add-to-cart-modal-area {\n    .modal-body {\n        padding: 30px;\n    }\n    .modal-product-img {\n        float: left;\n        max-width: 125px;\n        margin-right: 20px;\n    }\n    .modal-product-info {\n        overflow: hidden;\n    }\n    .added-cart {\n        i {\n            color: var(--green);\n        }\n    }\n    .btn-wrapper {\n        margin-top: 20px;\n        .btn {\n            padding: 5px 20px;\n            margin-right: 10px;\n        }\n    }\n    .additional-info {\n        border-top: 1px solid var(--border-color-1);\n        text-align: center;\n        padding-top: 30px;\n        margin-top: 40px;\n    }\n}\n\n.modal-backdrop.show {\n    opacity: .7;\n}\n\n/* ----------------------------------------------------\n    Product Tab\n---------------------------------------------------- */\n.ltn__tab-menu {\n    margin-bottom: 50px;\n}\n.ltn__tab-menu .nav {\n    display: inline-block;\n}\n.ltn__gallery-filter-menu button,\n.ltn__tab-menu a {\n    display: inline-block;\n    padding: 15px 40px;\n    margin-right: 5px;\n    margin-bottom: 10px;\n    color: var(--ltn__heading-color);\n    background-color: var(--section-bg-1);\n    font-weight: 700;\n    &:last-child {\n        margin-right: 0;\n    }\n    i {\n        margin-right: 10px;\n    }\n}\n.ltn__gallery-filter-menu .active,\n.ltn__tab-menu a.active {\n    color: var(--white);\n    background-color: var(--ltn__primary-color);\n    border-color: var(--ltn__primary-color);\n}\n.ltn__tab-menu-top-left {\n    position: absolute;\n    left: 15px;\n    top: 0;\n}\n.ltn__tab-menu-top-right {\n    position: absolute;\n    right: 15px;\n    top: 0;\n}\n.ltn__gallery-filter-menu {\n    &.text-uppercase {\n        button {\n            text-transform: uppercase;\n        }\n    }\n}\n\n.ltn__tab-menu-2 {\n    a {\n        background-color: transparent;\n        border-bottom: 2px solid transparent;\n        position: relative;\n        &.active {\n            color: var(--ltn__secondary-color);\n            background-color: transparent;\n            border-color: var(--ltn__secondary-color);\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            right: -5px;\n            top: 50%;\n            transform: translateY(-50%);\n            height: 16px;\n            width: 2px;\n            background-color: var(--ltn__color-1);\n            opacity: 0.4;\n        }\n        &:last-child::before {\n            display: none;\n        }\n    }\n}\n.ltn__tab-menu-3 {\n    margin-top: 0;\n    a {\n        background-color: transparent;\n        border-bottom: 2px solid transparent;\n        padding: 1px;\n        margin-right: 50px;\n        font-weight: 600;\n        font-size: 20px;\n        line-height: 1.2;\n        position: relative;\n        &.active {\n            color: var(--ltn__secondary-color);\n            background-color: transparent;\n            border-color: var(--ltn__secondary-color);\n            &::before {\n                background-color: var(--ltn__secondary-color);\n                border: 3px solid var(--white);\n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            right: 45%;\n            top: 100%;\n            transform: translateY(-40%);\n            height: 10px;\n            width: 10px;\n            background-color: transparent;\n            opacity: 1;\n            border: 3px solid transparent;\n            border-radius: 100%;\n        }\n    }\n}\n\n.ltn__tab-menu-4 {\n    a {\n        background-color: transparent;\n        padding: 0;\n        border: 7px solid;\n        border-color: var(--white);\n        img {\n            max-width: 120px;\n        }\n        &.active {\n            color: var(--ltn__secondary-color);\n            background-color: transparent;\n            border-color: var(--white);\n            &::before {\n                display: none;\n            }\n            img {\n                opacity: 0.6;\n            }\n        }\n    }\n}\n\n@media (max-width: 1200px) {\n    .ltn__tab-menu-3 {\n        a {\n            margin-right: 30px;\n            font-size: 18px;\n        }\n    }\n\n}\n\n@media (max-width: 991px) {\n    .ltn__gallery-filter-menu button, \n    .ltn__tab-menu a {\n        padding: 15px 25px;\n        font-size: 14px;\n    }\n    .ltn__tab-menu-top-right {\n        position: initial;\n    }\n    .ltn__tab-menu-3 {\n        margin-top: 0;\n        a {\n            padding: 1px;\n            margin-right: 20px;\n        }\n    }\n    .ltn__tab-menu-4 {\n        a {\n            padding: 0;\n            &.active {\n                padding: 0;\n            }\n        }\n    }\n\n}\n\n/* ----------------------------------------------------\n    Product Details\n---------------------------------------------------- */\n.ltn__small-product-item {\n    background-color: var(--white);\n    display: flex;\n    padding: 30px 25px;\n    border: 2px solid;\n    border-color: var(--border-color-1);\n    margin-bottom: 30px;\n    transition: all 0.3s ease 0s;\n    &:hover {\n        box-shadow: var(--ltn__box-shadow-1);\n        border-color: transparent;\n    }\n    .product-price {\n        color: var(--ltn__secondary-color);\n    }\n}\n.small-product-item-img {\n    max-width: 90px;\n    margin-right: 20px;\n}\n\n/* ----------------------------------------------------\n    Product Details\n---------------------------------------------------- */\n.product-meta-date input[type=\"date\"] {\n    border: 1px solid #ddd;\n    height: 63px;\n    padding: 0 15px;\n    line-height: 50px;\n}\n.product-meta-date input[type=\"date\"]::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: pink;\n    line-height: 50px;\n}\n.product-meta-date input[type=\"date\"]::-moz-placeholder { /* Firefox 19+ */\n  color: pink;\n    line-height: 50px;\n}\n.product-meta-date input[type=\"date\"]:-ms-input-placeholder { /* IE 10+ */\n  color: pink;\n    line-height: 50px;\n}\n.product-meta-date input[type=\"date\"]:-moz-placeholder { /* Firefox 18- */\n  color: pink;\n    line-height: 50px;\n}\n/* ltn__shop-details-img-gallery */\n.ltn__shop-details-img-gallery {\n    margin-bottom: 35px;\n    img {\n        background-color: var(--white-8);\n    }\n}\n.ltn__shop-details-small-img {\n    margin-top: 20px;\n    margin-left: -5px;\n    margin-right: -5px;\n    .single-small-img {\n        padding: 0 5px;\n        &.slick-current {\n            img {\n                border: 1px solid var(--ltn__secondary-color);\n                margin-bottom: 10px;\n            }\n        } \n    }\n}\n.ltn__shop-details-small-img.slick-arrow-2 {\n    margin-bottom: 35px;\n    .slick-arrow {\n        left: 5px;\n        bottom: -35px;\n    }\n    .slick-next {\n        left: 45px;\n    }\n}\n\n/* ltn__shop-details-content-wrap */\n.ltn__shop-details-content-wrap {\n    padding: 50px 50px 40px;\n}\n\n/* ltn__shop-details-tab-area */\n.ltn__shop-details-tab-menu {\n    .nav {\n        display: flex;\n        flex-wrap: wrap;\n        a {\n            background-color: var(--ltn__primary-color);\n            color: var(--white);\n            padding: 20px 20px;\n            font-size: 16px;\n            flex: 1 0 auto;\n            text-align: center;\n            font-weight: 700;\n            &.active {\n                background-color: var(--ltn__secondary-color);\n            }\n        }\n    }\n}\n.ltn__shop-details-tab-content-inner {\n    border: 1px solid #e5e5e5;\n    padding: 50px 50px 30px;\n    background-color: var(--section-bg-1);\n    .ltn__comment-reply-area form {\n        padding: 0;\n    }\n}\n.add-a-review {\n    display: flex;\n    align-items: center;\n    h6 {\n        margin-bottom: 0;\n        margin-right: 15px;\n    }\n}\n\n.ltn__shop-details-tab-inner-2 {\n    .ltn__shop-details-tab-menu {\n        border-bottom: 2px solid var(--border-color-1);\n        .nav {\n            display: flex;\n            flex-wrap: wrap;\n            a {\n                background-color: transparent;\n                color: var(--ltn__paragraph-color);\n                padding: 20px 0px;\n                margin-right: 50px;\n                flex: inherit;\n                text-align: left;\n                position: relative;\n                &::before {\n                    position: absolute;\n                    content: \"\";\n                    bottom: -2px;\n                    left: 0;\n                    width: 0%;\n                    height: 2px;\n                    background-color: transparent;\n                    transition: all 0.3s ease 0s;\n                }\n                &.active {\n                    color: var(--ltn__secondary-color);\n                    background-color: transparent;\n                    &::before {\n                        background-color: var(--ltn__secondary-color);\n                        width: 100%;\n                    }\n                }\n            }\n        }\n    }\n    .ltn__shop-details-tab-content-inner {\n        border: 0;\n        padding: 30px 0px 0px;\n        background-color: transparent;\n        .ltn__comment-reply-area form {\n            padding: 30px;\n        }\n    }\n}\n\n/* product-details-menu-1 */\n.ltn__product-details-menu-1 {\n    ul {\n        li {\n            a {\n                position: relative;\n                margin-right: 10px;\n                &::before {\n                    position: absolute;\n                    content: \",\";\n                    right: -5px;\n                }\n                &:last-child::before {\n                    display: none;\n                }\n            }\n            strong {\n                font-weight: 400;\n            }\n            span {\n                font-weight: 600;\n            }\n        }\n    }\n    .ltn__color-widget ul li a {\n        width: 15px;\n        height: 15px;\n    }\n    .ltn__tagcloud-widget ul li {\n        margin: 0;\n        a {\n            padding: 3px 10px 1px;\n        }\n    } \n}\n\n/* product-details-menu-2 */\n.ltn__product-details-menu-2 {\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n            display: inline-block;\n            margin-right: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}\n\n/* product-details-menu-3 */\n.ltn__product-details-menu-3 {\n    ul {\n        padding: 0;\n        margin: 0;\n        li {\n            list-style: none;\n            display: inline-block;\n            margin-right: 20px;\n            font-size: 14px;\n            font-weight: 600;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}\n.property-detail-info-list {\n    ul {\n        padding: 30px 50px 40px;\n        margin: 0;\n        float: left;\n        border-right: 1px solid;\n        border-color: var(--border-color-7);\n        &:last-child {\n            border-right: none;\n        }\n        li {\n            display: block;\n            label {\n                margin-right: 5px;\n                font-weight: 600;\n                min-width: 110px;\n                display: inline-block;\n            }\n            span {\n                font-weight: 600;\n                color: var(--ltn__heading-color);\n            }\n        }\n    }\n}\n.property-detail-feature-list {\n    margin-top: 0;\n    ul {\n        margin: 0;\n        padding: 0;\n        li {\n            display: inline-block;\n            min-width: 170px;\n            margin-right: 19px;\n            margin-bottom: 15px;\n        }\n    }\n    .property-detail-feature-list-item {\n        display: flex;\n        align-items: center;\n        line-height: 1;\n        i {\n            margin-right: 12px;\n            width: 40px;\n            min-width: 40px;\n            height: 40px;\n            line-height: 49px;\n            background-color: var(--section-bg-5);\n            text-align: center;\n            font-size: 22px;\n            color: var(--ltn__secondary-color);\n        }\n        h6 {\n            margin-top: 0;\n            margin-bottom: 6px;\n            font-size: 14px;\n            font-family: var(--ltn__heading-font);\n            font-weight: 500;\n        }\n    }\n}\n.property-details-google-map {\n    height: 360px;\n}\n.product-details-apartments-plan {\n    .apartments-plan-info {\n        padding: 0;\n    }\n}\n.product-details-apartments-info-list {\n    padding: 20px 40px;\n}\n.ltn__page-details-inner {\n    .ltn__product-details-review-inner {\n        margin-top: 0;\n        h1,\n        h2,\n        h3,\n        h4,\n        h5,\n        h6,\n        p {\n            margin-top: 0;\n        }\n    }\n}\n\n@media (max-width: 767px) {\n    .property-detail-info-list {\n        ul {\n            padding: 20px 30px 20px;\n            float: none;\n            border: none;\n        }\n    }\n}\n\n/* ----------------------------------------------------\n    Product Options\n---------------------------------------------------- */\n.nice-select .option {\n    margin-top: 0;\n    white-space: normal;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: 1.8;\n}\n.nice-select .list {\n    min-width: 100%;\n}\n.ltn__shop-options {\n    margin-bottom: 50px;\n    & > ul {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 30px;\n        margin: 0;\n        padding: 0;\n        & > li {\n            list-style: none;\n            margin-top: 0;\n            line-height: 50px;\n            margin-right: 30px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    .short-by {\n        .nice-select {\n            border-radius: 0;\n            border: 2px solid #ededed;\n            height: 50px;\n            line-height: 46px;\n            min-width: 190px;\n            .option {\n                width: 100%;\n                padding-left: 10px;\n                padding-right: 5px;\n            }\n            .current {\n                font-weight: 700;\n            }\n        }\n    }\n}\n.ltn__grid-list-tab-menu a {\n    font-size: 30px;\n    margin-right: 20px;\n}\n.ltn__grid-list-tab-menu a:last-child {\n    margin-right: 0px;\n}\n.ltn__grid-list-tab-menu .active {\n    color: var(--ltn__secondary-color);\n}\n.showing-product-number span {\n    font-weight: 500;\n    font-size: 16px;\n    font-family: var(--ltn__heading-font);\n}\n\n.ltn__product-list-view .product-title {\n    font-size: 22px;\n    margin-bottom: 10px;\n}\n.ltn__product-list-view .ltn__product-item:after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n.ltn__product-list-view .ltn__product-item .product-img {\n    max-width: 40%;\n    float: left;\n}\n.ltn__product-list-view {\n    .ltn__product-item {\n       .product-info {\n            overflow: hidden;\n            padding: 0 0 0 30px;\n        }  \n    }\n    .ltn__product-item-3 {\n       .product-info {\n            overflow: hidden;\n            padding: 25px 25px 20px 30px;\n        }  \n    }\n} \n\n.ltn__product-list-view .product-hover-action {\n    position: inherit;\n    transform: inherit;\n    text-align: left;\n    opacity: 1;\n    visibility: visible;\n    margin-top: 15px;\n}\n\n\n/* Bootstrap Tab with Slider Issue Fix Start */\n.tab-content {\n    width: 100%; \n}\n.tab-content .tab-pane {\n    display: block;\n    height: 0;\n    max-width: 100%;\n    visibility: hidden;\n    overflow: hidden;\n    opacity: 0; \n}\n.tab-content .tab-pane.active {\n    height: auto;\n    visibility: visible;\n    opacity: 1;\n    overflow: visible; \n}\n/* Bootstrap Tab with Slider Issue Fix End */\n\n@media (max-width: 1400px) {\n    .shop-details-info {\n        .product-price {\n            font-size: 36px;\n        }\n        .cart-plus-minus {\n            width: 130px;\n        }\n        .ltn__product-details-menu-2 {\n            .btn {\n                padding: 17px 15px;\n            }\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .ltn__product-item-3 {\n        .product-info {\n            padding: 25px 15px 15px;\n        }\n        .product-price {\n            font-size: 16px;\n            del {\n                font-size: 14px;\n            }\n        }\n    } \n    .ltn__shop-details-img-gallery {\n        margin-bottom: 75px;\n    }\n    .ltn__product-item-4 {\n        .product-title {\n            font-size: 20px;\n        }\n        .product-info {\n            padding: 30px 20px 1px;\n        }\n        .product-img-location-gallery {\n            padding: 0 15px 15px;\n            flex-flow: wrap-reverse;\n            ul {\n                li {\n                    font-size: 13px;\n                    margin-top: 5px;\n                }\n            }\n            .product-img-gallery {\n                margin-left: 0;\n                ul {\n                    li {\n                        width: inherit;\n                        background-color: transparent;\n                        margin-top: 0;\n                    }\n                }\n            }\n        }\n        .product-description p br {\n            display: none;\n        }\n        .product-info-bottom {\n            padding: 20px 20px 20px;\n            flex-flow: wrap-reverse;\n        }\n        .real-estate-agent {\n            margin-top: 20px;\n        }\n    }\n    .slick-slide {\n        .ltn__product-item-4 { \n            box-shadow: none;\n        }\n    }\n}\n\n@media (max-width: 767px) {\n    .ltn__shop-options > ul {\n        align-items: flex-start;\n        flex-flow: column;\n    }\n    .ltn__shop-options ul li {\n        margin: 5px 0;\n    }\n    .showing-product-number span {\n        font-size: 16px;\n    }\n    .ltn__product-list-view {\n        .ltn__product-item {\n            .product-img {\n                max-width: 100%;\n            }\n            .product-info {\n                padding: 25px 0 0 1px;\n            }\n        }\n        .ltn__product-item-3 {\n            .product-info {\n                padding: 25px 25px 20px 30px;\n            }\n        } \n    }\n    .modal-product-info {\n        h3 {\n            font-size: 22px;\n        }\n        .product-price {\n            font-size: 34px;\n        }\n    }\n    .ltn__shop-details-tab-menu .nav a {\n        padding: 15px 15px;\n        font-size: 14px;\n    }\n    .ltn__shop-details-tab-content-inner {\n        padding: 50px 20px 30px;\n    }\n    .ltn__product-item-4 {\n        .product-title {\n            font-size: 18px;\n        }\n    }\n    .ltn__product-list-view {\n        .ltn__product-item-5 {\n            .product-info-bottom {\n                padding: 0px 0px 0px 0px;\n                border: 0;\n            }\n        }\n    }\n\n}\n\n\n@media (max-width:576px) {\n    .product-hover-action li {\n        height: 35px;\n        width: 35px;\n        line-height: 35px;\n        font-size: 13px;\n    }\n    .product-badge li {\n        font-size: 12px;\n        padding: 1px 10px;\n        line-height: 20px;\n        &::before {\n            bottom: -6px;\n        }\n    }\n    .ltn__product-item-3 {\n        .product-title {\n            font-size: 14px;\n        }\n        .product-info {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n       .product-price {\n           font-size: 14px;\n            del {\n                font-size: 13px;\n            }  \n       } \n       .product-info-brief ul li {\n            font-size: 12px;\n        }\n        \n    }\n    .ltn__product-item-2 {\n        .product-title {\n            font-size: 14px;\n        }\n    }\n\n}\n\n/* ----------------------------------------------------\n    END\n---------------------------------------------------- */","/* ----------------------------------------------\n  Gallery Area\n---------------------------------------------- */\n.ltn__gallery-item {\n  margin-bottom: 30px;\n  &:hover {\n    .ltn__gallery-item-img {\n      &::before {\n        opacity: 0.8;\n        visibility: visible;\n      }\n      img {\n        transform: scale(1.1);\n      }\n    }\n    .ltn__gallery-action-icon {\n      top: 50%;\n      opacity: 1;\n      visibility: visible;\n    }    \n  }\n}\n.ltn__gallery-item-inner {\n  position: relative;\n  overflow: hidden;\n  h4 {\n    margin-bottom: 5px;\n  }\n  p {\n    margin-bottom: 0;\n    font-size: 14px;\n  }\n}\n.ltn__gallery-item-img {\n  position: relative;\n  overflow: hidden;\n  &::before {\n    position: absolute;\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    background-color: var(--ltn__primary-color);\n    pointer-events: none;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease 0s;\n    z-index: 1;\n  }\n  img {\n    transition: all 3.5s ease 0s;\n  }\n}\n.ltn__gallery-action-icon {\n  position: absolute;\n  top: 45%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  text-align: center;\n  font-size: 16px;\n  transform: translateY(-50%);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.5s ease 0s;\n  z-index: 2;\n  i {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    background-color: var(--white);\n    color: var(--ltn__primary-color);\n    border-radius: 100%;\n    margin: 3px;\n    transition: all 0.3s ease 0s;\n    &:hover {\n      background-color: var(--ltn__secondary-color);\n      color: var(--white);\n    }\n  }\n}\n.ltn__gallery-item-info {\n  padding: 25px 30px;\n  position: relative;\n  z-index: 2;\n}\n\n/* Gallery Style 1 */\n.ltn__gallery-style-1 {\n  .ltn__gallery-item-info {\n    border: 1px solid var(--border-color-1);\n    border: 0;\n  }\n}\n\n/* Gallery Style 2 */\n.ltn__gallery-style-2 {\n  .ltn__gallery-item-info {\n    position: absolute;\n    bottom: -30px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    text-align: center;\n    background: var(--gradient-color-3);\n    transition: all 0.3s ease 0s;\n    opacity: 0;\n    visibility: hidden;\n  }\n  h4, p {\n    color: var(--white);\n  }\n  .ltn__gallery-item {\n    &:hover {\n        .ltn__gallery-item-info {\n          bottom: 0px;\n          opacity: 1;\n          visibility: visible;\n        }\n        .ltn__gallery-action-icon {\n          top: 35%;\n        }\n    }\n  }\n}\n.ltn__gallery-info-hide {\n  .ltn__gallery-item-info {\n    display: none;\n  }\n  .ltn__gallery-item {\n    &:hover {\n        .ltn__gallery-action-icon {\n          top: 50%;\n        }\n    }\n  }\n}\n\n/* Lightcase Default CSS */\n.lightcase-error {\n  color: var(--white);\n}\n#lightcase-info {\n  color: var(--ltn__color-1);\n}\n#lightcase-caption {\n  color: var(--white);\n}\n\n/* ----------------------------------------------------\n    END\n---------------------------------------------------- */","/* ============================================================\r\n>>> TABLE OF CONTENTS:\r\n===============================================================\r\n# Common CSS\r\n# Section title\r\n# Category Area\r\n# Feature Area \r\n# Countdown Area\r\n# Blog Area\r\n# Blog Details\r\n# Service Details\r\n# Pagination\r\n# Testimonial\r\n# Banner Area\r\n# Team Area\r\n# CounterUp Area\r\n# Contact Form Area\r\n# Cart Table Area\r\n# Cart plus minus\r\n# Product Details\r\n# Shoping Cart\r\n# Custom Content\r\n# Newsletter\r\n# Faq Area\r\n# 404 Area\r\n# Coming Soon Area\r\n# Screenshot Area\r\n# Pricing List Area\r\n# Checkbox\r\n# Body Sidebar Icons\r\n# About Us Area\r\n# Why Choose Us Area\r\n# Service Area\r\n# Call To Action\r\n# Elements Area\r\n# Service Form \r\n# Get A Quote Form\r\n# Car Dealer Form\r\n# Video Area\r\n# Brand Logo\r\n# Progress Bar \r\n# Our Journey Area\r\n# Google Map Locations Area\r\n# Team Details\r\n# Our History Area\r\n# Appointment Form Area\r\n# Checkout Page\r\n# Myaccount Page\r\n# Time Schedule Area\r\n\r\n============================================================= */\r\n\r\n/* ----------------------------------------------------\r\n    Common CSS\r\n---------------------------------------------------- */\r\n.ltn__social-media {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin: 0 15px 0 0;\r\n            &:last-child {\r\n                margin: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__social-media-2 {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-right: 10px;\r\n            a {\r\n                background-color: var(--section-bg-1);\r\n                color: var(--ltn__paragraph-color);\r\n                display: block;\r\n                width: 40px;\r\n                height: 40px;\r\n                line-height: 40px;\r\n                text-align: center;\r\n                i {\r\n                    color: inherit;\r\n                }\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            &:hover {\r\n                a {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__social-media-3 {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-right: 10px;\r\n            a {\r\n                background-color: var(--white);\r\n                color: var(--ltn__paragraph-color);\r\n                border: 2px solid var(--border-color-11);\r\n                display: block;\r\n                width: 50px;\r\n                height: 50px;\r\n                line-height: 46px;\r\n                text-align: center;\r\n                i {\r\n                    color: inherit;\r\n                }\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            &:hover {\r\n                a {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    border-color: var(--ltn__secondary-color); \r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.bg-image {\r\n\r\n    background-image: url(../../img/hero1.jpeg);\r\n    background-size: cover;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.bg-quote {\r\n\r\n  background-image: url(../../img/quotation.png);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-2 {\r\n\r\n    background-image: url(../../img/hero2.jpeg);\r\n    background-size: cover;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n}\r\n.bg-image-3 {\r\n\r\n    background-image: url(../../img/hero3.jpeg);\r\n    background-size: cover;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n}\r\n.bg-image-4 {\r\n  \r\n      background-image: url(../../img/calling.jpg);\r\n      background-size: cover;\r\n      background-position: center center;\r\n      background-repeat: no-repeat;\r\n  }\r\n  .bg-image-5 {\r\n  \r\n    background-image: url(../../img/values.jpg);\r\n    background-size: cover;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-6 {\r\n  \r\n  background-image: url(../../img/clinical.jpeg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-7 {\r\n  \r\n  background-image: url(../../img/about2.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-8 {\r\n  height:fit-content;\r\n  background-image: url(../../img/training.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-9 {\r\n  height:fit-content;\r\n  background-image: url(../../img/team.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-10 {\r\n  height:fit-content;\r\n  background-image: url(../../img/work-with.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-11 {\r\n  height:fit-content;\r\n  background-image: url(../../img/funding.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-12 {\r\n  height:fit-content;\r\n  background-image: url(../../img/hero3.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-13 {\r\n  height:fit-content;\r\n  background-image: url(../../img/supported.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-14 {\r\n  height:fit-content;\r\n  background-image: url(../../img/home.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-15 {\r\n  height:fit-content;\r\n  background-image: url(../../img/consulting.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-16 {\r\n  height:fit-content;\r\n  background-image: url(../../img/specialist.jpeg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-17 {\r\n  height:fit-content;\r\n  background-image: url(../../img/brain-injury.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-18 {\r\n  height:fit-content;\r\n  background-image: url(../../img/spinal-cord.jpg);\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-19 {\r\n  position: relative;\r\n  background-image: url(../../img/join-us.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-20 {\r\n  position: relative;\r\n  background-image: url(../../img/learning.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-21 {\r\n  position: relative;\r\n  background-image: url(../../img/nursingcare.jpeg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n.bg-image-22 {\r\n  position: relative;\r\n  background-image: url(../../img/neurological.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-23 {\r\n  position: relative;\r\n  background-image: url(../../img/children.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-24 {\r\n  position: relative;\r\n  background-image: url(../../img/ventilation.jpeg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-25 {\r\n  position: relative;\r\n  background-image: url(../../img/recruit.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-26 {\r\n  position: relative;\r\n  background-image: url(../../img/workWithQuality.jpeg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-27 {\r\n  position: relative;\r\n  background-image: url(../../img/train.jpeg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-28 {\r\n  position: relative;\r\n  background-image: url(../../img/reward.jpg);\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.bg-image-top {\r\n    background-size: auto;\r\n    background-position: top center;\r\n    background-repeat: no-repeat;\r\n}\r\n.bg-image-right-before {\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        background-size: cover;\r\n        background-position: center center;\r\n        background-repeat: no-repeat;\r\n        background-image: url(../../img/bg/21.jpg);\r\n        height: 100%;\r\n        width: 48%;\r\n        left: auto;\r\n        right: 0;\r\n        top: 0;\r\n    }\r\n}\r\n\r\n.bg-image-left-before {\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        background-size: cover;\r\n        background-position: center center;\r\n        background-repeat: no-repeat;\r\n        background-image: url(../../img/others/1.png);\r\n        height: 100%;\r\n        width: 48%;\r\n        left: 0;\r\n        right: auto;\r\n        top: 0;\r\n    }\r\n}\r\n.nice-select .option {\r\n    font-weight: 400;\r\n}\r\n \r\n/* Responsive Device under :991px. */\r\n@media (max-width: 991px) {\r\n    .bg-image-top {\r\n        background-size: inherit;\r\n    }\r\n    .bg-image-right-before,\r\n    .bg-image-left-before {\r\n        &::before {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__social-media-4 {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-right: 10px;\r\n            a {\r\n                background-color: var(--ltn__primary-color-3);\r\n                color: var(--white);\r\n                display: block;\r\n                width: 50px;\r\n                height: 50px;\r\n                line-height: 50px;\r\n                text-align: center;\r\n                border-radius: 100%;\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            &:hover {\r\n                a {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }  \r\n}\r\n\r\n/* ----------------------------------------\r\n  Section title\r\n---------------------------------------- */\r\n.section-title-area {\r\n    margin-bottom: 50px;\r\n    p {\r\n        margin-bottom: 0;\r\n        max-width: 600px;\r\n    }\r\n    p + p {\r\n        margin-top: 15px;\r\n    }\r\n    &.text-right {\r\n        p {\r\n            margin-left: auto;\r\n        }\r\n    }\r\n    &.text-center {\r\n        p {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n\r\n}\r\n.section-title {\r\n    font-size: 44px;\r\n    font-weight: 700;\r\n    line-height: 1.3;\r\n    span {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    p{\r\n        font-size: 16px;\r\n        line-height: 1.8;\r\n        color: var(--ltn__paragraph-color);\r\n        margin-top: 20px;\r\n    }\r\n    &.white{\r\n        .section-title{\r\n            color: var(--white);\r\n        }\r\n        p{\r\n            color: rgba(var(--white),.7);\r\n        }\r\n    }\r\n\r\n\r\n}\r\n/* ltn__separate-line */\r\n.ltn__separate-line {\r\n    position: relative;\r\n    display: inline-block;\r\n    min-width: 200px;\r\n    margin-bottom: 3px;\r\n    text-align: center !important;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 0;\r\n        width: 100%;\r\n        height: 1px;\r\n        background: linear-gradient(90deg, rgba(242,139,194,1) 0%, rgba(216,177,242,1) 50%);\r\n    }\r\n    .separate-icon {\r\n        position: relative;\r\n        z-index: 1;\r\n        background-color: #fff;\r\n        padding: 0 15px;\r\n    }\r\n    i {\r\n        transform: rotate(45deg);\r\n        margin: 0 -4px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n} \r\n\r\n/* Section Title 2 */\r\n.ltn__section-title-2 {\r\n    margin-bottom: 40px;\r\n    .section-subtitle {\r\n        margin-top: 0;\r\n    }\r\n    .section-title {\r\n        font-size: 44px;\r\n        font-weight: 700;\r\n        margin-bottom: 15px;\r\n        line-height: 1.3;\r\n    }\r\n    p {\r\n        padding: 0 0 0 30px;\r\n        border-width: 0 0 0 2px;\r\n        border-style: solid;\r\n        border-color: var(--ltn__secondary-color);\r\n        max-width: 450px;\r\n    }\r\n    &.text-right {\r\n        p {\r\n            padding: 0 30px 0 0;\r\n            border-width: 0 2px 0 0;\r\n            margin-left: auto;\r\n        }\r\n    }\r\n    &.text-center {\r\n        p {\r\n            padding: 0 0 0 30px;\r\n            border-width: 0 0 0 2px;\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n            text-align: left !important;\r\n        }\r\n    }\r\n}\r\n\r\n/* Section Title 3 */\r\n.section-title-style-3 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    .section-brief-in {\r\n        p {\r\n            padding: 0 30px 0 0;\r\n            border-width: 0 2px 0 0;\r\n            margin-left: auto;\r\n            margin-right: 30px;\r\n            text-align: right;\r\n        }  \r\n    }\r\n}\r\n\r\n/* title-2 */\r\n.title-2 {\r\n    margin-bottom: 30px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    border-left: 2px solid;\r\n    border-color: var(--ltn__secondary-color);\r\n    padding-left: 10px;\r\n}\r\n\r\n.section-subtitle {\r\n    font-weight: 600;\r\n    font-family: var(--ltn__body-font);\r\n}\r\n.section-subtitle-2 {\r\n    display: inline-block;\r\n    padding: 5px 20px;\r\n    border-radius: 25px;\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        background-color: var(--ltn__secondary-color);\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 50%;\r\n        right: 50%;\r\n        transform: translateY(-50%) translateX(50%);\r\n        border-radius: 25px;\r\n        opacity: 0.1;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 1599px) {\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 60px;\r\n        }\r\n    } \r\n}\r\n@media (max-width: 1399px) {\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 56px;\r\n        }\r\n    }\r\n    .section-title-style-3 {\r\n        .section-title {\r\n            min-width: 320px;\r\n        }\r\n    }\r\n\r\n}\r\n@media (max-width: 1199px) {\r\n    .section-title {\r\n        font-size: 30px;\r\n    }\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 50px;\r\n        }\r\n    }\r\n\r\n}\r\n@media (max-width: 991px) {\r\n    .section-title {\r\n        font-size: 26px;\r\n    }\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 40px;\r\n        }\r\n         p {\r\n            padding: 0 0 0 15px;\r\n        }\r\n    }\r\n\r\n}\r\n@media (max-width: 767px) {\r\n    .section-title {\r\n        font-size: 30px;\r\n    }\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 30px;\r\n        }\r\n         p {\r\n            padding: 0 0 0 15px;\r\n        }\r\n    }\r\n    .section-title-style-3 {\r\n        display: block;\r\n        .section-title {\r\n            min-width: 100%;\r\n        }\r\n        .section-brief-in {\r\n            p {\r\n                padding: 0 0px 0 15px;\r\n                border-width: 0 0px 0 2px;\r\n                margin-left: 0;\r\n                margin-right: 0;\r\n                text-align: left;\r\n                margin-bottom: 15px;\r\n            }  \r\n        }\r\n    }\r\n    .title-2 {\r\n        font-size: 22px;\r\n    }\r\n\r\n}\r\n@media (max-width: 575px) {\r\n    .section-title {\r\n        font-size: 24px;\r\n    }\r\n    .ltn__section-title-2 {\r\n        .section-title {\r\n            font-size: 24px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Category Area\r\n---------------------------------------------------- */\r\n.ltn__category-item {\r\n    margin-top: 2px;\r\n    margin-bottom: 30px;\r\n    transition: all 0.3s ease 0s;\r\n    border: 1px solid var(--border-color-7);\r\n    background-color: var(--white);\r\n}\r\n.ltn__category-item-img {\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.ltn__category-item-name {\r\n    padding: 15px 20px 5px;\r\n}\r\n.ltn__category-item:hover {\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n}\r\n\r\n/* ltn__category-item-2 */\r\n.ltn__category-item-2 {\r\n    padding: 20px 15px 15px;\r\n    .ltn__category-item-img {\r\n        float: left;\r\n        width: 35%;\r\n    }\r\n    .ltn__category-item-name {\r\n        overflow: hidden;\r\n        ul {\r\n            padding: 0;\r\n            margin: 0;\r\n            li {    \r\n                list-style: circle;\r\n                margin-top: 5px;\r\n                font-size: 14px;\r\n                a {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    h4 {\r\n        margin-bottom: 5px;\r\n    }\r\n    .category-btn {    \r\n        float: right;\r\n        font-size: 13px;\r\n        text-transform: uppercase;\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n/* ltn__category-item-3 */\r\n.ltn__category-item-3 {\r\n    padding: 50px 0 25px;\r\n    position: relative;\r\n    box-shadow: none;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 0%;\r\n        height: 4px;\r\n        background-color: var(--ltn__secondary-color);\r\n        -webkit-transition: all 0.5s ease 0s;\r\n        -o-transition: all 0.5s ease 0s;\r\n        transition: all 0.5s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }\r\n    &:hover {\r\n        box-shadow: none;\r\n        &::before {\r\n            width: 100%;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        h5 {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__category-item-4 {\r\n    padding: 40px 30px 30px;\r\n    position: relative;\r\n    border: none;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    border-radius: 10px;\r\n    .ltn__category-item-img {\r\n        width: 100px;\r\n        height: 100px;\r\n        line-height: 115px;\r\n        font-size: 45px;\r\n        border-radius: 100%;\r\n        background-color: var(--section-bg-5);\r\n        color: var(--ltn__secondary-color);\r\n        text-align: center;\r\n        margin-right: 0;\r\n        margin-left: auto;\r\n    }\r\n    .ltn__category-item-name {\r\n        padding: 25px 0px 15px;\r\n        h4 {\r\n            font-weight: 600;\r\n        }\r\n        p {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n    .ltn__category-item-btn { \r\n        position: absolute;\r\n        left: 0;\r\n        width: 100%;\r\n        bottom: -20px;\r\n        a {\r\n            width: 45px;\r\n            height: 45px;\r\n            line-height: 50px;\r\n            background-color: var(--white);\r\n            display: block;\r\n            border-radius: 100%;\r\n            text-align: center;\r\n            font-size: 18px;\r\n            -webkit-box-shadow: var(--ltn__box-shadow-1);\r\n            box-shadow: var(--ltn__box-shadow-2);\r\n            border: 1px solid var(--border-color-8);\r\n        }\r\n    }\r\n    &.text-center {\r\n        .ltn__category-item-img {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n        .ltn__category-item-btn a { \r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-4);\r\n    }\r\n}\r\n.ltn__category-item-5 {\r\n    border: none;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    border-radius: 10px;\r\n    margin-bottom: 50px;\r\n    a {\r\n        padding: 40px 30px 35px;\r\n        display: block;\r\n        position: relative;\r\n        span {\r\n            display: block;\r\n        }\r\n        .category-icon {\r\n            width: 100px;\r\n            height: 100px;\r\n            line-height: 115px;\r\n            font-size: 45px;\r\n            border-radius: 100%;\r\n            background-color: var(--section-bg-5);\r\n            color: var(--ltn__secondary-color);\r\n            text-align: center;\r\n            margin-bottom: 20px;\r\n        }\r\n        .category-title {\r\n            font-size: 22px;\r\n            font-weight: 600;\r\n            font-family: var(--ltn__heading-font);\r\n            color: var(--ltn__heading-color);\r\n            transition: all 0.3s ease 0s;\r\n            margin-bottom: 10px;\r\n        }\r\n        .category-btn {\r\n            width: 45px;\r\n            height: 45px;\r\n            line-height: 50px;\r\n            background-color: var(--white);\r\n            display: block;\r\n            border-radius: 100%;\r\n            text-align: center;\r\n            font-size: 18px;\r\n            -webkit-box-shadow: var(--ltn__box-shadow-1);\r\n            box-shadow: var(--ltn__box-shadow-2);\r\n            border: 1px solid var(--border-color-8);\r\n            position: absolute;\r\n            bottom: -20px;\r\n            right: 50%;\r\n            transform: translateX(50%);\r\n        }\r\n    }\r\n    &.text-center {\r\n        .category-icon {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n        .category-btn {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-4);\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n        .category-title {\r\n            color: var(--white)\r\n        }\r\n    }\r\n}\r\n.ltn__category-item-5-2 {\r\n    a {\r\n        .category-icon {\r\n            margin-right: 0;\r\n            margin-left: auto;\r\n        }\r\n        .category-number {\r\n            transition: all 0.3s ease 0s;\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n            font-family: var(--ltn__body-font);\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n        .category-brief {\r\n            transition: all 0.3s ease 0s;\r\n        }\r\n    }\r\n    &:hover {\r\n        background-color: var(--ltn__secondary-color);\r\n        .category-number,\r\n        .category-brief {\r\n            color: var(--white);\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.ltn__category-item-6 {\r\n    border: 0;\r\n    .ltn__category-item-img {\r\n        font-size: 30px;\r\n        line-height: 1;\r\n        color: var(--ltn__color-1);\r\n    }\r\n    .ltn__category-item-name {\r\n        padding: 15px 5px 5px;\r\n    }\r\n    &:hover {\r\n        box-shadow: none;\r\n        i,\r\n        h5,\r\n        h6 {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .ltn__category-item-5 {\r\n        a {\r\n            padding: 40px 20px 35px;\r\n            .category-icon {\r\n                width: 80px;\r\n                height: 80px;\r\n                line-height: 90px;\r\n                font-size: 30px;\r\n            }\r\n            .category-title {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__category-item-2 {\r\n        .ltn__category-item-img {\r\n            display: none;\r\n        }\r\n    }\r\n    .ltn__category-item-3 {\r\n        padding: 30px 0 5px;\r\n    }\r\n    .ltn__category-item-5 {\r\n        a {\r\n            padding: 40px 15px 35px;\r\n            .category-icon {\r\n                width: 60px;\r\n                height: 60px;\r\n                line-height: 70px;\r\n                font-size: 25px;\r\n            }\r\n            .category-title {\r\n                font-size: 13px;\r\n            }\r\n        }\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Feature Area \r\n---------------------------------------------------- */\r\n.ltn__feature-item {\r\n    padding: 40px 25px 10px;\r\n    transition: all 0.3s ease 0s;\r\n    \r\n}\r\n.ltn__feature-icon-2 {\r\n\r\n  margin-bottom: 20px;\r\n  font-size: 60px;\r\n  line-height: 1;\r\n  color: #f1f1f1 !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.ltn__feature-icon {\r\n\r\n    margin-bottom: 20px;\r\n    font-size: 60px;\r\n    line-height: 1;\r\n    text-align: center !important;\r\n}\r\n\r\n/* feature-item-2 */\r\n.ltn__feature-item-2 {\r\n    padding: 40px 25px 10px;\r\n    .ltn__feature-icon {\r\n        margin-bottom: 20px;\r\n        span {\r\n            background: transparent;\r\n            height: 100px;\r\n            width: 100px;\r\n            line-height: 109px;\r\n            border-radius: 100%;\r\n            position: relative;\r\n            transition: all 0.5s ease 0s;\r\n            display: inline-block;\r\n            text-align: center;\r\n            &::before,\r\n            &::after {\r\n                position: absolute;\r\n                content: \"\";\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                left: 0;\r\n                right: 0;\r\n                margin: auto;\r\n                border-radius: 100%;\r\n                transition: all 0.8s ease 0s;\r\n            }\r\n            &:before {\r\n                height: 0%;\r\n                width: 0%;\r\n                background: transparent;\r\n            }\r\n            &:after {\r\n                height: 100%;\r\n                width: 100%;\r\n                border: 1px solid;\r\n                border-color: var(--ltn__heading-color);\r\n            }\r\n        }\r\n        i {\r\n            font-size: 26px;\r\n            color: var(--ltn__heading-color);\r\n            line-height: 1;\r\n            transition: all 0.5s ease 0s;\r\n            z-index: 1;\r\n            position: relative;\r\n        }\r\n    } \r\n    &.active-feature,\r\n    &:hover {\r\n        .ltn__feature-icon {\r\n            span {\r\n                color: var(--white);\r\n                border-color: transparent;\r\n                &:before {\r\n                    height: 100%;\r\n                    width: 100%;\r\n                    background: linear-gradient(90deg, rgba(238,145,203,1) 0%, rgba(217,176,241,1) 50%);\r\n                }\r\n                &:after {\r\n                    border-color: var(--white);\r\n                    height: 80%;\r\n                    width: 80%;\r\n                }\r\n            }\r\n            i {\r\n                color: var(--white);\r\n            }\r\n        }\r\n        .ltn__feature-info {\r\n            h6 {\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* feature-item-3 */\r\n.ltn__feature-item-3 {\r\n    padding: 25px 22px 1px;\r\n    display: flex;\r\n    transition: all 0.3s ease 0s;\r\n    border: 2px solid;\r\n    border-color: #f4faff;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n    h1, h2, h3, h4, h5, h6 {\r\n        margin-bottom: 5px;\r\n    }\r\n    .ltn__feature-icon {\r\n        margin: 0px 20px 0 0;\r\n        font-size: 50px;\r\n        color: var(--ltn__secondary-color);\r\n        line-height: 1.5;\r\n    }\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: -2px;\r\n        top: 50%;\r\n        width: 4px;\r\n        height: 0%;\r\n        background-color: var(--ltn__secondary-color);\r\n        transition: all 0.5s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transform: translateY(-50%);\r\n    }\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        &::before {\r\n            height: 80%;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n    &.text-right {\r\n        flex-flow: row-reverse;\r\n        .ltn__feature-icon {\r\n            margin: 0px 0 0 20px;\r\n        }\r\n        &::before {\r\n            right: -2px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n/* feature-item-4 */\r\n.ltn__feature-item-4 {\r\n    padding: 50px 20px 15px;\r\n    background-color: var(--white);\r\n    margin-bottom: 30px;\r\n    transition: all 0.3s ease 0s;\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n    }\r\n}\r\n\r\n/* feature-item-5 */\r\n.ltn__feature-item-5 {\r\n    padding: 70px 30px 25px;\r\n    margin-bottom: 30px;\r\n    .ltn__feature-icon {\r\n        margin-bottom: 25px;\r\n        font-size: 80px;\r\n        line-height: 1;\r\n        img {\r\n            max-width: 200px;\r\n        }\r\n        span {\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\\e942\";\r\n                font-family: 'icomoon';\r\n                right: -10px;\r\n                top: -10px;\r\n                height: 35px;\r\n                width: 35px;\r\n                line-height: 35px;\r\n                background-color: var(--ltn__primary-color);\r\n                color: var(--white);\r\n                font-size: 14px;\r\n                border-radius: 100%;\r\n            }\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        position: absolute;\r\n        width: 100%;\r\n        left: 0;\r\n        bottom: 0;\r\n        transition: all 0.3s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        a {\r\n            min-height: 60px;\r\n        }\r\n    }\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        .btn-wrapper {\r\n            bottom: -60px;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n    &.section-bg-2 {\r\n        .ltn__feature-icon {\r\n            color: var(--ltn__secondary-color);\r\n            i {\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n            span {\r\n                &::before {\r\n                    background-color: var(--white);\r\n                    color: var(--ltn__primary-color);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.white-bg {\r\n        .ltn__feature-icon {\r\n            span {\r\n                &::before {\r\n                    background-color: var(--ltn__secondary-color);\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n.feature-btn {\r\n    a {\r\n        display: block;\r\n        padding: 15px 20px;\r\n        background-color: #fff;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n/* feature-item-6 */\r\n.ltn__feature-item-6 {\r\n    border: 1px solid var(--border-color-8);\r\n    margin-bottom: 30px;\r\n    padding: 40px 30px 35px;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 0%;\r\n        height: 4px;\r\n        background-color: var(--ltn__secondary-color);\r\n        transition: all 0.5s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }\r\n    .ltn__feature-icon {\r\n        color: var(--ltn__secondary-color);\r\n        i {\r\n            transition: all 0.3s ease 0s;\r\n        }\r\n    }\r\n    .ltn__feature-info {\r\n        p {\r\n            font-size: 14px;\r\n            margin-bottom: 0;\r\n        }\r\n        p + p {\r\n            margin-top: 15px;\r\n        }\r\n        .ltn__service-btn {\r\n            transition: all 0.3s ease 0s;\r\n            color: var(--ltn__color-1);\r\n            font-weight: 700;\r\n            font-size: 14px;\r\n            display: flex;\r\n            justify-content: center;\r\n            margin-top: 25px;\r\n            i {\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n        }\r\n    }\r\n    &.active,\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        &::before {\r\n            width: 100%;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .ltn__feature-info .ltn__service-btn,\r\n        .ltn__feature-icon {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__feature-item-61 {\r\n  border: 1px solid var(--border-color-8);\r\n  margin-bottom: 30px;\r\n  border-radius: 15px;\r\n  padding: 40px 35px 35px;\r\n  &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 0%;\r\n      height: 4px;\r\n      \r\n      transition: all 0.5s ease 0s;\r\n      opacity: 0;\r\n      visibility: hidden;\r\n  }\r\n  .ltn__feature-icon {\r\n      color: var(--ltn__secondary-color);\r\n      i {\r\n          transition: all 0.3s ease 0s;\r\n      }\r\n  }\r\n  .ltn__feature-info {\r\n      p {\r\n          font-size: 28px;\r\n          margin-bottom: 0;\r\n          color: #f1f1f1;\r\n      }\r\n      p + p {\r\n          margin-top: 15px;\r\n      }\r\n      .ltn__service-btn {\r\n          transition: all 0.3s ease 0s;\r\n          color: var(--ltn__color-1);\r\n          font-weight: 700;\r\n          font-size: 14px;\r\n          display: flex;\r\n          justify-content: center;\r\n          margin-top: 25px;\r\n          i {\r\n              display: flex;\r\n              align-items: center;\r\n          }\r\n      }\r\n  }\r\n  &.active,\r\n  &:hover {\r\n      box-shadow: var(--ltn__box-shadow-1);\r\n      &::before {\r\n          width: 100%;\r\n          opacity: 1;\r\n          visibility: visible;\r\n      }\r\n      .ltn__feature-info .ltn__service-btn,\r\n      .ltn__feature-icon {\r\n          color: var(--ltn__secondary-color);\r\n      }\r\n  }\r\n}\r\n\r\n/* feature-item-7 */\r\n.ltn__feature-item-7 {\r\n    background-color: var(--white);\r\n    padding: 38px 30px 10px;\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n    margin-bottom: 30px;\r\n    .ltn__feature-icon-title {\r\n        display: flex;\r\n        align-items: center;\r\n        margin-bottom: 15px;\r\n    }\r\n    .ltn__feature-icon {\r\n        margin-bottom: 0;\r\n        margin-right: 20px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    h3 {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.ltn__feature-item-7-color-white {\r\n    background-color: transparent;\r\n    border: 1px solid #203336;\r\n    h3,\r\n    p {\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n/* feature-item-8 */\r\n.ltn__feature-item-8 {\r\n    padding: 40px 30px 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    .ltn__feature-icon {\r\n        margin-right: 20px;\r\n        font-size: 40px;\r\n        width: 50px;\r\n    }\r\n    .ltn__feature-info {\r\n        h4 {\r\n            margin-bottom: 5px;\r\n        }\r\n        p {\r\n            font-size: 15px;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__feature-item-box-wrap {\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n}\r\n\r\n.ltn__feature-item-box-wrap-2 {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-flow: wrap;\r\n    box-shadow: none;\r\n    .ltn__feature-item-8 {\r\n        min-width: 280px;\r\n    }\r\n}\r\n.ltn__border-between-column {\r\n    & [class*='col'] {\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            left: 0;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            height: 50%;\r\n            width: 1px;\r\n            background-color: var(--border-color-1);\r\n        }\r\n        &:first-child::before {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n/* feature-item-9 */\r\n.ltn__feature-item-9 {\r\n    padding: 30px 25px 5px;\r\n    border: 1px solid;\r\n    .ltn__feature-icon {\r\n        width: 80px;\r\n        height: 80px;\r\n        line-height: 80px;\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        border-radius: 100%;\r\n        margin-bottom: 0;\r\n        margin-right: 20px;\r\n        text-align: center;\r\n        float: left;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        align-items: center;\r\n        -webkit-box-pack: center;\r\n        justify-content: center;\r\n        font-size: 36px;\r\n        span {\r\n            line-height: 1;\r\n        }\r\n    }\r\n    .ltn__feature-info {\r\n        overflow: hidden;\r\n    }\r\n    h2 {\r\n        margin-bottom: 5px;\r\n    }\r\n    &:hover {\r\n        background-color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n\r\n/* small mobile :320px. */\r\n@media (max-width: 767px) {\r\n    .ltn__feature-item-5 + .btn-wrapper {\r\n        margin-bottom: 30px;\r\n    }\r\n    .ltn__feature-item-7 {\r\n        padding: 38px 20px 10px;\r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Countdown Area\r\n---------------------------------------------------- */\r\n.ltn__countdown {\r\n    margin-top: 30px;\r\n    display: inline-block;\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    padding: 25px 40px 5px;\r\n    .single {\r\n        display: inline-block;\r\n        margin-right: 30px;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__countdown-2 {\r\n    margin-top: 0;\r\n    padding: 20px 30px 1px;\r\n    .single {\r\n        margin-right: 20px;\r\n        h1 {\r\n            font-size: 22px;\r\n            margin-bottom: 5px;\r\n        }\r\n        p {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n.ltn__countdown-3 {\r\n    margin-top: 0;\r\n    padding: 0px;\r\n    box-shadow: none;\r\n    .single {\r\n        margin-right: 20px;\r\n        h1 {\r\n            font-size: 24px;\r\n            margin-bottom: 5px;\r\n            height: 50px;\r\n            width: 60px;\r\n            line-height: 50px;\r\n            background-color: var(--white);\r\n            color: var(--ltn__secondary-color);\r\n            text-align: center;\r\n            font-family: var(--ltn__body-font);\r\n        }\r\n        p {\r\n            font-size: 18px;\r\n            text-align: center;\r\n            font-family: var(--ltn__heading-font);\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 20px;\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__countdown-3 {\r\n        .single {\r\n            h1 {\r\n                font-size: 20px;\r\n                height: 50px;\r\n                width: 50px;\r\n                line-height: 50px;\r\n            }\r\n            p {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .ltn__countdown-1 {\r\n        min-width: 380px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Blog Area\r\n---------------------------------------------------- */\r\n.ltn__blog-item {\r\n    position: relative;\r\n    margin-bottom: 30px;\r\n}\r\n.ltn__blog-img {\r\n    position: relative;\r\n    img {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.ltn__blog-likes {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n    li {\r\n        list-style: none;\r\n        a {\r\n            height: 70px;\r\n            width: 70px;\r\n            font-size: 16px;\r\n            border-radius: 100%;\r\n            display: flex;\r\n            background-color: var(--white);\r\n            text-align: center;\r\n            flex-flow: column;\r\n            justify-content: center;\r\n            box-shadow: var(--ltn__box-shadow-3);\r\n            color: var(--ltn__heading-color);\r\n            i {\r\n                font-size: 18px;\r\n                margin-bottom: 5px;\r\n            }\r\n            span {\r\n                display: inline-block;\r\n                line-height: 1;\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__blog-brief {\r\n    padding: 30px 0 30px;\r\n}\r\n.ltn__blog-title {\r\n    margin-bottom: 20px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.ltn__blog-meta {\r\n    margin-bottom: 20px;\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n    li {\r\n        font-weight: 600;\r\n        display: inline-block;\r\n        margin-right: 25px;\r\n        position: relative;\r\n        font-size: 14px;\r\n        margin-top: 0;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n        i {\r\n            color: var(--ltn__secondary-color);\r\n            margin-right: 5px;\r\n        }\r\n        img {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.ltn__blog-tags {\r\n   a {\r\n        margin-right: 10px;\r\n        position: relative;\r\n        display: inline-block;\r\n        &::before {\r\n            position: absolute;\r\n            content: \",\";\r\n            right: -3px;\r\n        }\r\n        &:last-child::before {\r\n            display: none;\r\n        }\r\n    } \r\n} \r\n.ltn__blog-author {\r\n    img {\r\n        border-radius: 100%;\r\n        margin-right: 10px;\r\n        max-width: 30px;\r\n        display: inline-block;\r\n    }\r\n}\r\n.ltn__blog-btn {\r\n    color: var(--ltn__heading-color);\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.ltn__blog-category {\r\n    a {\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n        padding: 5px 15px 2px;\r\n        margin-bottom: 5px;\r\n        margin-right: 5px;\r\n        display: inline-block;\r\n        text-transform: uppercase;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n        &:hover {\r\n            background-color: var(--ltn__primary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n.ltn__blog-meta-btn {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    .ltn__blog-meta {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n/* ltn__blog-item-1 */\r\n.ltn__blog-item-1 {\r\n    .ltn__blog-img img {\r\n        border-radius: 0px 0px 0px 35px;\r\n    }\r\n    .ltn__blog-meta {\r\n        ul {\r\n            li {\r\n                position: relative;\r\n                &::before {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    width: 2px;\r\n                    height: 10px;\r\n                    top: 50%;\r\n                    background-color: var(--ltn__primary-color);\r\n                    right: -15px;\r\n                    transform: translateY(-50%);\r\n                    opacity: 0.2;\r\n                }\r\n                &:last-child {\r\n                    &::before {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ltn__blog-item-2 */\r\n.ltn__blog-item-2 {\r\n    transition: all 0.3s ease 0s;\r\n    .ltn__blog-brief {\r\n        padding: 30px 20px 30px;\r\n    }\r\n    .ltn__blog-meta li:before {\r\n        height: 15px;\r\n        width: 2px;\r\n        top: 50%;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            right: -15px;\r\n            height: 15px;\r\n            width: 2px;\r\n            background-color: var(--ltn__heading-color);\r\n            top: 50%;\r\n            bottom: 6px;\r\n            transform: translateY(-50%);\r\n            opacity: 0.6;\r\n        }\r\n        &:last-child::before {\r\n            display: none;\r\n        }\r\n    }\r\n    .ltn__blog-btn {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        margin-top: -20px;\r\n    }\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n        .ltn__blog-btn {\r\n            margin-top: 0;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n/* ltn__blog-item-3 */\r\n/* ltn__blog-item-4 */\r\n.ltn__blog-item-3,\r\n.ltn__blog-item-4 {\r\n    .ltn__blog-brief {\r\n        padding: 30px 30px 30px;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        background-color: var(--white);\r\n        position: relative;\r\n    }\r\n    .ltn__blog-meta {\r\n        margin-bottom: 15px;\r\n    } \r\n    .ltn__blog-meta-btn {\r\n        border-top: 1px solid;\r\n        border-color: var(--border-color-1);\r\n        padding-top: 20px;\r\n        .ltn__blog-meta {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n    .ltn__blog-btn {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        color: var(--ltn__secondary-color);\r\n        text-transform: uppercase;\r\n    }\r\n\r\n}\r\n/* ltn__blog-item-3 */\r\n.ltn__blog-item-3 {\r\n    .ltn__blog-brief {\r\n        width: calc( 100% - 30px );\r\n        box-shadow: var(--ltn__box-shadow-4);\r\n    }\r\n    .ltn__blog-img + .ltn__blog-brief {\r\n        margin-top: -50px;\r\n    }\r\n\r\n}\r\n.ltn__blog-item-3-normal {\r\n    .ltn__blog-item-3 {\r\n        margin-bottom: 50px;\r\n        .ltn__blog-brief {\r\n            width: calc( 100% );\r\n        }\r\n        .ltn__blog-img + .ltn__blog-brief {\r\n            margin-top: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__blog-item-3 {\r\n    .ltn__blog-img {\r\n        overflow: hidden;\r\n        img { \r\n            transition: all 0.5s ease 0s;\r\n        }\r\n    }\r\n    &:hover {\r\n        .ltn__blog-img {\r\n            img {\r\n                transform: scale(1.1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ltn__blog-item-4 */\r\n.ltn__blog-item-4 {\r\n    border: 2px solid var(--white-9);\r\n    margin-top: 1px;\r\n    .ltn__blog-brief {\r\n        margin-top: 0;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    p {\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 0%;\r\n        background-color: var(--ltn__primary-color);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    &:hover {\r\n        &::before {\r\n            width: 100%;\r\n            height: 100%;\r\n            opacity: 0.9;\r\n            visibility: visible;\r\n        }\r\n        .ltn__blog-brief {\r\n            background-color: transparent;\r\n        } \r\n        .ltn__blog-meta,\r\n        .ltn__blog-title,\r\n        p {\r\n            color: var(--white);\r\n        }\r\n\r\n    }\r\n}\r\n\r\n/* ltn__blog-item-5 */\r\n.ltn__blog-item-5 {\r\n    border: 2px solid var(--border-color-11);\r\n    .ltn__blog-brief {\r\n        padding: 40px 30px 40px 30px;\r\n    }\r\n    .ltn__blog-meta-btn {\r\n        padding-top: 10px;\r\n    }\r\n    .ltn__blog-author {\r\n        font-size: 16px;\r\n        img {\r\n            max-width: 40px;\r\n        }\r\n    }\r\n    .ltn__blog-btn {\r\n        font-size: 14px;\r\n        font-weight: 700;\r\n        font-family: var(--ltn__body-font);\r\n    }\r\n}\r\n\r\n/* blog-item-audio */\r\n.ltn__blog-item-audio {\r\n    iframe {\r\n        width: 100%;\r\n        min-height: 300px;\r\n    }\r\n}\r\n\r\n/* blog-item-quote */\r\n.ltn__blog-item-quote {\r\n    border: 0;\r\n    .ltn__blog-meta {\r\n        li {\r\n            color: var(--white);\r\n            i {\r\n                color: var(--white);\r\n            }\r\n            &:hover {\r\n                a {\r\n                    color: var(--white-3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    blockquote {\r\n        font-size: 20px;\r\n        font-weight: 700;\r\n        position: relative;\r\n        background-color: transparent;\r\n        font-style: normal;\r\n        border-left: 0;\r\n        border-color: var(--ltn__heading-color);\r\n        padding: 60px 0 0;\r\n        margin: 0px 0 30px 0px;\r\n        color: var(--white);\r\n        text-align: left;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\\e94d\";\r\n            font-family: 'icomoon';\r\n            font-size: 30px;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            transform: inherit;\r\n            transition: all 0.3s ease 0s;\r\n        }\r\n        a:hover,\r\n        &:hover {\r\n            color: var(--white-3);\r\n        }\r\n    }\r\n}\r\n\r\n/* blog-item-6 */\r\n.ltn__blog-item-6 {\r\n    box-shadow: var(--ltn__box-shadow-5);\r\n    transition: all 0.3s ease 0s;\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n    }\r\n    .ltn__blog-brief {\r\n        padding: 35px 30px 15px 35px;\r\n    }\r\n    .ltn__blog-title {\r\n        font-size: 20px;\r\n    }\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n/* blog-item-7 */\r\n.ltn__blog-item-7 {\r\n    box-shadow: var(--ltn__box-shadow-5);\r\n    transition: all 0.3s ease 0s;\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n    }\r\n    .ltn__blog-meta {\r\n        li {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .ltn__blog-brief {\r\n        padding: 30px 30px 30px 35px;\r\n    }\r\n    .ltn__blog-title {\r\n        font-size: 18px;\r\n        text-transform: uppercase;\r\n    }\r\n    p {\r\n        font-size: 18px;\r\n        line-height: 28px;\r\n    }\r\n    .ltn__blog-btn {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n/* blog-list-wrap */\r\n.ltn__blog-list-wrap {\r\n    .ltn__blog-item {\r\n        margin-bottom: 40px;\r\n    }\r\n    .ltn__blog-title {\r\n        font-size: 30px;\r\n        line-height: 1.2;\r\n    }\r\n    .ltn__blog-item-5 {\r\n        .ltn__blog-brief {\r\n            padding: 50px 40px 50px 45px;\r\n        }\r\n    }\r\n    .ltn__blog-item-quote {\r\n        .ltn__blog-meta {\r\n            padding-left: 100px;\r\n        }\r\n        blockquote {\r\n            font-size: 35px;\r\n            line-height: 1.2;\r\n            padding: 0 0 0 100px;\r\n            &::before {\r\n                font-size: 80px;\r\n                left: 0;\r\n            }\r\n            a:hover,\r\n            &:hover {\r\n                color: var(--white-3);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    .ltn__blog-list-wrap {\r\n        .ltn__blog-title {\r\n            font-size: 26px;\r\n        }\r\n        .ltn__blog-item-quote {\r\n           blockquote {\r\n                font-size: 24px;\r\n                padding: 0 0 0 80px;\r\n                &::before {\r\n                    font-size: 50px;\r\n                }\r\n            } \r\n            .ltn__blog-meta {\r\n                padding-left: 80px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__blog-item-6 {\r\n        .ltn__blog-title {\r\n            font-size: 20px;\r\n        }\r\n    } \r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__blog-title {\r\n        font-size: 20px;\r\n    }\r\n    .ltn__blog-item-3 {\r\n        .ltn__blog-brief {\r\n            width: calc( 100% - 30px);\r\n        }\r\n    }\r\n    .ltn__blog-list-wrap {\r\n        .ltn__blog-title {\r\n            font-size: 26px;\r\n        }\r\n        .ltn__blog-item-quote {\r\n           blockquote {\r\n                font-size: 24px;\r\n                padding: 0 0 0 0px;\r\n                &::before {\r\n                    font-size: 30px;\r\n                    display: block;\r\n                    position: relative;\r\n                    margin-bottom: 10px;\r\n                }\r\n            } \r\n            .ltn__blog-meta {\r\n                padding-left: 0;\r\n            }\r\n        }\r\n    } \r\n}\r\n \r\n@media (max-width: 767px) {\r\n    .ltn__blog-title {\r\n        font-size: 16px;\r\n    }\r\n    .ltn__blog-meta li {\r\n        margin-right: 10px;\r\n        font-size: 12px;\r\n    }\r\n    .ltn__blog-list-wrap {\r\n        .ltn__blog-title {\r\n            font-size: 22px;\r\n        }\r\n        .ltn__blog-item-5 {\r\n           .ltn__blog-brief {\r\n                padding: 40px 20px 35px 20px;\r\n            } \r\n        }\r\n        .ltn__blog-item-quote {\r\n           blockquote {\r\n                font-size: 20px;\r\n                padding: 0 0 0 0px;\r\n                &::before {\r\n                    font-size: 30px;\r\n                    display: block;\r\n                    position: relative;\r\n                    margin-bottom: 10px;\r\n                }\r\n            } \r\n            .ltn__blog-meta {\r\n                padding-left: 0;\r\n            }\r\n        }\r\n    }\r\n    .ltn__blog-item-3,\r\n    .ltn__blog-item-4 {\r\n        .ltn__blog-btn {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    .ltn__blog-item-6 {\r\n        .ltn__blog-title {\r\n            font-size: 20px;\r\n        }\r\n       .ltn__blog-brief {\r\n            padding: 35px 20px 15px 20px;\r\n        } \r\n    } \r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Blog Details\r\n---------------------------------------------------- */\r\n.ltn__page-details-inner {\r\n    h1, h2, h3, h4, h5, h6 {\r\n        margin-top: 30px;\r\n    }\r\n    p {\r\n        margin-top: 1.5em;\r\n    }\r\n    .ltn__blog-title {\r\n        margin-top: 0;\r\n        font-size: 30px;\r\n    }\r\n    .ltn__blog-img {\r\n        margin-bottom: 40px;\r\n    }\r\n    .img-radius {\r\n        img {\r\n            border-radius: 0px 0px 0px 35px;\r\n        }\r\n    }\r\n    label {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n/* blog-details-wrap */\r\n.ltn__blog-details-wrap {\r\n    border: 2px solid var(--border-color-11);\r\n    padding: 50px;\r\n}\r\n\r\nblockquote {\r\n    font-size: 18px;\r\n    font-family: var(--ltn__heading-font);\r\n    line-height: 1.6;\r\n    font-weight: 700;\r\n    background-color: var(--section-bg-1);\r\n    padding: 60px 50px 60px 60px;\r\n    margin: 50px 0 50px 0px;\r\n    font-style: normal;\r\n    text-align: center;\r\n    border-left: 0;\r\n    position: relative;\r\n    z-index: 1;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\\e94d\";\r\n        font-family: 'icomoon';\r\n        font-size: 150px;\r\n        right: 45px;\r\n        transition: all 0.3s ease 0s;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        color: var(--white);\r\n        z-index: -1;\r\n    }\r\n}\r\n\r\n.ltn__comment-item {\r\n    position: relative;\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n}\r\n.ltn__commenter-img {\r\n    float: left;\r\n    margin-right: 30px;\r\n    max-width: 100px;\r\n}\r\n.ltn__commenter-img img {\r\n    border-radius: 100%;\r\n}\r\n.ltn__commenter-comment {\r\n    overflow: hidden;\r\n}\r\n.ltn__commenter-comment h6 {\r\n    margin-bottom: 5px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n.ltn__commenter-comment .comment-date {\r\n    margin-bottom: 10px;\r\n    display: block;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    font-family: var(--ltn__heading-font);\r\n    color: var(--ltn__secondary-color);\r\n}\r\n\r\n.ltn__comment-inner ul {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.ltn__comment-inner li {\r\n    list-style: none;\r\n    border-top: 1px solid var(--border-color-12);\r\n    padding-top: 30px;\r\n    margin-top: 8px;\r\n}\r\n.ltn__comment-inner > ul > li:first-child {\r\n    border-top: 0;\r\n    padding-top: 0;\r\n    margin-top: 0;\r\n}\r\n.ltn__comment-inner ul ul {\r\n    margin: 0 0 0 70px;\r\n    padding: 0;\r\n}\r\n.ltn__comment-reply-btn {\r\n    position: absolute;\r\n    padding: 0 25px 0;\r\n    border: 2px solid var(--border-color-11);\r\n    display: inline-block;\r\n    border-radius: 25px;\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    height: 40px;\r\n    line-height: 36px;\r\n    top: 0;\r\n    right: 0;\r\n    i {\r\n        margin-right: 5px;\r\n    }\r\n    &:hover {\r\n        border-color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n.ltn__comment-reply-area {\r\n    form {\r\n        padding: 50px;\r\n        background-color: var(--white-5);\r\n        input[type=\"text\"], \r\n        input[type=\"email\"], \r\n        input[type=\"password\"], \r\n        input[type=\"submit\"],\r\n        textarea {\r\n            border-color: var(--white-5);\r\n        }\r\n    }\r\n}\r\n.ltn__comment-inner {\r\n    .product-ratting {\r\n        ul {\r\n            padding: 0;\r\n            margin: 0;\r\n            li {\r\n                padding: 0;\r\n                border: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n.values_p{\r\n   font-size: 28px;\r\n   margin-bottom: 0;\r\n   line-height: 1.5;\r\n}\r\n.values_p2{\r\n  font-size: 24px;\r\n  margin-bottom: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.values_p3{\r\n  \r\n  margin-bottom: 0;\r\n  line-height: 1.5;\r\n}\r\n.ltn__first-letter {\r\n    font-size: 70px;\r\n    font-weight: 700;\r\n    float: left;\r\n    background-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n    margin-right: 30px;\r\n    line-height: 1;\r\n    text-transform: uppercase;\r\n    width: 100px;\r\n    height: 100px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.ltn__blog-tags-social-media {\r\n    .ltn__social-media {\r\n        ul {\r\n            li {\r\n                color: var(--ltn__color-1);\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__prev-next-btn {\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\\e958\";\r\n        font-family: 'icomoon';\r\n        left: 50%;\r\n        top: 50%;\r\n        transform: translateY(-50%) translateX(-50%);\r\n        font-size: 30px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    h6 {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    .ltn__blog-title {\r\n        font-size: 24px;\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.ltn-author-introducing {\r\n    padding: 40px;\r\n    border: 2px solid var(--border-color-11);\r\n    margin-bottom: 50px;\r\n    .author-img {\r\n        float: left;\r\n        max-width: 180px;\r\n        margin-right: 40px;\r\n    }\r\n    .author-info {\r\n        overflow: hidden;\r\n        h6 {\r\n            margin-bottom: 0;\r\n            font-size: 14px;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n        h1,\r\n        h2,\r\n        h3 {\r\n            margin-bottom: 10px;\r\n        }\r\n        p {\r\n            font-size: 14px;\r\n            margin-bottom: 0;\r\n            & + p {\r\n                margin-top: 15px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    .ltn-author-introducing .author-img {\r\n        max-width: 120px;\r\n        margin-right: 30px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .ltn__blog-tags-social-media .ltn__social-media {\r\n        text-align: left !important;\r\n        margin-top: 30px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__page-details-inner {\r\n        .ltn__blog-title {\r\n            margin-top: 0;\r\n            font-size: 24px;\r\n        }\r\n        .ltn__blog-img {\r\n            margin-bottom: 40px;\r\n        }\r\n    }\r\n    .ltn__blog-details-wrap {\r\n        padding: 50px 20px;\r\n    }\r\n    blockquote {\r\n        font-size: 16px;\r\n        padding: 70px 20px 40px 20px;\r\n        &::before {\r\n            position: initial;\r\n            font-size: 60px;\r\n            display: block;\r\n            line-height: 1;\r\n        }\r\n    }\r\n    .ltn__prev-next-btn {\r\n        .ltn__blog-title {\r\n            font-size: 18px;\r\n        }\r\n    } \r\n    .blog-prev {\r\n        margin-bottom: 40px;\r\n    }\r\n    .blog-next {\r\n        margin-top: 40px;\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn-author-introducing {\r\n        padding: 40px 20px;\r\n        .author-img {\r\n            max-width: 100px;\r\n            margin-right: 0px;\r\n            margin-bottom: 30px;\r\n        }\r\n        .author-info {\r\n            overflow: inherit;\r\n        }\r\n    }\r\n    .ltn__commenter-img {\r\n        float: inherit;\r\n        margin-right: 0;\r\n        max-width: 80px;\r\n        margin-bottom: 20px;\r\n    }\r\n    .ltn__commenter-comment h6 {\r\n        font-size: 18px;\r\n    }\r\n    .ltn__comment-reply-btn {\r\n        position: inherit;\r\n        font-size: 12px;\r\n    }\r\n    .ltn__comment-inner ul ul {\r\n        margin: 0px;\r\n    }\r\n    .ltn__comment-inner li {\r\n        margin-top: 30px;\r\n    }\r\n    .ltn__comment-reply-area form {\r\n        padding: 50px 20px;\r\n    }\r\n    .ltn__first-letter {\r\n        font-size: 40px;\r\n        margin-right: 20px;\r\n        width: 60px;\r\n        height: 60px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Service Details\r\n---------------------------------------------------- */\r\n.ltn__service-list-menu {\r\n    ul {\r\n        padding: 0;\r\n        li {\r\n            display: block;\r\n            border-top: 2px solid #f6f6f6;\r\n            padding: 18px 0;\r\n            margin: 0;\r\n            font-weight: 700;\r\n            font-family: var(--ltn__heading-font);\r\n            &:last-child {\r\n                border-bottom: 2px solid #f6f6f6;\r\n            }\r\n            i {\r\n                margin-right: 5px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n            .service-price {\r\n                float: right;\r\n                text-transform: capitalize;\r\n                font-weight: 400;\r\n                font-family: var(--ltn__body-font);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__service-list-menu ul li .service-price {\r\n        float: none;\r\n        display: block;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Pagination\r\n---------------------------------------------------- */\r\n/* ltn__pagination-3 */\r\n.ltn__pagination {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-right: 10px;\r\n            &:last-child {\r\n                margin-right: 0px;\r\n            }\r\n            a {\r\n                height: 50px;\r\n                width: 50px;\r\n                line-height: 46px;\r\n                border: 2px solid var( --border-color-11);\r\n                text-align: center;\r\n                display: block;\r\n                font-weight: 700;\r\n                border-radius: 100%;\r\n            }\r\n            &:hover, &.active {\r\n                a {\r\n                background-color: var(--ltn__secondary-color);\r\n                border-color: var(--ltn__secondary-color);\r\n                color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__pagination {\r\n       ul {\r\n           li {\r\n                margin-right: 5px;\r\n                font-size: 14px;\r\n                a {\r\n                    height: 40px;\r\n                    width: 40px;\r\n                    line-height: 36px;\r\n                }\r\n            } \r\n       } \r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Testimonial ( 1, 2, 3, 4, 5, 6 )\r\n---------------------------------------------------- */\r\n.ltn__testimonial-item {\r\n    max-width: 80%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding-bottom: 30px;\r\n    margin-bottom: 50px;\r\n    .ltn__testimoni-img {\r\n        img {\r\n            border-radius: 100%;\r\n        }\r\n    }\r\n    &.text-center {\r\n        .ltn__testimoni-img {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n    &.text-right {\r\n        .ltn__testimoni-img {\r\n            margin-left: auto;\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.ltn__testimoni-img {\r\n    max-width: 120px;\r\n    margin-bottom: 30px;\r\n    img {\r\n        border-radius: 0;\r\n    }\r\n    i {\r\n        width: 50px;\r\n        height: 50px;\r\n        line-height: 48px;\r\n        border: 1px solid;\r\n        border-radius: 100%;\r\n        font-size: 18px;\r\n    }\r\n}\r\n\r\n/* testimonial-item-2 */\r\n.ltn__testimonial-item-2 {\r\n    max-width: 60%;\r\n    .ltn__testimoni-img {\r\n        max-width: 85px;\r\n        outline: 8px solid;\r\n        outline-color: var(--white);\r\n        margin-top: 8px;\r\n        position: relative;\r\n        img {\r\n            border-radius: 0;\r\n            box-shadow: var(--ltn__box-shadow-4);\r\n        }\r\n    }\r\n    p {\r\n        font-size: 24px;\r\n    }\r\n    .ltn__testimoni-info {\r\n        h4 {\r\n            font-size: 30px;\r\n            margin-bottom: 5px;\r\n        }\r\n        h6 {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n/* testimonial-item-3 */\r\n.ltn__testimonial-item-3 {\r\n    max-width: 100%;\r\n    margin-bottom: 20px;\r\n    .ltn__testimoni-info {\r\n        box-shadow: var(--ltn__box-shadow-4);\r\n        width: calc(100% - 40px);\r\n        margin: -60px auto 0;\r\n        background-color: var(--white);\r\n        padding: 25px 30px 30px;\r\n        position: relative;\r\n        z-index: 9;\r\n        p {\r\n            margin-top: 0;\r\n        }\r\n        h4 {\r\n           margin-bottom: 5px;\r\n            margin-top: 0;\r\n        }\r\n        h6 {\r\n            margin-bottom: 5px;\r\n            margin-top: 0;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .ltn__testimoni-info-inner {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .ltn__testimoni-img {\r\n        max-width: 60px;\r\n        margin-bottom: 0;\r\n        margin-right: 15px;\r\n        img {\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__testimoni-bg-icon {\r\n    position: absolute;\r\n    right: 15px;\r\n    bottom: 5px;\r\n    z-index: -1;\r\n    opacity: 0.1;\r\n    i {\r\n        font-size: 110px;\r\n        line-height: 1;\r\n        color: var(--ltn__color-1);\r\n    }\r\n}\r\n\r\n/* testimonial-item-4 */\r\n.ltn__testimonial-item-4 {\r\n    max-width: 100%;\r\n    position: relative;\r\n    padding: 40px;\r\n    background-color: var(--white);\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n    z-index: 2;\r\n    .ltn__testimoni-img {\r\n        max-width: 160px;\r\n        float: left;\r\n        margin-right: 40px;\r\n        img {\r\n            border-radius: 0;\r\n        }\r\n    }\r\n    .ltn__testimoni-info {\r\n        overflow: hidden;\r\n        p {\r\n            margin-bottom: 15px;\r\n        }\r\n        h4 {\r\n           margin-bottom: 5px;\r\n        }\r\n        h6 {\r\n            margin-bottom: 5px;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n/* testimonial-item-5 */\r\n.ltn__testimonial-slider-4 {\r\n    max-width: 45%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    text-align: center;\r\n}\r\n.ltn__testimonial-item-5 {\r\n    .ltn__quote-icon {\r\n        font-size: 240px;\r\n        position: absolute;\r\n        top: -15px;\r\n        line-height: 1;\r\n        color: var(--white-7);\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        z-index: -1;\r\n    }\r\n    .ltn__testimonial-image {\r\n            max-width: 85px;\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n            margin-top: 50px;\r\n        img {\r\n            outline: 8px solid #fff;\r\n            box-shadow: var(--ltn__box-shadow-1);\r\n        }\r\n    }\r\n    .ltn__testimonial-info {\r\n        margin-top: 30px;\r\n        p {\r\n            font-size: 24px;\r\n        }\r\n        h4 {\r\n            font-size: 30px;\r\n            margin-bottom: 5px;\r\n        }\r\n        h6 {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n\r\n}\r\n.ltn__testimonial-quote-menu {  \r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 0;\r\n    margin: 0;\r\n    li {\r\n        list-style: none;\r\n        img {\r\n            position: absolute;\r\n        }\r\n        &:nth-child(1) img {\r\n            width: 105px;\r\n            top: -15%;\r\n            left: 0;\r\n        }\r\n        &:nth-child(2) img {   \r\n            width: 65px;\r\n            top: 0;\r\n            left: auto;\r\n            right: 3%;\r\n        }\r\n        &:nth-child(3) img {   \r\n            width: 65px;\r\n            top: 70%;\r\n            left: 10%;\r\n        }\r\n        &:nth-child(4) img {   \r\n            width: 125px;\r\n            top: 60%;\r\n            left: auto;\r\n            right: 10%;\r\n        }\r\n        &:nth-child(5) img {   \r\n            width: 75px;\r\n            top: 40%;\r\n            left: 3%;\r\n        }\r\n        &:nth-child(6) img {   \r\n            width: 75px;\r\n            top: 25%;\r\n            left: auto;\r\n            right: 15%;\r\n        }\r\n        &:nth-child(7) img {   \r\n            width: 55px;\r\n            top: 20%;\r\n            left: 15%;\r\n        }\r\n        &:nth-child(8) img {   \r\n            width: 55px;\r\n            top: 40%;\r\n            left: auto;\r\n            right: 3%;\r\n        }\r\n    }\r\n}\r\n\r\n/* testimonial-item-6 */\r\n.ltn__testimonial-item-6 {\r\n    padding-top: 50px;\r\n    margin-bottom: 0;\r\n    .ltn__testimoni-img {\r\n        i {\r\n            border: 0;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    p {\r\n        font-size: 28px;\r\n    }\r\n}\r\n\r\n/* testimonial-item-7 */\r\n.ltn__testimonial-item-7 {\r\n    background-color: var(--white);\r\n    padding: 30px 35px 40px;\r\n    max-width: 100%;\r\n    border-radius: 10px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    border: 1px solid;\r\n    border-color: var(--border-color-13);\r\n    position: relative;\r\n    .ltn__testimonial-img {\r\n        margin-bottom: 30px;\r\n    }\r\n    .ltn__testimoni-info {\r\n        p {\r\n            font-size: 18px;\r\n            i {\r\n                font-size: 30px;\r\n                position: relative;\r\n                top: 8px;\r\n                margin-right: 2px;\r\n                line-height: 1;\r\n                transition: all 0.3s ease 0s;\r\n            }\r\n        }\r\n    }\r\n    .ltn__testimoni-info-inner {\r\n        display: flex;\r\n        align-items: center;\r\n        .ltn__testimoni-img {\r\n            max-width: 60px;\r\n            margin-right: 15px;\r\n            margin-bottom: 0;\r\n        }\r\n        .ltn__testimoni-name-designation {\r\n            h5 {\r\n                font-weight: 600;\r\n                margin-bottom: 0;\r\n            }\r\n            label {\r\n                font-size: 14px;\r\n                margin-bottom: 0;\r\n                text-transform: uppercase;\r\n            }\r\n        }\r\n    }\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 0%;\r\n        height: 4px;\r\n        background-color: var(--ltn__secondary-color);\r\n        transition: all 0.5s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }\r\n    &:hover {\r\n        &::before {\r\n            width: 100%;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .ltn__testimoni-info {\r\n            p {\r\n                i {\r\n                    color: var(--ltn__secondary-color);\r\n                } \r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* testimonial-item-8 */\r\n.ltn__testimonial-item-8 {\r\n    padding: 35px 35px 35px;\r\n    .ltn__testimoni-info {\r\n        p {\r\n            margin-bottom: 0;\r\n        }\r\n        p + p {\r\n            margin-top: 15px;\r\n        }\r\n    }\r\n\r\n}\r\n.ltn__testimoni-author-ratting {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 991px) { \r\n    .ltn__testimonial-item-2 {\r\n        max-width: 70%;\r\n        p {\r\n            font-size: 20px;\r\n        }\r\n        .ltn__testimoni-info h4 {\r\n            font-size: 24px;\r\n        }\r\n    }\r\n    .ltn__testimonial-slider-4 {\r\n        max-width: 70%;\r\n    }\r\n    .ltn__testimonial-item-5 {\r\n        .ltn__testimonial-info {\r\n            p {\r\n                font-size: 20px;\r\n            } \r\n        } \r\n    } \r\n    \r\n    .quote-animated-image {\r\n        display: none !important;\r\n    }\r\n    .ltn__testimoni-author-ratting {\r\n        flex-flow: column-reverse;\r\n    }\r\n    .ltn__testimonial-item-7 {\r\n        .ltn__testimoni-info {\r\n            p {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n \r\n@media (max-width: 767px) { \r\n    .ltn__testimonial-item-2 {\r\n        max-width: 95%;\r\n        p {\r\n            font-size: 16px;\r\n        }\r\n        .ltn__testimoni-info h4 {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n    .ltn__testimonial-item-3 {\r\n        .ltn__testimoni-info {\r\n            width: calc(100% - 20px);\r\n            padding: 25px 20px 30px;\r\n        }\r\n        .ltn__testimoni-info-inner {\r\n            flex-flow: row wrap;\r\n        }\r\n        .ltn__testimoni-img {\r\n            margin-bottom: 10px;\r\n        }\r\n    } \r\n    .ltn__testimonial-item-4 {\r\n       .ltn__testimoni-img {\r\n            float: none;\r\n        } \r\n    } \r\n    .ltn__testimonial-slider-4 {\r\n        max-width: 95%;\r\n    }\r\n    .ltn__testimonial-item-5 {\r\n        .ltn__testimonial-info {\r\n            p {\r\n                font-size: 16px;\r\n            } \r\n        } \r\n    } \r\n    .ltn__testimonial-item-7 {\r\n        .ltn__testimoni-info {\r\n            p {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n        .ltn__testimoni-info-inner {\r\n            flex-flow: row wrap;\r\n            .ltn__testimoni-img {\r\n                margin-bottom: 10px;\r\n            }\r\n        }\r\n        \r\n    } \r\n    \r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Banner Area ( style: 2, 3 )\r\n---------------------------------------------------- */\r\n.ltn__banner-item {\r\n    margin-bottom: 30px;\r\n    position: relative;\r\n}\r\n.ltn__banner-img {\r\n    overflow: hidden;\r\n    img {\r\n        transition: all 3.5s ease 0s;\r\n    }\r\n    &:hover {\r\n        img {\r\n            transform: scale(1.1);\r\n            -webkit-transform: scale(1.1);\r\n        }\r\n    }\r\n}\r\n.ltn__banner-info h4 {\r\n    margin-bottom: 10px;\r\n}\r\n.ltn__banner-style-2 .ltn__banner-info {\r\n    padding: 20px 30px;\r\n    border: 1px solid;\r\n    border-color: var(--border-color-1);\r\n}\r\n\r\n.ltn__banner-style-3 .ltn__banner-info {\r\n    position: absolute;\r\n    left: 35px;\r\n    top: 30px;\r\n}\r\n.ltn__banner-style-3 .banner-button {\r\n    position: absolute;\r\n    bottom: 30px;\r\n    left: 30px;\r\n    a {\r\n        color: var(--ltn__color-1);\r\n        padding: 12px 25px;\r\n        background-color: rgba(255,255,255,0.1);\r\n        display: inline-block;\r\n        &:hover {\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__banner-style-4 {\r\n    position: relative;\r\n    height: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    .ltn__banner-info {\r\n        position: relative;\r\n        padding: 30px 30px;\r\n        h3 {\r\n            margin-bottom: 10px;\r\n        }\r\n        p {\r\n            margin-bottom: 12px;\r\n        }\r\n        mark {\r\n            background-color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        cursor: pointer;\r\n        transition: all 0.4s ease 0s;\r\n        background-color: var(--ltn__primary-color);\r\n        opacity: 0.3;\r\n    }\r\n    &:hover {\r\n        &::before {\r\n            opacity: 0.15;\r\n        }\r\n    }\r\n       \r\n} \r\n\r\n\r\n/* ----------------------------------------------------\r\n    Team Area\r\n---------------------------------------------------- */\r\n.ltn__team-item {\r\n    margin-bottom: 30px;\r\n    border: 1px solid #f1f1f1;\r\n    text-align: center;\r\n    transition: .3s;\r\n    &:hover {\r\n        box-shadow: var(--ltn__box-shadow-1);\r\n    }\r\n}\r\n.team-info {\r\n    padding: 25px 15px;\r\n}\r\n\r\n/* team-item-2 */\r\n.ltn__team-item-2 {\r\n    position: relative;\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: var(--gradient-color-1);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    .team-info {\r\n        position: absolute;\r\n        width: 100%;\r\n        top: 60%;\r\n        transform: translateY(-50%);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    &:hover {\r\n        &:before {\r\n            opacity: 0.7;\r\n            visibility: visible;\r\n        }\r\n        .team-info {\r\n            top: 50%;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n/* team-item-3 */\r\n.ltn__team-item-3 {\r\n    padding: 45px 20px 25px;\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n    border: 0;\r\n    position: relative;\r\n    .team-img {\r\n        max-width: 180px;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        img {\r\n            border-radius: 100%;\r\n        }\r\n    }\r\n    h6 {\r\n        text-transform: uppercase;\r\n    }\r\n    .team-info {\r\n        padding: 0;\r\n        margin-top: 30px;\r\n    }\r\n    .ltn__social-media {\r\n        transition: .5s;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: 0;\r\n        background-color: currentColor;\r\n        width: 100%;\r\n        padding: 10px 20px 20px;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        border-bottom: 3px solid transparent;\r\n    }\r\n    &:hover {\r\n        background-color: var(--ltn__primary-color);\r\n        h6,\r\n        h4,\r\n        .ltn__social-media ul li {\r\n            color: var(--white);\r\n        }\r\n        .ltn__social-media {\r\n            bottom: -25px;\r\n            opacity: 1;\r\n            visibility: visible;\r\n            z-index: 999;\r\n            border-bottom-color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__team-item-3 {\r\n        max-width: 300px;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    CounterUp Area\r\n---------------------------------------------------- */\r\n.ltn__counterup-item {\r\n    margin-bottom: 50px;\r\n    text-align: center;\r\n    .counter-icon {\r\n        margin-bottom: 25px;\r\n        i {\r\n            font-size: 65px;\r\n            line-height: 1;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    h1 {\r\n        font-weight: 700;\r\n        font-size: 42px;\r\n    }\r\n    h6 {\r\n        color: var(--ltn__color-5);\r\n        font-family: var(--ltn__body-font);\r\n    }\r\n}\r\n/* counterup-item-2 */\r\n.ltn__counterup-item-2 {\r\n    margin-bottom: 50px;\r\n    display: flex;\r\n    .counter-icon {\r\n        margin-bottom: 0;\r\n        margin-right: 30px;\r\n        text-align: center;\r\n        i {\r\n            font-size: 35px;\r\n            height: 65px;\r\n            width: 65px;\r\n            line-height: 65px;\r\n            border: 1px solid;\r\n            border-radius: 5px;\r\n            color: var(--ltn__color-1);\r\n        }\r\n    }\r\n    h1, h6 {\r\n        font-weight: 600;\r\n        font-size: 36px;\r\n        line-height: 1;\r\n        margin-bottom: 10px;\r\n    }\r\n    h6 {\r\n        font-size: 20px;\r\n    }\r\n}\r\n/* counterup-item-3 */\r\n.ltn__counterup-item-3 {\r\n    margin-bottom: 50px;\r\n    .counter-icon {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    h1 {\r\n        font-size: 72px;\r\n        line-height: 1;\r\n        margin-bottom: 5px;\r\n    }\r\n    .counterUp-icon {\r\n        font-size: 30px;\r\n    }\r\n    h6 {\r\n        font-family: var(--ltn__body-font);\r\n    }\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n    .ltn__counterup-item-3 {\r\n        h1 {\r\n            font-size: 56px;\r\n        }\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__counterup-item h1 {\r\n        font-size: 36px;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__counterup-area .ltn__section-title-2 {\r\n        text-align: center;\r\n    }\r\n    .ltn__counterup-item h1 {\r\n        font-size: 30px;\r\n    }\r\n    .ltn__counterup-item-3 {\r\n        text-align: center;\r\n        h1 {\r\n            font-size: 56px;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Contact Form Area\r\n---------------------------------------------------- */\r\n.ltn__contact-address-item {\r\n    padding: 40px 30px 10px;\r\n    text-align: center;\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n    margin-bottom: 30px;\r\n    i {\r\n        background-color: transparent;\r\n        color: var(--ltn__heading-color);\r\n        height: 60px;\r\n        width: 60px;\r\n        line-height: 60px;\r\n        box-shadow: var(--ltn__box-shadow-2);\r\n        text-align: center;\r\n        border-radius: 100%;\r\n        margin-bottom: 30px;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    &:hover {\r\n        i {\r\n            background-color: var(--ltn__primary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n} \r\n.ltn__contact-address-item-2 {\r\n    padding: 30px 0 10px;\r\n    margin-bottom: 0;\r\n    box-shadow: none;\r\n    & + .ltn__contact-address-item-2 {\r\n        border-top: 1px solid;\r\n    }\r\n}\r\n.contact-form-box {\r\n    padding: 40px 50px 50px;\r\n    position: relative;\r\n    z-index: 1;\r\n    input::-webkit-input-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input::-moz-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input:-ms-input-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input:-moz-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n}\r\n.contact-form-box-2 {\r\n    input,\r\n    textarea {\r\n        border-top: 0;\r\n        border-left: 0;\r\n        border-right: 0;\r\n        padding-left: 0;\r\n    }\r\n}\r\n.google-map {\r\n    height: 800px;\r\n}\r\n.ltn__contact-address-item-3 {\r\n    box-shadow: none;\r\n    border: 2px solid var(--border-color-11);\r\n    padding: 50px 30px 25px;\r\n    i {\r\n        font-size: 50px;\r\n        border: 0;\r\n        box-shadow: none;\r\n    }\r\n    .ltn__contact-address-icon {\r\n        margin-bottom: 35px;\r\n        img {\r\n            max-width: 80px;\r\n        }\r\n    }\r\n    &:hover {\r\n        i {\r\n            background-color: transparent;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n.form-messege {\r\n    .error {\r\n        color: var(--red);\r\n    }\r\n    .success {\r\n        color: var(--green);\r\n    }\r\n} \r\n\r\n@media (max-width: 767px) {\r\n    .contact-form-box {\r\n        padding: 40px 25px 50px;\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Cart Table Area\r\n---------------------------------------------------- */\r\n.table-1 { \r\n    table {\r\n        border: 0;\r\n        text-transform: uppercase;\r\n        font-size: 13px;\r\n        width: 100%;\r\n        tr {\r\n            &:first-child {\r\n                font-weight: 700;\r\n                text-transform: uppercase;\r\n                background-color: #e5e5e6;\r\n            }\r\n            &:nth-child(odd) {\r\n                background-color: #e5e5e6;\r\n            }\r\n            &:nth-of-type(even) {\r\n                background: #f9f9f9;\r\n            }\r\n            th {\r\n                font-weight: 700;\r\n                text-transform: uppercase;\r\n                background-color: #e5e5e6;\r\n                border-right: 2px solid #fff;\r\n                border-bottom: 2px solid #fff;\r\n                padding: 10px 0;\r\n                display: table-cell;\r\n                line-height: 18px;\r\n                text-align: center;\r\n                width: 12%;\r\n            }\r\n            td {\r\n                border-right: 2px solid #fff;\r\n                border-bottom: 2px solid #fff;\r\n                padding: 10px 0;\r\n                display: table-cell;\r\n                line-height: 18px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.mobile-show {\r\n    display: none;\r\n}\r\n@media only screen and (max-width: 767px) {\r\n   .mobile-none {\r\n        display: none;\r\n    }\r\n    .mobile-show {\r\n        display: block;\r\n    }\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Cart plus minus\r\n---------------------------------------------------- */\r\n.cart-plus-minus {\r\n    border: 2px solid;\r\n    height: 63px;\r\n    line-height: 56px;\r\n    width: 140px;\r\n    text-align: center;\r\n}\r\n.qtybutton {\r\n    height: 100%;\r\n    width: 30%;\r\n}\r\n.dec.qtybutton {\r\n    float: left;\r\n    border-right: 2px solid;\r\n}\r\n.inc.qtybutton {\r\n    float: right;\r\n    border-left: 2px solid;\r\n}\r\n.cart-plus-minus,\r\n.dec.qtybutton,\r\n.inc.qtybutton {\r\n    background-color: var(--white);\r\n    border-color: var(--border-color-11);\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n}\r\ninput.cart-plus-minus-box {\r\n    background: transparent none repeat scroll 0 0;\r\n    box-shadow: none;\r\n    border: none;\r\n    height: 100%;\r\n    margin-bottom: 0;\r\n    padding: 0;\r\n    text-align: center;\r\n    width: 40%;\r\n    font-weight: 700;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Product Details\r\n---------------------------------------------------- */\r\n.product-details-content {\r\n    .product-title  {\r\n        font-size: 36px;\r\n        font-weight: 700;\r\n    }\r\n    .product-price {\r\n        font-size: 24px;\r\n        margin-top: 15px;\r\n        margin-bottom: 15px;\r\n    }\r\n    .product-excerpt {\r\n        margin-bottom: 30px;\r\n    }\r\n    .cart-plus-minus {\r\n        display: inline-block;\r\n        margin-right: 20px;\r\n    }\r\n    .product-details-cart-btn {\r\n        display: inline-block;\r\n        margin-top: 0;\r\n    }\r\n    .product-details-buy-btn .theme-btn-1 {\r\n        padding: 10px 100px 9px;\r\n    }\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Shoping Cart\r\n---------------------------------------------------- */\r\n.table tr:nth-child(odd) {\r\n    background-color: #f7f8fa;\r\n}\r\n.table tr:nth-child(even) {\r\n    background-color: #fafafa;\r\n}\r\n.shoping-cart-table {\r\n    tbody {\r\n        border-bottom: 1px solid #dee2e6;\r\n    }\r\n    thead th {\r\n        vertical-align: middle;\r\n        border-bottom: 0;\r\n        background-color: #f7f8fa;\r\n    }  \r\n    .table tr {\r\n        background-color: transparent;\r\n        display: table;\r\n        width: 100%;\r\n    }\r\n    td {\r\n        padding: 20px 25px;\r\n        vertical-align: middle;\r\n    }\r\n}\r\n.cart-product-image img {\r\n    max-width: 100px;\r\n}\r\n.cart-product-remove {\r\n    cursor: pointer;\r\n}\r\n.cart-product-remove:hover {\r\n    color: var(--ltn__secondary-color);\r\n}\r\n.cart-product-subtotal {\r\n    font-weight: 700;\r\n}\r\n.cart-coupon-row {\r\n    background-color: #f7f8fa;\r\n    text-align: right;\r\n}\r\n.cart-coupon {\r\n    text-align: left;\r\n}\r\n.cart-coupon input {\r\n    max-width: 250px;\r\n    margin-bottom: 0;\r\n}\r\n.submit-button-1 {\r\n    padding: 10px 30px;\r\n    background-color: var(--ltn__primary-color);\r\n    color: var(--white);\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.submit-button-1:hover {\r\n    background-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n}\r\n.btn.disabled {\r\n    cursor: not-allowed;\r\n}\r\n.shoping-cart-total {\r\n    float: right;\r\n    max-width: 450px;\r\n    width: 100%;\r\n    .table {\r\n        margin-bottom: 0;\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 0;\r\n        .theme-btn-1 {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n    .shoping-cart-table td {\r\n        padding: 20px 10px;\r\n    }\r\n    .cart-product-image img {\r\n        max-width: 80px;\r\n    }\r\n    .cart-product-info h4 {\r\n        font-size: 18px;\r\n    }\r\n\r\n}\r\n@media (max-width: 767px) {\r\n    .shoping-cart-table thead th {\r\n        display: none;\r\n    }\r\n    .shoping-cart-table .table tr {\r\n        display: block;\r\n        text-align: center;\r\n    }\r\n    .shoping-cart-table td {\r\n        display: block;\r\n        padding: 20px 15px;\r\n    }\r\n    .cart-product-image {\r\n        max-width: 100%;\r\n    }\r\n    .shoping-cart-table .cart-plus-minus {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n    .cart-coupon input {\r\n        margin-bottom: 20px;\r\n    }\r\n    .shoping-cart-table .table tr:nth-child(even) {\r\n        background-color: var(--section-bg-1);\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Custom Content\r\n---------------------------------------------------- */\r\n.custom-content-brief {\r\n    h1 {\r\n        margin-bottom: 30px;\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 40px;\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Newsletter\r\n---------------------------------------------------- */\r\n.ltn__newsletter-inner {\r\n    .ltn__form-box {\r\n        position: relative;\r\n        margin-top: 30px;\r\n        input {\r\n            margin-bottom: 0;\r\n            padding-right: 140px;\r\n        }\r\n        button {\r\n            margin-top: 0;\r\n            position: absolute;\r\n            right: 0;\r\n            top: 0;\r\n            height: 100%;\r\n            height: 100%;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n.ltn__newsletter-inner-2 {\r\n    .ltn__form-box {\r\n        input {\r\n            border-width: 0px 0px 1px 0px;\r\n            padding-right: 140px;\r\n        }\r\n    }\r\n}\r\n.ltn__newsletter-inner-3 {\r\n    .ltn__form-box {\r\n        input {\r\n            border-radius: 50px;\r\n            padding-left: 30px;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Faq Area\r\n---------------------------------------------------- */\r\n.ltn__faq-inner {\r\n    .card {\r\n        border: none;\r\n        border-radius: 0;\r\n        margin-bottom: 35px;\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n        .ltn__card-title {\r\n            background-color: var(--section-bg-1);\r\n            padding: 22px 15px 22px 40px;\r\n            cursor: pointer;\r\n            position: relative;\r\n            transition: .3s;\r\n            font-size: 18px;\r\n            margin-bottom: 0;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\\e903\";\r\n                font-family: 'icomoon';\r\n                right: 15px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                font-size: 20px;\r\n            }\r\n        }\r\n        .ltn__card-title[aria-expanded=\"true\"] {\r\n            background-color: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n        }\r\n        .ltn__card-title[aria-expanded=\"true\"]:before {\r\n            content: \"\\e904\";\r\n        }\r\n        .card-body {\r\n            padding: 20px 0 0 0;\r\n        }\r\n    }\r\n}\r\n\r\n/* ltn__faq-inner-2 */\r\n.ltn__faq-inner-2 {\r\n    .card {\r\n        margin: 0 0 -2px 0;\r\n        border: 2px solid;\r\n        border-color: var(--border-color-10);\r\n        .ltn__card-title {\r\n            background-color: transparent;\r\n            padding: 20px 60px 20px 40px;\r\n            &::before {\r\n                background-color: var(--section-bg-1);\r\n                color: var(--ltn__primary-color);\r\n                font-size: 16px;\r\n                height: 40px;\r\n                width: 40px;\r\n                text-align: center;\r\n                line-height: 40px;\r\n            }\r\n        }\r\n        .ltn__card-title[aria-expanded=\"true\"] {\r\n            background-color: transparent;\r\n            color: var(--ltn__primary-color);\r\n        }\r\n        .ltn__card-title[aria-expanded=\"true\"]:before {\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n        .card-body {\r\n            padding: 15px 40px 25px;\r\n        }\r\n    }\r\n}\r\n.ltn__faq-inner-3 {\r\n    .card {\r\n        background-color: transparent;\r\n        border-top: 0;\r\n        border-left: 0;\r\n        border-right: 0;\r\n        .ltn__card-title {\r\n            padding: 20px 60px 20px 5px;\r\n            font-weight: 600;\r\n            i {\r\n                width: 50px;\r\n                height: 50px;\r\n                line-height: 55px;\r\n                background-color: var(--ltn__secondary-color);\r\n                color: var(--white);\r\n                display: inline-block;\r\n                text-align: center;\r\n                margin-right: 10px;\r\n                font-size: 26px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__faq-inner-2 {\r\n        .card {\r\n            .ltn__card-title {\r\n                padding: 20px 60px 20px 20px;\r\n                font-size: 16px;\r\n            }\r\n            .card-body {\r\n                padding: 15px 20px 25px;\r\n            }\r\n        } \r\n    }\r\n    .ltn__faq-inner-3 {\r\n        .card {\r\n            .ltn__card-title {\r\n                font-size: 14px;\r\n                i {\r\n                    width: 40px;\r\n                    height: 40px;\r\n                    line-height: 45px;\r\n                    font-size: 20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    404 Area\r\n---------------------------------------------------- */\r\n.error-404-inner {\r\n    .btn-wrapper {\r\n        margin-top: 50px;\r\n    }\r\n}\r\n.error-404-title {\r\n    font-size: 120px;\r\n    line-height: 1;\r\n    margin-bottom: 40px;\r\n}\r\n\r\n/* 404 area 1 */\r\n.ltn__404-area-1 {\r\n    .error-404-title {\r\n        font-size: 400px;\r\n        line-height: 1;\r\n        color: var(--ltn__secondary-color);\r\n        margin-bottom: 0;\r\n    }\r\n    h2 {\r\n        font-size: 60px;\r\n    }\r\n}\r\n\r\n/* 404 area 2 */\r\n.ltn__404-area-2 {\r\n    min-height: 90vh;\r\n    display: flex;\r\n    align-items: center;\r\n    .error-404-inner {\r\n        padding: 150px 0 170px;\r\n    }\r\n}\r\n@media (max-width: 1199px) {\r\n    .ltn__404-area-1 {\r\n        .error-404-title {\r\n            font-size: 200px;\r\n        }\r\n        h2 {\r\n            font-size: 30px;\r\n        }\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__404-area-2 {\r\n        .error-404-inner {\r\n            padding: 80px 0 110px;\r\n        }\r\n    }\r\n    .error-404-inner {\r\n        p br {\r\n            display: none;\r\n        }\r\n    }\r\n    .error-404-title {\r\n        font-size: 80px;\r\n    }\r\n    .ltn__404-area-1 {\r\n        .error-404-title {\r\n            font-size: 100px;\r\n        }\r\n        h2 {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Coming Soon Area\r\n---------------------------------------------------- */\r\n.ltn__coming-soon-area {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n.coming-soon-inner {\r\n    padding: 120px 0 100px;\r\n    .ltn__countdown {\r\n        margin-top: 0;\r\n        .single {\r\n            border: 1px solid var(--border-color-3);\r\n            margin-right: 30px;\r\n            margin-top: 15px;\r\n            margin-bottom: 15px;\r\n            min-width: 120px;\r\n            padding-top: 15px;\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 50px;\r\n    }\r\n    p {\r\n        max-width: 380px;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n    .ltn__form-box {\r\n        max-width: 550px;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        input {\r\n            background-color: transparent;\r\n            color: var(--white);\r\n            border: 1px solid var(--border-color-3);\r\n        }\r\n        input[type=\"text\"]::-webkit-input-placeholder, \r\n        input[type=\"email\"]::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) and (max-width: 991px) {\r\n    .coming-soon-inner .ltn__countdown .single {\r\n        min-width: 110px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .coming-soon-inner {\r\n        padding: 80px 0 110px;\r\n        p br {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .coming-soon-inner {\r\n        .ltn__countdown {\r\n            padding: 25px 20px 5px;\r\n           .single {\r\n                margin-right: 20px;\r\n                min-width: 90px;\r\n            } \r\n        } \r\n    } \r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Screenshot Area\r\n---------------------------------------------------- */\r\n/* img-slide-item-1 */\r\n.ltn__img-slide-item-1 {\r\n    margin: 10px 0 20px 0;\r\n    padding: 0 0;\r\n}\r\n.slick-current .ltn__img-slide-item-1 {\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n}\r\n\r\n/* img-slide-item-2 */\r\n.ltn__img-slide-item-2 {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n/* img-slide-item-3 */\r\n.ltn__img-slide-item-3 {\r\n    position: relative;\r\n    margin-bottom: 85px;\r\n    .ltn__img-slide-info {\r\n        display: flex;\r\n        -webkit-box-pack: justify;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 30px 35px;\r\n        background-color: white;\r\n        position: absolute;\r\n        bottom: 0;\r\n        width: calc(100% - 60px);\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        left: 0;\r\n        right: 0;\r\n        transition: all 0.3s ease 0s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        box-shadow: var(--ltn__box-shadow-2);\r\n    }\r\n    .ltn__img-slide-info-brief {\r\n        padding-right: 20px;\r\n    }\r\n    h6 {\r\n        margin-bottom: 5px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    h1 {\r\n        margin-bottom: 0;\r\n        font-size: 30px;\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 0;\r\n        .btn {\r\n            padding: 15px 20px 13px;\r\n        }\r\n    }\r\n    &:hover {\r\n        .ltn__img-slide-info {\r\n            bottom: -65px;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n.slick-current {\r\n    .ltn__img-slide-item-3 {\r\n        .ltn__img-slide-info {\r\n            bottom: -65px;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n.ltn__img-slide-item-4 {\r\n    position: relative;\r\n    margin-bottom: 30px;\r\n    .ltn__img-slide-info {\r\n        display: flex;\r\n        -webkit-box-pack: justify;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 30px 35px;\r\n        position: absolute;\r\n        bottom: 5px;\r\n        width: 100%;\r\n        transition: all 0.3s ease 0s;\r\n        background: var(--gradient-color-3);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n    }    \r\n    .ltn__img-slide-info-brief {\r\n        padding-right: 20px;\r\n    }\r\n    h6 {\r\n        margin-bottom: 5px;\r\n        color: var(--white);\r\n        font-weight: 400;\r\n    }\r\n    h1 {\r\n        margin-bottom: 0;\r\n        font-size: 26px;\r\n        color: var(--white);\r\n        font-weight: 500;\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 0;\r\n        .btn {\r\n            padding: 15px 20px 13px;\r\n        }\r\n    }\r\n    &:hover {\r\n        .ltn__img-slide-info {\r\n            bottom: 0;\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1399px) {\r\n    .ltn__img-slide-item-3 {\r\n        .ltn__img-slide-info {\r\n            padding: 30px 20px;\r\n            width: calc(100% - 30px);\r\n        }\r\n        .ltn__img-slide-info-brief {\r\n            padding-right: 15px;\r\n        }\r\n        h1 {\r\n            font-size: 18px;\r\n        }\r\n        .btn-wrapper .btn {\r\n            padding: 10px 10px 8px;\r\n        }\r\n    } \r\n    .ltn__img-slide-item-4 {\r\n        .ltn__img-slide-info {\r\n            padding: 30px 20px;\r\n        }\r\n        h1 {\r\n            font-size: 18px;\r\n        }\r\n        .btn-wrapper .btn {\r\n            padding: 10px 10px 8px;\r\n        }\r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Pricing List Area\r\n---------------------------------------------------- */\r\n.ltn__pricing-plan-item {\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n    margin-bottom: 30px;\r\n    transition: all 0.3s ease 0s;\r\n    position: relative;\r\n    overflow: hidden;\r\n    .pricing-badge {\r\n        color: var(--white);\r\n        background-color: var(--ltn__secondary-color);\r\n        padding: 4px 20px;\r\n        text-transform: uppercase;\r\n        font-size: 8px;\r\n        line-height: 20px;\r\n        font-weight: 700;\r\n        letter-spacing: 1px;\r\n        display: table;\r\n        transform: rotate(45deg);\r\n        top: 18px;\r\n        position: absolute;\r\n        right: -28px;\r\n        transition: all 0.3s ease-in;\r\n    }\r\n    .pricing-title {\r\n        margin: 0;\r\n        height: 100px;\r\n        line-height: 100px;\r\n    }\r\n    .pricing-price {\r\n        background-color: var(--section-bg-1);\r\n        height: 85px;\r\n        line-height: 85px;\r\n        transition: all 0.3s ease 0s;\r\n        h2 {\r\n            margin-bottom: 0;\r\n            line-height: inherit;\r\n            font-size: 48px;\r\n        }\r\n        sup,\r\n        sub {\r\n            font-size: 24px;\r\n        }\r\n        sup {\r\n            top: -.9em;\r\n        }\r\n        sub {\r\n            bottom: -.2em;\r\n        }\r\n    }\r\n    ul {\r\n        margin: 35px 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            font-size: 18px;\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        padding-bottom: 50px;\r\n    }\r\n    &.active-price,\r\n    &.active {\r\n        box-shadow: var(--ltn__box-shadow-6);\r\n        transform: scale(1.1);\r\n        overflow: hidden;\r\n        position: relative;\r\n        .pricing-price {\r\n            h2 {\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n        .btn {\r\n            background-color: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__pricing-plan-item.active-price, .ltn__pricing-plan-item.active {\r\n        transform: scale(1);\r\n    }\r\n}\r\n/* ----------------------------------------------------\r\n    Checkbox\r\n---------------------------------------------------- */\r\n/* checkbox-item */\r\n.checkbox-item {\r\n  display: inline-block;\r\n  position: relative;\r\n  padding-left: 30px;\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none; }\r\n\r\n/* Hide the browser's default checkbox */\r\n.checkbox-item input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  height: 0;\r\n  width: 0; \r\n}\r\n\r\n/* Create a custom checkbox */\r\n.checkbox-item .checkmark {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 0;\r\n  height: 16px;\r\n  width: 16px;\r\n  background-color: var(--white);\r\n  border: 1px solid;\r\n  border-color: #93959E; }\r\n\r\n/* On mouse-over, add a grey background color */\r\n.checkbox-item:hover input ~ .checkmark {\r\n  background-color: var(--ltn__secondary-color); }\r\n\r\n/* When the checkbox is checked, add a blue background */\r\n.checkbox-item input:checked ~ .checkmark {\r\n  background-color: var(--ltn__secondary-color); \r\n  border-color: var(--ltn__secondary-color); \r\n}\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n.checkbox-item .checkmark:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  display: none; }\r\n\r\n/* Show the checkmark when checked */\r\n.checkbox-item input:checked ~ .checkmark:after {\r\n  display: block; }\r\n\r\n/* Style the checkmark/indicator */\r\n.checkbox-item .checkmark:after {\r\n  left: 4px;\r\n  top: 0px;\r\n  width: 5px;\r\n  height: 10px;\r\n  border: solid #fff;\r\n  border-width: 0 1px 1px 0;\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg); }\r\n\r\n/* ----------------------------------------------------\r\n    Body Sidebar Icons\r\n---------------------------------------------------- */\r\n.body-sidebar-icons {\r\n    position: fixed;\r\n    top: 50%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    z-index: 9;\r\n    -webkit-transition: -webkit-transform .3s ease 1s;\r\n    transition: -webkit-transform .3s ease 1s;\r\n    transition: transform .3s ease 1s;\r\n    transition: transform .3s ease 1s,-webkit-transform .3s ease 1s;\r\n    \r\n    right: 0;\r\n    -webkit-transform: translate3d(100%,-50%,0);\r\n    transform: translate3d(100%,-50%,0);\r\n    -webkit-box-align: end;\r\n    -ms-flex-align: end;\r\n    align-items: flex-end;\r\n\r\n    -webkit-transform: translate3d(0,-50%,0);\r\n    transform: translate3d(0,-50%,0);\r\n    a {    \r\n        background-color: #ddd;\r\n        text-align: center;\r\n        color: #fff;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n        width: auto;\r\n        height: 40px;\r\n        min-width: 40px;\r\n        margin: 0;\r\n        overflow: hidden;\r\n\r\n\r\n            -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: reverse;\r\n        -ms-flex-direction: row-reverse;\r\n        flex-direction: row-reverse;\r\n        i {\r\n            width: 40px;\r\n            line-height: 40px;\r\n            font-size: 14px;\r\n            vertical-align: middle;\r\n        }\r\n        .icon-name {\r\n            white-space: nowrap;\r\n            max-width: 0;\r\n            padding: 0;\r\n            overflow: hidden;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            -webkit-transition: padding .4s cubic-bezier(.175,.885,.32,1.15),max-width .4s cubic-bezier(.175,.885,.32,1.15);\r\n            transition: padding .4s cubic-bezier(.175,.885,.32,1.15),max-width .4s cubic-bezier(.175,.885,.32,1.15);\r\n        }\r\n        &.facebook-icon {\r\n            background-color: var(--facebook);\r\n        }\r\n        &.twitter-icon {\r\n            background-color: var(--twitter);\r\n        }\r\n        &.pinterest-icon {\r\n            background-color: var(--pinterest);\r\n        }\r\n        &.instagram-icon {\r\n            background-color: var(--instagram);\r\n        }\r\n        &.dribbble-icon {\r\n            background-color: var(--dribbble);\r\n        }\r\n        &.behance-icon {\r\n            background-color: var(--behance);\r\n        }\r\n        &.google-plus-icon {\r\n            background-color: var(--google-plus);\r\n        }\r\n        &.linkedin-icon {\r\n            background-color: var(--linkedin);\r\n        }\r\n        &.youtube-icon {\r\n            background-color: var(--youtube);\r\n        }\r\n        &.vk-icon {\r\n            background-color: var(--vk);\r\n        }\r\n        &.wechat-icon {\r\n            background-color: var(--wechat);\r\n        }\r\n        &.email-icon {\r\n            background-color: var(--email);\r\n        }\r\n        &:hover {\r\n            -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n            .icon-name {\r\n                padding-left: 15px;\r\n                max-width: 220px;\r\n            }\r\n        }\r\n    }\r\n    &.left-side {\r\n        left: 0;\r\n        right: auto;\r\n        align-items: flex-start;\r\n        a {\r\n            flex-direction: unset;\r\n            &:hover {\r\n                -webkit-box-shadow: none;\r\n                box-shadow: none;\r\n                .icon-name {\r\n                    padding-right: 15px;\r\n                    padding-left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    About Us Area\r\n---------------------------------------------------- */\r\n.about-us-img-wrap {\r\n    position: relative;\r\n    img {\r\n        margin: 0;\r\n    }\r\n}\r\n.about-us-img-info {\r\n    width: 310px;\r\n    height: 310px;\r\n    background-color: var(--white);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n    position: absolute;\r\n    top: 70%;\r\n    transform: translateY(-50%);\r\n    left: 0;\r\n    right: 0;\r\n    margin: auto;\r\n    h1 {\r\n        margin: 0;\r\n        font-size: 120px;\r\n        line-height: 0.8;\r\n        color: var(--ltn__secondary-color);\r\n        .counter {\r\n        font-size: 120px;\r\n        line-height: 0.8;\r\n        color: var(--ltn__secondary-color);\r\n            \r\n        }\r\n        span {\r\n            font-size: 20px;\r\n            color: var(--ltn__heading-color);\r\n        }\r\n    }\r\n    h6 {\r\n        margin: 0;\r\n        span {\r\n            font-size: 20px;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 50px;\r\n    }\r\n    .dots-bottom {\r\n        height: 25px;\r\n        width: 25px;\r\n        background-color: var(--ltn__secondary-color);\r\n        display: inline-block;\r\n        position: absolute;\r\n        bottom: -10px;\r\n        left: 12px;\r\n    }\r\n}\r\n.about-us-img-info-2 {\r\n    width: 190px;\r\n    height: 190px;\r\n    background-color: var(--ltn__secondary-color);\r\n    border: 15px solid;\r\n    border-color: var(--white);\r\n    bottom: 0;\r\n    top: auto;\r\n    transform: inherit;\r\n    margin-right: 0;\r\n    h1 {\r\n        font-size: 50px;\r\n        color: var(--white);\r\n        .counter {\r\n            font-size: 50px;\r\n            color: var(--white);\r\n        }\r\n        span {\r\n            font-size: 20px;\r\n            color: var(--white);\r\n        }\r\n    }\r\n    h6 {\r\n        color: var(--white);\r\n    }\r\n}\r\n.about-us-img-info-3 {\r\n    right: auto;\r\n    left: 10px;\r\n    border: 0;\r\n    height: inherit;\r\n    width: inherit;\r\n    max-width: 300px;\r\n    bottom: 70px;\r\n    background-color: transparent;\r\n    .ltn__video-img::before {\r\n        opacity: 0.1;\r\n    }\r\n}\r\n.about-us-info-wrap {\r\n    position: relative;\r\n    .btn-wrapper {\r\n        margin-top: 40px;\r\n    }\r\n    hr {\r\n        margin-top: 40px;\r\n        margin-bottom: 40px;\r\n    }\r\n    .ltn__video-play-btn {\r\n        width: 80px;\r\n        height: 80px;\r\n        line-height: 84px;\r\n        font-size: 20px;    \r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        right: -100px;\r\n    }\r\n}\r\n.about-us-info-devide {\r\n    display: flex;\r\n    .list-item-with-icon {\r\n        margin-left: 30px;\r\n        margin-bottom: 30px;\r\n    }\r\n}\r\n.list-item-with-icon {\r\n    min-width: 300px;\r\n}\r\n.about-us-img-info-inner {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-flow: column;\r\n}\r\n.list-item-with-icon-2,\r\n.list-item-with-icon {\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            position: relative;\r\n            list-style: none;\r\n            padding-left: 60px;\r\n            font-weight: 700;\r\n            margin-bottom: 25px;\r\n            &:last-child {\r\n                margin-bottom: 0;\r\n            }\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\\f00c\";\r\n                font-family: 'Font Awesome\\ 5 Free';\r\n                font-weight: 900;\r\n                left: 0;\r\n                top: -5px;\r\n                background-color: var(--section-bg-1);\r\n                height: 40px;\r\n                width: 40px;\r\n                line-height: 40px;\r\n                text-align: center;\r\n                font-size: 12px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n.list-item-with-icon-2 {\r\n    ul {\r\n        li {\r\n            padding-left: 30px;\r\n            font-weight: 400;\r\n            margin-bottom: 0;\r\n            &::before {\r\n                height: inherit;\r\n                line-height: inherit;\r\n                width: inherit;\r\n                background-color: transparent;\r\n                color: var(--ltn__heading-color);\r\n                top: 5px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.about-img-left {\r\n    margin-right: 30px;\r\n}\r\n.about-img-right {\r\n    margin-left: 30px;\r\n}\r\n.ltn__img-shape-left,\r\n.ltn__img-shape-right {\r\n    position: relative;\r\n    &::before {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        height: 85%;\r\n        width: 30px;\r\n        background-color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n.ltn__img-shape-left {\r\n    padding-left: 30px;\r\n    &::before {\r\n        left: 0;\r\n    }\r\n}\r\n.ltn__img-shape-right {\r\n    padding-right: 30px;\r\n    &::before {\r\n        left: auto;\r\n        right: 0;\r\n    }\r\n}\r\n.about-call-us {\r\n    display: flex;\r\n    align-items: center;\r\n    .call-us-icon {\r\n        font-size: 50px;\r\n        margin-right: 20px;\r\n        color: var(--ltn__secondary-color);\r\n        line-height: 1;\r\n    }\r\n    .call-us-info {\r\n        p {\r\n            margin-bottom: 10px;\r\n        }\r\n        h2 {\r\n            margin-bottom: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__list-item-half {\r\n    margin-top: 0;\r\n    padding-left: 0;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    li {\r\n        width: 50%;\r\n        float: left;\r\n        list-style: none;\r\n        display: flex;\r\n        align-items: center;\r\n        padding-right: 20px;\r\n        img {\r\n            max-width: 50px;\r\n            margin-right: 10px;\r\n        }\r\n        i {\r\n            font-size: 20px;\r\n            color: var(--white);\r\n            margin-right: 15px;\r\n            height: 45px;\r\n            width: 45px;\r\n            line-height: 45px;\r\n            background-color: var(--ltn__secondary-color);\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            flex: 0 0 45px;\r\n            border-radius: 100%;\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-half-2 {\r\n    li {\r\n        i {\r\n            font-size: 14px;\r\n            height: 32px;\r\n            width: 32px;\r\n            line-height: 32px;\r\n            flex: 0 0 32px;\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-1 {\r\n    padding-left: 0;\r\n    li {\r\n        list-style: none;\r\n        i {\r\n            margin-right: 10px;\r\n            color: var(--ltn__secondary-color);\r\n            font-size: 26px;\r\n            float: left;\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-1-before {\r\n    padding-left: 30px;\r\n    li {\r\n        position: relative;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            left: -30px;\r\n            width: 15px;\r\n            height: 1px;\r\n            background-color: var(--ltn__secondary-color);\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-2 {\r\n    padding-left: 0;\r\n    li {\r\n        list-style: none;\r\n        display: inline-block;\r\n        position: relative;\r\n        margin-right: 30px;\r\n        max-width: 160px;\r\n        font-size: 14px;\r\n        span {\r\n            display: block;\r\n            font-weight: 700;\r\n        }\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-2-before {\r\n    li {\r\n        position: relative;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            right: -15px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            width: 1px;\r\n            height: 100%;\r\n            background-color: var(--ltn__primary-color);\r\n            opacity: 0.2;\r\n        }\r\n        &:last-child {\r\n            &::before {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__list-item-2-img {\r\n    li {\r\n        margin-right: 10px;\r\n        width: 30%;\r\n    }\r\n}\r\n.ltn__callout {\r\n    padding: 20px;\r\n    margin: 25px 0;\r\n    border-left: 4px solid;\r\n    border-color: var(--ltn__secondary-color);\r\n    p {\r\n        margin-bottom: 0;\r\n    }\r\n    p + p {\r\n        margin-top: 20px;\r\n    }\r\n}\r\n\r\n.list-item-margin {\r\n    li {\r\n        margin-top: 30px;\r\n    }\r\n}\r\n\r\n.about-author-info-2 {\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        flex-flow: row wrap;\r\n        li {\r\n            list-style: none;\r\n            margin-right: 45px;\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\";\r\n                top: 50%;\r\n                right: -22px;\r\n                transform: translateY(-50%);\r\n                width: 1px;\r\n                height: 100%;\r\n                background-color: var(--ltn__primary-color);\r\n                opacity: 0.2;\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n                &::before {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .about-author-info-2-brief {\r\n        img {\r\n            max-width: 40px;\r\n            border-radius: 100%;\r\n            margin-right: 15px;\r\n        }\r\n    }\r\n    .about-author-info-2-contact {\r\n        padding: 10px 20px;\r\n        background-color: var(--section-bg-1);\r\n        i {\r\n            font-size: 25px;\r\n            margin-right: 15px;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    .about-us-info-devide {\r\n        display: block;\r\n        .list-item-with-icon {\r\n           margin-left: 0;\r\n        }\r\n    }\r\n    .list-item-with-icon {\r\n        margin-top: 30px;\r\n        margin-bottom: 40px;\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .about-img-left {\r\n        margin-right: 0;\r\n        margin-bottom: 40px;\r\n    }\r\n    .about-img-right {\r\n        margin-left: 0;\r\n        margin-bottom: 40px;\r\n    }\r\n    .about-us-info-wrap {\r\n        .ltn__video-play-btn {\r\n            position: inherit;\r\n            transform: inherit;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .custom-content-brief {\r\n        margin-bottom: 30px;\r\n    }\r\n    .about-us-img-info {\r\n        height: 200px;\r\n        width: 220px;\r\n        h1 {\r\n            .counter {\r\n                font-size: 80px;\r\n            }\r\n        }\r\n    }\r\n    .about-us-img-info-2 {\r\n        width: 150px;\r\n        height: 150px;\r\n        h1 {\r\n            .counter {\r\n                font-size: 30px;\r\n            }\r\n        }\r\n    }\r\n    .about-us-info-devide {\r\n        display: block;\r\n        .list-item-with-icon {\r\n           margin-left: 0;\r\n        }\r\n    }\r\n    .list-item-with-icon {\r\n        margin-top: 30px;\r\n        margin-bottom: 40px;\r\n    }\r\n    .list-item-with-icon {\r\n        min-width: 275px;\r\n    }\r\n    .ltn__list-item-half li {\r\n        width: 100%;\r\n        padding-right: 0px;\r\n    }\r\n    .ltn__flat-info {\r\n        li {\r\n            margin-right: 20px;\r\n        }\r\n    }\r\n    .ltn__list-item-2-before {\r\n        li {\r\n            &::before {\r\n                right: -12px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Why Choose Us Area\r\n---------------------------------------------------- */\r\n.why-choose-us-feature-item {\r\n    display: flex;\r\n    margin-bottom: 10px;\r\n    max-width: 480px;\r\n    .why-choose-us-feature-icon {\r\n        margin-right: 20px;\r\n        font-size: 70px;\r\n        line-height: 1.2;\r\n        color: var(--ltn__secondary-color);\r\n        min-width: fit-content;\r\n    }\r\n    .why-choose-us-feature-brief {\r\n        h3 {\r\n            margin-bottom: 5px;\r\n        }\r\n    }\r\n}\r\n.why-choose-us-img-wrap img {\r\n    max-width: 65%;\r\n}\r\n.why-choose-us-img-2 {\r\n    margin-top: -15%;\r\n    img {\r\n        border: 15px solid var(--white);\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Service Area\r\n---------------------------------------------------- */\r\n.ltn__service-item-1 {\r\n    background-color: var(--white);\r\n    margin-bottom: 50px;\r\n    .service-item-img {\r\n        position: relative;\r\n        overflow: hidden;\r\n        img {\r\n            transition: all 0.5s ease 0s;\r\n        }\r\n    }\r\n    .service-item-icon {\r\n        position: absolute;\r\n        right: 0;\r\n        bottom: 0;\r\n        width: 70px;\r\n        height: 70px;\r\n        background-color: white;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-size: 40px;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    .service-item-brief {\r\n        padding: 32px 40px 10px;\r\n        h3 {\r\n            margin-bottom: 5px;\r\n        }\r\n    }\r\n    &:hover {\r\n        .service-item-img {\r\n            img {\r\n                transform: scale(1.1)\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__service-item-2 {\r\n    padding: 0px 45px 30px;\r\n    margin-bottom: 50px;\r\n    margin-top: 35px;\r\n    .service-item-icon {\r\n        font-size: 80px;\r\n        line-height: 1;\r\n        top: -35px;\r\n        position: relative;\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    .service-item-brief {\r\n        padding-top: 50px;\r\n    }\r\n    .service-item-icon + .service-item-brief {\r\n        padding-top: 0;\r\n    }\r\n    ul {\r\n        margin-bottom: 10px;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            margin-top: 10px;\r\n            span {\r\n                color: var(--ltn__color-1);\r\n            }\r\n        }\r\n    }\r\n    hr {\r\n        margin-top: 25px;\r\n        margin-bottom: 25px;\r\n    }\r\n}\r\n@media (max-width: 1199px) {\r\n    .ltn__service-item-2 {\r\n        padding: 0px 30px 30px;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__service-item-1 {\r\n        .service-item-brief {\r\n            padding: 30px 22px 10px;\r\n        }\r\n    } \r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Call To Action 1, 2, 3, 4, 5\r\n---------------------------------------------------- */\r\n/* call-to-action-2 */\r\n.call-to-action-2 {\r\n    background-color: var(--white-3);\r\n}\r\n.call-to-action-inner-2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    h2 {\r\n        margin: 0;\r\n    }\r\n    .btn-wrapper {\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n/* call-to-action-3 */\r\n.get-a-free-service-margin {\r\n    margin-bottom: -180px;\r\n}\r\n.get-a-free-service-inner {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-shadow: var(--ltn__box-shadow-1);\r\n    padding-right: 80px;\r\n    padding-left: 30px;\r\n    .call-to-img {\r\n        img {\r\n            max-width: 350px;\r\n            position: absolute;\r\n            left: 35px;\r\n            bottom: 0;\r\n            z-index: 2;\r\n        }\r\n    }\r\n    .call-to-action-inner-content {\r\n        position: relative;\r\n        z-index: 3;\r\n    }\r\n}\r\n.call-to-circle-1,\r\n.call-to-circle-2 {\r\n    height: 265px;\r\n    width: 265px;\r\n    display: inline-block;\r\n    background-color: var(--ltn__secondary-color);\r\n    position: absolute;\r\n    left: 60px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    border-radius: 100%;\r\n    z-index: 1;\r\n}\r\n.call-to-circle-2 {\r\n    height: 80px;\r\n    width: 80px;\r\n    left: 300px;\r\n    top: 10%;\r\n    transform: inherit;\r\n    animation: wave 8s 0.1s infinite linear;\r\n}\r\n.call-to-bg-icon {\r\n    position: absolute;\r\n    font-size: 220px;\r\n    right: 35px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    z-index: 1;\r\n    color: var(--ltn__color-1);\r\n    opacity: 0.1;\r\n}\r\n\r\n.get-a-free-service-inner {\r\n    .call-to-circle-2 {\r\n        animation: wave 8s 0.1s infinite linear;\r\n    }  \r\n}\r\n\r\n/* call-to-action-4 */\r\n.ltn__call-to-action-4 {\r\n    position: relative;\r\n    .call-to-action-inner-4 {\r\n        position: relative;\r\n        z-index: 99;\r\n        h2 {\r\n            font-style: italic;\r\n        }\r\n        .h1 {\r\n            font-size: 50px;\r\n        }\r\n        p {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__call-to-4-img-1 {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    max-width: 34%;\r\n}\r\n.ltn__call-to-4-img-2 {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n    max-width: 27%;\r\n}\r\n\r\n/* call-to-action-5 */\r\n.call-to-action-inner-5 {\r\n\r\n    a {\r\n        &:hover {\r\n            text-decoration: underline;\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n.team-pics {\r\n  border-radius: 50%;\r\n  height: 450px;\r\n}\r\n\r\n.team-pics1 {\r\n  border-radius: 50%;\r\n  height: 400px;\r\n  width: 400px;\r\n}\r\n\r\n/* call-to-action-6 */\r\n.call-to-action-inner-6 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 50px 60px;   \r\n    .coll-to-info {\r\n        p {\r\n            margin-bottom: 0;\r\n        }\r\n        p + p {\r\n            margin-top: 15px;\r\n        }\r\n    } \r\n    .btn-wrapper {\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n/* Device :991px. */\r\n@media (max-width: 991px) {\r\n    .ltn__call-to-4-img-1,\r\n    .ltn__call-to-4-img-2 {\r\n        display: none;\r\n    }\r\n    .ltn__call-to-action-4 {\r\n        .call-to-action-inner-4 {\r\n            .h1 {\r\n                font-size: 30px;\r\n            }\r\n            p {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n    .call-to-action-inner-6 {\r\n        padding: 50px 25px;\r\n        flex-flow: column;\r\n        .btn {\r\n            margin-top: 30px;\r\n        }\r\n    }\r\n\r\n}\r\n/* small mobile :320px. */\r\n@media (max-width: 767px) {\r\n    .call-to-action-inner-2 {\r\n        flex-flow: column;\r\n        .btn-wrapper {\r\n            margin-top: 15px;\r\n        }\r\n    }\r\n    .get-a-free-service-inner {\r\n        display: block;\r\n        padding-right: 0;\r\n        padding-left: 0px;\r\n        .call-to-img {\r\n            margin-bottom: 40px;\r\n            img {\r\n                max-width: 100%;\r\n                position: relative;\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n    .call-to-circle-1,\r\n    .call-to-circle-2 {\r\n        display: none;\r\n    }\r\n    .ltn__call-to-action-4 {\r\n        .call-to-action-inner-4 {\r\n            .h1 {\r\n                font-size: 24px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/* small mobile :320px. */\r\n@media (max-width: 580px) {\r\n    .call-to-action-inner-6 {\r\n        h1,\r\n        h2,\r\n        h3 {\r\n            br {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Elements Area\r\n---------------------------------------------------- */\r\n.ltn__elements-area {\r\n    background-color: var(--section-bg-1);\r\n    padding: 50px 0;\r\n    margin: 50px 0;\r\n}\r\n.elements-title-area {\r\n    text-align: center;\r\n}\r\n.elements-title-inner {\r\n    background-color: var(--white-3);\r\n    display: inline-block;\r\n    padding: 10px 30px;\r\n    outline: 10px solid;\r\n    outline-offset: 10px;\r\n    outline-color: var(--white-3);\r\n    margin: 20px;\r\n    p {\r\n        margin-bottom: 0;\r\n        padding-top: 5px;\r\n        border-top: 1px solid #ddd;\r\n        margin-top: 5px;\r\n    }\r\n}\r\n.elements-title {\r\n    display: inline-block;\r\n    margin: 0;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Service Form \r\n---------------------------------------------------- */\r\n.ltn__service-form-box {\r\n    margin: 0;\r\n    padding: 0 30px;\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        & > li {\r\n            display: inline-block;\r\n            margin-right: 20px;\r\n            list-style: none;\r\n        }\r\n    }\r\n    .nice-select {\r\n        margin: 0;\r\n        height: 60px;\r\n        line-height: 58px;\r\n        padding-right: 40px;\r\n        padding-left: 20px;\r\n        border-radius: 0;\r\n        min-width: 200px;\r\n        font-size: 16px;\r\n        font-weight: 700;\r\n        font-family: var(--ltn__heading-font);\r\n        &:after {\r\n            right: 20px;\r\n        }\r\n        UL {\r\n            li {\r\n                display: block;\r\n            }\r\n        }\r\n    }\r\n    input {\r\n        margin: 0;\r\n    }\r\n    input[type=\"date\"] {\r\n        margin: 0;\r\n        height: 60px;\r\n        padding: 0 20px;\r\n        border: 1px solid;\r\n        font-weight: 700;\r\n        font-family: var(--ltn__heading-font);\r\n        text-transform: uppercase;\r\n    }\r\n    .btn-wrapper {\r\n        margin: 0;\r\n    }\r\n}\r\n.ltn__service-form-color-white {\r\n    .ltn__service-form-box {\r\n        .nice-select {\r\n            background-color: transparent;\r\n            border: 2px solid;\r\n            border-color: var(--border-color-3);\r\n            .current {\r\n                color: var(--white);\r\n                text-transform: uppercase;\r\n            }\r\n            &::after {\r\n                border-bottom: 2px solid;\r\n                border-right: 2px solid;\r\n                border-color: var(--border-color-3);\r\n            }\r\n        }\r\n        input {\r\n            background-color: transparent;\r\n            color: var(--white);\r\n            border-color: var(--border-color-3);\r\n            font-weight: 700;\r\n            height: 60px;\r\n        }\r\n    }\r\n    .ltn__service-form-box input[type=\"date\"] {\r\n        background-color: transparent;\r\n        color: var(--white);\r\n    }\r\n    .ltn__service-form-box input[type=\"date\"]::-webkit-calendar-picker-indicator {\r\n        filter: invert(100%);\r\n    }\r\n    .ltn__service-form-box input::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n        color: var(--white);\r\n    }\r\n    .ltn__service-form-box input::-moz-placeholder { /* Firefox 19+ */\r\n        color: var(--white);\r\n    }\r\n    .ltn__service-form-box input:-ms-input-placeholder { /* IE 10+ */\r\n        color: var(--white);\r\n    }\r\n    .ltn__service-form-box input:-moz-placeholder { /* Firefox 18- */\r\n        color: var(--white);\r\n    }\r\n    .input-item-date.ltn__custom-icon::before {\r\n        color: var(--white);\r\n        top: 50%;\r\n    }\r\n}\r\n.input-item-date {\r\n    margin-bottom: 30px;\r\n    input[type=\"date\"] {\r\n        background-color: transparent;\r\n        border: 2px solid var(--border-color-1);\r\n        height: 65px;\r\n        width: 100%;\r\n        padding: 0 20px;\r\n    }\r\n    input[type=\"date\"]::-webkit-calendar-picker-indicator {\r\n        filter: invert(0%);\r\n    }\r\n}\r\n\r\n.ltn__service-form-1 {\r\n    .ltn__service-form-brief {\r\n        padding-left: 100px;\r\n    }\r\n}\r\n.ltn__service-form-margin {\r\n    margin-top: -160px;\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1599px) {\r\n    .ltn__service-form-box {\r\n        padding: 0;\r\n        .input-item {\r\n            max-width: 200px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n    .ltn__service-form-box > ul {\r\n        justify-content: center;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__service-form-box > ul {\r\n        flex-flow: column;\r\n    }\r\n}\r\n@media (max-width: 575px) {\r\n    .ltn__service-form-1 {\r\n        .ltn__service-form-brief {\r\n            padding-left: 20px;\r\n        }\r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Get A Quote Form\r\n---------------------------------------------------- */\r\n.get-a-quote-wrap {\r\n    padding: 40px 50px 50px;\r\n    border: 2px solid;\r\n    border-color: var(--border-color-1);\r\n}\r\n.get-a-quote-form {\r\n    margin: 0;\r\n    .btn-wrapper {\r\n        padding: 0 40px;\r\n    }\r\n    .btn {\r\n        width: 100%;\r\n    }\r\n    input::-webkit-input-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input::-moz-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input:-ms-input-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n    input:-moz-placeholder {\r\n        color: var(--ltn__color-1);\r\n    }\r\n}\r\n\r\n.input-item {\r\n    .nice-select {\r\n        border: 2px solid;\r\n        border-color: var(--border-color-1);\r\n        border-radius: 0;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        height: 65px;\r\n        line-height: 60px;\r\n        width: 100%;\r\n        margin-bottom: 30px;\r\n        .current {\r\n            font-weight: 700;\r\n        }\r\n        &::after {\r\n            display: none;\r\n        }\r\n        &::before {\r\n            content: \"\\f063\";\r\n            font-size: 14px;\r\n            position: absolute;\r\n            top: 50%;\r\n            right: 20px;\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n            font-family: 'Font Awesome\\ 5 Free';\r\n            font-weight: 900;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n    &::after {\r\n        display: block;\r\n        clear: both;\r\n        content: \"\";\r\n    }\r\n}\r\n@media (max-width: 1199px) {\r\n    .get-a-quote-form .btn-wrapper {\r\n        padding: 0 0px;\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .get-a-quote-wrap {\r\n        padding: 40px 30px 50px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Car Dealer Form\r\n---------------------------------------------------- */\r\n.ltn__car-dealer-form-tab {\r\n    .ltn__tab-menu {\r\n        margin-bottom: 0;\r\n        .active {\r\n            border-color: var(--ltn__secondary-color);\r\n            background-color: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n    .tab-content {\r\n        padding: 40px;\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n.ltn__car-dealer-form-box {\r\n    .ltn__car-dealer-form-item {\r\n        position: relative;\r\n        display: inline-block;\r\n        margin-bottom: 30px;\r\n    }\r\n    .nice-select {\r\n        margin: 0;\r\n        height: 60px;\r\n        line-height: 58px;\r\n        padding-right: 40px;\r\n        padding-left: 20px;\r\n        border-radius: 0;\r\n        min-width: 200px;\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n        font-family: var(--ltn__heading-font);\r\n        width: 100%;\r\n        .list {\r\n            width: 100%;\r\n            z-index: 99;\r\n        }\r\n    }\r\n    .ltn__custom-icon {\r\n        &::before {\r\n            display: none;\r\n        }\r\n        .nice-select {\r\n            &::before {\r\n                content: \"\\f063\";\r\n                font-family: 'Font Awesome\\ 5 Free';\r\n                font-weight: 900;\r\n                margin-right: 10px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n        &.ltn__icon-calendar {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f073\";\r\n                }\r\n            }\r\n        }\r\n        &.ltn__icon-car {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f1b9\";\r\n                }\r\n            }\r\n        }\r\n        &.ltn__icon-meter {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f3fd\";\r\n                }\r\n            }\r\n        }\r\n        &.ltn__icon-ring {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f1cd\";\r\n                }\r\n            }\r\n        }\r\n        &.ltn__icon-cog {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f013\";\r\n                }\r\n            }\r\n        }\r\n        &.ltn__icon-transgender {\r\n            .nice-select {\r\n                &::before {\r\n                    content: \"\\f225\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n.car-price-filter-range {\r\n    .price_filter {\r\n        .ui-widget-content {\r\n            height: 8px;\r\n            background-color: var(--white);\r\n            margin-top: 20px;\r\n        }\r\n        .ui-state-default {\r\n            &:last-child {\r\n                &::before {\r\n                    position: absolute;\r\n                }\r\n                &::after {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    top: -30px;\r\n                    left: -5px;\r\n                    background-image: url(../../img/icons/car.png);\r\n                    z-index: 99;\r\n                    width: 125px;\r\n                    height: 50px;\r\n                    background-repeat: no-repeat;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .price_slider_amount > input[type=\"text\"], \r\n    .price_slider_amount > input[type=\"submit\"] {\r\n        font-weight: 700;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__car-dealer-form-tab .tab-content {\r\n        padding: 40px 25px;\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Video Area\r\n---------------------------------------------------- */\r\n/* car home 3 */\r\n.ltn__video-popup-margin {\r\n    margin-bottom: -180px;\r\n}\r\n/* Service page */\r\n.ltn__video-popup-margin-2 { \r\n    margin-top: -295px;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Brand Logo\r\n---------------------------------------------------- */\r\n.ltn__brand-logo-item {\r\n    -webkit-filter: grayscale(0);\r\n    filter: grayscale(0);\r\n    opacity: 1;\r\n    transition: all 0.3s ease 0s;\r\n    margin: 10px 0;\r\n    img {\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n    &:hover {\r\n        -webkit-filter: grayscale(0);\r\n        filter: grayscale(0);\r\n        opacity: 1;\r\n        img {\r\n            transform: scale(1.1);\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Progress Bar \r\n---------------------------------------------------- */\r\n.ltn__progress-bar-wrap {\r\n    margin-bottom: 50px;\r\n}\r\n.ltn__progress-bar-item {\r\n    overflow: hidden;\r\n    margin-bottom: 10px;\r\n    & > p {\r\n        font-size: 18px;\r\n        font-weight: 700;\r\n        margin: 0;\r\n    }\r\n    .progress {\r\n        background: #ebeeee none repeat scroll 0 0;\r\n        border-radius: 0;\r\n        box-shadow: none;\r\n        font-weight: 400;\r\n        height: 3px;\r\n        letter-spacing: 1px;\r\n        margin-bottom: 15px;\r\n        margin-top: 12px;\r\n        overflow: visible;\r\n        text-transform: uppercase;\r\n        position: relative;\r\n    }\r\n    .progress-bar {\r\n        background-color: var(--ltn__secondary-color);\r\n        box-sizing: border-box;\r\n        color: var(--ltn__secondary-color);\r\n        font-size: 11px;\r\n        overflow: visible;\r\n        height: 7px;\r\n        margin-top: -2px;\r\n        text-align: left;\r\n        position: relative;\r\n        span {\r\n            border-radius: 15px;\r\n            display: inline-block;\r\n            height: 25px;\r\n            letter-spacing: 0;\r\n            line-height: 24px;\r\n            min-width: 25px;\r\n            padding: 0 3px;\r\n            position: absolute;\r\n            right: 0;\r\n            text-align: center;\r\n            bottom: 15px;\r\n            font-size: 18px;\r\n            font-weight: 700;\r\n            transition: all 0.3s ease 0s;\r\n        }\r\n    }\r\n}\r\n\r\n/* progress-bar-item-2 */\r\n.ltn__progress-bar-item-2 {\r\n    margin-bottom: 50px;\r\n    .progress {\r\n        width: 160px;\r\n        height: 160px;\r\n        background: none;\r\n        position: relative;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        &::after {\r\n            content: \"\";\r\n            width: 100%;\r\n            height: 100%;\r\n            border-radius: 50%;\r\n            border: 10px solid #eee;\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n        }\r\n        & > span {\r\n            width: 50%;\r\n            height: 100%;\r\n            overflow: hidden;\r\n            position: absolute;\r\n            top: 0;\r\n            z-index: 1;\r\n        }\r\n        .progress-bar {\r\n            width: 100%;\r\n            height: 100%;\r\n            background: none;\r\n            border-width: 10px;\r\n            border-style: solid;\r\n            position: absolute;\r\n            top: 0;\r\n            border-color: var(--ltn__secondary-color) !important;\r\n        }\r\n        .progress-left {\r\n            left: 0;\r\n            .progress-bar {\r\n                left: 100%;\r\n                border-top-right-radius: 80px;\r\n                border-bottom-right-radius: 80px;\r\n                border-left: 0;\r\n                -webkit-transform-origin: center left;\r\n                transform-origin: center left;\r\n            }\r\n        }\r\n        .progress-right {\r\n            right: 0;\r\n            .progress-bar {\r\n                left: -100%;\r\n                border-top-left-radius: 80px;\r\n                border-bottom-left-radius: 80px;\r\n                border-right: 0;\r\n                -webkit-transform-origin: center right;\r\n                transform-origin: center right;\r\n            }\r\n        }\r\n        .progress-value {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            height: 100%;\r\n            width: 100%;\r\n            border-radius: 100%;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n        }\r\n        .progress-count {\r\n            font-size: 50px;\r\n            font-weight: 700;\r\n            sup, sub {\r\n                font-weight: 400;\r\n                font-size: 20px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n    .ltn__progress-info {\r\n        margin-top: 25px;\r\n        h3 {\r\n            margin-bottom: 5px;\r\n            text-transform: uppercase;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__progress-bar-item {\r\n        & > p {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Our Journey Area\r\n---------------------------------------------------- */\r\n.ltn__our-journey-wrap {\r\n    ul {\r\n        margin-left: 0;\r\n        padding-left: 0;\r\n    }\r\n    & > ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        display: flex;\r\n        justify-content: space-around;\r\n        position: relative;\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            background-color: #d13724;\r\n            height: 4px;\r\n            width: 100%;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n        }\r\n        li {\r\n            list-style: none;\r\n            margin: 0;\r\n        }\r\n        & > li {\r\n            display: inline-block;\r\n            position: relative;\r\n            margin: 0 10px;\r\n            &:nth-last-child(1),\r\n            &:nth-last-child(2) {\r\n                ul {\r\n                    left: auto;\r\n                    right: 0;\r\n                }\r\n            }\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\";\r\n                top: 15px;\r\n                width: 0;\r\n                height: 0;\r\n                border-left: 15px solid transparent;\r\n                border-right: 15px solid transparent;\r\n                border-bottom: 15px solid #fff;\r\n                left: 0;\r\n                right: 0;\r\n                margin: auto;\r\n                transition: all 0.3s ease 0s;\r\n                opacity: 0;\r\n                visibility: hidden;\r\n            }\r\n            ul {\r\n                position: absolute;\r\n                bottom: 100%;\r\n                transition: all 0.3s ease 0s;\r\n                opacity: 0;\r\n                visibility: hidden;\r\n            }\r\n            &.active,\r\n            &:hover {\r\n                .ltn__journey-icon {\r\n                    background-color: var(--white);\r\n                    color: var(--ltn__secondary-color);\r\n                }\r\n                ul {\r\n                    opacity: 1;\r\n                    visibility: visible;\r\n                }\r\n                &::before {\r\n                    opacity: 1;\r\n                    visibility: visible;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .ltn__journey-icon {\r\n        font-size: 20px;\r\n        font-weight: 700;\r\n        padding: 40px;\r\n        background-color: var(--ltn__primary-color);\r\n        color: var(--white);\r\n        display: block;\r\n        margin: 30px 0;\r\n        transition: all 0.3s ease 0s;\r\n        box-shadow: var(--ltn__box-shadow-2);\r\n        text-align: center;\r\n    }\r\n    .dropdown-menu {\r\n        padding: 0;\r\n    }\r\n}\r\n.ltn__journey-history-item-info {\r\n    background-color: var(--white);\r\n    padding: 20px;\r\n    display: block;\r\n    width: 550px;\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n    position: relative;\r\n    .ltn__journey-history-img {\r\n        float: left;\r\n        margin-right: 20px;\r\n        max-width: 150px;\r\n    }\r\n    .ltn__journey-history-info {\r\n        overflow: hidden;\r\n    }\r\n    h3 {\r\n        margin-bottom: 5px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    .ltn__journey-history-item-info {\r\n        width: 500px;\r\n    }\r\n}\r\n@media (max-width: 1199px) {\r\n    .ltn__our-journey-wrap .ltn__journey-icon {\r\n        font-size: 18px;\r\n        padding: 20px;\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .ltn__journey-history-item-info {\r\n        width: 350px;\r\n        .ltn__journey-history-img {\r\n            float: none;\r\n            margin-bottom: 20px;\r\n            max-width: 100px;\r\n        }\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__our-journey-wrap > ul {\r\n        flex-flow: column;\r\n    }\r\n    .ltn__our-journey-wrap > ul > li ul {\r\n        left: 30px;\r\n    }\r\n    .ltn__our-journey-wrap > ul > li:nth-last-child(1) ul, \r\n    .ltn__our-journey-wrap > ul > li:nth-last-child(2) ul {\r\n        left: 30px;\r\n        right: auto;\r\n    }\r\n}\r\n@media (max-width: 575px) {\r\n    .ltn__journey-history-item-info {\r\n        width: 250px;\r\n        .ltn__journey-history-img {\r\n            float: none;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n    \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Google Map Locations Area\r\n---------------------------------------------------- */\r\n.ltn__google-map-locations-area {\r\n    #gmap {\r\n        height: 90vh;\r\n        .gm-ui-hover-effect {\r\n            top: 0 !important;\r\n            right: 0 !important;\r\n        }\r\n        .gm-style .gm-style-iw-c {\r\n            padding: 25px 8px 5px 25px !important;\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__map-item {\r\n    padding: 30px 25px 35px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    .ltn__location-name {\r\n        border-bottom: 2px solid var(--border-color-1);\r\n        margin-bottom: 25px;\r\n        color: var(--ltn__secondary-color);\r\n        font-size: 20px;\r\n    }\r\n    .ltn__location-single-info {\r\n        display: flex;\r\n        align-items: center;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        i {\r\n            margin-right: 10px;\r\n            background: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n            width: 40px;\r\n            height: 40px;\r\n            line-height: 40px;\r\n            text-align: center;    \r\n        }\r\n    }\r\n    .btn-wrapper {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .btn {\r\n        padding: 10px 10px;\r\n        font-size: 13px;\r\n        margin-right: 10px;\r\n    }\r\n}\r\n.ltn__google-map-locations-list-area {\r\n    .ltn__map-item {\r\n        margin-bottom: 50px;\r\n    }\r\n}\r\n.ltn__location-search {\r\n    h3 {\r\n        float: left;\r\n        margin-right: 30px;\r\n        margin-bottom: 0;\r\n        line-height: 63px;\r\n        color: var(--white);\r\n    }\r\n    .input-item {\r\n        float: left;\r\n        width: 300px;\r\n    }\r\n    form {\r\n        padding: 50px 50px 20px;\r\n        background-color: var(--ltn__secondary-color);\r\n    }\r\n}\r\n.ltn__state-location-title {\r\n    padding: 15px 30px;\r\n    background-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n    margin: 50px 0;\r\n}\r\n.ltn__map-product-item {\r\n    max-width: 260px;\r\n    img {\r\n        max-width: 100%;\r\n        margin-bottom: 25px;\r\n    }\r\n    .ltn__map-product-title {\r\n        margin-bottom: 10px;\r\n        font-size: 16px;\r\n        font-weight: 600;\r\n    }\r\n    .ltn__map-product-price {\r\n        color: var(--ltn__secondary-color);\r\n    }\r\n    .ltn__map-product-location {\r\n        font-weight: 500;\r\n        i {\r\n            color: var(--ltn__secondary-color);\r\n            margin-right: 2px;\r\n        }\r\n    }\r\n    .ltn__map-product-info {\r\n        font-weight: 500;\r\n        span {\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Team Details\r\n---------------------------------------------------- */\r\n.ltn__team-details-member-info {\r\n    .team-details-img {\r\n        margin-bottom: 30px;\r\n        max-width: 350px;\r\n    }\r\n    &.text-right {\r\n        .team-details-img {\r\n            margin-left: auto;\r\n            margin-right: 0;\r\n        }\r\n    }\r\n    &.text-center {\r\n        .team-details-img {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n        }\r\n    }\r\n}\r\n.ltn__team-details-member-about {\r\n    ul {\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n            display: block;\r\n            strong {\r\n                min-width: 120px;\r\n                display: inline-block;\r\n            }\r\n        }\r\n    }\r\n    & > ul {\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Our History Area\r\n---------------------------------------------------- */\r\n.ltn__our-history-inner {\r\n    .ltn__tab-menu {\r\n        .nav {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\";\r\n                left: 0;\r\n                top: 50%;\r\n                width: 100%;\r\n                height: 2px;\r\n                background-color: var(--white-6);\r\n                z-index: -1;\r\n            }\r\n        }\r\n        a {\r\n            background-color: var(--white);\r\n            border: 2px solid var(--white-6);\r\n        }\r\n        .active {\r\n            border-color: var(--ltn__secondary-color);\r\n            background-color: var(--ltn__secondary-color);\r\n            color: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__history-icon {\r\n    position: absolute;\r\n    bottom: 40px;\r\n    right: 0;\r\n    font-size: 160px;\r\n    line-height: 1;\r\n    color: var(--ltn__secondary-color);\r\n    i {\r\n        margin: 0;\r\n    }\r\n}\r\n.ltn__our-history-inner {\r\n    .about-img-left {\r\n        padding-right: 70px;\r\n    }\r\n    .about-img-right {\r\n        padding-left: 70px;\r\n    }\r\n}\r\n\r\n.ltn__our-history-inner-2 {\r\n    .ltn__tab-menu {\r\n        margin-bottom: 20px;\r\n        .nav {\r\n            display: flex;\r\n            justify-content: flex-end;\r\n            position: relative;\r\n            &::before {\r\n                display: none;\r\n            }\r\n        }\r\n        a {\r\n            background-color: transparent;\r\n            border: 2px solid transparent;\r\n            font-size: 22px;\r\n            padding: 5px 20px;\r\n        }\r\n        .active {\r\n            border-color: transparent;\r\n            background-color: transparent;\r\n            color: var(--ltn__secondary-color);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .ltn__history-icon {\r\n        bottom: 10px;\r\n        right: 10px;\r\n        font-size: 80px;\r\n    }\r\n    .ltn__our-history-inner {\r\n        .about-img-left {\r\n            padding-right: 0px;\r\n        }\r\n        .about-img-right {\r\n            padding-left: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Appointment Form Area\r\n---------------------------------------------------- */\r\n.ltn__appointment-inner {\r\n    .alert {\r\n        border-radius: 0;\r\n        padding: 20px 30px;\r\n        margin-bottom: 30px;\r\n    }\r\n    .alert-danger {\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Checkout Page\r\n---------------------------------------------------- */\r\n.ltn__checkout-single-content {\r\n    margin-bottom: 30px;\r\n    h5 {\r\n        background-color: var(--section-bg-1);\r\n        padding: 20px 30px;\r\n    }\r\n}\r\n.ltn__checkout-single-content-info {\r\n    padding: 30px;\r\n    border: 1px solid var(--border-color-1);\r\n}\r\n\r\n.ltn__checkout-payment-method {\r\n    .card {\r\n        padding: 20px;\r\n        border-radius: 0;\r\n    }\r\n    .card:not(:last-of-type) {\r\n        border-bottom: 0;\r\n        border-bottom-right-radius: 0;\r\n        border-bottom-left-radius: 0;\r\n    }\r\n    .card-body {\r\n        padding: 15px 30px;\r\n        box-shadow: var(--ltn__box-shadow-3);\r\n        margin-top: 15px;\r\n        position: relative;\r\n        &::before {\r\n            position: absolute;\r\n            top: -3px;\r\n            left: 25px;\r\n            width: 10px;\r\n            height: 10px;\r\n            content: \"\";\r\n            -webkit-transform: rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: rotate(45deg);\r\n            background-color: #fff;\r\n        }\r\n    }\r\n    .ltn__card-title {\r\n        position: relative;\r\n        padding-left: 30px;\r\n        margin-bottom: 0;\r\n        &::before {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 0;\r\n            width: 16px;\r\n            height: 16px;\r\n            margin-top: 2px;\r\n            content: \"\";\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n            border: 1px solid #333;\r\n            border-radius: 50%;\r\n        }\r\n        &::after {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 2px;\r\n            width: 11px;\r\n            height: 11px;\r\n            margin-top: 2px;\r\n            content: \"\";\r\n            -webkit-transition: all .5s ease 0s;\r\n            -o-transition: all .5s ease 0s;\r\n            transition: all .5s ease 0s;\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n            opacity: 0;\r\n            border-radius: 50%;\r\n            background-color: #333;\r\n        }\r\n        img {\r\n            height: 45px;\r\n            margin-left: 10px;\r\n        }\r\n    }\r\n    .ltn__card-title[aria-expanded=\"true\"]::after {\r\n        opacity: 1;\r\n    }\r\n    p {\r\n        font-size: 14px;\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }  \r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Myaccount Page\r\n---------------------------------------------------- */\r\n.ltn__tab-menu-list {\r\n    .nav {\r\n        display: block;\r\n        margin-right: 30px;\r\n        border: 1px solid #eee;\r\n        a {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            padding: 15px 20px;\r\n            border-bottom: 1px solid var(--border-color-1);\r\n            &:last-child {\r\n                border-bottom: 0;\r\n            }\r\n            i {\r\n                font-size: 14px;\r\n            }\r\n            &.active {\r\n                background-color: var(--section-bg-2);\r\n                color: var(--white);\r\n            }\r\n        }\r\n    }\r\n}\r\n.ltn__myaccount-tab-content-inner {\r\n    & > p {\r\n        padding: 20px;\r\n        background-color: var(--section-bg-1);\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Time Schedule Area\r\n---------------------------------------------------- */\r\n.ltn__time-schedule-widget {\r\n    padding: 50px 40px;\r\n    margin-top: -10px;\r\n    h3 {\r\n        border-bottom: 2px solid rgba(255,255,255,0.1);\r\n        padding-bottom: 20px;\r\n        margin-bottom: 25px;\r\n    }\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            display: block;\r\n            span {\r\n                float: right;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Contact Feature\r\n---------------------------------------------------- */\r\n.ltn__contact-feature-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 25px 30px 20px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    margin-bottom: 30px;\r\n    background-color: var(--white);\r\n}\r\n.ltn__contact-feature-icon {\r\n    font-size: 50px;\r\n    margin-right: 20px;\r\n    color: var(--ltn__secondary-color);\r\n    line-height: 1;\r\n    max-width: 50px;\r\n}\r\n.ltn__contact-feature-info {\r\n    .h6,\r\n    .h2 {\r\n        font-family: var(--ltn__body-font);\r\n    }\r\n    .h6 {\r\n        color: var(--ltn__color-3);\r\n    }\r\n}\r\n@media (max-width: 1400px) {\r\n    .ltn__contact-feature-icon {\r\n        font-size: 40px;\r\n        margin-right: 15px;\r\n    }\r\n    .ltn__contact-feature-info {\r\n        .h6 {\r\n            font-size: 14px;\r\n        }\r\n        .h2 {\r\n            font-size: 18px;\r\n        }\r\n    }  \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Image Slide (Screenshot)\r\n---------------------------------------------------- */\r\n.ltn__img-slide-item-4,\r\n.ltn__img-slide-item-3,\r\n.ltn__img-slide-item-2 {\r\n    & > a {\r\n        display: block;\r\n        overflow: hidden;\r\n    }\r\n    img {\r\n        transition: all 0.5s ease 0s;\r\n    }\r\n    &:hover {\r\n        img {\r\n            transform: scale(1.1)\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Background Video\r\n---------------------------------------------------- */\r\n/* Video From Local (src=\"myFolderName/videoName.mp4\") */\r\n\r\n/*\r\n#myVideo {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n    min-width: 100%; \r\n    min-height: 100%;\r\n}\r\n\r\n*/\r\n#myVideo {\r\n    position: absolute;\r\n    left: 0;\r\n    right: auto;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: auto;\r\n    min-width: 100%; \r\n    min-height: 100%;\r\n}\r\n\r\n\r\n/* Video From Link (src=\"website.com/videoUrl\") */\r\n.video-foreground,\r\n.video-background iframe {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n}\r\n.ltn__video-play-btn {\r\n    margin-top: 0;\r\n    width: 60px;\r\n    height: 60px;\r\n    line-height: 65px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    border-radius: 100%;\r\n    box-shadow: var(--ltn__box-shadow-2);\r\n}\r\n\r\n/* YouTube Video */\r\n.ltn__youtube-video-background {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n    z-index: 1;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Newsletter Popup 2\r\n---------------------------------------------------- */\r\n.ltn__newsletter-popup-2 {\r\n    .modal-header .close {\r\n        background-color: var(--section-bg-1);\r\n        color: var(--ltn__heading-color);\r\n        border-radius: 0px 0px 0px 20px;\r\n    }\r\n    .modal-body {\r\n        padding: 0;\r\n    }\r\n    .ltn__newsletter-popup-info {\r\n        padding: 30px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Newsletter Popup\r\n---------------------------------------------------- */\r\n.ltn__newletter-popup-active {\r\n    max-width: 850px;\r\n    background: #fff;\r\n    top: 50% !important;\r\n    margin-top: -179px;\r\n    position: fixed !important;\r\n    display: none;\r\n}\r\n.ltn__newletter-popup {\r\n    position: relative;\r\n    padding: 30px;\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n    .subscribe-bottom {\r\n        font-size: 14px;\r\n    }\r\n}\r\n.ltn__newsletter-close {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    z-index: 999;\r\n}\r\n.ltn__newsletter-close:hover {\r\n    color: var(--ltn__secondary-color);\r\n}\r\n.ltn__newsletter-close-btn-left {\r\n    right: auto;\r\n    left: 0;\r\n}\r\n.ltn__newsletter-popup-info {\r\n    padding: 15px;\r\n}\r\n.text-center {\r\n    .ltn__newsletter-popup-info {\r\n        input[type=\"email\"] {\r\n            text-align: center;\r\n        }\r\n    }\r\n}\r\n.ltn__newletter-popup-3 {\r\n    padding: 0;\r\n    .ltn__newsletter-popup-info {\r\n        padding: 30px;\r\n    }\r\n}\r\n.ltn__newletter-popup-4 {\r\n    padding: 0;\r\n    .ltn__newsletter-popup-info {\r\n        padding: 30px 30px 30px 10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .ltn__newletter-popup-active {\r\n        max-width: 400px;\r\n        max-height: 450px;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n    .ltn__newsletter-popup-img {\r\n        display: none;\r\n    }\r\n}\r\n@media (max-width: 768px) {\r\n    .ltn__newletter-popup-active {\r\n        max-width: 300px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Apartments Plan Area\r\n---------------------------------------------------- */\r\n.apartments-plan-info {\r\n    padding: 70px;\r\n}\r\n.apartments-plan-info,\r\n.apartments-plan-img {\r\n    margin-bottom: 50px;\r\n}\r\n.apartments-info-list {\r\n    & > ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            list-style: none;\r\n            margin-top: 10px;\r\n            display: block;\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\";\r\n                width: 100%;\r\n                height: 1px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                border: 1px dashed;\r\n                border-color: var(--section-bg-5);\r\n                z-index: 1;\r\n            }\r\n            a {\r\n                display: block;\r\n                span {\r\n                    float: right;\r\n                }\r\n            }\r\n            label {\r\n                padding-right: 10px;\r\n                background-color: var(--white);\r\n                position: relative;\r\n                z-index: 2;\r\n            }\r\n            span {\r\n                float: right;\r\n                padding-left: 10px;\r\n                background-color: var(--white);\r\n                position: relative;\r\n                z-index: 2;\r\n            }\r\n        }\r\n    }\r\n}\r\n.apartments-info-list-color {    \r\n    & > ul {\r\n        li {\r\n            &::before {\r\n                border-color: var(--section-bg-5);\r\n            }\r\n            label {\r\n                background-color: var(--ltn__secondary-color);\r\n            }\r\n            span {\r\n                background-color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n.section-bg-1 {\r\n    .apartments-info-list-color {    \r\n        & > ul {\r\n            li {\r\n                &::before {\r\n                    border-color: var(--ltn__color-1);\r\n                }\r\n                label {\r\n                    background-color: var(--section-bg-1);\r\n                }\r\n                span {\r\n                    background-color: var(--section-bg-1);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media ( max-width: 767px ) {\r\n    .apartments-plan-info {\r\n        padding: 30px;\r\n    }\r\n    .apartments-info-list {\r\n        ul {\r\n            li {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Upcoming Project Area\r\n---------------------------------------------------- */\r\n.ltn__upcoming-project-item {\r\n    padding: 30px 45px 30px 30px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    margin-top: 10px;\r\n    margin-bottom: 50px;\r\n    background-color: var(--white);\r\n    .ltn__upcoming-project-img {\r\n        margin-top: 0;\r\n    }\r\n    .ltn__upcoming-project-info {\r\n        padding: 50px 20px;\r\n    }\r\n}\r\n\r\n@media ( max-width: 991px ) {\r\n    .ltn__upcoming-project-item {\r\n        padding: 30px 30px 30px 30px;\r\n        .ltn__upcoming-project-img {\r\n            margin-bottom: 30px;\r\n        }\r\n    } \r\n}\r\n@media ( max-width: 767px ) {\r\n    .ltn__upcoming-project-item {\r\n        .ltn__upcoming-project-info {\r\n            padding: 50px 0px;\r\n        }\r\n    } \r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Search By Place Area\r\n---------------------------------------------------- */\r\n.ltn__search-by-place-item {\r\n    padding: 15px;\r\n    box-shadow: var(--ltn__box-shadow-4);\r\n    background-color: var(--white);\r\n    margin-bottom: 50px;\r\n    .search-by-place-img {\r\n        position: relative;\r\n        .search-by-place-badge {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 10px;\r\n            ul {\r\n                padding: 0;\r\n                margin: 0;\r\n                li {\r\n                    display: inline-block;\r\n                    background-color: var(--white);\r\n                    padding: 6px 15px 2px;\r\n                    border-radius: 25px;\r\n                    box-shadow: var(--ltn__box-shadow-4);\r\n                    font-size: 13px;\r\n                    text-transform: uppercase;\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .search-by-place-info {\r\n        padding: 30px 5px 10px;\r\n        h6 {\r\n            font-family: var(--ltn__body-font);\r\n            color: var(--ltn__color-5);\r\n            font-weight: 400;\r\n        }\r\n        h4 {\r\n            font-weight: 600;\r\n        }\r\n        .search-by-place-btn {\r\n            a {\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n    }\r\n    .search-by-place-brief {\r\n        font-size: 14px;\r\n        margin-top: 10px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Select Availability Table Area\r\n---------------------------------------------------- */\r\n.ltn__select-availability-table-wrap {\r\n    .tower-name {\r\n        text-transform: uppercase;\r\n    }\r\n}\r\n.ltn__select-availability-table {\r\n    ul {\r\n        padding: 0 0 15px;\r\n        margin: 0;\r\n        display: flex;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            flex: 1;\r\n            text-align: center;\r\n        }\r\n    }\r\n    .ltn__select-availability-table-head {\r\n        border-bottom: 2px solid;\r\n        border-color: var(--border-color-1);\r\n    }\r\n    .ltn__select-availability-table-row {\r\n        &:nth-child(odd) {\r\n            background-color: var(--section-bg-1);\r\n        }\r\n    }\r\n}\r\n\r\n.ltn__select-availability-table-responsive {\r\n    .ltn__select-availability-table-row-responsive-item {\r\n        padding: 10px 0 25px;\r\n        margin: 0;\r\n        text-align: center;\r\n        &:nth-child(odd) {\r\n            background-color: var(--section-bg-1);\r\n        }\r\n        li {\r\n            display: block;\r\n            list-style: none;\r\n            &::after {\r\n                display: block;\r\n                clear: both;\r\n                content: \"\";\r\n            }\r\n            span {\r\n                width: 50%;\r\n                float: left;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Neighbour Area\r\n---------------------------------------------------- */\r\n.ltn__neighbour-tab-wrap {\r\n    position: relative;\r\n    .ltn__tab-menu-4 {\r\n        position: absolute;\r\n        z-index: 2;\r\n        bottom: 10px;\r\n        left: 20px;\r\n    }\r\n}\r\n\r\n@media ( max-width: 991px ) {\r\n    .ltn__neighbour-tab-wrap {\r\n        .ltn__tab-menu-4 {\r\n            position: inherit;\r\n            margin-bottom: 30px;\r\n            left: inherit;\r\n            bottom: inherit;\r\n            a {\r\n                img {\r\n                    max-width: 70px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    LightCase\r\n---------------------------------------------------- */\r\n#lightcase-overlay {\r\n    z-index: 9999;\r\n    background: var(--section-bg-2);\r\n}\r\n#lightcase-case {\r\n    z-index: 99999;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","/* ----------------------------------------------------\r\n    Footer Default Style\r\n---------------------------------------------------- */\r\n.footer-widget {\r\n    .footer-title {\r\n        font-size: 22px;\r\n    }\r\n}\r\n\r\n/* footer-2 */\r\n.ltn__footer-2 {\r\n    .footer-widget {\r\n        .footer-title {\r\n            font-size: 24px;\r\n        }\r\n        p,\r\n        li {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n    .footer-about-widget {\r\n        .footer-logo {\r\n            position: relative;\r\n            top: -20px;\r\n            margin-bottom: 10px;\r\n        }\r\n    }\r\n    .footer-menu ul li {\r\n        margin-bottom: 30px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n\r\n.ltn__footer-2 .footer-widget,\r\n.footer-widget {\r\n    .ltn__blog-meta {\r\n        li {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n\r\n/* footer-color-1 */\r\n.ltn__footer-color-1 {\r\n    p {\r\n        color: var(--ltn__color-2);\r\n        a {\r\n            color: var(--white);\r\n        }\r\n    }\r\n    .ltn__footer-timeline-widget-1 {\r\n        li {\r\n            span {\r\n                color: var(--ltn__color-1);\r\n            }\r\n            &:last-child {\r\n                span {\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .footer-menu ul li {\r\n        color: var(--ltn__color-2);\r\n    } \r\n    .ltn__footer-blog-item {\r\n        border-color: var(--border-color-6);\r\n        .ltn__blog-meta {\r\n            li {\r\n                color: var(--ltn__color-2);\r\n            }\r\n        }\r\n    }\r\n    .ltn__copyright-area {\r\n        background-color: var(--ltn__primary-color-2);\r\n    }\r\n    .get-support-info h6 {\r\n        color: var(--ltn__color-4);\r\n    }\r\n    .get-support-info h4 {\r\n        color: var(--white);\r\n    }\r\n    .ltn__copyright-menu ul li {\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n/* footer-color-2 */\r\n.ltn__footer-color-2 {\r\n    .ltn__footer-timeline-widget-1 {\r\n        background-color: var(--white);\r\n        li {\r\n            border-color: transparent;\r\n            &:last-child {\r\n                span {\r\n                    color: var(--ltn__secondary-color);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .ltn__footer-blog-item {\r\n        border-color: var(--border-color-7);\r\n    }\r\n    .ltn__copyright-area {\r\n        background-color: var(--white-4);\r\n    }\r\n}\r\n\r\n/*-------------------------\r\n    Footer Area\r\n-------------------------*/\r\n.footer-top-area {\r\n    padding-top: 92px;\r\n    padding-bottom: 20px;\r\n}\r\n.footer-widget {\r\n    margin-bottom: 60px;\r\n}\r\n.footer-logo {\r\n    position: relative;\r\n    top: -10px;\r\n}\r\n.footer-title {\r\n    font-size: 20px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Footer About Widget\r\n---------------------------------------------------- */\r\n/* footer-address */\r\n.footer-address {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: block;\r\n            margin-top: 8px;\r\n            &:after {\r\n                display: block;\r\n                clear: both;\r\n                content: \"\";\r\n            }\r\n            .footer-address-icon {\r\n                float: left;\r\n                margin-right: 15px;\r\n            }\r\n            .footer-address-info {\r\n                overflow: hidden;\r\n                p {\r\n                    margin-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Footer Menu Widget\r\n---------------------------------------------------- */\r\n/* footer-menu */\r\n.footer-menu ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    li {\r\n        list-style: none;\r\n        margin-top: 0px;\r\n        margin-bottom: 15px;\r\n        position: relative;\r\n        a {\r\n            position: relative;\r\n            &::before {\r\n                position: absolute;\r\n                content: \"//\";\r\n                left: 0;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                transition: inherit;\r\n                opacity: 0;\r\n                visibility: hidden;\r\n                margin-left: -20px;\r\n                color: var(--ltn__secondary-color);\r\n            }\r\n        }\r\n        &:hover {\r\n            a {\r\n                padding-left: 20px;\r\n                &::before {\r\n                    opacity: 1;\r\n                    visibility: visible;\r\n                    margin-left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.footer-menu ul ul {\r\n    margin-left: 15px;\r\n}\r\n\r\n/* footer-menu-widget-2-column */\r\n.footer-menu-widget-2-column {\r\n    padding-left: 30px;\r\n    .footer-menu {\r\n        width: 50%;\r\n        float: left;\r\n        &:nth-child(odd) {\r\n            padding-left: 20px;\r\n        }\r\n    }\r\n    ul {\r\n        margin: 0;\r\n        li {\r\n            font-weight: 600;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Footer Newsletter Widget\r\n---------------------------------------------------- */\r\n.footer-newsletter {\r\n    form {\r\n        position: relative;\r\n    }\r\n    input[type=\"email\"] {\r\n        margin: 0;\r\n        padding-right: 50px;\r\n    }\r\n    .btn-wrapper {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        margin: 0;\r\n        height: 100%;\r\n        .btn {\r\n            padding: 0 18px;\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Footer Timeline Widget\r\n---------------------------------------------------- */\r\n.ltn__footer-timeline-widget {\r\n    padding: 50px 50px 40px;\r\n    border-bottom: 5px solid;\r\n    border-color: var(--border-color-5);\r\n    margin-top: -92px;\r\n    .footer-title {\r\n        font-size: 36px;\r\n    }\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            font-family: var(--ltn__heading-font);\r\n            font-weight: 700;\r\n            border-bottom: 1px solid;\r\n            border-color: var(--border-color-6);\r\n            padding-bottom: 10px;\r\n            margin-top: 10px;\r\n            &:last-child {\r\n                border-bottom: 0;\r\n                padding-bottom: 0;\r\n                span {\r\n                    font-weight: 700;\r\n                }\r\n            }\r\n            span {\r\n                float: right;\r\n                font-weight: 600;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* ----------------------------------------------------\r\n    Footer Blog Widget\r\n---------------------------------------------------- */\r\n.ltn__footer-blog-item {\r\n    border-bottom: 1px solid;\r\n    border-color: var(--border-color-6);\r\n    margin-bottom: 20px;\r\n    &:last-child {\r\n        border-bottom: 0;\r\n        margin-bottom: 0;\r\n    }\r\n    .ltn__blog-meta {\r\n        margin-bottom: 5px;\r\n        i {\r\n            color: var(--ltn__secondary-color);\r\n            margin-right: 5px;\r\n        }\r\n    }\r\n    .ltn__blog-title {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Copyright Area\r\n---------------------------------------------------- */\r\n.ltn__copyright-area {\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n    .payment-method {\r\n        text-align: right;\r\n    }\r\n}\r\n\r\n.ltn__copyright-design {\r\n    h6, h4 {\r\n        font-size: 14px;\r\n        font-family: var(--ltn__body-font);\r\n        font-weight: 700;\r\n    }\r\n    p {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.ltn__copyright-menu {\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        li {\r\n            list-style: none;\r\n            display: inline-block;\r\n            margin-top: 0;\r\n            margin-right: 20px;\r\n            font-size: 14px;\r\n            font-family: var(--ltn__heading-font);\r\n            font-weight: 600;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            a {\r\n                margin: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    Responsive\r\n---------------------------------------------------- */\r\n@media (max-width: 991px) {\r\n    .ltn__footer-timeline-widget {\r\n        padding: 50px 25px 40px;\r\n    }\r\n    .ltn__copyright-area {\r\n        text-align: center;\r\n        .payment-method {\r\n            text-align: center;\r\n            margin-top: 15px;\r\n        }\r\n        .site-logo-wrap {\r\n            justify-content: center;\r\n           \r\n        }\r\n        .ltn__copyright-menu {\r\n            text-align: center !important;\r\n        }\r\n    }\r\n    #scrollUp {\r\n        font-size: 16px;\r\n        height: 30px;\r\n        width: 30px;\r\n        bottom: 50px;\r\n    }\r\n    #scrollUp i {\r\n        line-height: 30px;\r\n    }\r\n\r\n}\r\n@media (max-width: 767px) {\r\n    .ltn__footer-timeline-widget {\r\n        padding: 50px 25px 40px;\r\n    }\r\n    .footer-menu-widget-2-column {\r\n        padding-left: 0;\r\n    } \r\n    .ltn__copyright-menu {\r\n        margin-top: 25px;\r\n    }\r\n    .ltn__footer-2 .footer-widget p, \r\n    .ltn__footer-2 .footer-widget li {\r\n        font-size: 14px;\r\n    }\r\n    .ltn__footer-2 .footer-widget,\r\n    .footer-widget {\r\n        .ltn__blog-meta {\r\n            li {\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n    .ltn__footer-2 .footer-menu ul li {\r\n        margin-bottom: 20px;\r\n    }\r\n    .ltn__footer-blog-item .ltn__blog-title {\r\n        font-size: 18px;\r\n    }\r\n\r\n}\r\n@media (max-width: 575px) {\r\n    .ltn__footer-timeline-widget {\r\n        padding: 50px 25px 40px;\r\n    }\r\n    .footer-menu-widget-2-column {\r\n        .footer-menu {\r\n            width: 100%;\r\n            &:nth-child(odd) {\r\n                padding-left: 0px;\r\n            }\r\n        }\r\n    } \r\n    .ltn__copyright-menu {\r\n        margin-top: 25px;\r\n    }\r\n\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */","\r\n/* -------------------------\r\n    ## Preloader Css\r\n--------------------------- */\r\n.pre-wrap{\r\n    position: fixed;\r\n    content: '';\r\n    transform: translate(-100%, -240%);\r\n    font-size:62px;\r\n}\r\n.preloader-inner {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    z-index: 9999999;\r\n    background-color: rgba(7, 28, 31, 1);\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    .cancel-preloader{\r\n        position: absolute;\r\n        bottom: 30px;\r\n        right: 30px;\r\n       a{\r\n            background-color: var(--white);\r\n            font-weight: 600;\r\n            text-transform: capitalize;\r\n            color: var(--ltn__primary-color);\r\n            width: 200px;\r\n            height: 50px;\r\n            text-align: center;\r\n            line-height: 50px;\r\n            border-radius: 30px;\r\n            display: block;\r\n            transition: all 0.3s ease 0s;\r\n            &:hover{\r\n                background-color: var(--ltn__secondary-color);\r\n                color: var(--white);\r\n            }\r\n       }\r\n    }\r\n}\r\n.spinner {\r\n  margin: 120px auto;\r\n  width: 60px;\r\n  height: 60px;\r\n  position: relative;\r\n  text-align: center;\r\n  \r\n  -webkit-animation: sk-rotate 2.0s infinite linear;\r\n  animation: sk-rotate 2.0s infinite linear;\r\n}\r\n\r\n.dot1, .dot2 {\r\n  width: 60%;\r\n  height: 60%;\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 0;\r\n  background-color: var(--ltn__secondary-color);\r\n  border-radius: 100%;\r\n  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;\r\n  animation: sk-bounce 2.0s infinite ease-in-out;\r\n}\r\n\r\n.dot2 {\r\n  top: auto;\r\n  bottom: 0;\r\n  -webkit-animation-delay: -1.0s;\r\n  animation-delay: -1.0s;\r\n}\r\n\r\n@-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}\r\n@keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}\r\n\r\n@-webkit-keyframes sk-bounce {\r\n  0%, 100% { -webkit-transform: scale(0.0) }\r\n  50% { -webkit-transform: scale(1.0) }\r\n}\r\n\r\n@keyframes sk-bounce {\r\n  0%, 100% { \r\n    transform: scale(0.0);\r\n    -webkit-transform: scale(0.0);\r\n  } 50% { \r\n    transform: scale(1.0);\r\n    -webkit-transform: scale(1.0);\r\n  }\r\n}\r\n","/*----------------------------------------\r\n  Search Popup\r\n----------------------------------------*/","/* ---------------------------------------\r\n    ## Button\r\n--------------------------------------- */\r\n.btn-wrapper  {\r\n    display: block;\r\n    margin-top: 30px;\r\n}\r\n.btn-top {\r\n  background-color: var(--ltn__secondary-color);\r\n  border-radius: 0px;\r\n  display: block;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  font-family: var(--ltn__heading-font);\r\n  padding-left: 20px !important;\r\n  padding-top: 16px !important;\r\n  padding-bottom: 16px !important;\r\n  padding-right: 20px !important;\r\n  text-align: center;\r\n  color: #fff !important;\r\n  cursor: pointer;\r\n  height: fit-content !important;\r\n  transition: all 0.3s ease 0s;\r\n  position: relative;\r\n  z-index: 1;\r\n  margin-right: 15px;\r\n  &:last-child {\r\n      margin-right: 0;\r\n  }\r\n}\r\n.btn {\r\n    border-radius: 0;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    font-family: var(--ltn__heading-font);\r\n    padding: 17px 35px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease 0s;\r\n    position: relative;\r\n    z-index: 1;\r\n    margin-right: 15px;\r\n    &:last-child {\r\n        margin-right: 0;\r\n    }\r\n}\r\n.theme-btn-top {\r\n  background-color: var(--ltn__secondary-color);\r\n  color: var(--white);\r\n  &:hover{\r\n      background-color:  var(--ltn__primary-color);\r\n      color: var(--white);\r\n  }\r\n}\r\n.theme-btn-1 {\r\n    background-color: var(--ltn__secondary-color);\r\n    color: var(--white);\r\n    &:hover{\r\n        background-color:  var(--ltn__primary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.theme-btn-2 {\r\n    background-color:  var(--ltn__primary-color);\r\n    color: var(--white);\r\n    &:hover{\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.theme-btn-3 {\r\n    background-color:  transparent;\r\n    border: 2px solid var(--border-color-9);\r\n    &:hover{\r\n        background-color: var(--ltn__secondary-color);\r\n        border-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.reverse-color{\r\n    background-color: var(--ltn__secondary-color);\r\n    &:hover{\r\n        background-color:  var(--ltn__primary-color);\r\n    }\r\n}\r\n.btn-white {\r\n    background-color: var(--white);\r\n    color: var(--ltn__primary-color);\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    &:hover{\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.btn-black {\r\n    background-color: var(--black);\r\n    color: var(--white);\r\n    &:hover{\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.btn-transparent {\r\n    background-color: transparent;\r\n    box-shadow: var(--ltn__box-shadow-3);\r\n    border-color: #ddd;\r\n    &:hover{\r\n        background-color: var(--ltn__secondary-color);\r\n        color: var(--white);\r\n    }\r\n}\r\n.btn-round {\r\n    border-radius: 50px;\r\n}\r\n.btn-opacity-6 {\r\n    opacity: 0.6;\r\n    &:hover {\r\n        opacity: 1;\r\n    }\r\n}\r\n.btn-opacity-7 {\r\n    opacity: 0.7;\r\n    &:hover {\r\n        opacity: 1;\r\n    }\r\n}\r\n.btn-opacity-8 {\r\n    opacity: 0.8;\r\n    &:hover {\r\n        opacity: 1;\r\n    }\r\n}\r\n.btn-opacity-9 {\r\n    opacity: 0.9;\r\n    &:hover {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.btn:after {\r\n    content: '';\r\n    position: absolute;\r\n    z-index: -1;\r\n    -webkit-transition: all 0.3s;\r\n    -moz-transition: all 0.3s;\r\n    transition: all 0.3s;\r\n}\r\n.btn-effect-1 {\r\n    &:after {\r\n        width: 0%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        background: var(--white);\r\n    }\r\n    &:hover{\r\n        color: var(--ltn__heading-color);\r\n        &::after {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.btn-effect-2 {\r\n    &:after {\r\n        width: 0%;\r\n        height: 100%;\r\n        top: 0;\r\n        right: 0;\r\n        background: var(--white);\r\n    }\r\n    &:hover{\r\n        color: var(--ltn__heading-color);\r\n        &::after {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.btn-effect-3 {\r\n    &:after {\r\n        width: 0%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        background: var(--ltn__primary-color);\r\n    }\r\n    &:hover{\r\n        color: var(--white);\r\n        &::after {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.btn-effect-4 {\r\n    &:after {\r\n        width: 0%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        background: var(--ltn__secondary-color);\r\n    }\r\n    &:hover{\r\n        color: var(--white);\r\n        &::after {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.btn-full-width {\r\n    display: block;\r\n}\r\n.btn-full-width-2 {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.btn-border {\r\n    border: 2px solid var(--border-color-10);\r\n    box-shadow: none;\r\n}\r\n\r\n\r\n\r\n@media (min-width: 768px) and (max-width: 991px){\r\n    .btn {\r\n        padding: 12px 25px;\r\n    }\r\n    [type=\"submit\"].btn {\r\n        padding: 15px 30px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width:767px){\r\n    .btn {\r\n        padding: 10px 20px;\r\n        font-size: 14px;\r\n    }\r\n    [type=\"submit\"].btn {\r\n        padding: 12px 30px;\r\n    }\r\n}\r\n\r\n/* ----------------------------------------------------\r\n    END\r\n---------------------------------------------------- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
